import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from './hooks';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
// Generated on 2026-10-26T14:09:31+00:00

/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: ID;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Date in format YYYY-MM-DD */
  Date: Date;
  /** Time without date (HH:MM:SS) */
  Time: TimeString;
  /** Date in format iso 8601 format */
  DateTime: Date;
  /** Data in json format */
  Json: {[key: string]: string | number};
  /** Base64 encoded JSON */
  Base64Json: any;
  /** Input file type for Apollo upload using multipart requests */
  InputFile: any;
};

/** The query root of this schema */
export type TQuery = {
  readonly __typename?: 'Query';
  /**
   * Index all records of AddressType
   *
   * ALLOWED ROLES: [admin, operator, super_admin, support, user]
   *
   */
  readonly addressTypes: ReadonlyArray<TAddressType>;
  /**
   * Fetch integration states for the specified company branches
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_company_branch, editor_integrations, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly aggregatedIntegrationStates: TAggregatedIntegrationStates;
  /**
   * Index all records of Allergen
   *
   * ALLOWED ROLES: [admin, editor_menu, editor_orders, gastra_api, guest, super_admin, support, user]
   *
   */
  readonly allergens: ReadonlyArray<TAllergen>;
  /**
   * List setting for application (styles, header text, homepage url)
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
   *
   */
  readonly applicationSettings: TApplicationSettings;
  /**
   * Get details of Board
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
   *
   */
  readonly board: TBoard;
  /**
   * Index boards
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
   *
   */
  readonly boards: ReadonlyArray<TBoard>;
  /**
   * Get details of BoardScreen
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
   *
   */
  readonly boardScreen: TBoardScreen;
  /**
   * Index boards
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
   *
   */
  readonly boardScreens: ReadonlyArray<TBoardScreen>;
  /**
   * Get details of BoardTemplate
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly boardTemplate: TBoardTemplate;
  /**
   * Index board templates
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly boardTemplates: ReadonlyArray<TBoardTemplate>;
  /**
   * Details of a bolt Profile
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_business_hours, editor_integrations, editor_menu, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly boltProfile: TBoltProfile;
  /**
   * Get details of BusinessHour
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_business_hour, editor_business_hours, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
   *
   */
  readonly businessHour: TBusinessHour;
  /**
   * Get all business hours based on specified filtering
   *
   * ALLOWED ROLES: [access_config, account_manager, accountant, admin, branch_owner, brand_owner, call_center, cashier, cashier_allowed_delivery_types, cashier_basic_recipes, cashier_cancel, cashier_change_delivery_type, cashier_delivery, cashier_isolated_print, cashier_kiosk, cashier_menu, cashier_payment_methods, cashier_pos, cashier_process_time, cashier_refund, cashier_reports, cashier_reports_with_products, cashier_statistics, cashier_transfer_company_branch, cashier_unlimited, cashier_unlimited_customer, cashier_without_print, cashless_supervisor, customer, driver, driver_default, driver_dodo, driver_foodis, driver_foodora_go, driver_liftago, driver_prorozvoz, driver_wolt_drive, editor, editor_address, editor_announcement, editor_availability, editor_billings, editor_business_hour, editor_business_hours, editor_cash_box, editor_company, editor_company_branch, editor_company_branch_currency, editor_company_branch_delivery, editor_company_branch_user, editor_company_order_origin, editor_country, editor_country_vat, editor_country_vat_price_type, editor_country_vat_type_price, editor_currency, editor_event, editor_financial_report, editor_import_log, editor_ingredient, editor_integrations, editor_label, editor_label_translation, editor_menu, editor_note, editor_order, editor_order_billing, editor_order_discount, editor_order_origin_price_type, editor_order_payment_method, editor_order_price_modification, editor_order_recipe, editor_order_state_relation, editor_orders, editor_page_element, editor_payment_method, editor_payment_method_branch, editor_promo_code, editor_recipe, editor_recipe_price, editor_recipe_relation, editor_rejected_payment_method, editor_role, editor_setting, editor_shift, editor_shift_user, editor_sorting, editor_stock_item, editor_stock_item_allergen, editor_stock_transfer, editor_transportation_device, editor_transportation_device_user, editor_user, editor_user_delivering_order, editor_user_login_provider, editor_user_personal, editor_wallet_credits, editor_wallet_credits_refund, editor_ware, editor_ware_category, editor_ware_category_relation, editor_zone, editor_zones, export_customers, extern, external_api, gastra_api, guest, liftago, merchant, operator, owner_cancel, request_cancel, request_external_driver, sales_representative, super_admin, supervisor, support, suspended_user, templatable_manager, user, vam]
   *
   */
  readonly businessHours: ReadonlyArray<TBusinessHour>;
  /**
   * Get appropriate cash box
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_cash_box, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly cashBox: TCashBox;
  /**
   * Index of cash boxes
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_cash_box, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly cashBoxes: ReadonlyArray<TCashBox>;
  /**
   * Get list of cashiers
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
   *
   */
  readonly cashiers: ReadonlyArray<TUser>;
  /**
   * Index of companies of appropriate type
   *
   * ALLOWED ROLES: [access_config, account_manager, accountant, admin, branch_owner, brand_owner, call_center, cashier, cashier_allowed_delivery_types, cashier_basic_recipes, cashier_cancel, cashier_change_delivery_type, cashier_delivery, cashier_isolated_print, cashier_kiosk, cashier_menu, cashier_payment_methods, cashier_pos, cashier_process_time, cashier_refund, cashier_reports, cashier_reports_with_products, cashier_statistics, cashier_transfer_company_branch, cashier_unlimited, cashier_unlimited_customer, cashier_without_print, cashless_supervisor, customer, driver, driver_default, driver_dodo, driver_foodis, driver_foodora_go, driver_liftago, driver_prorozvoz, driver_wolt_drive, editor, editor_address, editor_announcement, editor_availability, editor_billings, editor_business_hour, editor_business_hours, editor_cash_box, editor_company, editor_company_branch, editor_company_branch_currency, editor_company_branch_delivery, editor_company_branch_user, editor_company_order_origin, editor_country, editor_country_vat, editor_country_vat_price_type, editor_country_vat_type_price, editor_currency, editor_event, editor_financial_report, editor_import_log, editor_ingredient, editor_integrations, editor_label, editor_label_translation, editor_menu, editor_note, editor_order, editor_order_billing, editor_order_discount, editor_order_origin_price_type, editor_order_payment_method, editor_order_price_modification, editor_order_recipe, editor_order_state_relation, editor_orders, editor_page_element, editor_payment_method, editor_payment_method_branch, editor_promo_code, editor_recipe, editor_recipe_price, editor_recipe_relation, editor_rejected_payment_method, editor_role, editor_setting, editor_shift, editor_shift_user, editor_sorting, editor_stock_item, editor_stock_item_allergen, editor_stock_transfer, editor_transportation_device, editor_transportation_device_user, editor_user, editor_user_delivering_order, editor_user_login_provider, editor_user_personal, editor_wallet_credits, editor_wallet_credits_refund, editor_ware, editor_ware_category, editor_ware_category_relation, editor_zone, editor_zones, export_customers, extern, external_api, gastra_api, guest, liftago, merchant, operator, owner_cancel, request_cancel, request_external_driver, sales_representative, super_admin, supervisor, support, suspended_user, templatable_manager, user, vam]
   *
   */
  readonly companies: ReadonlyArray<TCompany>;
  /**
   * Get details of Company
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, driver, editor_company, guest, sales_representative, super_admin, supervisor, support, user, vam]
   *
   */
  readonly company: TCompany;
  /**
   * Get details of CompanyBranch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
   *
   */
  readonly companyBranch: TCompanyBranch;
  /**
   * Get all company branches of defined company
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
   *
   */
  readonly companyBranches: ReadonlyArray<TCompanyBranch>;
  /**
   * Obtain all company branches that deliver to appropriate address
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
   *
   */
  readonly companyBranchesLookUp: TCompanyBranchesLookUp;
  /**
   * Find a suitable company branch.
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
   *
   */
  readonly companyBranchLookUp: TCompanyBrandLookUp;
  /**
   * Index company branch trigger printers
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, cashier_isolated_print, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly companyBranchTriggerPrinters: ReadonlyArray<TCompanyBranchTriggerPrinter>;
  /**
   * Index company branch triggers
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, cashier_isolated_print, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly companyBranchTriggers: ReadonlyArray<TCompanyBranchTrigger>;
  /**
   * Get details of CompanyBranchUser
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, driver, editor_company_branch_user, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly companyBranchUser: TCompanyBranchUser;
  /**
   * Get links between Company Branch and User
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, driver, editor_company_branch_user, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly companyBranchUsers: ReadonlyArray<TCompanyBranchUser>;
  /**
   * Index all records of CompanyType
   *
   * ALLOWED ROLES: [admin, super_admin, support, user]
   *
   */
  readonly companyTypes: ReadonlyArray<TCompanyType>;
  /**
   * Get details of Consent
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly consent: TConsent;
  /**
   * Index all records of ConsentRevokeType
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly consentRevokeTypes: ReadonlyArray<TConsentsRevokeType>;
  /**
   * Index all records of ConsentType
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly consentTypes: ReadonlyArray<TConsentsType>;
  /**
   * Index all records of Country
   *
   * ALLOWED ROLES: [admin, editor_country, editor_menu, gastra_api, guest, operator, super_admin, support, user]
   *
   */
  readonly countries: ReadonlyArray<TCountry>;
  /**
   * Get details of Country
   *
   * ALLOWED ROLES: [admin, editor_country, editor_menu, gastra_api, guest, operator, super_admin, support, user]
   *
   */
  readonly country: TCountry;
  /**
   * Lookup a Cashless Wallet by NFC ID
   *
   * ALLOWED ROLES: [admin, cashier_pos, customer, editor_wallet_credits, editor_wallet_credits_refund, guest, super_admin, support]
   *
   */
  readonly creditsCashlessWallet: TCreditsCashlessWalletLookup;
  /**
   * Details of a FundsTransfer
   *
   * ALLOWED ROLES: [admin, editor_wallet_credits, editor_wallet_credits_refund, super_admin, support]
   *
   */
  readonly creditsFundsTransfer: TCreditsFundsTransfer;
  /**
   * Index of FundsTransfer
   *
   * ALLOWED ROLES: [admin, editor_wallet_credits, editor_wallet_credits_refund, super_admin, support]
   *
   */
  readonly creditsFundsTransfers: ReadonlyArray<TCreditsFundsTransfer>;
  /**
   * Details of a Reward
   *
   * ALLOWED ROLES: [admin, customer, super_admin, support]
   *
   */
  readonly creditsReward: TCreditsReward;
  /**
   * Details of a Wallet
   *
   * ALLOWED ROLES: [admin, cashier_pos, customer, editor_wallet_credits, editor_wallet_credits_refund, guest, super_admin, support]
   *
   */
  readonly creditsWallet: TCreditsWallet;
  /**
   * Details of a WalletActivity
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, customer, guest, super_admin, supervisor, support]
   *
   */
  readonly creditsWalletActivity: TCreditsWalletActivity;
  /**
   * Index all records of Currency
   *
   * ALLOWED ROLES: [admin, editor_currency, guest, super_admin, support, user]
   *
   */
  readonly currencies: ReadonlyArray<TCurrency>;
  /**
   * Get details of Currency
   *
   * ALLOWED ROLES: [admin, editor_currency, guest, super_admin, support, user]
   *
   */
  readonly currency: TCurrency;
  /**
   * Details of a Customer
   *
   * ALLOWED ROLES: [admin, customer, super_admin, support]
   *
   */
  readonly customer: TCustomer;
  /**
   * Export customers for specified period of time
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_company_branch, export_customers, super_admin, supervisor]
   *
   */
  readonly customersFileReports: Scalars['String'];
  /**
   * Get all delivery slots from now + default_order_process_time until delayed_delivery_limit. If a Zone is passed in as argument, its delivery_deviation_minutes is added to the delayed_delivery_limit.
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly deliverySlots: ReadonlyArray<TDeliverySlot>;
  /**
   * Index all records of DeliveryType
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly deliveryTypes: ReadonlyArray<TDeliveryType>;
  /**
   * Index all records of DeviceState
   *
   * ALLOWED ROLES: [admin, super_admin, support]
   *
   */
  readonly deviceStates: ReadonlyArray<TDeviceState>;
  /**
   * Index all records of DeviceType
   *
   * ALLOWED ROLES: [admin, super_admin, support]
   *
   */
  readonly deviceTypes: ReadonlyArray<TDeviceType>;
  /**
   * Details of a Dotykacka Profile
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_business_hours, editor_integrations, editor_menu, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly dotykackaProfile: TDotykackaProfile;
  /**
   * Get list of drivers
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
   *
   */
  readonly drivers: ReadonlyArray<TUser>;
  /**
   * Get estimated pickup, delivery times and estimated delivery fee
   *
   * ALLOWED ROLES: [admin, editor_order, operator, request_external_driver, super_admin]
   *
   */
  readonly estimateExternalDelivery: TExternalDeliveryEstimate;
  /**
   * Details of express delivery setting
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, guest, super_admin, supervisor, support]
   *
   */
  readonly expressDeliverySetting: TExpressDeliverySetting;
  /**
   * Get all active external deliveries of company branches
   *
   * ALLOWED ROLES: [admin, editor_order, operator, request_external_driver, super_admin]
   *
   */
  readonly externalDeliveries: ReadonlyArray<TExternalDelivery>;
  /**
   * Index all records of FieldState
   *
   * ALLOWED ROLES: [admin, editor, super_admin, support, user]
   *
   */
  readonly fieldStates: ReadonlyArray<TFieldState>;
  /**
   * Calculate statistics for specified period of time
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_statistics, editor_company_branch, merchant, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly fileReports: Scalars['String'];
  /**
   * Index all records of FileReportType
   *
   * ALLOWED ROLES: [admin, super_admin, support, user]
   *
   */
  readonly fileReportTypes: ReadonlyArray<TFileReportType>;
  /**
   * Get details of FinancialReport
   *
   * ALLOWED ROLES: [accountant, admin, branch_owner, brand_owner, cashier_reports, editor_financial_report, gastra_api, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly financialReport: TFinancialReport;
  /**
   * Index all financial reports for specified object.
   *
   * ALLOWED ROLES: [accountant, admin, branch_owner, brand_owner, cashier_reports, editor_financial_report, gastra_api, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly financialReports: ReadonlyArray<TFinancialReport>;
  /**
   * Details of a foodora Profile
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_business_hours, editor_integrations, editor_menu, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly foodoraProfile: TFoodoraProfile;
  /**
   * Generate a customised greeting for the current user.
   *
   * ALLOWED ROLES: [access_config, account_manager, accountant, admin, branch_owner, brand_owner, call_center, cashier, cashier_allowed_delivery_types, cashier_basic_recipes, cashier_cancel, cashier_change_delivery_type, cashier_delivery, cashier_isolated_print, cashier_kiosk, cashier_menu, cashier_payment_methods, cashier_pos, cashier_process_time, cashier_refund, cashier_reports, cashier_reports_with_products, cashier_statistics, cashier_transfer_company_branch, cashier_unlimited, cashier_unlimited_customer, cashier_without_print, cashless_supervisor, customer, driver, driver_default, driver_dodo, driver_foodis, driver_foodora_go, driver_liftago, driver_prorozvoz, driver_wolt_drive, editor, editor_address, editor_announcement, editor_availability, editor_billings, editor_business_hour, editor_business_hours, editor_cash_box, editor_company, editor_company_branch, editor_company_branch_currency, editor_company_branch_delivery, editor_company_branch_user, editor_company_order_origin, editor_country, editor_country_vat, editor_country_vat_price_type, editor_country_vat_type_price, editor_currency, editor_event, editor_financial_report, editor_import_log, editor_ingredient, editor_integrations, editor_label, editor_label_translation, editor_menu, editor_note, editor_order, editor_order_billing, editor_order_discount, editor_order_origin_price_type, editor_order_payment_method, editor_order_price_modification, editor_order_recipe, editor_order_state_relation, editor_orders, editor_page_element, editor_payment_method, editor_payment_method_branch, editor_promo_code, editor_recipe, editor_recipe_price, editor_recipe_relation, editor_rejected_payment_method, editor_role, editor_setting, editor_shift, editor_shift_user, editor_sorting, editor_stock_item, editor_stock_item_allergen, editor_stock_transfer, editor_transportation_device, editor_transportation_device_user, editor_user, editor_user_delivering_order, editor_user_login_provider, editor_user_personal, editor_wallet_credits, editor_wallet_credits_refund, editor_ware, editor_ware_category, editor_ware_category_relation, editor_zone, editor_zones, export_customers, extern, external_api, gastra_api, guest, liftago, merchant, operator, owner_cancel, request_cancel, request_external_driver, sales_representative, super_admin, supervisor, support, suspended_user, templatable_manager, user, vam]
   *
   */
  readonly greeting: TGreeting;
  /**
   * Index all records of Group
   *
   * ALLOWED ROLES: [admin, super_admin, support, user]
   *
   */
  readonly groups: ReadonlyArray<TGroup>;
  /**
   * Get details of Ingredient
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_ingredient, editor_menu, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly ingredient: TIngredient;
  /**
   * Get ingredients for appropriate recipe
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_ingredient, editor_menu, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly ingredients: ReadonlyArray<TIngredient>;
  /**
   * Details of an Integrations Activity
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_menu, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly integrationsActivity: TIntegrationsActivity;
  /**
   * Get all business hours for an integration profile
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_business_hours, editor_integrations, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly integrationsBusinessHours: ReadonlyArray<TIntegrationsBusinessHour>;
  /**
   * Details of an Integrations Entity
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_menu, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly integrationsEntity: TIntegrationsEntity;
  /**
   * Details of an Integrations Error
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_menu, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly integrationsError: TIntegrationsError;
  /**
   * Details of an Integrations ProfileWareCategory
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_menu, super_admin, supervisor, support]
   *
   */
  readonly integrationsProfileWareCategory: TIntegrationsProfileWareCategory;
  /**
   * Details of a Jidlo Pod Nos Profile
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_business_hours, editor_integrations, editor_menu, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly jidloPodNosProfile: TJidloPodNosProfile;
  /**
   * Index all records of Language
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly languages: ReadonlyArray<TLanguage>;
  /**
   * Generate current financial report for specified object.
   *
   * ALLOWED ROLES: [accountant, admin, branch_owner, brand_owner, cashier_reports, editor_financial_report, gastra_api, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly lastFinancialReport: TFinancialReport;
  /**
   * Find last generated financial report for specified object.
   *
   * ALLOWED ROLES: [accountant, admin, branch_owner, brand_owner, cashier_reports, editor_financial_report, gastra_api, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly lastGeneratedFinancialReport: Maybe<TFinancialReport>;
  /**
   * List setting for mobile application
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
   *
   */
  readonly mobileApplicationSettings: Maybe<TMobileApplicationSetting>;
  /**
   * Get details of Occasion
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly occasion: TOccasion;
  /**
   * Index occasion records
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly occasions: ReadonlyArray<TOccasion>;
  /**
   * Index all records of OperatingCostType
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_statistics, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly operatingCostTypes: ReadonlyArray<TOperatingCostType>;
  /**
   * Index records of OperatingCostType for deliveries
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_statistics, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly operatingCostTypesForDeliveries: ReadonlyArray<TOperatingCostType>;
  /**
   * Index records of OperatingCostType for payment gates
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_statistics, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly operatingCostTypesForPayments: ReadonlyArray<TOperatingCostType>;
  /**
   * Index records of OperatingCostType for SMS
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_statistics, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly operatingCostTypesForSms: ReadonlyArray<TOperatingCostType>;
  /**
   * Get appropriate order
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly order: TOrder;
  /**
   * Index all records of OrderBillingType
   *
   * ALLOWED ROLES: [accountant, admin, editor_billings, super_admin, support, user]
   *
   */
  readonly orderBillingTypes: ReadonlyArray<TOrderBillingType>;
  /**
   * Get details of OrderGroup
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly orderGroup: TOrderGroup;
  /**
   * Index all records of OrderGroupColor
   *
   * ALLOWED ROLES: [admin, super_admin, support, user]
   *
   */
  readonly orderGroupColors: ReadonlyArray<TOrderGroupColor>;
  /**
   * Get categories of recipes
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_menu, editor_menu, editor_ware_category, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
   *
   */
  readonly orderMenuAdmin: ReadonlyArray<TOrderMenu>;
  /**
   * Reload information about payment status from external service
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly orderOnlinePaymentStatus: TOrderOnlinePaymentStatus;
  /**
   * Index all records of OrderOnlineState
   *
   * ALLOWED ROLES: [admin, super_admin, support, user]
   *
   */
  readonly orderOnlineStates: ReadonlyArray<TOrderOnlineState>;
  /**
   * Index all records of OrderOriginCategory
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly orderOriginCategories: ReadonlyArray<TOrderOriginCategory>;
  /**
   * Index all records of OrderOrigin
   *
   * ALLOWED ROLES: [admin, editor_orders, guest, super_admin, support, user]
   *
   */
  readonly orderOrigins: ReadonlyArray<TOrderOrigin>;
  /**
   * Index all records of OrderRatingType
   *
   * ALLOWED ROLES: [admin, cashier_menu, editor_menu, merchant, super_admin, support, user]
   *
   */
  readonly orderRatingTypes: ReadonlyArray<TOrderRatingType>;
  /**
   * Read Order Recipe
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order_recipe, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly orderRecipe: TOrderRecipe;
  /**
   * Get items of order
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order_recipe, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly orderRecipes: ReadonlyArray<TOrderRecipe>;
  /**
   * Get orders with using of additional filters
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly orders: ReadonlyArray<TOrder>;
  /**
   * Count number of orders for specified user
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly ordersCategoryCount: ReadonlyArray<TOrderStateCategoryCount>;
  /**
   * Count number of orders for specified user
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   * @deprecated Use ordersCategoryCount instead.
   */
  readonly ordersCount: Scalars['Int'];
  /**
   *
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly orderStateCategories: ReadonlyArray<TOrderStateCategory>;
  /**
   * Index all records of OrderState
   *
   * ALLOWED ROLES: [admin, editor_orders, guest, super_admin, support, user]
   *
   */
  readonly orderStates: ReadonlyArray<TOrderState>;
  /**
   * Index all records of PaymentGate
   *
   * ALLOWED ROLES: [admin, super_admin, support, user]
   *
   */
  readonly paymentGates: ReadonlyArray<TPaymentGate>;
  /**
   * Get details of PaymentMethod
   *
   * ALLOWED ROLES: [admin, editor_payment_method, guest, super_admin, support, user]
   *
   */
  readonly paymentMethod: TPaymentMethod;
  /**
   * List of payment methods used by branch
   *
   * ALLOWED ROLES: [admin, editor_payment_method, guest, super_admin, support, user]
   *
   */
  readonly paymentMethods: ReadonlyArray<TPaymentMethod>;
  /**
   * Index all records of PaymentType
   *
   * ALLOWED ROLES: [admin, super_admin, support]
   *
   */
  readonly paymentTypes: ReadonlyArray<TPaymentType>;
  /**
   * Obtain global user permissions for specified set of actions
   *
   * ALLOWED ROLES: [access_config, account_manager, accountant, admin, branch_owner, brand_owner, call_center, cashier, cashier_allowed_delivery_types, cashier_basic_recipes, cashier_cancel, cashier_change_delivery_type, cashier_delivery, cashier_isolated_print, cashier_kiosk, cashier_menu, cashier_payment_methods, cashier_pos, cashier_process_time, cashier_refund, cashier_reports, cashier_reports_with_products, cashier_statistics, cashier_transfer_company_branch, cashier_unlimited, cashier_unlimited_customer, cashier_without_print, cashless_supervisor, customer, driver, driver_default, driver_dodo, driver_foodis, driver_foodora_go, driver_liftago, driver_prorozvoz, driver_wolt_drive, editor, editor_address, editor_announcement, editor_availability, editor_billings, editor_business_hour, editor_business_hours, editor_cash_box, editor_company, editor_company_branch, editor_company_branch_currency, editor_company_branch_delivery, editor_company_branch_user, editor_company_order_origin, editor_country, editor_country_vat, editor_country_vat_price_type, editor_country_vat_type_price, editor_currency, editor_event, editor_financial_report, editor_import_log, editor_ingredient, editor_integrations, editor_label, editor_label_translation, editor_menu, editor_note, editor_order, editor_order_billing, editor_order_discount, editor_order_origin_price_type, editor_order_payment_method, editor_order_price_modification, editor_order_recipe, editor_order_state_relation, editor_orders, editor_page_element, editor_payment_method, editor_payment_method_branch, editor_promo_code, editor_recipe, editor_recipe_price, editor_recipe_relation, editor_rejected_payment_method, editor_role, editor_setting, editor_shift, editor_shift_user, editor_sorting, editor_stock_item, editor_stock_item_allergen, editor_stock_transfer, editor_transportation_device, editor_transportation_device_user, editor_user, editor_user_delivering_order, editor_user_login_provider, editor_user_personal, editor_wallet_credits, editor_wallet_credits_refund, editor_ware, editor_ware_category, editor_ware_category_relation, editor_zone, editor_zones, export_customers, extern, external_api, gastra_api, guest, liftago, merchant, operator, owner_cancel, request_cancel, request_external_driver, sales_representative, super_admin, supervisor, support, suspended_user, templatable_manager, user, vam]
   *
   */
  readonly permissions: TUserPermission;
  /**
   * Info about latest Pohoda exports
   *
   * ALLOWED ROLES: [admin, branch_owner, super_admin, support]
   *
   */
  readonly pohodaExport: TPohodaExportInfoType;
  /**
   * Index all records of PrintableType
   *
   * ALLOWED ROLES: [admin, super_admin, support, user]
   *
   * @deprecated Use triggerableTypes instead.
   */
  readonly printableTypes: ReadonlyArray<TPrintableType>;
  /**
   * Index print configurations
   *
   * ALLOWED ROLES: [admin, super_admin, support, user]
   *
   * @deprecated Use triggerConfigurations instead.
   */
  readonly printConfigurations: ReadonlyArray<TTriggerConfiguration>;
  /**
   * Get details of Printer
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support, user]
   *
   */
  readonly printer: TPrinter;
  /**
   * Index printers
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support, user]
   *
   */
  readonly printers: ReadonlyArray<TPrinter>;
  /**
   * Index all records of PrinterType
   *
   * ALLOWED ROLES: [admin, super_admin, support, user]
   *
   */
  readonly printerTypes: ReadonlyArray<TPrinterType>;
  /**
   * Read relevant print queue records
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly printQueues: ReadonlyArray<TPrintQueue>;
  /**
   * Index print templates
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support, templatable_manager, user]
   *
   */
  readonly printTemplates: ReadonlyArray<TPrintTemplate>;
  /**
   * Get details of PromoCode
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_orders, editor_promo_code, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly promoCode: TPromoCode;
  /**
   * List of promo code used by branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_orders, editor_promo_code, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly promoCodes: ReadonlyArray<TPromoCode>;
  /**
   * Get details of promo tag
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly promoTag: TPromoTag;
  /**
   * Index all records of PromoTag
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly promoTags: ReadonlyArray<TPromoTag>;
  /**
   * Read recipe
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
   *
   */
  readonly recipe: TRecipe;
  /**
   * Index all records of RecipeColor
   *
   * ALLOWED ROLES: [admin, super_admin, support, user]
   *
   */
  readonly recipeColors: ReadonlyArray<TRecipeColor>;
  /**
   * Index recipe records
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
   *
   */
  readonly recipes: ReadonlyArray<TRecipe>;
  /**
   * Get details of promo tag
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly recipeTag: TRecipeTag;
  /**
   * Index all records of RecipeTagCategoryType
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly recipeTagCategoryTypes: ReadonlyArray<TRecipeTagCategoryType>;
  /**
   * Get details of RecipeTagRelation
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly recipeTagRelation: TRecipeTagRelation;
  /**
   *
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly recipeTagRelations: ReadonlyArray<TRecipeTagRelation>;
  /**
   * Returns all RecipeTags available to the User – system RecipeTags + company RecipeTags for the companies the User is in.
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly recipeTags: ReadonlyArray<TRecipeTag>;
  /**
   * Obtain correct gps coordinates/address from user defined gps/address. Uses even IP address in case that gps/address is missing.
   *
   * ALLOWED ROLES: [access_config, account_manager, accountant, admin, branch_owner, brand_owner, call_center, cashier, cashier_allowed_delivery_types, cashier_basic_recipes, cashier_cancel, cashier_change_delivery_type, cashier_delivery, cashier_isolated_print, cashier_kiosk, cashier_menu, cashier_payment_methods, cashier_pos, cashier_process_time, cashier_refund, cashier_reports, cashier_reports_with_products, cashier_statistics, cashier_transfer_company_branch, cashier_unlimited, cashier_unlimited_customer, cashier_without_print, cashless_supervisor, customer, driver, driver_default, driver_dodo, driver_foodis, driver_foodora_go, driver_liftago, driver_prorozvoz, driver_wolt_drive, editor, editor_address, editor_announcement, editor_availability, editor_billings, editor_business_hour, editor_business_hours, editor_cash_box, editor_company, editor_company_branch, editor_company_branch_currency, editor_company_branch_delivery, editor_company_branch_user, editor_company_order_origin, editor_country, editor_country_vat, editor_country_vat_price_type, editor_country_vat_type_price, editor_currency, editor_event, editor_financial_report, editor_import_log, editor_ingredient, editor_integrations, editor_label, editor_label_translation, editor_menu, editor_note, editor_order, editor_order_billing, editor_order_discount, editor_order_origin_price_type, editor_order_payment_method, editor_order_price_modification, editor_order_recipe, editor_order_state_relation, editor_orders, editor_page_element, editor_payment_method, editor_payment_method_branch, editor_promo_code, editor_recipe, editor_recipe_price, editor_recipe_relation, editor_rejected_payment_method, editor_role, editor_setting, editor_shift, editor_shift_user, editor_sorting, editor_stock_item, editor_stock_item_allergen, editor_stock_transfer, editor_transportation_device, editor_transportation_device_user, editor_user, editor_user_delivering_order, editor_user_login_provider, editor_user_personal, editor_wallet_credits, editor_wallet_credits_refund, editor_ware, editor_ware_category, editor_ware_category_relation, editor_zone, editor_zones, export_customers, extern, external_api, gastra_api, guest, liftago, merchant, operator, owner_cancel, request_cancel, request_external_driver, sales_representative, super_admin, supervisor, support, suspended_user, templatable_manager, user, vam]
   *
   */
  readonly resolveLocation: TAddressResolvedLocation;
  /**
   * Get details of Sector
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, guest, operator, sales_representative, super_admin, supervisor, support, user]
   *
   */
  readonly sector: TSector;
  /**
   * Get details of SectorRecipe
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly sectorRecipe: TSectorRecipe;
  /**
   * Index sector recipes
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly sectorRecipes: ReadonlyArray<TSectorRecipe>;
  /**
   * Index sector records
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, guest, operator, sales_representative, super_admin, supervisor, support, user]
   *
   */
  readonly sectors: ReadonlyArray<TSector>;
  /**
   * Index all records of SettingType
   *
   * ALLOWED ROLES: [admin, super_admin, support, user]
   *
   */
  readonly settingTypes: ReadonlyArray<TSettingType>;
  /**
   * Get details of Shift
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, driver, editor_shift, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly shift: TShift;
  /**
   * Index of shifts for appropriate company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, driver, editor_shift, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly shifts: ReadonlyArray<Maybe<TShift>>;
  /**
   * Index all records of ShiftUserState
   *
   * ALLOWED ROLES: [admin, super_admin, support]
   *
   */
  readonly shiftUserStates: ReadonlyArray<TShiftUserState>;
  /**
   * Calculate statistics for specified period of time
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_statistics, driver, editor_company_branch, gastra_api, merchant, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly statistics: TStatistics;
  /**
   * Calculates credit statistics for the specified credits group and time period.
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, operator, super_admin, supervisor]
   *
   */
  readonly statisticsForCredits: TStatisticsCredits;
  /**
   * Calculate fees for specified period of time
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_company_branch, merchant, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly statisticsForFees: ReadonlyArray<TStatisticsForFees>;
  /**
   * Calculate turnover and fees divided by order origin
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_company_branch, merchant, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly statisticsForOperatingCosts: ReadonlyArray<TStatisticsForOperatingCosts>;
  /**
   * Calculate total amount divided by type of payment (online vs other)
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_company_branch, merchant, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly statisticsForPayments: TStatisticsForPayments;
  /**
   * Index of stock items for appropriate company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, gastra_api, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly stockInventories: ReadonlyArray<TStockInventory>;
  /**
   * Get details of StockInventory
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, gastra_api, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly stockInventory: TStockInventory;
  /**
   * Get details of StockInventoryItem
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, gastra_api, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly stockInventoryItem: TStockInventoryItem;
  /**
   * Index all records of StockInventoryItemChangeType
   *
   * ALLOWED ROLES: [admin, gastra_api, super_admin, support, user]
   *
   */
  readonly stockInventoryItemChangeTypes: ReadonlyArray<TStockInventoryItemChangeType>;
  /**
   * Get details of StockItem
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_menu, editor_stock_item, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly stockItem: TStockItem;
  /**
   * Index all records of StockItemChangeType
   *
   * ALLOWED ROLES: [admin, gastra_api, super_admin, support, user]
   *
   */
  readonly stockItemChangeTypes: ReadonlyArray<TStockItemChangeType>;
  /**
   * Index of stock items for appropriate company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_menu, editor_stock_item, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly stockItems: ReadonlyArray<TStockItem>;
  /**
   * Get details of StockTransfer
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_stock_transfer, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly stockItemTransfer: TStockTransfer;
  /**
   * Index stock item transfers
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_stock_transfer, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly stockItemTransfers: ReadonlyArray<TStockTransfer>;
  /**
   * Index all records of StornoRequestType
   *
   * ALLOWED ROLES: [admin, super_admin, support, user]
   *
   */
  readonly stornoRequestTypes: ReadonlyArray<TStornoRequestType>;
  /**
   * Obtain correct gps coordinates from seznam suggestions defined gps/address.
   *
   * ALLOWED ROLES: [access_config, account_manager, accountant, admin, branch_owner, brand_owner, call_center, cashier, cashier_allowed_delivery_types, cashier_basic_recipes, cashier_cancel, cashier_change_delivery_type, cashier_delivery, cashier_isolated_print, cashier_kiosk, cashier_menu, cashier_payment_methods, cashier_pos, cashier_process_time, cashier_refund, cashier_reports, cashier_reports_with_products, cashier_statistics, cashier_transfer_company_branch, cashier_unlimited, cashier_unlimited_customer, cashier_without_print, cashless_supervisor, customer, driver, driver_default, driver_dodo, driver_foodis, driver_foodora_go, driver_liftago, driver_prorozvoz, driver_wolt_drive, editor, editor_address, editor_announcement, editor_availability, editor_billings, editor_business_hour, editor_business_hours, editor_cash_box, editor_company, editor_company_branch, editor_company_branch_currency, editor_company_branch_delivery, editor_company_branch_user, editor_company_order_origin, editor_country, editor_country_vat, editor_country_vat_price_type, editor_country_vat_type_price, editor_currency, editor_event, editor_financial_report, editor_import_log, editor_ingredient, editor_integrations, editor_label, editor_label_translation, editor_menu, editor_note, editor_order, editor_order_billing, editor_order_discount, editor_order_origin_price_type, editor_order_payment_method, editor_order_price_modification, editor_order_recipe, editor_order_state_relation, editor_orders, editor_page_element, editor_payment_method, editor_payment_method_branch, editor_promo_code, editor_recipe, editor_recipe_price, editor_recipe_relation, editor_rejected_payment_method, editor_role, editor_setting, editor_shift, editor_shift_user, editor_sorting, editor_stock_item, editor_stock_item_allergen, editor_stock_transfer, editor_transportation_device, editor_transportation_device_user, editor_user, editor_user_delivering_order, editor_user_login_provider, editor_user_personal, editor_wallet_credits, editor_wallet_credits_refund, editor_ware, editor_ware_category, editor_ware_category_relation, editor_zone, editor_zones, export_customers, extern, external_api, gastra_api, guest, liftago, merchant, operator, owner_cancel, request_cancel, request_external_driver, sales_representative, super_admin, supervisor, support, suspended_user, templatable_manager, user, vam]
   *
   */
  readonly suggestAddress: ReadonlyArray<TAddressResolvedLocation>;
  /**
   * Return list of places with similar name from geolocation service
   *
   * ALLOWED ROLES: [access_config, account_manager, accountant, admin, branch_owner, brand_owner, call_center, cashier, cashier_allowed_delivery_types, cashier_basic_recipes, cashier_cancel, cashier_change_delivery_type, cashier_delivery, cashier_isolated_print, cashier_kiosk, cashier_menu, cashier_payment_methods, cashier_pos, cashier_process_time, cashier_refund, cashier_reports, cashier_reports_with_products, cashier_statistics, cashier_transfer_company_branch, cashier_unlimited, cashier_unlimited_customer, cashier_without_print, cashless_supervisor, customer, driver, driver_default, driver_dodo, driver_foodis, driver_foodora_go, driver_liftago, driver_prorozvoz, driver_wolt_drive, editor, editor_address, editor_announcement, editor_availability, editor_billings, editor_business_hour, editor_business_hours, editor_cash_box, editor_company, editor_company_branch, editor_company_branch_currency, editor_company_branch_delivery, editor_company_branch_user, editor_company_order_origin, editor_country, editor_country_vat, editor_country_vat_price_type, editor_country_vat_type_price, editor_currency, editor_event, editor_financial_report, editor_import_log, editor_ingredient, editor_integrations, editor_label, editor_label_translation, editor_menu, editor_note, editor_order, editor_order_billing, editor_order_discount, editor_order_origin_price_type, editor_order_payment_method, editor_order_price_modification, editor_order_recipe, editor_order_state_relation, editor_orders, editor_page_element, editor_payment_method, editor_payment_method_branch, editor_promo_code, editor_recipe, editor_recipe_price, editor_recipe_relation, editor_rejected_payment_method, editor_role, editor_setting, editor_shift, editor_shift_user, editor_sorting, editor_stock_item, editor_stock_item_allergen, editor_stock_transfer, editor_transportation_device, editor_transportation_device_user, editor_user, editor_user_delivering_order, editor_user_login_provider, editor_user_personal, editor_wallet_credits, editor_wallet_credits_refund, editor_ware, editor_ware_category, editor_ware_category_relation, editor_zone, editor_zones, export_customers, extern, external_api, gastra_api, guest, liftago, merchant, operator, owner_cancel, request_cancel, request_external_driver, sales_representative, super_admin, supervisor, support, suspended_user, templatable_manager, user, vam]
   *
   */
  readonly suggestGeolocation: ReadonlyArray<TJsonAddress>;
  /**
   * Get all terminal transaction records
   *
   * ALLOWED ROLES: [admin, cashier, editor_wallet_credits, super_admin, support]
   *
   */
  readonly terminalTransactionRecords: ReadonlyArray<TTerminalTransactionRecord>;
  /**
   * Get details of TransportationDevice
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, driver, editor_transportation_device, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly transportationDevice: TTransportationDevice;
  /**
   * Get all transportation device of defined company branch - can use additional filtering
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, driver, editor_transportation_device, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly transportationDevices: ReadonlyArray<TTransportationDevice>;
  /**
   * Get details of TransportationDeviceUser
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, driver, editor_transportation_device_user, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly transportationDeviceUser: TTransportationDeviceUser;
  /**
   * Index of transportation devices assigned to user
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, driver, editor_transportation_device_user, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly transportationDeviceUsers: ReadonlyArray<TTransportationDeviceUser>;
  /**
   * Index all records of TriggerableType
   *
   * ALLOWED ROLES: [admin, super_admin, support, user]
   *
   */
  readonly triggerableTypes: ReadonlyArray<TTriggerableType>;
  /**
   * Index trigger configurations
   *
   * ALLOWED ROLES: [admin, super_admin, support, user]
   *
   */
  readonly triggerConfigurations: ReadonlyArray<TTriggerConfiguration>;
  /**
   * Index all records of TriggerType
   *
   * ALLOWED ROLES: [admin, super_admin, support]
   *
   */
  readonly triggerTypes: ReadonlyArray<TTriggerType>;
  /**
   * Get details of User
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
   *
   */
  readonly user: TUser;
  /**
   * Find information about call event.
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_order, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly userCustomerCalling: TUserCustomerCalling;
  /**
   * Assign user that will deliver order
   *
   * ALLOWED ROLES: [admin, cashier_delivery, driver, super_admin, support]
   *
   */
  readonly userDeliveries: ReadonlyArray<TUserDelivery>;
  /**
   * Get details of UserDeliveringOrder
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, cashier_delivery, driver, editor_user_delivering_order, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly userDeliveringOrder: TUserDeliveringOrder;
  /**
   * Index of orders delivered by appropriate user
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, cashier_delivery, driver, editor_user_delivering_order, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly userDeliveringOrders: ReadonlyArray<TUserDeliveringOrder>;
  /**
   * Get details of UserDelivery
   *
   * ALLOWED ROLES: [admin, cashier_delivery, driver, super_admin, support]
   *
   */
  readonly userDelivery: TUserDelivery;
  /**
   * Get list of users
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
   *
   */
  readonly users: ReadonlyArray<TUser>;
  /**
   * Index of shifts of appropriate user
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, driver, editor_shift_user, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly userShifts: ReadonlyArray<TShiftUser>;
  /**
   * Find customer by phone and return known information.
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_company_branch, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly vamInformation: TCustomerInformation;
  /**
   * Query VAM and return its result about user agreements.
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly vamStatus: ReadonlyArray<TVamAgreement>;
  /**
   * Index of vats
   *
   * ALLOWED ROLES: [admin, editor_country, editor_menu, gastra_api, guest, operator, super_admin, support, user]
   *
   */
  readonly vats: ReadonlyArray<TVat>;
  /**
   * Get details of Ware
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_ware, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly ware: TWare;
  /**
   * Get categories of recipes
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_menu, editor_menu, editor_ware_category, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
   *
   */
  readonly wareCategories: ReadonlyArray<TWareCategory>;
  /**
   * Read ware category
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_menu, editor_menu, editor_ware_category, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
   *
   */
  readonly wareCategory: TWareCategory;
  /**
   * Index all records of WareCategoryColor
   *
   * ALLOWED ROLES: [admin, super_admin, support, user]
   *
   */
  readonly wareCategoryColors: ReadonlyArray<TWareCategoryColor>;
  /**
   * Index all records of WareCategoryType
   *
   * ALLOWED ROLES: [admin, editor_menu, guest, super_admin, support, user]
   *
   */
  readonly wareCategoryTypes: ReadonlyArray<TWareCategoryType>;
  /**
   * Index of wares
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_ware, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly wares: ReadonlyArray<TWare>;
  /**
   * Index all records of WareUnit
   *
   * ALLOWED ROLES: [admin, editor_menu, operator, super_admin, support, user]
   *
   */
  readonly wareUnits: ReadonlyArray<TWareUnit>;
  /**
   * Index all records of WeekDay
   *
   * ALLOWED ROLES: [admin, editor_business_hours, editor_orders, guest, super_admin, support, user]
   *
   */
  readonly weekDays: ReadonlyArray<TWeekDay>;
  /**
   * Details of a Wolt Profile
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_business_hours, editor_integrations, editor_menu, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly woltProfile: TWoltProfile;
  /**
   * Get details of Zone
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, driver, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly zone: TZone;
  /**
   * Index all records of ZoneColor
   *
   * ALLOWED ROLES: [admin, editor_zones, super_admin, support, user]
   *
   */
  readonly zoneColors: ReadonlyArray<TZoneColor>;
  /**
   * Index of zones
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, driver, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly zones: ReadonlyArray<TZone>;
  /**
   * Index all records of ZoneType
   *
   * ALLOWED ROLES: [admin, editor_zones, super_admin, support, user]
   *
   */
  readonly zoneTypes: ReadonlyArray<TZoneType>;
};


/** The query root of this schema */
export type TQueryAddressTypesArgs = {
  internal?: InputMaybe<Scalars['Boolean']>;
};


/** The query root of this schema */
export type TQueryAggregatedIntegrationStatesArgs = {
  companyBranchIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};


/** The query root of this schema */
export type TQueryApplicationSettingsArgs = {
  brand?: InputMaybe<Scalars['ID']>;
  companyBranch?: InputMaybe<Scalars['ID']>;
};


/** The query root of this schema */
export type TQueryBoardArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryBoardsArgs = {
  boardTemplates?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};


/** The query root of this schema */
export type TQueryBoardScreenArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryBoardScreensArgs = {
  board: ReadonlyArray<Scalars['ID']>;
};


/** The query root of this schema */
export type TQueryBoardTemplateArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryBoardTemplatesArgs = {
  features?: InputMaybe<TInputBoardTemplateFeaturesIndex>;
};


/** The query root of this schema */
export type TQueryBoltProfileArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryBusinessHourArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryBusinessHoursArgs = {
  companyBranch: Scalars['ID'];
  mode?: InputMaybe<TBusinessHoursModeEnum>;
  specific?: InputMaybe<Scalars['Boolean']>;
};


/** The query root of this schema */
export type TQueryCashBoxArgs = {
  uuid: Scalars['String'];
};


/** The query root of this schema */
export type TQueryCashBoxesArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  enabled?: InputMaybe<Scalars['Boolean']>;
};


/** The query root of this schema */
export type TQueryCashiersArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};


/** The query root of this schema */
export type TQueryCompaniesArgs = {
  companyType?: InputMaybe<TCompanyTypeEnum>;
};


/** The query root of this schema */
export type TQueryCompanyArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryCompanyBranchArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryCompanyBranchesArgs = {
  brand?: InputMaybe<Scalars['ID']>;
  company?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  portal?: InputMaybe<Scalars['Boolean']>;
};


/** The query root of this schema */
export type TQueryCompanyBranchesLookUpArgs = {
  address: Scalars['String'];
  companyBranchIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};


/** The query root of this schema */
export type TQueryCompanyBranchLookUpArgs = {
  findNearestCompanyBranch?: InputMaybe<Scalars['Boolean']>;
  hostUrl?: InputMaybe<Scalars['String']>;
};


/** The query root of this schema */
export type TQueryCompanyBranchTriggerPrintersArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  onlyTarget?: InputMaybe<Scalars['Boolean']>;
  targetMac?: InputMaybe<Scalars['String']>;
};


/** The query root of this schema */
export type TQueryCompanyBranchTriggersArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  triggerType?: InputMaybe<TTriggerTypeEnum>;
};


/** The query root of this schema */
export type TQueryCompanyBranchUserArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryCompanyBranchUsersArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  deleted?: InputMaybe<Scalars['Boolean']>;
};


/** The query root of this schema */
export type TQueryConsentArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryCountryArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryCreditsCashlessWalletArgs = {
  nfcId: Scalars['String'];
};


/** The query root of this schema */
export type TQueryCreditsFundsTransferArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryCreditsFundsTransfersArgs = {
  cashBoxId?: InputMaybe<Scalars['ID']>;
  companyBranchId?: InputMaybe<Scalars['ID']>;
  state?: InputMaybe<TCreditsFundsTransferStateEnum>;
  type?: InputMaybe<TCreditsFundsTransferTypeEnum>;
  userId?: InputMaybe<Scalars['ID']>;
};


/** The query root of this schema */
export type TQueryCreditsRewardArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryCreditsWalletArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryCreditsWalletActivityArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryCurrencyArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryCustomerArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryCustomersFileReportsArgs = {
  backgroundExport: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryDeliverySlotsArgs = {
  companyBranch: Scalars['ID'];
  deliveryType: TDeliveryTypeEnum;
  empty?: InputMaybe<Scalars['Boolean']>;
  full?: InputMaybe<Scalars['Boolean']>;
  taken?: InputMaybe<Scalars['Boolean']>;
  zone?: InputMaybe<Scalars['ID']>;
};


/** The query root of this schema */
export type TQueryDotykackaProfileArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryDriversArgs = {
  availableForAll?: InputMaybe<Scalars['Boolean']>;
  companyBranch?: InputMaybe<Scalars['ID']>;
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  onlyAvailable?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['ID']>;
  showExternalApi?: InputMaybe<Scalars['Boolean']>;
};


/** The query root of this schema */
export type TQueryEstimateExternalDeliveryArgs = {
  externalDeliveryProvider: TExternalDeliveryProviderEnum;
  order: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryExpressDeliverySettingArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryExternalDeliveriesArgs = {
  companyBranches: ReadonlyArray<Scalars['ID']>;
};


/** The query root of this schema */
export type TQueryFileReportsArgs = {
  fileReportType: TFileReportTypeEnum;
  format?: InputMaybe<TFileReportFormat>;
  statisticsInput: TInputStatisticCreate;
};


/** The query root of this schema */
export type TQueryFinancialReportArgs = {
  report: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryFinancialReportsArgs = {
  cashBoxId?: InputMaybe<Scalars['ID']>;
  companyBranchId: Scalars['ID'];
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  userId?: InputMaybe<Scalars['ID']>;
};


/** The query root of this schema */
export type TQueryFoodoraProfileArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryGreetingArgs = {
  arguments?: InputMaybe<TGreetingsInputArgumentsRead>;
};


/** The query root of this schema */
export type TQueryIngredientArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryIngredientsArgs = {
  quantity?: InputMaybe<Scalars['Int']>;
  recipe: Scalars['ID'];
  stockItem?: InputMaybe<Scalars['ID']>;
};


/** The query root of this schema */
export type TQueryIntegrationsActivityArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryIntegrationsBusinessHoursArgs = {
  profileId: Scalars['ID'];
  profileIntegration: TIntegrationEnum;
};


/** The query root of this schema */
export type TQueryIntegrationsEntityArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryIntegrationsErrorArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryIntegrationsProfileWareCategoryArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryJidloPodNosProfileArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryLastFinancialReportArgs = {
  cashBoxId?: InputMaybe<Scalars['ID']>;
  companyBranchId: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
};


/** The query root of this schema */
export type TQueryLastGeneratedFinancialReportArgs = {
  cashBoxId?: InputMaybe<Scalars['ID']>;
  companyBranchId: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
};


/** The query root of this schema */
export type TQueryMobileApplicationSettingsArgs = {
  companyBranch: Scalars['ID'];
  platform: TMobilePlatformEnum;
};


/** The query root of this schema */
export type TQueryOccasionArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryOccasionsArgs = {
  activePreorder?: InputMaybe<Scalars['Boolean']>;
  companyBranch?: InputMaybe<Scalars['ID']>;
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  future?: InputMaybe<Scalars['Boolean']>;
};


/** The query root of this schema */
export type TQueryOrderArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryOrderGroupArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryOrderMenuAdminArgs = {
  companyBranch: Scalars['ID'];
  language?: InputMaybe<TLanguageEnum>;
  orderOriginCategory: TOrderOriginCategoryEnum;
  wareCategoryType: TWareCategoryTypeEnum;
};


/** The query root of this schema */
export type TQueryOrderOnlinePaymentStatusArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryOrderRecipeArgs = {
  companyBranch?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  language?: InputMaybe<TLanguageEnum>;
};


/** The query root of this schema */
export type TQueryOrderRecipesArgs = {
  order: Scalars['ID'];
  orderRecipeState?: InputMaybe<TOrderRecipeStateEnum>;
  recipe?: InputMaybe<Scalars['ID']>;
};


/** The query root of this schema */
export type TQueryOrdersArgs = {
  order?: InputMaybe<TInputOrderIndex>;
  pagination?: InputMaybe<TInputPaginationParams>;
};


/** The query root of this schema */
export type TQueryOrdersCategoryCountArgs = {
  companyBranches: ReadonlyArray<Scalars['ID']>;
  includeOldFinished?: InputMaybe<Scalars['Boolean']>;
  orderStateCategoriesOR?: InputMaybe<ReadonlyArray<TOrderStateCategoryEnum>>;
  orderStateCategoryTarget?: InputMaybe<TOrderStateCategoryTargetEnum>;
};


/** The query root of this schema */
export type TQueryOrdersCountArgs = {
  companyBranch?: InputMaybe<Scalars['ID']>;
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  includeOldFinished?: InputMaybe<Scalars['Boolean']>;
  orderStateCategories?: InputMaybe<ReadonlyArray<TOrderStateCategoryEnum>>;
  orderStateCategoriesOR?: InputMaybe<ReadonlyArray<TOrderStateCategoryEnum>>;
  orderStateCategoryTarget?: InputMaybe<TOrderStateCategoryTargetEnum>;
  orderStates?: InputMaybe<ReadonlyArray<TOrderStateEnum>>;
  orderStatesOR?: InputMaybe<ReadonlyArray<TOrderStateEnum>>;
};


/** The query root of this schema */
export type TQueryOrderStateCategoriesArgs = {
  target?: InputMaybe<TOrderStateCategoryTargetEnum>;
};


/** The query root of this schema */
export type TQueryPaymentMethodArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryPaymentMethodsArgs = {
  paymentMethod: TInputPaymentMethodIndex;
};


/** The query root of this schema */
export type TQueryPohodaExportArgs = {
  companyBranch: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryPrintConfigurationsArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  printableType?: InputMaybe<TPrintableTypeEnum>;
};


/** The query root of this schema */
export type TQueryPrinterArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryPrintersArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  printerType?: InputMaybe<TPrinterTypeEnum>;
  targetMac?: InputMaybe<Scalars['String']>;
};


/** The query root of this schema */
export type TQueryPrintQueuesArgs = {
  printers?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  targetMac?: InputMaybe<Scalars['String']>;
};


/** The query root of this schema */
export type TQueryPrintTemplatesArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  default?: InputMaybe<Scalars['Boolean']>;
  orderOrigins?: InputMaybe<TInputOrderOriginsWithBlank>;
  public?: InputMaybe<Scalars['Boolean']>;
  triggerableType?: InputMaybe<TTriggerableTypeEnum>;
};


/** The query root of this schema */
export type TQueryPromoCodeArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryPromoCodesArgs = {
  promoCode: TInputPromoCodeIndex;
};


/** The query root of this schema */
export type TQueryPromoTagArgs = {
  enum?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};


/** The query root of this schema */
export type TQueryRecipeArgs = {
  companyBranch?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  language?: InputMaybe<TLanguageEnum>;
};


/** The query root of this schema */
export type TQueryRecipesArgs = {
  ageControl?: InputMaybe<Scalars['Boolean']>;
  companyBranch: Scalars['ID'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  isAvailable?: InputMaybe<Scalars['Boolean']>;
  isAvailableAt?: InputMaybe<Scalars['DateTime']>;
  isCombinationMeal?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<TLanguageEnum>;
  onlyNotInCategory?: InputMaybe<Scalars['Boolean']>;
  orderOriginCategory?: InputMaybe<TOrderOriginCategoryEnum>;
  recipeTags?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  ware?: InputMaybe<Scalars['ID']>;
  wareCategory?: InputMaybe<Scalars['ID']>;
  wareCategoryType?: InputMaybe<TWareCategoryTypeEnum>;
};


/** The query root of this schema */
export type TQueryRecipeTagArgs = {
  id: Scalars['ID'];
  skipSystemTagFallback?: InputMaybe<Scalars['Boolean']>;
};


/** The query root of this schema */
export type TQueryRecipeTagRelationArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryRecipeTagRelationsArgs = {
  usedByCompanyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  withRecipeTagsByCompanies?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};


/** The query root of this schema */
export type TQueryRecipeTagsArgs = {
  companies?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  enabledOnBranches?: InputMaybe<Scalars['Boolean']>;
  recipeTagCategoryTypes?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  systemTags?: InputMaybe<Scalars['Boolean']>;
  usedByCompanyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};


/** The query root of this schema */
export type TQueryResolveLocationArgs = {
  address?: InputMaybe<Scalars['String']>;
  brand?: InputMaybe<Scalars['ID']>;
  companyBranch?: InputMaybe<Scalars['ID']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
};


/** The query root of this schema */
export type TQuerySectorArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQuerySectorRecipeArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQuerySectorRecipesArgs = {
  companyBranch?: InputMaybe<Scalars['ID']>;
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  groups?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  orderRecipeStateOR?: InputMaybe<ReadonlyArray<TOrderRecipeStateEnum>>;
  sectors?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  sectorsWithChildren?: InputMaybe<Scalars['Boolean']>;
  stateChangeSince?: InputMaybe<Scalars['DateTime']>;
};


/** The query root of this schema */
export type TQuerySectorsArgs = {
  companyBranch?: InputMaybe<Scalars['ID']>;
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  isAvailable?: InputMaybe<Scalars['Boolean']>;
  orderOriginCategory?: InputMaybe<TOrderOriginCategoryEnum>;
  sectorType?: InputMaybe<TSectorTypeEnum>;
};


/** The query root of this schema */
export type TQueryShiftArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryShiftsArgs = {
  beginAt?: InputMaybe<Scalars['DateTime']>;
  capacity?: InputMaybe<Scalars['Int']>;
  companyBranch: Scalars['ID'];
  endAt?: InputMaybe<Scalars['DateTime']>;
};


/** The query root of this schema */
export type TQueryStatisticsArgs = {
  statisticsInput: TInputStatisticCreate;
};


/** The query root of this schema */
export type TQueryStatisticsForCreditsArgs = {
  statisticsInput: TInputsStatisticCreditsCreate;
};


/** The query root of this schema */
export type TQueryStatisticsForFeesArgs = {
  statisticsParams: TInputFeeStatistics;
};


/** The query root of this schema */
export type TQueryStatisticsForOperatingCostsArgs = {
  statisticsParams: TInputFeeStatistics;
};


/** The query root of this schema */
export type TQueryStatisticsForPaymentsArgs = {
  statisticsParams: TInputFeeStatistics;
};


/** The query root of this schema */
export type TQueryStockInventoriesArgs = {
  companyBranch: Scalars['ID'];
  createdFrom?: InputMaybe<Scalars['DateTime']>;
  createdTo?: InputMaybe<Scalars['DateTime']>;
  finished?: InputMaybe<Scalars['Boolean']>;
  inProgress?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<Scalars['ID']>;
};


/** The query root of this schema */
export type TQueryStockInventoryArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryStockInventoryItemArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryStockItemArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryStockItemsArgs = {
  company?: InputMaybe<Scalars['ID']>;
  companyBranch?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
};


/** The query root of this schema */
export type TQueryStockItemTransferArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryStockItemTransfersArgs = {
  code?: InputMaybe<Scalars['String']>;
  rejectAccepted?: InputMaybe<Scalars['Boolean']>;
  rejectedByTarget?: InputMaybe<Scalars['Boolean']>;
  sourceCompanyBranch?: InputMaybe<Scalars['ID']>;
  targetCompanyBranch?: InputMaybe<Scalars['ID']>;
};


/** The query root of this schema */
export type TQuerySuggestAddressArgs = {
  brand?: InputMaybe<Scalars['ID']>;
  companyBranch?: InputMaybe<Scalars['ID']>;
  gps: ReadonlyArray<TInputGeoPointCreate>;
};


/** The query root of this schema */
export type TQuerySuggestGeolocationArgs = {
  address: Scalars['String'];
  country?: InputMaybe<TCountryEnum>;
};


/** The query root of this schema */
export type TQueryTerminalTransactionRecordsArgs = {
  creditsFundsTransferId?: InputMaybe<Scalars['ID']>;
  isRefund?: InputMaybe<Scalars['Boolean']>;
  isSuccessful?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['ID']>;
};


/** The query root of this schema */
export type TQueryTransportationDeviceArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryTransportationDevicesArgs = {
  companyBranch: Scalars['ID'];
  deviceState?: InputMaybe<TDeviceStateEnum>;
  deviceType?: InputMaybe<TDeviceTypeEnum>;
};


/** The query root of this schema */
export type TQueryTransportationDeviceUserArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryTransportationDeviceUsersArgs = {
  createdFrom?: InputMaybe<Scalars['DateTime']>;
  createdTo?: InputMaybe<Scalars['DateTime']>;
  returnedFrom?: InputMaybe<Scalars['DateTime']>;
  returnedTo?: InputMaybe<Scalars['DateTime']>;
  transportationDevice?: InputMaybe<Scalars['ID']>;
  user?: InputMaybe<Scalars['ID']>;
};


/** The query root of this schema */
export type TQueryTriggerConfigurationsArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  triggerableType?: InputMaybe<TTriggerableTypeEnum>;
  triggerType?: InputMaybe<TTriggerTypeEnum>;
};


/** The query root of this schema */
export type TQueryUserArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryUserCustomerCallingArgs = {
  eventId: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryUserDeliveriesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyBranch?: InputMaybe<Scalars['ID']>;
  transportationDeviceUser?: InputMaybe<Scalars['ID']>;
};


/** The query root of this schema */
export type TQueryUserDeliveringOrderArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryUserDeliveringOrdersArgs = {
  includeOldFinished?: InputMaybe<Scalars['Boolean']>;
  orderStates: ReadonlyArray<TOrderStateEnum>;
  user: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryUserDeliveryArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryUsersArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};


/** The query root of this schema */
export type TQueryUserShiftsArgs = {
  companyBranch?: InputMaybe<Scalars['ID']>;
  shiftUserState?: InputMaybe<TShiftUserStateEnum>;
  user?: InputMaybe<Scalars['ID']>;
};


/** The query root of this schema */
export type TQueryVamInformationArgs = {
  companyBranchId: Scalars['ID'];
  phone: Scalars['String'];
};


/** The query root of this schema */
export type TQueryVamStatusArgs = {
  input: TInputVamStatus;
};


/** The query root of this schema */
export type TQueryVatsArgs = {
  companyBranch: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryWareArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryWareCategoriesArgs = {
  companyBranch: Scalars['ID'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  filterByRecipe?: InputMaybe<TInputRecipeFilterType>;
  isAvailable?: InputMaybe<Scalars['Boolean']>;
  isAvailableAt?: InputMaybe<Scalars['DateTime']>;
  language?: InputMaybe<TLanguageEnum>;
  occasion?: InputMaybe<Scalars['ID']>;
  orderOriginCategory?: InputMaybe<TOrderOriginCategoryEnum>;
  promoTags?: InputMaybe<ReadonlyArray<TPromoTagEnum>>;
  public?: InputMaybe<Scalars['Boolean']>;
  recipeTags?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  sector?: InputMaybe<Scalars['ID']>;
  wareCategoryType?: InputMaybe<TWareCategoryTypeEnum>;
  withoutPromoTags?: InputMaybe<ReadonlyArray<TPromoTagEnum>>;
};


/** The query root of this schema */
export type TQueryWareCategoryArgs = {
  companyBranch?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  language?: InputMaybe<TLanguageEnum>;
};


/** The query root of this schema */
export type TQueryWaresArgs = {
  code?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  isAvailable?: InputMaybe<Scalars['Boolean']>;
  recipe?: InputMaybe<Scalars['ID']>;
};


/** The query root of this schema */
export type TQueryWoltProfileArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryZoneArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type TQueryZonesArgs = {
  companyBranches: ReadonlyArray<Scalars['ID']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  zoneTypes?: InputMaybe<ReadonlyArray<TZoneTypeEnum>>;
};

/**
 * Possible AddressType types
 *
 *
 * INDEX: [admin, operator, super_admin, support, user]
 *
 * READ: [admin, operator, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TAddressType = {
  readonly __typename?: 'AddressType';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TAddressTypeEnum;
  readonly id: Scalars['ID'];
  /** mark if this address type is public and should be used in registration */
  readonly internal: Scalars['Boolean'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** AddressType enum */
export type TAddressTypeEnum =
  | 'BUSINESS'
  | 'HOME'
  | 'MAIN_ADDRESS'
  | 'OTHER'
  | 'PREMISES'
  | 'WORK';

/**
 * Represents integration data for company branches, including aggregated integration state for each integration
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TAggregatedIntegrationStates = {
  readonly __typename?: 'AggregatedIntegrationStates';
  readonly bolt: Maybe<TBoltIntegration>;
  readonly companyBranches: ReadonlyArray<TCompanyBranch>;
  readonly foodora: Maybe<TFoodoraIntegration>;
  readonly wolt: Maybe<TWoltIntegration>;
};

/**
 * BoltIntegration
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TBoltIntegration = {
  readonly __typename?: 'BoltIntegration';
  readonly integrationState: TIntegrationState;
};

/**
 * Possible IntegrationState types
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TIntegrationState = {
  readonly __typename?: 'IntegrationState';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TIntegrationStateEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** IntegrationState enum */
export type TIntegrationStateEnum =
  | 'ACTIVE'
  | 'CLOSED'
  | 'CLOSED_TODAY'
  | 'CLOSED_UNTIL'
  | 'INACTIVE'
  | 'OFFLINE'
  | 'ONLINE'
  | 'OPEN'
  | 'PARTIALLY_ONLINE'
  | 'UNKNOWN';

/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranch = TApplicationSettingsInterface & TBusinessHoursInterface & TCompanyBranchSettingInterface & TInvoiceSequenceInterface & TLanguageInterface & TProcessTimeInterface & TStockInterface & {
  readonly __typename?: 'CompanyBranch';
  readonly accountNumber: Scalars['String'];
  /** Main address of company branch */
  readonly address: TAddress;
  /** definition of allowed order state categories */
  readonly allowedCategories: ReadonlyArray<TOrderStateCategoryEnum>;
  readonly boltProfiles: ReadonlyArray<TBoltProfile>;
  readonly brand: TCompany;
  readonly businessHours: ReadonlyArray<TBusinessHour>;
  readonly businessHoursIntervals: ReadonlyArray<TBusinessHourInterval>;
  readonly businessHoursMidnight: Scalars['Time'];
  /** order payment method can be updated to these values */
  readonly canBeUpdatedToPaymentMethods: ReadonlyArray<TPaymentMethod>;
  readonly company: TCompany;
  /** all possible covers of company branch */
  readonly covers: ReadonlyArray<TRecipe>;
  readonly creditsGroupMembership: Maybe<TCreditsGroupMembership>;
  /** currencies used by company branch */
  readonly currencies: ReadonlyArray<TCurrency>;
  readonly currentDeliveryTime: Scalars['Int'];
  readonly currentInterval: Maybe<TBusinessHourInterval>;
  readonly currentPickupTime: Scalars['Int'];
  readonly defaultCurrency: TCurrency;
  /** time in minutes that is required to deliver order */
  readonly defaultDeliveryTime: Scalars['Int'];
  readonly defaultDeliveryTimeEnabled: Scalars['Boolean'];
  readonly defaultLanguage: TLanguageEnum;
  /** time in minutes that is required to pickup order */
  readonly defaultPickupTime: Scalars['Int'];
  readonly defaultPickupTimeEnabled: Scalars['Boolean'];
  readonly defaultTimeZone: TTimeZone;
  /** default vat of company branch for defined price type */
  readonly defaultVats: ReadonlyArray<TVatPriceType>;
  readonly delayedDeliveryEnabled: Scalars['Boolean'];
  readonly delayedDeliveryEnabledWaiter: Scalars['Boolean'];
  readonly delayedDeliveryIntervals: ReadonlyArray<TBusinessHourInterval>;
  readonly delayedDeliveryLimit: Scalars['Int'];
  readonly deliveryAsapEnabled: Maybe<Scalars['Boolean']>;
  /** possibility of delivering order */
  readonly deliveryEnabled: Scalars['Boolean'];
  /** Display name for e-shop/waiter, falls back to name */
  readonly displayName: Scalars['String'];
  readonly dotykackaProfiles: ReadonlyArray<TDotykackaProfile>;
  readonly driverOrderAssignments: ReadonlyArray<TUserDeliveringOrdersAssignmentType>;
  readonly driverSmsText: Maybe<Scalars['String']>;
  readonly dynamicTranslations: Maybe<TDynamicTranslationsTranslations>;
  /** Mark if branch allowing assign driver before order is ready to deliver */
  readonly earlyDriverAssignment: Scalars['Boolean'];
  readonly eetCertificate: Maybe<TEetCertificate>;
  readonly employers: ReadonlyArray<TUser>;
  /** is company branch working? */
  readonly enabled: Scalars['Boolean'];
  readonly expressDeliverySetting: Maybe<TExpressDeliverySetting>;
  readonly foodMenuUrl: Maybe<Scalars['String']>;
  readonly foodoraProfiles: ReadonlyArray<TFoodoraProfile>;
  /** GPS coordinates of company branch */
  readonly gps: TGeoPoint;
  readonly gpTomIntegrationAllowed: Scalars['Boolean'];
  readonly headerText: Maybe<Scalars['String']>;
  readonly homepageUrl: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  /** stock items that are incoming to branch */
  readonly incomingStockTransfer: ReadonlyArray<TStockTransfer>;
  /** Returns a translated message specific to a company branch. */
  readonly infoMessage: Maybe<Scalars['String']>;
  readonly internalNumber: Maybe<Scalars['String']>;
  readonly isOpen: Scalars['Boolean'];
  readonly jidloPodNosProfiles: ReadonlyArray<TJidloPodNosProfile>;
  readonly kitchenModuleEnabled: Scalars['Boolean'];
  readonly lastInvoiceSequence: Scalars['Int'];
  readonly lastResettableInvoiceSequence: Scalars['Int'];
  /** maximal size of cart */
  readonly maxCartSize: Scalars['Int'];
  readonly mobileApplicationSetting: Maybe<TMobileApplicationSetting>;
  readonly name: Scalars['String'];
  readonly occasions: ReadonlyArray<TOccasion>;
  /** how many hours it takes for order to be marked as old */
  readonly oldOrderThreshold: Scalars['Int'];
  /** stock items that are leaving branch */
  readonly outcomingStockTransfer: ReadonlyArray<TStockTransfer>;
  readonly overriddenDeliveryTime: Maybe<TOrderProcessTime>;
  readonly overriddenPickupTime: Maybe<TOrderProcessTime>;
  /** payment method used by company branch */
  readonly paymentMethods: ReadonlyArray<TPaymentMethodBranch>;
  readonly phone: Scalars['String'];
  readonly pickupAsapEnabled: Maybe<Scalars['Boolean']>;
  /** possibility of personal order pickup */
  readonly pickupEnabled: Scalars['Boolean'];
  readonly pohodaEnabled: Scalars['Boolean'];
  readonly popUpMessage: Maybe<Scalars['String']>;
  readonly popUpMessageFromBranch: Maybe<Scalars['Boolean']>;
  readonly promoBanners: Maybe<ReadonlyArray<TPromoBanner>>;
  readonly promoCodeLimit: Scalars['Int'];
  /** enabling promo header setting */
  readonly promoHeaderEnabled: Maybe<Scalars['Boolean']>;
  /** inherited promo header text */
  readonly promoHeaderText: Maybe<Scalars['String']>;
  /** promo header text from setting without inheritance */
  readonly promoHeaderTranslations: Maybe<ReadonlyArray<TPromoHeaderTranslation>>;
  readonly settings: TSettingCompanyBranch;
  readonly shifts: ReadonlyArray<TShift>;
  readonly stockItemsCanBeNegative: Scalars['Boolean'];
  /** graphic styles */
  readonly styles: TGraphicStyle;
  readonly supportedLanguages: ReadonlyArray<TLanguageEnum>;
  readonly url: Scalars['String'];
  readonly urlPath: Scalars['String'];
  readonly userAccountsEnabledForCustomer: Scalars['Boolean'];
  readonly wac: Scalars['String'];
  readonly wareCategories: ReadonlyArray<TWareCategory>;
  readonly wifiAppInstructions: ReadonlyArray<TWiFiAppInstruction>;
  readonly willCloseAt: Maybe<Scalars['DateTime']>;
  readonly willOpenAt: Maybe<Scalars['DateTime']>;
  readonly woltProfiles: ReadonlyArray<TWoltProfile>;
  readonly zones: ReadonlyArray<TZone>;
};


/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranchAllowedCategoriesArgs = {
  target?: InputMaybe<TOrderStateCategoryTargetEnum>;
};


/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranchBoltProfilesArgs = {
  integrationFlow?: InputMaybe<TIntegrationsFlowEnum>;
};


/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranchBusinessHoursArgs = {
  date?: InputMaybe<Scalars['Date']>;
  mode?: InputMaybe<TBusinessHoursModeEnum>;
  wholeWeek?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranchBusinessHoursIntervalsArgs = {
  from?: InputMaybe<Scalars['DateTime']>;
  ignoreFastClose?: InputMaybe<Scalars['Boolean']>;
  mode?: InputMaybe<TBusinessHoursModeEnum>;
  to?: InputMaybe<Scalars['DateTime']>;
};


/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranchCanBeUpdatedToPaymentMethodsArgs = {
  country?: InputMaybe<TCountryEnum>;
  deliveryType?: InputMaybe<TDeliveryTypeEnum>;
  orderOrigin?: InputMaybe<TOrderOriginEnum>;
  warePriceType?: InputMaybe<TWarePriceTypeEnum>;
};


/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranchCurrentIntervalArgs = {
  mode?: InputMaybe<TBusinessHoursModeEnum>;
};


/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranchDelayedDeliveryIntervalsArgs = {
  mode?: InputMaybe<TBusinessHoursModeEnum>;
};


/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranchIsOpenArgs = {
  atDateTime?: InputMaybe<Scalars['DateTime']>;
  mode?: InputMaybe<TBusinessHoursModeEnum>;
};


/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranchMobileApplicationSettingArgs = {
  platform: TMobilePlatformEnum;
};


/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranchPaymentMethodsArgs = {
  country?: InputMaybe<TCountryEnum>;
  deliveryType?: InputMaybe<TDeliveryTypeEnum>;
  orderOrigin: TOrderOriginEnum;
  warePriceType: TWarePriceTypeEnum;
};


/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranchPopUpMessageArgs = {
  orderOrigin: TOrderOriginEnum;
};


/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranchPopUpMessageFromBranchArgs = {
  orderOrigin: TOrderOriginEnum;
};


/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranchPromoBannersArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  inherit?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<TLanguageEnum>;
  positions?: InputMaybe<ReadonlyArray<TPromoBannerPositionEnum>>;
};


/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranchStylesArgs = {
  originCategory?: InputMaybe<TOrderOriginCategoryEnum>;
};


/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranchSupportedLanguagesArgs = {
  userSpecific?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranchWareCategoriesArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  public?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranchWillCloseAtArgs = {
  mode?: InputMaybe<TBusinessHoursModeEnum>;
};


/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranchWillOpenAtArgs = {
  mode?: InputMaybe<TBusinessHoursModeEnum>;
};


/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranchWoltProfilesArgs = {
  onboardingStates?: InputMaybe<ReadonlyArray<TWoltProfileOnboardingStateEnum>>;
};

export type TApplicationSettingsInterface = {
  readonly defaultTimeZone: TTimeZone;
  readonly dynamicTranslations: Maybe<TDynamicTranslationsTranslations>;
  readonly headerText: Maybe<Scalars['String']>;
  readonly homepageUrl: Maybe<Scalars['String']>;
  /** enabling promo header setting */
  readonly promoHeaderEnabled: Maybe<Scalars['Boolean']>;
  /** inherited promo header text */
  readonly promoHeaderText: Maybe<Scalars['String']>;
  /** promo header text from setting without inheritance */
  readonly promoHeaderTranslations: Maybe<ReadonlyArray<TPromoHeaderTranslation>>;
  /** graphic styles */
  readonly styles: TGraphicStyle;
  readonly userAccountsEnabledForCustomer: Scalars['Boolean'];
  readonly wifiAppInstructions: ReadonlyArray<TWiFiAppInstruction>;
};


export type TApplicationSettingsInterfaceStylesArgs = {
  originCategory?: InputMaybe<TOrderOriginCategoryEnum>;
};

export type TTimeZone = {
  readonly __typename?: 'TimeZone';
  readonly code: Scalars['String'];
  readonly name: Scalars['String'];
};

/** Specifies the variant of translations to be used. */
export type TDynamicTranslationsTranslations = {
  readonly __typename?: 'DynamicTranslationsTranslations';
  readonly orderDeliveryTime: Maybe<TDynamicTranslationsOrderDeliveryTime>;
};

/** Specifies the variant of translations related to order delivery time to be used. */
export type TDynamicTranslationsOrderDeliveryTime = {
  readonly __typename?: 'DynamicTranslationsOrderDeliveryTime';
  /** delivery_type_doc */
  readonly deliveryType: Maybe<TDynamicTranslationsDeliveryTypeEnum>;
};

/** Possible translation variants for delivery type text. */
export type TDynamicTranslationsDeliveryTypeEnum =
  | 'IN'
  | 'WITHIN';

/** Promo header translations */
export type TPromoHeaderTranslation = {
  readonly __typename?: 'PromoHeaderTranslation';
  readonly content: Maybe<Scalars['String']>;
  readonly language: TLanguageEnum;
};

/** Language enum */
export type TLanguageEnum =
  | 'AF'
  | 'CS'
  | 'DE'
  | 'EN'
  | 'ES'
  | 'FR'
  | 'IT'
  | 'NL'
  | 'PL'
  | 'PT'
  | 'RU'
  | 'SK'
  | 'UK'
  | 'ZU';

/** OrderOriginCategory enum */
export type TOrderOriginCategoryEnum =
  | 'DOVEZE'
  | 'KIOSK'
  | 'MENUBOARD'
  | 'STAFF'
  | 'STAFF_POS'
  | 'WEBSITE'
  | 'WIFI'
  | 'WOLT';

export type TGraphicStyle = {
  readonly __typename?: 'GraphicStyle';
  readonly active: Scalars['String'];
  readonly applicationStyles: Scalars['String'];
  readonly backgroundCart: Scalars['String'];
  readonly headerImage: Scalars['String'];
  readonly main: Scalars['String'];
  readonly mainSecondary: Scalars['String'];
  readonly owner: Scalars['Boolean'];
  readonly screensaver: Scalars['String'];
  readonly storeLogo: Scalars['String'];
  readonly storeLogoMobile: Scalars['String'];
};


export type TGraphicStyleBackgroundCartArgs = {
  height?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};


export type TGraphicStyleHeaderImageArgs = {
  height?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};


export type TGraphicStyleScreensaverArgs = {
  height?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};


export type TGraphicStyleStoreLogoArgs = {
  height?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};


export type TGraphicStyleStoreLogoMobileArgs = {
  height?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};

/** One page of instructions for wifi app */
export type TWiFiAppInstruction = {
  readonly __typename?: 'WiFiAppInstruction';
  readonly header: Maybe<Scalars['String']>;
  readonly image: Maybe<Scalars['String']>;
  readonly text: Scalars['String'];
};


/** One page of instructions for wifi app */
export type TWiFiAppInstructionImageArgs = {
  height?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type TBusinessHoursInterface = {
  readonly businessHours: ReadonlyArray<TBusinessHour>;
  readonly businessHoursIntervals: ReadonlyArray<TBusinessHourInterval>;
  readonly currentInterval: Maybe<TBusinessHourInterval>;
  readonly delayedDeliveryIntervals: ReadonlyArray<TBusinessHourInterval>;
  readonly isOpen: Scalars['Boolean'];
  readonly willCloseAt: Maybe<Scalars['DateTime']>;
  readonly willOpenAt: Maybe<Scalars['DateTime']>;
};


export type TBusinessHoursInterfaceBusinessHoursArgs = {
  date?: InputMaybe<Scalars['Date']>;
  mode?: InputMaybe<TBusinessHoursModeEnum>;
  wholeWeek?: InputMaybe<Scalars['Boolean']>;
};


export type TBusinessHoursInterfaceBusinessHoursIntervalsArgs = {
  from?: InputMaybe<Scalars['DateTime']>;
  ignoreFastClose?: InputMaybe<Scalars['Boolean']>;
  mode?: InputMaybe<TBusinessHoursModeEnum>;
  to?: InputMaybe<Scalars['DateTime']>;
};


export type TBusinessHoursInterfaceCurrentIntervalArgs = {
  mode?: InputMaybe<TBusinessHoursModeEnum>;
};


export type TBusinessHoursInterfaceDelayedDeliveryIntervalsArgs = {
  mode?: InputMaybe<TBusinessHoursModeEnum>;
};


export type TBusinessHoursInterfaceIsOpenArgs = {
  atDateTime?: InputMaybe<Scalars['DateTime']>;
  mode?: InputMaybe<TBusinessHoursModeEnum>;
};


export type TBusinessHoursInterfaceWillCloseAtArgs = {
  mode?: InputMaybe<TBusinessHoursModeEnum>;
};


export type TBusinessHoursInterfaceWillOpenAtArgs = {
  mode?: InputMaybe<TBusinessHoursModeEnum>;
};

/** BusinessHoursMode enum */
export type TBusinessHoursModeEnum =
  | 'ONLINE'
  | 'PHYSICAL';

/**
 * Schema of opening hours of Company Branch
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, editor_business_hour, editor_business_hours, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, editor_business_hour, editor_business_hours, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_business_hour, editor_business_hours, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_business_hour, editor_business_hours, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_business_hour, editor_business_hours, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TBusinessHour = {
  readonly __typename?: 'BusinessHour';
  readonly closeAt: Scalars['Time'];
  readonly closed: Scalars['Boolean'];
  /** reason of closing */
  readonly closedNote: Maybe<Scalars['String']>;
  readonly companyBranch: TCompanyBranch;
  readonly id: Scalars['ID'];
  /** business hours for online orders or physical location */
  readonly mode: TBusinessHoursModeEnum;
  readonly openAt: Scalars['Time'];
  readonly smsLabel: Maybe<Scalars['String']>;
  /** special day */
  readonly specificDate: Maybe<Scalars['Date']>;
  /** localized special day */
  readonly specificDateLocalized: Maybe<Scalars['String']>;
  /** can hours work together with regular ones */
  readonly type: TBusinessHoursTypeEnum;
  readonly webLabel: Maybe<Scalars['String']>;
  /** which day of week It is used to */
  readonly weekDay: Maybe<TWeekDay>;
};

/** BusinessHoursType enum */
export type TBusinessHoursTypeEnum =
  | 'FAST_CLOSE'
  | 'PLANNED_CHANGE'
  | 'REGULAR';

/**
 * Possible WeekDay types
 *
 *
 * INDEX: [admin, editor_business_hours, editor_orders, guest, super_admin, support, user]
 *
 * READ: [admin, editor_business_hours, editor_orders, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TWeekDay = {
  readonly __typename?: 'WeekDay';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TWeekDayEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** WeekDay enum */
export type TWeekDayEnum =
  | 'FRIDAY'
  | 'MONDAY'
  | 'SATURDAY'
  | 'SUNDAY'
  | 'THURSDAY'
  | 'TUESDAY'
  | 'WEDNESDAY';

/** Grouped business hours of company branch */
export type TBusinessHourInterval = {
  readonly __typename?: 'BusinessHourInterval';
  readonly closeAt: Scalars['DateTime'];
  readonly closed: Scalars['Boolean'];
  /** reason of closing */
  readonly closedNote: Maybe<Scalars['String']>;
  readonly openAt: Scalars['DateTime'];
  readonly relevantDay: Scalars['Date'];
};

export type TCompanyBranchSettingInterface = {
  /** definition of allowed order state categories */
  readonly allowedCategories: ReadonlyArray<TOrderStateCategoryEnum>;
  readonly businessHoursMidnight: Scalars['Time'];
  readonly deliveryAsapEnabled: Maybe<Scalars['Boolean']>;
  /** possibility of delivering order */
  readonly deliveryEnabled: Scalars['Boolean'];
  readonly driverOrderAssignments: ReadonlyArray<TUserDeliveringOrdersAssignmentType>;
  readonly driverSmsText: Maybe<Scalars['String']>;
  /** Mark if branch allowing assign driver before order is ready to deliver */
  readonly earlyDriverAssignment: Scalars['Boolean'];
  readonly expressDeliverySetting: Maybe<TExpressDeliverySetting>;
  readonly foodMenuUrl: Maybe<Scalars['String']>;
  readonly gpTomIntegrationAllowed: Scalars['Boolean'];
  readonly kitchenModuleEnabled: Scalars['Boolean'];
  /** maximal size of cart */
  readonly maxCartSize: Scalars['Int'];
  readonly mobileApplicationSetting: Maybe<TMobileApplicationSetting>;
  /** how many hours it takes for order to be marked as old */
  readonly oldOrderThreshold: Scalars['Int'];
  readonly pickupAsapEnabled: Maybe<Scalars['Boolean']>;
  /** possibility of personal order pickup */
  readonly pickupEnabled: Scalars['Boolean'];
  readonly pohodaEnabled: Scalars['Boolean'];
  readonly promoCodeLimit: Scalars['Int'];
  readonly settings: TSettingCompanyBranch;
  readonly urlPath: Scalars['String'];
};


export type TCompanyBranchSettingInterfaceAllowedCategoriesArgs = {
  target?: InputMaybe<TOrderStateCategoryTargetEnum>;
};


export type TCompanyBranchSettingInterfaceMobileApplicationSettingArgs = {
  platform: TMobilePlatformEnum;
};

/** OrderStateCategoryTarget enum */
export type TOrderStateCategoryTargetEnum =
  | 'BACKEND'
  | 'DRIVER'
  | 'FE_ADMIN'
  | 'FE_COMPLETION'
  | 'FE_KITCHEN';

/** OrderStateCategory enum */
export type TOrderStateCategoryEnum =
  | 'BILLS'
  | 'CANCEL'
  | 'DELIVERY'
  | 'FINISHED'
  | 'IN_CART'
  | 'MAIN'
  | 'NEW_ORDERS'
  | 'NOTIFICATION'
  | 'ON_WAY'
  | 'PAYMENT'
  | 'PREPARING'
  | 'PRODUCTION'
  | 'READY_TO_DELIVER'
  | 'RECLAMATION'
  | 'UNCATEGORIZED';

/** Possible UserDeliveringOrdersAssignmentType types */
export type TUserDeliveringOrdersAssignmentType = {
  readonly __typename?: 'UserDeliveringOrdersAssignmentType';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TUserDeliveringOrdersAssignmentTypeEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** UserDeliveringOrdersAssignmentType enum */
export type TUserDeliveringOrdersAssignmentTypeEnum =
  | 'CHECKED_BY_DRIVER'
  | 'DRIVER'
  | 'STAFF';

/** ExpressDeliverySetting */
export type TExpressDeliverySetting = {
  readonly __typename?: 'ExpressDeliverySetting';
  readonly companyBranch: TCompanyBranch;
  readonly currency: TCurrency;
  readonly expressBaseTimeMinutes: Scalars['Int'];
  readonly expressFee: TPriceConverted;
  readonly id: Scalars['ID'];
  /** Returns true when express is enabled, not paused, and capacity is available */
  readonly isExpressAvailable: Scalars['Boolean'];
  readonly isExpressEnabled: Scalars['Boolean'];
  readonly maxOrderValue: Maybe<TPriceConverted>;
  readonly ordersInProgressCurrentCount: Scalars['Int'];
  readonly ordersInProgressLimit: Maybe<Scalars['Int']>;
  readonly pausedBy: Maybe<TUser>;
  readonly pausedFrom: Maybe<Scalars['DateTime']>;
  readonly pausedUntil: Maybe<Scalars['DateTime']>;
};

/**
 * Currency type schema
 *
 *
 * INDEX: [admin, editor_currency, guest, super_admin, support, user]
 *
 * READ: [admin, editor_currency, guest, super_admin, support, user]
 *
 * CREATE: [admin, editor_currency, super_admin, support]
 *
 * UPDATE: [admin, editor_currency, super_admin, support]
 *
 * DESTROY: [admin, editor_currency, super_admin]
 *
 */
export type TCurrency = {
  readonly __typename?: 'Currency';
  readonly code: Scalars['String'];
  /** number of digits */
  readonly decimalRound: Scalars['Int'];
  /** enum string used to identify object */
  readonly enum: TCurrencyEnum;
  /** rate is used for money exchanging */
  readonly exchangeRate: Scalars['Float'];
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** Currency enum */
export type TCurrencyEnum =
  | 'CZK'
  | 'EUR'
  | 'HOP'
  | 'PLN'
  | 'USD'
  | 'ZAR';

/** Price converted to preferred currency */
export type TPriceConverted = {
  readonly __typename?: 'PriceConverted';
  readonly currency: TCurrency;
  /** value formatted based on provided currency */
  readonly formattedValue: Scalars['String'];
  /** value rounded to defined number of decimal places based on currency */
  readonly roundedValue: Scalars['Float'];
  readonly value: Scalars['Float'];
  /** rounded value in minimal currency units */
  readonly valueInMinorUnits: Scalars['Int'];
};

/**
 * Holds information about every user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support, user]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 */
export type TUser = TCreditsOverviewInterface & TDriverInterface & TOrdersInterface & TStatisticsAccessInterface & {
  readonly __typename?: 'User';
  readonly accessibleBranches: ReadonlyArray<TCompanyBranch>;
  readonly accessibleCreditsGroups: ReadonlyArray<TCreditsGroup>;
  readonly address: Maybe<TAddress>;
  readonly addresses: Maybe<ReadonlyArray<TAddress>>;
  readonly companyBranchUsers: ReadonlyArray<TCompanyBranchUser>;
  readonly countUndeliveredOrders: Scalars['Int'];
  readonly createdAt: Scalars['DateTime'];
  readonly creditsExpiringSoon: TCreditsWalletActivityConnection;
  readonly creditsExpiringSoonSum: TCreditsPriceConverted;
  readonly creditsPendingRewards: TCreditsRewardConnection;
  readonly creditsRewards: TCreditsRewardConnection;
  readonly creditsWalletActivities: TCreditsWalletActivityConnection;
  readonly creditsWallets: ReadonlyArray<TCreditsWallet>;
  readonly customers: ReadonlyArray<TCustomer>;
  readonly email: Scalars['String'];
  readonly emails: ReadonlyArray<Scalars['String']>;
  readonly employedBy: ReadonlyArray<TCompanyBranch>;
  readonly firstName: Maybe<Scalars['String']>;
  readonly gps: Maybe<TGeoPoint>;
  readonly greeting: TGreeting;
  readonly id: Scalars['ID'];
  readonly inAppNotifications: TInAppNotificationConnection;
  readonly initials: Scalars['String'];
  readonly isCompanyCustomer: Scalars['Boolean'];
  /** is user guest type? -> customer specific data should be taken from different source */
  readonly isGuest: Scalars['Boolean'];
  readonly language: TLanguage;
  readonly lastName: Maybe<Scalars['String']>;
  readonly login: Maybe<Scalars['String']>;
  readonly maskedEmail: Maybe<Scalars['String']>;
  /** what method use for user notification */
  readonly notification: Maybe<TNotification>;
  readonly orders: ReadonlyArray<TOrder>;
  readonly phone: Scalars['String'];
  readonly roles: ReadonlyArray<TRole>;
  readonly settings: TSettingUser;
  readonly shifts: ReadonlyArray<TShiftUser>;
  readonly signInAt: Maybe<Scalars['DateTime']>;
  readonly signInCount: Maybe<Scalars['Int']>;
  readonly signInIp: Maybe<Scalars['String']>;
  readonly transportationDeviceUsers: ReadonlyArray<TTransportationDeviceUser>;
  readonly unreadInAppNotificationsCount: Scalars['Int'];
  readonly updatedAt: Scalars['DateTime'];
  readonly usedTransportationDevice: Maybe<TTransportationDeviceUser>;
  readonly userDeliveringOrders: ReadonlyArray<TUserDeliveringOrder>;
};


/**
 * Holds information about every user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support, user]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 */
export type TUserAccessibleBranchesArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Holds information about every user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support, user]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 */
export type TUserAddressArgs = {
  addressType?: InputMaybe<TAddressTypeEnum>;
};


/**
 * Holds information about every user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support, user]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 */
export type TUserAddressesArgs = {
  addressTypes?: InputMaybe<ReadonlyArray<TAddressTypeEnum>>;
};


/**
 * Holds information about every user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support, user]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 */
export type TUserCreditsExpiringSoonArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyBranchIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/**
 * Holds information about every user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support, user]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 */
export type TUserCreditsExpiringSoonSumArgs = {
  companyBranchIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};


/**
 * Holds information about every user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support, user]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 */
export type TUserCreditsPendingRewardsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyBranchIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/**
 * Holds information about every user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support, user]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 */
export type TUserCreditsRewardsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyBranchIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  states?: InputMaybe<ReadonlyArray<TCreditsRewardStateEnum>>;
};


/**
 * Holds information about every user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support, user]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 */
export type TUserCreditsWalletActivitiesArgs = {
  activityTypes?: InputMaybe<ReadonlyArray<TCreditsWalletActivityTypeEnum>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyBranchIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  first?: InputMaybe<Scalars['Int']>;
  isExpired?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};


/**
 * Holds information about every user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support, user]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 */
export type TUserCreditsWalletsArgs = {
  companyBranchId?: InputMaybe<Scalars['ID']>;
  companyBranchIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};


/**
 * Holds information about every user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support, user]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 */
export type TUserCustomersArgs = {
  companies?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};


/**
 * Holds information about every user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support, user]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 */
export type TUserEmailsArgs = {
  confirmationStatus?: InputMaybe<TConfirmationStatusSelectorEnum>;
};


/**
 * Holds information about every user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support, user]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 */
export type TUserGreetingArgs = {
  arguments?: InputMaybe<TGreetingsInputArgumentsRead>;
};


/**
 * Holds information about every user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support, user]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 */
export type TUserInAppNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  read?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Holds information about every user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support, user]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 */
export type TUserOrdersArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  from?: InputMaybe<Scalars['DateTime']>;
  orderOrigins?: InputMaybe<ReadonlyArray<TOrderOriginEnum>>;
  to?: InputMaybe<Scalars['DateTime']>;
};


/**
 * Holds information about every user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support, user]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 */
export type TUserPhoneArgs = {
  part?: InputMaybe<TPhonePartSelectorEnum>;
};


/**
 * Holds information about every user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support, user]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 */
export type TUserUserDeliveringOrdersArgs = {
  onlyUndelivered?: InputMaybe<Scalars['Boolean']>;
};

export type TCreditsOverviewInterface = {
  readonly creditsExpiringSoon: TCreditsWalletActivityConnection;
  readonly creditsExpiringSoonSum: TCreditsPriceConverted;
  readonly creditsPendingRewards: TCreditsRewardConnection;
  readonly creditsRewards: TCreditsRewardConnection;
  readonly creditsWalletActivities: TCreditsWalletActivityConnection;
};


export type TCreditsOverviewInterfaceCreditsExpiringSoonArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyBranchIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TCreditsOverviewInterfaceCreditsExpiringSoonSumArgs = {
  companyBranchIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};


export type TCreditsOverviewInterfaceCreditsPendingRewardsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyBranchIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TCreditsOverviewInterfaceCreditsRewardsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyBranchIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  states?: InputMaybe<ReadonlyArray<TCreditsRewardStateEnum>>;
};


export type TCreditsOverviewInterfaceCreditsWalletActivitiesArgs = {
  activityTypes?: InputMaybe<ReadonlyArray<TCreditsWalletActivityTypeEnum>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyBranchIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  first?: InputMaybe<Scalars['Int']>;
  isExpired?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for CreditsWalletActivity. */
export type TCreditsWalletActivityConnection = {
  readonly __typename?: 'CreditsWalletActivityConnection';
  /** A list of edges. */
  readonly edges: Maybe<ReadonlyArray<Maybe<TCreditsWalletActivityEdge>>>;
  /** A list of nodes. */
  readonly nodes: Maybe<ReadonlyArray<Maybe<TCreditsWalletActivity>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: TPageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type TCreditsWalletActivityEdge = {
  readonly __typename?: 'CreditsWalletActivityEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: Maybe<TCreditsWalletActivity>;
};

export type TCreditsWalletActivity = TCreditsCurrencyInterface & {
  readonly __typename?: 'CreditsWalletActivity';
  readonly activityType: TCreditsWalletActivityType;
  readonly amount: TCreditsPriceConverted;
  /** Alias of `self.group.country.cashPaymentDecimals`. */
  readonly cashPaymentDecimals: Scalars['Int'];
  /** Alias of `self.group.country.cashPaymentUnit`. */
  readonly cashPaymentUnit: Scalars['Float'];
  readonly companyBranch: TCompanyBranch;
  readonly createdAt: Scalars['DateTime'];
  readonly currency: TCurrency;
  readonly expiresAt: Maybe<Scalars['DateTime']>;
  readonly group: TCreditsGroup;
  readonly id: Scalars['ID'];
  readonly isExpired: Scalars['Boolean'];
  readonly isExpiringSoon: Scalars['Boolean'];
  readonly order: Maybe<TOrder>;
  readonly remainingAmount: TCreditsPriceConverted;
  readonly wallet: TCreditsWallet;
};

export type TCreditsCurrencyInterface = {
  /** Alias of `self.group.country.cashPaymentDecimals`. */
  readonly cashPaymentDecimals: Scalars['Int'];
  /** Alias of `self.group.country.cashPaymentUnit`. */
  readonly cashPaymentUnit: Scalars['Float'];
  readonly currency: TCurrency;
  readonly group: TCreditsGroup;
};

export type TCreditsGroup = TCreditsCashlessGroupLimitsInterface & {
  readonly __typename?: 'CreditsGroup';
  readonly allMemberships: ReadonlyArray<TCreditsGroupMembership>;
  readonly amlInfoText: Maybe<Scalars['String']>;
  readonly canTopUpMax: TPriceConverted;
  readonly cashlessRefundFrom: Maybe<Scalars['DateTime']>;
  readonly cashlessRefundTo: Maybe<Scalars['DateTime']>;
  readonly closedAt: Maybe<Scalars['DateTime']>;
  readonly company: Maybe<TCompany>;
  readonly country: TCountry;
  readonly currentBalanceLimit: TPriceConverted;
  readonly id: Scalars['ID'];
  readonly isCashlessRefundWindowOpen: Scalars['Boolean'];
  readonly isClosed: Scalars['Boolean'];
  readonly memberships: ReadonlyArray<TCreditsGroupMembership>;
  readonly name: Scalars['String'];
  readonly topUpLimit: TPriceConverted;
};

export type TCreditsCashlessGroupLimitsInterface = {
  readonly canTopUpMax: TPriceConverted;
  readonly currentBalanceLimit: TPriceConverted;
  readonly topUpLimit: TPriceConverted;
};

export type TCreditsGroupMembership = {
  readonly __typename?: 'CreditsGroupMembership';
  readonly canCollect: Scalars['Boolean'];
  readonly canSpend: Scalars['Boolean'];
  readonly closedAt: Maybe<Scalars['DateTime']>;
  readonly companyBranch: TCompanyBranch;
  readonly group: TCreditsGroup;
  readonly id: Scalars['ID'];
  readonly isClosed: Scalars['Boolean'];
};

/**
 * Company type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, driver, editor_company, guest, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * READ: [admin, branch_owner, brand_owner, driver, editor_company, guest, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * CREATE: [admin, editor_company, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company, super_admin]
 *
 */
export type TCompany = TApplicationSettingsInterface & TLanguageInterface & {
  readonly __typename?: 'Company';
  /** Company account number */
  readonly account: Scalars['String'];
  /** Main address of company */
  readonly address: Maybe<TAddress>;
  /** Company branches accessible by user */
  readonly companyBranches: ReadonlyArray<TCompanyBranch>;
  readonly companyConsents: ReadonlyArray<TConsentCompany>;
  readonly companyType: TCompanyType;
  readonly defaultLanguage: TLanguageEnum;
  readonly defaultTimeZone: TTimeZone;
  /** possibility of delivering order at least by one brand branch */
  readonly deliveryEnabled: Maybe<Scalars['Boolean']>;
  readonly dynamicTranslations: Maybe<TDynamicTranslationsTranslations>;
  readonly hasCreditsGroups: Scalars['Boolean'];
  readonly headerText: Maybe<Scalars['String']>;
  readonly homepageUrl: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly internalNumber: Maybe<Scalars['String']>;
  readonly mobileApplicationSetting: Maybe<TMobileApplicationSetting>;
  readonly name: Scalars['String'];
  readonly number: Scalars['String'];
  /** possibility of personal order pickup at least by one brand branch */
  readonly pickupEnabled: Maybe<Scalars['Boolean']>;
  readonly promoBanners: Maybe<ReadonlyArray<TPromoBanner>>;
  /** enabling promo header setting */
  readonly promoHeaderEnabled: Maybe<Scalars['Boolean']>;
  /** inherited promo header text */
  readonly promoHeaderText: Maybe<Scalars['String']>;
  /** promo header text from setting without inheritance */
  readonly promoHeaderTranslations: Maybe<ReadonlyArray<TPromoHeaderTranslation>>;
  readonly settings: TSettingCompany;
  /** graphic styles */
  readonly styles: TGraphicStyle;
  readonly subdomain: Scalars['String'];
  readonly supportedLanguages: ReadonlyArray<TLanguageEnum>;
  readonly url: Scalars['String'];
  readonly userAccountsEnabledForCustomer: Scalars['Boolean'];
  readonly vatIdent: Maybe<Scalars['String']>;
  /** Indicates if Company is payer of VAT. Only for company client type. */
  readonly vatPayer: Scalars['Boolean'];
  readonly wac: Scalars['String'];
  readonly wareCategorySharingAllowed: Scalars['Boolean'];
  readonly wifiAppInstructions: ReadonlyArray<TWiFiAppInstruction>;
};


/**
 * Company type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, driver, editor_company, guest, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * READ: [admin, branch_owner, brand_owner, driver, editor_company, guest, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * CREATE: [admin, editor_company, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company, super_admin]
 *
 */
export type TCompanyCompanyBranchesArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  public?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Company type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, driver, editor_company, guest, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * READ: [admin, branch_owner, brand_owner, driver, editor_company, guest, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * CREATE: [admin, editor_company, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company, super_admin]
 *
 */
export type TCompanyMobileApplicationSettingArgs = {
  platform: TMobilePlatformEnum;
};


/**
 * Company type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, driver, editor_company, guest, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * READ: [admin, branch_owner, brand_owner, driver, editor_company, guest, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * CREATE: [admin, editor_company, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company, super_admin]
 *
 */
export type TCompanyPromoBannersArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<TLanguageEnum>;
  positions?: InputMaybe<ReadonlyArray<TPromoBannerPositionEnum>>;
};


/**
 * Company type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, driver, editor_company, guest, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * READ: [admin, branch_owner, brand_owner, driver, editor_company, guest, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * CREATE: [admin, editor_company, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company, super_admin]
 *
 */
export type TCompanyStylesArgs = {
  originCategory?: InputMaybe<TOrderOriginCategoryEnum>;
};


/**
 * Company type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, driver, editor_company, guest, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * READ: [admin, branch_owner, brand_owner, driver, editor_company, guest, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * CREATE: [admin, editor_company, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company, super_admin]
 *
 */
export type TCompanySupportedLanguagesArgs = {
  userSpecific?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Company type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, driver, editor_company, guest, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * READ: [admin, branch_owner, brand_owner, driver, editor_company, guest, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * CREATE: [admin, editor_company, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company, super_admin]
 *
 */
export type TCompanyUrlArgs = {
  origin?: InputMaybe<TOrderOriginEnum>;
};

export type TLanguageInterface = {
  readonly defaultLanguage: TLanguageEnum;
  readonly supportedLanguages: ReadonlyArray<TLanguageEnum>;
};


export type TLanguageInterfaceSupportedLanguagesArgs = {
  userSpecific?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Address schema of User, Company or Company Branch. Holds information about location and contact possibilities.
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, editor_address, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, editor_address, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, customer, editor_address, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, customer, editor_address, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * DESTROY: [admin, customer, editor_address, super_admin]
 *
 */
export type TAddress = {
  readonly __typename?: 'Address';
  readonly addressType: TAddressType;
  readonly country: Maybe<TCountry>;
  readonly driverNote: Maybe<Scalars['String']>;
  /** possible e-mail contacts */
  readonly emails: ReadonlyArray<TEmail>;
  readonly gps: Maybe<TGeoPoint>;
  readonly id: Scalars['ID'];
  /** description of location */
  readonly location: Maybe<TJsonAddress>;
  /** possible phone contacts */
  readonly phones: ReadonlyArray<TPhone>;
  readonly title: Maybe<Scalars['String']>;
};

/**
 * Holds information about a Country
 *
 *
 * INDEX: [admin, editor_country, editor_menu, gastra_api, guest, operator, super_admin, support, user]
 *
 * READ: [admin, editor_country, editor_menu, gastra_api, guest, operator, super_admin, support, user]
 *
 * CREATE: [admin, editor_country, super_admin, support]
 *
 * UPDATE: [admin, editor_country, super_admin, support]
 *
 * DESTROY: [admin, editor_country, super_admin]
 *
 */
export type TCountry = {
  readonly __typename?: 'Country';
  readonly cashlessWalletLimit: Maybe<Scalars['Float']>;
  readonly cashPaymentDecimals: Scalars['Int'];
  readonly cashPaymentUnit: Scalars['Float'];
  readonly code: Scalars['String'];
  readonly countryVats: ReadonlyArray<TVat>;
  /** default currency for country */
  readonly currency: TCurrency;
  /** enum string used to identify object */
  readonly enum: TCountryEnum;
  readonly id: Scalars['ID'];
  readonly phonePrefix: Scalars['String'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** Vat values */
export type TVat = {
  readonly __typename?: 'Vat';
  readonly default: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly vat: Scalars['Float'];
};

/** Country enum */
export type TCountryEnum =
  | 'CZ'
  | 'DE'
  | 'PL'
  | 'RSA'
  | 'SK';

/**
 * Holds information about email and its description
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, operator, super_admin, support]
 *
 * UPDATE: [admin, operator, super_admin, support]
 *
 * DESTROY: [admin, operator, super_admin]
 *
 */
export type TEmail = {
  readonly __typename?: 'Email';
  readonly default: Scalars['Boolean'];
  readonly description: Maybe<Scalars['String']>;
  readonly email: Scalars['String'];
};

/** Geographic coordinates */
export type TGeoPoint = {
  readonly __typename?: 'GeoPoint';
  readonly latitude: Scalars['Float'];
  readonly longitude: Scalars['Float'];
};

/** Address data such as city, street, etc. Often obtained automatically with inconsistent information. */
export type TJsonAddress = {
  readonly __typename?: 'JsonAddress';
  readonly city: Maybe<Scalars['String']>;
  readonly country: Maybe<Scalars['String']>;
  readonly countryCode: Maybe<Scalars['String']>;
  readonly gps: Maybe<TGeoPoint>;
  readonly houseNumber: Maybe<Scalars['String']>;
  readonly original: Maybe<Scalars['String']>;
  readonly postCode: Maybe<Scalars['String']>;
  readonly state: Maybe<Scalars['String']>;
  readonly street: Maybe<Scalars['String']>;
  readonly venue: Maybe<Scalars['String']>;
};

/**
 * Holds information about phone number and its description
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, operator, super_admin, support]
 *
 * UPDATE: [admin, operator, super_admin, support]
 *
 * DESTROY: [admin, operator, super_admin]
 *
 */
export type TPhone = {
  readonly __typename?: 'Phone';
  readonly default: Scalars['Boolean'];
  readonly description: Maybe<Scalars['String']>;
  readonly phone: Scalars['String'];
};


/**
 * Holds information about phone number and its description
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, operator, super_admin, support]
 *
 * UPDATE: [admin, operator, super_admin, support]
 *
 * DESTROY: [admin, operator, super_admin]
 *
 */
export type TPhonePhoneArgs = {
  part?: InputMaybe<TPhonePartSelectorEnum>;
};

/** Allows to select a specific part of a phone number (country code, local number) or the full international number. Without a selection, the default is the full international number. */
export type TPhonePartSelectorEnum =
  | 'COUNTRY_CODE'
  | 'FULL'
  | 'LOCAL_NUMBER';

export type TConsentCompany = {
  readonly __typename?: 'ConsentCompany';
  readonly company: TCompany;
  readonly consent: TConsent;
  readonly descriptionRendered: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly isActive: Scalars['Boolean'];
  readonly nameRendered: Scalars['String'];
};

/**
 * Details about consent.
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TConsent = {
  readonly __typename?: 'Consent';
  /** Description of consent translated into request language. */
  readonly description: Scalars['String'];
  /** Value in seconds. Meaning: How long is consent active from users confirmation. */
  readonly expiration: Scalars['Int'];
  /** Consent ID */
  readonly id: Scalars['ID'];
  readonly isMandatory: Scalars['Boolean'];
  /** Name of consent translated into request language. */
  readonly name: Scalars['String'];
  /** Indicates if consent is active just for order processing. */
  readonly oneTime: Scalars['Boolean'];
  readonly parent: Maybe<TConsent>;
  /** Type of consent */
  readonly type: TConsentsType;
};

/** Possible ConsentsType types */
export type TConsentsType = {
  readonly __typename?: 'ConsentsType';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TConsentsTypeEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** ConsentsType enum */
export type TConsentsTypeEnum =
  | 'ANALYTICS'
  | 'MARKETING'
  | 'TERMS_AND_CONDITIONS';

/**
 * Possible CompanyType types
 *
 *
 * INDEX: [admin, super_admin, support, user]
 *
 * READ: [admin, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TCompanyType = {
  readonly __typename?: 'CompanyType';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TCompanyTypeEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** CompanyType enum */
export type TCompanyTypeEnum =
  | 'AFFILIATE'
  | 'BRAND'
  | 'CLIENT';

/** Possible mobile platforms */
export type TMobilePlatformEnum =
  | 'ANDROID'
  | 'IOS'
  | 'PWA';

/** Setting attributes for company branches mobile application */
export type TMobileApplicationSetting = {
  readonly __typename?: 'MobileApplicationSetting';
  readonly icon: Scalars['String'];
  readonly title: Scalars['String'];
  readonly url: Scalars['String'];
};


/** Setting attributes for company branches mobile application */
export type TMobileApplicationSettingIconArgs = {
  height?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};

/** PromoBannerPosition enum */
export type TPromoBannerPositionEnum =
  | 'HOMEPAGE1'
  | 'HOMEPAGE2'
  | 'HOMEPAGE3'
  | 'MINIWEB_POPUP1'
  | 'MINIWEB_POPUP2'
  | 'MINIWEB_POPUP3'
  | 'SUBMITTED';

/**
 * Promo Banner
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, guest, merchant, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, guest, merchant, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, merchant, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, merchant, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, merchant, super_admin, supervisor]
 *
 */
export type TPromoBanner = {
  readonly __typename?: 'PromoBanner';
  readonly assignable: TPromoBannerAssignable;
  readonly desktopImage: Maybe<Scalars['String']>;
  readonly enabled: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly language: TLanguageEnum;
  readonly mobileImage: Maybe<Scalars['String']>;
  readonly position: TPromoBannerPositionEnum;
  readonly promoUrl: Maybe<Scalars['String']>;
  readonly recipe: Maybe<TRecipe>;
  /** Provided in milliseconds. */
  readonly showDuration: Maybe<Scalars['Int']>;
};


/**
 * Promo Banner
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, guest, merchant, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, guest, merchant, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, merchant, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, merchant, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, merchant, super_admin, supervisor]
 *
 */
export type TPromoBannerDesktopImageArgs = {
  height?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};


/**
 * Promo Banner
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, guest, merchant, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, guest, merchant, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, merchant, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, merchant, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, merchant, super_admin, supervisor]
 *
 */
export type TPromoBannerMobileImageArgs = {
  height?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};

/** Object in which it may belong a PromoBanner */
export type TPromoBannerAssignable = TCompany | TCompanyBranch;

/**
 * Recipe description for every Ware. Holds information about types of Ware - for example can keep information that Pizza is XXL.
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TRecipe = TActionableEntityInterface & TAvailabilityInterface & {
  readonly __typename?: 'Recipe';
  readonly ageControl: Scalars['Boolean'];
  /** possible allergens */
  readonly allergens: ReadonlyArray<TAllergen>;
  /** recipes that are associated with current recipe */
  readonly associatedRecipes: ReadonlyArray<TRecipeRelation>;
  /** when record is available */
  readonly availabilities: ReadonlyArray<TAvailability>;
  /** number of items that can be produced based on stock */
  readonly availableAmount: Scalars['Int'];
  readonly bistroId: Maybe<Scalars['ID']>;
  /** recipe code */
  readonly code: Scalars['String'];
  /** Description of rules where current recipe is used. */
  readonly dependentRules: ReadonlyArray<Scalars['String']>;
  readonly descriptionLabel: Maybe<Scalars['String']>;
  readonly descriptionLabelTranslated: Maybe<Scalars['String']>;
  readonly dotykackaId: Maybe<Scalars['ID']>;
  readonly enabled: Scalars['Boolean'];
  readonly enabledByOwner: Scalars['Boolean'];
  /** Groups (Workplaces) where the recipe belongs to */
  readonly groups: ReadonlyArray<TGroup>;
  /** Return true if recipe has at least one mandatory side dish category */
  readonly hasMandatoryCategories: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly image: Maybe<Scalars['String']>;
  /** ingredients of recipe */
  readonly ingredients: ReadonlyArray<TIngredient>;
  /** The records of this entity being synced to integrations profiles */
  readonly integrationsEntityProfileSyncs: TIntegrationsProfileEntitySyncConnection;
  /** recipe internal code */
  readonly internalCode: Scalars['String'];
  readonly internalNote: Maybe<Scalars['String']>;
  /** is available at specific time? */
  readonly isAvailable: Scalars['Boolean'];
  readonly isCombinationMeal: Scalars['Boolean'];
  readonly isCover: Scalars['Boolean'];
  readonly isDynamicPricingEnabled: Scalars['Boolean'];
  readonly isMain: Scalars['Boolean'];
  readonly isSideDish: Scalars['Boolean'];
  /** minimum possible sum of the prices of all recipes from side dishes categories */
  readonly mainCombinationMealPrice: TPriceConverted;
  readonly nameLabel: Scalars['String'];
  readonly nameLabelTranslated: Maybe<Scalars['String']>;
  /** number recipes that is part of appropriate order */
  readonly orderRecipeCount: Scalars['Int'];
  /** Return pictogram of recipe. If not specified, inheritance fallback to primaryCategory is enabled. */
  readonly pictogram: Maybe<Scalars['String']>;
  /** delivered price converted to prefered currency */
  readonly price: TPriceConverted;
  /** possible prices of recipes */
  readonly prices: ReadonlyArray<TRecipePrice>;
  /** all categories where recipe is used */
  readonly primaryWareCategory: Maybe<TWareCategory>;
  readonly recipeColor: Maybe<TRecipeColor>;
  readonly recipeTagRelations: Maybe<ReadonlyArray<TRecipeTagRelation>>;
  readonly recipeTags: Maybe<ReadonlyArray<TRecipeTag>>;
  /** which payment methods can be used to pay for recipe */
  readonly rejectedPaymentMethods: ReadonlyArray<TPaymentMethod>;
  readonly shared: Scalars['Boolean'];
  readonly sharedToNonVatPayerCompanyBranches: ReadonlyArray<TCompanyBranch>;
  /** returns an array of the difference between the price of recipe and minimum price of all recipes for each recipe categories */
  readonly sideDishCombinationMealPrices: Maybe<ReadonlyArray<TPriceComboSideDish>>;
  /** all categories that contains possible side dishes of recipe */
  readonly sideDishesWareCategories: ReadonlyArray<TWareCategory>;
  /** number of side dishes categories that recipe can use */
  readonly sideDishesWareCategoriesCount: Scalars['Int'];
  readonly soldOut: Scalars['Boolean'];
  /** stock items of recipe */
  readonly stockItems: ReadonlyArray<TStockItem>;
  readonly translations: ReadonlyArray<TRecipeTranslation>;
  readonly video: Maybe<Scalars['String']>;
  readonly ware: Maybe<TWare>;
  /** all categories where recipe is used */
  readonly wareCategories: ReadonlyArray<TWareCategory>;
  /** number of categories where recipe is used */
  readonly wareCategoriesCount: Scalars['Int'];
  readonly wareCategoryType: TWareCategoryType;
};


/**
 * Recipe description for every Ware. Holds information about types of Ware - for example can keep information that Pizza is XXL.
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TRecipeImageArgs = {
  height?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};


/**
 * Recipe description for every Ware. Holds information about types of Ware - for example can keep information that Pizza is XXL.
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TRecipeIntegrationsEntityProfileSyncsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/**
 * Recipe description for every Ware. Holds information about types of Ware - for example can keep information that Pizza is XXL.
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TRecipeIsAvailableArgs = {
  dateTime?: InputMaybe<Scalars['DateTime']>;
  orderOriginCategory?: InputMaybe<TOrderOriginCategoryEnum>;
};


/**
 * Recipe description for every Ware. Holds information about types of Ware - for example can keep information that Pizza is XXL.
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TRecipeMainCombinationMealPriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
  warePriceType?: InputMaybe<TWarePriceTypeEnum>;
};


/**
 * Recipe description for every Ware. Holds information about types of Ware - for example can keep information that Pizza is XXL.
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TRecipeOrderRecipeCountArgs = {
  orderId: Scalars['ID'];
};


/**
 * Recipe description for every Ware. Holds information about types of Ware - for example can keep information that Pizza is XXL.
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TRecipePictogramArgs = {
  enableFallback?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Recipe description for every Ware. Holds information about types of Ware - for example can keep information that Pizza is XXL.
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TRecipePriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
  warePriceType?: InputMaybe<TWarePriceTypeEnum>;
};


/**
 * Recipe description for every Ware. Holds information about types of Ware - for example can keep information that Pizza is XXL.
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TRecipePricesArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
  warePriceType?: InputMaybe<TWarePriceTypeEnum>;
};


/**
 * Recipe description for every Ware. Holds information about types of Ware - for example can keep information that Pizza is XXL.
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TRecipeSideDishCombinationMealPricesArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
  warePriceType?: InputMaybe<TWarePriceTypeEnum>;
};

export type TActionableEntityInterface = {
  /** The records of this entity being synced to integrations profiles */
  readonly integrationsEntityProfileSyncs: TIntegrationsProfileEntitySyncConnection;
};


export type TActionableEntityInterfaceIntegrationsEntityProfileSyncsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for IntegrationsProfileEntitySync. */
export type TIntegrationsProfileEntitySyncConnection = {
  readonly __typename?: 'IntegrationsProfileEntitySyncConnection';
  /** A list of edges. */
  readonly edges: Maybe<ReadonlyArray<Maybe<TIntegrationsProfileEntitySyncEdge>>>;
  /** A list of nodes. */
  readonly nodes: Maybe<ReadonlyArray<Maybe<TIntegrationsProfileEntitySync>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: TPageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type TIntegrationsProfileEntitySyncEdge = {
  readonly __typename?: 'IntegrationsProfileEntitySyncEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: Maybe<TIntegrationsProfileEntitySync>;
};

export type TIntegrationsProfileEntitySync = {
  readonly __typename?: 'IntegrationsProfileEntitySync';
  readonly entity: TIntegrationsActionableEntityUnion;
  readonly id: Scalars['ID'];
  readonly profile: TIntegrationsProfileUnion;
  readonly syncAt: Scalars['DateTime'];
};

export type TIntegrationsActionableEntityUnion = TBoltProfile | TFoodoraProfile | TIntegrationsEntity | TJidloPodNosProfile | TRecipe | TWoltProfile;

export type TBoltProfile = TDeletableInterface & TEntityErrorsInterface & TIntegrableInterface & TProfileErrorsInterface & {
  readonly __typename?: 'BoltProfile';
  readonly businessHours: Maybe<ReadonlyArray<TIntegrationsBusinessHour>>;
  readonly companyBranch: TCompanyBranch;
  readonly deliveryProvider: Maybe<TBoltDeliveryProvider>;
  readonly id: Scalars['ID'];
  readonly integration: TIntegration;
  readonly integrationFlow: TIntegrationsFlow;
  /** Activities of an entity */
  readonly integrationsEntityActivities: TIntegrationsActivityConnection;
  /** Errors of an entity */
  readonly integrationsEntityErrors: TIntegrationsErrorConnection;
  /** Activities of a profile */
  readonly integrationsProfileActivities: TIntegrationsActivityConnection;
  /** The records of entities being synced to this profile */
  readonly integrationsProfileEntitySyncs: TIntegrationsProfileEntitySyncConnection;
  /** Errors of a profile */
  readonly integrationsProfileErrors: TIntegrationsErrorConnection;
  readonly isAutomaticMenuSyncEnabled: Scalars['Boolean'];
  readonly isDeleted: Scalars['Boolean'];
  readonly lastMenuSyncAt: Maybe<Scalars['DateTime']>;
  readonly name: Scalars['String'];
  readonly onlineState: Maybe<TIntegrationState>;
  /** Bolt's vendor code */
  readonly restaurantIdValue: Maybe<Scalars['String']>;
  /** Unresolved activities of an entity */
  readonly unresolvedIntegrationsEntityActivities: TIntegrationsActivityConnection;
  /** Unresolved errors of an entity */
  readonly unresolvedIntegrationsEntityErrors: TIntegrationsErrorConnection;
  /** Unresolved activities of a profile */
  readonly unresolvedIntegrationsProfileActivities: TIntegrationsActivityConnection;
  /** Unresolved errors of a profile */
  readonly unresolvedIntegrationsProfileErrors: TIntegrationsErrorConnection;
};


export type TBoltProfileIntegrationsEntityActivitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TBoltProfileIntegrationsEntityErrorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TBoltProfileIntegrationsProfileActivitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TBoltProfileIntegrationsProfileEntitySyncsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TBoltProfileIntegrationsProfileErrorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TBoltProfileUnresolvedIntegrationsEntityActivitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TBoltProfileUnresolvedIntegrationsEntityErrorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TBoltProfileUnresolvedIntegrationsProfileActivitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TBoltProfileUnresolvedIntegrationsProfileErrorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type TDeletableInterface = {
  readonly isDeleted: Scalars['Boolean'];
};

export type TEntityErrorsInterface = {
  /** Activities of an entity */
  readonly integrationsEntityActivities: TIntegrationsActivityConnection;
  /** Errors of an entity */
  readonly integrationsEntityErrors: TIntegrationsErrorConnection;
  /** Unresolved activities of an entity */
  readonly unresolvedIntegrationsEntityActivities: TIntegrationsActivityConnection;
  /** Unresolved errors of an entity */
  readonly unresolvedIntegrationsEntityErrors: TIntegrationsErrorConnection;
};


export type TEntityErrorsInterfaceIntegrationsEntityActivitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TEntityErrorsInterfaceIntegrationsEntityErrorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TEntityErrorsInterfaceUnresolvedIntegrationsEntityActivitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TEntityErrorsInterfaceUnresolvedIntegrationsEntityErrorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for IntegrationsActivity. */
export type TIntegrationsActivityConnection = {
  readonly __typename?: 'IntegrationsActivityConnection';
  /** A list of edges. */
  readonly edges: Maybe<ReadonlyArray<Maybe<TIntegrationsActivityEdge>>>;
  /** A list of nodes. */
  readonly nodes: Maybe<ReadonlyArray<Maybe<TIntegrationsActivity>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: TPageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type TIntegrationsActivityEdge = {
  readonly __typename?: 'IntegrationsActivityEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: Maybe<TIntegrationsActivity>;
};

export type TIntegrationsActivity = {
  readonly __typename?: 'IntegrationsActivity';
  readonly entity: TIntegrationsActionableEntityUnion;
  readonly errorAt: Maybe<Scalars['DateTime']>;
  readonly id: Scalars['ID'];
  readonly integrationsErrors: TIntegrationsErrorConnection;
  readonly isSuccess: Scalars['Boolean'];
  readonly profile: TIntegrationsProfileUnion;
  readonly replayable: Scalars['Boolean'];
  readonly successAt: Maybe<Scalars['DateTime']>;
  readonly userDescription: Maybe<Scalars['String']>;
};


export type TIntegrationsActivityIntegrationsErrorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for IntegrationsError. */
export type TIntegrationsErrorConnection = {
  readonly __typename?: 'IntegrationsErrorConnection';
  /** A list of edges. */
  readonly edges: Maybe<ReadonlyArray<Maybe<TIntegrationsErrorEdge>>>;
  /** A list of nodes. */
  readonly nodes: Maybe<ReadonlyArray<Maybe<TIntegrationsError>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: TPageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type TIntegrationsErrorEdge = {
  readonly __typename?: 'IntegrationsErrorEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: Maybe<TIntegrationsError>;
};

export type TIntegrationsError = {
  readonly __typename?: 'IntegrationsError';
  readonly activity: TIntegrationsActivity;
  readonly entity: TIntegrationsActionableEntityUnion;
  readonly externalMessage: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly internalMessage: Scalars['String'];
  readonly profile: TIntegrationsProfileUnion;
};

/** Object which can be an integrations profile */
export type TIntegrationsProfileUnion = TBoltProfile | TFoodoraProfile | TJidloPodNosProfile | TWoltProfile;

export type TFoodoraProfile = TDeletableInterface & TEntityErrorsInterface & TIntegrableInterface & TProfileErrorsInterface & {
  readonly __typename?: 'FoodoraProfile';
  readonly companyBranch: TCompanyBranch;
  readonly deliveryProvider: Maybe<TFoodoraDeliveryProvider>;
  readonly id: Scalars['ID'];
  readonly integration: TIntegration;
  /** Activities of an entity */
  readonly integrationsEntityActivities: TIntegrationsActivityConnection;
  /** Errors of an entity */
  readonly integrationsEntityErrors: TIntegrationsErrorConnection;
  /** Activities of a profile */
  readonly integrationsProfileActivities: TIntegrationsActivityConnection;
  /** The records of entities being synced to this profile */
  readonly integrationsProfileEntitySyncs: TIntegrationsProfileEntitySyncConnection;
  /** Errors of a profile */
  readonly integrationsProfileErrors: TIntegrationsErrorConnection;
  readonly isAutomaticMenuSyncEnabled: Scalars['Boolean'];
  readonly isDeleted: Scalars['Boolean'];
  readonly lastMenuSyncAt: Maybe<Scalars['DateTime']>;
  readonly name: Scalars['String'];
  readonly onlineState: Maybe<TIntegrationState>;
  /** foodora's vendor code */
  readonly restaurantIdValue: Maybe<Scalars['String']>;
  /** Unresolved activities of an entity */
  readonly unresolvedIntegrationsEntityActivities: TIntegrationsActivityConnection;
  /** Unresolved errors of an entity */
  readonly unresolvedIntegrationsEntityErrors: TIntegrationsErrorConnection;
  /** Unresolved activities of a profile */
  readonly unresolvedIntegrationsProfileActivities: TIntegrationsActivityConnection;
  /** Unresolved errors of a profile */
  readonly unresolvedIntegrationsProfileErrors: TIntegrationsErrorConnection;
};


export type TFoodoraProfileIntegrationsEntityActivitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TFoodoraProfileIntegrationsEntityErrorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TFoodoraProfileIntegrationsProfileActivitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TFoodoraProfileIntegrationsProfileEntitySyncsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TFoodoraProfileIntegrationsProfileErrorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TFoodoraProfileUnresolvedIntegrationsEntityActivitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TFoodoraProfileUnresolvedIntegrationsEntityErrorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TFoodoraProfileUnresolvedIntegrationsProfileActivitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TFoodoraProfileUnresolvedIntegrationsProfileErrorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type TIntegrableInterface = {
  readonly companyBranch: TCompanyBranch;
  readonly integration: TIntegration;
  /** The records of entities being synced to this profile */
  readonly integrationsProfileEntitySyncs: TIntegrationsProfileEntitySyncConnection;
  readonly isAutomaticMenuSyncEnabled: Scalars['Boolean'];
  readonly lastMenuSyncAt: Maybe<Scalars['DateTime']>;
  readonly name: Scalars['String'];
};


export type TIntegrableInterfaceIntegrationsProfileEntitySyncsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/**
 * Possible Integration types
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TIntegration = {
  readonly __typename?: 'Integration';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TIntegrationEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** Integration enum */
export type TIntegrationEnum =
  | 'BOLT'
  | 'DOTYKACKA'
  | 'FOODORA'
  | 'JIDLO_POD_NOS'
  | 'WOLT';

export type TProfileErrorsInterface = {
  /** Activities of a profile */
  readonly integrationsProfileActivities: TIntegrationsActivityConnection;
  /** Errors of a profile */
  readonly integrationsProfileErrors: TIntegrationsErrorConnection;
  /** Unresolved activities of a profile */
  readonly unresolvedIntegrationsProfileActivities: TIntegrationsActivityConnection;
  /** Unresolved errors of a profile */
  readonly unresolvedIntegrationsProfileErrors: TIntegrationsErrorConnection;
};


export type TProfileErrorsInterfaceIntegrationsProfileActivitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TProfileErrorsInterfaceIntegrationsProfileErrorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TProfileErrorsInterfaceUnresolvedIntegrationsProfileActivitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TProfileErrorsInterfaceUnresolvedIntegrationsProfileErrorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Possible FoodoraDeliveryProvider types */
export type TFoodoraDeliveryProvider = {
  readonly __typename?: 'FoodoraDeliveryProvider';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TFoodoraDeliveryProviderEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** FoodoraDeliveryProvider enum */
export type TFoodoraDeliveryProviderEnum =
  | 'FOODORA'
  | 'SELF_DELIVERY';

export type TJidloPodNosProfile = TDeletableInterface & TEntityErrorsInterface & TIntegrableInterface & TProfileErrorsInterface & {
  readonly __typename?: 'JidloPodNosProfile';
  readonly companyBranch: TCompanyBranch;
  readonly id: Scalars['ID'];
  readonly integration: TIntegration;
  /** Activities of an entity */
  readonly integrationsEntityActivities: TIntegrationsActivityConnection;
  /** Errors of an entity */
  readonly integrationsEntityErrors: TIntegrationsErrorConnection;
  /** Activities of a profile */
  readonly integrationsProfileActivities: TIntegrationsActivityConnection;
  /** The records of entities being synced to this profile */
  readonly integrationsProfileEntitySyncs: TIntegrationsProfileEntitySyncConnection;
  /** Errors of a profile */
  readonly integrationsProfileErrors: TIntegrationsErrorConnection;
  readonly isAutomaticMenuSyncEnabled: Scalars['Boolean'];
  readonly isDeleted: Scalars['Boolean'];
  readonly lastMenuSyncAt: Maybe<Scalars['DateTime']>;
  readonly name: Scalars['String'];
  /** Jidlo pod nos's vendor code */
  readonly restaurantIdValue: Maybe<Scalars['String']>;
  /** Unresolved activities of an entity */
  readonly unresolvedIntegrationsEntityActivities: TIntegrationsActivityConnection;
  /** Unresolved errors of an entity */
  readonly unresolvedIntegrationsEntityErrors: TIntegrationsErrorConnection;
  /** Unresolved activities of a profile */
  readonly unresolvedIntegrationsProfileActivities: TIntegrationsActivityConnection;
  /** Unresolved errors of a profile */
  readonly unresolvedIntegrationsProfileErrors: TIntegrationsErrorConnection;
};


export type TJidloPodNosProfileIntegrationsEntityActivitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TJidloPodNosProfileIntegrationsEntityErrorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TJidloPodNosProfileIntegrationsProfileActivitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TJidloPodNosProfileIntegrationsProfileEntitySyncsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TJidloPodNosProfileIntegrationsProfileErrorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TJidloPodNosProfileUnresolvedIntegrationsEntityActivitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TJidloPodNosProfileUnresolvedIntegrationsEntityErrorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TJidloPodNosProfileUnresolvedIntegrationsProfileActivitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TJidloPodNosProfileUnresolvedIntegrationsProfileErrorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type TWoltProfile = TDeletableInterface & TEntityErrorsInterface & TIntegrableInterface & TProfileErrorsInterface & {
  readonly __typename?: 'WoltProfile';
  readonly companyBranch: TCompanyBranch;
  readonly deliveryProvider: Maybe<TWoltDeliveryProvider>;
  readonly id: Scalars['ID'];
  readonly integration: TIntegration;
  /** Activities of an entity */
  readonly integrationsEntityActivities: TIntegrationsActivityConnection;
  /** Errors of an entity */
  readonly integrationsEntityErrors: TIntegrationsErrorConnection;
  /** Activities of a profile */
  readonly integrationsProfileActivities: TIntegrationsActivityConnection;
  /** The records of entities being synced to this profile */
  readonly integrationsProfileEntitySyncs: TIntegrationsProfileEntitySyncConnection;
  /** Errors of a profile */
  readonly integrationsProfileErrors: TIntegrationsErrorConnection;
  readonly isAutomaticMenuSyncEnabled: Scalars['Boolean'];
  readonly isDeleted: Scalars['Boolean'];
  readonly lastMenuSyncAt: Maybe<Scalars['DateTime']>;
  readonly name: Scalars['String'];
  readonly onboardingErrors: ReadonlyArray<TWoltApiErrorGlEnum>;
  readonly onboardingErrorsLocalised: ReadonlyArray<Scalars['String']>;
  readonly onboardingState: TWoltProfileOnboardingState;
  readonly onlineState: Maybe<TIntegrationState>;
  /** Wolt's venue_id */
  readonly restaurantIdValue: Maybe<Scalars['String']>;
  /** Unresolved activities of an entity */
  readonly unresolvedIntegrationsEntityActivities: TIntegrationsActivityConnection;
  /** Unresolved errors of an entity */
  readonly unresolvedIntegrationsEntityErrors: TIntegrationsErrorConnection;
  /** Unresolved activities of a profile */
  readonly unresolvedIntegrationsProfileActivities: TIntegrationsActivityConnection;
  /** Unresolved errors of a profile */
  readonly unresolvedIntegrationsProfileErrors: TIntegrationsErrorConnection;
};


export type TWoltProfileIntegrationsEntityActivitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TWoltProfileIntegrationsEntityErrorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TWoltProfileIntegrationsProfileActivitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TWoltProfileIntegrationsProfileEntitySyncsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TWoltProfileIntegrationsProfileErrorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TWoltProfileUnresolvedIntegrationsEntityActivitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TWoltProfileUnresolvedIntegrationsEntityErrorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TWoltProfileUnresolvedIntegrationsProfileActivitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TWoltProfileUnresolvedIntegrationsProfileErrorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Possible WoltDeliveryProvider types */
export type TWoltDeliveryProvider = {
  readonly __typename?: 'WoltDeliveryProvider';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TWoltDeliveryProviderEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** WoltDeliveryProvider enum */
export type TWoltDeliveryProviderEnum =
  | 'SELF_DELIVERY'
  | 'WOLT';

/** Wolt API errors. */
export type TWoltApiErrorGlEnum =
  /** An active profile with the same ID already exists. */
  | 'PROFILE_ALREADY_ONBOARDED'
  /** Error in communication with Wolt API. */
  | 'WOLT_API_COMMUNICATION_ERROR'
  /** Wolt API returned an unexpected response. */
  | 'WOLT_API_RESPONSE_ERROR';

/** Possible WoltProfileOnboardingState types */
export type TWoltProfileOnboardingState = {
  readonly __typename?: 'WoltProfileOnboardingState';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TWoltProfileOnboardingStateEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** WoltProfileOnboardingState enum */
export type TWoltProfileOnboardingStateEnum =
  | 'FAILED'
  | 'IN_PROGRESS'
  | 'NOT_STARTED'
  | 'SUCCESSFUL';

/** Information about pagination in a connection. */
export type TPageInfo = {
  readonly __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor: Maybe<Scalars['String']>;
};

/**
 * Schema of integration profile opening hours
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, editor_business_hour, editor_business_hours, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, editor_business_hour, editor_business_hours, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_business_hour, editor_business_hours, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_business_hour, editor_business_hours, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_business_hour, editor_business_hours, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TIntegrationsBusinessHour = {
  readonly __typename?: 'IntegrationsBusinessHour';
  readonly closeAt: Scalars['Time'];
  readonly id: Scalars['ID'];
  readonly openAt: Scalars['Time'];
  readonly profile: TIntegrationsProfileUnion;
  /** which day of week it is used to */
  readonly weekDay: TWeekDay;
};

/** Possible BoltDeliveryProvider types */
export type TBoltDeliveryProvider = {
  readonly __typename?: 'BoltDeliveryProvider';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TBoltDeliveryProviderEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** BoltDeliveryProvider enum */
export type TBoltDeliveryProviderEnum =
  | 'BOLT'
  | 'SELF_DELIVERY';

/** Possible IntegrationsFlow types */
export type TIntegrationsFlow = {
  readonly __typename?: 'IntegrationsFlow';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TIntegrationsFlowEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** IntegrationsFlow enum */
export type TIntegrationsFlowEnum =
  | 'DIRECT'
  | 'INDIRECT';

export type TIntegrationsEntity = TEntityErrorsInterface & {
  readonly __typename?: 'IntegrationsEntity';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TIntegrationsEntityEnum;
  readonly id: Scalars['ID'];
  /** Activities of an entity */
  readonly integrationsEntityActivities: TIntegrationsActivityConnection;
  /** Errors of an entity */
  readonly integrationsEntityErrors: TIntegrationsErrorConnection;
  /** not localized code */
  readonly rawCode: Scalars['String'];
  /** Unresolved activities of an entity */
  readonly unresolvedIntegrationsEntityActivities: TIntegrationsActivityConnection;
  /** Unresolved errors of an entity */
  readonly unresolvedIntegrationsEntityErrors: TIntegrationsErrorConnection;
};


export type TIntegrationsEntityIntegrationsEntityActivitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TIntegrationsEntityIntegrationsEntityErrorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TIntegrationsEntityUnresolvedIntegrationsEntityActivitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TIntegrationsEntityUnresolvedIntegrationsEntityErrorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** IntegrationsEntityEnum */
export type TIntegrationsEntityEnum =
  | 'BUSINESS_HOURS'
  | 'MENU';

export type TAvailabilityInterface = {
  /** when record is available */
  readonly availabilities: ReadonlyArray<TAvailability>;
  /** is available at specific time? */
  readonly isAvailable: Scalars['Boolean'];
};


export type TAvailabilityInterfaceIsAvailableArgs = {
  dateTime?: InputMaybe<Scalars['DateTime']>;
  orderOriginCategory?: InputMaybe<TOrderOriginCategoryEnum>;
};

/**
 * Holds information about usability - what times can be Ware, etc. used
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, cashier_menu, editor_availability, editor_menu, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, cashier_menu, editor_availability, editor_menu, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_availability, editor_menu, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_availability, editor_menu, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_availability, editor_menu, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TAvailability = {
  readonly __typename?: 'Availability';
  readonly availabilityType: TAvailabilityType;
  readonly available: Scalars['Boolean'];
  readonly dateFrom: Maybe<Scalars['Date']>;
  readonly dateTo: Maybe<Scalars['Date']>;
  readonly id: Scalars['ID'];
  readonly orderOriginCategories: ReadonlyArray<TOrderOriginCategoryEnum>;
  readonly periodic: Scalars['Boolean'];
  readonly timeFrom: Maybe<Scalars['Time']>;
  readonly timeTo: Maybe<Scalars['Time']>;
  readonly weekDay: Maybe<TWeekDay>;
};

/**
 * Possible AvailabilityType types
 *
 *
 * INDEX: [admin, editor_menu, super_admin, support, user]
 *
 * READ: [admin, editor_menu, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TAvailabilityType = {
  readonly __typename?: 'AvailabilityType';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TAvailabilityTypeEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** AvailabilityType enum */
export type TAvailabilityTypeEnum =
  | 'MAIN'
  | 'SPECIFIC';

/**
 * Allergen type schema
 *
 *
 * INDEX: [admin, editor_menu, editor_orders, gastra_api, guest, super_admin, support, user]
 *
 * READ: [admin, editor_menu, editor_orders, gastra_api, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TAllergen = {
  readonly __typename?: 'Allergen';
  /** category of allergen */
  readonly category: Scalars['Int'];
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TAllergenEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** Allergen enum */
export type TAllergenEnum =
  | 'CELERY'
  | 'CEREALS_WITH_GLUTTEN'
  | 'EGG'
  | 'FISH'
  | 'LUPIN'
  | 'MILK'
  | 'MOLLUSCS'
  | 'MUSTARD'
  | 'NUT'
  | 'PEANUT'
  | 'SESAME'
  | 'SHELLFISH'
  | 'SOYBEANS'
  | 'SULFUROUS';

/**
 * Relation between two recipes
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_recipe_relation, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_recipe_relation, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_recipe_relation, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_recipe_relation, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_recipe_relation, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TRecipeRelation = {
  readonly __typename?: 'RecipeRelation';
  readonly associatedRecipe: TRecipe;
  readonly id: Scalars['ID'];
  readonly recipe: TRecipe;
  readonly warePriceType: TWarePriceType;
};

/**
 * Possible WarePriceType types
 *
 *
 * INDEX: [admin, editor_menu, guest, super_admin, support, user]
 *
 * READ: [admin, editor_menu, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TWarePriceType = {
  readonly __typename?: 'WarePriceType';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TWarePriceTypeEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** WarePriceType enum */
export type TWarePriceTypeEnum =
  | 'BOLT'
  | 'DELIVERY'
  | 'FOODORA'
  | 'INHOUSE'
  | 'JIDLO_POD_NOS'
  | 'WOLT';

/**
 * Group (workplace) for recipes
 *
 *
 * INDEX: [admin, super_admin, support, user]
 *
 * READ: [admin, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TGroup = {
  readonly __typename?: 'Group';
  readonly code: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly label: Scalars['String'];
};

/**
 * Holds information about recipe/ware ingredients
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, editor_ingredient, editor_menu, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, editor_ingredient, editor_menu, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_ingredient, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_ingredient, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_ingredient, gastra_api, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TIngredient = {
  readonly __typename?: 'Ingredient';
  readonly id: Scalars['ID'];
  readonly quantity: Scalars['Float'];
  readonly recipe: TRecipe;
  readonly stockItem: TStockItem;
};

/**
 * Keeps information about items at stock
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, editor_menu, editor_stock_item, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, editor_menu, editor_stock_item, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_stock_item, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_stock_item, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_stock_item, gastra_api, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TStockItem = {
  readonly __typename?: 'StockItem';
  /** possible allergens */
  readonly allergens: ReadonlyArray<TAllergen>;
  readonly allowNegative: TFieldStateEnum;
  readonly allowNegativeValue: Scalars['Boolean'];
  readonly code: Scalars['String'];
  readonly companyBranch: TCompanyBranch;
  readonly history: ReadonlyArray<TStockItemHistory>;
  readonly id: Scalars['ID'];
  /** ingredients that are using stock item */
  readonly ingredients: ReadonlyArray<TIngredient>;
  readonly label: Scalars['String'];
  readonly note: Scalars['String'];
  /** The StockItem that this StockItem is shared from. When the StockItem is not shared, it references itself. */
  readonly originalStockItem: TStockItem;
  /** The StockItem that will be used to perform stock manipulations when this StockItem is used. */
  readonly physicalStockItem: TStockItem;
  readonly plu: Maybe<Scalars['String']>;
  readonly price: Scalars['Float'];
  readonly quantity: Scalars['Float'];
  readonly quantityChange: Scalars['Float'];
  /** recipes that are using stock item */
  readonly recipes: ReadonlyArray<TRecipe>;
  /** True when the StockItem is shared, false when it is an original StockItem. */
  readonly shared: Scalars['Boolean'];
  readonly wareUnit: TWareUnit;
};


/**
 * Keeps information about items at stock
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, editor_menu, editor_stock_item, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, editor_menu, editor_stock_item, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_stock_item, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_stock_item, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_stock_item, gastra_api, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TStockItemQuantityChangeArgs = {
  fromDate: Scalars['DateTime'];
  toDate?: InputMaybe<Scalars['DateTime']>;
};

/** FieldState enum */
export type TFieldStateEnum =
  | 'DEFAULT'
  | 'DISABLED'
  | 'ENABLED';

export type TStockItemHistory = {
  readonly __typename?: 'StockItemHistory';
  readonly amount: Scalars['Float'];
  readonly dateTime: Scalars['DateTime'];
  readonly user: TUser;
  readonly wareUnit: TWareUnit;
};

/**
 * Possible WareUnit types
 *
 *
 * INDEX: [admin, editor_menu, operator, super_admin, support, user]
 *
 * READ: [admin, editor_menu, operator, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TWareUnit = {
  readonly __typename?: 'WareUnit';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TWareUnitEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** WareUnit enum */
export type TWareUnitEnum =
  | 'GRAM'
  | 'KILOGRAM'
  | 'LITRE'
  | 'MILLIGRAM'
  | 'MILLILITRE'
  | 'PIECE';

/**
 * Price of recipe
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, driver, editor_menu, editor_recipe_price, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, driver, editor_menu, editor_recipe_price, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe_price, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe_price, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_recipe_price, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TRecipePrice = {
  readonly __typename?: 'RecipePrice';
  readonly dynamicVat: TVat;
  readonly id: Scalars['ID'];
  /** price converted to prefered currency */
  readonly price: TPriceConverted;
  readonly recipe: TRecipe;
  readonly vat: TVat;
  readonly warePriceType: TWarePriceType;
};


/**
 * Price of recipe
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, driver, editor_menu, editor_recipe_price, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, driver, editor_menu, editor_recipe_price, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe_price, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe_price, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_recipe_price, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TRecipePriceDynamicVatArgs = {
  companyBranchId?: InputMaybe<Scalars['ID']>;
};


/**
 * Price of recipe
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, driver, editor_menu, editor_recipe_price, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, driver, editor_menu, editor_recipe_price, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe_price, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe_price, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_recipe_price, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TRecipePricePriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};

/**
 * Information about category of wares
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier_menu, editor_menu, editor_ware_category, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier_menu, editor_menu, editor_ware_category, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_ware_category, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_ware_category, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_ware_category, gastra_api, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TWareCategory = TAvailabilityInterface & {
  readonly __typename?: 'WareCategory';
  readonly automaticFinish: Scalars['Boolean'];
  /** when record is available */
  readonly availabilities: ReadonlyArray<TAvailability>;
  /** owner of category */
  readonly companyBranch: TCompanyBranch;
  /** number of items in category */
  readonly countRecipes: Scalars['Int'];
  /** covers of ware category */
  readonly covers: ReadonlyArray<TRecipe>;
  /** Description of rules where current ware category is used. */
  readonly dependentRules: ReadonlyArray<Scalars['String']>;
  readonly descriptionLabel: Maybe<Scalars['String']>;
  readonly descriptionLabelTranslated: Maybe<Scalars['String']>;
  readonly dotykackaId: Maybe<Scalars['ID']>;
  /** is category active? */
  readonly enabled: Scalars['Boolean'];
  readonly enabledByOwner: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly image: Maybe<Scalars['String']>;
  /** List of integrations this category is shared to */
  readonly integrations: ReadonlyArray<TIntegration>;
  /** List of profiles this category is shared to */
  readonly integrationsProfiles: ReadonlyArray<TIntegrationsProfileUnion>;
  /** List of associations with integrations this category is shared to */
  readonly integrationsProfileWareCategories: ReadonlyArray<TIntegrationsProfileWareCategory>;
  readonly internalNoteLabel: Maybe<Scalars['String']>;
  readonly internalNoteLabelTranslated: Maybe<Scalars['String']>;
  /** is available at specific time? */
  readonly isAvailable: Scalars['Boolean'];
  /** main recipes of ware category */
  readonly mains: ReadonlyArray<TRecipe>;
  /** maximal number of wares that have to selected at this category */
  readonly maxCount: Scalars['Int'];
  /** max number of recipes of one kind that can be selected */
  readonly maxRecipesCount: Scalars['Int'];
  /** minimal number of wares that have to selected at this category */
  readonly minCount: Scalars['Int'];
  readonly nameLabel: Scalars['String'];
  readonly nameLabelTranslated: Maybe<Scalars['String']>;
  readonly orderOriginCategories: ReadonlyArray<TOrderOriginCategoryEnum>;
  readonly pictogram: Maybe<Scalars['String']>;
  readonly promoTags: ReadonlyArray<TPromoTag>;
  /** should be category shown to public? */
  readonly public: Scalars['Boolean'];
  /** all recipes of ware category */
  readonly recipes: ReadonlyArray<TRecipe>;
  readonly recipeTagRelations: Maybe<ReadonlyArray<TRecipeTagRelation>>;
  readonly recipeTags: Maybe<ReadonlyArray<TRecipeTag>>;
  readonly sharedCompanyBranches: ReadonlyArray<TCompanyBranch>;
  /** side dishes of ware category */
  readonly sideDishes: ReadonlyArray<TRecipe>;
  readonly translations: ReadonlyArray<TWareCategoryTranslation>;
  readonly wareCategoryColor: Maybe<TWareCategoryColor>;
  readonly wareCategoryType: TWareCategoryType;
};


/**
 * Information about category of wares
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier_menu, editor_menu, editor_ware_category, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier_menu, editor_menu, editor_ware_category, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_ware_category, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_ware_category, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_ware_category, gastra_api, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TWareCategoryImageArgs = {
  height?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};


/**
 * Information about category of wares
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier_menu, editor_menu, editor_ware_category, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier_menu, editor_menu, editor_ware_category, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_ware_category, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_ware_category, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_ware_category, gastra_api, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TWareCategoryIsAvailableArgs = {
  dateTime?: InputMaybe<Scalars['DateTime']>;
  orderOriginCategory?: InputMaybe<TOrderOriginCategoryEnum>;
};


/**
 * Information about category of wares
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier_menu, editor_menu, editor_ware_category, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier_menu, editor_menu, editor_ware_category, gastra_api, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_ware_category, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_ware_category, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_ware_category, gastra_api, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TWareCategoryRecipesArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  isAvailable?: InputMaybe<Scalars['Boolean']>;
  isAvailableAt?: InputMaybe<Scalars['DateTime']>;
  orderOriginCategory?: InputMaybe<TOrderOriginCategoryEnum>;
};

export type TIntegrationsProfileWareCategory = {
  readonly __typename?: 'IntegrationsProfileWareCategory';
  readonly id: Scalars['ID'];
  readonly integration: TIntegration;
  readonly profile: TIntegrationsProfileUnion;
  readonly wareCategory: TWareCategory;
};

/**
 * Possible PromoTag types
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TPromoTag = {
  readonly __typename?: 'PromoTag';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TPromoTagEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** PromoTag enum */
export type TPromoTagEnum =
  | 'HIDDEN_FROM_STANDARD'
  | 'PROMO_CART'
  | 'PROMO_CATEGORY_LIST'
  | 'PROMO_FOOTER'
  | 'PROMO_HEADER'
  | 'PROMO_SIDE_DISH';

/**
 *
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TRecipeTagRelation = {
  readonly __typename?: 'RecipeTagRelation';
  readonly id: Scalars['ID'];
  readonly inherited: Scalars['Boolean'];
  readonly parentRelation: Maybe<TRecipeTagRelation>;
  readonly recipeTag: TRecipeTag;
  readonly taggable: TRecipeTagTaggable;
};

/**
 *
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_menu, super_admin, supervisor]
 *
 */
export type TRecipeTag = {
  readonly __typename?: 'RecipeTag';
  readonly color: Maybe<Scalars['String']>;
  readonly company: Maybe<TCompany>;
  readonly id: Scalars['ID'];
  readonly image: Maybe<Scalars['String']>;
  readonly label: Maybe<Scalars['String']>;
  readonly pictogram: Maybe<Scalars['String']>;
  readonly recipeTagCategoryType: Maybe<TRecipeTagCategoryType>;
  readonly systemRecipeTag: Maybe<TRecipeTag>;
  readonly translations: ReadonlyArray<TRecipeTagTranslation>;
};


/**
 *
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_menu, super_admin, supervisor]
 *
 */
export type TRecipeTagImageArgs = {
  height?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};


/**
 *
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_menu, super_admin, supervisor]
 *
 */
export type TRecipeTagLabelArgs = {
  company?: InputMaybe<Scalars['ID']>;
};

/**
 * Possible RecipeTagCategoryType types
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TRecipeTagCategoryType = {
  readonly __typename?: 'RecipeTagCategoryType';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TRecipeTagCategoryTypeEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** RecipeTagCategoryType enum */
export type TRecipeTagCategoryTypeEnum =
  | 'SPECIAL_FLAG'
  | 'WARE_PROPERTY'
  | 'WARE_TYPE';

/** Translations */
export type TRecipeTagTranslation = {
  readonly __typename?: 'RecipeTagTranslation';
  readonly label: Maybe<Scalars['String']>;
  readonly language: TLanguage;
};

/**
 * Possible Language types
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TLanguage = {
  readonly __typename?: 'Language';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TLanguageEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** Object which can be tagged by a RecipeTag */
export type TRecipeTagTaggable = TRecipe | TWareCategory;

/** Translations */
export type TWareCategoryTranslation = {
  readonly __typename?: 'WareCategoryTranslation';
  readonly descriptionLabel: Maybe<Scalars['String']>;
  readonly internalNoteLabel: Maybe<Scalars['String']>;
  readonly label: Maybe<Scalars['String']>;
  readonly language: TLanguage;
};

/**
 * Ware category color with code and color definition
 *
 *
 * INDEX: [admin, super_admin, support, user]
 *
 * READ: [admin, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TWareCategoryColor = TColorInterface & {
  readonly __typename?: 'WareCategoryColor';
  readonly code: Scalars['String'];
  readonly color: Scalars['String'];
  readonly id: Scalars['ID'];
};

export type TColorInterface = {
  readonly code: Scalars['String'];
  readonly color: Scalars['String'];
  readonly id: Scalars['ID'];
};

/**
 * Possible WareCategoryType types
 *
 *
 * INDEX: [admin, editor_menu, guest, super_admin, support, user]
 *
 * READ: [admin, editor_menu, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TWareCategoryType = {
  readonly __typename?: 'WareCategoryType';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TWareCategoryTypeEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** WareCategoryType enum */
export type TWareCategoryTypeEnum =
  | 'COVER'
  | 'MAIN'
  | 'MIXIN'
  | 'SIDE_DISH';

/**
 * Recipe color with code and color definition
 *
 *
 * INDEX: [admin, super_admin, support, user]
 *
 * READ: [admin, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TRecipeColor = TColorInterface & {
  readonly __typename?: 'RecipeColor';
  readonly code: Scalars['String'];
  readonly color: Scalars['String'];
  readonly id: Scalars['ID'];
};

/**
 * Holds information about specifications of payment method
 *
 *
 * INDEX: [admin, editor_payment_method, guest, super_admin, support, user]
 *
 * READ: [admin, editor_payment_method, guest, super_admin, support, user]
 *
 * CREATE: [admin, editor_payment_method, super_admin, support]
 *
 * UPDATE: [admin, editor_payment_method, super_admin, support]
 *
 * DESTROY: [admin, editor_payment_method, super_admin]
 *
 */
export type TPaymentMethod = {
  readonly __typename?: 'PaymentMethod';
  readonly country: TCountry;
  /** default description of payment method */
  readonly description: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly paymentGate: TPaymentGate;
  readonly paymentType: TPaymentType;
  /** default value of payment method */
  readonly price: Maybe<TPriceConverted>;
};


/**
 * Holds information about specifications of payment method
 *
 *
 * INDEX: [admin, editor_payment_method, guest, super_admin, support, user]
 *
 * READ: [admin, editor_payment_method, guest, super_admin, support, user]
 *
 * CREATE: [admin, editor_payment_method, super_admin, support]
 *
 * UPDATE: [admin, editor_payment_method, super_admin, support]
 *
 * DESTROY: [admin, editor_payment_method, super_admin]
 *
 */
export type TPaymentMethodPriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};

/**
 * Possible PaymentGate types
 *
 *
 * INDEX: [admin, super_admin, support, user]
 *
 * READ: [admin, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TPaymentGate = {
  readonly __typename?: 'PaymentGate';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TPaymentGateEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** PaymentGate enum */
export type TPaymentGateEnum =
  | 'ADYEN'
  | 'CASH'
  | 'CREDIT'
  | 'CSOB'
  | 'EXTERNAL_GATE'
  | 'GOPAY'
  | 'GP_WEBPAY'
  | 'KIOSK_GATE'
  | 'PAY_FAST'
  | 'PAYPAL'
  | 'PAYU'
  | 'POS2_GATE'
  | 'WALLET_CREDIT';

/**
 * Possible PaymentType types
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TPaymentType = {
  readonly __typename?: 'PaymentType';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TPaymentTypeEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** PaymentType enum */
export type TPaymentTypeEnum =
  | 'CASH'
  | 'CREDIT'
  | 'DISCOUNT'
  | 'POST_PAID'
  | 'VOUCHER'
  | 'WALLET_CREDIT';

/** Price converted to preferred currency with ware category id */
export type TPriceComboSideDish = {
  readonly __typename?: 'PriceComboSideDish';
  readonly price: TPriceConverted;
  readonly wareCategoryId: Scalars['ID'];
};

/** Translations */
export type TRecipeTranslation = {
  readonly __typename?: 'RecipeTranslation';
  readonly descriptionLabel: Maybe<Scalars['String']>;
  readonly label: Maybe<Scalars['String']>;
  readonly language: TLanguage;
};

/**
 * Type for Ware
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, editor_menu, editor_ware, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, editor_menu, editor_ware, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_ware, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_ware, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_ware, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TWare = {
  readonly __typename?: 'Ware';
  /** when ware is available */
  readonly availabilities: ReadonlyArray<TAvailability>;
  /** ware code */
  readonly code: Scalars['String'];
  readonly companyBranch: TCompanyBranch;
  readonly descriptionLabel: Scalars['String'];
  readonly enabled: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly isAvailable: Scalars['Boolean'];
  readonly nameLabel: Scalars['String'];
  /** all recipes of Ware */
  readonly recipes: ReadonlyArray<TRecipe>;
};

/** Settings of Company */
export type TSettingCompany = {
  readonly __typename?: 'SettingCompany';
  readonly kioskStyles: Maybe<TKioskStylesSetting>;
};

/** Setting attributes for kiosk styles */
export type TKioskStylesSetting = {
  readonly __typename?: 'KioskStylesSetting';
  readonly carouselImages: ReadonlyArray<TKioskCarouselImage>;
  readonly mainIntroImage: Maybe<Scalars['String']>;
};


/** Setting attributes for kiosk styles */
export type TKioskStylesSettingMainIntroImageArgs = {
  language?: InputMaybe<TLanguageEnum>;
};

/** Kiosk carousel image */
export type TKioskCarouselImage = {
  readonly __typename?: 'KioskCarouselImage';
  readonly duration: Scalars['Int'];
  readonly imageUrl: Scalars['String'];
};

/** OrderOrigin enum */
export type TOrderOriginEnum =
  | 'AFFILIATE_PIZZA_ROZVOZ'
  | 'AFFILIATE_ROZVOZ_JIDLA'
  | 'AFFILIATE_ROZVOZ_PIZZY_ZDARMA'
  | 'BAKER'
  | 'BISTRO'
  | 'BOLT'
  | 'CALL_CENTER'
  | 'DAME_JIDLO'
  | 'DEFAULT'
  | 'DOTYKACKA'
  | 'ENIGOO'
  | 'JIDLO_POD_NOS'
  | 'KIOSK'
  | 'MINISITE'
  | 'MOBIL_ANDROID'
  | 'MOBIL_IOS'
  | 'MPIZZA'
  | 'PWA'
  | 'STAFF'
  | 'STAFF_POS'
  | 'WEB'
  | 'WEB_MENU'
  | 'WEB_PARTNER'
  | 'WIFI'
  | 'WIFI_DEFAULT'
  | 'WIFI_PREORDER'
  | 'WOLT';

/** Possible CreditsWalletActivityType types */
export type TCreditsWalletActivityType = {
  readonly __typename?: 'CreditsWalletActivityType';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TCreditsWalletActivityTypeEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** CreditsWalletActivityType enum */
export type TCreditsWalletActivityTypeEnum =
  | 'GIFT'
  | 'MANUAL_DECREASE'
  | 'ORDER_PAYMENT'
  | 'ORDER_PAYMENT_CANCELED'
  | 'ORDER_REWARD'
  | 'REFUND'
  | 'REFUND_REQUEST'
  | 'TOP_UP';

/** Credits price converted to format of the current locale */
export type TCreditsPriceConverted = {
  readonly __typename?: 'CreditsPriceConverted';
  readonly formattedValue: Scalars['String'];
  readonly value: Scalars['Float'];
};

/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrder = TFlagAttributesInterface & TInvoiceSequencesInterface & TOrderStateInterface & TPriceInterface & TRestrictedAttributes & TTransportFeeInterface & {
  readonly __typename?: 'Order';
  readonly acceptedAt: Maybe<Scalars['DateTime']>;
  /** can be address from google - no consistent data */
  readonly address: TJsonAddress;
  readonly affiliate: Maybe<TCompany>;
  readonly ageControl: Scalars['Boolean'];
  /** rules applied to order and all order wares */
  readonly allAppliedRules: ReadonlyArray<Scalars['String']>;
  /** rules applied to this order */
  readonly appliedRules: ReadonlyArray<Scalars['String']>;
  readonly billing: ReadonlyArray<TOrderBilling>;
  /** order payment method can be updated to these values */
  readonly canBeUpdatedToPaymentMethods: ReadonlyArray<TPaymentMethod>;
  readonly cancelAlreadyRequested: Scalars['Boolean'];
  readonly canRequestCancel: Scalars['Boolean'];
  readonly cashBox: Maybe<TCashBox>;
  /** how much courier should collect from customer */
  readonly collectFromCustomer: TPriceConverted;
  readonly companyBranch: TCompanyBranch;
  readonly confirmationToken: Maybe<Scalars['String']>;
  /** number of wares */
  readonly countWares: Scalars['Int'];
  /** array of orders covered by virtual one */
  readonly coveringOrders: ReadonlyArray<TOrder>;
  readonly coverPrice: TPriceConverted;
  readonly createdAt: Scalars['DateTime'];
  readonly creditsPendingWalletPayment: Maybe<TCreditsPendingWalletPayment>;
  readonly creditsReward: Maybe<TCreditsReward>;
  readonly currentOnlinePaymentGate: Maybe<TPaymentGateEnum>;
  readonly currentUserCanFinishOrder: Scalars['Boolean'];
  /** customer data - can be deleted after order is finished */
  readonly customer: TJsonCustomer;
  /** customer data - can be deleted after order is finished */
  readonly customerJson: TJsonCustomer;
  /** count of all customers orders */
  readonly customerOrdersCountCurrent: Scalars['Int'];
  /** sequence of current customers order */
  readonly customerOrdersCountTotal: Scalars['Int'];
  readonly defaultEmail: Maybe<TEmail>;
  readonly defaultPhone: Maybe<TPhone>;
  /** delivery time specified by user */
  readonly delayedDeliveryTime: Maybe<Scalars['DateTime']>;
  /** time of when should be order delivered */
  readonly deliverAt: Maybe<Scalars['DateTime']>;
  /** time of when should be order delivered in worst case */
  readonly deliverAtWorst: Maybe<Scalars['DateTime']>;
  /** time of when order was deliver */
  readonly deliveredAt: Maybe<Scalars['DateTime']>;
  readonly deliverySlot: Maybe<TDeliverySlot>;
  readonly deliveryType: Maybe<TDeliveryType>;
  readonly discounts: ReadonlyArray<TPriceWithDescription>;
  readonly doNotCount: Maybe<Scalars['Int']>;
  readonly driverWillPickupAt: Maybe<Scalars['DateTime']>;
  readonly eet: Maybe<TEetType>;
  readonly emails: ReadonlyArray<TEmail>;
  /** associated express delivery */
  readonly expressDelivery: Maybe<TOrderExpressDelivery>;
  /** list of available external drivers for order */
  readonly externalDeliveryProviders: ReadonlyArray<TExternalDeliveryProvider>;
  readonly externalDiscountsSum: TPriceConverted;
  readonly extraCharge: TPriceConverted;
  /** List of extra fees */
  readonly extraFees: ReadonlyArray<TExtraFee>;
  /** Sum of all extra fees */
  readonly extraFeesSum: TPriceConverted;
  /** flat items of orders -- same recipes are grouped together */
  readonly flatItems: ReadonlyArray<TOrderRecipeFlat>;
  readonly foodoraRecord: Maybe<TFoodoraRecordGlType>;
  readonly gps: Maybe<TGeoPoint>;
  /** grouped recipe IDs and their quantity in the order */
  readonly groupedRecipes: ReadonlyArray<TGroupedRecipe>;
  readonly hasRating: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  /** invoice sequence of company branch */
  readonly invoiceSequence: Maybe<Scalars['String']>;
  /** invoice sequence of cash_box */
  readonly invoiceSequenceCashBox: Maybe<Scalars['Int']>;
  /** resettable invoice sequence of company branch, e.g. queue number */
  readonly invoiceSequenceResettable: Maybe<Scalars['Int']>;
  /** was it non registered user who made order */
  readonly isAnonymous: Scalars['Boolean'];
  /** can user cancel current order */
  readonly isCancelable: Scalars['Boolean'];
  readonly isCustomerRegistered: Scalars['Boolean'];
  readonly isExpressDelivery: Scalars['Boolean'];
  /** is current order finalized */
  readonly isFinalized: Scalars['Boolean'];
  readonly isFromLoggedInCustomer: Scalars['Boolean'];
  readonly isPaidWithCard: Scalars['Boolean'];
  /** is current order partially finalized */
  readonly isPartiallyFinalized: Scalars['Boolean'];
  /** is current order marked as high priority */
  readonly isPriority: Scalars['Boolean'];
  /** ordered items (recipes) */
  readonly items: ReadonlyArray<TOrderRecipe>;
  readonly language: TLanguage;
  /** array of all possible transport fees for order */
  readonly levelsOfTransportFees: ReadonlyArray<TTransportFees>;
  /** the number of possible transport fees for order */
  readonly levelsOfTransportFeesCount: Maybe<Scalars['Int']>;
  /** highly depends on location origin - for example, in restaurant can contain number of table */
  readonly location: Maybe<TJsonLocation>;
  /** minimal price of order in case of delivery */
  readonly minimalOrderPrice: Maybe<TPriceConverted>;
  /** Return how much should customer add to order to succeed validation. When succeeds, returns nil. */
  readonly minimalOrderPriceRemainder: Maybe<TPriceConverted>;
  /** Indicates if discounts are included in minimalOrderPrice. When zone is not assignet to order, always return true */
  readonly minimalOrderPriceWithDiscounts: Scalars['Boolean'];
  /** Indicates if transportFee is included in minimalOrderPrice. When zone is not assignet to order, always return true */
  readonly minimalOrderPriceWithTransportFee: Scalars['Boolean'];
  readonly minOrderCharge: TPriceConverted;
  /** the nearest lower value of the transport fee for order */
  readonly nextPossibleTransportFee: Maybe<TTransportFees>;
  /** actual user note */
  readonly note: Maybe<Scalars['String']>;
  /** what method use for user notification */
  readonly notification: TNotification;
  /** operating cost records related to order */
  readonly operatingCostRecords: ReadonlyArray<TOperatingCostRecord>;
  readonly orderConsents: ReadonlyArray<TConsentOrder>;
  readonly orderDeliverySlot: Maybe<TOrderDeliverySlot>;
  /** associated orger group */
  readonly orderGroup: Maybe<TOrderGroup>;
  /** index of order inside associated orger group */
  readonly orderGroupIndex: Maybe<Scalars['Int']>;
  readonly orderOnlineState: Maybe<TOrderOnlineState>;
  readonly orderOrigin: TOrderOrigin;
  /** paid information of order */
  readonly orderPayments: ReadonlyArray<TOrderPaymentMethod>;
  /**
   * OrderStateCategory array where order belongs to
   * @deprecated Use only orderStateCategory query
   */
  readonly orderStateCategories: ReadonlyArray<TOrderStateCategoryEnum>;
  /** last OrderStateCategory where order belongs to */
  readonly orderStateCategory: TOrderStateCategoryEnum;
  /** list of relations to order category state */
  readonly orderStateCategoryRelations: ReadonlyArray<TOrderStateCategoryRelation>;
  readonly orderStateRelations: ReadonlyArray<TOrderStateRelation>;
  readonly orderStates: ReadonlyArray<TOrderState>;
  readonly paidPrice: TPriceConverted;
  readonly phones: ReadonlyArray<TPhone>;
  /** order update time to the nearest millisecond */
  readonly preciseUpdatedAt: Maybe<Scalars['String']>;
  /** Note from previous order */
  readonly previousNote: Maybe<Scalars['String']>;
  /** Provides the sum of all product prices without covers, delivery fees and discounts. */
  readonly productTotalSum: TPriceConverted;
  /** active promo codes of order */
  readonly promoCodes: ReadonlyArray<TPromoCode>;
  readonly purchasedCreditsWallet: Maybe<TCreditsWallet>;
  /** array of order rating notes */
  readonly rating: Maybe<ReadonlyArray<TOrderRating>>;
  readonly returnPrice: TPriceConverted;
  readonly sector: Maybe<TSector>;
  readonly serviceFee: Maybe<TOrderServiceFee>;
  readonly tip: TPriceConverted;
  readonly totalDiscount: TPriceConverted;
  /** summarized price of order */
  readonly totalSum: TPriceConverted;
  readonly totalVouchers: TPriceConverted;
  readonly totalWithoutServiceFee: TPriceConverted;
  /** summarized price of order without tip */
  readonly totalWithoutTips: TPriceConverted;
  /** original order which was transferred to current one */
  readonly transferOrderFrom: Maybe<TOrder>;
  /** last order this order was transferred to */
  readonly transferOrderTo: Maybe<TOrder>;
  readonly transportFee: TPriceConverted;
  readonly updatedAt: Maybe<Scalars['DateTime']>;
  readonly user: Maybe<TUser>;
  /** current user delivering order */
  readonly userDeliveringOrder: Maybe<TUserDeliveringOrder>;
  /** all associations of user delivering order */
  readonly userDeliveringOrders: ReadonlyArray<TUserDeliveringOrder>;
  readonly vouchers: ReadonlyArray<TPriceWithDescription>;
  readonly warePriceType: TWarePriceType;
  readonly zone: Maybe<TZone>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderCollectFromCustomerArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderCoverPriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderEetArgs = {
  storno?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderExternalDiscountsSumArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderExtraChargeArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderExtraFeesArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderExtraFeesSumArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderFlatItemsArgs = {
  groupWithSideDishes?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderLevelsOfTransportFeesArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderMinimalOrderPriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderMinOrderChargeArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderNextPossibleTransportFeeArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderOrderStateCategoriesArgs = {
  target?: InputMaybe<TOrderStateCategoryTargetEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderOrderStateCategoryArgs = {
  target?: InputMaybe<TOrderStateCategoryTargetEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderOrderStateCategoryRelationsArgs = {
  target?: InputMaybe<TOrderStateCategoryTargetEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderPaidPriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderProductTotalSumArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderReturnPriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderTipArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderTotalDiscountArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderTotalSumArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderTotalVouchersArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderTotalWithoutServiceFeeArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderTotalWithoutTipsArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderTransportFeeArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};

export type TFlagAttributesInterface = {
  /** was it non registered user who made order */
  readonly isAnonymous: Scalars['Boolean'];
  /** can user cancel current order */
  readonly isCancelable: Scalars['Boolean'];
  /** is current order finalized */
  readonly isFinalized: Scalars['Boolean'];
  /** is current order partially finalized */
  readonly isPartiallyFinalized: Scalars['Boolean'];
  /** is current order marked as high priority */
  readonly isPriority: Scalars['Boolean'];
};

export type TInvoiceSequencesInterface = {
  /** invoice sequence of company branch */
  readonly invoiceSequence: Maybe<Scalars['String']>;
  /** invoice sequence of cash_box */
  readonly invoiceSequenceCashBox: Maybe<Scalars['Int']>;
  /** resettable invoice sequence of company branch, e.g. queue number */
  readonly invoiceSequenceResettable: Maybe<Scalars['Int']>;
};

export type TOrderStateInterface = {
  /**
   * OrderStateCategory array where order belongs to
   * @deprecated Use only orderStateCategory query
   */
  readonly orderStateCategories: ReadonlyArray<TOrderStateCategoryEnum>;
  /** last OrderStateCategory where order belongs to */
  readonly orderStateCategory: TOrderStateCategoryEnum;
  /** list of relations to order category state */
  readonly orderStateCategoryRelations: ReadonlyArray<TOrderStateCategoryRelation>;
  readonly orderStateRelations: ReadonlyArray<TOrderStateRelation>;
  readonly orderStates: ReadonlyArray<TOrderState>;
};


export type TOrderStateInterfaceOrderStateCategoriesArgs = {
  target?: InputMaybe<TOrderStateCategoryTargetEnum>;
};


export type TOrderStateInterfaceOrderStateCategoryArgs = {
  target?: InputMaybe<TOrderStateCategoryTargetEnum>;
};


export type TOrderStateInterfaceOrderStateCategoryRelationsArgs = {
  target?: InputMaybe<TOrderStateCategoryTargetEnum>;
};

/**
 * Order state category relation type schema
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TOrderStateCategoryRelation = {
  readonly __typename?: 'OrderStateCategoryRelation';
  readonly createdAt: Scalars['DateTime'];
  readonly orderStateCategory: TOrderStateCategoryEnum;
  readonly orderStates: ReadonlyArray<TOrderStateHistorical>;
};

/** All order states taken from events */
export type TOrderStateHistorical = {
  readonly __typename?: 'OrderStateHistorical';
  readonly createdAt: Scalars['DateTime'];
  readonly orderState: TOrderStateEnum;
  readonly user: TUser;
};

/** OrderState enum */
export type TOrderStateEnum =
  | 'ACCEPTED'
  | 'ASSIGNED_TO_DELIVER'
  | 'BILL_PASSED'
  | 'BILL_PRINTED'
  | 'BRANCH_CANCEL'
  | 'BY_CREDIT_CARD'
  | 'CANCEL_ON_WAY'
  | 'CANCELED'
  | 'CAUSE'
  | 'CUSTOMER_CANCEL'
  | 'CUSTOMER_DID_NOT_COME'
  | 'CUSTOMER_NOTIFIED'
  | 'DELIVER_REJECTED'
  | 'DELIVERED'
  | 'EVALUATED'
  | 'FINISHED'
  | 'HANDOVER'
  | 'HIGH_PRIORITY'
  | 'IN_CART'
  | 'IN_PRODUCE'
  | 'IN_PROGRESS'
  | 'KITCHEN_TICKET_PRINTED'
  | 'LATE'
  | 'MADE'
  | 'NEW'
  | 'NOT_EVALUATED'
  | 'ON_WAY'
  | 'ONLINE'
  | 'PAID'
  | 'READY_TO_DELIVER'
  | 'READY_TO_PRODUCE'
  | 'RECEIVED'
  | 'RECLAMATION'
  | 'RECLAMATION_HANDLED'
  | 'REFUND'
  | 'SHOULD_BE_PAID'
  | 'SHOWN'
  | 'STUCK_ON_ROAD'
  | 'TRANSFER_CANCEL'
  | 'UNPAID'
  | 'WAITING_FOR_CUSTOMER'
  | 'WIFI_DELAYED';

/**
 * Order state relation type schema
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order_state_relation, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order_state_relation, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, cashier, cashier_cancel, customer, driver, editor_order_state_relation, guest, operator, owner_cancel, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order_state_relation, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, cashier, customer, editor_order_state_relation, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 */
export type TOrderStateRelation = {
  readonly __typename?: 'OrderStateRelation';
  readonly createdAt: Scalars['DateTime'];
  readonly id: Scalars['ID'];
  readonly order: TOrder;
  readonly orderState: TOrderState;
};

/**
 * Order state type schema
 *
 *
 * INDEX: [admin, editor_orders, guest, super_admin, support, user]
 *
 * READ: [admin, editor_orders, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TOrderState = {
  readonly __typename?: 'OrderState';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TOrderStateEnum;
  readonly id: Scalars['ID'];
  readonly orderStateCategory: TOrderStateCategory;
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/**
 * Order state category type schema
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TOrderStateCategory = {
  readonly __typename?: 'OrderStateCategory';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TOrderStateCategoryEnum;
  readonly id: Scalars['ID'];
  readonly orderStates: ReadonlyArray<TOrderStateEnum>;
  /** not localized code */
  readonly rawCode: Scalars['String'];
};


/**
 * Order state category type schema
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TOrderStateCategoryOrderStatesArgs = {
  target?: InputMaybe<TOrderStateCategoryTargetEnum>;
};

export type TPriceInterface = {
  /** rules applied to order and all order wares */
  readonly allAppliedRules: ReadonlyArray<Scalars['String']>;
  /** rules applied to this order */
  readonly appliedRules: ReadonlyArray<Scalars['String']>;
  readonly billing: ReadonlyArray<TOrderBilling>;
  /** order payment method can be updated to these values */
  readonly canBeUpdatedToPaymentMethods: ReadonlyArray<TPaymentMethod>;
  readonly cashBox: Maybe<TCashBox>;
  /** how much courier should collect from customer */
  readonly collectFromCustomer: TPriceConverted;
  readonly coverPrice: TPriceConverted;
  readonly creditsPendingWalletPayment: Maybe<TCreditsPendingWalletPayment>;
  readonly currentOnlinePaymentGate: Maybe<TPaymentGateEnum>;
  readonly discounts: ReadonlyArray<TPriceWithDescription>;
  readonly eet: Maybe<TEetType>;
  readonly externalDiscountsSum: TPriceConverted;
  readonly extraCharge: TPriceConverted;
  /** List of extra fees */
  readonly extraFees: ReadonlyArray<TExtraFee>;
  /** Sum of all extra fees */
  readonly extraFeesSum: TPriceConverted;
  readonly isPaidWithCard: Scalars['Boolean'];
  /** minimal price of order in case of delivery */
  readonly minimalOrderPrice: Maybe<TPriceConverted>;
  /** Return how much should customer add to order to succeed validation. When succeeds, returns nil. */
  readonly minimalOrderPriceRemainder: Maybe<TPriceConverted>;
  /** Indicates if discounts are included in minimalOrderPrice. When zone is not assignet to order, always return true */
  readonly minimalOrderPriceWithDiscounts: Scalars['Boolean'];
  /** Indicates if transportFee is included in minimalOrderPrice. When zone is not assignet to order, always return true */
  readonly minimalOrderPriceWithTransportFee: Scalars['Boolean'];
  readonly minOrderCharge: TPriceConverted;
  /** operating cost records related to order */
  readonly operatingCostRecords: ReadonlyArray<TOperatingCostRecord>;
  /** paid information of order */
  readonly orderPayments: ReadonlyArray<TOrderPaymentMethod>;
  readonly paidPrice: TPriceConverted;
  /** Provides the sum of all product prices without covers, delivery fees and discounts. */
  readonly productTotalSum: TPriceConverted;
  /** active promo codes of order */
  readonly promoCodes: ReadonlyArray<TPromoCode>;
  readonly returnPrice: TPriceConverted;
  readonly tip: TPriceConverted;
  readonly totalDiscount: TPriceConverted;
  /** summarized price of order */
  readonly totalSum: TPriceConverted;
  readonly totalVouchers: TPriceConverted;
  readonly totalWithoutServiceFee: TPriceConverted;
  /** summarized price of order without tip */
  readonly totalWithoutTips: TPriceConverted;
  readonly vouchers: ReadonlyArray<TPriceWithDescription>;
};


export type TPriceInterfaceCollectFromCustomerArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


export type TPriceInterfaceCoverPriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


export type TPriceInterfaceEetArgs = {
  storno?: InputMaybe<Scalars['Boolean']>;
};


export type TPriceInterfaceExternalDiscountsSumArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


export type TPriceInterfaceExtraChargeArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


export type TPriceInterfaceExtraFeesArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


export type TPriceInterfaceExtraFeesSumArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


export type TPriceInterfaceMinimalOrderPriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


export type TPriceInterfaceMinOrderChargeArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


export type TPriceInterfacePaidPriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


export type TPriceInterfaceProductTotalSumArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


export type TPriceInterfaceReturnPriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


export type TPriceInterfaceTipArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


export type TPriceInterfaceTotalDiscountArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


export type TPriceInterfaceTotalSumArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


export type TPriceInterfaceTotalVouchersArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


export type TPriceInterfaceTotalWithoutServiceFeeArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


export type TPriceInterfaceTotalWithoutTipsArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};

/**
 * Complete billing information about order
 *
 *
 * INDEX: [accountant, admin, branch_owner, brand_owner, editor_billings, editor_order_billing, merchant, sales_representative, super_admin, supervisor]
 *
 * READ: [accountant, admin, branch_owner, brand_owner, editor_billings, editor_order_billing, merchant, sales_representative, super_admin, supervisor]
 *
 * CREATE: [admin, editor_order_billing, super_admin]
 *
 * UPDATE: [admin, editor_order_billing, super_admin]
 *
 * DESTROY: [admin, editor_order_billing, super_admin]
 *
 */
export type TOrderBilling = {
  readonly __typename?: 'OrderBilling';
  readonly id: Scalars['ID'];
  readonly order: TOrder;
  /** Type of billing */
  readonly orderBillingType: TOrderBillingType;
  /** price converted to prefered currency */
  readonly price: Maybe<TPriceConverted>;
  readonly processed: Maybe<Scalars['Boolean']>;
};


/**
 * Complete billing information about order
 *
 *
 * INDEX: [accountant, admin, branch_owner, brand_owner, editor_billings, editor_order_billing, merchant, sales_representative, super_admin, supervisor]
 *
 * READ: [accountant, admin, branch_owner, brand_owner, editor_billings, editor_order_billing, merchant, sales_representative, super_admin, supervisor]
 *
 * CREATE: [admin, editor_order_billing, super_admin]
 *
 * UPDATE: [admin, editor_order_billing, super_admin]
 *
 * DESTROY: [admin, editor_order_billing, super_admin]
 *
 */
export type TOrderBillingPriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};

/**
 * Possible OrderBillingType types
 *
 *
 * INDEX: [accountant, admin, editor_billings, super_admin, support, user]
 *
 * READ: [accountant, admin, editor_billings, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TOrderBillingType = {
  readonly __typename?: 'OrderBillingType';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TOrderBillingTypeEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** OrderBillingType enum */
export type TOrderBillingTypeEnum =
  | 'AFFILIATE'
  | 'COMMISSION'
  | 'FEE'
  | 'PRICE_SUM'
  | 'REWARD_RESULT';

/**
 * Schema of cash boxes of Company Branch
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, editor_cash_box, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, editor_cash_box, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_cash_box, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, editor_cash_box, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_cash_box, super_admin]
 *
 */
export type TCashBox = TInvoiceSequenceInterface & {
  readonly __typename?: 'CashBox';
  readonly automaticOrderFinish: Scalars['Boolean'];
  readonly companyBranch: TCompanyBranch;
  readonly configuration: Maybe<Scalars['Json']>;
  readonly deleted: Scalars['Boolean'];
  readonly eetId: Scalars['String'];
  readonly enabled: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly kiosk: Scalars['Boolean'];
  readonly lastInvoiceSequence: Scalars['Int'];
  readonly lastResettableInvoiceSequence: Scalars['Int'];
  readonly name: Scalars['String'];
  readonly resettableInvoicePrefix: Maybe<Scalars['Int']>;
  readonly type: TCashBoxTypeEnum;
  readonly user: Maybe<TUser>;
  readonly uuid: Scalars['String'];
  readonly virtual: Scalars['Boolean'];
};

export type TInvoiceSequenceInterface = {
  readonly lastInvoiceSequence: Scalars['Int'];
  readonly lastResettableInvoiceSequence: Scalars['Int'];
};

/** CashBoxType enum */
export type TCashBoxTypeEnum =
  | 'KIOSK'
  | 'POS'
  | 'POS2'
  | 'VIRTUAL';

/** Pending wallet credit payments */
export type TCreditsPendingWalletPayment = {
  readonly __typename?: 'CreditsPendingWalletPayment';
  readonly amount: TPriceConverted;
  readonly resolvedAt: Scalars['DateTime'];
  readonly unpaid: TPriceConverted;
};

export type TPriceWithDescription = {
  readonly __typename?: 'PriceWithDescription';
  readonly code: Scalars['ID'];
  readonly description: Scalars['String'];
  readonly price: TPriceConverted;
  readonly promoCodes: ReadonlyArray<Scalars['String']>;
};


export type TPriceWithDescriptionPriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};

/**
 * EET receipt
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TEetType = {
  readonly __typename?: 'EETType';
  readonly bkp: Scalars['String'];
  readonly fik: Maybe<Scalars['String']>;
  readonly mode: Scalars['String'];
  readonly pkp: Scalars['String'];
  readonly placeId: Scalars['String'];
  readonly receiptId: Scalars['String'];
  readonly warnings: ReadonlyArray<Scalars['String']>;
};

/** ExtraFee graphql model */
export type TExtraFee = {
  readonly __typename?: 'ExtraFee';
  readonly code: TExtraFeeType;
  readonly name: Scalars['String'];
  readonly price: TPriceConverted;
};

/** Possible extra fees */
export type TExtraFeeType =
  | 'BOLT_FEE'
  | 'DAME_JIDLO_FEE';

/**
 * OperatingCostRecord graphql model
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [super_admin]
 *
 */
export type TOperatingCostRecord = {
  readonly __typename?: 'OperatingCostRecord';
  readonly absoluteValue: TPriceConverted;
  readonly canceled: Scalars['Boolean'];
  readonly createdAt: Scalars['DateTime'];
  readonly id: Scalars['ID'];
  readonly operatingCostSetting: TOperatingCostSetting;
  readonly percentageValue: TPriceConverted;
  readonly recordValue: TPriceConverted;
};

/**
 * OperatingCostSetting graphql model
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [super_admin]
 *
 */
export type TOperatingCostSetting = {
  readonly __typename?: 'OperatingCostSetting';
  readonly absoluteValue: Scalars['Float'];
  readonly cancelable: Scalars['Boolean'];
  readonly closed: Scalars['Boolean'];
  readonly companyBranch: TCompanyBranch;
  readonly id: Scalars['ID'];
  readonly month: Scalars['Date'];
  readonly operatingCostFrequencyType: TOperatingCostFrequencyType;
  readonly percentageValue: Scalars['Float'];
};

/**
 * OperatingCostType and OperatingCostFrequency grouping model
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TOperatingCostFrequencyType = {
  readonly __typename?: 'OperatingCostFrequencyType';
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly operatingCostFrequency: TOperatingCostFrequency;
  readonly operatingCostType: TOperatingCostType;
};

/**
 * Possible OperatingCostFrequency types
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TOperatingCostFrequency = {
  readonly __typename?: 'OperatingCostFrequency';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TOperatingCostFrequencyEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** OperatingCostFrequency enum */
export type TOperatingCostFrequencyEnum =
  | 'AUTOMATIC'
  | 'MONTH'
  | 'ON_DEMAND';

/**
 * Possible OperatingCostType types
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier_statistics, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier_statistics, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TOperatingCostType = {
  readonly __typename?: 'OperatingCostType';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TOperatingCostTypeEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** OperatingCostType enum */
export type TOperatingCostTypeEnum =
  | 'ADYEN'
  | 'AXIMA'
  | 'BASIC'
  | 'CASH'
  | 'COMMISSION'
  | 'CREDIT'
  | 'CSOB'
  | 'FOODORA_GO'
  | 'GOPAY'
  | 'GP_WEBPAY'
  | 'INHOUSE'
  | 'MESSENGER'
  | 'MINIMUM_PAYMENT'
  | 'NETHOST'
  | 'PAY_FAST'
  | 'PAYU'
  | 'PICKUP'
  | 'SERVICE_FEE_LIMIT'
  | 'SPEEDLO_SERVICE'
  | 'TMOBILE'
  | 'WALLET_CREDIT'
  | 'WOLT_DRIVE';

/**
 * Holds information about one payment of order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order_payment_method, guest, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, editor_order_payment_method, guest, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, cashier, editor_order_payment_method, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, editor_order_payment_method, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, cashier, editor_order_payment_method, sales_representative, super_admin, supervisor]
 *
 */
export type TOrderPaymentMethod = {
  readonly __typename?: 'OrderPaymentMethod';
  readonly id: Scalars['ID'];
  readonly order: TOrder;
  readonly paymentMethod: TPaymentMethod;
  readonly price: TPriceConverted;
};


/**
 * Holds information about one payment of order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order_payment_method, guest, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, editor_order_payment_method, guest, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, cashier, editor_order_payment_method, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, editor_order_payment_method, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, cashier, editor_order_payment_method, sales_representative, super_admin, supervisor]
 *
 */
export type TOrderPaymentMethodPriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};

/**
 * Information about promo code
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, editor_orders, editor_promo_code, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, editor_orders, editor_promo_code, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_promo_code, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_promo_code, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_promo_code, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TPromoCode = {
  readonly __typename?: 'PromoCode';
  readonly code: Scalars['String'];
  readonly company: Maybe<TCompany>;
  readonly companyBranch: Maybe<TCompanyBranch>;
  readonly enabled: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly maxUsage: Maybe<Scalars['Int']>;
  readonly maxUsagePerUser: Maybe<Scalars['Int']>;
  readonly public: Scalars['Boolean'];
  readonly type: TPromoCodeType;
  readonly validTill: Maybe<Scalars['DateTime']>;
};

/**
 * Possible PromoCodeType types
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TPromoCodeType = {
  readonly __typename?: 'PromoCodeType';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TPromoCodeTypeEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** PromoCodeType enum */
export type TPromoCodeTypeEnum =
  | 'PROMO_CODE'
  | 'VOUCHER';

export type TRestrictedAttributes = {
  /** can be address from google - no consistent data */
  readonly address: TJsonAddress;
  /** customer data - can be deleted after order is finished */
  readonly customer: TJsonCustomer;
  /** customer data - can be deleted after order is finished */
  readonly customerJson: TJsonCustomer;
  readonly defaultEmail: Maybe<TEmail>;
  readonly defaultPhone: Maybe<TPhone>;
  readonly emails: ReadonlyArray<TEmail>;
  readonly gps: Maybe<TGeoPoint>;
  /** highly depends on location origin - for example, in restaurant can contain number of table */
  readonly location: Maybe<TJsonLocation>;
  readonly phones: ReadonlyArray<TPhone>;
};

/** Possible information for anonymous user that made order */
export type TJsonCustomer = {
  readonly __typename?: 'JsonCustomer';
  readonly defaultEmail: Maybe<TEmail>;
  readonly defaultPhone: Maybe<TPhone>;
  /** possible emails contacts */
  readonly emails: ReadonlyArray<TEmail>;
  readonly firstName: Maybe<Scalars['String']>;
  readonly isCancelRisk: Maybe<Scalars['Boolean']>;
  readonly lastName: Maybe<Scalars['String']>;
  /** possible phone contacts */
  readonly phones: ReadonlyArray<TPhone>;
  readonly vamAgreements: ReadonlyArray<TVamAgreement>;
};

/** Information about specific agreement. */
export type TVamAgreement = {
  readonly __typename?: 'VAMAgreement';
  /** Consent description */
  readonly description: Scalars['String'];
  /** Consent ID */
  readonly id: Scalars['ID'];
  /** Consent is confirmed by customer */
  readonly isConfirmed: Scalars['Boolean'];
  /** Consent is required to finish order */
  readonly isMandatory: Scalars['Boolean'];
  /** Consent name */
  readonly name: Scalars['String'];
};

/** Location of order, for example number of table. */
export type TJsonLocation = {
  readonly __typename?: 'JsonLocation';
  readonly tableNumber: Maybe<Scalars['Int']>;
};

export type TTransportFeeInterface = {
  /** array of all possible transport fees for order */
  readonly levelsOfTransportFees: ReadonlyArray<TTransportFees>;
  /** the number of possible transport fees for order */
  readonly levelsOfTransportFeesCount: Maybe<Scalars['Int']>;
  /** the nearest lower value of the transport fee for order */
  readonly nextPossibleTransportFee: Maybe<TTransportFees>;
  readonly transportFee: TPriceConverted;
};


export type TTransportFeeInterfaceLevelsOfTransportFeesArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


export type TTransportFeeInterfaceNextPossibleTransportFeeArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


export type TTransportFeeInterfaceTransportFeeArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};

/** Transport fee according to zone rules */
export type TTransportFees = {
  readonly __typename?: 'TransportFees';
  /** minimum price for a new transport fee */
  readonly fromPrice: Maybe<TPriceConverted>;
  readonly newTransportFee: Maybe<TPriceConverted>;
  /**  the difference between order price and minimum price for a new transport fee */
  readonly priceNeedToOrder: Maybe<TPriceConverted>;
};

export type TCreditsReward = TCreditsCurrencyInterface & {
  readonly __typename?: 'CreditsReward';
  readonly amount: TCreditsPriceConverted;
  /** Alias of `self.group.country.cashPaymentDecimals`. */
  readonly cashPaymentDecimals: Scalars['Int'];
  /** Alias of `self.group.country.cashPaymentUnit`. */
  readonly cashPaymentUnit: Scalars['Float'];
  readonly createdAt: Maybe<Scalars['DateTime']>;
  readonly currency: TCurrency;
  readonly group: TCreditsGroup;
  readonly id: Maybe<Scalars['ID']>;
  readonly order: TOrder;
  readonly state: TCreditsRewardState;
};

/** Possible CreditsRewardState types */
export type TCreditsRewardState = {
  readonly __typename?: 'CreditsRewardState';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TCreditsRewardStateEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** CreditsRewardState enum */
export type TCreditsRewardStateEnum =
  | 'CANCELED'
  | 'COLLECTED'
  | 'PENDING'
  | 'PENDING_COLLECTION'
  | 'PENDING_ORDER_FINISH'
  | 'POTENTIAL';

/**
 * Schema of a DeliverySlot
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TDeliverySlot = {
  readonly __typename?: 'DeliverySlot';
  readonly capacity: Scalars['Int'];
  readonly capacityTaken: Scalars['Int'];
  readonly companyBranch: TCompanyBranch;
  readonly deliveryType: TDeliveryType;
  readonly endAt: Scalars['DateTime'];
  readonly id: Scalars['ID'];
  readonly isFull: Scalars['Boolean'];
  readonly startAt: Scalars['DateTime'];
  readonly userEdited: Scalars['Boolean'];
};

/**
 * Possible DeliveryType types
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TDeliveryType = {
  readonly __typename?: 'DeliveryType';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TDeliveryTypeEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** DeliveryType enum */
export type TDeliveryTypeEnum =
  | 'MESSENGER'
  | 'PICKUP';

/** Express delivery details for an order */
export type TOrderExpressDelivery = {
  readonly __typename?: 'OrderExpressDelivery';
  readonly expressFee: TPriceConverted;
  readonly totalGuaranteeMinutes: Scalars['Int'];
};

/**
 * Possible ExternalDeliveryProvider types
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TExternalDeliveryProvider = {
  readonly __typename?: 'ExternalDeliveryProvider';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TExternalDeliveryProviderEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** ExternalDeliveryProvider enum */
export type TExternalDeliveryProviderEnum =
  | 'FOODORA_GO'
  | 'WOLT';

/** Grouped recipes of one order. Recipes are grouped when they property are same. */
export type TOrderRecipeFlat = {
  readonly __typename?: 'OrderRecipeFlat';
  readonly automatic: Scalars['Boolean'];
  readonly hasDynamicPrice: Scalars['Boolean'];
  /** IDs of OrderRecipes that this object groups. */
  readonly ids: ReadonlyArray<Scalars['ID']>;
  readonly note: Maybe<Scalars['String']>;
  readonly order: TOrder;
  readonly price: TPriceConverted;
  readonly priceWithSideDishes: TPriceConverted;
  readonly quantity: Scalars['Int'];
  readonly recipe: TRecipe;
  /** tree structure of wares of order */
  readonly sideDishes: ReadonlyArray<TOrderRecipeFlat>;
  /** ware category of order recipe for side dishes */
  readonly wareCategory: Maybe<TWareCategory>;
};


/** Grouped recipes of one order. Recipes are grouped when they property are same. */
export type TOrderRecipeFlatPriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/** Grouped recipes of one order. Recipes are grouped when they property are same. */
export type TOrderRecipeFlatPriceWithSideDishesArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/** Grouped recipes of one order. Recipes are grouped when they property are same. */
export type TOrderRecipeFlatSideDishesArgs = {
  grouped?: InputMaybe<Scalars['Boolean']>;
};

/** FoodoraRecordGlType */
export type TFoodoraRecordGlType = {
  readonly __typename?: 'FoodoraRecordGlType';
  readonly isDeliveredByFoodora: Scalars['Boolean'];
  readonly maxFoodoraPickupTime: Maybe<Scalars['DateTime']>;
  readonly minFoodoraPickupTime: Maybe<Scalars['DateTime']>;
};

/** GroupedRecipe */
export type TGroupedRecipe = {
  readonly __typename?: 'GroupedRecipe';
  readonly id: Scalars['ID'];
  readonly quantity: Scalars['Int'];
};

/**
 * One item of Order (ordered recipe)
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order_recipe, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order_recipe, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order_recipe, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, cashier, customer, driver, editor_order_recipe, guest, operator, super_admin, support]
 *
 * DESTROY: [admin, cashier, customer, editor_order_recipe, guest, operator, super_admin]
 *
 */
export type TOrderRecipe = {
  readonly __typename?: 'OrderRecipe';
  /** rules applied to this order */
  readonly appliedRules: ReadonlyArray<Scalars['String']>;
  /** was item added to order automatically */
  readonly automatic: Scalars['Boolean'];
  /** covers of item */
  readonly covers: ReadonlyArray<TOrderRecipe>;
  readonly hasDynamicPrice: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  /** actual user note */
  readonly note: Maybe<Scalars['String']>;
  readonly order: TOrder;
  readonly orderRecipeState: TOrderRecipeState;
  readonly parent: Maybe<TOrderRecipe>;
  readonly price: TPriceConverted;
  readonly priceWithSideDishes: TPriceConverted;
  readonly promoTag: Maybe<TPromoTag>;
  readonly recipe: TRecipe;
  /** side dishes of item */
  readonly sideDishes: ReadonlyArray<TOrderRecipe>;
  readonly wareCategory: Maybe<TWareCategory>;
};


/**
 * One item of Order (ordered recipe)
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order_recipe, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order_recipe, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order_recipe, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, cashier, customer, driver, editor_order_recipe, guest, operator, super_admin, support]
 *
 * DESTROY: [admin, cashier, customer, editor_order_recipe, guest, operator, super_admin]
 *
 */
export type TOrderRecipePriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * One item of Order (ordered recipe)
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order_recipe, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order_recipe, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order_recipe, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, cashier, customer, driver, editor_order_recipe, guest, operator, super_admin, support]
 *
 * DESTROY: [admin, cashier, customer, editor_order_recipe, guest, operator, super_admin]
 *
 */
export type TOrderRecipePriceWithSideDishesArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};

/**
 * Possible OrderRecipeState types
 *
 *
 * INDEX: [admin, editor_orders, super_admin, support, user]
 *
 * READ: [admin, editor_orders, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TOrderRecipeState = {
  readonly __typename?: 'OrderRecipeState';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TOrderRecipeStateEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** OrderRecipeState enum */
export type TOrderRecipeStateEnum =
  | 'CANCELED'
  | 'COOKED'
  | 'DISPATCHED'
  | 'FINISHED'
  | 'FRESH'
  | 'PREPARING'
  | 'READY';

/** Possible types of notification */
export type TNotification = {
  readonly __typename?: 'Notification';
  readonly chrome: Maybe<Scalars['Boolean']>;
  readonly firebase: Maybe<Scalars['Boolean']>;
  readonly sms: Maybe<Scalars['Boolean']>;
};

/** Information about active consent assigned with order record. */
export type TConsentOrder = {
  readonly __typename?: 'ConsentOrder';
  readonly consent: TConsent;
  readonly id: Scalars['ID'];
  readonly order: TOrder;
};

/**
 * Schema of an OrderDeliverySlot
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TOrderDeliverySlot = {
  readonly __typename?: 'OrderDeliverySlot';
  readonly applied: Scalars['Boolean'];
  readonly deliverySlotSize: Scalars['Int'];
  readonly firstDeliverySlot: TDeliverySlotElement;
  readonly id: Scalars['ID'];
  readonly order: TOrder;
};

/**
 * Schema of a DeliverySlotElement
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TDeliverySlotElement = {
  readonly __typename?: 'DeliverySlotElement';
  readonly capacityTaken: Scalars['Int'];
  readonly companyBranch: TCompanyBranch;
  readonly deliverySlot: Maybe<TDeliverySlot>;
  readonly deliveryType: TDeliveryType;
  readonly id: Scalars['ID'];
  readonly startAt: Scalars['DateTime'];
};

/**
 * Entity grouping multiple orders together.
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TOrderGroup = {
  readonly __typename?: 'OrderGroup';
  readonly color: Maybe<TOrderGroupColor>;
  readonly id: Scalars['ID'];
  readonly name: Maybe<Scalars['String']>;
  readonly orders: ReadonlyArray<TOrder>;
  readonly user: TUser;
};

/**
 * Order group color with code and color definition
 *
 *
 * INDEX: [admin, super_admin, support, user]
 *
 * READ: [admin, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TOrderGroupColor = TColorInterface & {
  readonly __typename?: 'OrderGroupColor';
  readonly code: Scalars['String'];
  readonly color: Scalars['String'];
  readonly id: Scalars['ID'];
};

/**
 * Possible OrderOnlineState types
 *
 *
 * INDEX: [admin, super_admin, support, user]
 *
 * READ: [admin, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TOrderOnlineState = {
  readonly __typename?: 'OrderOnlineState';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TOrderOnlineStateEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** OrderOnlineState enum */
export type TOrderOnlineStateEnum =
  | 'CANCELED'
  | 'COMPLETED'
  | 'CREATED'
  | 'PAID'
  | 'PENDING'
  | 'REFUNDED';

/**
 * Possible OrderOrigin types
 *
 *
 * INDEX: [admin, editor_orders, guest, super_admin, support, user]
 *
 * READ: [admin, editor_orders, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TOrderOrigin = {
  readonly __typename?: 'OrderOrigin';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TOrderOriginEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

export type TCreditsWallet = TCreditsCashlessLimitsInterface & TCreditsCurrencyInterface & TCreditsOverviewInterface & {
  readonly __typename?: 'CreditsWallet';
  readonly balance: TCreditsPriceConverted;
  readonly canTopUpMax: TPriceConverted;
  /** Alias of `self.group.country.cashPaymentDecimals`. */
  readonly cashPaymentDecimals: Scalars['Int'];
  /** Alias of `self.group.country.cashPaymentUnit`. */
  readonly cashPaymentUnit: Scalars['Float'];
  readonly closedAt: Maybe<Scalars['DateTime']>;
  readonly companyBranches: ReadonlyArray<TCompanyBranch>;
  readonly creditsExpiringSoon: TCreditsWalletActivityConnection;
  readonly creditsExpiringSoonSum: TCreditsPriceConverted;
  readonly creditsPendingRewards: TCreditsRewardConnection;
  readonly creditsRewards: TCreditsRewardConnection;
  readonly creditsWalletActivities: TCreditsWalletActivityConnection;
  readonly currency: TCurrency;
  readonly currentBalanceLimit: TPriceConverted;
  readonly currentBalanceLimitLeft: TPriceConverted;
  readonly currentBalanceLimitUsage: TPriceConverted;
  readonly group: TCreditsGroup;
  readonly id: Scalars['ID'];
  readonly isClosed: Scalars['Boolean'];
  readonly isRefundRequestAllowed: Scalars['Boolean'];
  readonly isTopUpAllowed: Scalars['Boolean'];
  readonly name: Scalars['String'];
  readonly nfcId: Maybe<Scalars['String']>;
  readonly refundRequest: Maybe<TCreditsRefundRequest>;
  readonly topUpLimit: TPriceConverted;
  readonly topUpLimitLeft: TPriceConverted;
  readonly topUpLimitUsage: TPriceConverted;
};


export type TCreditsWalletCreditsExpiringSoonArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyBranchIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TCreditsWalletCreditsExpiringSoonSumArgs = {
  companyBranchIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};


export type TCreditsWalletCreditsPendingRewardsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyBranchIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TCreditsWalletCreditsRewardsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyBranchIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  states?: InputMaybe<ReadonlyArray<TCreditsRewardStateEnum>>;
};


export type TCreditsWalletCreditsWalletActivitiesArgs = {
  activityTypes?: InputMaybe<ReadonlyArray<TCreditsWalletActivityTypeEnum>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyBranchIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  first?: InputMaybe<Scalars['Int']>;
  isExpired?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type TCreditsCashlessLimitsInterface = {
  readonly canTopUpMax: TPriceConverted;
  readonly currentBalanceLimit: TPriceConverted;
  readonly currentBalanceLimitLeft: TPriceConverted;
  readonly currentBalanceLimitUsage: TPriceConverted;
  readonly topUpLimit: TPriceConverted;
  readonly topUpLimitLeft: TPriceConverted;
  readonly topUpLimitUsage: TPriceConverted;
};

/** The connection type for CreditsReward. */
export type TCreditsRewardConnection = {
  readonly __typename?: 'CreditsRewardConnection';
  /** A list of edges. */
  readonly edges: Maybe<ReadonlyArray<Maybe<TCreditsRewardEdge>>>;
  /** A list of nodes. */
  readonly nodes: Maybe<ReadonlyArray<Maybe<TCreditsReward>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: TPageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type TCreditsRewardEdge = {
  readonly __typename?: 'CreditsRewardEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: Maybe<TCreditsReward>;
};

export type TCreditsRefundRequest = {
  readonly __typename?: 'CreditsRefundRequest';
  readonly accountNumber: Scalars['String'];
  readonly amount: TPriceConverted;
  readonly bicSwift: Maybe<Scalars['String']>;
  readonly email: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly requestedAt: Scalars['DateTime'];
};

/** Order rating */
export type TOrderRating = {
  readonly __typename?: 'OrderRating';
  readonly id: Scalars['ID'];
  readonly orderRatingType: TOrderRatingType;
  readonly text: Maybe<Scalars['String']>;
  readonly value: Maybe<Scalars['Int']>;
};

/** Possible OrderRating types */
export type TOrderRatingType = {
  readonly __typename?: 'OrderRatingType';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TOrderRatingTypeEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** Possible order rating types */
export type TOrderRatingTypeEnum =
  | 'RATING'
  | 'RATING_DELIVERY'
  | 'RATING_FOOD'
  | 'RATING_ORDER';

/**
 * Sector information
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, guest, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, guest, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TSector = TAvailabilityInterface & {
  readonly __typename?: 'Sector';
  /** when record is available */
  readonly availabilities: ReadonlyArray<TAvailability>;
  readonly code: Scalars['String'];
  readonly companyBranch: TCompanyBranch;
  /** delivery type for sector */
  readonly deliveryType: Maybe<TDeliveryType>;
  readonly eetEnabled: Maybe<Scalars['Boolean']>;
  readonly enabled: Scalars['Boolean'];
  readonly gps: Maybe<TGeoPoint>;
  readonly id: Scalars['ID'];
  readonly inheritedAvailabilities: ReadonlyArray<TAvailability>;
  /** delivery type for sector when inheritance is used */
  readonly inheritedDeliveryType: Maybe<TDeliveryType>;
  readonly inheritedEetEnabled: Scalars['Boolean'];
  readonly inheritedEnabled: Scalars['Boolean'];
  readonly inheritedOccasionsEnabled: Scalars['Boolean'];
  readonly inheritedOrderDelaySeconds: Scalars['Int'];
  /** ware price type for sector when inheritance is used */
  readonly inheritedWarePriceType: TWarePriceType;
  /** is available at specific time? */
  readonly isAvailable: Scalars['Boolean'];
  readonly name: Scalars['String'];
  /** all available occasions */
  readonly occasions: ReadonlyArray<TOccasion>;
  readonly occasionsEnabled: Maybe<Scalars['Boolean']>;
  readonly orderDelaySeconds: Maybe<Scalars['Int']>;
  /** sectors parent */
  readonly parent: Maybe<TSector>;
  /** occasions with active preorder */
  readonly preordableOccasions: ReadonlyArray<TOccasion>;
  readonly sectorType: TSectorType;
  readonly wareCategoryAvailabilities: ReadonlyArray<TSectorWareCategory>;
  /** ware price type for sector */
  readonly warePriceType: Maybe<TWarePriceType>;
};


/**
 * Sector information
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, guest, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, guest, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TSectorIsAvailableArgs = {
  dateTime?: InputMaybe<Scalars['DateTime']>;
  orderOriginCategory?: InputMaybe<TOrderOriginCategoryEnum>;
};

/**
 * Occasion event information
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TOccasion = {
  readonly __typename?: 'Occasion';
  readonly companyBranch: TCompanyBranch;
  /** @deprecated Divided into dateFrom and dateTo fields */
  readonly date: Scalars['DateTime'];
  readonly dateFrom: Scalars['DateTime'];
  readonly dateTo: Scalars['DateTime'];
  readonly id: Scalars['ID'];
  readonly image: Maybe<Scalars['String']>;
  readonly preorderFrom: Scalars['DateTime'];
  readonly preorderTo: Scalars['DateTime'];
  readonly title: Scalars['String'];
  readonly titleShort: Scalars['String'];
};


/**
 * Occasion event information
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TOccasionImageArgs = {
  height?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};

/**
 * Possible SectorType types
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TSectorType = {
  readonly __typename?: 'SectorType';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TSectorTypeEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** SectorType enum */
export type TSectorTypeEnum =
  | 'AREA'
  | 'TABLE';

/** Ware Category information about Sector */
export type TSectorWareCategory = {
  readonly __typename?: 'SectorWareCategory';
  readonly access: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly inherited: Scalars['Boolean'];
  readonly wareCategory: TWareCategory;
};

/** Service fee applied to an order */
export type TOrderServiceFee = {
  readonly __typename?: 'OrderServiceFee';
  readonly amount: TPriceConverted;
  readonly id: Scalars['ID'];
  readonly order: TOrder;
  readonly orderPaymentMethod: Maybe<TOrderPaymentMethod>;
  readonly paymentGate: Maybe<TPaymentGate>;
};

/**
 * Information about user and order that is being delivered
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, cashier_delivery, driver, editor_user_delivering_order, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, cashier_delivery, driver, editor_user_delivering_order, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, cashier_delivery, driver, editor_user_delivering_order, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier_delivery, driver, editor_user_delivering_order, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, cashier_delivery, driver, editor_user_delivering_order, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TUserDeliveringOrder = {
  readonly __typename?: 'UserDeliveringOrder';
  readonly assignmentType: Maybe<TUserDeliveringOrdersAssignmentTypeEnum>;
  /** time of when order was assigned to user */
  readonly createdAt: Scalars['DateTime'];
  readonly current: Scalars['Boolean'];
  /** time of when order was deliver */
  readonly deliveredAt: Maybe<Scalars['DateTime']>;
  /** state of current association */
  readonly deliveryState: TDeliveryStateEnum;
  readonly deliveryStates: ReadonlyArray<TDeliveryStateHistorical>;
  readonly id: Scalars['ID'];
  readonly order: TOrder;
  readonly updatedAt: Scalars['DateTime'];
  readonly user: TUser;
  readonly userDelivery: Maybe<TUserDelivery>;
  readonly willPickupAt: Maybe<Scalars['DateTime']>;
};

/** DeliveryState enum */
export type TDeliveryStateEnum =
  | 'ACCEPTED'
  | 'CANCELED'
  | 'DELIVERED'
  | 'DRIVER_CHANGED'
  | 'DRIVER_REJECTED'
  | 'FRESH'
  | 'LAST_MILE_DELIVERY'
  | 'LATE_DELIVERY'
  | 'NOT_FOUND'
  | 'ON_WAY'
  | 'RECLAMATION';

/** History of delivery state assignments taken from events. */
export type TDeliveryStateHistorical = {
  readonly __typename?: 'DeliveryStateHistorical';
  readonly createdAt: Scalars['DateTime'];
  readonly deliveryState: TDeliveryStateEnum;
  readonly user: TUser;
};

/**
 * Information about users delivery
 *
 *
 * INDEX: [admin, cashier_delivery, driver, super_admin, support]
 *
 * READ: [admin, cashier_delivery, driver, super_admin, support]
 *
 * CREATE: [admin, cashier_delivery, driver, super_admin, support]
 *
 * UPDATE: [admin, cashier_delivery, driver, super_admin, support]
 *
 * DESTROY: [admin, cashier_delivery, driver, super_admin]
 *
 */
export type TUserDelivery = {
  readonly __typename?: 'UserDelivery';
  readonly active: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly remainingUserDeliveringOrders: ReadonlyArray<TUserDeliveringOrder>;
  readonly user: TTransportationDeviceUser;
  readonly userDeliveringOrders: ReadonlyArray<TUserDeliveringOrder>;
};

/**
 * Information about transportation device assigned to user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_transportation_device_user, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_transportation_device_user, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, driver, editor_transportation_device_user, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, driver, editor_transportation_device_user, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_transportation_device_user, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TTransportationDeviceUser = {
  readonly __typename?: 'TransportationDeviceUser';
  /** Active UserDelivery of TransportationDeviceUser */
  readonly activeUserDelivery: Maybe<TUserDelivery>;
  /** time of when order was assigned to user */
  readonly createdAt: Scalars['DateTime'];
  /** points that transportation device visited */
  readonly geoRoad: ReadonlyArray<TGeoPositionWithTimestamp>;
  readonly id: Scalars['ID'];
  /** driver returned transportation device and logged out */
  readonly isFinalized: Scalars['Boolean'];
  /** last geo position that device visited */
  readonly lastPosition: Maybe<TGeoPositionWithTimestamp>;
  /** time when transportation device was returned */
  readonly returnedAt: Maybe<Scalars['DateTime']>;
  /** crossed return zone */
  readonly returning: Scalars['Boolean'];
  /** actual return zone in which is user located */
  readonly returnZone: Maybe<TZone>;
  readonly transportationDevice: TTransportationDevice;
  readonly updatedAt: Scalars['DateTime'];
  readonly user: TUser;
};

/** Gps position with timestamp */
export type TGeoPositionWithTimestamp = {
  readonly __typename?: 'GeoPositionWithTimestamp';
  readonly geoPosition: TGeoPoint;
  readonly timestamp: Scalars['DateTime'];
};

/**
 * Zone information
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_zone, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TZone = TAvailabilityInterface & {
  readonly __typename?: 'Zone';
  /** when record is available */
  readonly availabilities: ReadonlyArray<TAvailability>;
  readonly companyBranch: TCompanyBranch;
  readonly createdAt: Scalars['DateTime'];
  /** in minutes */
  readonly defaultDeliveryTime: Scalars['Int'];
  /** in minutes */
  readonly deliveryTimeDeviation: Scalars['Int'];
  readonly enabled: Scalars['Boolean'];
  readonly geoPolygon: ReadonlyArray<TGeoPoint>;
  readonly id: Scalars['ID'];
  /** is available at specific time? */
  readonly isAvailable: Scalars['Boolean'];
  readonly minimalOrderPrice: TPriceConverted;
  /** Indicates if discounts are included in minimalOrderPrice */
  readonly minimalOrderPriceWithDiscounts: Scalars['Boolean'];
  /** Indicates if transportFee is included in minimalOrderPrice */
  readonly minimalOrderPriceWithTransportFee: Scalars['Boolean'];
  readonly name: Scalars['String'];
  /** price range rules converted to prefered currency */
  readonly priceRangeRules: ReadonlyArray<TZonePriceRangeRule>;
  readonly priority: Scalars['Int'];
  /** description of rule */
  readonly rule: Maybe<Scalars['Json']>;
  readonly updatedAt: Scalars['DateTime'];
  readonly zoneColor: TZoneColor;
  readonly zoneType: TZoneType;
};


/**
 * Zone information
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_zone, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TZoneIsAvailableArgs = {
  dateTime?: InputMaybe<Scalars['DateTime']>;
  orderOriginCategory?: InputMaybe<TOrderOriginCategoryEnum>;
};


/**
 * Zone information
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_zone, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TZoneMinimalOrderPriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Zone information
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_zone, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TZonePriceRangeRulesArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};

/** Price rules of the zone */
export type TZonePriceRangeRule = {
  readonly __typename?: 'ZonePriceRangeRule';
  /** price converted to prefered currency */
  readonly price: TPriceConverted;
  /** maximal price of rule */
  readonly toPrice: TPriceConverted;
};

/**
 * Zone color with code and color definition
 *
 *
 * INDEX: [admin, editor_zones, super_admin, support, user]
 *
 * READ: [admin, editor_zones, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TZoneColor = TColorInterface & {
  readonly __typename?: 'ZoneColor';
  readonly code: Scalars['String'];
  readonly color: Scalars['String'];
  readonly id: Scalars['ID'];
};

/**
 * Possible ZoneType types
 *
 *
 * INDEX: [admin, editor_zones, super_admin, support, user]
 *
 * READ: [admin, editor_zones, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TZoneType = {
  readonly __typename?: 'ZoneType';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TZoneTypeEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** ZoneType enum */
export type TZoneTypeEnum =
  | 'AREA'
  | 'RETURN'
  | 'SECTOR'
  | 'TABLE';

/**
 * Type for transportation device
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_transportation_device, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_transportation_device, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_transportation_device, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_transportation_device, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_transportation_device, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TTransportationDevice = {
  readonly __typename?: 'TransportationDevice';
  readonly companyBranch: TCompanyBranch;
  readonly deviceState: TDeviceState;
  readonly deviceType: TDeviceType;
  readonly id: Scalars['ID'];
  readonly idNumber: Scalars['String'];
};

/**
 * Possible DeviceState types
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TDeviceState = {
  readonly __typename?: 'DeviceState';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TDeviceStateEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** DeviceState enum */
export type TDeviceStateEnum =
  | 'BROKEN'
  | 'BUSY'
  | 'FREE'
  | 'WORKING';

/**
 * Possible DeviceType types
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TDeviceType = {
  readonly __typename?: 'DeviceType';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TDeviceTypeEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** DeviceType enum */
export type TDeviceTypeEnum =
  | 'CAR'
  | 'DRON'
  | 'PLANE';

export type TDriverInterface = {
  readonly countUndeliveredOrders: Scalars['Int'];
  readonly transportationDeviceUsers: ReadonlyArray<TTransportationDeviceUser>;
  readonly usedTransportationDevice: Maybe<TTransportationDeviceUser>;
  readonly userDeliveringOrders: ReadonlyArray<TUserDeliveringOrder>;
};


export type TDriverInterfaceUserDeliveringOrdersArgs = {
  onlyUndelivered?: InputMaybe<Scalars['Boolean']>;
};

export type TOrdersInterface = {
  readonly orders: ReadonlyArray<TOrder>;
};


export type TOrdersInterfaceOrdersArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  from?: InputMaybe<Scalars['DateTime']>;
  orderOrigins?: InputMaybe<ReadonlyArray<TOrderOriginEnum>>;
  to?: InputMaybe<Scalars['DateTime']>;
};

export type TStatisticsAccessInterface = {
  readonly accessibleCreditsGroups: ReadonlyArray<TCreditsGroup>;
};

/**
 * Link between Company Branch and User
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, driver, editor_company_branch_user, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, driver, editor_company_branch_user, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_company_branch_user, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch_user, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_company_branch_user, sales_representative, super_admin, supervisor]
 *
 */
export type TCompanyBranchUser = {
  readonly __typename?: 'CompanyBranchUser';
  readonly companyBranch: TCompanyBranch;
  /** user is no longer employed by company branch */
  readonly deleted: Scalars['Boolean'];
  readonly driverOrderAssignments: ReadonlyArray<TUserDeliveringOrdersAssignmentType>;
  readonly driverSmsText: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly user: TUser;
};


/**
 * Link between Company Branch and User
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, driver, editor_company_branch_user, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, driver, editor_company_branch_user, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_company_branch_user, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch_user, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_company_branch_user, sales_representative, super_admin, supervisor]
 *
 */
export type TCompanyBranchUserDriverOrderAssignmentsArgs = {
  enableFallback?: InputMaybe<Scalars['Boolean']>;
};

/** Holds information about Customer */
export type TCustomer = TOrdersInterface & {
  readonly __typename?: 'Customer';
  readonly company: TCompany;
  readonly customerConsents: ReadonlyArray<TConsentCustomer>;
  readonly email: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly isCancelRisk: Scalars['Boolean'];
  readonly isCustomerRegistered: Scalars['Boolean'];
  readonly lastName: Scalars['String'];
  readonly orders: ReadonlyArray<TOrder>;
  readonly phone: Scalars['String'];
};


/** Holds information about Customer */
export type TCustomerOrdersArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  from?: InputMaybe<Scalars['DateTime']>;
  orderOrigins?: InputMaybe<ReadonlyArray<TOrderOriginEnum>>;
  to?: InputMaybe<Scalars['DateTime']>;
};


/** Holds information about Customer */
export type TCustomerPhoneArgs = {
  part?: InputMaybe<TPhonePartSelectorEnum>;
};

/** Information about customer consent association. */
export type TConsentCustomer = {
  readonly __typename?: 'ConsentCustomer';
  readonly consent: TConsent;
  readonly customer: TCustomer;
  readonly history: ReadonlyArray<TConsentCustomerHistory>;
  readonly isActive: Scalars['Boolean'];
};

/** Historical activity of customers consent association. */
export type TConsentCustomerHistory = {
  readonly __typename?: 'ConsentCustomerHistory';
  readonly createdAt: Scalars['DateTime'];
  readonly id: Scalars['ID'];
  readonly revokedAt: Maybe<Scalars['DateTime']>;
  readonly revokeType: Maybe<TConsentsRevokeType>;
};

/** Possible ConsentsRevokeType types */
export type TConsentsRevokeType = {
  readonly __typename?: 'ConsentsRevokeType';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TConsentsRevokeTypeEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** ConsentsRevokeType enum */
export type TConsentsRevokeTypeEnum =
  | 'COMPANY_REVOKE'
  | 'CUSTOMER_REVOKE'
  | 'EXPIRATION'
  | 'MASS_REVOKE'
  | 'ONE_TIME'
  | 'TRANSFER_REVOKE';

/** Allows to select a only records with a specified confirmation status. */
export type TConfirmationStatusSelectorEnum =
  | 'CONFIRMED'
  | 'PENDING';

export type TGreetingsInputArgumentsRead = {
  readonly formality?: InputMaybe<TGreetingsFormalityArgumentGlEnum>;
  readonly time?: InputMaybe<TGreetingsTimeArgumentGlEnum>;
};

/** Formality of the greeting. */
export type TGreetingsFormalityArgumentGlEnum =
  /** Random style, either formal or informal. */
  | 'ALL'
  /** Formal style. */
  | 'FORMAL'
  /** Informal style. */
  | 'INFORMAL';

/** Whether the greeting should be time-based. */
export type TGreetingsTimeArgumentGlEnum =
  /** Random greeting, either generic or based on current time of day. */
  | 'ALL'
  /** A generic greeting. */
  | 'GENERIC'
  /** A greeting based on current time of day. */
  | 'TIME_BASED';

export type TGreeting = {
  readonly __typename?: 'Greeting';
  readonly message: Scalars['String'];
};

/** The connection type for InAppNotification. */
export type TInAppNotificationConnection = {
  readonly __typename?: 'InAppNotificationConnection';
  /** A list of edges. */
  readonly edges: Maybe<ReadonlyArray<Maybe<TInAppNotificationEdge>>>;
  /** A list of nodes. */
  readonly nodes: Maybe<ReadonlyArray<Maybe<TInAppNotification>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: TPageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type TInAppNotificationEdge = {
  readonly __typename?: 'InAppNotificationEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: Maybe<TInAppNotification>;
};

/** InAppNotification */
export type TInAppNotification = {
  readonly __typename?: 'InAppNotification';
  readonly content: Scalars['String'];
  readonly createdAt: Scalars['DateTime'];
  readonly id: Scalars['ID'];
  readonly isRead: Scalars['Boolean'];
  readonly readAt: Maybe<Scalars['DateTime']>;
  readonly title: Scalars['String'];
  readonly url: Maybe<Scalars['String']>;
};

/**
 * Possible user roles
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, editor_role, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, editor_role, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, editor_role, super_admin]
 *
 * UPDATE: [admin, editor_role, super_admin]
 *
 * DESTROY: [admin, editor_role, super_admin]
 *
 */
export type TRole = {
  readonly __typename?: 'Role';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TRoleEnum;
  readonly id: Scalars['ID'];
  /** @deprecated Use rawCode instead. */
  readonly name: Scalars['String'];
  readonly rawCode: Scalars['String'];
};

/** Possible roles for user */
export type TRoleEnum =
  | 'ACCESS_CONFIG'
  | 'ACCOUNT_MANAGER'
  | 'ACCOUNTANT'
  | 'ADMIN'
  | 'BRANCH_OWNER'
  | 'BRAND_OWNER'
  | 'CALL_CENTER'
  | 'CASHIER'
  | 'CASHIER_ALLOWED_DELIVERY_TYPES'
  | 'CASHIER_BASIC_RECIPES'
  | 'CASHIER_CANCEL'
  | 'CASHIER_CHANGE_DELIVERY_TYPE'
  | 'CASHIER_DELIVERY'
  | 'CASHIER_ISOLATED_PRINT'
  | 'CASHIER_KIOSK'
  | 'CASHIER_MENU'
  | 'CASHIER_PAYMENT_METHODS'
  | 'CASHIER_POS'
  | 'CASHIER_PROCESS_TIME'
  | 'CASHIER_REFUND'
  | 'CASHIER_REPORTS'
  | 'CASHIER_REPORTS_WITH_PRODUCTS'
  | 'CASHIER_STATISTICS'
  | 'CASHIER_TRANSFER_COMPANY_BRANCH'
  | 'CASHIER_UNLIMITED'
  | 'CASHIER_UNLIMITED_CUSTOMER'
  | 'CASHIER_WITHOUT_PRINT'
  | 'CASHLESS_SUPERVISOR'
  | 'CUSTOMER'
  | 'DRIVER'
  | 'DRIVER_DEFAULT'
  | 'DRIVER_DODO'
  | 'DRIVER_FOODIS'
  | 'DRIVER_FOODORA_GO'
  | 'DRIVER_LIFTAGO'
  | 'DRIVER_PROROZVOZ'
  | 'DRIVER_WOLT_DRIVE'
  | 'EDITOR'
  | 'EDITOR_ADDRESS'
  | 'EDITOR_ANNOUNCEMENT'
  | 'EDITOR_AVAILABILITY'
  | 'EDITOR_BILLINGS'
  | 'EDITOR_BUSINESS_HOUR'
  | 'EDITOR_BUSINESS_HOURS'
  | 'EDITOR_CASH_BOX'
  | 'EDITOR_COMPANY'
  | 'EDITOR_COMPANY_BRANCH'
  | 'EDITOR_COMPANY_BRANCH_CURRENCY'
  | 'EDITOR_COMPANY_BRANCH_DELIVERY'
  | 'EDITOR_COMPANY_BRANCH_USER'
  | 'EDITOR_COMPANY_ORDER_ORIGIN'
  | 'EDITOR_COUNTRY'
  | 'EDITOR_COUNTRY_VAT'
  | 'EDITOR_COUNTRY_VAT_PRICE_TYPE'
  | 'EDITOR_COUNTRY_VAT_TYPE_PRICE'
  | 'EDITOR_CURRENCY'
  | 'EDITOR_EVENT'
  | 'EDITOR_FINANCIAL_REPORT'
  | 'EDITOR_IMPORT_LOG'
  | 'EDITOR_INGREDIENT'
  | 'EDITOR_INTEGRATIONS'
  | 'EDITOR_LABEL'
  | 'EDITOR_LABEL_TRANSLATION'
  | 'EDITOR_MENU'
  | 'EDITOR_NOTE'
  | 'EDITOR_ORDER'
  | 'EDITOR_ORDER_BILLING'
  | 'EDITOR_ORDER_DISCOUNT'
  | 'EDITOR_ORDER_ORIGIN_PRICE_TYPE'
  | 'EDITOR_ORDER_PAYMENT_METHOD'
  | 'EDITOR_ORDER_PRICE_MODIFICATION'
  | 'EDITOR_ORDER_RECIPE'
  | 'EDITOR_ORDER_STATE_RELATION'
  | 'EDITOR_ORDERS'
  | 'EDITOR_PAGE_ELEMENT'
  | 'EDITOR_PAYMENT_METHOD'
  | 'EDITOR_PAYMENT_METHOD_BRANCH'
  | 'EDITOR_PROMO_CODE'
  | 'EDITOR_RECIPE'
  | 'EDITOR_RECIPE_PRICE'
  | 'EDITOR_RECIPE_RELATION'
  | 'EDITOR_REJECTED_PAYMENT_METHOD'
  | 'EDITOR_ROLE'
  | 'EDITOR_SETTING'
  | 'EDITOR_SHIFT'
  | 'EDITOR_SHIFT_USER'
  | 'EDITOR_SORTING'
  | 'EDITOR_STOCK_ITEM'
  | 'EDITOR_STOCK_ITEM_ALLERGEN'
  | 'EDITOR_STOCK_TRANSFER'
  | 'EDITOR_TRANSPORTATION_DEVICE'
  | 'EDITOR_TRANSPORTATION_DEVICE_USER'
  | 'EDITOR_USER'
  | 'EDITOR_USER_DELIVERING_ORDER'
  | 'EDITOR_USER_LOGIN_PROVIDER'
  | 'EDITOR_USER_PERSONAL'
  | 'EDITOR_WALLET_CREDITS'
  | 'EDITOR_WALLET_CREDITS_REFUND'
  | 'EDITOR_WARE'
  | 'EDITOR_WARE_CATEGORY'
  | 'EDITOR_WARE_CATEGORY_RELATION'
  | 'EDITOR_ZONE'
  | 'EDITOR_ZONES'
  | 'EXPORT_CUSTOMERS'
  | 'EXTERN'
  | 'EXTERNAL_API'
  | 'GASTRA_API'
  | 'GUEST'
  | 'LIFTAGO'
  | 'MERCHANT'
  | 'OPERATOR'
  | 'OWNER_CANCEL'
  | 'REQUEST_CANCEL'
  | 'REQUEST_EXTERNAL_DRIVER'
  | 'SALES_REPRESENTATIVE'
  | 'SUPER_ADMIN'
  | 'SUPERVISOR'
  | 'SUPPORT'
  | 'SUSPENDED_USER'
  | 'TEMPLATABLE_MANAGER'
  | 'USER'
  | 'VAM';

/** Settings of User */
export type TSettingUser = {
  readonly __typename?: 'SettingUser';
  readonly userAssignableRoles: ReadonlyArray<TRole>;
};

/**
 * Keeps user information for appropriate shift
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, driver, editor_shift_user, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, driver, editor_shift_user, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, driver, editor_shift_user, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, driver, editor_shift_user, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, driver, editor_shift_user, sales_representative, super_admin, supervisor]
 *
 */
export type TShiftUser = {
  readonly __typename?: 'ShiftUser';
  readonly id: Scalars['ID'];
  readonly shift: TShift;
  readonly shiftUserState: TShiftUserState;
  readonly user: TUser;
};

/**
 * Description of shift
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, driver, editor_shift, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, driver, editor_shift, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_shift, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_shift, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_shift, sales_representative, super_admin, supervisor]
 *
 */
export type TShift = {
  readonly __typename?: 'Shift';
  readonly beginAt: Maybe<Scalars['DateTime']>;
  readonly capacity: Scalars['Int'];
  readonly companyBranch: TCompanyBranch;
  readonly endAt: Maybe<Scalars['DateTime']>;
  readonly id: Scalars['ID'];
  readonly placeCode: Maybe<Scalars['String']>;
  readonly shiftUsers: ReadonlyArray<TShiftUser>;
};

/**
 * Possible ShiftUserState types
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TShiftUserState = {
  readonly __typename?: 'ShiftUserState';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TShiftUserStateEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** ShiftUserState enum */
export type TShiftUserStateEnum =
  | 'ACCEPTED'
  | 'REJECTED'
  | 'WAITING_FOR_RESPONSE';

/** Settings of CompanyBranch */
export type TSettingCompanyBranch = {
  readonly __typename?: 'SettingCompanyBranch';
  readonly deliveryVat: TVat;
  readonly dotykacka: Maybe<TDotykackaSetting>;
  readonly kioskStyles: Maybe<TKioskStylesSetting>;
};


/** Settings of CompanyBranch */
export type TSettingCompanyBranchKioskStylesArgs = {
  enableFallback?: InputMaybe<Scalars['Boolean']>;
};

/** Setting attributes for Dotykacka */
export type TDotykackaSetting = {
  readonly __typename?: 'DotykackaSetting';
  readonly branchId: Maybe<Scalars['String']>;
  readonly cloudId: Maybe<Scalars['String']>;
  readonly enabled: Scalars['Boolean'];
  readonly refreshToken: Maybe<Scalars['String']>;
  readonly webhookUrl: Maybe<Scalars['String']>;
};

export type TProcessTimeInterface = {
  readonly currentDeliveryTime: Scalars['Int'];
  readonly currentPickupTime: Scalars['Int'];
  /** time in minutes that is required to deliver order */
  readonly defaultDeliveryTime: Scalars['Int'];
  readonly defaultDeliveryTimeEnabled: Scalars['Boolean'];
  /** time in minutes that is required to pickup order */
  readonly defaultPickupTime: Scalars['Int'];
  readonly defaultPickupTimeEnabled: Scalars['Boolean'];
  readonly delayedDeliveryEnabled: Scalars['Boolean'];
  readonly delayedDeliveryEnabledWaiter: Scalars['Boolean'];
  readonly delayedDeliveryLimit: Scalars['Int'];
  readonly overriddenDeliveryTime: Maybe<TOrderProcessTime>;
  readonly overriddenPickupTime: Maybe<TOrderProcessTime>;
};

/**
 * Orders default delivery/pickup time overriding
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, cashier, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, cashier, super_admin, supervisor, support]
 *
 */
export type TOrderProcessTime = {
  readonly __typename?: 'OrderProcessTime';
  readonly companyBranch: TCompanyBranch;
  readonly createdAt: Scalars['DateTime'];
  readonly deliveryType: TDeliveryType;
  readonly expiresAt: Scalars['DateTime'];
  readonly id: Scalars['ID'];
  readonly processTime: Scalars['Int'];
};

export type TStockInterface = {
  /** stock items that are incoming to branch */
  readonly incomingStockTransfer: ReadonlyArray<TStockTransfer>;
  /** stock items that are leaving branch */
  readonly outcomingStockTransfer: ReadonlyArray<TStockTransfer>;
  readonly stockItemsCanBeNegative: Scalars['Boolean'];
};

/**
 * Transfer information about stock item
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, editor_stock_transfer, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, editor_stock_transfer, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_stock_transfer, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_stock_transfer, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_stock_transfer, operator, super_admin]
 *
 */
export type TStockTransfer = {
  readonly __typename?: 'StockTransfer';
  readonly id: Scalars['ID'];
  readonly quantity: Scalars['Float'];
  readonly rejectAccepted: Scalars['Boolean'];
  readonly rejectedByTarget: Scalars['Boolean'];
  readonly sourceCompanyBranch: TCompanyBranch;
  /** code of stock item from source company branch */
  readonly stockItemCode: Scalars['String'];
  readonly targetCompanyBranch: TCompanyBranch;
  readonly wareUnit: TWareUnit;
};

/** Vat value for defined ware price type */
export type TVatPriceType = {
  readonly __typename?: 'VatPriceType';
  readonly id: Scalars['ID'];
  readonly vat: Scalars['Float'];
  readonly warePriceType: TWarePriceType;
};

/** Dotykacka profile */
export type TDotykackaProfile = TDeletableInterface & TEntityErrorsInterface & TIntegrableInterface & TProfileErrorsInterface & {
  readonly __typename?: 'DotykackaProfile';
  readonly cloudIdValue: Scalars['String'];
  readonly companyBranch: TCompanyBranch;
  readonly id: Scalars['ID'];
  readonly integration: TIntegration;
  /** Activities of an entity */
  readonly integrationsEntityActivities: TIntegrationsActivityConnection;
  /** Errors of an entity */
  readonly integrationsEntityErrors: TIntegrationsErrorConnection;
  /** Activities of a profile */
  readonly integrationsProfileActivities: TIntegrationsActivityConnection;
  /** The records of entities being synced to this profile */
  readonly integrationsProfileEntitySyncs: TIntegrationsProfileEntitySyncConnection;
  /** Errors of a profile */
  readonly integrationsProfileErrors: TIntegrationsErrorConnection;
  readonly isAutomaticMenuSyncEnabled: Scalars['Boolean'];
  readonly isDeleted: Scalars['Boolean'];
  readonly lastMenuSyncAt: Maybe<Scalars['DateTime']>;
  readonly name: Scalars['String'];
  readonly restaurantIdValue: Scalars['String'];
  /** Unresolved activities of an entity */
  readonly unresolvedIntegrationsEntityActivities: TIntegrationsActivityConnection;
  /** Unresolved errors of an entity */
  readonly unresolvedIntegrationsEntityErrors: TIntegrationsErrorConnection;
  /** Unresolved activities of a profile */
  readonly unresolvedIntegrationsProfileActivities: TIntegrationsActivityConnection;
  /** Unresolved errors of a profile */
  readonly unresolvedIntegrationsProfileErrors: TIntegrationsErrorConnection;
};


/** Dotykacka profile */
export type TDotykackaProfileIntegrationsEntityActivitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Dotykacka profile */
export type TDotykackaProfileIntegrationsEntityErrorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Dotykacka profile */
export type TDotykackaProfileIntegrationsProfileActivitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Dotykacka profile */
export type TDotykackaProfileIntegrationsProfileEntitySyncsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Dotykacka profile */
export type TDotykackaProfileIntegrationsProfileErrorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Dotykacka profile */
export type TDotykackaProfileUnresolvedIntegrationsEntityActivitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Dotykacka profile */
export type TDotykackaProfileUnresolvedIntegrationsEntityErrorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Dotykacka profile */
export type TDotykackaProfileUnresolvedIntegrationsProfileActivitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Dotykacka profile */
export type TDotykackaProfileUnresolvedIntegrationsProfileErrorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/**
 * EET certificate informations
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TEetCertificate = {
  readonly __typename?: 'EETCertificate';
  readonly mode: Scalars['String'];
  readonly passphrase: Scalars['String'];
  readonly placeId: Scalars['Int'];
  readonly privateKey: Scalars['String'];
  readonly rootCertificate: Scalars['String'];
};

/**
 * Payment methods used by branch
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, editor_payment_method_branch, guest, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, editor_payment_method_branch, guest, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_payment_method_branch, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_payment_method_branch, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_payment_method_branch, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TPaymentMethodBranch = {
  readonly __typename?: 'PaymentMethodBranch';
  readonly companyBranch: TCompanyBranch;
  readonly deliveryType: Maybe<TDeliveryType>;
  readonly enabled: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  /** Maximum amount allowed for the payment method */
  readonly maximumAmount: Maybe<TPriceConverted>;
  readonly orderOrigin: TOrderOrigin;
  readonly paymentMethod: TPaymentMethod;
  readonly warePriceType: TWarePriceType;
};

/**
 * FoodoraIntegration
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TFoodoraIntegration = {
  readonly __typename?: 'FoodoraIntegration';
  readonly integrationState: TIntegrationState;
};

/**
 * WoltIntegration
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TWoltIntegration = {
  readonly __typename?: 'WoltIntegration';
  readonly integrationState: TIntegrationState;
};

/** Setting attributes for brand or branch */
export type TApplicationSettings = TApplicationSettingsInterface & {
  readonly __typename?: 'ApplicationSettings';
  readonly defaultTimeZone: TTimeZone;
  readonly dynamicTranslations: Maybe<TDynamicTranslationsTranslations>;
  readonly headerText: Maybe<Scalars['String']>;
  readonly homepageUrl: Maybe<Scalars['String']>;
  /** enabling promo header setting */
  readonly promoHeaderEnabled: Maybe<Scalars['Boolean']>;
  /** inherited promo header text */
  readonly promoHeaderText: Maybe<Scalars['String']>;
  /** promo header text from setting without inheritance */
  readonly promoHeaderTranslations: Maybe<ReadonlyArray<TPromoHeaderTranslation>>;
  /** graphic styles */
  readonly styles: TGraphicStyle;
  readonly userAccountsEnabledForCustomer: Scalars['Boolean'];
  readonly wifiAppInstructions: ReadonlyArray<TWiFiAppInstruction>;
};


/** Setting attributes for brand or branch */
export type TApplicationSettingsStylesArgs = {
  originCategory?: InputMaybe<TOrderOriginCategoryEnum>;
};

/**
 * Board
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor]
 *
 */
export type TBoard = {
  readonly __typename?: 'Board';
  /** Converts ActiveStorage attachment to URL */
  readonly backgroundImage: Maybe<Scalars['String']>;
  /** Converts ActiveStorage attachment to URL */
  readonly backgroundVideo: Maybe<Scalars['String']>;
  /** Board screens ordered through sorting */
  readonly boardScreens: ReadonlyArray<TBoardScreen>;
  readonly boardTemplate: TBoardTemplate;
  /** Custom color set */
  readonly colors: ReadonlyArray<Scalars['String']>;
  readonly companyBranch: TCompanyBranch;
  readonly features: TBoardFeatures;
  readonly id: Scalars['ID'];
  /** Converts ActiveStorage attachment to URL */
  readonly logo: Maybe<Scalars['String']>;
  readonly name: Scalars['String'];
};


/**
 * Board
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor]
 *
 */
export type TBoardBackgroundImageArgs = {
  height?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};


/**
 * Board
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor]
 *
 */
export type TBoardBackgroundVideoArgs = {
  height?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};


/**
 * Board
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor]
 *
 */
export type TBoardLogoArgs = {
  height?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};

/**
 * Board screen
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor]
 *
 */
export type TBoardScreen = {
  readonly __typename?: 'BoardScreen';
  /** Converts ActiveStorage attachment to URL */
  readonly backgroundImage: Maybe<Scalars['String']>;
  /** Converts ActiveStorage attachment to URL */
  readonly backgroundVideo: Maybe<Scalars['String']>;
  readonly board: TBoard;
  readonly id: Scalars['ID'];
  /** Board screen name */
  readonly name: Scalars['String'];
  readonly wareCategories: ReadonlyArray<TWareCategory>;
};


/**
 * Board screen
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor]
 *
 */
export type TBoardScreenBackgroundImageArgs = {
  height?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};


/**
 * Board screen
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor]
 *
 */
export type TBoardScreenBackgroundVideoArgs = {
  height?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};

/**
 * Board template
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TBoardTemplate = {
  readonly __typename?: 'BoardTemplate';
  readonly features: TBoardTemplateFeatures;
  readonly id: Scalars['ID'];
  /** Template name */
  readonly name: Scalars['String'];
  /** Converts ActiveStorage attachment to URL */
  readonly preview: Scalars['String'];
  /** Converts ActiveStorage attachment to URL */
  readonly styles: Scalars['String'];
};


/**
 * Board template
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TBoardTemplatePreviewArgs = {
  height?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};


/**
 * Board template
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TBoardTemplateStylesArgs = {
  height?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};

/** Board template features */
export type TBoardTemplateFeatures = {
  readonly __typename?: 'BoardTemplateFeatures';
  readonly allergens: Scalars['Boolean'];
  readonly availableColors: Scalars['Int'];
  readonly infoMessage: Scalars['Boolean'];
  readonly logo: Scalars['Boolean'];
  readonly promo: Scalars['Boolean'];
  readonly screenTitle: Scalars['Boolean'];
};

/** Board features */
export type TBoardFeatures = {
  readonly __typename?: 'BoardFeatures';
  readonly allergensEnabled: Scalars['Boolean'];
  readonly infoMessageEnabled: Scalars['Boolean'];
  readonly infoMessagePrimary: Maybe<Scalars['String']>;
  readonly infoMessageSecondary: Maybe<Scalars['String']>;
  readonly logoEnabled: Scalars['Boolean'];
  readonly promoCategory: Maybe<TWareCategory>;
  readonly promoEnabled: Scalars['Boolean'];
  readonly titleEnabled: Scalars['Boolean'];
  readonly titleText: Maybe<Scalars['String']>;
  readonly titleUrl: Maybe<Scalars['String']>;
};

export type TInputBoardTemplateFeaturesIndex = {
  readonly allergens?: InputMaybe<Scalars['Boolean']>;
  readonly availableColors?: InputMaybe<Scalars['Int']>;
  readonly infoMessage?: InputMaybe<Scalars['Boolean']>;
  readonly logo?: InputMaybe<Scalars['Boolean']>;
  readonly promo?: InputMaybe<Scalars['Boolean']>;
  readonly screenTitle?: InputMaybe<Scalars['Boolean']>;
};

export type TCompanyBranchesLookUp = {
  readonly __typename?: 'CompanyBranchesLookUp';
  readonly finalAddress: Maybe<TJsonAddress>;
  readonly finalAddressFormatted: Maybe<Scalars['String']>;
  readonly gpsCoordinates: Maybe<TGeoPoint>;
  readonly isResolved: Scalars['Boolean'];
  readonly isValidAddress: Scalars['Boolean'];
  readonly resolvedBranches: ReadonlyArray<TResolvedCompanyBranch>;
};

export type TResolvedCompanyBranch = {
  readonly __typename?: 'ResolvedCompanyBranch';
  readonly companyBranch: TCompanyBranch;
  /** url to doveze app */
  readonly url: Scalars['String'];
  /** zone that applies for customer delivery */
  readonly zone: TZone;
};

export type TCompanyBrandLookUp = {
  readonly __typename?: 'CompanyBrandLookUp';
  readonly analyticsCodes: ReadonlyArray<TAnalyticsCode>;
  readonly brand: Maybe<TCompany>;
  readonly companyBranch: Maybe<TCompanyBranch>;
  readonly companyBranches: ReadonlyArray<TCompanyBranch>;
  /** @deprecated Use analyticsCodes instead. */
  readonly googleAnalyticsCode: Maybe<Scalars['String']>;
  readonly isBrandUrl: Scalars['Boolean'];
  /** @deprecated Use isBrandUrl instead. */
  readonly isBrandWac: Scalars['Boolean'];
  readonly isMobileApp: Scalars['Boolean'];
  readonly knownBasePath: Scalars['String'];
  readonly orderOrigin: TOrderOriginEnum;
  readonly redirectUrl: Maybe<Scalars['String']>;
  readonly sector: Maybe<TSector>;
  readonly userDefaultLanguage: TLanguageEnum;
};

/** Information about available analytics codes */
export type TAnalyticsCode = {
  readonly __typename?: 'AnalyticsCode';
  readonly analyticsCodeType: TAnalyticsCodeType;
  readonly code: Maybe<Scalars['String']>;
};

/**
 * Possible AnalyticsCodeType types
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TAnalyticsCodeType = {
  readonly __typename?: 'AnalyticsCodeType';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TAnalyticsCodeTypeEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** AnalyticsCodeType enum */
export type TAnalyticsCodeTypeEnum =
  | 'FACEBOOK_PIXEL'
  | 'GOOGLE_ANALYTICS'
  | 'SKLIK_CONVERSION';

/**
 * Company branch trigger to printer
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, cashier_isolated_print, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, cashier_isolated_print, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor]
 *
 */
export type TCompanyBranchTriggerPrinter = {
  readonly __typename?: 'CompanyBranchTriggerPrinter';
  /** printer */
  readonly companyBranchPrinter: TCompanyBranchPrinter;
  /** triggers */
  readonly companyBranchTrigger: TCompanyBranchTrigger;
  readonly id: Scalars['ID'];
  readonly targetMac: Scalars['String'];
};

/**
 * Company branch printer
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, cashier_isolated_print, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, cashier_isolated_print, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, cashier, super_admin, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor]
 *
 */
export type TCompanyBranchPrinter = {
  readonly __typename?: 'CompanyBranchPrinter';
  /** Company branch */
  readonly companyBranch: TCompanyBranch;
  readonly id: Scalars['ID'];
  /** printer */
  readonly printer: TPrinter;
};

/**
 * Printer schema
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor]
 *
 */
export type TPrinter = {
  readonly __typename?: 'Printer';
  readonly companyBranchPrinters: ReadonlyArray<TCompanyBranchPrinter>;
  readonly id: Scalars['ID'];
  readonly mac: Scalars['String'];
  readonly name: Scalars['String'];
  readonly printerType: TPrinterType;
  readonly user: TUser;
};

/**
 * Possible PrinterType types
 *
 *
 * INDEX: [admin, super_admin, support, user]
 *
 * READ: [admin, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TPrinterType = {
  readonly __typename?: 'PrinterType';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TPrinterTypeEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** PrinterType enum */
export type TPrinterTypeEnum =
  | 'KIOSK'
  | 'W58MM'
  | 'W80MM';

/**
 * Company branch trigger
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, cashier_isolated_print, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, cashier_isolated_print, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor]
 *
 */
export type TCompanyBranchTrigger = {
  readonly __typename?: 'CompanyBranchTrigger';
  readonly assignable: TCompanyBranchTriggerAssignable;
  /**
   * Company branch
   * @deprecated Use assignable polymorphic association instead
   */
  readonly companyBranch: TCompanyBranch;
  /** Company branch trigger printers */
  readonly companyBranchTriggerPrinters: ReadonlyArray<TCompanyBranchTriggerPrinter>;
  readonly id: Scalars['ID'];
  /**
   * Print configuration
   * @deprecated Use triggerConfiguration field instead
   */
  readonly printConfiguration: TPrintConfiguration;
  /**
   * Template
   * @deprecated Use templatable polymorphic association instead
   */
  readonly printTemplate: TPrintTemplate;
  readonly templatable: TCompanyBranchTriggerTemplatable;
  /** Trigger configuration */
  readonly triggerConfiguration: TTriggerConfiguration;
  /**
   * Trigger type
   * @deprecated Determine the trigger type according to the trigger configuration.
   */
  readonly triggerType: TTriggerType;
};

/** Object in which it may belong a CompanyBranchTrigger */
export type TCompanyBranchTriggerAssignable = TCompany | TCompanyBranch;

/** Print configuration */
export type TPrintConfiguration = {
  readonly __typename?: 'PrintConfiguration';
  readonly configuration: Scalars['Json'];
  readonly description: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly printableType: TPrintableType;
};

/** Possible PrintableType types */
export type TPrintableType = {
  readonly __typename?: 'PrintableType';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TPrintableTypeEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** PrintableType enum */
export type TPrintableTypeEnum =
  | 'CREDITS_FUNDS_TRANSFER'
  | 'CREDITS_WALLET_ACTIVITY'
  | 'FINANCIAL_REPORT'
  | 'NOTE'
  | 'ORDER'
  | 'PRINTER'
  | 'USERS_CONFIRMATION_CODE';

/**
 * Print template schema
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support, templatable_manager, user]
 *
 * READ: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support, templatable_manager, user]
 *
 * CREATE: [admin, super_admin, support, templatable_manager]
 *
 * UPDATE: [admin, super_admin, support, templatable_manager]
 *
 * DESTROY: [admin, super_admin, templatable_manager]
 *
 */
export type TPrintTemplate = {
  readonly __typename?: 'PrintTemplate';
  /** template */
  readonly content: Scalars['String'];
  readonly default: Scalars['Boolean'];
  readonly description: Scalars['String'];
  /** @deprecated Replaced with `PrintTemplate.default` */
  readonly enabled: Scalars['Boolean'];
  readonly expirationMinutes: Scalars['Int'];
  readonly id: Scalars['ID'];
  readonly language: Maybe<TLanguage>;
  /** @deprecated Replaced with triggerable_type */
  readonly printableType: TPrintableType;
  readonly printTemplateType: TPrintTemplateType;
  readonly public: Scalars['Boolean'];
  readonly triggerableType: TTriggerableType;
};

/**
 * Possible PrintTemplateType types
 *
 *
 * INDEX: [admin, super_admin, support, user]
 *
 * READ: [admin, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TPrintTemplateType = {
  readonly __typename?: 'PrintTemplateType';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TPrintTemplateTypeEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** PrintTemplateType enum */
export type TPrintTemplateTypeEnum =
  | 'CREDITS_FUNDS_TRANSFER_TICKET'
  | 'FINANCIAL_REPORT_BRANCH'
  | 'FINANCIAL_REPORT_TERMINAL'
  | 'FINANCIAL_REPORT_WITH_PRODUCTS'
  | 'KITCHEN_TICKET'
  | 'ORDER_TICKET';

/**
 * Possible TriggerableType types
 *
 *
 * INDEX: [admin, super_admin, support, user]
 *
 * READ: [admin, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TTriggerableType = {
  readonly __typename?: 'TriggerableType';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TTriggerableTypeEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** TriggerableType enum */
export type TTriggerableTypeEnum =
  | 'CREDITS_FUNDS_TRANSFER'
  | 'CREDITS_WALLET_ACTIVITY'
  | 'FINANCIAL_REPORT'
  | 'NOTE'
  | 'ORDER'
  | 'PRINTER'
  | 'USERS_CONFIRMATION_CODE';

/** Object which can be triggered by a CompanyBranchTrigger */
export type TCompanyBranchTriggerTemplatable = TPrintTemplate | TSmsTemplate;

/**
 * Sms template schema
 *
 *
 * INDEX: [admin, super_admin, support, templatable_manager]
 *
 * READ: [admin, super_admin, support, templatable_manager]
 *
 * CREATE: [admin, super_admin, support, templatable_manager]
 *
 * UPDATE: [admin, super_admin, support, templatable_manager]
 *
 * DESTROY: [admin, super_admin, templatable_manager]
 *
 */
export type TSmsTemplate = {
  readonly __typename?: 'SmsTemplate';
  /** template */
  readonly body: Scalars['String'];
  readonly default: Scalars['Boolean'];
  readonly description: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly language: TLanguage;
  readonly public: Scalars['Boolean'];
  readonly smsTemplateType: TSmsTemplateType;
  readonly triggerableType: TTriggerableType;
};

/**
 * Possible SmsTemplateType types
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TSmsTemplateType = {
  readonly __typename?: 'SmsTemplateType';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TSmsTemplateTypeEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** SmsTemplateType enum */
export type TSmsTemplateTypeEnum =
  | 'ONE_TIME_SMS'
  | 'ORDER_ACCEPTED'
  | 'ORDER_CANCELED'
  | 'ORDER_FINISHED'
  | 'ORDER_IN_PRODUCE'
  | 'ORDER_IN_PROGRESS'
  | 'ORDER_ON_WAY'
  | 'ORDER_READY_TO_DELIVER'
  | 'ORDER_RECEIVED'
  | 'PRINTER_CANNOT_PRINT'
  | 'PRINTER_OUT_OF_PAPER'
  | 'PRINTER_READY_FOR_PRINT'
  | 'PROMO_CODE'
  | 'RECEIVED_BY_USER';

/**
 * Trigger configuration
 *
 *
 * INDEX: [admin, super_admin, support, user]
 *
 * READ: [admin, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TTriggerConfiguration = {
  readonly __typename?: 'TriggerConfiguration';
  readonly configuration: Scalars['Json'];
  readonly description: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly triggerableType: TTriggerableType;
  /** Trigger type */
  readonly triggerType: TTriggerType;
};

/**
 * Possible TriggerType types
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TTriggerType = {
  readonly __typename?: 'TriggerType';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TTriggerTypeEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** TriggerType enum */
export type TTriggerTypeEnum =
  | 'MAIL'
  | 'PRINT'
  | 'SMS';

export type TCreditsCashlessWalletLookup = {
  readonly __typename?: 'CreditsCashlessWalletLookup';
  readonly wallet: Maybe<TCreditsWallet>;
};

export type TCreditsFundsTransfer = {
  readonly __typename?: 'CreditsFundsTransfer';
  readonly amount: TPriceConverted;
  readonly canceledAt: Maybe<Scalars['DateTime']>;
  readonly cashBox: Maybe<TCashBox>;
  readonly companyBranch: TCompanyBranch;
  readonly createdAt: Scalars['DateTime'];
  readonly currency: TCurrency;
  readonly id: Scalars['ID'];
  readonly order: Maybe<TOrder>;
  readonly paidAt: Maybe<Scalars['DateTime']>;
  readonly paymentMethod: Maybe<TPaymentMethod>;
  readonly state: TCreditsFundsTransferState;
  readonly type: TCreditsFundsTransferType;
  readonly user: TUser;
  readonly wallet: Maybe<TCreditsWallet>;
};

/** Possible CreditsFundsTransferState types */
export type TCreditsFundsTransferState = {
  readonly __typename?: 'CreditsFundsTransferState';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TCreditsFundsTransferStateEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** CreditsFundsTransferState enum */
export type TCreditsFundsTransferStateEnum =
  | 'CANCELED'
  | 'PAID'
  | 'PENDING';

/** Possible CreditsFundsTransferType types */
export type TCreditsFundsTransferType = {
  readonly __typename?: 'CreditsFundsTransferType';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TCreditsFundsTransferTypeEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** CreditsFundsTransferType enum */
export type TCreditsFundsTransferTypeEnum =
  | 'REFUND_AND_CLOSE'
  | 'TOP_UP';

/** Estimated pickup, delivery times and estimated delivery fee */
export type TExternalDeliveryEstimate = {
  readonly __typename?: 'ExternalDeliveryEstimate';
  readonly courierEtaDelivery: Maybe<Scalars['DateTime']>;
  readonly courierEtaPickup: Maybe<Scalars['DateTime']>;
  readonly errorMessage: Maybe<Scalars['String']>;
  readonly estimatedDeliveryFee: Maybe<TPriceConverted>;
  readonly rawErrorMessage: Maybe<Scalars['String']>;
};

/**
 * Status of external delivery request
 *
 *
 * INDEX: [admin, request_external_driver, super_admin, support]
 *
 * READ: [admin, request_external_driver, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TExternalDelivery = {
  readonly __typename?: 'ExternalDelivery';
  readonly errorMessage: Maybe<Scalars['String']>;
  readonly externalDeliveryProvider: TExternalDeliveryProvider;
  readonly externalDeliveryState: TExternalDeliveryState;
  readonly externalIdentifier: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly order: TOrder;
  readonly orderNumber: Maybe<Scalars['String']>;
  readonly seen: Scalars['Boolean'];
};

/**
 * Possible ExternalDeliveryState types
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TExternalDeliveryState = {
  readonly __typename?: 'ExternalDeliveryState';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TExternalDeliveryStateEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** ExternalDeliveryState enum */
export type TExternalDeliveryStateEnum =
  | 'ACCEPTED'
  | 'CANCELED'
  | 'FINISHED'
  | 'REJECTED'
  | 'REQUESTED';

/**
 * Possible FieldState types
 *
 *
 * INDEX: [admin, editor, super_admin, support, user]
 *
 * READ: [admin, editor, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TFieldState = {
  readonly __typename?: 'FieldState';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TFieldStateEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** FileReportType enum */
export type TFileReportTypeEnum =
  | 'CSV_DAILY_VAT'
  | 'CSV_EXTERNAL_DELIVERIES_FOODORA_GO'
  | 'CSV_EXTERNAL_DELIVERIES_WOLT_DRIVE'
  | 'CSV_INCOMING_CALL'
  | 'CSV_ORDERS_DETAILS'
  | 'CSV_SALES'
  | 'CSV_STOCK_MANIPULATIONS'
  | 'XLS_DAILY_VAT'
  | 'XLS_EXTERNAL_DELIVERIES_FOODORA_GO'
  | 'XLS_EXTERNAL_DELIVERIES_WOLT_DRIVE'
  | 'XLS_INCOMING_CALL'
  | 'XLS_ORDERS_DETAILS'
  | 'XLS_SALES'
  | 'XLS_STOCK_MANIPULATIONS';

/** Possible file formats for export */
export type TFileReportFormat =
  | 'CSV'
  | 'XLS';

export type TInputStatisticCreate = {
  readonly branches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly cashBoxes?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly cashiers?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly country?: InputMaybe<TCountryEnum>;
  readonly customerPhone?: InputMaybe<Scalars['String']>;
  readonly dateFrom?: InputMaybe<Scalars['Date']>;
  readonly dateTimeFrom?: InputMaybe<Scalars['DateTime']>;
  readonly dateTimeTo?: InputMaybe<Scalars['DateTime']>;
  readonly dateTo?: InputMaybe<Scalars['Date']>;
  readonly drivers?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly hasRating?: InputMaybe<Scalars['Boolean']>;
  readonly occasions?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly orderOrigins?: InputMaybe<ReadonlyArray<TOrderOriginEnum>>;
  readonly paymentGates?: InputMaybe<ReadonlyArray<TPaymentGateEnum>>;
  readonly sectors?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly sectorsWithChildren?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Possible FileReportType types
 *
 *
 * INDEX: [admin, super_admin, support, user]
 *
 * READ: [admin, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TFileReportType = {
  readonly __typename?: 'FileReportType';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TFileReportTypeEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/**
 * Schema of financial report of associated objects
 *
 *
 * INDEX: [accountant, admin, branch_owner, brand_owner, cashier_reports, editor_financial_report, gastra_api, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [accountant, admin, branch_owner, brand_owner, cashier_reports, editor_financial_report, gastra_api, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, cashier_reports, editor_financial_report, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier_reports, editor_financial_report, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_financial_report, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TFinancialReport = TCreditFundsTransferInterface & {
  readonly __typename?: 'FinancialReport';
  readonly balanceCreditFundsTransfers: ReadonlyArray<TStatisticsFundsTransfers>;
  readonly categoryData: ReadonlyArray<TStatisticsCategory>;
  readonly data: ReadonlyArray<TStatisticsDelivery>;
  readonly deliveryZoneData: ReadonlyArray<TStatisticsDeliveryZone>;
  readonly discountData: ReadonlyArray<TStatisticsDiscount>;
  readonly groupedIncomes: ReadonlyArray<TStatisticsBilling>;
  readonly id: Scalars['ID'];
  readonly plainData: Scalars['String'];
  readonly refundCreditFundsTransfers: ReadonlyArray<TStatisticsFundsTransfers>;
  readonly reportDatetime: Scalars['DateTime'];
  readonly reportDatetimeFrom: Maybe<Scalars['DateTime']>;
  readonly reportSequence: Scalars['Int'];
  readonly sectorRecipesData: TStatisticsSectorRecipe;
  readonly topUpCreditFundsTransfers: ReadonlyArray<TStatisticsFundsTransfers>;
  /** Amount of orders and all credit transfers, grouped by payment method */
  readonly totalBalance: ReadonlyArray<TStatisticsBalance>;
  readonly totalIncomes: TPriceConverted;
  readonly totalOrdersCount: Scalars['Int'];
  /** Total amount of credit transfers for refund. */
  readonly totalRefundValue: TPriceConverted;
  readonly totalStornoCount: Scalars['Int'];
  /** Total amount of credit transfers for top-up. */
  readonly totalTopUpValue: TPriceConverted;
  readonly totalVatSummarization: ReadonlyArray<TStatisticsVatSummarization>;
};

export type TCreditFundsTransferInterface = {
  readonly balanceCreditFundsTransfers: ReadonlyArray<TStatisticsFundsTransfers>;
  readonly refundCreditFundsTransfers: ReadonlyArray<TStatisticsFundsTransfers>;
  readonly topUpCreditFundsTransfers: ReadonlyArray<TStatisticsFundsTransfers>;
  /** Total amount of credit transfers for refund. */
  readonly totalRefundValue: TPriceConverted;
  /** Total amount of credit transfers for top-up. */
  readonly totalTopUpValue: TPriceConverted;
};

/** Credit funds transfers statistics for specific billing type */
export type TStatisticsFundsTransfers = {
  readonly __typename?: 'StatisticsFundsTransfers';
  readonly amount: TPriceConverted;
  readonly paymentType: Maybe<TPaymentType>;
  readonly transfersCount: Scalars['Int'];
  readonly transferState: TCreditsFundsTransferState;
};

/** Sales statistics for whole category */
export type TStatisticsCategory = {
  readonly __typename?: 'StatisticsCategory';
  readonly noWareCategory: ReadonlyArray<TStatisticsRecipeCategory>;
  readonly wareCategories: ReadonlyArray<TStatisticsWareCategory>;
  readonly warePriceType: TWarePriceType;
};

/** Counts sales of specific recipe */
export type TStatisticsRecipeCategory = {
  readonly __typename?: 'StatisticsRecipeCategory';
  readonly hasDynamicPrice: Scalars['Boolean'];
  readonly historicalRecipes: ReadonlyArray<TStatisticsRecipeCategory>;
  readonly name: Scalars['String'];
  /** price of each recipe */
  readonly price: TPriceConverted;
  readonly recipeCount: Scalars['Int'];
  /** sum of prices of grouped recipes */
  readonly recipeTotalPrice: TPriceConverted;
};

/** Sales statistics for WareCategory */
export type TStatisticsWareCategory = {
  readonly __typename?: 'StatisticsWareCategory';
  readonly recipes: ReadonlyArray<TStatisticsRecipeCategory>;
  readonly wareCategory: TWareCategory;
};

/** Delivery statistics for branches */
export type TStatisticsDelivery = {
  readonly __typename?: 'StatisticsDelivery';
  readonly deliveryType: Maybe<TDeliveryType>;
  readonly incomes: ReadonlyArray<TStatisticsBilling>;
  readonly ordersCount: Scalars['Int'];
  readonly stornoCount: Scalars['Int'];
  readonly stornoValue: TPriceConverted;
  readonly vatSummarization: ReadonlyArray<TStatisticsVatSummarization>;
  readonly warePriceType: TWarePriceType;
};

/** Income statistics for specific billing type */
export type TStatisticsBilling = {
  readonly __typename?: 'StatisticsBilling';
  readonly income: TPriceConverted;
  readonly ordersCount: Scalars['Int'];
  readonly paymentType: TPaymentType;
};

/** Vat summarization for reports/statistics */
export type TStatisticsVatSummarization = {
  readonly __typename?: 'StatisticsVatSummarization';
  readonly value: TPriceConverted;
  readonly vat: Maybe<TVat>;
};

/** Delivery zone statistics for branches */
export type TStatisticsDeliveryZone = {
  readonly __typename?: 'StatisticsDeliveryZone';
  readonly deliveries: ReadonlyArray<TStatisticsZoneDeliveryPrice>;
  /** Delivering zone */
  readonly zone: TZone;
};

/** Delivery zone statistics for branches */
export type TStatisticsZoneDeliveryPrice = {
  readonly __typename?: 'StatisticsZoneDeliveryPrice';
  /** Number of deliveries into zone. */
  readonly count: Scalars['Int'];
  /** Price of single delivery. */
  readonly price: TPriceConverted;
};

/** Discount statistics for branches */
export type TStatisticsDiscount = {
  readonly __typename?: 'StatisticsDiscount';
  readonly count: Scalars['Int'];
  readonly description: Scalars['String'];
  readonly totalValue: TPriceConverted;
};

/** Statistics for SectorRecipes */
export type TStatisticsSectorRecipe = {
  readonly __typename?: 'StatisticsSectorRecipe';
  readonly canceled: ReadonlyArray<TSectorRecipe>;
};

/**
 * SectorRecipe information
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, super_admin, support]
 *
 * UPDATE: [admin, cashier, super_admin, support]
 *
 * DESTROY: [admin, cashier, super_admin]
 *
 */
export type TSectorRecipe = {
  readonly __typename?: 'SectorRecipe';
  readonly canceledAt: Maybe<Scalars['DateTime']>;
  readonly canceledBy: Maybe<TUser>;
  /** covers of item */
  readonly covers: ReadonlyArray<TSectorRecipe>;
  readonly createdAt: Scalars['DateTime'];
  readonly createdBy: Maybe<TUser>;
  readonly id: Scalars['ID'];
  /** actual user note */
  readonly note: Maybe<Scalars['String']>;
  readonly orderRecipeState: TOrderRecipeState;
  readonly parent: Maybe<TSectorRecipe>;
  readonly recipe: TRecipe;
  readonly sector: TSector;
  /** side dishes of item */
  readonly sideDishes: ReadonlyArray<TSectorRecipe>;
  readonly updatedAt: Scalars['DateTime'];
};

/** Income and transfers statistics for specific billing type */
export type TStatisticsBalance = {
  readonly __typename?: 'StatisticsBalance';
  readonly income: TPriceConverted;
  readonly ordersCount: Scalars['Int'];
  readonly paymentType: Maybe<TPaymentType>;
};

/** OrderMenu */
export type TOrderMenu = TAvailabilityInterface & {
  readonly __typename?: 'OrderMenu';
  /** when record is available */
  readonly availabilities: ReadonlyArray<TAvailability>;
  readonly id: Scalars['ID'];
  /** is available at specific time? */
  readonly isAvailable: Scalars['Boolean'];
  readonly nameLabel: Scalars['String'];
  readonly pictogram: Maybe<Scalars['String']>;
  readonly recipes: ReadonlyArray<TOrderMenuRecipe>;
  readonly wareCategoryColor: Maybe<TWareCategoryColor>;
};


/** OrderMenu */
export type TOrderMenuIsAvailableArgs = {
  dateTime?: InputMaybe<Scalars['DateTime']>;
  orderOriginCategory?: InputMaybe<TOrderOriginCategoryEnum>;
};

/** OrderMenuRecipe */
export type TOrderMenuRecipe = {
  readonly __typename?: 'OrderMenuRecipe';
  readonly code: Scalars['String'];
  readonly descriptionLabel: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly internalNote: Maybe<Scalars['String']>;
  readonly isDynamicPricingEnabled: Scalars['Boolean'];
  readonly nameLabel: Scalars['String'];
  readonly price: TPriceConverted;
  readonly recipeColor: Maybe<TRecipeColor>;
  readonly sideDishesWareCategoriesCount: Scalars['Int'];
};


/** OrderMenuRecipe */
export type TOrderMenuRecipePriceArgs = {
  warePriceType: TWarePriceTypeEnum;
};

/** Status of payment in external service */
export type TOrderOnlinePaymentStatus = TOnlinePaymentGatesInterface & {
  readonly __typename?: 'OrderOnlinePaymentStatus';
  readonly csobUrl: Maybe<Scalars['String']>;
  readonly gopayUrl: Maybe<Scalars['String']>;
  readonly gpWebpayUrl: Maybe<Scalars['String']>;
  /** Indicates that online payment transaction is processing. */
  readonly isProcessing: Scalars['Boolean'];
  /** Indicates that online payment transaction finished successfully. */
  readonly isSuccess: Scalars['Boolean'];
  readonly order: TOrder;
  readonly payFastUrl: Maybe<Scalars['String']>;
  readonly payuUrl: Maybe<Scalars['String']>;
  /** errors which we should display to user */
  readonly userErrors: ReadonlyArray<Scalars['String']>;
};

export type TOnlinePaymentGatesInterface = {
  readonly csobUrl: Maybe<Scalars['String']>;
  readonly gopayUrl: Maybe<Scalars['String']>;
  readonly gpWebpayUrl: Maybe<Scalars['String']>;
  readonly payFastUrl: Maybe<Scalars['String']>;
  readonly payuUrl: Maybe<Scalars['String']>;
};

/**
 * Possible OrderOriginCategory types
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TOrderOriginCategory = {
  readonly __typename?: 'OrderOriginCategory';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TOrderOriginCategoryEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

export type TInputOrderIndex = {
  readonly acceptedAfter?: InputMaybe<Scalars['DateTime']>;
  readonly companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly currency?: InputMaybe<TCurrencyEnum>;
  readonly groups?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly includeOldFinished?: InputMaybe<Scalars['Boolean']>;
  readonly location?: InputMaybe<TInputLocationIndex>;
  readonly occasions?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly orderStateCategoriesOR?: InputMaybe<ReadonlyArray<TOrderStateCategoryEnum>>;
  readonly orderStateCategoryTarget?: InputMaybe<TOrderStateCategoryTargetEnum>;
  readonly orderStatesAND?: InputMaybe<ReadonlyArray<TOrderStateEnum>>;
  readonly orderStatesOR?: InputMaybe<ReadonlyArray<TOrderStateEnum>>;
  readonly sectors?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly sectorsWithChildren?: InputMaybe<Scalars['Boolean']>;
  /** Return only records changed after argument value. */
  readonly stateChangeSince?: InputMaybe<Scalars['DateTime']>;
  readonly user?: InputMaybe<Scalars['ID']>;
};

export type TInputLocationIndex = {
  readonly tableNumber?: InputMaybe<Scalars['Int']>;
};

export type TInputPaginationParams = {
  readonly fromIndex: Scalars['Int'];
  readonly toIndex: Scalars['Int'];
};

/** Order state category type schema */
export type TOrderStateCategoryCount = {
  readonly __typename?: 'OrderStateCategoryCount';
  readonly ordersCount: Scalars['Int'];
  /** enum string used to identify object */
  readonly orderStateCategory: TOrderStateCategory;
};

export type TInputPaymentMethodIndex = {
  readonly companyBranch: Scalars['ID'];
  readonly enabled?: InputMaybe<Scalars['Boolean']>;
  readonly orderOrigin: TOrderOriginEnum;
  readonly paymentGate: TPaymentGateEnum;
  readonly paymentType: TPaymentTypeEnum;
  readonly warePriceType: TWarePriceTypeEnum;
};

/** Global user permissions */
export type TUserPermission = {
  readonly __typename?: 'UserPermission';
  /** User can cancel orders */
  readonly canCancelOrders: Scalars['Boolean'];
  /** User can create order */
  readonly canCreateOrder: Scalars['Boolean'];
  /** User can index orders */
  readonly canIndexOrders: Scalars['Boolean'];
};

/** Data about the latest Pohoda exports */
export type TPohodaExportInfoType = {
  readonly __typename?: 'PohodaExportInfoType';
  readonly currentlySyncing: Scalars['Boolean'];
  readonly lastExportAt: Maybe<Scalars['DateTime']>;
  readonly lastExportStatus: Maybe<TPohodaExportLogStatusEnum>;
  readonly lastSuccessExportAt: Maybe<Scalars['DateTime']>;
};

/** State of the Pohoda export */
export type TPohodaExportLogStatusEnum =
  | 'FAILED'
  | 'RUNNING'
  | 'SCHEDULED'
  | 'SUCCESS';

/**
 * Print queue item
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TPrintQueue = {
  readonly __typename?: 'PrintQueue';
  readonly createdAt: Scalars['DateTime'];
  readonly expiresAt: Scalars['DateTime'];
  readonly id: Scalars['ID'];
  readonly printer: TPrinter;
  readonly printQueueState: TPrintQueueState;
  readonly printTemplateRender: TPrintTemplateRender;
  /** Printer identification through company branch trigger printer */
  readonly targetMac: Scalars['String'];
};

/**
 * Possible PrintQueueState types
 *
 *
 * INDEX: [admin, super_admin, support, user]
 *
 * READ: [admin, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TPrintQueueState = {
  readonly __typename?: 'PrintQueueState';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TPrintQueueStateEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** PrintQueueState enum */
export type TPrintQueueStateEnum =
  | 'CANCELED'
  | 'EXPIRED'
  | 'FAILURE'
  | 'FRESH'
  | 'PRINTED'
  | 'UNKNOWN';

/**
 * Print template render
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TPrintTemplateRender = {
  readonly __typename?: 'PrintTemplateRender';
  readonly id: Scalars['ID'];
  readonly printableId: Scalars['ID'];
  readonly printableType: Scalars['String'];
  readonly renderedContent: Scalars['String'];
  readonly renderedContentBase64: Scalars['String'];
};

export type TInputOrderOriginsWithBlank = {
  readonly enums?: InputMaybe<ReadonlyArray<TOrderOriginEnum>>;
  /** Pass true to filter records with specified OrderOrigins as well as records with no associated OrderOrigin. */
  readonly includeBlank?: InputMaybe<Scalars['Boolean']>;
};

export type TInputPromoCodeIndex = {
  readonly brand?: InputMaybe<Scalars['ID']>;
  readonly companyBranch?: InputMaybe<Scalars['ID']>;
  readonly enabled?: InputMaybe<Scalars['Boolean']>;
};

export type TAddressResolvedLocation = {
  readonly __typename?: 'AddressResolvedLocation';
  readonly companyBranch: Maybe<TCompanyBranch>;
  readonly finalAddress: Maybe<TJsonAddress>;
  readonly finalAddressFormatted: Maybe<Scalars['String']>;
  readonly gpsCoordinates: Maybe<TGeoPoint>;
  readonly inDeliveryLocation: Scalars['Boolean'];
  readonly isResolved: Scalars['Boolean'];
  readonly isValidAddress: Scalars['Boolean'];
  readonly zone: Maybe<TZone>;
};

/**
 * Possible SettingType types
 *
 *
 * INDEX: [admin, super_admin, support, user]
 *
 * READ: [admin, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TSettingType = {
  readonly __typename?: 'SettingType';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TSettingTypeEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** SettingType enum */
export type TSettingTypeEnum =
  | 'ADMIN_ORDER_LISTING'
  | 'CONFIRMATION'
  | 'GRAPHIC'
  | 'OPTIONS'
  | 'RULES'
  | 'URL';

/** Statistics for branches */
export type TStatistics = {
  readonly __typename?: 'Statistics';
  readonly categoryStatistics: ReadonlyArray<TStatisticsCategory>;
  readonly categoryStatisticsPlain: Scalars['String'];
  readonly chargeStatisticsPlain: Scalars['String'];
  readonly creditFundsTransfers: TStatisticsFullFundsTransfers;
  readonly customerStatistics: TStatisticsCustomer;
  readonly dailyStatistics: ReadonlyArray<TStatisticsDaily>;
  readonly dailyStatisticsPlain: Scalars['String'];
  readonly deliveryStatistics: ReadonlyArray<TStatisticsDelivery>;
  readonly deliveryStatisticsPlain: Scalars['String'];
  readonly deliveryZoneStatistics: ReadonlyArray<TStatisticsDeliveryZone>;
  readonly deliveryZoneStatisticsPlain: Scalars['String'];
  readonly discountStatistics: ReadonlyArray<TStatisticsDiscount>;
  readonly discountStatisticsPlain: Scalars['String'];
  readonly driversStatistics: ReadonlyArray<TStatisticsDrivers>;
  readonly driversStatisticsPlain: Scalars['String'];
  readonly finishedOrders: TStatisticsOrders;
  readonly ordersDetailsUrl: Scalars['String'];
  readonly orderStatistics: TStatisticsOrdersCategories;
  readonly orderStatisticsPlain: Scalars['String'];
  readonly vatStatisticsPlain: Scalars['String'];
};

/** Summarized statistics about credit funds transactions */
export type TStatisticsFullFundsTransfers = {
  readonly __typename?: 'StatisticsFullFundsTransfers';
  readonly transfers: ReadonlyArray<TCreditsFundsTransfer>;
};


/** Summarized statistics about credit funds transactions */
export type TStatisticsFullFundsTransfersTransfersArgs = {
  pagination?: InputMaybe<TInputPaginationParams>;
};

/** Customer statistics */
export type TStatisticsCustomer = {
  readonly __typename?: 'StatisticsCustomer';
  readonly addresses: ReadonlyArray<Scalars['String']>;
  readonly emails: ReadonlyArray<Scalars['String']>;
  readonly fullNames: ReadonlyArray<Scalars['String']>;
  readonly orders: ReadonlyArray<TOrder>;
  readonly phone: Maybe<Scalars['String']>;
  readonly promoCodeStatistics: ReadonlyArray<TPromoCodeStatistic>;
  readonly userAccount: Maybe<TUser>;
};

/** Promo code statistics */
export type TPromoCodeStatistic = {
  readonly __typename?: 'PromoCodeStatistic';
  /** order where the promo code was used */
  readonly appliedOrder: Maybe<TOrder>;
  /** Phone of customer who claimed the voucher */
  readonly claimCustomerPhone: Maybe<Scalars['String']>;
  /** origin of the right to use promo code */
  readonly claimDate: Maybe<Scalars['Date']>;
  /** expiration of claim */
  readonly claimExpiration: Maybe<Scalars['Date']>;
  /** order that entitles use promo code */
  readonly claimOrder: Maybe<TOrder>;
  /** Description of promo code. */
  readonly description: Maybe<Scalars['String']>;
  /** Discount given by promo code. */
  readonly discount: Maybe<TPriceConverted>;
  readonly promoCode: TPromoCode;
};

/** Daily statistics for branches */
export type TStatisticsDaily = {
  readonly __typename?: 'StatisticsDaily';
  readonly date: Scalars['Date'];
  readonly incomes: ReadonlyArray<TStatisticsBilling>;
  readonly incomesWithBill: ReadonlyArray<TStatisticsBilling>;
  readonly ordersCount: Scalars['Int'];
};

/** Drivers statistics for branches */
export type TStatisticsDrivers = {
  readonly __typename?: 'StatisticsDrivers';
  readonly drivenDistance: Scalars['Int'];
  readonly incomes: ReadonlyArray<TStatisticsBilling>;
  readonly ordersCount: Scalars['Int'];
  readonly user: TUser;
};

/** Summarized statistics about finished orders */
export type TStatisticsOrders = {
  readonly __typename?: 'StatisticsOrders';
  readonly fees: TPriceConverted;
  readonly onlinePayments: TPriceConverted;
  readonly orders: ReadonlyArray<TOrder>;
  readonly ordersCanceledCount: Scalars['Int'];
  readonly ordersCount: Scalars['Int'];
  readonly total: TPriceConverted;
};


/** Summarized statistics about finished orders */
export type TStatisticsOrdersFeesArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/** Summarized statistics about finished orders */
export type TStatisticsOrdersOnlinePaymentsArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/** Summarized statistics about finished orders */
export type TStatisticsOrdersOrdersArgs = {
  includeCanceled?: InputMaybe<Scalars['Boolean']>;
  orderStatesOr?: InputMaybe<ReadonlyArray<TOrderStateEnum>>;
  pagination?: InputMaybe<TInputPaginationParams>;
};


/** Summarized statistics about finished orders */
export type TStatisticsOrdersTotalArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};

/** Summarized statistics about finished orders divided into specific categories */
export type TStatisticsOrdersCategories = {
  readonly __typename?: 'StatisticsOrdersCategories';
  readonly ordersAdyen: TStatisticsOrderCategoryInfo;
  readonly ordersBistro: TStatisticsOrderCategoryInfo;
  readonly ordersBolt: TStatisticsOrderCategoryInfo;
  readonly ordersCanceled: TStatisticsOrderCategoryInfo;
  readonly ordersCsob: TStatisticsOrderCategoryInfo;
  readonly ordersDameJidlo: TStatisticsOrderCategoryInfo;
  readonly ordersDotykacka: TStatisticsOrderCategoryInfo;
  readonly ordersEshop: TStatisticsOrderCategoryInfo;
  readonly ordersExternalGate: TStatisticsOrderCategoryInfo;
  readonly ordersGpWebpay: TStatisticsOrderCategoryInfo;
  readonly ordersJidloPodNos: TStatisticsOrderCategoryInfo;
  readonly ordersKiosk: TStatisticsOrderCategoryInfo;
  readonly ordersKioskGate: TStatisticsOrderCategoryInfo;
  readonly ordersOnline: TStatisticsOrderCategoryInfo;
  readonly ordersPayU: TStatisticsOrderCategoryInfo;
  readonly ordersPos2Gate: TStatisticsOrderCategoryInfo;
  readonly ordersStaff: TStatisticsOrderCategoryInfo;
  readonly ordersStaffPos: TStatisticsOrderCategoryInfo;
  readonly ordersWolt: TStatisticsOrderCategoryInfo;
};

/** Summarized statistics about orders in specific category */
export type TStatisticsOrderCategoryInfo = {
  readonly __typename?: 'StatisticsOrderCategoryInfo';
  readonly ordersCount: Scalars['Int'];
  readonly ordersFee: TPriceConverted;
  readonly paidOut: TPriceConverted;
  readonly tips: TPriceConverted;
  readonly turnover: TPriceConverted;
};


/** Summarized statistics about orders in specific category */
export type TStatisticsOrderCategoryInfoOrdersFeeArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/** Summarized statistics about orders in specific category */
export type TStatisticsOrderCategoryInfoPaidOutArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/** Summarized statistics about orders in specific category */
export type TStatisticsOrderCategoryInfoTipsArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/** Summarized statistics about orders in specific category */
export type TStatisticsOrderCategoryInfoTurnoverArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};

export type TInputsStatisticCreditsCreate = {
  readonly companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly creditsGroup: Scalars['ID'];
  readonly from: Scalars['DateTime'];
  readonly orderOrigins?: InputMaybe<ReadonlyArray<TOrderOriginEnum>>;
  readonly to: Scalars['DateTime'];
};

/** Credit statistics for credits group */
export type TStatisticsCredits = {
  readonly __typename?: 'StatisticsCredits';
  readonly creditWalletActivities: TStatisticsWalletActivities;
};

/** Statistics of all credit activities excluding credits topped up or paid during speedlopay events. */
export type TStatisticsWalletActivities = {
  readonly __typename?: 'StatisticsWalletActivities';
  readonly availableOrderRewardsSum: TPriceConverted;
  readonly expiredOrderRewardsSum: TPriceConverted;
  readonly orderPaymentsSum: TPriceConverted;
  readonly orderRewardsSum: TPriceConverted;
};

export type TInputFeeStatistics = {
  readonly branches: ReadonlyArray<Scalars['ID']>;
  readonly country?: InputMaybe<TCountryEnum>;
  readonly months: ReadonlyArray<TMonthAndYear>;
  readonly operatingCostTypes?: InputMaybe<ReadonlyArray<TOperatingCostTypeEnum>>;
  readonly orderOrigins?: InputMaybe<ReadonlyArray<TOrderOriginEnum>>;
};

/** Representation of month in the year */
export type TMonthAndYear = {
  readonly month?: InputMaybe<Scalars['Int']>;
  readonly year?: InputMaybe<Scalars['Int']>;
};

/** Fees for specified branches */
export type TStatisticsForFees = {
  readonly __typename?: 'StatisticsForFees';
  readonly commission: TPriceConverted;
  readonly commissionAfterLimit: TPriceConverted;
  readonly commissionLimit: TPriceConverted;
  readonly companyBranch: TCompanyBranch;
  readonly deliveries: TPriceConverted;
  readonly minimumPayment: TPriceConverted;
  readonly minimumPaymentSurcharge: TPriceConverted;
  readonly month: Scalars['Date'];
  readonly notifications: TPriceConverted;
  readonly paymentGates: TPriceConverted;
  readonly speedloServices: TPriceConverted;
  readonly total: TPriceConverted;
  readonly totalWithVat: TPriceConverted;
  readonly vat: Scalars['Float'];
};

/** Operating costs summarization */
export type TStatisticsForOperatingCosts = {
  readonly __typename?: 'StatisticsForOperatingCosts';
  readonly companyBranch: TCompanyBranch;
  readonly date: Scalars['Date'];
  readonly operatingCostFrequencyType: TOperatingCostFrequencyType;
  readonly operatingCostSetting: Maybe<TOperatingCostSetting>;
  readonly orderOrigin: Maybe<TOrderOrigin>;
  readonly timePrecision: TTimePrecisionTypeEnum;
  readonly totalAbsoluteSum: TPriceConverted;
  readonly totalCount: Scalars['Int'];
  readonly totalPercentageSum: TPriceConverted;
  readonly totalRecordValueSum: TPriceConverted;
};

/** Possible time precision types */
export type TTimePrecisionTypeEnum =
  | 'DAY'
  | 'MONTH'
  | 'YEAR';

/** Calculate total amount from online and normal payments */
export type TStatisticsForPayments = {
  readonly __typename?: 'StatisticsForPayments';
  readonly collectedServiceFees: TPriceConverted;
  readonly postPaidOrderCount: Scalars['Int'];
  readonly postPaidTurnover: TPriceConverted;
  readonly prePaidOrderCount: Scalars['Int'];
  readonly prePaidTurnover: TPriceConverted;
  readonly valueHoldBySpeedlo: TPriceConverted;
};

/**
 * Keeps information about stock inventories
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, gastra_api, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, gastra_api, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, gastra_api, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, gastra_api, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TStockInventory = {
  readonly __typename?: 'StockInventory';
  readonly companyBranch: TCompanyBranch;
  /** time when stock inventory was initialized */
  readonly createdAt: Scalars['DateTime'];
  /** time when stock inventory was finished */
  readonly finishedAt: Maybe<Scalars['DateTime']>;
  readonly id: Scalars['ID'];
  /** stock intentory items */
  readonly items: ReadonlyArray<TStockInventoryItem>;
  /** user note */
  readonly note: Maybe<Scalars['String']>;
  readonly user: TUser;
};

/**
 * Keeps information about stock inventory items
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, gastra_api, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, gastra_api, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, gastra_api, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TStockInventoryItem = {
  readonly __typename?: 'StockInventoryItem';
  readonly finalQuantity: Maybe<Scalars['Float']>;
  readonly id: Scalars['ID'];
  readonly originalQuantity: Scalars['Float'];
  readonly stockInventory: TStockInventory;
  readonly stockInventoryItemChangeType: Maybe<TStockInventoryItemChangeType>;
  readonly stockItem: TStockItem;
  readonly stockItemChangeType: Maybe<TStockItemChangeType>;
};

/** Possible StockInventoryItemChangeType types */
export type TStockInventoryItemChangeType = {
  readonly __typename?: 'StockInventoryItemChangeType';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TStockInventoryItemChangeTypeEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** Possible StockInventoryItem change types */
export type TStockInventoryItemChangeTypeEnum =
  | 'DAMAGE'
  | 'EXPIRED'
  | 'SOLD_OUTSIDE_SYSTEM'
  | 'STOCK_CANCEL'
  | 'STOCK_DOWN'
  | 'STOCK_RETURN'
  | 'STOCK_TRANSFER'
  | 'STOCK_UP'
  | 'STOLEN'
  | 'TASTING';

/**
 * Possible StockItemChangeType types
 *
 *
 * INDEX: [admin, gastra_api, super_admin, support, user]
 *
 * READ: [admin, gastra_api, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TStockItemChangeType = {
  readonly __typename?: 'StockItemChangeType';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TStockItemChangeTypeEnum;
  readonly id: Scalars['ID'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** StockItemChangeType enum */
export type TStockItemChangeTypeEnum =
  | 'DAMAGE'
  | 'EXPIRED'
  | 'SOLD_OUTSIDE_SYSTEM'
  | 'STOCK_CANCEL'
  | 'STOCK_DOWN'
  | 'STOCK_RETURN'
  | 'STOCK_SALE'
  | 'STOCK_TRANSFER'
  | 'STOCK_UP'
  | 'STOLEN'
  | 'TASTING';

/**
 * Possible StornoRequestType types
 *
 *
 * INDEX: [admin, super_admin, support, user]
 *
 * READ: [admin, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TStornoRequestType = {
  readonly __typename?: 'StornoRequestType';
  readonly code: Scalars['String'];
  /** enum string used to identify object */
  readonly enum: TStornoRequestTypeEnum;
  readonly id: Scalars['ID'];
  readonly needComment: Scalars['Boolean'];
  /** not localized code */
  readonly rawCode: Scalars['String'];
};

/** StornoRequestType enum */
export type TStornoRequestTypeEnum =
  | 'CLOSED'
  | 'CUSTOMER_STORNED'
  | 'CUSTOMER_UNAVAILABLE'
  | 'DUPLICATE'
  | 'MISTAKE_IN_ORDER'
  | 'OTHER'
  | 'TECHNICAL_DIFFICULTIES'
  | 'THIRD_PARTY';

export type TInputGeoPointCreate = {
  readonly latitude: Scalars['Float'];
  readonly longitude: Scalars['Float'];
};

/**
 * The data we got from the terminal after the transaction
 *
 *
 * INDEX: [admin, cashier, editor_wallet_credits, super_admin, support]
 *
 * READ: [admin, cashier, editor_wallet_credits, super_admin, support]
 *
 * CREATE: [admin, cashier, editor_wallet_credits, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TTerminalTransactionRecord = {
  readonly __typename?: 'TerminalTransactionRecord';
  readonly creditsFundsTransfer: Maybe<TCreditsFundsTransfer>;
  readonly data: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly isRefund: Scalars['Boolean'];
  readonly isSuccess: Scalars['Boolean'];
  readonly order: Maybe<TOrder>;
};

/** Information about user calling customer */
export type TUserCustomerCalling = {
  readonly __typename?: 'UserCustomerCalling';
  /** ID of created event */
  readonly eventId: Scalars['ID'];
  /** Indicator of call activity */
  readonly isRinging: Scalars['Boolean'];
  /** phone of caller */
  readonly phone: Scalars['String'];
  /** country code */
  readonly prefix: Scalars['String'];
};

/** Possible information for customer */
export type TCustomerInformation = {
  readonly __typename?: 'CustomerInformation';
  readonly customer: Maybe<TCustomer>;
  readonly email: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly isFound: Scalars['Boolean'];
  readonly lastName: Scalars['String'];
  readonly lastOrder: Maybe<TOrder>;
  readonly locations: ReadonlyArray<TJsonAddress>;
  readonly phone: Scalars['String'];
};


/** Possible information for customer */
export type TCustomerInformationLocationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type TInputVamStatus = {
  readonly email?: InputMaybe<Scalars['String']>;
  readonly firstname?: InputMaybe<Scalars['String']>;
  readonly lastname?: InputMaybe<Scalars['String']>;
  readonly orderId: Scalars['ID'];
  readonly phone?: InputMaybe<Scalars['String']>;
  readonly user?: InputMaybe<Scalars['ID']>;
};

/**
 * These arguments are used to filter ware categories based on
 *         their suitability for recipes.
 */
export type TInputRecipeFilterType = {
  readonly enabled?: InputMaybe<Scalars['Boolean']>;
  readonly isAvailable?: InputMaybe<Scalars['Boolean']>;
  readonly isAvailableAt?: InputMaybe<Scalars['DateTime']>;
  /**
   * OrderOriginCategory which has to be enabled. Use only with isAvailable argument.
   *           Ignored if argument is used in resolver call, cause it has higher priority.
   */
  readonly orderOriginCategory?: InputMaybe<TOrderOriginCategoryEnum>;
};

/** The mutation root of this schema */
export type TMutation = {
  readonly __typename?: 'Mutation';
  /**
   * Accept order from Bolt
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, cashier_cancel, customer, driver, editor_order_state_relation, guest, operator, owner_cancel, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly acceptBoltOrder: TOrder;
  /**
   * Accept order from foodora
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, cashier_cancel, customer, driver, editor_order_state_relation, guest, operator, owner_cancel, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly acceptFoodoraOrder: TOrder;
  /**
   * Accept order from Jídlo pod nos
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, cashier_cancel, customer, driver, editor_order_state_relation, guest, operator, owner_cancel, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly acceptJidloPodNosOrder: TOrder;
  /**
   * Accept order from Wolt
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, cashier_cancel, customer, driver, editor_order_state_relation, guest, operator, owner_cancel, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly acceptWoltOrder: TOrder;
  /**
   * Acknowledge that user seen rejected status of external delivery and unassign driver
   *
   * ALLOWED ROLES: [admin, editor_order, operator, request_external_driver, super_admin]
   *
   */
  readonly acknowledgeExternalDelivery: Maybe<TExternalDelivery>;
  /**
   * Add new allergen to recipe
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_stock_item_allergen, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly addAllergenStockItem: TStockItem;
  /**
   * Add pending wallet credit payment
   *
   * ALLOWED ROLES: [admin, cashier_pos, customer, super_admin]
   *
   */
  readonly addCreditsPayment: TCreditsPaymentAdd;
  /**
   * Create order group record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly addItemToOrderGroup: TOrderGroup;
  /**
   * Assign promo code to order
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly addOrderPromoCode: TOrderWithErrors;
  /**
   * Add new order state to order
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, cashier_cancel, customer, driver, editor_order_state_relation, guest, operator, owner_cancel, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly addOrderState: TOrder;
  /**
   * Create business hour record for specific date
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_business_hour, editor_business_hours, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly addSpecialBusinessHour: TBusinessHour;
  /**
   * Close company branch for specific amount of time
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_business_hour, editor_business_hours, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly addSpecialClosingBusinessHours: TCompanyBranch;
  /**
   * Adjust order pickup time for foodora delivery order
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly adjustFoodoraOrderPickupTime: TOrder;
  /**
   * Reset online state on orders where payment was initiated through Adyen
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly adyenOrderOnlineStateReset: TOrder;
  /**
   * Call Adyens payments API and return response
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly adyenPaymentCreate: TAdyenPaymentResponse;
  /**
   * Call Adyens payment details API and return response
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly adyenPaymentDetailsCreate: TAdyenPaymentDetailsResponse;
  /**
   * Call Adyens payment methods API and return its response
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly adyenPaymentMethods: TAdyenPaymentMethodResponse;
  /**
   * Batch update recipe price records
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_recipe_price, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly batchUpdateRecipePrices: ReadonlyArray<TRecipePrice>;
  /**
   * Update InAppNotification records
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly bulkUpdateInAppNotifications: ReadonlyArray<TInAppNotification>;
  /**
   * Reject order from Bolt
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_order, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly cancelBoltOrder: TOrder;
  /**
   * Reject order from foodora
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_order, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly cancelFoodoraOrder: TOrder;
  /**
   * Cancel order from Jídlo pod nos
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_order, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly cancelJidloPodNosOrder: TOrder;
  /**
   * Cancel multiple orders in one request
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, cashier_cancel, customer, driver, editor_order_state_relation, guest, operator, owner_cancel, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly cancelOrders: TOrdersBulkCanceledResult;
  /**
   * Reject order from Wolt
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_order, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly cancelWoltOrder: TOrder;
  /**
   * Login user to appropriate cash box
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_cash_box, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly cashBoxLogin: TCashBox;
  /**
   * Logout user from appropriate cash box
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_cash_box, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly cashBoxLogout: TCashBox;
  /**
   * Login user to appropriate cash box
   *
   * ALLOWED ROLES: [admin, cashier, editor_cash_box, super_admin]
   *
   */
  readonly cashBoxLogTerminalEvent: Scalars['Boolean'];
  /**
   * Change amount of stock item by defined offset (add or remove)
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_stock_item, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly changeAmountStockItem: TStockItem;
  /**
   * Confirm stock item transfer
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_stock_transfer, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly confirmStockItemTransfer: TStockTransfer;
  /**
   * Request a login link to the consents manager app
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_user, guest, super_admin, supervisor, user]
   *
   */
  readonly consentsAppLink: Scalars['String'];
  /**
   * Create address record for current user
   *
   * ALLOWED ROLES: [admin, customer, editor_address, super_admin, support]
   *
   */
  readonly createAddress: TAddress;
  /**
   * Board create
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createBoard: TBoard;
  /**
   * Board screen create
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createBoardScreen: TBoardScreen;
  /**
   * Create business hour records
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_business_hour, editor_business_hours, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createBusinessHours: ReadonlyArray<TBusinessHour>;
  /**
   * Create company record
   *
   * ALLOWED ROLES: [admin, editor_company, super_admin, support]
   *
   */
  readonly createCompany: TCompany;
  /**
   * Create company branch record
   *
   * ALLOWED ROLES: [admin, editor_company_branch, super_admin, support]
   *
   */
  readonly createCompanyBranch: TCompanyBranch;
  /**
   * Create new popup message for company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createCompanyBranchPopup: ReadonlyArray<TPopup>;
  /**
   * Create binding printer to company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createCompanyBranchPrinter: TCompanyBranchPrinter;
  /**
   * Create printer trigger for company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createCompanyBranchTrigger: TCompanyBranchTrigger;
  /**
   * Create printer to trigger association for company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createCompanyBranchTriggerPrinter: TCompanyBranchTriggerPrinter;
  /**
   * Create connection between user and specific company branch or enable existing connection
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_company_branch_user, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createCompanyBranchUser: TUser;
  /**
   * Create new popup message for brand
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_company, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createCompanyPopup: ReadonlyArray<TPopup>;
  /**
   * Create consent assigned to order
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support]
   *
   */
  readonly createConsentOrder: TOrder;
  /**
   * Create currency record
   *
   * ALLOWED ROLES: [admin, editor_currency, super_admin, support]
   *
   */
  readonly createCurrency: TCurrency;
  /**
   * Create delivery order record
   *
   * ALLOWED ROLES: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
   *
   */
  readonly createDeliveryOrder: TOrder;
  /**
   * Create Express Delivery Setting
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, super_admin, supervisor, support]
   *
   */
  readonly createExpressDeliverySetting: TExpressDeliverySetting;
  /**
   * Create external delivery request for order
   *
   * ALLOWED ROLES: [admin, editor_order, operator, request_external_driver, super_admin]
   *
   */
  readonly createExternalDelivery: Maybe<Scalars['String']>;
  /**
   * Create order record for external service
   *
   * ALLOWED ROLES: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
   *
   */
  readonly createExternalOrder: TCreatedExternalOrderType;
  /**
   * Create financial report for specified object.
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_reports, editor_financial_report, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createFinancialReport: TFinancialReport;
  /**
   * Create ingredient record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_ingredient, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createIngredient: TIngredient;
  /**
   * Create a new Integrations ProfileWareCategory
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, super_admin, supervisor, support]
   *
   */
  readonly createIntegrationsProfileWareCategory: TIntegrationsProfileWareCategory;
  /**
   * Create order record for kiosk
   *
   * ALLOWED ROLES: [admin, cashier, cashier_kiosk, editor_order, operator, super_admin]
   *
   */
  readonly createKioskOrder: TOrder;
  /**
   * Create Label with defined translations
   *
   * ALLOWED ROLES: [admin, editor_label, super_admin, support]
   *
   */
  readonly createLabel: TLabel;
  /**
   * Create occasion
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createOccasion: TOccasion;
  /**
   * Create order record
   *
   * ALLOWED ROLES: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
   *
   */
  readonly createOrder: TOrder;
  /**
   * Create order group record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createOrderGroup: TOrderGroup;
  /**
   * Create payment record for order
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_order_payment_method, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createOrderPaymentMethod: TOrder;
  /**
   * Update default delivery or pickup time of company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, super_admin, supervisor, support]
   *
   */
  readonly createOrderProcessTime: TCompanyBranch;
  /**
   * Create rating for order
   *
   * ALLOWED ROLES: [admin, cashier, customer, editor_order, guest, operator, super_admin]
   *
   */
  readonly createOrderRating: TOrder;
  /**
   * Create order recipe record (new item of order)
   *
   * ALLOWED ROLES: [admin, cashier, customer, editor_order_recipe, guest, operator, super_admin, support]
   *
   */
  readonly createOrderRecipe: TOrder;
  /**
   * Create pickup order record
   *
   * ALLOWED ROLES: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
   *
   */
  readonly createPickupOrder: TOrder;
  /**
   * Printer create
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createPrinter: TPrinter;
  /**
   * Reprint
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createPrintQueue: Maybe<TPrintQueue>;
  /**
   * Create promo banner
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, merchant, super_admin, supervisor, support]
   *
   */
  readonly createPromoBanner: TPromoBanner;
  /**
   * Create recipe record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createRecipe: TRecipe;
  /**
   * Create recipe price record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_recipe_price, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createRecipePrice: TRecipe;
  /**
   * Create recipe relation record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_recipe_relation, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createRecipeRelation: TRecipeRelation;
  /**
   * Create a RecipeTag record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, super_admin, supervisor, support]
   *
   */
  readonly createRecipeTag: TRecipeTag;
  /**
   * Create new registered user
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_user, guest, super_admin, supervisor]
   *
   */
  readonly createRegisteredUser: Scalars['ID'];
  /**
   * Print the financial report from the kiosk
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createReportPrintQueue: Maybe<TPrintQueue>;
  /**
   * Create sector record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createSector: TSector;
  /**
   * Create sector recipe
   *
   * ALLOWED ROLES: [admin, cashier, super_admin, support]
   *
   */
  readonly createSectorRecipe: ReadonlyArray<TSectorRecipe>;
  /**
   * Create sector recipes in batch.
   *
   * ALLOWED ROLES: [admin, cashier, super_admin, support]
   *
   */
  readonly createSectorRecipes: ReadonlyArray<TSectorRecipe>;
  /**
   * Create shift record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_shift, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createShift: TShift;
  /**
   * Create user shift record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, driver, editor_shift_user, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createShiftUser: TShift;
  /**
   * Create staff order record
   *
   * ALLOWED ROLES: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
   *
   */
  readonly createStaffOrder: TOrder;
  /**
   * Create stock inventory
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, gastra_api, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createStockInventory: TStockInventory;
  /**
   * Create stock item
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_stock_item, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createStockItem: TStockItem;
  /**
   * Create stock item transfer
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_stock_transfer, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createStockItemTransfer: TStockTransfer;
  /**
   * Create batch of stock item transfers that are immediately confirmed
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_stock_transfer, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createStockItemTransfers: ReadonlyArray<TStockItem>;
  /**
   * Create financial report from the terminal.
   *
   * ALLOWED ROLES: [admin, cashier_kiosk, cashier_reports, super_admin, support]
   *
   */
  readonly createTerminalFinancialReport: TTerminalFinancialReport;
  /**
   * Create terminal transaction record
   *
   * ALLOWED ROLES: [admin, cashier, editor_wallet_credits, super_admin, support]
   *
   */
  readonly createTerminalTransactionRecord: TTerminalTransactionRecord;
  /**
   * Create transportation device record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_transportation_device, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createTransportationDevice: TTransportationDevice;
  /**
   * Assign user and transportation device
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, driver, editor_transportation_device_user, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createTransportationDeviceUser: TTransportationDeviceUser;
  /**
   * Create new user
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support]
   *
   */
  readonly createUser: TUser;
  /**
   * Assign user that will deliver order
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_delivery, driver, editor_user_delivering_order, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createUserDeliveringOrder: TUserDeliveringOrder;
  /**
   * Assign user that will deliver order
   *
   * ALLOWED ROLES: [admin, cashier_delivery, driver, super_admin, support]
   *
   */
  readonly createUserDelivery: TUserDelivery;
  /**
   * Create voucher and send it to user by SMS. Maximum length is 160 characters. It is possible to use `code` keyword wrapped by two curly brackets.
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_promo_code, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createUserVoucher: TPromoCode;
  /**
   * Create order record for virtual cash box
   *
   * ALLOWED ROLES: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
   *
   */
  readonly createVirtualCashBoxOrder: TOrder;
  /**
   * Create ware record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_ware, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createWare: TWare;
  /**
   * Create ware category record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_ware_category, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createWareCategory: TWareCategory;
  /**
   * Create new ware category color with appropriate code
   *
   * ALLOWED ROLES: [admin, super_admin, support]
   *
   */
  readonly createWareCategoryColor: TWareCategoryColor;
  /**
   * Create ware relation to specific ware category (subcategory is defined by ware category type)
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_ware_category_relation, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createWareCategoryRelation: TWareCategoryRelation;
  /**
   * Create wifi order record
   *
   * ALLOWED ROLES: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
   *
   */
  readonly createWifiOrder: TOrder;
  /**
   * Create a new Wolt Profile
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, super_admin, supervisor, support]
   *
   */
  readonly createWoltProfile: TWoltProfile;
  /**
   * Create new zone
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createZone: TZone;
  /**
   * Create new zone color with appropriate code
   *
   * ALLOWED ROLES: [admin, super_admin, support]
   *
   */
  readonly createZoneColor: TZoneColor;
  /**
   * Create a gift wallet activity and conditionally send a notification text message
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_company_branch, merchant, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly creditsCreateGift: TCreditsWalletActivity;
  /**
   * Create a funds transfer
   *
   * ALLOWED ROLES: [admin, editor_wallet_credits, editor_wallet_credits_refund, super_admin, support]
   *
   */
  readonly creditsFundsTransferCreate: TCreditsFundsTransfer;
  /**
   * Update state of a funds transfer
   *
   * ALLOWED ROLES: [admin, editor_wallet_credits, editor_wallet_credits_refund, super_admin, support]
   *
   */
  readonly creditsFundsTransferUpdateState: TCreditsFundsTransfer;
  /**
   * Request a wallet credits refund
   *
   * ALLOWED ROLES: [admin, editor_wallet_credits_refund, guest, super_admin]
   *
   */
  readonly creditsRequestRefund: TCreditsWallet;
  /**
   * Destroy address
   *
   * ALLOWED ROLES: [admin, customer, editor_address, super_admin]
   *
   */
  readonly destroyAddress: TAddress;
  /**
   * Board destroy
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyBoard: TBoard;
  /**
   * Board screen destroy
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyBoardScreen: TBoardScreen;
  /**
   * Destroy business hour record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_business_hour, editor_business_hours, merchant, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyBusinessHour: TBusinessHour;
  /**
   * Delete current company branch popup messages for given origins
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly destroyCompanyBranchPopup: ReadonlyArray<TPopup>;
  /**
   * Destroy binding printer to company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyCompanyBranchPrinter: TCompanyBranchPrinter;
  /**
   * Destroy trigger for company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyCompanyBranchTrigger: TCompanyBranchTrigger;
  /**
   * Destroy printer to trigger assign
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyCompanyBranchTriggerPrinter: TCompanyBranchTriggerPrinter;
  /**
   * Destroy connection between user and specific company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_company_branch_user, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyCompanyBranchUser: TUser;
  /**
   * Delete current company popup messages for given origins
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_company, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly destroyCompanyPopup: ReadonlyArray<TPopup>;
  /**
   * Destroy consent assigned to order
   *
   * ALLOWED ROLES: [admin, guest, super_admin]
   *
   */
  readonly destroyConsentOrder: TOrder;
  /**
   * Destroy ingredient record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_ingredient, gastra_api, merchant, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyIngredient: TIngredient;
  /**
   * Destroy ware category record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, super_admin, supervisor]
   *
   */
  readonly destroyIntegrationsProfileWareCategory: Scalars['Boolean'];
  /**
   * Destroy multiple order recipe record
   *
   * ALLOWED ROLES: [admin, cashier, customer, editor_order_recipe, guest, operator, super_admin]
   *
   */
  readonly destroyMultipleOrderRecipes: TOrder;
  /**
   * Destroy occasion
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyOccasion: TOccasion;
  /**
   * Destroy payment record for order
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_order_payment_method, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyOrderPaymentMethod: TOrder;
  /**
   * Destroy updating default delivery or pickup time of company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, super_admin, supervisor, support]
   *
   */
  readonly destroyOrderProcessTime: TCompanyBranch;
  /**
   * Destroy order recipe record
   *
   * ALLOWED ROLES: [admin, cashier, customer, editor_order_recipe, guest, operator, super_admin]
   *
   */
  readonly destroyOrderRecipe: TOrder;
  /**
   * Destroy same recipes of one order
   *
   * ALLOWED ROLES: [admin, cashier, customer, editor_order_recipe, guest, operator, super_admin]
   *
   */
  readonly destroyOrderRecipes: TOrder;
  /**
   * Printer destroy
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyPrinter: TPrinter;
  /**
   * Destroy promo banner record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, merchant, super_admin, supervisor]
   *
   */
  readonly destroyPromoBanner: TPromoBanner;
  /**
   * Destroy recipe record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyRecipe: TRecipe;
  /**
   * Destroy recipe relation record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_recipe_relation, merchant, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyRecipeRelation: TRecipe;
  /**
   * Destroy a RecipeTag record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, super_admin, supervisor]
   *
   */
  readonly destroyRecipeTag: TRecipeTag;
  /**
   * Destroy sector record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly destroySector: TSector;
  /**
   * Destroy sector recipe
   *
   * ALLOWED ROLES: [admin, cashier, super_admin]
   *
   */
  readonly destroySectorRecipe: TSector;
  /**
   * Destroy shift record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_shift, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyShift: TShift;
  /**
   * Destroy stock inventory record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyStockInventory: TStockInventory;
  /**
   * Destroy stock item record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_stock_item, gastra_api, merchant, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyStockItem: TStockItem;
  /**
   * Destroy stock item transfer
   *
   * ALLOWED ROLES: [admin, editor_stock_transfer, operator, super_admin]
   *
   */
  readonly destroyStockItemTransfer: TStockTransfer;
  /**
   * Remove assignation of user and transportation device
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, driver, editor_transportation_device_user, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly destroyTransportationDeviceUser: TTransportationDeviceUser;
  /**
   * Destroy the current user
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
   *
   */
  readonly destroyUser: Scalars['Boolean'];
  /**
   * Remove user that will assign user
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_delivery, driver, editor_user_delivering_order, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyUserDeliveringOrder: TUserDeliveringOrder;
  /**
   * Destroy ware category record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_ware_category, gastra_api, merchant, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyWareCategory: TWareCategory;
  /**
   * Remove ware from defined subcategory of appropriate ware category
   *
   * ALLOWED ROLES: [admin, editor_ware_category_relation, operator, super_admin]
   *
   */
  readonly destroyWareCategoryRelation: TWareCategoryRelation;
  /**
   * Destroy zone
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_zone, merchant, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyZone: TZone;
  /**
   * Create a background customer export.
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_company_branch, export_customers, super_admin, supervisor]
   *
   */
  readonly exportCustomers: TCustomerExport;
  /**
   * Mark order as finished by external service
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly finishExternalOrder: TOrder;
  /**
   * Mark order as finished
   *
   * ALLOWED ROLES: [admin, cashier, editor_order, operator, super_admin]
   *
   */
  readonly finishKioskOrder: TFinishedOrder;
  /**
   * Mark order as finished
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly finishOrder: TFinishedOrder;
  /**
   * Mark order as finished by staff
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly finishStaffOrder: TOrder;
  /**
   * Finish stock inventory
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, gastra_api, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly finishStockInventory: TStockInventory;
  /**
   * Mark order as finished
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly finishVirtualCashBoxOrder: TFinishedOrder;
  /**
   * Fetch availability state of foodora profile from foodora API
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_business_hours, editor_integrations, editor_menu, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly foodoraProfileStatus: TFoodoraProfile;
  /**
   * Create staff order record
   *
   * ALLOWED ROLES: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
   *
   */
  readonly importOrders: ReadonlyArray<TImportedOrder>;
  /**
   * Login user to appropriate cash box
   *
   * ALLOWED ROLES: [admin, cashier, editor_cash_box, super_admin]
   *
   */
  readonly logKioskEvent: Scalars['Boolean'];
  /**
   * Logout the current User
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
   *
   */
  readonly logoutUser: Maybe<Scalars['Boolean']>;
  /**
   * Send notification to user that his/her order is prepared
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_order, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly orderNotifyCustomer: TOrder;
  /**
   * Pause Express Delivery
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, super_admin, supervisor]
   *
   */
  readonly pauseExpressDelivery: TExpressDeliverySetting;
  /**
   * Run synchronize process with Pohoda
   *
   * ALLOWED ROLES: [admin, branch_owner, super_admin]
   *
   */
  readonly pohodaExportPlan: TPohodaExportPlanType;
  /**
   * Push menu to Bolt
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, super_admin, supervisor, support]
   *
   */
  readonly pushBoltMenu: TBoltProfile;
  /**
   * Push menu to Foodora
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, super_admin, supervisor, support]
   *
   */
  readonly pushFoodoraMenu: TFoodoraProfile;
  /**
   * Push integration profile business hours to external integration (replaces all existing ones)
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_business_hours, editor_integrations, super_admin, supervisor, support]
   *
   */
  readonly pushIntegrationsBusinessHours: ReadonlyArray<TIntegrationsBusinessHour>;
  /**
   * Push menu to JidloPodNos
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, super_admin, supervisor, support]
   *
   */
  readonly pushJidloPodNosMenu: TJidloPodNosProfile;
  /**
   * Push menu to Wolt
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, super_admin, supervisor, support]
   *
   */
  readonly pushWoltMenu: TWoltProfile;
  /**
   * Accept rejection of stock item transfer
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_stock_transfer, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly rejectionAcceptedStockItemTransfer: TStockTransfer;
  /**
   * Reject stock item transfer
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_stock_transfer, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly rejectStockItemTransfer: TStockTransfer;
  /**
   * Remove allergen for defined recipe
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_stock_item_allergen, sales_representative, super_admin, supervisor]
   *
   */
  readonly removeAllergenStockItem: TStockItem;
  /**
   * Remove driver from all orders of order group
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly removeDriverFromOrderGroup: TOrderGroup;
  /**
   * Create order group record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly removeItemFromOrderGroup: Maybe<TOrderGroup>;
  /**
   * Remove promo code from order
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, guest, merchant, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly removeOrderPromoCode: TOrder;
  /**
   * Remove order state for defined order
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, editor_order_state_relation, guest, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly removeOrderState: TOrder;
  /**
   * Replay an integration activity
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_menu, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly replayIntegrationsActivity: TReplayActivityResult;
  /**
   * Send order cancel request to support
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_order, operator, request_cancel, sales_representative, super_admin, supervisor]
   *
   */
  readonly requestCancelOrder: TOrder;
  /**
   * Request sending confirmation code for given phone number
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly requestEmailConfirmationCode: TRequestEmailConfirmationCode;
  /**
   * Request sending confirmation code for given phone number
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly requestPhoneConfirmationCode: TRequestPhoneConfirmationCode;
  /**
   * Resend EET Receipt if previous attempt end with error
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_order, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly resendEETReceipt: TOrder;
  /**
   * Resolve an integration activity
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_menu, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly resolveIntegrationsActivity: TIntegrationsActivity;
  /**
   * Change priority of order
   *
   * ALLOWED ROLES: [admin, cashier, editor_order, operator, super_admin]
   *
   */
  readonly setPriorityOrder: TOrder;
  /**
   * Send storno EET Receipt for order
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_order, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly stornoEETReceipt: TOrder;
  /**
   * Suspends user and sends password reset email
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support, user]
   *
   */
  readonly suspendUser: TUser;
  /**
   * Transfer order to different CompanyBranch
   *
   * ALLOWED ROLES: [admin, cashier_transfer_company_branch, editor_order, operator, super_admin]
   *
   */
  readonly transferOrder: TOrder;
  /**
   * Update address record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, customer, editor_address, operator, sales_representative, super_admin, supervisor, support, user]
   *
   */
  readonly updateAddress: TAddress;
  /**
   * Update allowed delivery types for a company branch.
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_allowed_delivery_types, editor_company_branch, super_admin, supervisor, support]
   *
   */
  readonly updateAllowedDeliveryTypes: TCompanyBranch;
  /**
   * Board update
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateBoard: TBoard;
  /**
   * Board screen update
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateBoardScreen: TBoardScreen;
  /**
   * Update Bolt profile availability state
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_integrations, super_admin, supervisor, support]
   *
   */
  readonly updateBoltAvailabilityState: TBoltProfile;
  /**
   * Update a Bolt Profile
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_integrations, super_admin, supervisor, support]
   *
   */
  readonly updateBoltProfile: TBoltProfile;
  /**
   * Update current company branch popup message
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateCompanyBranchPopup: TPopup;
  /**
   * Update company branch specific recipe data
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_basic_recipes, editor_menu, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateCompanyBranchRecipe: TRecipe;
  /**
   * Create printer trigger for company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateCompanyBranchTrigger: TCompanyBranchTrigger;
  /**
   * Update connection between user and specific company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_company_branch_user, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateCompanyBranchUser: TCompanyBranchUser;
  /**
   * Update company branch specific recipe data
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateCompanyBranchWareCategory: TWareCategory;
  /**
   * Update current company popup message
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_company, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateCompanyPopup: TPopup;
  /**
   * Update exchange rate of defined currency
   *
   * ALLOWED ROLES: [admin, editor_currency, super_admin, support]
   *
   */
  readonly updateCurrencyExchangeRate: TCurrency;
  /**
   * Update default delivery time of company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_process_time, editor_company_branch, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateDefaultDeliveryTime: TCompanyBranch;
  /**
   * Update default order process time of company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_process_time, editor_company_branch, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateDefaultOrderProcessTime: TCompanyBranch;
  /**
   * Update a Dotykacka Profile
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_integrations, super_admin, supervisor, support]
   *
   */
  readonly updateDotykackaProfile: TDotykackaProfile;
  /**
   * Update Express Delivery Setting
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, super_admin, supervisor, support]
   *
   */
  readonly updateExpressDeliverySetting: TExpressDeliverySetting;
  /**
   * Update foodora profile availability state
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_integrations, super_admin, supervisor, support]
   *
   */
  readonly updateFoodoraAvailabilityState: TFoodoraProfile;
  /**
   * Update a Foodora Profile
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_integrations, super_admin, supervisor, support]
   *
   */
  readonly updateFoodoraProfile: TFoodoraProfile;
  /**
   * Update promo header text of company or company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_setting, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateGraphicHeaders: Maybe<Scalars['Boolean']>;
  /**
   * Update graphic styles of company or company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_setting, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateGraphicStyles: TGraphicStyle;
  /**
   * Update ingredient record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_ingredient, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateIngredient: TIngredient;
  /**
   * Update a new JidloPodNos Profile
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_integrations, super_admin, supervisor, support]
   *
   */
  readonly updateJidloPodNosProfile: TJidloPodNosProfile;
  /**
   * Update occasion
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateOccasion: TOccasion;
  /**
   * Update order record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateOrder: TOrder;
  /**
   * Change received order from DELIVERY to PICKUP
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_change_delivery_type, editor_order, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly updateOrderDeliveryToPickup: TOrder;
  /**
   * Create order group record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateOrderGroup: Maybe<TOrderGroup>;
  /**
   * Change order of orders in order group
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_sorting, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateOrderGroupOrder: Scalars['Boolean'];
  /**
   * Update the OrderOnlineState of a kiosk Order
   *
   * ALLOWED ROLES: [admin, cashier, cashier_kiosk, editor_order, operator, super_admin]
   *
   */
  readonly updateOrderOnlineStateKioskOrder: TOrder;
  /**
   * Update the OrderOnlineState of a pos2 Order
   *
   * ALLOWED ROLES: [admin, cashier, cashier_kiosk, editor_order, operator, super_admin]
   *
   */
  readonly updateOrderOnlineStatePos2: TOrder;
  /**
   * Change payment method of order.
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_payment_methods, driver, editor_order, operator, super_admin, supervisor]
   *
   */
  readonly updateOrderPaymentMethod: TOrder;
  /**
   * Change payment methods of order - allows to pay order by multiple payment methods
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_payment_methods, driver, editor_order, operator, super_admin, supervisor]
   *
   */
  readonly updateOrderPaymentMethods: TOrder;
  /**
   * Prepare preview of order record update. Keep in mind that new changes are stored just in-memory,
   * so digging deep inside GraphQL structure may lead to read of inaccurate data.
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateOrderPreview: ReadonlyArray<TOrderDiffEntry>;
  /**
   * Update order recipe record (item of order)
   *
   * ALLOWED ROLES: [admin, cashier, customer, driver, editor_order_recipe, guest, operator, super_admin, support]
   *
   */
  readonly updateOrderRecipe: TOrder;
  /**
   * Update order recipe record (item of order)
   *
   * ALLOWED ROLES: [admin, cashier, customer, driver, editor_order_recipe, guest, operator, super_admin, support]
   *
   */
  readonly updateOrderRecipeState: TOrderRecipe;
  /**
   * Update order tip. If both absolute and relative values are present, both are applied. If only one is present, the other is updated to zero.
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateOrderTip: TOrder;
  /**
   * Update the User of an Order
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateOrderUser: TOrder;
  /**
   * Printer update
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updatePrinter: TPrinter;
  /**
   * Update printer state
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updatePrinterState: Maybe<Scalars['Boolean']>;
  /**
   * Change print queue state
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updatePrintQueue: TPrintQueue;
  /**
   * Update a print template record
   *
   * ALLOWED ROLES: [admin, super_admin, templatable_manager]
   *
   */
  readonly updatePrintTemplate: TPrintTemplate;
  /**
   * Update promo banner
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, merchant, super_admin, supervisor, support]
   *
   */
  readonly updatePromoBanner: TPromoBanner;
  /**
   * Update recipe record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateRecipe: TRecipe;
  /**
   * Update recipe price record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_recipe_price, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateRecipePrice: TRecipe;
  /**
   * Change order of recipes of ware category
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_sorting, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateRecipesOrder: Scalars['Boolean'];
  /**
   * Update a RecipeTag record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, super_admin, supervisor, support]
   *
   */
  readonly updateRecipeTag: TRecipeTag;
  /**
   * Update sector record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateSector: TSector;
  /**
   * Update sector recipe
   *
   * ALLOWED ROLES: [admin, cashier, super_admin, support]
   *
   */
  readonly updateSectorRecipe: TSectorRecipe;
  /**
   * Update sector recipes
   *
   * ALLOWED ROLES: [admin, cashier, super_admin, support]
   *
   */
  readonly updateSectorRecipes: ReadonlyArray<TSectorRecipe>;
  /**
   * Update shift record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_shift, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateShift: TShift;
  /**
   * Update user shift record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, driver, editor_shift_user, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateShiftUser: TShift;
  /**
   * Change order of ware categories of recipe (side dishes)
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_sorting, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateSideDishesOrder: Scalars['Boolean'];
  /**
   * Update information about stock item
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, gastra_api, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateStockInventoryItem: TStockInventoryItem;
  /**
   * Update information about stock item
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_stock_item, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateStockItem: TStockItem;
  /**
   * Change state of defined transportation device
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_transportation_device, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateTransportationDeviceState: TTransportationDevice;
  /**
   * Update information about users and its transportation device
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, driver, editor_transportation_device_user, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateTransportationDeviceUser: TTransportationDeviceUser;
  /**
   * Update information about user
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, support, user]
   *
   */
  readonly updateUser: TUser;
  /**
   * Remove user that will assign user
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_delivery, driver, editor_user_delivering_order, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateUserDeliveringOrder: TUserDeliveringOrder;
  /**
   * Assign user that will deliver order
   *
   * ALLOWED ROLES: [admin, cashier_delivery, driver, super_admin, support]
   *
   */
  readonly updateUserDelivery: TUserDelivery;
  /**
   * Update information about user
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, suspended_user, user]
   *
   */
  readonly updateUserPassword: TUserUpdatedPassword;
  /**
   * Update ware information
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_ware, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateWare: TWare;
  /**
   * Change order of recipes categories of company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_sorting, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateWareCategoriesOrder: Scalars['Boolean'];
  /**
   * Update ware category record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_ware_category, gastra_api, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateWareCategory: TWareCategory;
  /**
   * Change color of defined ware category color
   *
   * ALLOWED ROLES: [admin, super_admin, support]
   *
   */
  readonly updateWareCategoryColor: TWareCategoryColor;
  /**
   * Update Wolt profile's regular business hours
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_business_hours, editor_integrations, super_admin, supervisor, support]
   *
   */
  readonly updateWoltBusinessHours: TWoltProfile;
  /**
   * Update Wolt profile delivery provider
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_integrations, super_admin, supervisor, support]
   *
   */
  readonly updateWoltDeliveryProvider: TWoltProfile;
  /**
   * Update Wolt profile online state
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_integrations, super_admin, supervisor, support]
   *
   */
  readonly updateWoltOnlineState: TWoltProfile;
  /**
   * Update a new Wolt Profile
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_integrations, super_admin, supervisor, support]
   *
   */
  readonly updateWoltProfile: TWoltProfile;
  /**
   * Update recipe in Wolt
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, super_admin, supervisor, support]
   *
   */
  readonly updateWoltRecipes: TWoltProfile;
  /**
   * Update zone
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateZone: TZone;
  /**
   * Change color of defined zone color
   *
   * ALLOWED ROLES: [admin, super_admin, support]
   *
   */
  readonly updateZoneColor: TZoneColor;
  /**
   * Change order of zones of company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_sorting, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateZonePriority: ReadonlyArray<TZone>;
  /**
   * Create information about calling customer on server.
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_order, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly userNotifyCustomerCalling: TUserCustomerCalling;
  /**
   * Create information about customer call hang-up.
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_order, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly userNotifyCustomerHangup: TUserCustomerHangup;
  /**
   * Confirm current user phone number with given activation code for exports
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_company_branch, export_customers, super_admin, supervisor]
   *
   */
  readonly validateCurrentUserConfirmationCode: Maybe<TCurrentUserValidation>;
  /**
   * Request sending confirmation code for given phone number
   *
   * ALLOWED ROLES: [admin, guest, super_admin, user]
   *
   */
  readonly validateEmailConfirmationCode: TRequestEmailConfirmationCode;
  /**
   * Confirm phone number with given activation code
   *
   * ALLOWED ROLES: [admin, guest, super_admin, user]
   *
   */
  readonly validatePhoneConfirmationCode: Maybe<TPhoneCodeValidation>;
  /**
   * Fetch information about current delivery provider from Wolt API
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_business_hours, editor_integrations, editor_menu, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly woltDeliveryProvider: TWoltDeliveryProvider;
  /**
   * Fetch a Wolt onboarding URL
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_integrations, super_admin, supervisor, support]
   *
   */
  readonly woltOnboardingUrl: TWoltOnboardingUrl;
  /**
   * Fetch information about Wolt profile from Wolt API
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_business_hours, editor_integrations, editor_menu, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly woltProfileStatus: TWoltProfileStatus;
};


/** The mutation root of this schema */
export type TMutationAcceptBoltOrderArgs = {
  delayReason?: InputMaybe<Scalars['String']>;
  deliverAt?: InputMaybe<Scalars['DateTime']>;
  orderId: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationAcceptFoodoraOrderArgs = {
  deliverAt?: InputMaybe<Scalars['DateTime']>;
  orderId: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationAcceptJidloPodNosOrderArgs = {
  deliverAt?: InputMaybe<Scalars['DateTime']>;
  orderId: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationAcceptWoltOrderArgs = {
  deliverAt?: InputMaybe<Scalars['DateTime']>;
  orderId: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationAcknowledgeExternalDeliveryArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationAddAllergenStockItemArgs = {
  allergen: TAllergenEnum;
  stockItem: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationAddCreditsPaymentArgs = {
  amount: Scalars['Float'];
  orderId: Scalars['ID'];
  walletId: Scalars['ID'];
  zeroPaymentValue?: InputMaybe<Scalars['Boolean']>;
};


/** The mutation root of this schema */
export type TMutationAddItemToOrderGroupArgs = {
  order: Scalars['ID'];
  orderGroup: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationAddOrderPromoCodeArgs = {
  order: Scalars['ID'];
  promoCode: Scalars['String'];
};


/** The mutation root of this schema */
export type TMutationAddOrderStateArgs = {
  order: Scalars['ID'];
  orderState: TOrderStateEnum;
  target?: InputMaybe<TOrderStateCategoryTargetEnum>;
};


/** The mutation root of this schema */
export type TMutationAddSpecialBusinessHourArgs = {
  businessHour: TInputBusinessHourSpecificDateCreate;
};


/** The mutation root of this schema */
export type TMutationAddSpecialClosingBusinessHoursArgs = {
  closingSpecification: TInputBusinessHourSpecificCloseCreate;
};


/** The mutation root of this schema */
export type TMutationAdjustFoodoraOrderPickupTimeArgs = {
  orderId: Scalars['ID'];
  pickupAt: Scalars['DateTime'];
};


/** The mutation root of this schema */
export type TMutationAdyenOrderOnlineStateResetArgs = {
  order: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationAdyenPaymentCreateArgs = {
  adyenPayment: TAdyenInputPaymentCreate;
};


/** The mutation root of this schema */
export type TMutationAdyenPaymentDetailsCreateArgs = {
  adyenPaymentDetails: TAdyenInputPaymentDetailsCreate;
};


/** The mutation root of this schema */
export type TMutationAdyenPaymentMethodsArgs = {
  order: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationBatchUpdateRecipePricesArgs = {
  currency: TCurrencyEnum;
  difference: Scalars['Float'];
  recipeIds: ReadonlyArray<Scalars['ID']>;
  warePriceType: TWarePriceTypeEnum;
};


/** The mutation root of this schema */
export type TMutationBulkUpdateInAppNotificationsArgs = {
  ids: ReadonlyArray<Scalars['ID']>;
  isRead: Scalars['Boolean'];
};


/** The mutation root of this schema */
export type TMutationCancelBoltOrderArgs = {
  orderId: Scalars['ID'];
  rejectComment?: InputMaybe<Scalars['String']>;
};


/** The mutation root of this schema */
export type TMutationCancelFoodoraOrderArgs = {
  orderId: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationCancelJidloPodNosOrderArgs = {
  orderId: Scalars['ID'];
  reason: Scalars['String'];
};


/** The mutation root of this schema */
export type TMutationCancelOrdersArgs = {
  ids: ReadonlyArray<Scalars['ID']>;
};


/** The mutation root of this schema */
export type TMutationCancelWoltOrderArgs = {
  orderId: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
};


/** The mutation root of this schema */
export type TMutationCashBoxLoginArgs = {
  cashBox: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationCashBoxLogoutArgs = {
  cashBox: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationCashBoxLogTerminalEventArgs = {
  cashBox: Scalars['ID'];
  events: ReadonlyArray<TInputCashBoxLogTerminalEvent>;
};


/** The mutation root of this schema */
export type TMutationChangeAmountStockItemArgs = {
  amountOffset: Scalars['Float'];
  id: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
};


/** The mutation root of this schema */
export type TMutationConfirmStockItemTransferArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationCreateAddressArgs = {
  address: TInputAddressCreate;
};


/** The mutation root of this schema */
export type TMutationCreateBoardArgs = {
  backgroundImage?: InputMaybe<Scalars['InputFile']>;
  backgroundVideo?: InputMaybe<Scalars['InputFile']>;
  boardScreens?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  boardTemplate: Scalars['ID'];
  colors?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  companyBranch: Scalars['ID'];
  features: TInputBoardFeaturesCreate;
  logo?: InputMaybe<Scalars['InputFile']>;
  name: Scalars['String'];
};


/** The mutation root of this schema */
export type TMutationCreateBoardScreenArgs = {
  backgroundImage?: InputMaybe<Scalars['InputFile']>;
  backgroundVideo?: InputMaybe<Scalars['InputFile']>;
  board: Scalars['ID'];
  name: Scalars['String'];
  wareCategories: ReadonlyArray<Scalars['ID']>;
};


/** The mutation root of this schema */
export type TMutationCreateBusinessHoursArgs = {
  businessHours: ReadonlyArray<TInputBusinessHourCreate>;
  companyBranch: Scalars['ID'];
  mode?: InputMaybe<TBusinessHoursModeEnum>;
};


/** The mutation root of this schema */
export type TMutationCreateCompanyArgs = {
  company: TInputCompanyCreate;
};


/** The mutation root of this schema */
export type TMutationCreateCompanyBranchArgs = {
  company: Scalars['ID'];
  companyBranch: TInputCompanyBranchCreate;
};


/** The mutation root of this schema */
export type TMutationCreateCompanyBranchPopupArgs = {
  id: Scalars['ID'];
  orderOriginCategories: ReadonlyArray<TOrderOriginCategoryEnum>;
  text: Scalars['String'];
};


/** The mutation root of this schema */
export type TMutationCreateCompanyBranchPrinterArgs = {
  companyBranch: Scalars['ID'];
  printer: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationCreateCompanyBranchTriggerArgs = {
  companyBranch: Scalars['ID'];
  templatable?: InputMaybe<Scalars['ID']>;
  triggerConfiguration?: InputMaybe<Scalars['ID']>;
};


/** The mutation root of this schema */
export type TMutationCreateCompanyBranchTriggerPrinterArgs = {
  companyBranchPrinter: Scalars['ID'];
  companyBranchTrigger: Scalars['ID'];
  targetMac: Scalars['String'];
};


/** The mutation root of this schema */
export type TMutationCreateCompanyBranchUserArgs = {
  companyBranch: Scalars['ID'];
  driverSetting?: InputMaybe<TInputCompanyBranchUserDriverSetting>;
  user: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationCreateCompanyPopupArgs = {
  id: Scalars['ID'];
  orderOriginCategories: ReadonlyArray<TOrderOriginCategoryEnum>;
  text: Scalars['String'];
};


/** The mutation root of this schema */
export type TMutationCreateConsentOrderArgs = {
  consentOrder: TInputConsentOrderCreate;
};


/** The mutation root of this schema */
export type TMutationCreateCurrencyArgs = {
  code: Scalars['String'];
  decimalRound?: InputMaybe<Scalars['Int']>;
  exchangeRate: Scalars['Float'];
  promoDecimalRound?: InputMaybe<Scalars['Int']>;
};


/** The mutation root of this schema */
export type TMutationCreateDeliveryOrderArgs = {
  order: TInputOrderDeliveryCreate;
};


/** The mutation root of this schema */
export type TMutationCreateExpressDeliverySettingArgs = {
  setting: TExpressDeliverySettingCreate;
};


/** The mutation root of this schema */
export type TMutationCreateExternalDeliveryArgs = {
  closestPickup?: InputMaybe<Scalars['DateTime']>;
  externalDeliveryProvider: TExternalDeliveryProviderEnum;
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationCreateExternalOrderArgs = {
  inputOrder: TInputExternalOrderCreate;
};


/** The mutation root of this schema */
export type TMutationCreateFinancialReportArgs = {
  cashBoxId?: InputMaybe<Scalars['ID']>;
  companyBranchId: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
};


/** The mutation root of this schema */
export type TMutationCreateIngredientArgs = {
  ingredient: TInputIngredientCreate;
};


/** The mutation root of this schema */
export type TMutationCreateIntegrationsProfileWareCategoryArgs = {
  profileId: Scalars['ID'];
  profileIntegration: TIntegrationEnum;
  wareCategoryId: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationCreateKioskOrderArgs = {
  cashBox: Scalars['ID'];
  order: TInputOrderStaffPosCreate;
};


/** The mutation root of this schema */
export type TMutationCreateLabelArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  translations: ReadonlyArray<TInputLabelTranslation>;
};


/** The mutation root of this schema */
export type TMutationCreateOccasionArgs = {
  occasion: TInputOccasionCreate;
};


/** The mutation root of this schema */
export type TMutationCreateOrderArgs = {
  order: TInputOrderCreate;
};


/** The mutation root of this schema */
export type TMutationCreateOrderGroupArgs = {
  orderGroup: TInputOrderGroupCreate;
};


/** The mutation root of this schema */
export type TMutationCreateOrderPaymentMethodArgs = {
  orderPaymentMethod: TInputOrderPaymentMethodCreate;
};


/** The mutation root of this schema */
export type TMutationCreateOrderProcessTimeArgs = {
  companyBranch: Scalars['ID'];
  deliveryType: TDeliveryTypeEnum;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  processTime: Scalars['Int'];
};


/** The mutation root of this schema */
export type TMutationCreateOrderRatingArgs = {
  id: Scalars['ID'];
  ratings: ReadonlyArray<TInputOrderRatingCreate>;
};


/** The mutation root of this schema */
export type TMutationCreateOrderRecipeArgs = {
  orderRecipe: TInputOrderRecipeCreate;
};


/** The mutation root of this schema */
export type TMutationCreatePickupOrderArgs = {
  order: TInputOrderPickupCreate;
};


/** The mutation root of this schema */
export type TMutationCreatePrinterArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  mac: Scalars['String'];
  name: Scalars['String'];
  printerType: TPrinterTypeEnum;
};


/** The mutation root of this schema */
export type TMutationCreatePrintQueueArgs = {
  printableObject: Scalars['ID'];
  printer: Scalars['ID'];
  targetMac: Scalars['String'];
  template: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationCreatePromoBannerArgs = {
  companyBranchId?: InputMaybe<Scalars['ID']>;
  companyId?: InputMaybe<Scalars['ID']>;
  desktopImage?: InputMaybe<Scalars['InputFile']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  language: TLanguageEnum;
  mobileImage?: InputMaybe<Scalars['InputFile']>;
  position: TPromoBannerPositionEnum;
  promoUrl?: InputMaybe<Scalars['String']>;
  recipeId?: InputMaybe<Scalars['ID']>;
  showDuration?: InputMaybe<Scalars['Int']>;
};


/** The mutation root of this schema */
export type TMutationCreateRecipeArgs = {
  recipe: TInputRecipeCreate;
};


/** The mutation root of this schema */
export type TMutationCreateRecipePriceArgs = {
  recipe: Scalars['ID'];
  recipePrice: TInputRecipePriceCreate;
};


/** The mutation root of this schema */
export type TMutationCreateRecipeRelationArgs = {
  associatedRecipe: Scalars['ID'];
  recipe: Scalars['ID'];
  warePriceType: TWarePriceTypeEnum;
};


/** The mutation root of this schema */
export type TMutationCreateRecipeTagArgs = {
  recipeTag: TInputRecipeTagCreate;
};


/** The mutation root of this schema */
export type TMutationCreateRegisteredUserArgs = {
  user: TInputUserRegisteredCreate;
};


/** The mutation root of this schema */
export type TMutationCreateReportPrintQueueArgs = {
  cashBox: Scalars['ID'];
  content: Scalars['String'];
  printer: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationCreateSectorArgs = {
  sector: TInputSectorCreate;
};


/** The mutation root of this schema */
export type TMutationCreateSectorRecipeArgs = {
  sectorRecipe: TInputSectorRecipeCreate;
};


/** The mutation root of this schema */
export type TMutationCreateSectorRecipesArgs = {
  sectorRecipes: ReadonlyArray<TInputSectorRecipeCreate>;
};


/** The mutation root of this schema */
export type TMutationCreateShiftArgs = {
  shift: TInputShiftCreate;
};


/** The mutation root of this schema */
export type TMutationCreateShiftUserArgs = {
  shift: Scalars['ID'];
  shiftUserState?: InputMaybe<TShiftUserStateEnum>;
  user: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationCreateStaffOrderArgs = {
  cashBox: Scalars['ID'];
  companyBranch?: InputMaybe<Scalars['ID']>;
  deliveryType?: InputMaybe<TDeliveryTypeEnum>;
  orderRecipes?: InputMaybe<ReadonlyArray<TInputOrderRecipeCreates>>;
  sector?: InputMaybe<Scalars['ID']>;
  warePriceType: TWarePriceTypeEnum;
};


/** The mutation root of this schema */
export type TMutationCreateStockInventoryArgs = {
  companyBranch: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationCreateStockItemArgs = {
  stockItem: TInputStockItemCreate;
};


/** The mutation root of this schema */
export type TMutationCreateStockItemTransferArgs = {
  companyBranch: Scalars['ID'];
  quantity: Scalars['Float'];
  stockItem: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationCreateStockItemTransfersArgs = {
  destinationBranchId: Scalars['ID'];
  transfers: ReadonlyArray<TInputStockTransferCreate>;
};


/** The mutation root of this schema */
export type TMutationCreateTerminalFinancialReportArgs = {
  cashBoxId: Scalars['ID'];
  data?: InputMaybe<Scalars['String']>;
  dataGpTerminal?: InputMaybe<Scalars['Json']>;
  financialReportId?: InputMaybe<Scalars['ID']>;
};


/** The mutation root of this schema */
export type TMutationCreateTerminalTransactionRecordArgs = {
  creditsFundsTransferId?: InputMaybe<Scalars['ID']>;
  data?: InputMaybe<Scalars['String']>;
  dataGpTerminal?: InputMaybe<Scalars['Json']>;
  isRefund?: InputMaybe<Scalars['Boolean']>;
  isSuccess: Scalars['Boolean'];
  orderId?: InputMaybe<Scalars['ID']>;
};


/** The mutation root of this schema */
export type TMutationCreateTransportationDeviceArgs = {
  transportationDevice: TInputTransportationDeviceCreate;
};


/** The mutation root of this schema */
export type TMutationCreateTransportationDeviceUserArgs = {
  user?: InputMaybe<Scalars['ID']>;
};


/** The mutation root of this schema */
export type TMutationCreateUserArgs = {
  user: TInputUserCreate;
};


/** The mutation root of this schema */
export type TMutationCreateUserDeliveringOrderArgs = {
  assignmentType?: InputMaybe<TUserDeliveringOrdersAssignmentTypeEnum>;
  automaticOnWay?: InputMaybe<Scalars['Boolean']>;
  order: Scalars['ID'];
  user: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationCreateUserDeliveryArgs = {
  transportationDeviceUser: Scalars['ID'];
  userDeliveringOrders: ReadonlyArray<Scalars['ID']>;
};


/** The mutation root of this schema */
export type TMutationCreateUserVoucherArgs = {
  companyBranch: Scalars['ID'];
  discount: Scalars['Float'];
  message: Scalars['String'];
  phone: Scalars['String'];
  public?: InputMaybe<Scalars['Boolean']>;
  validTill: Scalars['DateTime'];
};


/** The mutation root of this schema */
export type TMutationCreateVirtualCashBoxOrderArgs = {
  order: TInputOrderStaffPosCreate;
};


/** The mutation root of this schema */
export type TMutationCreateWareArgs = {
  ware: TInputWareCreate;
};


/** The mutation root of this schema */
export type TMutationCreateWareCategoryArgs = {
  wareCategory: TInputWareCategoryCreate;
};


/** The mutation root of this schema */
export type TMutationCreateWareCategoryColorArgs = {
  code: Scalars['String'];
  color: Scalars['String'];
};


/** The mutation root of this schema */
export type TMutationCreateWareCategoryRelationArgs = {
  categoryOfWare?: InputMaybe<Scalars['Boolean']>;
  recipe: Scalars['ID'];
  wareCategory: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationCreateWifiOrderArgs = {
  order: TInputOrderWifiCreate;
};


/** The mutation root of this schema */
export type TMutationCreateWoltProfileArgs = {
  profile: TWoltInputProfileCreate;
};


/** The mutation root of this schema */
export type TMutationCreateZoneArgs = {
  zone: TInputZoneCreate;
};


/** The mutation root of this schema */
export type TMutationCreateZoneColorArgs = {
  code: Scalars['String'];
  color: Scalars['String'];
};


/** The mutation root of this schema */
export type TMutationCreditsCreateGiftArgs = {
  amount: Scalars['Float'];
  companyBranchId: Scalars['ID'];
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  message?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationCreditsFundsTransferCreateArgs = {
  amount: Scalars['Float'];
  cashBoxId?: InputMaybe<Scalars['ID']>;
  companyBranchId: Scalars['ID'];
  orderId?: InputMaybe<Scalars['ID']>;
  type: TCreditsFundsTransferTypeEnum;
  walletId?: InputMaybe<Scalars['ID']>;
};


/** The mutation root of this schema */
export type TMutationCreditsFundsTransferUpdateStateArgs = {
  fundsTransferId: Scalars['ID'];
  nfcId?: InputMaybe<Scalars['String']>;
  paymentMethodId?: InputMaybe<Scalars['ID']>;
  state: TCreditsFundsTransferStateEnum;
};


/** The mutation root of this schema */
export type TMutationCreditsRequestRefundArgs = {
  cashBoxId?: InputMaybe<Scalars['ID']>;
  refundInformation?: InputMaybe<TInputRefundRequestType>;
  walletId: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationDestroyAddressArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationDestroyBoardArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationDestroyBoardScreenArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationDestroyBusinessHourArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationDestroyCompanyBranchPopupArgs = {
  id: Scalars['ID'];
  orderOriginCategories?: InputMaybe<ReadonlyArray<TOrderOriginCategoryEnum>>;
};


/** The mutation root of this schema */
export type TMutationDestroyCompanyBranchPrinterArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationDestroyCompanyBranchTriggerArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationDestroyCompanyBranchTriggerPrinterArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationDestroyCompanyBranchUserArgs = {
  companyBranchUser: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationDestroyCompanyPopupArgs = {
  id: Scalars['ID'];
  orderOriginCategories?: InputMaybe<ReadonlyArray<TOrderOriginCategoryEnum>>;
};


/** The mutation root of this schema */
export type TMutationDestroyConsentOrderArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationDestroyIngredientArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationDestroyIntegrationsProfileWareCategoryArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationDestroyMultipleOrderRecipesArgs = {
  ids: ReadonlyArray<Scalars['ID']>;
};


/** The mutation root of this schema */
export type TMutationDestroyOccasionArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationDestroyOrderPaymentMethodArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationDestroyOrderProcessTimeArgs = {
  companyBranch: Scalars['ID'];
  deliveryType: TDeliveryTypeEnum;
};


/** The mutation root of this schema */
export type TMutationDestroyOrderRecipeArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationDestroyOrderRecipesArgs = {
  order: Scalars['ID'];
  recipe: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationDestroyPrinterArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationDestroyPromoBannerArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationDestroyRecipeArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationDestroyRecipeRelationArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationDestroyRecipeTagArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationDestroySectorArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationDestroySectorRecipeArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationDestroyShiftArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationDestroyStockInventoryArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationDestroyStockItemArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationDestroyStockItemTransferArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationDestroyTransportationDeviceUserArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


/** The mutation root of this schema */
export type TMutationDestroyUserArgs = {
  password: Scalars['String'];
};


/** The mutation root of this schema */
export type TMutationDestroyUserDeliveringOrderArgs = {
  id: Scalars['ID'];
  keepDriver?: InputMaybe<Scalars['Boolean']>;
  reason?: InputMaybe<TDeliveryStateEnum>;
};


/** The mutation root of this schema */
export type TMutationDestroyWareCategoryArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationDestroyWareCategoryRelationArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationDestroyZoneArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationExportCustomersArgs = {
  companyBranches: ReadonlyArray<Scalars['ID']>;
  dateFrom: Scalars['DateTime'];
  dateTo: Scalars['DateTime'];
  format: TFileReportFormat;
  madeOrder: Scalars['Boolean'];
};


/** The mutation root of this schema */
export type TMutationFinishExternalOrderArgs = {
  id: Scalars['ID'];
  paymentMethods: ReadonlyArray<TInputOrderPaymentMethodsCreate>;
};


/** The mutation root of this schema */
export type TMutationFinishKioskOrderArgs = {
  id: Scalars['ID'];
  order: TInputOrderFinish;
};


/** The mutation root of this schema */
export type TMutationFinishOrderArgs = {
  id: Scalars['ID'];
  order: TInputOrderFinish;
};


/** The mutation root of this schema */
export type TMutationFinishStaffOrderArgs = {
  id: Scalars['ID'];
  invoice?: InputMaybe<Scalars['String']>;
  invoiceNumber?: InputMaybe<Scalars['Int']>;
  paymentMethods?: InputMaybe<ReadonlyArray<TInputOrderPaymentMethodsCreate>>;
};


/** The mutation root of this schema */
export type TMutationFinishStockInventoryArgs = {
  id: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
};


/** The mutation root of this schema */
export type TMutationFinishVirtualCashBoxOrderArgs = {
  id: Scalars['ID'];
  order: TInputOrderFinish;
};


/** The mutation root of this schema */
export type TMutationFoodoraProfileStatusArgs = {
  profileId: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationImportOrdersArgs = {
  cashBox: Scalars['String'];
  lastInvoiceNumber: Scalars['Int'];
  orders: ReadonlyArray<TInputOrderStaffImport>;
};


/** The mutation root of this schema */
export type TMutationLogKioskEventArgs = {
  cashBox: Scalars['ID'];
  events: ReadonlyArray<TInputKioskEventLog>;
};


/** The mutation root of this schema */
export type TMutationOrderNotifyCustomerArgs = {
  id: Scalars['ID'];
  minutes: Scalars['Int'];
};


/** The mutation root of this schema */
export type TMutationPauseExpressDeliveryArgs = {
  id: Scalars['ID'];
  pausedFrom?: InputMaybe<Scalars['DateTime']>;
  pausedUntil?: InputMaybe<Scalars['DateTime']>;
};


/** The mutation root of this schema */
export type TMutationPohodaExportPlanArgs = {
  companyBranch: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationPushBoltMenuArgs = {
  profileId: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationPushFoodoraMenuArgs = {
  profileId: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationPushIntegrationsBusinessHoursArgs = {
  businessHours: ReadonlyArray<TInputIntegrationsBusinessHourCreate>;
  profileId: Scalars['ID'];
  profileIntegration: TIntegrationEnum;
};


/** The mutation root of this schema */
export type TMutationPushJidloPodNosMenuArgs = {
  profileId: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationPushWoltMenuArgs = {
  profileId: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationRejectionAcceptedStockItemTransferArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationRejectStockItemTransferArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationRemoveAllergenStockItemArgs = {
  allergen: TAllergenEnum;
  stockItem: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationRemoveDriverFromOrderGroupArgs = {
  orderGroup: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationRemoveItemFromOrderGroupArgs = {
  order: Scalars['ID'];
  orderGroup: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationRemoveOrderPromoCodeArgs = {
  order: Scalars['ID'];
  promoCode: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationRemoveOrderStateArgs = {
  order: Scalars['ID'];
  orderState: TOrderStateEnum;
  target?: InputMaybe<TOrderStateCategoryTargetEnum>;
};


/** The mutation root of this schema */
export type TMutationReplayIntegrationsActivityArgs = {
  activityId: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationRequestCancelOrderArgs = {
  cancelReason: TStornoRequestTypeEnum;
  comment?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationRequestEmailConfirmationCodeArgs = {
  email?: InputMaybe<Scalars['String']>;
  returnUrl: Scalars['String'];
};


/** The mutation root of this schema */
export type TMutationRequestPhoneConfirmationCodeArgs = {
  backgroundExport?: InputMaybe<Scalars['ID']>;
  originatorHost?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
};


/** The mutation root of this schema */
export type TMutationResendEetReceiptArgs = {
  id: Scalars['ID'];
  storno?: InputMaybe<Scalars['Boolean']>;
};


/** The mutation root of this schema */
export type TMutationResolveIntegrationsActivityArgs = {
  activityId: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationSetPriorityOrderArgs = {
  isPriority: Scalars['Boolean'];
  order: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationStornoEetReceiptArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationSuspendUserArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationTransferOrderArgs = {
  companyBranch: Scalars['ID'];
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationUpdateAddressArgs = {
  address: TInputAddressUpdate;
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationUpdateAllowedDeliveryTypesArgs = {
  companyBranchId: Scalars['ID'];
  deliveryTypes: ReadonlyArray<TDeliveryTypeEnum>;
};


/** The mutation root of this schema */
export type TMutationUpdateBoardArgs = {
  backgroundImage?: InputMaybe<TInputFileUpdate>;
  backgroundVideo?: InputMaybe<TInputFileUpdate>;
  boardScreens?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  boardTemplate?: InputMaybe<Scalars['ID']>;
  colors?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  features?: InputMaybe<TInputBoardFeaturesUpdate>;
  id: Scalars['ID'];
  logo?: InputMaybe<TInputFileUpdate>;
  name?: InputMaybe<Scalars['String']>;
};


/** The mutation root of this schema */
export type TMutationUpdateBoardScreenArgs = {
  backgroundImage?: InputMaybe<TInputFileUpdate>;
  backgroundVideo?: InputMaybe<TInputFileUpdate>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  wareCategories?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};


/** The mutation root of this schema */
export type TMutationUpdateBoltAvailabilityStateArgs = {
  availabilityState: TBoltAvailabilityStateGlEnum;
  profileId: Scalars['ID'];
  until?: InputMaybe<Scalars['DateTime']>;
};


/** The mutation root of this schema */
export type TMutationUpdateBoltProfileArgs = {
  id: Scalars['ID'];
  profile: TBoltInputProfileUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateCompanyBranchPopupArgs = {
  id: Scalars['ID'];
  orderOriginCategory: TOrderOriginCategoryEnum;
  text: Scalars['String'];
};


/** The mutation root of this schema */
export type TMutationUpdateCompanyBranchRecipeArgs = {
  companyBranch: Scalars['ID'];
  recipe: TInputCompanyBranchRecipeUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateCompanyBranchTriggerArgs = {
  id: Scalars['ID'];
  templatable?: InputMaybe<Scalars['ID']>;
  triggerConfiguration?: InputMaybe<Scalars['ID']>;
};


/** The mutation root of this schema */
export type TMutationUpdateCompanyBranchUserArgs = {
  companyBranchUser: TInputCompanyBranchUserUpdate;
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationUpdateCompanyBranchWareCategoryArgs = {
  companyBranch: Scalars['ID'];
  wareCategory: TInputCompanyBranchWareCategoryUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateCompanyPopupArgs = {
  id: Scalars['ID'];
  orderOriginCategory: TOrderOriginCategoryEnum;
  text: Scalars['String'];
};


/** The mutation root of this schema */
export type TMutationUpdateCurrencyExchangeRateArgs = {
  exchangeRate: Scalars['Float'];
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationUpdateDefaultDeliveryTimeArgs = {
  defaultDeliveryTime: Scalars['Int'];
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationUpdateDefaultOrderProcessTimeArgs = {
  companyBranch: Scalars['ID'];
  defaultTime: Scalars['Int'];
  deliveryType: TDeliveryTypeEnum;
};


/** The mutation root of this schema */
export type TMutationUpdateDotykackaProfileArgs = {
  id: Scalars['ID'];
  profile: TDotykackaInputProfileUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateExpressDeliverySettingArgs = {
  id: Scalars['ID'];
  setting: TExpressDeliverySettingUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateFoodoraAvailabilityStateArgs = {
  availabilityState: TFoodoraAvailabilityStateGlEnum;
  closedReason?: InputMaybe<TFoodoraClosedReasonEnum>;
  closingMinutes?: InputMaybe<Scalars['Int']>;
  profileId: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationUpdateFoodoraProfileArgs = {
  id: Scalars['ID'];
  profile: TFoodoraInputProfileUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateGraphicHeadersArgs = {
  company?: InputMaybe<Scalars['ID']>;
  companyBranch?: InputMaybe<Scalars['ID']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  promoTranslations?: InputMaybe<ReadonlyArray<TInputLabelTranslation>>;
};


/** The mutation root of this schema */
export type TMutationUpdateGraphicStylesArgs = {
  applicationStyles?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  companyBranch?: InputMaybe<Scalars['ID']>;
  originCategory: TOrderOriginCategoryEnum;
};


/** The mutation root of this schema */
export type TMutationUpdateIngredientArgs = {
  id: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Int']>;
  recipe?: InputMaybe<Scalars['ID']>;
  stockItem?: InputMaybe<Scalars['ID']>;
};


/** The mutation root of this schema */
export type TMutationUpdateJidloPodNosProfileArgs = {
  id: Scalars['ID'];
  profile: TJidloPodNosInputProfileUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateOccasionArgs = {
  id: Scalars['ID'];
  occasion: TInputOccasionUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateOrderArgs = {
  id: Scalars['ID'];
  order: TInputOrderUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateOrderDeliveryToPickupArgs = {
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationUpdateOrderGroupArgs = {
  orderGroup: TInputOrderGroupUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateOrderGroupOrderArgs = {
  offset: Scalars['Int'];
  order: Scalars['ID'];
  orderGroup: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationUpdateOrderOnlineStateKioskOrderArgs = {
  order: Scalars['ID'];
  orderOnlineState?: InputMaybe<TOrderOnlineStateEnum>;
};


/** The mutation root of this schema */
export type TMutationUpdateOrderOnlineStatePos2Args = {
  order: Scalars['ID'];
  orderOnlineState?: InputMaybe<TOrderOnlineStateEnum>;
};


/** The mutation root of this schema */
export type TMutationUpdateOrderPaymentMethodArgs = {
  orderId: Scalars['ID'];
  paymentMethodId: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationUpdateOrderPaymentMethodsArgs = {
  orderId: Scalars['ID'];
  paymentMethods: ReadonlyArray<TInputOrderPaymentMethodUpdate>;
};


/** The mutation root of this schema */
export type TMutationUpdateOrderPreviewArgs = {
  id: Scalars['ID'];
  order: TInputOrderUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateOrderRecipeArgs = {
  id: Scalars['ID'];
  orderRecipe: TInputOrderRecipeUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateOrderRecipeStateArgs = {
  id: Scalars['ID'];
  orderRecipeState: TOrderRecipeStateEnum;
  target?: InputMaybe<TOrderStateCategoryTargetEnum>;
};


/** The mutation root of this schema */
export type TMutationUpdateOrderTipArgs = {
  orderId: Scalars['ID'];
  tip: TInputOrderTipUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateOrderUserArgs = {
  order: Scalars['ID'];
  token: Scalars['String'];
};


/** The mutation root of this schema */
export type TMutationUpdatePrinterArgs = {
  companyBranches: ReadonlyArray<Scalars['ID']>;
  id: Scalars['ID'];
  mac?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  printerType?: InputMaybe<TPrinterTypeEnum>;
};


/** The mutation root of this schema */
export type TMutationUpdatePrinterStateArgs = {
  printerId: Scalars['ID'];
  state: Scalars['Int'];
};


/** The mutation root of this schema */
export type TMutationUpdatePrintQueueArgs = {
  id: Scalars['ID'];
  printQueueState: TPrintQueueStateEnum;
};


/** The mutation root of this schema */
export type TMutationUpdatePrintTemplateArgs = {
  content: Scalars['String'];
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationUpdatePromoBannerArgs = {
  desktopImage?: InputMaybe<TInputImage>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  language?: InputMaybe<TLanguageEnum>;
  mobileImage?: InputMaybe<TInputImage>;
  position?: InputMaybe<TPromoBannerPositionEnum>;
  promoUrl?: InputMaybe<Scalars['String']>;
  recipeId?: InputMaybe<Scalars['ID']>;
  showDuration?: InputMaybe<Scalars['Int']>;
};


/** The mutation root of this schema */
export type TMutationUpdateRecipeArgs = {
  id: Scalars['ID'];
  recipe: TInputRecipeUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateRecipePriceArgs = {
  id: Scalars['ID'];
  price?: InputMaybe<TInputCurrencyCreate>;
  vat?: InputMaybe<Scalars['Float']>;
  warePriceType?: InputMaybe<TWarePriceTypeEnum>;
};


/** The mutation root of this schema */
export type TMutationUpdateRecipesOrderArgs = {
  offset: Scalars['Int'];
  recipe: Scalars['ID'];
  wareCategory: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationUpdateRecipeTagArgs = {
  id: Scalars['ID'];
  recipeTag: TInputRecipeTagUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateSectorArgs = {
  sector: TInputSectorUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateSectorRecipeArgs = {
  id: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  orderRecipeState?: InputMaybe<TOrderRecipeStateEnum>;
  sector?: InputMaybe<Scalars['ID']>;
};


/** The mutation root of this schema */
export type TMutationUpdateSectorRecipesArgs = {
  orderRecipeState: TOrderRecipeStateEnum;
  sectorId: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationUpdateShiftArgs = {
  beginAt?: InputMaybe<Scalars['DateTime']>;
  capacity?: InputMaybe<Scalars['Int']>;
  companyBranch?: InputMaybe<Scalars['ID']>;
  endAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  placeCode?: InputMaybe<Scalars['String']>;
};


/** The mutation root of this schema */
export type TMutationUpdateShiftUserArgs = {
  id: Scalars['ID'];
  shiftUserState: TShiftUserStateEnum;
};


/** The mutation root of this schema */
export type TMutationUpdateSideDishesOrderArgs = {
  offset: Scalars['Int'];
  recipe: Scalars['ID'];
  wareCategory: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationUpdateStockInventoryItemArgs = {
  id: Scalars['ID'];
  stockInventoryItem: TInputStockInventoryItemUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateStockItemArgs = {
  id: Scalars['ID'];
  stockItem: TInputStockItemUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateTransportationDeviceStateArgs = {
  deviceState: TDeviceStateEnum;
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationUpdateTransportationDeviceUserArgs = {
  id?: InputMaybe<Scalars['ID']>;
  locality?: InputMaybe<TInputGeoPointCreate>;
};


/** The mutation root of this schema */
export type TMutationUpdateUserArgs = {
  id: Scalars['ID'];
  user: TInputUserUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateUserDeliveringOrderArgs = {
  deliveryState: TDeliveryStateEnum;
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationUpdateUserDeliveryArgs = {
  id: Scalars['ID'];
  userDeliveringOrders: ReadonlyArray<Scalars['ID']>;
};


/** The mutation root of this schema */
export type TMutationUpdateUserPasswordArgs = {
  newPassword: Scalars['String'];
  oldPassword?: InputMaybe<Scalars['String']>;
};


/** The mutation root of this schema */
export type TMutationUpdateWareArgs = {
  id: Scalars['ID'];
  ware: TInputWareUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateWareCategoriesOrderArgs = {
  companyBranch: Scalars['ID'];
  offset: Scalars['Int'];
  wareCategory: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationUpdateWareCategoryArgs = {
  id: Scalars['ID'];
  wareCategory: TInputWareCategoryUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateWareCategoryColorArgs = {
  color: Scalars['String'];
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationUpdateWoltBusinessHoursArgs = {
  businessHours: ReadonlyArray<TInputBusinessHourCreate>;
  profileId: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationUpdateWoltDeliveryProviderArgs = {
  deliveryProvider: TWoltDeliveryProviderEnum;
  profileId: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationUpdateWoltOnlineStateArgs = {
  onlineState: TIntegrationStateEnum;
  profileId: Scalars['ID'];
  until?: InputMaybe<Scalars['DateTime']>;
};


/** The mutation root of this schema */
export type TMutationUpdateWoltProfileArgs = {
  id: Scalars['ID'];
  profile: TWoltInputProfileUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateWoltRecipesArgs = {
  profileId: Scalars['ID'];
  recipeIds: ReadonlyArray<Scalars['ID']>;
};


/** The mutation root of this schema */
export type TMutationUpdateZoneArgs = {
  id: Scalars['ID'];
  zone: TInputZoneUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateZoneColorArgs = {
  color: Scalars['String'];
  id: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationUpdateZonePriorityArgs = {
  offset: Scalars['Int'];
  zone: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationUserNotifyCustomerCallingArgs = {
  phone: Scalars['String'];
};


/** The mutation root of this schema */
export type TMutationUserNotifyCustomerHangupArgs = {
  eventId: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationValidateCurrentUserConfirmationCodeArgs = {
  code: Scalars['String'];
};


/** The mutation root of this schema */
export type TMutationValidateEmailConfirmationCodeArgs = {
  token: Scalars['String'];
};


/** The mutation root of this schema */
export type TMutationValidatePhoneConfirmationCodeArgs = {
  code: Scalars['String'];
  phoneNumber: Scalars['String'];
};


/** The mutation root of this schema */
export type TMutationWoltDeliveryProviderArgs = {
  profileId: Scalars['ID'];
};


/** The mutation root of this schema */
export type TMutationWoltOnboardingUrlArgs = {
  profileId: Scalars['ID'];
  redirectUrl: Scalars['String'];
};


/** The mutation root of this schema */
export type TMutationWoltProfileStatusArgs = {
  profileId: Scalars['ID'];
};

export type TCreditsPaymentAdd = {
  readonly __typename?: 'CreditsPaymentAdd';
  readonly order: TOrder;
  readonly wallet: TCreditsWallet;
};

/** Provide order information with errors */
export type TOrderWithErrors = {
  readonly __typename?: 'OrderWithErrors';
  readonly errors: ReadonlyArray<Scalars['String']>;
  readonly order: TOrder;
};

export type TInputBusinessHourSpecificDateCreate = {
  readonly closeAt?: InputMaybe<Scalars['Time']>;
  readonly closed?: InputMaybe<Scalars['Boolean']>;
  readonly closedNote?: InputMaybe<Scalars['String']>;
  readonly companyBranch: Scalars['ID'];
  /**
   * Online mode is used to determine the operating hours for online orders and physical mode
   *         represents the operation times for a physical location.
   */
  readonly mode?: InputMaybe<TBusinessHoursModeEnum>;
  readonly openAt?: InputMaybe<Scalars['Time']>;
  readonly smsLabel?: InputMaybe<TInputLabelCreate>;
  readonly specificDate: Scalars['Date'];
  readonly type?: InputMaybe<TBusinessHoursTypeEnum>;
  readonly webLabel?: InputMaybe<TInputLabelCreate>;
};

export type TInputLabelCreate = {
  readonly enabled?: InputMaybe<Scalars['Boolean']>;
  readonly translations: ReadonlyArray<TInputLabelTranslation>;
};

export type TInputLabelTranslation = {
  readonly content: Scalars['String'];
  readonly language: TLanguageEnum;
};

export type TInputBusinessHourSpecificCloseCreate = {
  readonly closedNote?: InputMaybe<Scalars['String']>;
  /** close for defined interval in minutes */
  readonly closingInterval: Scalars['Int'];
  readonly companyBranchId: Scalars['ID'];
};

export type TAdyenInputPaymentCreate = {
  readonly order: Scalars['ID'];
  readonly paymentRequest: Scalars['Base64Json'];
};

/** Response from Adyen payments API */
export type TAdyenPaymentResponse = {
  readonly __typename?: 'AdyenPaymentResponse';
  readonly response: Scalars['Base64Json'];
};

export type TAdyenInputPaymentDetailsCreate = {
  readonly order: Scalars['ID'];
  readonly paymentDetailsRequest: Scalars['Base64Json'];
};

/** Response from Adyen payments details API */
export type TAdyenPaymentDetailsResponse = {
  readonly __typename?: 'AdyenPaymentDetailsResponse';
  readonly response: Scalars['Base64Json'];
};

/** Response from Adyen payment methods API */
export type TAdyenPaymentMethodResponse = {
  readonly __typename?: 'AdyenPaymentMethodResponse';
  readonly response: Scalars['Base64Json'];
};

/** Result of canceling multiple orders */
export type TOrdersBulkCanceledResult = {
  readonly __typename?: 'OrdersBulkCanceledResult';
  readonly canceled: ReadonlyArray<TOrder>;
  readonly notCanceled: ReadonlyArray<TOrderCancelFailed>;
};

/** Order which was not canceled with reason */
export type TOrderCancelFailed = {
  readonly __typename?: 'OrderCancelFailed';
  readonly id: Scalars['ID'];
  readonly reason: Scalars['String'];
};

export type TInputCashBoxLogTerminalEvent = {
  readonly message: Scalars['String'];
  readonly terminalUuid: Scalars['String'];
  readonly timestamp: Scalars['DateTime'];
};

export type TInputAddressCreate = {
  readonly addressType: TAddressTypeEnum;
  readonly driverNote?: InputMaybe<Scalars['String']>;
  readonly gps: TInputGeoPointCreate;
  readonly title?: InputMaybe<Scalars['String']>;
};

export type TInputBoardFeaturesCreate = {
  readonly allergensEnabled: Scalars['Boolean'];
  readonly infoMessageEnabled: Scalars['Boolean'];
  readonly infoMessagePrimary?: InputMaybe<Scalars['String']>;
  readonly infoMessageSecondary?: InputMaybe<Scalars['String']>;
  readonly logoEnabled: Scalars['Boolean'];
  readonly promoCategory?: InputMaybe<Scalars['ID']>;
  readonly promoEnabled: Scalars['Boolean'];
  readonly titleEnabled: Scalars['Boolean'];
  readonly titleText?: InputMaybe<Scalars['String']>;
  readonly titleUrl?: InputMaybe<Scalars['String']>;
};

export type TInputBusinessHourCreate = {
  readonly closeAt: Scalars['Time'];
  readonly openAt: Scalars['Time'];
  readonly smsLabel?: InputMaybe<TInputLabelCreate>;
  readonly webLabel?: InputMaybe<TInputLabelCreate>;
  readonly weekDay: TWeekDayEnum;
};

export type TInputCompanyCreate = {
  readonly account: Scalars['String'];
  readonly companyType: TCompanyTypeEnum;
  readonly internalNumber?: InputMaybe<Scalars['String']>;
  readonly name: Scalars['String'];
  readonly number: Scalars['String'];
  readonly vatIdent: Scalars['String'];
};

export type TInputCompanyBranchCreate = {
  readonly brand: Scalars['ID'];
  readonly currencies?: InputMaybe<ReadonlyArray<TCurrencyEnum>>;
  readonly displayName?: InputMaybe<Scalars['String']>;
  readonly enabled?: InputMaybe<Scalars['Boolean']>;
  readonly internalNumber: Scalars['String'];
  readonly name: Scalars['String'];
};

export type TPopup = {
  readonly __typename?: 'Popup';
  readonly orderOriginCategories: Maybe<TOrderOriginCategoryEnum>;
  readonly text: Scalars['String'];
};

export type TInputCompanyBranchUserDriverSetting = {
  readonly driverSmsText?: InputMaybe<Scalars['String']>;
  readonly orderAssignmentTypes?: InputMaybe<ReadonlyArray<TUserDeliveringOrdersAssignmentTypeEnum>>;
};

export type TInputConsentOrderCreate = {
  readonly consent: Scalars['ID'];
  readonly order: Scalars['ID'];
};

export type TInputOrderDeliveryCreate = {
  readonly address?: InputMaybe<Scalars['String']>;
  readonly brand?: InputMaybe<Scalars['ID']>;
  readonly companyBranch?: InputMaybe<Scalars['ID']>;
  readonly deliverySlot?: InputMaybe<Scalars['ID']>;
  readonly deliveryType?: InputMaybe<TDeliveryTypeEnum>;
  readonly gps: TInputGeoPointCreate;
  readonly isExpress?: InputMaybe<Scalars['Boolean']>;
  readonly orderOrigin: TOrderOriginEnum;
};

export type TExpressDeliverySettingCreate = {
  readonly companyBranchId: Scalars['ID'];
  readonly expressBaseTimeMinutes: Scalars['Int'];
  readonly expressFee: Scalars['Float'];
  readonly isExpressEnabled: Scalars['Boolean'];
  readonly maxOrderValue?: InputMaybe<Scalars['Float']>;
  readonly ordersInProgressLimit?: InputMaybe<Scalars['Int']>;
  readonly pausedUntil?: InputMaybe<Scalars['DateTime']>;
};

export type TInputExternalOrderCreate = {
  readonly address?: InputMaybe<Scalars['String']>;
  readonly cancelUnpaid?: InputMaybe<Scalars['Boolean']>;
  readonly companyBranch: Scalars['ID'];
  readonly customer?: InputMaybe<TInputCustomerCreate>;
  readonly deliverAt: Scalars['DateTime'];
  readonly deliveryType?: InputMaybe<TDeliveryTypeEnum>;
  readonly gps?: InputMaybe<TInputGeoPointCreate>;
  readonly note?: InputMaybe<Scalars['String']>;
  readonly orderOrigin: TOrderOriginEnum;
  readonly orderRecipes?: InputMaybe<ReadonlyArray<TInputOrderRecipeCreates>>;
  readonly warePriceType?: InputMaybe<TWarePriceTypeEnum>;
};

export type TInputCustomerCreate = {
  readonly emails?: InputMaybe<ReadonlyArray<TInputEmailCreate>>;
  readonly firstName?: InputMaybe<Scalars['String']>;
  readonly lastName?: InputMaybe<Scalars['String']>;
  readonly phones?: InputMaybe<ReadonlyArray<TInputPhoneCreate>>;
};

export type TInputEmailCreate = {
  readonly default?: InputMaybe<Scalars['Boolean']>;
  readonly description?: InputMaybe<Scalars['String']>;
  readonly email: Scalars['String'];
};

export type TInputPhoneCreate = {
  readonly default?: InputMaybe<Scalars['Boolean']>;
  readonly description?: InputMaybe<Scalars['String']>;
  readonly phone: Scalars['String'];
};

export type TInputOrderRecipeCreates = {
  readonly amount?: InputMaybe<Scalars['Int']>;
  readonly associatedRecipes?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly note?: InputMaybe<Scalars['String']>;
  readonly recipe: Scalars['ID'];
  readonly sideDishes?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly sideDishRecipes?: InputMaybe<ReadonlyArray<TInputOrderRecipeSideDishCreate>>;
};

export type TInputOrderRecipeSideDishCreate = {
  readonly categoryId: Scalars['ID'];
  readonly recipeId: Scalars['ID'];
};

/** Response for created order by external service */
export type TCreatedExternalOrderType = {
  readonly __typename?: 'CreatedExternalOrderType';
  readonly missingStockItems: ReadonlyArray<TStockItem>;
  readonly order: Maybe<TOrder>;
  readonly userErrors: ReadonlyArray<Scalars['String']>;
};

export type TInputIngredientCreate = {
  readonly quantity: Scalars['Float'];
  readonly recipe: Scalars['ID'];
  readonly stockItem: Scalars['ID'];
};

export type TInputOrderStaffPosCreate = {
  /** Argument is not reguired for STAFF orders. Also we try to reverse geocode GPS to address, thus argument may be blank. */
  readonly address?: InputMaybe<Scalars['String']>;
  readonly callEventId?: InputMaybe<Scalars['ID']>;
  readonly companyBranch: Scalars['ID'];
  readonly customer: TInputCustomerCreate;
  readonly deliverAt?: InputMaybe<Scalars['DateTime']>;
  readonly deliverySlot?: InputMaybe<Scalars['ID']>;
  readonly deliveryType?: InputMaybe<TDeliveryTypeEnum>;
  /** Optional for INHOUSE-PICKUP order and for MESSENGER delivering orders associateg with Sector, which has defines its GPS. */
  readonly gps?: InputMaybe<TInputGeoPointCreate>;
  readonly language?: InputMaybe<TLanguageEnum>;
  readonly location?: InputMaybe<TInputLocationCreate>;
  readonly note?: InputMaybe<Scalars['String']>;
  readonly notification?: InputMaybe<TInputNotificationCreate>;
  readonly occasion?: InputMaybe<Scalars['ID']>;
  readonly sector?: InputMaybe<Scalars['ID']>;
  readonly warePriceType: TWarePriceTypeEnum;
};

export type TInputLocationCreate = {
  readonly tableNumber?: InputMaybe<Scalars['Int']>;
};

export type TInputNotificationCreate = {
  readonly chrome?: InputMaybe<Scalars['Json']>;
  readonly firebase?: InputMaybe<Scalars['Json']>;
  readonly sms?: InputMaybe<Scalars['String']>;
};

/**
 * String description of some attribute - can be localized name, etc.
 *
 *
 * INDEX: [admin, editor_business_hours, editor_label, editor_menu, guest, merchant, super_admin, support, user]
 *
 * READ: [admin, editor_business_hours, editor_label, editor_menu, guest, merchant, super_admin, support, user]
 *
 * CREATE: [admin, editor_label, super_admin, support]
 *
 * UPDATE: [admin, editor_label, editor_menu, super_admin, support]
 *
 * DESTROY: [admin, editor_label, super_admin]
 *
 */
export type TLabel = {
  readonly __typename?: 'Label';
  readonly content: Maybe<Scalars['String']>;
  readonly enabled: Scalars['Boolean'];
  readonly id: Scalars['ID'];
};

export type TInputOccasionCreate = {
  readonly companyBranch: Scalars['ID'];
  /** Date when occasion begins */
  readonly dateFrom: Scalars['DateTime'];
  /** Date when occasions ends */
  readonly dateTo: Scalars['DateTime'];
  readonly image?: InputMaybe<Scalars['InputFile']>;
  /** Beginning of preorder */
  readonly preorderFrom: Scalars['DateTime'];
  /** End of preorder */
  readonly preorderTo: Scalars['DateTime'];
  readonly title: Scalars['String'];
  /** Short title for mobile view */
  readonly titleShort: Scalars['String'];
};

export type TInputOrderCreate = {
  /** Argument is not required for STAFF orders. Also we try to reverse geocode GPS to address, thus argument may be blank. */
  readonly address?: InputMaybe<Scalars['String']>;
  readonly callEventId?: InputMaybe<Scalars['ID']>;
  readonly cashBox?: InputMaybe<Scalars['ID']>;
  readonly companyBranch: Scalars['ID'];
  readonly customer: TInputCustomerCreate;
  readonly deliverAt?: InputMaybe<Scalars['DateTime']>;
  readonly deliverySlot?: InputMaybe<Scalars['ID']>;
  readonly deliveryType?: InputMaybe<TDeliveryTypeEnum>;
  /** Optional for INHOUSE-PICKUP order and for MESSENGER delivering orders associated with Sector, which has defines its GPS. */
  readonly gps?: InputMaybe<TInputGeoPointCreate>;
  readonly isExpress?: InputMaybe<Scalars['Boolean']>;
  readonly language?: InputMaybe<TLanguageEnum>;
  readonly location?: InputMaybe<TInputLocationCreate>;
  readonly note?: InputMaybe<Scalars['String']>;
  readonly notification?: InputMaybe<TInputNotificationCreate>;
  readonly occasion?: InputMaybe<Scalars['ID']>;
  readonly orderOrigin: TOrderOriginEnum;
  readonly resolvedAddress?: InputMaybe<TInputOrderResolvedAddressType>;
  readonly sector?: InputMaybe<Scalars['ID']>;
  readonly warePriceType: TWarePriceTypeEnum;
};

export type TInputOrderResolvedAddressType = {
  readonly city?: InputMaybe<Scalars['String']>;
  readonly country?: InputMaybe<Scalars['String']>;
  readonly houseNumber?: InputMaybe<Scalars['String']>;
  readonly postCode?: InputMaybe<Scalars['String']>;
  readonly state?: InputMaybe<Scalars['String']>;
  readonly street?: InputMaybe<Scalars['String']>;
  readonly venue?: InputMaybe<Scalars['String']>;
};

export type TInputOrderGroupCreate = {
  readonly name?: InputMaybe<Scalars['String']>;
  readonly orderGroupColor?: InputMaybe<Scalars['ID']>;
  readonly orders: ReadonlyArray<Scalars['ID']>;
};

export type TInputOrderPaymentMethodCreate = {
  readonly order: Scalars['ID'];
  readonly paymentMethod: Scalars['ID'];
  readonly price: TInputCurrencyCreate;
};

export type TInputCurrencyCreate = {
  readonly currency?: InputMaybe<TCurrencyEnum>;
  readonly value: Scalars['Float'];
};

export type TInputOrderRatingCreate = {
  readonly orderRatingType: TOrderRatingTypeEnum;
  readonly text?: InputMaybe<Scalars['String']>;
  readonly value?: InputMaybe<Scalars['Int']>;
};

export type TInputOrderRecipeCreate = {
  readonly amount?: InputMaybe<Scalars['Int']>;
  readonly associatedRecipes?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly dynamicPrice?: InputMaybe<TInputCurrencyCreate>;
  readonly note?: InputMaybe<Scalars['String']>;
  readonly order: Scalars['ID'];
  readonly orderRecipeState?: InputMaybe<TOrderRecipeStateEnum>;
  readonly parent?: InputMaybe<Scalars['ID']>;
  readonly promoTag?: InputMaybe<TPromoTagEnum>;
  readonly recipe: Scalars['ID'];
  readonly sideDishes?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly sideDishRecipes?: InputMaybe<ReadonlyArray<TInputOrderRecipeSideDishCreate>>;
  readonly wareCategory?: InputMaybe<Scalars['ID']>;
};

export type TInputOrderPickupCreate = {
  readonly companyBranch: Scalars['ID'];
  readonly deliverySlot?: InputMaybe<Scalars['ID']>;
  readonly isExpress?: InputMaybe<Scalars['Boolean']>;
  readonly orderOrigin: TOrderOriginEnum;
};

export type TInputRecipeCreate = {
  readonly ageControl?: InputMaybe<Scalars['Boolean']>;
  readonly associatedRecipes?: InputMaybe<ReadonlyArray<TInputRecipeRelationCreate>>;
  readonly availabilities?: InputMaybe<ReadonlyArray<TInputAvailabilityCreate>>;
  readonly bistroId?: InputMaybe<Scalars['ID']>;
  readonly code?: InputMaybe<Scalars['String']>;
  readonly companyBranch: Scalars['ID'];
  readonly descriptionLabel?: InputMaybe<Scalars['String']>;
  readonly dotykackaId?: InputMaybe<Scalars['ID']>;
  readonly enabled?: InputMaybe<Scalars['Boolean']>;
  readonly groups: ReadonlyArray<Scalars['ID']>;
  readonly image?: InputMaybe<Scalars['InputFile']>;
  readonly ingredients?: InputMaybe<ReadonlyArray<TInputRecipeIngredient>>;
  readonly internalNote?: InputMaybe<Scalars['String']>;
  readonly isCombinationMeal?: InputMaybe<Scalars['Boolean']>;
  readonly isDynamicPricingEnabled?: InputMaybe<Scalars['Boolean']>;
  readonly nameLabel?: InputMaybe<Scalars['String']>;
  readonly pictogram?: InputMaybe<Scalars['String']>;
  readonly prices: ReadonlyArray<TInputRecipePriceCreate>;
  readonly primaryWareCategory?: InputMaybe<Scalars['ID']>;
  readonly recipeColor?: InputMaybe<Scalars['ID']>;
  readonly recipeTags?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly sideDishCategories?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly soldOut?: InputMaybe<Scalars['Boolean']>;
  readonly translations?: InputMaybe<ReadonlyArray<TInputRecipeTranslation>>;
  readonly video?: InputMaybe<Scalars['String']>;
  readonly ware?: InputMaybe<Scalars['ID']>;
  readonly wareCategories?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly wareCategoryType: TWareCategoryTypeEnum;
};

export type TInputRecipeRelationCreate = {
  readonly associatedRecipe: Scalars['ID'];
  readonly warePriceType: TWarePriceTypeEnum;
};

export type TInputAvailabilityCreate = {
  readonly availabilityType?: InputMaybe<TAvailabilityTypeEnum>;
  readonly available?: InputMaybe<Scalars['Boolean']>;
  readonly dateFrom?: InputMaybe<Scalars['Date']>;
  readonly dateTo?: InputMaybe<Scalars['Date']>;
  readonly orderOriginCategories?: InputMaybe<ReadonlyArray<TOrderOriginCategoryEnum>>;
  readonly periodic?: InputMaybe<Scalars['Boolean']>;
  readonly timeFrom?: InputMaybe<Scalars['Time']>;
  readonly timeTo?: InputMaybe<Scalars['Time']>;
  readonly weekDay?: InputMaybe<TWeekDayEnum>;
};

export type TInputRecipeIngredient = {
  readonly quantity: Scalars['Float'];
  readonly stockItem: Scalars['ID'];
};

export type TInputRecipePriceCreate = {
  readonly price: TInputCurrencyCreate;
  readonly vat: Scalars['ID'];
  readonly warePriceType: TWarePriceTypeEnum;
};

export type TInputRecipeTranslation = {
  readonly descriptionLabel?: InputMaybe<Scalars['String']>;
  readonly language: TLanguageEnum;
  readonly nameLabel?: InputMaybe<Scalars['String']>;
};

export type TInputRecipeTagCreate = {
  readonly color?: InputMaybe<Scalars['String']>;
  readonly company: Scalars['ID'];
  readonly image?: InputMaybe<Scalars['InputFile']>;
  readonly pictogram?: InputMaybe<Scalars['String']>;
  readonly systemRecipeTag: Scalars['ID'];
  readonly translations?: InputMaybe<ReadonlyArray<TInputRecipeTagTranslation>>;
};

export type TInputRecipeTagTranslation = {
  readonly label?: InputMaybe<Scalars['String']>;
  readonly language: TLanguageEnum;
};

export type TInputUserRegisteredCreate = {
  readonly companyBranchId?: InputMaybe<Scalars['ID']>;
  readonly email: Scalars['String'];
  readonly language: TLanguageEnum;
  readonly password: Scalars['String'];
  /** The absolute URL that the User will visit to confirm the provided email or a relative URL that will be appended to an absolute URL taken from the HTTP referer. */
  readonly returnUrl: Scalars['String'];
  readonly token: Scalars['String'];
};

export type TInputSectorCreate = {
  readonly availabilities?: InputMaybe<ReadonlyArray<TInputAvailabilityCreate>>;
  readonly code: Scalars['String'];
  readonly companyBranch: Scalars['ID'];
  readonly deliveryType?: InputMaybe<TDeliveryTypeEnum>;
  readonly disabledWareCategories?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly eetEnabled?: InputMaybe<Scalars['Boolean']>;
  readonly enabled?: InputMaybe<Scalars['Boolean']>;
  readonly enabledWareCategories?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly gps?: InputMaybe<TInputGeoPointCreate>;
  readonly nameLabel: Scalars['String'];
  readonly orderDelaySeconds?: InputMaybe<Scalars['Int']>;
  readonly parent?: InputMaybe<Scalars['ID']>;
  readonly sectorType: TSectorTypeEnum;
  readonly warePriceType?: InputMaybe<TWarePriceTypeEnum>;
};

export type TInputSectorRecipeCreate = {
  readonly amount?: InputMaybe<Scalars['Int']>;
  readonly associatedRecipes?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly note?: InputMaybe<Scalars['String']>;
  readonly parent?: InputMaybe<Scalars['ID']>;
  readonly recipe: Scalars['ID'];
  readonly sector: Scalars['ID'];
  readonly sideDishes?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly warePriceType?: InputMaybe<TWarePriceTypeEnum>;
};

export type TInputShiftCreate = {
  readonly beginAt: Scalars['DateTime'];
  readonly capacity?: InputMaybe<Scalars['Int']>;
  readonly companyBranch: Scalars['ID'];
  readonly endAt: Scalars['DateTime'];
  readonly placeCode: Scalars['String'];
};

export type TInputStockItemCreate = {
  readonly allergens?: InputMaybe<ReadonlyArray<TAllergenEnum>>;
  readonly allowNegative: TFieldStateEnum;
  readonly code: Scalars['String'];
  readonly companyBranch: Scalars['ID'];
  readonly label: Scalars['String'];
  readonly note?: InputMaybe<Scalars['String']>;
  readonly plu?: InputMaybe<Scalars['String']>;
  readonly price?: InputMaybe<Scalars['Float']>;
  readonly quantity?: InputMaybe<Scalars['Float']>;
  readonly wareUnit: TWareUnitEnum;
};

export type TInputStockTransferCreate = {
  readonly quantity: Scalars['Float'];
  readonly stockItemId: Scalars['ID'];
};

/**
 * Schema of financial report from the terminal
 *
 *
 * INDEX: [admin, cashier_kiosk, cashier_reports, super_admin, support]
 *
 * READ: [admin, cashier_kiosk, cashier_reports, super_admin, support]
 *
 * CREATE: [admin, cashier_kiosk, cashier_reports, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TTerminalFinancialReport = {
  readonly __typename?: 'TerminalFinancialReport';
  readonly data: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly reportDatetime: Scalars['DateTime'];
};

export type TInputTransportationDeviceCreate = {
  readonly companyBranch: Scalars['ID'];
  readonly deviceState: Scalars['ID'];
  readonly deviceType: Scalars['ID'];
  readonly idNumber: Scalars['String'];
};

export type TInputUserCreate = {
  readonly companyBranches: ReadonlyArray<Scalars['ID']>;
  readonly email: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly language: TLanguageEnum;
  readonly lastName: Scalars['String'];
  readonly login: Scalars['String'];
  readonly phone: Scalars['String'];
  readonly roles: ReadonlyArray<TRoleEnum>;
};

export type TInputWareCreate = {
  readonly availabilities?: InputMaybe<ReadonlyArray<TInputAvailabilityCreate>>;
  readonly code?: InputMaybe<Scalars['String']>;
  readonly companyBranch: Scalars['ID'];
  readonly descriptionLabel: TInputLabelCreate;
  readonly enabled?: InputMaybe<Scalars['Boolean']>;
  readonly internalCode?: InputMaybe<Scalars['String']>;
  readonly nameLabel: TInputLabelCreate;
};

export type TInputWareCategoryCreate = {
  readonly automaticFinish?: InputMaybe<Scalars['Boolean']>;
  readonly availabilities?: InputMaybe<ReadonlyArray<TInputAvailabilityCreate>>;
  readonly companyBranch: Scalars['ID'];
  readonly descriptionLabel?: InputMaybe<Scalars['String']>;
  readonly dotykackaId?: InputMaybe<Scalars['ID']>;
  readonly enabled?: InputMaybe<Scalars['Boolean']>;
  readonly image?: InputMaybe<Scalars['InputFile']>;
  readonly integrationsWareCategories?: InputMaybe<TInputWareCategoryIntegrationsWareCategoriesCreate>;
  readonly internalNoteLabel?: InputMaybe<Scalars['String']>;
  readonly maxCount?: InputMaybe<Scalars['Int']>;
  readonly maxRecipesCount?: InputMaybe<Scalars['Int']>;
  readonly minCount?: InputMaybe<Scalars['Int']>;
  readonly nameLabel?: InputMaybe<Scalars['String']>;
  readonly orderOriginCategories?: InputMaybe<ReadonlyArray<TOrderOriginCategoryEnum>>;
  readonly pictogram?: InputMaybe<Scalars['String']>;
  readonly promoTags?: InputMaybe<ReadonlyArray<TPromoTagEnum>>;
  readonly public?: InputMaybe<Scalars['Boolean']>;
  readonly recipes?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly recipeTags?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly sharedCompanyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly translations?: InputMaybe<ReadonlyArray<TInputWareCategoryTranslation>>;
  readonly wareCategoryColor?: InputMaybe<Scalars['ID']>;
  readonly wareCategoryType: TWareCategoryTypeEnum;
};

export type TInputWareCategoryIntegrationsWareCategoriesCreate = {
  readonly boltProfileIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly foodoraProfileIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly jidloPodNosProfileIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly woltProfileIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};

export type TInputWareCategoryTranslation = {
  readonly descriptionLabel?: InputMaybe<Scalars['String']>;
  readonly internalNoteLabel?: InputMaybe<Scalars['String']>;
  readonly language: TLanguageEnum;
  readonly nameLabel?: InputMaybe<Scalars['String']>;
};

/**
 * Subcategory of ware categories. Every recipe can be part of different ware categories and can represent different recipe type (for example can be main dish in one category and dessert at another).
 *
 *
 * INDEX: [admin, editor_ware_category_relation, guest, operator, super_admin, support, user]
 *
 * READ: [admin, editor_ware_category_relation, guest, operator, super_admin, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_ware_category_relation, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, editor_ware_category_relation, operator, super_admin, support]
 *
 * DESTROY: [admin, editor_ware_category_relation, operator, super_admin]
 *
 */
export type TWareCategoryRelation = {
  readonly __typename?: 'WareCategoryRelation';
  readonly categoryOfWare: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly recipe: TRecipe;
  readonly wareCategory: TWareCategory;
};

export type TInputOrderWifiCreate = {
  readonly companyBranch: Scalars['ID'];
  readonly deliverySlot?: InputMaybe<Scalars['ID']>;
  readonly deliveryType?: InputMaybe<TDeliveryTypeEnum>;
  readonly occasion?: InputMaybe<Scalars['ID']>;
  readonly orderOrigin: TOrderOriginEnum;
  readonly sector?: InputMaybe<Scalars['ID']>;
  readonly warePriceType: TWarePriceTypeEnum;
};

export type TWoltInputProfileCreate = {
  readonly companyBranchId: Scalars['ID'];
  readonly isAutomaticMenuSyncEnabled?: InputMaybe<Scalars['Boolean']>;
  readonly name: Scalars['String'];
};

export type TInputZoneCreate = {
  readonly availabilities?: InputMaybe<ReadonlyArray<TInputAvailabilityCreate>>;
  readonly companyBranch: Scalars['ID'];
  readonly enabled?: InputMaybe<Scalars['Boolean']>;
  readonly geoPolygon?: InputMaybe<ReadonlyArray<TInputGeoPointCreate>>;
  readonly minimalOrderPrice?: InputMaybe<TInputCurrencyCreate>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly priceRangeRules?: InputMaybe<ReadonlyArray<TPriceRangeRuleCreate>>;
  readonly zoneColor?: InputMaybe<Scalars['ID']>;
  readonly zoneType?: InputMaybe<TZoneTypeEnum>;
};

export type TPriceRangeRuleCreate = {
  readonly price: TInputCurrencyCreate;
  readonly toPrice: TInputCurrencyCreate;
};

export type TInputRefundRequestType = {
  readonly accountHolder?: InputMaybe<Scalars['String']>;
  readonly accountNumber: Scalars['String'];
  readonly bicSwift?: InputMaybe<Scalars['String']>;
  readonly consentIds: ReadonlyArray<Scalars['ID']>;
  readonly email: Scalars['String'];
  readonly firstName?: InputMaybe<Scalars['String']>;
  readonly lastName?: InputMaybe<Scalars['String']>;
  readonly phone: Scalars['String'];
};

/** CustomerExport */
export type TCustomerExport = {
  readonly __typename?: 'CustomerExport';
  readonly maskedEmail: Maybe<Scalars['String']>;
  /** status of customer export */
  readonly success: Scalars['Boolean'];
};

export type TInputOrderPaymentMethodsCreate = {
  readonly paymentGate: TPaymentGateEnum;
  readonly paymentType: TPaymentTypeEnum;
  readonly price: TInputCurrencyCreate;
};

export type TInputOrderFinish = {
  readonly cancelUrl?: InputMaybe<Scalars['String']>;
  readonly confirmedAgreements?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly customer?: InputMaybe<TInputCustomerCreate>;
  /** Preferred time of order delivery. In case that argument is null, deliver_at value is computed based on branch opening hours and default delivery times */
  readonly deliverAt?: InputMaybe<Scalars['DateTime']>;
  readonly deliverySlot?: InputMaybe<Scalars['ID']>;
  readonly note?: InputMaybe<Scalars['String']>;
  /** payment gate used to finalize order */
  readonly paymentGate?: InputMaybe<TPaymentGateEnum>;
  /** payment type used to finalize order */
  readonly paymentMethod?: InputMaybe<TPaymentTypeEnum>;
  /** id of payment method  used to finalize order */
  readonly paymentMethodId?: InputMaybe<Scalars['ID']>;
  /** The absolute URL to check payment status within the application. Using a relative URL appended to the HTTP referer is deprecated. */
  readonly returnUrl?: InputMaybe<Scalars['String']>;
  /** percentage value of tips */
  readonly tips?: InputMaybe<Scalars['Float']>;
};

export type TFinishedOrder = TOnlinePaymentGatesInterface & {
  readonly __typename?: 'FinishedOrder';
  readonly csobUrl: Maybe<Scalars['String']>;
  readonly gopayUrl: Maybe<Scalars['String']>;
  readonly gpWebpayUrl: Maybe<Scalars['String']>;
  readonly order: TOrder;
  readonly payFastUrl: Maybe<Scalars['String']>;
  readonly payuUrl: Maybe<Scalars['String']>;
  /** errors which we should display to user */
  readonly userErrors: ReadonlyArray<Scalars['String']>;
};

export type TInputOrderStaffImport = {
  readonly acceptedAt?: InputMaybe<Scalars['DateTime']>;
  readonly acceptedAtRaw?: InputMaybe<Scalars['String']>;
  readonly canceled?: InputMaybe<Scalars['Boolean']>;
  readonly companyBranch: Scalars['ID'];
  readonly deliveryType?: InputMaybe<TDeliveryTypeEnum>;
  readonly fik?: InputMaybe<Scalars['String']>;
  readonly forceFinish?: InputMaybe<Scalars['Boolean']>;
  readonly id?: InputMaybe<Scalars['ID']>;
  readonly invoice: Scalars['String'];
  readonly invoiceNumber: Scalars['Int'];
  readonly orderRecipes: ReadonlyArray<TInputOrderRecipeCreates>;
  readonly paymentMethods: ReadonlyArray<TInputOrderPaymentMethodsCreate>;
  readonly recipePrices?: InputMaybe<ReadonlyArray<TInputRecipePriceCashBox>>;
  readonly sector?: InputMaybe<Scalars['ID']>;
  readonly totalDiscount?: InputMaybe<TInputCurrencyCreate>;
  readonly warePriceType: TWarePriceTypeEnum;
};

export type TInputRecipePriceCashBox = {
  readonly price: TInputCurrencyCreate;
  readonly recipe: Scalars['ID'];
};

/** Brief information about imported order */
export type TImportedOrder = {
  readonly __typename?: 'ImportedOrder';
  /** errors of import */
  readonly error: Maybe<Scalars['String']>;
  readonly id: Maybe<Scalars['ID']>;
  /** invoice sequence of cash_box */
  readonly invoiceSequenceCashBox: Scalars['Int'];
  /** status of order import */
  readonly success: Scalars['Boolean'];
};

export type TInputKioskEventLog = {
  readonly message: Scalars['String'];
  readonly terminalUuid: Scalars['String'];
  readonly timestamp: Scalars['DateTime'];
};

export type TPohodaExportPlanType = {
  readonly __typename?: 'PohodaExportPlanType';
  readonly message: Scalars['String'];
};

export type TInputIntegrationsBusinessHourCreate = {
  readonly closeAt: Scalars['Time'];
  readonly openAt: Scalars['Time'];
  readonly weekDay: TWeekDayEnum;
};

export type TReplayActivityResult = {
  readonly __typename?: 'ReplayActivityResult';
  readonly activity: TIntegrationsActivity;
};

export type TRequestEmailConfirmationCode = {
  readonly __typename?: 'RequestEmailConfirmationCode';
  readonly email: Scalars['String'];
};

export type TRequestPhoneConfirmationCode = {
  readonly __typename?: 'RequestPhoneConfirmationCode';
  readonly phone: Scalars['String'];
};


export type TRequestPhoneConfirmationCodePhoneArgs = {
  part?: InputMaybe<TPhonePartSelectorEnum>;
};

export type TInputAddressUpdate = {
  readonly addressType?: InputMaybe<TAddressTypeEnum>;
  readonly driverNote?: InputMaybe<Scalars['String']>;
  readonly gps?: InputMaybe<TInputGeoPointCreate>;
  readonly title?: InputMaybe<Scalars['String']>;
};

export type TInputFileUpdate = {
  readonly delete?: InputMaybe<Scalars['Boolean']>;
  readonly file?: InputMaybe<Scalars['InputFile']>;
};

export type TInputBoardFeaturesUpdate = {
  readonly allergensEnabled?: InputMaybe<Scalars['Boolean']>;
  readonly infoMessageEnabled?: InputMaybe<Scalars['Boolean']>;
  readonly logoEnabled?: InputMaybe<Scalars['Boolean']>;
  readonly promoEnabled?: InputMaybe<Scalars['Boolean']>;
  readonly titleEnabled?: InputMaybe<Scalars['Boolean']>;
};

/** Bolt availability state values. */
export type TBoltAvailabilityStateGlEnum =
  | 'ACTIVE'
  | 'INACTIVE';

export type TBoltInputProfileUpdate = {
  readonly isAutomaticMenuSyncEnabled?: InputMaybe<Scalars['Boolean']>;
  readonly isDeleted?: InputMaybe<Scalars['Boolean']>;
  readonly name?: InputMaybe<Scalars['String']>;
};

export type TInputCompanyBranchRecipeUpdate = {
  readonly bistroId?: InputMaybe<Scalars['ID']>;
  readonly dotykackaId?: InputMaybe<Scalars['ID']>;
  readonly enabled?: InputMaybe<Scalars['Boolean']>;
  readonly id: Scalars['ID'];
  readonly soldOut?: InputMaybe<Scalars['Boolean']>;
};

export type TInputCompanyBranchUserUpdate = {
  readonly deleted?: InputMaybe<Scalars['Boolean']>;
  readonly driverSetting?: InputMaybe<TInputCompanyBranchUserDriverSetting>;
};

export type TInputCompanyBranchWareCategoryUpdate = {
  readonly dotykackaId?: InputMaybe<Scalars['ID']>;
  readonly enabled?: InputMaybe<Scalars['Boolean']>;
  readonly id: Scalars['ID'];
};

export type TDotykackaInputProfileUpdate = {
  readonly isAutomaticMenuSyncEnabled?: InputMaybe<Scalars['Boolean']>;
  readonly isDeleted?: InputMaybe<Scalars['Boolean']>;
  readonly name?: InputMaybe<Scalars['String']>;
};

export type TExpressDeliverySettingUpdate = {
  readonly expressBaseTimeMinutes?: InputMaybe<Scalars['Int']>;
  readonly expressFee?: InputMaybe<Scalars['Float']>;
  readonly isExpressEnabled?: InputMaybe<Scalars['Boolean']>;
  readonly maxOrderValue?: InputMaybe<Scalars['Float']>;
  readonly ordersInProgressLimit?: InputMaybe<Scalars['Int']>;
  readonly pausedFrom?: InputMaybe<Scalars['DateTime']>;
  readonly pausedUntil?: InputMaybe<Scalars['DateTime']>;
};

/** Foodora availability state values. */
export type TFoodoraAvailabilityStateGlEnum =
  | 'CLOSED'
  | 'CLOSED_TODAY'
  | 'CLOSED_UNTIL'
  | 'INACTIVE'
  | 'OPEN'
  | 'UNKNOWN';

/** FoodoraClosedReason enum */
export type TFoodoraClosedReasonEnum =
  | 'AREA_DISRUPTION'
  | 'BAD_WEATHER'
  | 'CHECK_IN_FAILED'
  | 'CHECK_IN_REQUIRED'
  | 'CLOSED'
  | 'COMPLIANCE_ISSUES'
  | 'COURIER_DELAYED_AT_PICKUP'
  | 'FOOD_HYGIENE'
  | 'FRAUD'
  | 'HOLIDAY_SPECIAL_DAY'
  | 'OFFBOARDING'
  | 'ONBOARDING'
  | 'ORDER_FAILURE'
  | 'OTHER'
  | 'OWNERSHIP_CHANGE'
  | 'REFURBISHMENT'
  | 'RELIGIOUS_OBSERVANCE'
  | 'RESTRICTED_VISIBILITY'
  | 'RETENTION'
  | 'TECHNICAL_PROBLEM'
  | 'TOO_BUSY_KITCHEN'
  | 'TOO_BUSY_NO_DRIVERS'
  | 'TOO_MANY_REJECTED_ORDERS'
  | 'UNREACHABLE'
  | 'UPDATES_IN_MENU';

export type TFoodoraInputProfileUpdate = {
  readonly isAutomaticMenuSyncEnabled?: InputMaybe<Scalars['Boolean']>;
  readonly isDeleted?: InputMaybe<Scalars['Boolean']>;
  readonly name?: InputMaybe<Scalars['String']>;
};

export type TJidloPodNosInputProfileUpdate = {
  readonly isAutomaticMenuSyncEnabled?: InputMaybe<Scalars['Boolean']>;
  readonly isDeleted?: InputMaybe<Scalars['Boolean']>;
  readonly name?: InputMaybe<Scalars['String']>;
};

export type TInputOccasionUpdate = {
  /** Date when occasion begins */
  readonly dateFrom?: InputMaybe<Scalars['DateTime']>;
  /** Date when occasions ends */
  readonly dateTo?: InputMaybe<Scalars['DateTime']>;
  readonly image?: InputMaybe<TInputRecipeImage>;
  /** Beginning of preorder */
  readonly preorderFrom?: InputMaybe<Scalars['DateTime']>;
  /** End of preorder */
  readonly preorderTo?: InputMaybe<Scalars['DateTime']>;
  readonly title?: InputMaybe<Scalars['String']>;
  /** Short title for mobile view */
  readonly titleShort?: InputMaybe<Scalars['String']>;
};

export type TInputRecipeImage = {
  readonly delete: Scalars['Boolean'];
  readonly file?: InputMaybe<Scalars['InputFile']>;
};

export type TInputOrderUpdate = {
  readonly address?: InputMaybe<Scalars['String']>;
  readonly companyBranch?: InputMaybe<Scalars['ID']>;
  readonly customer?: InputMaybe<TInputCustomerCreate>;
  readonly deliverAt?: InputMaybe<Scalars['DateTime']>;
  readonly deliverySlot?: InputMaybe<Scalars['ID']>;
  readonly deliveryType?: InputMaybe<TDeliveryTypeEnum>;
  readonly gps?: InputMaybe<TInputGeoPointCreate>;
  readonly isExpress?: InputMaybe<Scalars['Boolean']>;
  readonly language?: InputMaybe<TLanguageEnum>;
  readonly location?: InputMaybe<TInputLocationCreate>;
  readonly note?: InputMaybe<Scalars['String']>;
  readonly notification?: InputMaybe<TInputNotificationCreate>;
  readonly orderGroup?: InputMaybe<Scalars['ID']>;
  readonly resolvedAddress?: InputMaybe<TInputOrderResolvedAddressType>;
  /** percentage value of tips */
  readonly tips?: InputMaybe<Scalars['Float']>;
  readonly warePriceType?: InputMaybe<TWarePriceTypeEnum>;
};

export type TInputOrderGroupUpdate = {
  readonly addedOrders?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly id: Scalars['ID'];
  readonly name?: InputMaybe<Scalars['String']>;
  readonly orderGroupColor?: InputMaybe<Scalars['ID']>;
  readonly removedOrders?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly updatedOrders?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};

export type TInputOrderPaymentMethodUpdate = {
  readonly paymentMethodId: Scalars['ID'];
  readonly price: TInputCurrencyCreate;
};

/** Objects which may be commented on */
export type TOrderDiffEntry = {
  readonly __typename?: 'OrderDiffEntry';
  readonly attribute: TOrderDiffAttributeEnum;
  readonly changeType: TOrderDiffChangeTypeEnum;
  readonly newData: Maybe<TOrderDiffAttribute>;
  readonly oldData: Maybe<TOrderDiffAttribute>;
};

/** Possible attributes which may change in updateOrderPreview */
export type TOrderDiffAttributeEnum =
  | 'COMPANY_BRANCH'
  | 'DELIVER_AT'
  | 'DELIVERY_SLOT'
  | 'DELIVERY_TYPE'
  | 'EXPRESS_DELIVERY'
  | 'ORDER_RECIPE_MAIN'
  | 'ORDER_RECIPE_SIDE_DISH'
  | 'PRICE_EXTRA_CHARGE'
  | 'PRICE_TIP'
  | 'PRICE_TOTAL_SUM'
  | 'PRICE_TRANSPORT_FEE'
  | 'SERVICE_FEE';

/** Possible change types of OrderDiff */
export type TOrderDiffChangeTypeEnum =
  | 'ADD'
  | 'REMOVE'
  | 'UPDATE';

/** Objects which may be returned from OrderUpdatePreview */
export type TOrderDiffAttribute = TCompanyBranch | TDateTimeWrapped | TDeliverySlot | TDeliveryType | TOrderExpressDelivery | TOrderRecipe | TOrderServiceFee | TPriceConverted;

/** Wrapper for DateTime scalar type. Used in union types. */
export type TDateTimeWrapped = {
  readonly __typename?: 'DateTimeWrapped';
  readonly value: Scalars['DateTime'];
};

export type TInputOrderRecipeUpdate = {
  readonly dynamicPrice?: InputMaybe<TInputCurrencyCreate>;
  readonly note?: InputMaybe<Scalars['String']>;
  readonly order?: InputMaybe<Scalars['ID']>;
  readonly orderRecipeState?: InputMaybe<TOrderRecipeStateEnum>;
  readonly parent?: InputMaybe<Scalars['ID']>;
  readonly recipe?: InputMaybe<Scalars['ID']>;
  readonly sideDishes?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly sideDishRecipes?: InputMaybe<ReadonlyArray<TInputOrderRecipeSideDishUpdate>>;
};

export type TInputOrderRecipeSideDishUpdate = {
  readonly categoryId: Scalars['ID'];
  readonly recipeId: Scalars['ID'];
};

export type TInputOrderTipUpdate = {
  /** absolute value of the tip */
  readonly absoluteValue?: InputMaybe<Scalars['Float']>;
  /** percentage value of the tip */
  readonly percentageValue?: InputMaybe<Scalars['Float']>;
};

export type TInputImage = {
  readonly delete?: InputMaybe<Scalars['Boolean']>;
  readonly file?: InputMaybe<Scalars['InputFile']>;
};

export type TInputRecipeUpdate = {
  readonly ageControl?: InputMaybe<Scalars['Boolean']>;
  readonly associatedRecipes?: InputMaybe<ReadonlyArray<TInputRecipeRelationCreate>>;
  readonly code?: InputMaybe<Scalars['String']>;
  readonly descriptionLabel?: InputMaybe<Scalars['String']>;
  readonly enabled?: InputMaybe<Scalars['Boolean']>;
  readonly groups?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly image?: InputMaybe<TInputRecipeImage>;
  readonly ingredients?: InputMaybe<ReadonlyArray<TInputRecipeIngredient>>;
  readonly internalNote?: InputMaybe<Scalars['String']>;
  readonly isCombinationMeal?: InputMaybe<Scalars['Boolean']>;
  readonly isDynamicPricingEnabled?: InputMaybe<Scalars['Boolean']>;
  readonly nameLabel?: InputMaybe<Scalars['String']>;
  readonly pictogram?: InputMaybe<Scalars['String']>;
  readonly prices?: InputMaybe<ReadonlyArray<TInputRecipePriceCreate>>;
  readonly primaryWareCategory?: InputMaybe<Scalars['ID']>;
  readonly recipeColor?: InputMaybe<Scalars['ID']>;
  readonly recipeTags?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly sideDishCategories?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly soldOut?: InputMaybe<Scalars['Boolean']>;
  readonly translations?: InputMaybe<ReadonlyArray<TInputRecipeTranslation>>;
  readonly video?: InputMaybe<Scalars['String']>;
  readonly ware?: InputMaybe<Scalars['ID']>;
  readonly wareCategories?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};

export type TInputRecipeTagUpdate = {
  readonly color?: InputMaybe<Scalars['String']>;
  readonly company?: InputMaybe<Scalars['ID']>;
  readonly deleteLabel?: InputMaybe<Scalars['Boolean']>;
  readonly image?: InputMaybe<TInputRecipeTagImage>;
  readonly pictogram?: InputMaybe<Scalars['String']>;
  readonly systemRecipeTag?: InputMaybe<Scalars['ID']>;
  readonly translations?: InputMaybe<ReadonlyArray<TInputRecipeTagTranslation>>;
};

export type TInputRecipeTagImage = {
  readonly delete?: InputMaybe<Scalars['Boolean']>;
  readonly file?: InputMaybe<Scalars['InputFile']>;
};

export type TInputSectorUpdate = {
  readonly availabilities?: InputMaybe<ReadonlyArray<TInputAvailabilityCreate>>;
  readonly code?: InputMaybe<Scalars['String']>;
  readonly companyBranch?: InputMaybe<Scalars['ID']>;
  readonly deliveryType?: InputMaybe<TDeliveryTypeEnum>;
  readonly disabledWareCategories?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly eetEnabled?: InputMaybe<Scalars['Boolean']>;
  readonly enabled?: InputMaybe<Scalars['Boolean']>;
  readonly enabledWareCategories?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly gps?: InputMaybe<TInputGeoPointCreate>;
  readonly id: Scalars['ID'];
  readonly orderDelaySeconds?: InputMaybe<Scalars['Int']>;
  readonly parent?: InputMaybe<Scalars['ID']>;
  readonly sectorType?: InputMaybe<TSectorTypeEnum>;
  readonly translations?: InputMaybe<ReadonlyArray<TInputSectorTranslation>>;
  readonly warePriceType?: InputMaybe<TWarePriceTypeEnum>;
};

export type TInputSectorTranslation = {
  readonly language: TLanguageEnum;
  readonly nameLabel?: InputMaybe<Scalars['String']>;
};

export type TInputStockInventoryItemUpdate = {
  readonly finalQuantity: Scalars['Float'];
  readonly stockInventoryItemChangeType?: InputMaybe<TStockInventoryItemChangeTypeEnum>;
  readonly stockItemChangeType?: InputMaybe<TStockInventoryItemChangeTypeEnum>;
};

export type TInputStockItemUpdate = {
  readonly allergens?: InputMaybe<ReadonlyArray<TAllergenEnum>>;
  readonly allowNegative?: InputMaybe<TFieldStateEnum>;
  readonly code?: InputMaybe<Scalars['String']>;
  readonly label?: InputMaybe<Scalars['String']>;
  readonly note?: InputMaybe<Scalars['String']>;
  readonly plu?: InputMaybe<Scalars['String']>;
  readonly price?: InputMaybe<Scalars['Float']>;
  readonly quantity?: InputMaybe<Scalars['Float']>;
  readonly wareUnit?: InputMaybe<TWareUnitEnum>;
};

export type TInputUserUpdate = {
  readonly email?: InputMaybe<Scalars['String']>;
  readonly firstName?: InputMaybe<Scalars['String']>;
  readonly language?: InputMaybe<TLanguageEnum>;
  readonly lastName?: InputMaybe<Scalars['String']>;
  readonly phone?: InputMaybe<Scalars['String']>;
  readonly roles?: InputMaybe<ReadonlyArray<TRoleEnum>>;
};

/** New token after updating password */
export type TUserUpdatedPassword = {
  readonly __typename?: 'UserUpdatedPassword';
  /** user id */
  readonly id: Scalars['ID'];
  /** users token */
  readonly token: Scalars['String'];
};

export type TInputWareUpdate = {
  readonly code?: InputMaybe<Scalars['String']>;
  readonly companyBranch?: InputMaybe<Scalars['ID']>;
  readonly descriptionLabel?: InputMaybe<TInputLabelUpdate>;
  readonly enabled?: InputMaybe<Scalars['Boolean']>;
  readonly internalCode?: InputMaybe<Scalars['String']>;
  readonly nameLabel?: InputMaybe<TInputLabelUpdate>;
};

export type TInputLabelUpdate = {
  readonly enabled?: InputMaybe<Scalars['Boolean']>;
  readonly translations?: InputMaybe<ReadonlyArray<TInputLabelTranslation>>;
};

export type TInputWareCategoryUpdate = {
  readonly automaticFinish?: InputMaybe<Scalars['Boolean']>;
  readonly enabled?: InputMaybe<Scalars['Boolean']>;
  readonly image?: InputMaybe<TInputWareCategoryImage>;
  readonly integrationsWareCategories?: InputMaybe<TInputWareCategoryIntegrationsWareCategoriesUpdate>;
  readonly internalNoteLabel?: InputMaybe<Scalars['String']>;
  readonly maxCount?: InputMaybe<Scalars['Int']>;
  readonly maxRecipesCount?: InputMaybe<Scalars['Int']>;
  readonly minCount?: InputMaybe<Scalars['Int']>;
  readonly nameLabel?: InputMaybe<Scalars['String']>;
  readonly orderOriginCategories?: InputMaybe<ReadonlyArray<TOrderOriginCategoryEnum>>;
  readonly pictogram?: InputMaybe<Scalars['String']>;
  readonly promoTags?: InputMaybe<ReadonlyArray<TPromoTagEnum>>;
  readonly public?: InputMaybe<Scalars['Boolean']>;
  readonly recipes?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly recipeTags?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly sharedCompanyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly translations?: InputMaybe<ReadonlyArray<TInputWareCategoryTranslation>>;
  readonly wareCategoryColor?: InputMaybe<Scalars['ID']>;
  readonly wareCategoryType?: InputMaybe<TWareCategoryTypeEnum>;
  readonly wareRequirement?: InputMaybe<TWareRequirementEnum>;
};

export type TInputWareCategoryImage = {
  readonly delete: Scalars['Boolean'];
  readonly file?: InputMaybe<Scalars['InputFile']>;
};

export type TInputWareCategoryIntegrationsWareCategoriesUpdate = {
  readonly boltProfileIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly foodoraProfileIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly jidloPodNosProfileIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly woltProfileIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};

/** WareRequirement enum */
export type TWareRequirementEnum =
  | 'MANDATORY'
  | 'MAX_ONE'
  | 'NO_LIMIT'
  | 'OPTIONAL';

export type TWoltInputProfileUpdate = {
  readonly isAutomaticMenuSyncEnabled?: InputMaybe<Scalars['Boolean']>;
  readonly isDeleted?: InputMaybe<Scalars['Boolean']>;
  readonly name?: InputMaybe<Scalars['String']>;
};

export type TInputZoneUpdate = {
  readonly availabilities?: InputMaybe<ReadonlyArray<TInputAvailabilityUpdate>>;
  readonly companyBranch?: InputMaybe<Scalars['ID']>;
  readonly deliveryTimeDeviation?: InputMaybe<Scalars['Int']>;
  readonly enabled?: InputMaybe<Scalars['Boolean']>;
  readonly geoPolygon?: InputMaybe<ReadonlyArray<TInputGeoPointCreate>>;
  readonly minimalOrderPrice?: InputMaybe<TInputCurrencyCreate>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly priceRangeRules?: InputMaybe<ReadonlyArray<TPriceRangeRuleCreate>>;
  readonly zoneColor?: InputMaybe<Scalars['ID']>;
};

export type TInputAvailabilityUpdate = {
  readonly availabilityType?: InputMaybe<TAvailabilityTypeEnum>;
  readonly available?: InputMaybe<Scalars['Boolean']>;
  readonly dateFrom?: InputMaybe<Scalars['Date']>;
  readonly dateTo?: InputMaybe<Scalars['Date']>;
  readonly orderOriginCategories?: InputMaybe<ReadonlyArray<TOrderOriginCategoryEnum>>;
  readonly periodic?: InputMaybe<Scalars['Boolean']>;
  readonly timeFrom?: InputMaybe<Scalars['Time']>;
  readonly timeTo?: InputMaybe<Scalars['Time']>;
  readonly weekDay?: InputMaybe<TWeekDayEnum>;
};

/** Information about call hangup */
export type TUserCustomerHangup = {
  readonly __typename?: 'UserCustomerHangup';
  /** ID of created event */
  readonly eventId: Scalars['ID'];
  /** Created order */
  readonly order: Maybe<TOrder>;
  /** ID of original event */
  readonly originalEventId: Scalars['ID'];
};

/** Hold registration token for phone number of the current user */
export type TCurrentUserValidation = {
  readonly __typename?: 'CurrentUserValidation';
  readonly token: Scalars['String'];
};

/** Hold registration token and information about user presence for given phone number */
export type TPhoneCodeValidation = {
  readonly __typename?: 'PhoneCodeValidation';
  readonly token: Scalars['String'];
  readonly userExists: Scalars['Boolean'];
};

export type TWoltOnboardingUrl = {
  readonly __typename?: 'WoltOnboardingUrl';
  readonly profile: TWoltProfile;
  readonly url: Scalars['String'];
};

/** Profile information from Wolt */
export type TWoltProfileStatus = {
  readonly __typename?: 'WoltProfileStatus';
  readonly ipadFreeStatus: Scalars['Boolean'];
  readonly onlineState: TIntegrationState;
  readonly openingTimes: ReadonlyArray<TWoltBusinessHour>;
  readonly openStatus: Scalars['Boolean'];
  readonly specialTimes: ReadonlyArray<TWoltBusinessHour>;
};

/**
 * Business hours for Wolt profile
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, editor_business_hour, editor_business_hours, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, editor_business_hour, editor_business_hours, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_business_hour, editor_business_hours, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_business_hour, editor_business_hours, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_business_hour, editor_business_hours, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TWoltBusinessHour = {
  readonly __typename?: 'WoltBusinessHour';
  readonly closeAt: Scalars['Time'];
  readonly openAt: Scalars['Time'];
  readonly specificDate: Maybe<Scalars['Date']>;
  readonly specificDateLocalized: Maybe<Scalars['String']>;
  readonly type: TBusinessHoursTypeEnum;
  readonly weekDay: Maybe<TWeekDay>;
};

/** The subscription root of this schema */
export type TSubscription = {
  readonly __typename?: 'Subscription';
  /**
   *
   *
   * ALLOWED ROLES: [access_config, account_manager, accountant, admin, branch_owner, brand_owner, call_center, cashier, cashier_allowed_delivery_types, cashier_basic_recipes, cashier_cancel, cashier_change_delivery_type, cashier_delivery, cashier_isolated_print, cashier_kiosk, cashier_menu, cashier_payment_methods, cashier_pos, cashier_process_time, cashier_refund, cashier_reports, cashier_reports_with_products, cashier_statistics, cashier_transfer_company_branch, cashier_unlimited, cashier_unlimited_customer, cashier_without_print, cashless_supervisor, customer, driver, driver_default, driver_dodo, driver_foodis, driver_foodora_go, driver_liftago, driver_prorozvoz, driver_wolt_drive, editor, editor_address, editor_announcement, editor_availability, editor_billings, editor_business_hour, editor_business_hours, editor_cash_box, editor_company, editor_company_branch, editor_company_branch_currency, editor_company_branch_delivery, editor_company_branch_user, editor_company_order_origin, editor_country, editor_country_vat, editor_country_vat_price_type, editor_country_vat_type_price, editor_currency, editor_event, editor_financial_report, editor_import_log, editor_ingredient, editor_integrations, editor_label, editor_label_translation, editor_menu, editor_note, editor_order, editor_order_billing, editor_order_discount, editor_order_origin_price_type, editor_order_payment_method, editor_order_price_modification, editor_order_recipe, editor_order_state_relation, editor_orders, editor_page_element, editor_payment_method, editor_payment_method_branch, editor_promo_code, editor_recipe, editor_recipe_price, editor_recipe_relation, editor_rejected_payment_method, editor_role, editor_setting, editor_shift, editor_shift_user, editor_sorting, editor_stock_item, editor_stock_item_allergen, editor_stock_transfer, editor_transportation_device, editor_transportation_device_user, editor_user, editor_user_delivering_order, editor_user_login_provider, editor_user_personal, editor_wallet_credits, editor_wallet_credits_refund, editor_ware, editor_ware_category, editor_ware_category_relation, editor_zone, editor_zones, export_customers, extern, external_api, gastra_api, guest, liftago, merchant, operator, owner_cancel, request_cancel, request_external_driver, sales_representative, super_admin, supervisor, support, suspended_user, templatable_manager, user, vam]
   *
   */
  readonly updatedExternalDelivery: TExternalDeliveryUpdateSubscription;
  /**
   *
   *
   * ALLOWED ROLES: [access_config, account_manager, accountant, admin, branch_owner, brand_owner, call_center, cashier, cashier_allowed_delivery_types, cashier_basic_recipes, cashier_cancel, cashier_change_delivery_type, cashier_delivery, cashier_isolated_print, cashier_kiosk, cashier_menu, cashier_payment_methods, cashier_pos, cashier_process_time, cashier_refund, cashier_reports, cashier_reports_with_products, cashier_statistics, cashier_transfer_company_branch, cashier_unlimited, cashier_unlimited_customer, cashier_without_print, cashless_supervisor, customer, driver, driver_default, driver_dodo, driver_foodis, driver_foodora_go, driver_liftago, driver_prorozvoz, driver_wolt_drive, editor, editor_address, editor_announcement, editor_availability, editor_billings, editor_business_hour, editor_business_hours, editor_cash_box, editor_company, editor_company_branch, editor_company_branch_currency, editor_company_branch_delivery, editor_company_branch_user, editor_company_order_origin, editor_country, editor_country_vat, editor_country_vat_price_type, editor_country_vat_type_price, editor_currency, editor_event, editor_financial_report, editor_import_log, editor_ingredient, editor_integrations, editor_label, editor_label_translation, editor_menu, editor_note, editor_order, editor_order_billing, editor_order_discount, editor_order_origin_price_type, editor_order_payment_method, editor_order_price_modification, editor_order_recipe, editor_order_state_relation, editor_orders, editor_page_element, editor_payment_method, editor_payment_method_branch, editor_promo_code, editor_recipe, editor_recipe_price, editor_recipe_relation, editor_rejected_payment_method, editor_role, editor_setting, editor_shift, editor_shift_user, editor_sorting, editor_stock_item, editor_stock_item_allergen, editor_stock_transfer, editor_transportation_device, editor_transportation_device_user, editor_user, editor_user_delivering_order, editor_user_login_provider, editor_user_personal, editor_wallet_credits, editor_wallet_credits_refund, editor_ware, editor_ware_category, editor_ware_category_relation, editor_zone, editor_zones, export_customers, extern, external_api, gastra_api, guest, liftago, merchant, operator, owner_cancel, request_cancel, request_external_driver, sales_representative, super_admin, supervisor, support, suspended_user, templatable_manager, user, vam]
   *
   */
  readonly updatedOrder: TOrderUpdateSubscription;
  /**
   *
   *
   * ALLOWED ROLES: [access_config, account_manager, accountant, admin, branch_owner, brand_owner, call_center, cashier, cashier_allowed_delivery_types, cashier_basic_recipes, cashier_cancel, cashier_change_delivery_type, cashier_delivery, cashier_isolated_print, cashier_kiosk, cashier_menu, cashier_payment_methods, cashier_pos, cashier_process_time, cashier_refund, cashier_reports, cashier_reports_with_products, cashier_statistics, cashier_transfer_company_branch, cashier_unlimited, cashier_unlimited_customer, cashier_without_print, cashless_supervisor, customer, driver, driver_default, driver_dodo, driver_foodis, driver_foodora_go, driver_liftago, driver_prorozvoz, driver_wolt_drive, editor, editor_address, editor_announcement, editor_availability, editor_billings, editor_business_hour, editor_business_hours, editor_cash_box, editor_company, editor_company_branch, editor_company_branch_currency, editor_company_branch_delivery, editor_company_branch_user, editor_company_order_origin, editor_country, editor_country_vat, editor_country_vat_price_type, editor_country_vat_type_price, editor_currency, editor_event, editor_financial_report, editor_import_log, editor_ingredient, editor_integrations, editor_label, editor_label_translation, editor_menu, editor_note, editor_order, editor_order_billing, editor_order_discount, editor_order_origin_price_type, editor_order_payment_method, editor_order_price_modification, editor_order_recipe, editor_order_state_relation, editor_orders, editor_page_element, editor_payment_method, editor_payment_method_branch, editor_promo_code, editor_recipe, editor_recipe_price, editor_recipe_relation, editor_rejected_payment_method, editor_role, editor_setting, editor_shift, editor_shift_user, editor_sorting, editor_stock_item, editor_stock_item_allergen, editor_stock_transfer, editor_transportation_device, editor_transportation_device_user, editor_user, editor_user_delivering_order, editor_user_login_provider, editor_user_personal, editor_wallet_credits, editor_wallet_credits_refund, editor_ware, editor_ware_category, editor_ware_category_relation, editor_zone, editor_zones, export_customers, extern, external_api, gastra_api, guest, liftago, merchant, operator, owner_cancel, request_cancel, request_external_driver, sales_representative, super_admin, supervisor, support, suspended_user, templatable_manager, user, vam]
   *
   */
  readonly updatedOrderCategoryCount: TOrderCategoryCountSubscription;
  /**
   *
   *
   * ALLOWED ROLES: [access_config, account_manager, accountant, admin, branch_owner, brand_owner, call_center, cashier, cashier_allowed_delivery_types, cashier_basic_recipes, cashier_cancel, cashier_change_delivery_type, cashier_delivery, cashier_isolated_print, cashier_kiosk, cashier_menu, cashier_payment_methods, cashier_pos, cashier_process_time, cashier_refund, cashier_reports, cashier_reports_with_products, cashier_statistics, cashier_transfer_company_branch, cashier_unlimited, cashier_unlimited_customer, cashier_without_print, cashless_supervisor, customer, driver, driver_default, driver_dodo, driver_foodis, driver_foodora_go, driver_liftago, driver_prorozvoz, driver_wolt_drive, editor, editor_address, editor_announcement, editor_availability, editor_billings, editor_business_hour, editor_business_hours, editor_cash_box, editor_company, editor_company_branch, editor_company_branch_currency, editor_company_branch_delivery, editor_company_branch_user, editor_company_order_origin, editor_country, editor_country_vat, editor_country_vat_price_type, editor_country_vat_type_price, editor_currency, editor_event, editor_financial_report, editor_import_log, editor_ingredient, editor_integrations, editor_label, editor_label_translation, editor_menu, editor_note, editor_order, editor_order_billing, editor_order_discount, editor_order_origin_price_type, editor_order_payment_method, editor_order_price_modification, editor_order_recipe, editor_order_state_relation, editor_orders, editor_page_element, editor_payment_method, editor_payment_method_branch, editor_promo_code, editor_recipe, editor_recipe_price, editor_recipe_relation, editor_rejected_payment_method, editor_role, editor_setting, editor_shift, editor_shift_user, editor_sorting, editor_stock_item, editor_stock_item_allergen, editor_stock_transfer, editor_transportation_device, editor_transportation_device_user, editor_user, editor_user_delivering_order, editor_user_login_provider, editor_user_personal, editor_wallet_credits, editor_wallet_credits_refund, editor_ware, editor_ware_category, editor_ware_category_relation, editor_zone, editor_zones, export_customers, extern, external_api, gastra_api, guest, liftago, merchant, operator, owner_cancel, request_cancel, request_external_driver, sales_representative, super_admin, supervisor, support, suspended_user, templatable_manager, user, vam]
   *
   */
  readonly updatedOrdersCount: TOrderCountSubscription;
  /**
   *
   *
   * ALLOWED ROLES: [access_config, account_manager, accountant, admin, branch_owner, brand_owner, call_center, cashier, cashier_allowed_delivery_types, cashier_basic_recipes, cashier_cancel, cashier_change_delivery_type, cashier_delivery, cashier_isolated_print, cashier_kiosk, cashier_menu, cashier_payment_methods, cashier_pos, cashier_process_time, cashier_refund, cashier_reports, cashier_reports_with_products, cashier_statistics, cashier_transfer_company_branch, cashier_unlimited, cashier_unlimited_customer, cashier_without_print, cashless_supervisor, customer, driver, driver_default, driver_dodo, driver_foodis, driver_foodora_go, driver_liftago, driver_prorozvoz, driver_wolt_drive, editor, editor_address, editor_announcement, editor_availability, editor_billings, editor_business_hour, editor_business_hours, editor_cash_box, editor_company, editor_company_branch, editor_company_branch_currency, editor_company_branch_delivery, editor_company_branch_user, editor_company_order_origin, editor_country, editor_country_vat, editor_country_vat_price_type, editor_country_vat_type_price, editor_currency, editor_event, editor_financial_report, editor_import_log, editor_ingredient, editor_integrations, editor_label, editor_label_translation, editor_menu, editor_note, editor_order, editor_order_billing, editor_order_discount, editor_order_origin_price_type, editor_order_payment_method, editor_order_price_modification, editor_order_recipe, editor_order_state_relation, editor_orders, editor_page_element, editor_payment_method, editor_payment_method_branch, editor_promo_code, editor_recipe, editor_recipe_price, editor_recipe_relation, editor_rejected_payment_method, editor_role, editor_setting, editor_shift, editor_shift_user, editor_sorting, editor_stock_item, editor_stock_item_allergen, editor_stock_transfer, editor_transportation_device, editor_transportation_device_user, editor_user, editor_user_delivering_order, editor_user_login_provider, editor_user_personal, editor_wallet_credits, editor_wallet_credits_refund, editor_ware, editor_ware_category, editor_ware_category_relation, editor_zone, editor_zones, export_customers, extern, external_api, gastra_api, guest, liftago, merchant, operator, owner_cancel, request_cancel, request_external_driver, sales_representative, super_admin, supervisor, support, suspended_user, templatable_manager, user, vam]
   *
   */
  readonly updatedPrintQueue: TPrintQueueUpdateSubscription;
  /**
   *
   *
   * ALLOWED ROLES: [access_config, account_manager, accountant, admin, branch_owner, brand_owner, call_center, cashier, cashier_allowed_delivery_types, cashier_basic_recipes, cashier_cancel, cashier_change_delivery_type, cashier_delivery, cashier_isolated_print, cashier_kiosk, cashier_menu, cashier_payment_methods, cashier_pos, cashier_process_time, cashier_refund, cashier_reports, cashier_reports_with_products, cashier_statistics, cashier_transfer_company_branch, cashier_unlimited, cashier_unlimited_customer, cashier_without_print, cashless_supervisor, customer, driver, driver_default, driver_dodo, driver_foodis, driver_foodora_go, driver_liftago, driver_prorozvoz, driver_wolt_drive, editor, editor_address, editor_announcement, editor_availability, editor_billings, editor_business_hour, editor_business_hours, editor_cash_box, editor_company, editor_company_branch, editor_company_branch_currency, editor_company_branch_delivery, editor_company_branch_user, editor_company_order_origin, editor_country, editor_country_vat, editor_country_vat_price_type, editor_country_vat_type_price, editor_currency, editor_event, editor_financial_report, editor_import_log, editor_ingredient, editor_integrations, editor_label, editor_label_translation, editor_menu, editor_note, editor_order, editor_order_billing, editor_order_discount, editor_order_origin_price_type, editor_order_payment_method, editor_order_price_modification, editor_order_recipe, editor_order_state_relation, editor_orders, editor_page_element, editor_payment_method, editor_payment_method_branch, editor_promo_code, editor_recipe, editor_recipe_price, editor_recipe_relation, editor_rejected_payment_method, editor_role, editor_setting, editor_shift, editor_shift_user, editor_sorting, editor_stock_item, editor_stock_item_allergen, editor_stock_transfer, editor_transportation_device, editor_transportation_device_user, editor_user, editor_user_delivering_order, editor_user_login_provider, editor_user_personal, editor_wallet_credits, editor_wallet_credits_refund, editor_ware, editor_ware_category, editor_ware_category_relation, editor_zone, editor_zones, export_customers, extern, external_api, gastra_api, guest, liftago, merchant, operator, owner_cancel, request_cancel, request_external_driver, sales_representative, super_admin, supervisor, support, suspended_user, templatable_manager, user, vam]
   *
   */
  readonly updatedSectorRecipe: TSectorRecipeUpdateSubscription;
  /**
   *
   *
   * ALLOWED ROLES: [access_config, account_manager, accountant, admin, branch_owner, brand_owner, call_center, cashier, cashier_allowed_delivery_types, cashier_basic_recipes, cashier_cancel, cashier_change_delivery_type, cashier_delivery, cashier_isolated_print, cashier_kiosk, cashier_menu, cashier_payment_methods, cashier_pos, cashier_process_time, cashier_refund, cashier_reports, cashier_reports_with_products, cashier_statistics, cashier_transfer_company_branch, cashier_unlimited, cashier_unlimited_customer, cashier_without_print, cashless_supervisor, customer, driver, driver_default, driver_dodo, driver_foodis, driver_foodora_go, driver_liftago, driver_prorozvoz, driver_wolt_drive, editor, editor_address, editor_announcement, editor_availability, editor_billings, editor_business_hour, editor_business_hours, editor_cash_box, editor_company, editor_company_branch, editor_company_branch_currency, editor_company_branch_delivery, editor_company_branch_user, editor_company_order_origin, editor_country, editor_country_vat, editor_country_vat_price_type, editor_country_vat_type_price, editor_currency, editor_event, editor_financial_report, editor_import_log, editor_ingredient, editor_integrations, editor_label, editor_label_translation, editor_menu, editor_note, editor_order, editor_order_billing, editor_order_discount, editor_order_origin_price_type, editor_order_payment_method, editor_order_price_modification, editor_order_recipe, editor_order_state_relation, editor_orders, editor_page_element, editor_payment_method, editor_payment_method_branch, editor_promo_code, editor_recipe, editor_recipe_price, editor_recipe_relation, editor_rejected_payment_method, editor_role, editor_setting, editor_shift, editor_shift_user, editor_sorting, editor_stock_item, editor_stock_item_allergen, editor_stock_transfer, editor_transportation_device, editor_transportation_device_user, editor_user, editor_user_delivering_order, editor_user_login_provider, editor_user_personal, editor_wallet_credits, editor_wallet_credits_refund, editor_ware, editor_ware_category, editor_ware_category_relation, editor_zone, editor_zones, export_customers, extern, external_api, gastra_api, guest, liftago, merchant, operator, owner_cancel, request_cancel, request_external_driver, sales_representative, super_admin, supervisor, support, suspended_user, templatable_manager, user, vam]
   *
   */
  readonly updatedTransportationDeviceUser: TTransportationDeviceUserUpdateSubscription;
  /**
   *
   *
   * ALLOWED ROLES: [access_config, account_manager, accountant, admin, branch_owner, brand_owner, call_center, cashier, cashier_allowed_delivery_types, cashier_basic_recipes, cashier_cancel, cashier_change_delivery_type, cashier_delivery, cashier_isolated_print, cashier_kiosk, cashier_menu, cashier_payment_methods, cashier_pos, cashier_process_time, cashier_refund, cashier_reports, cashier_reports_with_products, cashier_statistics, cashier_transfer_company_branch, cashier_unlimited, cashier_unlimited_customer, cashier_without_print, cashless_supervisor, customer, driver, driver_default, driver_dodo, driver_foodis, driver_foodora_go, driver_liftago, driver_prorozvoz, driver_wolt_drive, editor, editor_address, editor_announcement, editor_availability, editor_billings, editor_business_hour, editor_business_hours, editor_cash_box, editor_company, editor_company_branch, editor_company_branch_currency, editor_company_branch_delivery, editor_company_branch_user, editor_company_order_origin, editor_country, editor_country_vat, editor_country_vat_price_type, editor_country_vat_type_price, editor_currency, editor_event, editor_financial_report, editor_import_log, editor_ingredient, editor_integrations, editor_label, editor_label_translation, editor_menu, editor_note, editor_order, editor_order_billing, editor_order_discount, editor_order_origin_price_type, editor_order_payment_method, editor_order_price_modification, editor_order_recipe, editor_order_state_relation, editor_orders, editor_page_element, editor_payment_method, editor_payment_method_branch, editor_promo_code, editor_recipe, editor_recipe_price, editor_recipe_relation, editor_rejected_payment_method, editor_role, editor_setting, editor_shift, editor_shift_user, editor_sorting, editor_stock_item, editor_stock_item_allergen, editor_stock_transfer, editor_transportation_device, editor_transportation_device_user, editor_user, editor_user_delivering_order, editor_user_login_provider, editor_user_personal, editor_wallet_credits, editor_wallet_credits_refund, editor_ware, editor_ware_category, editor_ware_category_relation, editor_zone, editor_zones, export_customers, extern, external_api, gastra_api, guest, liftago, merchant, operator, owner_cancel, request_cancel, request_external_driver, sales_representative, super_admin, supervisor, support, suspended_user, templatable_manager, user, vam]
   *
   */
  readonly updatedUserCallingCustomer: TUserCallingCustomerSubscription;
  /**
   *
   *
   * ALLOWED ROLES: [access_config, account_manager, accountant, admin, branch_owner, brand_owner, call_center, cashier, cashier_allowed_delivery_types, cashier_basic_recipes, cashier_cancel, cashier_change_delivery_type, cashier_delivery, cashier_isolated_print, cashier_kiosk, cashier_menu, cashier_payment_methods, cashier_pos, cashier_process_time, cashier_refund, cashier_reports, cashier_reports_with_products, cashier_statistics, cashier_transfer_company_branch, cashier_unlimited, cashier_unlimited_customer, cashier_without_print, cashless_supervisor, customer, driver, driver_default, driver_dodo, driver_foodis, driver_foodora_go, driver_liftago, driver_prorozvoz, driver_wolt_drive, editor, editor_address, editor_announcement, editor_availability, editor_billings, editor_business_hour, editor_business_hours, editor_cash_box, editor_company, editor_company_branch, editor_company_branch_currency, editor_company_branch_delivery, editor_company_branch_user, editor_company_order_origin, editor_country, editor_country_vat, editor_country_vat_price_type, editor_country_vat_type_price, editor_currency, editor_event, editor_financial_report, editor_import_log, editor_ingredient, editor_integrations, editor_label, editor_label_translation, editor_menu, editor_note, editor_order, editor_order_billing, editor_order_discount, editor_order_origin_price_type, editor_order_payment_method, editor_order_price_modification, editor_order_recipe, editor_order_state_relation, editor_orders, editor_page_element, editor_payment_method, editor_payment_method_branch, editor_promo_code, editor_recipe, editor_recipe_price, editor_recipe_relation, editor_rejected_payment_method, editor_role, editor_setting, editor_shift, editor_shift_user, editor_sorting, editor_stock_item, editor_stock_item_allergen, editor_stock_transfer, editor_transportation_device, editor_transportation_device_user, editor_user, editor_user_delivering_order, editor_user_login_provider, editor_user_personal, editor_wallet_credits, editor_wallet_credits_refund, editor_ware, editor_ware_category, editor_ware_category_relation, editor_zone, editor_zones, export_customers, extern, external_api, gastra_api, guest, liftago, merchant, operator, owner_cancel, request_cancel, request_external_driver, sales_representative, super_admin, supervisor, support, suspended_user, templatable_manager, user, vam]
   *
   */
  readonly updatedUserDeliveringOrder: TUserDeliveringOrderUpdateSubscription;
};


/** The subscription root of this schema */
export type TSubscriptionUpdatedExternalDeliveryArgs = {
  companyBranches: ReadonlyArray<Scalars['ID']>;
};


/** The subscription root of this schema */
export type TSubscriptionUpdatedOrderArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  groups?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  id?: InputMaybe<Scalars['ID']>;
  includeOldFinished?: InputMaybe<Scalars['Boolean']>;
  occasions?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  orderStateCategoriesOR?: InputMaybe<ReadonlyArray<TOrderStateCategoryEnum>>;
  orderStateCategoryTarget?: InputMaybe<TOrderStateCategoryTargetEnum>;
  sectors?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  sectorsWithChildren?: InputMaybe<Scalars['Boolean']>;
};


/** The subscription root of this schema */
export type TSubscriptionUpdatedOrderCategoryCountArgs = {
  companyBranches: ReadonlyArray<Scalars['ID']>;
  orderStateCategories: ReadonlyArray<TOrderStateCategoryEnum>;
  orderStateCategoryTarget?: InputMaybe<TOrderStateCategoryTargetEnum>;
};


/** The subscription root of this schema */
export type TSubscriptionUpdatedOrdersCountArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};


/** The subscription root of this schema */
export type TSubscriptionUpdatedPrintQueueArgs = {
  printers: ReadonlyArray<Scalars['ID']>;
  targetMac: Scalars['String'];
};


/** The subscription root of this schema */
export type TSubscriptionUpdatedSectorRecipeArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  groups?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  orderRecipeStateOR?: InputMaybe<ReadonlyArray<TOrderRecipeStateEnum>>;
  sectors?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  sectorsWithChildren?: InputMaybe<Scalars['Boolean']>;
};


/** The subscription root of this schema */
export type TSubscriptionUpdatedTransportationDeviceUserArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  transportationDevice?: InputMaybe<Scalars['ID']>;
  user?: InputMaybe<Scalars['ID']>;
};


/** The subscription root of this schema */
export type TSubscriptionUpdatedUserCallingCustomerArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  user?: InputMaybe<Scalars['ID']>;
};


/** The subscription root of this schema */
export type TSubscriptionUpdatedUserDeliveringOrderArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  user?: InputMaybe<Scalars['ID']>;
};

/** Subscription of external deliveries statuses */
export type TExternalDeliveryUpdateSubscription = {
  readonly __typename?: 'ExternalDeliveryUpdateSubscription';
  readonly actionType: TSubscriptionActionType;
  readonly externalDelivery: Maybe<TExternalDelivery>;
  readonly id: Scalars['ID'];
};

/** Possible action types of subscription */
export type TSubscriptionActionType =
  | 'CREATE'
  | 'DESTROY'
  | 'REMOVE'
  | 'UPDATE';

/** Subscription of order changes */
export type TOrderUpdateSubscription = {
  readonly __typename?: 'OrderUpdateSubscription';
  readonly actionType: TSubscriptionActionType;
  readonly id: Scalars['ID'];
  readonly order: Maybe<TOrder>;
};

/** Subscription of order category change */
export type TOrderCategoryCountSubscription = {
  readonly __typename?: 'OrderCategoryCountSubscription';
  readonly actionType: TSubscriptionActionType;
  readonly id: Scalars['ID'];
  readonly newOrderStateCategory: TOrderStateCategoryEnum;
  readonly oldOrderStateCategory: TOrderStateCategoryEnum;
  readonly order: TOrder;
};

/** Subscription of order count changes */
export type TOrderCountSubscription = {
  readonly __typename?: 'OrderCountSubscription';
  readonly actionType: TSubscriptionActionType;
  readonly id: Scalars['ID'];
  readonly ordersCount: Scalars['Int'];
};

/** Subscription of print queue */
export type TPrintQueueUpdateSubscription = {
  readonly __typename?: 'PrintQueueUpdateSubscription';
  readonly actionType: TSubscriptionActionType;
  readonly id: Scalars['ID'];
  readonly printQueue: TPrintQueue;
};

/** Subscription of sector recipe */
export type TSectorRecipeUpdateSubscription = {
  readonly __typename?: 'SectorRecipeUpdateSubscription';
  readonly actionType: TSubscriptionActionType;
  readonly id: Scalars['ID'];
  readonly sectorRecipe: Maybe<TSectorRecipe>;
};

/** Subscription of transportation device of user */
export type TTransportationDeviceUserUpdateSubscription = {
  readonly __typename?: 'TransportationDeviceUserUpdateSubscription';
  readonly actionType: TSubscriptionActionType;
  readonly id: Scalars['ID'];
  readonly transportationDeviceUser: Maybe<TTransportationDeviceUser>;
};

/** Subscription for calling numbers for logged user */
export type TUserCallingCustomerSubscription = {
  readonly __typename?: 'UserCallingCustomerSubscription';
  /** ID of event which started call */
  readonly eventId: Scalars['ID'];
  /** Indicator of call activity */
  readonly isRinging: Scalars['Boolean'];
  /** phone of caller */
  readonly phone: Scalars['String'];
  /** country code */
  readonly prefix: Scalars['String'];
};

/** Subscription of user delivering order changes */
export type TUserDeliveringOrderUpdateSubscription = {
  readonly __typename?: 'UserDeliveringOrderUpdateSubscription';
  readonly actionType: TSubscriptionActionType;
  readonly id: Scalars['ID'];
  readonly userDeliveringOrder: Maybe<TUserDeliveringOrder>;
};

/**
 * A Directive provides a way to describe alternate runtime execution and type validation behavior in a GraphQL document.
 *
 * In some cases, you need to provide options to alter GraphQL's execution behavior
 * in ways field arguments will not suffice, such as conditionally including or
 * skipping a field. Directives provide this by describing additional information
 * to the executor.
 */
export type TDirective = {
  readonly __typename?: '__Directive';
  readonly name: Scalars['String'];
  readonly description: Maybe<Scalars['String']>;
  readonly locations: ReadonlyArray<TDirectiveLocation>;
  readonly args: ReadonlyArray<TInputValue>;
};

/**
 * A Directive can be adjacent to many parts of the GraphQL language, a
 * __DirectiveLocation describes one such possible adjacencies.
 */
export type TDirectiveLocation =
  /** Location adjacent to a query operation. */
  | 'QUERY'
  /** Location adjacent to a mutation operation. */
  | 'MUTATION'
  /** Location adjacent to a subscription operation. */
  | 'SUBSCRIPTION'
  /** Location adjacent to a field. */
  | 'FIELD'
  /** Location adjacent to a fragment definition. */
  | 'FRAGMENT_DEFINITION'
  /** Location adjacent to a fragment spread. */
  | 'FRAGMENT_SPREAD'
  /** Location adjacent to an inline fragment. */
  | 'INLINE_FRAGMENT'
  /** Location adjacent to a variable definition. */
  | 'VARIABLE_DEFINITION'
  /** Location adjacent to a schema definition. */
  | 'SCHEMA'
  /** Location adjacent to a scalar definition. */
  | 'SCALAR'
  /** Location adjacent to an object type definition. */
  | 'OBJECT'
  /** Location adjacent to a field definition. */
  | 'FIELD_DEFINITION'
  /** Location adjacent to an argument definition. */
  | 'ARGUMENT_DEFINITION'
  /** Location adjacent to an interface definition. */
  | 'INTERFACE'
  /** Location adjacent to a union definition. */
  | 'UNION'
  /** Location adjacent to an enum definition. */
  | 'ENUM'
  /** Location adjacent to an enum value definition. */
  | 'ENUM_VALUE'
  /** Location adjacent to an input object type definition. */
  | 'INPUT_OBJECT'
  /** Location adjacent to an input object field definition. */
  | 'INPUT_FIELD_DEFINITION';

/**
 * One possible value for a given Enum. Enum values are unique values, not a
 * placeholder for a string or numeric value. However an Enum value is returned in
 * a JSON response as a string.
 */
export type TEnumValue = {
  readonly __typename?: '__EnumValue';
  readonly name: Scalars['String'];
  readonly description: Maybe<Scalars['String']>;
  readonly isDeprecated: Scalars['Boolean'];
  readonly deprecationReason: Maybe<Scalars['String']>;
};

/**
 * Object and Interface types are described by a list of Fields, each of which has
 * a name, potentially a list of arguments, and a return type.
 */
export type TField = {
  readonly __typename?: '__Field';
  readonly name: Scalars['String'];
  readonly description: Maybe<Scalars['String']>;
  readonly args: ReadonlyArray<TInputValue>;
  readonly type: TType;
  readonly isDeprecated: Scalars['Boolean'];
  readonly deprecationReason: Maybe<Scalars['String']>;
};

/**
 * Arguments provided to Fields or Directives and the input fields of an
 * InputObject are represented as Input Values which describe their type and
 * optionally a default value.
 */
export type TInputValue = {
  readonly __typename?: '__InputValue';
  readonly name: Scalars['String'];
  readonly description: Maybe<Scalars['String']>;
  readonly type: TType;
  /** A GraphQL-formatted string representing the default value for this input value. */
  readonly defaultValue: Maybe<Scalars['String']>;
};

/**
 * A GraphQL Schema defines the capabilities of a GraphQL server. It exposes all
 * available types and directives on the server, as well as the entry points for
 * query, mutation, and subscription operations.
 */
export type TSchema = {
  readonly __typename?: '__Schema';
  /** A list of all types supported by this server. */
  readonly types: ReadonlyArray<TType>;
  /** The type that query operations will be rooted at. */
  readonly queryType: TType;
  /** If this server supports mutation, the type that mutation operations will be rooted at. */
  readonly mutationType: Maybe<TType>;
  /** If this server support subscription, the type that subscription operations will be rooted at. */
  readonly subscriptionType: Maybe<TType>;
  /** A list of all directives supported by this server. */
  readonly directives: ReadonlyArray<TDirective>;
};

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of
 * types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that
 * type. Scalar types provide no information beyond a name and description, while
 * Enum types provide their values. Object and Interface types provide the fields
 * they describe. Abstract types, Union and Interface, provide the Object types
 * possible at runtime. List and NonNull types compose other types.
 */
export type TType = {
  readonly __typename?: '__Type';
  readonly kind: TTypeKind;
  readonly name: Maybe<Scalars['String']>;
  readonly description: Maybe<Scalars['String']>;
  readonly fields: Maybe<ReadonlyArray<TField>>;
  readonly interfaces: Maybe<ReadonlyArray<TType>>;
  readonly possibleTypes: Maybe<ReadonlyArray<TType>>;
  readonly enumValues: Maybe<ReadonlyArray<TEnumValue>>;
  readonly inputFields: Maybe<ReadonlyArray<TInputValue>>;
  readonly ofType: Maybe<TType>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of
 * types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that
 * type. Scalar types provide no information beyond a name and description, while
 * Enum types provide their values. Object and Interface types provide the fields
 * they describe. Abstract types, Union and Interface, provide the Object types
 * possible at runtime. List and NonNull types compose other types.
 */
export type TTypeFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of
 * types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that
 * type. Scalar types provide no information beyond a name and description, while
 * Enum types provide their values. Object and Interface types provide the fields
 * they describe. Abstract types, Union and Interface, provide the Object types
 * possible at runtime. List and NonNull types compose other types.
 */
export type TTypeEnumValuesArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']>;
};

/** An enum describing what kind of type a given `__Type` is. */
export type TTypeKind =
  /** Indicates this type is a scalar. */
  | 'SCALAR'
  /** Indicates this type is an object. `fields` and `interfaces` are valid fields. */
  | 'OBJECT'
  /** Indicates this type is an interface. `fields` and `possibleTypes` are valid fields. */
  | 'INTERFACE'
  /** Indicates this type is a union. `possibleTypes` is a valid field. */
  | 'UNION'
  /** Indicates this type is an enum. `enumValues` is a valid field. */
  | 'ENUM'
  /** Indicates this type is an input object. `inputFields` is a valid field. */
  | 'INPUT_OBJECT'
  /** Indicates this type is a list. `ofType` is a valid field. */
  | 'LIST'
  /** Indicates this type is a non-null. `ofType` is a valid field. */
  | 'NON_NULL';

export type TFDeliveryAddressSuggestion = { readonly __typename?: 'AddressResolvedLocation', readonly address: { readonly __typename?: 'JsonAddress', readonly state: string | null, readonly city: string | null, readonly venue: string | null, readonly street: string | null, readonly houseNumber: string | null, readonly country: string | null } | null, readonly gps: { readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number } | null };

export type TQDeliveryAddressSuggestionsVariables = Exact<{
  gpsList: ReadonlyArray<TInputGeoPointCreate>;
}>;


export type TQDeliveryAddressSuggestions = { readonly __typename?: 'Query', readonly suggestions: ReadonlyArray<{ readonly __typename?: 'AddressResolvedLocation', readonly address: { readonly __typename?: 'JsonAddress', readonly state: string | null, readonly city: string | null, readonly venue: string | null, readonly street: string | null, readonly houseNumber: string | null, readonly country: string | null } | null, readonly gps: { readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number } | null }> };

export type TQResolveDeliveryAddressVariables = Exact<{
  branchId?: InputMaybe<Scalars['ID']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  addressInput?: InputMaybe<Scalars['String']>;
}>;


export type TQResolveDeliveryAddress = { readonly __typename?: 'Query', readonly location: { readonly __typename?: 'AddressResolvedLocation', readonly address: { readonly __typename?: 'JsonAddress', readonly state: string | null, readonly city: string | null, readonly venue: string | null, readonly street: string | null, readonly houseNumber: string | null, readonly country: string | null } | null, readonly gps: { readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number } | null } };

export type TQLogoutWidgetVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TQLogoutWidget = { readonly __typename?: 'Query', readonly user: { readonly __typename?: 'User', readonly id: ID, readonly firstName: string | null, readonly lastName: string | null, readonly initials: string } };

export type TFOrderGroup = { readonly __typename?: 'OrderGroup', readonly id: ID, readonly name: string | null, readonly color: { readonly __typename?: 'OrderGroupColor', readonly id: ID, readonly color: string } | null };

export type TFOrderGroupColor = { readonly __typename?: 'OrderGroupColor', readonly id: ID, readonly color: string };

export type TFOrderGroupModalOrder = { readonly __typename?: 'Order', readonly id: ID, readonly deliverAt: Date | null, readonly deliveredAt: Date | null, readonly orderGroupIndex: number | null, readonly orderStateCategory: TOrderStateCategoryEnum, readonly delayedDeliveryTime: Date | null, readonly orderNumber: number | null, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly formattedValue: string }, readonly customer: { readonly __typename?: 'JsonCustomer', readonly firstName: string | null, readonly lastName: string | null }, readonly orderGroup: { readonly __typename?: 'OrderGroup', readonly id: ID } | null, readonly driver: { readonly __typename?: 'UserDeliveringOrder', readonly id: ID } | null, readonly gps: { readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number } | null, readonly warePriceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly sector: { readonly __typename?: 'Sector', readonly name: string } | null, readonly address: { readonly __typename?: 'JsonAddress', readonly original: string | null, readonly state: string | null, readonly city: string | null, readonly venue: string | null, readonly street: string | null, readonly houseNumber: string | null, readonly country: string | null } };

export type TFOrderOrderGroup = { readonly __typename?: 'Order', readonly id: ID, readonly orderGroupIndex: number | null, readonly orderGroup: { readonly __typename?: 'OrderGroup', readonly id: ID, readonly name: string | null, readonly color: { readonly __typename?: 'OrderGroupColor', readonly id: ID, readonly color: string } | null } | null };

export type TMCreateOrderGroupVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['ID']>;
  orders: ReadonlyArray<Scalars['ID']>;
}>;


export type TMCreateOrderGroup = { readonly __typename?: 'Mutation', readonly createOrderGroup: { readonly __typename?: 'OrderGroup', readonly id: ID } };

export type TMEditOrderGroupVariables = Exact<{
  color?: InputMaybe<Scalars['ID']>;
  groupId: Scalars['ID'];
  sortedOrderIds: ReadonlyArray<Scalars['ID']>;
}>;


export type TMEditOrderGroup = { readonly __typename?: 'Mutation', readonly updateOrderGroup: { readonly __typename?: 'OrderGroup', readonly id: ID, readonly name: string | null, readonly color: { readonly __typename?: 'OrderGroupColor', readonly id: ID, readonly color: string } | null } | null };

export type TQOrderGroupVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type TQOrderGroup = { readonly __typename?: 'Query', readonly orderGroup: { readonly __typename?: 'OrderGroup', readonly id: ID, readonly name: string | null, readonly orders: ReadonlyArray<{ readonly __typename?: 'Order', readonly id: ID, readonly orderStateCategory: TOrderStateCategoryEnum }>, readonly color: { readonly __typename?: 'OrderGroupColor', readonly id: ID, readonly color: string } | null } };

export type TQOrderGroupColorsVariables = Exact<{ [key: string]: never; }>;


export type TQOrderGroupColors = { readonly __typename?: 'Query', readonly colors: ReadonlyArray<{ readonly __typename?: 'OrderGroupColor', readonly id: ID, readonly code: string, readonly color: string }> };

export type TFProductTagOption = { readonly __typename?: 'RecipeTag', readonly id: ID, readonly label: string | null, readonly category: { readonly __typename?: 'RecipeTagCategoryType', readonly enum: TRecipeTagCategoryTypeEnum, readonly label: string } | null, readonly originTag: { readonly __typename?: 'RecipeTag', readonly id: ID } | null };

export type TQProductTagOptionsVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type TQProductTagOptions = { readonly __typename?: 'Query', readonly productTags: ReadonlyArray<{ readonly __typename?: 'RecipeTag', readonly id: ID, readonly label: string | null, readonly category: { readonly __typename?: 'RecipeTagCategoryType', readonly enum: TRecipeTagCategoryTypeEnum, readonly label: string } | null, readonly originTag: { readonly __typename?: 'RecipeTag', readonly id: ID } | null }> };

export type TQWorkplacesVariables = Exact<{ [key: string]: never; }>;


export type TQWorkplaces = { readonly __typename?: 'Query', readonly workplaces: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: ID, readonly code: string, readonly label: string }> };

export type TQBranchCountryPhonePrefixVariables = Exact<{
  branchId: Scalars['ID'];
}>;


export type TQBranchCountryPhonePrefix = { readonly __typename?: 'Query', readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly address: { readonly __typename?: 'Address', readonly id: ID, readonly country: { readonly __typename?: 'Country', readonly id: ID, readonly enum: TCountryEnum, readonly phonePrefix: string } | null } } };

export type TQFilterCashboxesVariables = Exact<{
  branches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
}>;


export type TQFilterCashboxes = { readonly __typename?: 'Query', readonly cashBoxes: ReadonlyArray<{ readonly __typename?: 'CashBox', readonly id: ID, readonly name: string, readonly uuid: string, readonly deleted: boolean }> };

export type TQFilterCashiersVariables = Exact<{
  branches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
}>;


export type TQFilterCashiers = { readonly __typename?: 'Query', readonly cashiers: ReadonlyArray<{ readonly __typename?: 'User', readonly id: ID, readonly firstName: string | null, readonly lastName: string | null }> };

export type TQFilterCountriesVariables = Exact<{ [key: string]: never; }>;


export type TQFilterCountries = { readonly __typename?: 'Query', readonly countries: ReadonlyArray<{ readonly __typename?: 'Country', readonly id: ID, readonly code: string, readonly enum: TCountryEnum }> };

export type TQFilterDriversVariables = Exact<{
  branches: ReadonlyArray<Scalars['ID']>;
  withExternalDrivers: Scalars['Boolean'];
}>;


export type TQFilterDrivers = { readonly __typename?: 'Query', readonly drivers: ReadonlyArray<{ readonly __typename?: 'User', readonly id: ID, readonly initials: string, readonly firstName: string | null, readonly lastName: string | null }> };

export type TQFilterOriginsVariables = Exact<{ [key: string]: never; }>;


export type TQFilterOrigins = { readonly __typename?: 'Query', readonly origins: ReadonlyArray<{ readonly __typename?: 'OrderOrigin', readonly code: string, readonly enum: TOrderOriginEnum }> };

export type TQFilterPaymentGatesVariables = Exact<{ [key: string]: never; }>;


export type TQFilterPaymentGates = { readonly __typename?: 'Query', readonly paymentGates: ReadonlyArray<{ readonly __typename?: 'PaymentGate', readonly id: ID, readonly code: string, readonly enum: TPaymentGateEnum }> };

export type TQFilterPromoTagsVariables = Exact<{ [key: string]: never; }>;


export type TQFilterPromoTags = { readonly __typename?: 'Query', readonly promoTags: ReadonlyArray<{ readonly __typename?: 'PromoTag', readonly id: ID, readonly code: string, readonly enum: TPromoTagEnum }> };

export type TQFilterSectorsVariables = Exact<{
  branches: ReadonlyArray<Scalars['ID']>;
}>;


export type TQFilterSectors = { readonly __typename?: 'Query', readonly sectors: ReadonlyArray<{ readonly __typename?: 'Sector', readonly id: ID, readonly code: string, readonly name: string, readonly parent: { readonly __typename?: 'Sector', readonly id: ID } | null, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID } }> };

export type TMRequestReprintVariables = Exact<{
  printerId: Scalars['ID'];
  templateId: Scalars['ID'];
  thisPcMAC: Scalars['String'];
  printObjectId: Scalars['ID'];
}>;


export type TMRequestReprint = { readonly __typename?: 'Mutation', readonly printRecord: { readonly __typename?: 'PrintQueue', readonly id: ID } | null };

export type TQReprintTemplatesVariables = Exact<{
  companyBranchIds: ReadonlyArray<Scalars['ID']>;
  forPrintableObject: TTriggerableTypeEnum;
}>;


export type TQReprintTemplates = { readonly __typename?: 'Query', readonly printTemplates: ReadonlyArray<{ readonly __typename?: 'PrintTemplate', readonly id: ID, readonly nameLabel: string }> };

export type TFAddress = { readonly __typename?: 'JsonAddress', readonly state: string | null, readonly city: string | null, readonly venue: string | null, readonly street: string | null, readonly houseNumber: string | null, readonly country: string | null };

export type TFCompanyBranch = { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string, readonly url: string, readonly urlPath: string, readonly defaultLanguage: TLanguageEnum, readonly supportedLanguages: ReadonlyArray<TLanguageEnum>, readonly promoHeaderText: string | null, readonly pohodaEnabled: boolean, readonly userAccountsEnabledForCustomer: boolean, readonly address: { readonly __typename?: 'Address', readonly country: { readonly __typename?: 'Country', readonly phonePrefix: string } | null }, readonly gps: { readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number }, readonly brand: { readonly __typename?: 'Company', readonly id: ID, readonly name: string, readonly defaultLanguage: TLanguageEnum, readonly supportedLanguages: ReadonlyArray<TLanguageEnum>, readonly promoHeaderText: string | null, readonly wareCategorySharingAllowed: boolean, readonly publicBranches: ReadonlyArray<{ readonly __typename?: 'CompanyBranch', readonly id: ID }> } };

export type TFCustomer = { readonly __typename?: 'JsonCustomer', readonly firstName: string | null, readonly lastName: string | null, readonly defaultEmail: { readonly __typename?: 'Email', readonly email: string, readonly description: string | null, readonly default: boolean } | null, readonly defaultPhone: { readonly __typename?: 'Phone', readonly phone: string, readonly description: string | null, readonly default: boolean } | null };

export type TFDriver = { readonly __typename?: 'User', readonly id: ID, readonly initials: string, readonly firstName: string | null, readonly lastName: string | null };

export type TFEmail = { readonly __typename?: 'Email', readonly email: string, readonly description: string | null, readonly default: boolean };

export type TFFormattedPrice = { readonly __typename?: 'PriceConverted', readonly formattedValue: string };

export type TFGeoPoint = { readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number };

export type TFOrderStateCategory = { readonly __typename?: 'Order', readonly id: ID, readonly orderStateCategory: TOrderStateCategoryEnum };

export type TFPaymentMethod = { readonly __typename?: 'PaymentMethod', readonly id: ID, readonly description: string, readonly paymentType: { readonly __typename?: 'PaymentType', readonly id: ID, readonly enum: TPaymentTypeEnum }, readonly paymentGate: { readonly __typename?: 'PaymentGate', readonly id: ID, readonly enum: TPaymentGateEnum, readonly code: string } };

export type TFPhone = { readonly __typename?: 'Phone', readonly phone: string, readonly description: string | null, readonly default: boolean };

export type TFPrice = { readonly __typename?: 'PriceConverted', readonly value: number };

export type TFPriceWithCurrency = { readonly __typename?: 'PriceConverted', readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } };

export type TFPromoTag = { readonly __typename?: 'PromoTag', readonly id: ID, readonly code: string, readonly enum: TPromoTagEnum };

export type TFUser = { readonly __typename?: 'User', readonly id: ID, readonly initials: string, readonly firstName: string | null, readonly lastName: string | null };

export type TFUserName = { readonly __typename?: 'User', readonly firstName: string | null, readonly lastName: string | null };

export type TMOrderStateVariables = Exact<{
  orderId: Scalars['ID'];
  state: TOrderStateEnum;
}>;


export type TMOrderState = { readonly __typename?: 'Mutation', readonly addOrderState: { readonly __typename?: 'Order', readonly id: ID, readonly orderStateCategory: TOrderStateCategoryEnum, readonly stateChanges: ReadonlyArray<{ readonly __typename?: 'OrderStateCategoryRelation', readonly createdAt: Date, readonly state: TOrderStateCategoryEnum }> } };

export type TMSetPriorityOrderVariables = Exact<{
  orderId: Scalars['ID'];
  isPriority: Scalars['Boolean'];
}>;


export type TMSetPriorityOrder = { readonly __typename?: 'Mutation', readonly setPriorityOrder: { readonly __typename?: 'Order', readonly id: ID, readonly isPriority: boolean } };

export type TFOrderForDestination = { readonly __typename?: 'Order', readonly id: ID, readonly warePriceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly sector: { readonly __typename?: 'Sector', readonly name: string } | null, readonly address: { readonly __typename?: 'JsonAddress', readonly original: string | null, readonly state: string | null, readonly city: string | null, readonly venue: string | null, readonly street: string | null, readonly houseNumber: string | null, readonly country: string | null } };

export type TFOrderForHandoverType = { readonly __typename?: 'Order', readonly id: ID, readonly warePriceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null };

export type TFOrderForItemGrouping = { readonly __typename?: 'Order', readonly id: ID, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly note: string | null, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID }, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID } }> }> };

export type TFOrderForNumber = { readonly __typename?: 'Order', readonly id: ID, readonly orderNumber: number | null };

export type TFOrderForPaymentCategory = { readonly __typename?: 'Order', readonly id: ID, readonly isPaidWithCard: boolean, readonly onlinePaymentState: { readonly __typename?: 'OrderOnlineState', readonly enum: TOrderOnlineStateEnum } | null, readonly orderPayments: ReadonlyArray<{ readonly __typename?: 'OrderPaymentMethod', readonly id: ID, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly paymentMethod: { readonly __typename?: 'PaymentMethod', readonly id: ID, readonly description: string, readonly paymentType: { readonly __typename?: 'PaymentType', readonly id: ID, readonly enum: TPaymentTypeEnum } } }> };

export type TFEmployee = { readonly __typename?: 'User', readonly id: ID, readonly email: string, readonly phone: string, readonly login: string | null, readonly lastName: string | null, readonly firstName: string | null, readonly language: { readonly __typename?: 'Language', readonly id: ID, readonly code: string, readonly enum: TLanguageEnum }, readonly roles: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: ID, readonly enum: TRoleEnum, readonly code: string }>, readonly employments: ReadonlyArray<{ readonly __typename?: 'CompanyBranchUser', readonly id: ID, readonly inactive: boolean, readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string } }> };

export type TFEmployeeBranch = { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string };

export type TFEmployeeRole = { readonly __typename?: 'Role', readonly id: ID, readonly enum: TRoleEnum, readonly code: string };

export type TFLanguage = { readonly __typename?: 'Language', readonly id: ID, readonly code: string, readonly enum: TLanguageEnum };

export type TMCreateEmployeeVariables = Exact<{
  userData: TInputUserCreate;
}>;


export type TMCreateEmployee = { readonly __typename?: 'Mutation', readonly createdEmployee: { readonly __typename?: 'User', readonly id: ID, readonly email: string, readonly phone: string, readonly login: string | null, readonly lastName: string | null, readonly firstName: string | null, readonly language: { readonly __typename?: 'Language', readonly id: ID, readonly code: string, readonly enum: TLanguageEnum }, readonly roles: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: ID, readonly enum: TRoleEnum, readonly code: string }>, readonly employments: ReadonlyArray<{ readonly __typename?: 'CompanyBranchUser', readonly id: ID, readonly inactive: boolean, readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string } }> } };

export type TMCreateEmploymentVariables = Exact<{
  employeeId: Scalars['ID'];
  branchId: Scalars['ID'];
}>;


export type TMCreateEmployment = { readonly __typename?: 'Mutation', readonly createCompanyBranchUser: { readonly __typename?: 'User', readonly id: ID } };

export type TMDeactivateEmploymentVariables = Exact<{
  employmentId: Scalars['ID'];
}>;


export type TMDeactivateEmployment = { readonly __typename?: 'Mutation', readonly destroyCompanyBranchUser: { readonly __typename?: 'User', readonly id: ID } };

export type TMSuspendUserVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type TMSuspendUser = { readonly __typename?: 'Mutation', readonly suspendedUser: { readonly __typename?: 'User', readonly id: ID, readonly email: string, readonly phone: string, readonly login: string | null, readonly lastName: string | null, readonly firstName: string | null, readonly language: { readonly __typename?: 'Language', readonly id: ID, readonly code: string, readonly enum: TLanguageEnum }, readonly roles: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: ID, readonly enum: TRoleEnum, readonly code: string }>, readonly employments: ReadonlyArray<{ readonly __typename?: 'CompanyBranchUser', readonly id: ID, readonly inactive: boolean, readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string } }> } };

export type TMUpdateEmployeeVariables = Exact<{
  employeeId: Scalars['ID'];
  userData: TInputUserUpdate;
}>;


export type TMUpdateEmployee = { readonly __typename?: 'Mutation', readonly updatedEmployee: { readonly __typename?: 'User', readonly id: ID, readonly email: string, readonly phone: string, readonly login: string | null, readonly lastName: string | null, readonly firstName: string | null, readonly language: { readonly __typename?: 'Language', readonly id: ID, readonly code: string, readonly enum: TLanguageEnum }, readonly roles: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: ID, readonly enum: TRoleEnum, readonly code: string }>, readonly employments: ReadonlyArray<{ readonly __typename?: 'CompanyBranchUser', readonly id: ID, readonly inactive: boolean, readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string } }> } };

export type TQEmployeeFormConfigVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type TQEmployeeFormConfig = { readonly __typename?: 'Query', readonly user: { readonly __typename?: 'User', readonly id: ID, readonly settings: { readonly __typename?: 'SettingUser', readonly canAssignRoles: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: ID, readonly enum: TRoleEnum, readonly code: string }> } }, readonly languages: ReadonlyArray<{ readonly __typename?: 'Language', readonly id: ID, readonly code: string, readonly enum: TLanguageEnum }> };

export type TQEmployeeListVariables = Exact<{
  branchIds: ReadonlyArray<Scalars['ID']>;
}>;


export type TQEmployeeList = { readonly __typename?: 'Query', readonly employees: ReadonlyArray<{ readonly __typename?: 'User', readonly id: ID, readonly email: string, readonly phone: string, readonly login: string | null, readonly lastName: string | null, readonly firstName: string | null, readonly language: { readonly __typename?: 'Language', readonly id: ID, readonly code: string, readonly enum: TLanguageEnum }, readonly roles: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: ID, readonly enum: TRoleEnum, readonly code: string }>, readonly employments: ReadonlyArray<{ readonly __typename?: 'CompanyBranchUser', readonly id: ID, readonly inactive: boolean, readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string } }> }> };

export type TFProductTagCategory = { readonly __typename?: 'RecipeTagCategoryType', readonly enum: TRecipeTagCategoryTypeEnum, readonly label: string };

export type TFProductTagInList = { readonly __typename?: 'RecipeTag', readonly color: string | null, readonly pictogram: string | null, readonly id: ID, readonly label: string | null, readonly imageUrl: string | null, readonly category: { readonly __typename?: 'RecipeTagCategoryType', readonly enum: TRecipeTagCategoryTypeEnum, readonly label: string } | null, readonly originTag: { readonly __typename?: 'RecipeTag', readonly id: ID, readonly label: string | null } | null, readonly translations: ReadonlyArray<{ readonly __typename?: 'RecipeTagTranslation', readonly label: string | null, readonly language: { readonly __typename?: 'Language', readonly enum: TLanguageEnum } }> };

export type TFProductTagInListBase = { readonly __typename?: 'RecipeTag', readonly id: ID, readonly label: string | null };

export type TFProductTagTranslations = { readonly __typename?: 'RecipeTag', readonly id: ID, readonly translations: ReadonlyArray<{ readonly __typename?: 'RecipeTagTranslation', readonly label: string | null, readonly language: { readonly __typename?: 'Language', readonly enum: TLanguageEnum } }> };

export type TFProductTagBrand = { readonly __typename?: 'Company', readonly id: ID, readonly defaultLanguage: TLanguageEnum, readonly supportedLanguages: ReadonlyArray<TLanguageEnum> };

export type TFProductTagDetail = { readonly __typename?: 'RecipeTag', readonly color: string | null, readonly pictogram: string | null, readonly id: ID, readonly label: string | null, readonly imageUrl: string | null, readonly originTag: { readonly __typename?: 'RecipeTag', readonly color: string | null, readonly pictogram: string | null, readonly id: ID, readonly label: string | null, readonly imageUrl: string | null, readonly category: { readonly __typename?: 'RecipeTagCategoryType', readonly enum: TRecipeTagCategoryTypeEnum, readonly label: string } | null, readonly translations: ReadonlyArray<{ readonly __typename?: 'RecipeTagTranslation', readonly label: string | null, readonly language: { readonly __typename?: 'Language', readonly enum: TLanguageEnum } }> } | null, readonly category: { readonly __typename?: 'RecipeTagCategoryType', readonly enum: TRecipeTagCategoryTypeEnum, readonly label: string } | null, readonly translations: ReadonlyArray<{ readonly __typename?: 'RecipeTagTranslation', readonly label: string | null, readonly language: { readonly __typename?: 'Language', readonly enum: TLanguageEnum } }> };

export type TFProductTagDetailBase = { readonly __typename?: 'RecipeTag', readonly color: string | null, readonly pictogram: string | null, readonly id: ID, readonly label: string | null, readonly imageUrl: string | null, readonly category: { readonly __typename?: 'RecipeTagCategoryType', readonly enum: TRecipeTagCategoryTypeEnum, readonly label: string } | null, readonly translations: ReadonlyArray<{ readonly __typename?: 'RecipeTagTranslation', readonly label: string | null, readonly language: { readonly __typename?: 'Language', readonly enum: TLanguageEnum } }> };

export type TFProductTagRelatedCategory = { readonly __typename?: 'WareCategory', readonly id: ID, readonly nameLabel: string, readonly categoryType: { readonly __typename?: 'WareCategoryType', readonly enum: TWareCategoryTypeEnum }, readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string } };

export type TFProductTagRelatedRecipe = { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string, readonly recipeType: { readonly __typename?: 'WareCategoryType', readonly enum: TWareCategoryTypeEnum }, readonly primaryCategory: { readonly __typename?: 'WareCategory', readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string } } | null };

export type TQProductTagBrandVariables = Exact<{
  tagId: Scalars['ID'];
  brandId: Scalars['ID'];
  byTag: Scalars['Boolean'];
}>;


export type TQProductTagBrand = { readonly __typename?: 'Query', readonly tag: { readonly __typename?: 'RecipeTag', readonly id: ID, readonly brand: { readonly __typename?: 'Company', readonly id: ID, readonly defaultLanguage: TLanguageEnum, readonly supportedLanguages: ReadonlyArray<TLanguageEnum> } | null }, readonly brand: { readonly __typename?: 'Company', readonly id: ID, readonly defaultLanguage: TLanguageEnum, readonly supportedLanguages: ReadonlyArray<TLanguageEnum> } };

export type TQProductTagDetailVariables = Exact<{
  tagId: Scalars['ID'];
}>;


export type TQProductTagDetail = { readonly __typename?: 'Query', readonly tag: { readonly __typename?: 'RecipeTag', readonly color: string | null, readonly pictogram: string | null, readonly id: ID, readonly label: string | null, readonly imageUrl: string | null, readonly originTag: { readonly __typename?: 'RecipeTag', readonly color: string | null, readonly pictogram: string | null, readonly id: ID, readonly label: string | null, readonly imageUrl: string | null, readonly category: { readonly __typename?: 'RecipeTagCategoryType', readonly enum: TRecipeTagCategoryTypeEnum, readonly label: string } | null, readonly translations: ReadonlyArray<{ readonly __typename?: 'RecipeTagTranslation', readonly label: string | null, readonly language: { readonly __typename?: 'Language', readonly enum: TLanguageEnum } }> } | null, readonly category: { readonly __typename?: 'RecipeTagCategoryType', readonly enum: TRecipeTagCategoryTypeEnum, readonly label: string } | null, readonly translations: ReadonlyArray<{ readonly __typename?: 'RecipeTagTranslation', readonly label: string | null, readonly language: { readonly __typename?: 'Language', readonly enum: TLanguageEnum } }> } };

export type TQProductTagRelationsVariables = Exact<{
  branchIds: ReadonlyArray<Scalars['ID']>;
}>;


export type TQProductTagRelations = { readonly __typename?: 'Query', readonly relations: ReadonlyArray<{ readonly __typename?: 'RecipeTagRelation', readonly id: ID, readonly inherited: boolean, readonly productTag: { readonly __typename?: 'RecipeTag', readonly id: ID }, readonly relatedObject: { readonly __typename: 'Recipe', readonly id: ID, readonly nameLabel: string, readonly recipeType: { readonly __typename?: 'WareCategoryType', readonly enum: TWareCategoryTypeEnum }, readonly primaryCategory: { readonly __typename?: 'WareCategory', readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string } } | null } | { readonly __typename: 'WareCategory', readonly id: ID, readonly nameLabel: string, readonly categoryType: { readonly __typename?: 'WareCategoryType', readonly enum: TWareCategoryTypeEnum }, readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string } } }> };

export type TQSystemProductTagsVariables = Exact<{ [key: string]: never; }>;


export type TQSystemProductTags = { readonly __typename?: 'Query', readonly productTags: ReadonlyArray<{ readonly __typename?: 'RecipeTag', readonly color: string | null, readonly pictogram: string | null, readonly id: ID, readonly label: string | null, readonly imageUrl: string | null, readonly category: { readonly __typename?: 'RecipeTagCategoryType', readonly enum: TRecipeTagCategoryTypeEnum, readonly label: string } | null, readonly originTag: { readonly __typename?: 'RecipeTag', readonly id: ID, readonly label: string | null } | null, readonly translations: ReadonlyArray<{ readonly __typename?: 'RecipeTagTranslation', readonly label: string | null, readonly language: { readonly __typename?: 'Language', readonly enum: TLanguageEnum } }> }> };

export type TQProductTagListVariables = Exact<{
  brandId: Scalars['ID'];
  branchIds: ReadonlyArray<Scalars['ID']>;
}>;


export type TQProductTagList = { readonly __typename?: 'Query', readonly productTags: ReadonlyArray<{ readonly __typename?: 'RecipeTag', readonly color: string | null, readonly pictogram: string | null, readonly id: ID, readonly label: string | null, readonly imageUrl: string | null, readonly category: { readonly __typename?: 'RecipeTagCategoryType', readonly enum: TRecipeTagCategoryTypeEnum, readonly label: string } | null, readonly originTag: { readonly __typename?: 'RecipeTag', readonly id: ID, readonly label: string | null } | null, readonly translations: ReadonlyArray<{ readonly __typename?: 'RecipeTagTranslation', readonly label: string | null, readonly language: { readonly __typename?: 'Language', readonly enum: TLanguageEnum } }> }>, readonly relations: ReadonlyArray<{ readonly __typename?: 'RecipeTagRelation', readonly id: ID, readonly inherited: boolean, readonly recipeTag: { readonly __typename?: 'RecipeTag', readonly id: ID } }> };

export type TMCreateProductTagVariables = Exact<{
  brandId: Scalars['ID'];
  originTagId: Scalars['ID'];
  color?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['InputFile']>;
  pictogram?: InputMaybe<Scalars['String']>;
  translatedNameLabels: ReadonlyArray<TInputRecipeTagTranslation>;
}>;


export type TMCreateProductTag = { readonly __typename?: 'Mutation', readonly createdTag: { readonly __typename?: 'RecipeTag', readonly color: string | null, readonly pictogram: string | null, readonly id: ID, readonly label: string | null, readonly imageUrl: string | null, readonly category: { readonly __typename?: 'RecipeTagCategoryType', readonly enum: TRecipeTagCategoryTypeEnum, readonly label: string } | null, readonly originTag: { readonly __typename?: 'RecipeTag', readonly id: ID, readonly label: string | null } | null, readonly translations: ReadonlyArray<{ readonly __typename?: 'RecipeTagTranslation', readonly label: string | null, readonly language: { readonly __typename?: 'Language', readonly enum: TLanguageEnum } }> } };

export type TMDeleteProductTagVariables = Exact<{
  tagId: Scalars['ID'];
}>;


export type TMDeleteProductTag = { readonly __typename?: 'Mutation', readonly deletedTag: { readonly __typename?: 'RecipeTag', readonly id: ID } };

export type TMUpdateProductTagVariables = Exact<{
  tagId: Scalars['ID'];
  originTagId?: InputMaybe<Scalars['ID']>;
  color?: InputMaybe<Scalars['String']>;
  pictogram?: InputMaybe<Scalars['String']>;
  deleteLabel?: InputMaybe<Scalars['Boolean']>;
  image?: InputMaybe<TInputRecipeTagImage>;
  translatedNameLabels: ReadonlyArray<TInputRecipeTagTranslation>;
}>;


export type TMUpdateProductTag = { readonly __typename?: 'Mutation', readonly updatedTag: { readonly __typename?: 'RecipeTag', readonly color: string | null, readonly pictogram: string | null, readonly id: ID, readonly label: string | null, readonly imageUrl: string | null, readonly category: { readonly __typename?: 'RecipeTagCategoryType', readonly enum: TRecipeTagCategoryTypeEnum, readonly label: string } | null, readonly originTag: { readonly __typename?: 'RecipeTag', readonly id: ID, readonly label: string | null } | null, readonly translations: ReadonlyArray<{ readonly __typename?: 'RecipeTagTranslation', readonly label: string | null, readonly language: { readonly __typename?: 'Language', readonly enum: TLanguageEnum } }> } };

export type TFRegularBusinessHour = { readonly __typename?: 'BusinessHour', readonly id: ID, readonly openAt: TimeString, readonly closeAt: TimeString, readonly weekDay: { readonly __typename?: 'WeekDay', readonly enum: TWeekDayEnum } | null };

export type TFSpecificBusinessHour = { readonly __typename?: 'BusinessHour', readonly id: ID, readonly specificDate: Date | null, readonly closed: boolean, readonly closedNote: string | null, readonly openAt: TimeString, readonly closeAt: TimeString, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID } };

export type TFUsualHandoverTimes = { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly defaultDeliveryTimeEnabled: boolean, readonly defaultPickupTimeEnabled: boolean, readonly usualDeliveryTime: number, readonly usualPickupTime: number };

export type TFWeekday = { readonly __typename?: 'WeekDay', readonly enum: TWeekDayEnum, readonly code: string };

export type TFWoltOpeningTimes = { readonly __typename?: 'WoltProfileStatus', readonly openingTimes: ReadonlyArray<{ readonly __typename?: 'WoltBusinessHour', readonly openAt: TimeString, readonly closeAt: TimeString, readonly weekDay: { readonly __typename?: 'WeekDay', readonly id: ID, readonly enum: TWeekDayEnum } | null }> };

export type TMBusinessHoursSubmitVariables = Exact<{
  branchId: Scalars['ID'];
  hours: ReadonlyArray<TInputBusinessHourCreate>;
  mode: TBusinessHoursModeEnum;
}>;


export type TMBusinessHoursSubmit = { readonly __typename?: 'Mutation', readonly createBusinessHours: ReadonlyArray<{ readonly __typename?: 'BusinessHour', readonly id: ID, readonly openAt: TimeString, readonly closeAt: TimeString, readonly weekDay: { readonly __typename?: 'WeekDay', readonly enum: TWeekDayEnum } | null }> };

export type TMSpecificBusinessHourCreateVariables = Exact<{
  input: TInputBusinessHourSpecificDateCreate;
}>;


export type TMSpecificBusinessHourCreate = { readonly __typename?: 'Mutation', readonly result: { readonly __typename?: 'BusinessHour', readonly id: ID, readonly specificDate: Date | null, readonly closed: boolean, readonly closedNote: string | null, readonly openAt: TimeString, readonly closeAt: TimeString, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID } } };

export type TMSpecificBusinessHourDeleteVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TMSpecificBusinessHourDelete = { readonly __typename?: 'Mutation', readonly result: { readonly __typename?: 'BusinessHour', readonly id: ID } };

export type TMUpdateBoltBusinessHoursVariables = Exact<{
  profileId: Scalars['ID'];
  businessHours: ReadonlyArray<TInputIntegrationsBusinessHourCreate>;
}>;


export type TMUpdateBoltBusinessHours = { readonly __typename?: 'Mutation', readonly pushIntegrationsBusinessHours: ReadonlyArray<{ readonly __typename?: 'IntegrationsBusinessHour', readonly id: ID }> };

export type TMUpdateUsualHandoverTimeVariables = Exact<{
  minutes: Scalars['Int'];
  branchId: Scalars['ID'];
  handoverType: TDeliveryTypeEnum;
}>;


export type TMUpdateUsualHandoverTime = { readonly __typename?: 'Mutation', readonly handoverTimes: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly defaultDeliveryTimeEnabled: boolean, readonly defaultPickupTimeEnabled: boolean, readonly usualDeliveryTime: number, readonly usualPickupTime: number } };

export type TMUpdateWoltBusinessHoursVariables = Exact<{
  profileId: Scalars['ID'];
  businessHours: ReadonlyArray<TInputBusinessHourCreate>;
}>;


export type TMUpdateWoltBusinessHours = { readonly __typename?: 'Mutation', readonly updateWoltBusinessHours: { readonly __typename?: 'WoltProfile', readonly id: ID } };

export type TMWoltBusinessHoursVariables = Exact<{
  profileId: Scalars['ID'];
}>;


export type TMWoltBusinessHours = { readonly __typename?: 'Mutation', readonly woltProfileStatus: { readonly __typename?: 'WoltProfileStatus', readonly openingTimes: ReadonlyArray<{ readonly __typename?: 'WoltBusinessHour', readonly openAt: TimeString, readonly closeAt: TimeString, readonly weekDay: { readonly __typename?: 'WeekDay', readonly id: ID, readonly enum: TWeekDayEnum } | null }> } };

export type TQBoltBusinessHoursVariables = Exact<{
  profileId: Scalars['ID'];
}>;


export type TQBoltBusinessHours = { readonly __typename?: 'Query', readonly integrationsBusinessHours: ReadonlyArray<{ readonly __typename?: 'IntegrationsBusinessHour', readonly id: ID, readonly openAt: TimeString, readonly closeAt: TimeString, readonly weekDay: { readonly __typename?: 'WeekDay', readonly id: ID, readonly enum: TWeekDayEnum } }> };

export type TQRegularBusinessHoursVariables = Exact<{
  branchId: Scalars['ID'];
  mode: TBusinessHoursModeEnum;
}>;


export type TQRegularBusinessHours = { readonly __typename?: 'Query', readonly businessHours: ReadonlyArray<{ readonly __typename?: 'BusinessHour', readonly id: ID, readonly openAt: TimeString, readonly closeAt: TimeString, readonly weekDay: { readonly __typename?: 'WeekDay', readonly enum: TWeekDayEnum } | null }> };

export type TQSpecificBusinessHoursVariables = Exact<{
  branchId: Scalars['ID'];
  mode: TBusinessHoursModeEnum;
}>;


export type TQSpecificBusinessHours = { readonly __typename?: 'Query', readonly businessHours: ReadonlyArray<{ readonly __typename?: 'BusinessHour', readonly id: ID, readonly specificDate: Date | null, readonly closed: boolean, readonly closedNote: string | null, readonly openAt: TimeString, readonly closeAt: TimeString, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID } }> };

export type TQUsualHandoverTimesVariables = Exact<{
  branchId: Scalars['ID'];
}>;


export type TQUsualHandoverTimes = { readonly __typename?: 'Query', readonly handoverTimes: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly defaultDeliveryTimeEnabled: boolean, readonly defaultPickupTimeEnabled: boolean, readonly usualDeliveryTime: number, readonly usualPickupTime: number } };

export type TQWeekDaysVariables = Exact<{ [key: string]: never; }>;


export type TQWeekDays = { readonly __typename?: 'Query', readonly weekDays: ReadonlyArray<{ readonly __typename?: 'WeekDay', readonly id: ID, readonly enum: TWeekDayEnum, readonly code: string }> };

export type TFAcceptedOrder = { readonly __typename?: 'FinishedOrder', readonly userErrors: ReadonlyArray<string>, readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly countWares: number, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly note: string | null, readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly nameLabel: string, readonly sideDishCount: number }, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly nameLabel: string }, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly coverPrice: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly discounts: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly minimalOrderPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string } | null, readonly totalDiscount: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly totalVouchers: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly value: number } } };

export type TFCreateOrder = { readonly __typename?: 'Order', readonly id: ID, readonly countWares: number, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly note: string | null, readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly nameLabel: string, readonly sideDishCount: number }, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly nameLabel: string }, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly coverPrice: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly discounts: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly minimalOrderPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string } | null, readonly totalDiscount: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly totalVouchers: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly value: number } };

export type TFCreateOrderItem = { readonly __typename?: 'OrderRecipe', readonly id: ID, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly nameLabel: string } };

export type TFCreateOrderRecipeSideDishes = { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string, readonly isDynamicPricingEnabled: boolean, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } }, readonly sideDishCategories: ReadonlyArray<{ readonly __typename?: 'WareCategory', readonly id: ID, readonly nameLabel: string, readonly minCount: number, readonly maxCount: number, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } } }> }> };

export type TFOrderCustomer = { readonly __typename?: 'CustomerInformation', readonly email: string, readonly firstName: string, readonly lastName: string, readonly customer: { readonly __typename?: 'Customer', readonly id: ID, readonly isRegistered: boolean } | null, readonly locations: ReadonlyArray<{ readonly __typename?: 'JsonAddress', readonly state: string | null, readonly city: string | null, readonly venue: string | null, readonly street: string | null, readonly houseNumber: string | null, readonly country: string | null, readonly gps: { readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number } | null }> };

export type TFOrderCustomerLocation = { readonly __typename?: 'JsonAddress', readonly state: string | null, readonly city: string | null, readonly venue: string | null, readonly street: string | null, readonly houseNumber: string | null, readonly country: string | null, readonly gps: { readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number } | null };

export type TMAcceptCashRegisterOrderVariables = Exact<{
  orderId: Scalars['ID'];
  customer: TInputCustomerCreate;
  note?: InputMaybe<Scalars['String']>;
  paymentType?: InputMaybe<TPaymentTypeEnum>;
  paymentGate?: InputMaybe<TPaymentGateEnum>;
}>;


export type TMAcceptCashRegisterOrder = { readonly __typename?: 'Mutation', readonly finishOrder: { readonly __typename?: 'FinishedOrder', readonly userErrors: ReadonlyArray<string>, readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly countWares: number, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly note: string | null, readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly nameLabel: string, readonly sideDishCount: number }, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly nameLabel: string }, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly coverPrice: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly discounts: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly minimalOrderPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string } | null, readonly totalDiscount: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly totalVouchers: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly value: number } } } };

export type TMAddOrderPromoVariables = Exact<{
  orderId: Scalars['ID'];
  code: Scalars['String'];
}>;


export type TMAddOrderPromo = { readonly __typename?: 'Mutation', readonly addOrderPromoCode: { readonly __typename?: 'OrderWithErrors', readonly userErrors: ReadonlyArray<string>, readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly countWares: number, readonly promoCodes: ReadonlyArray<{ readonly __typename?: 'PromoCode', readonly id: ID, readonly code: string }>, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly note: string | null, readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly nameLabel: string, readonly sideDishCount: number }, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly nameLabel: string }, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly coverPrice: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly discounts: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly minimalOrderPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string } | null, readonly totalDiscount: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly totalVouchers: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly value: number } } } };

export type TMAddToSectorVariables = Exact<{
  sectorId: Scalars['ID'];
  recipeId: Scalars['ID'];
  sideDishes?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
}>;


export type TMAddToSector = { readonly __typename?: 'Mutation', readonly createSectorRecipe: ReadonlyArray<{ readonly __typename?: 'SectorRecipe', readonly id: ID }> };

export type TMCancelOrderVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type TMCancelOrder = { readonly __typename?: 'Mutation', readonly addOrderState: { readonly __typename?: 'Order', readonly id: ID, readonly orderStateCategory: TOrderStateCategoryEnum } };

export type TMCreateOrderAcceptVariables = Exact<{
  orderId: Scalars['ID'];
  customer: TInputCustomerCreate;
  deliverAt?: InputMaybe<Scalars['DateTime']>;
  note?: InputMaybe<Scalars['String']>;
  paymentType?: InputMaybe<TPaymentTypeEnum>;
  paymentGate?: InputMaybe<TPaymentGateEnum>;
}>;


export type TMCreateOrderAccept = { readonly __typename?: 'Mutation', readonly finishOrder: { readonly __typename?: 'FinishedOrder', readonly userErrors: ReadonlyArray<string>, readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly countWares: number, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly note: string | null, readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly nameLabel: string, readonly sideDishCount: number }, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly nameLabel: string }, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly coverPrice: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly discounts: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly minimalOrderPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string } | null, readonly totalDiscount: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly totalVouchers: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly value: number } } } };

export type TMCreateOrderAddRecipeVariables = Exact<{
  note?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
  recipeId: Scalars['ID'];
  categoryId: Scalars['ID'];
  sideDishes?: InputMaybe<ReadonlyArray<TInputOrderRecipeSideDishCreate>>;
  itemQuantity: Scalars['Int'];
  dynamicPrice?: InputMaybe<TInputCurrencyCreate>;
}>;


export type TMCreateOrderAddRecipe = { readonly __typename?: 'Mutation', readonly createOrderRecipe: { readonly __typename?: 'Order', readonly id: ID, readonly countWares: number, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly note: string | null, readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly nameLabel: string, readonly sideDishCount: number }, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly nameLabel: string }, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly coverPrice: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly discounts: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly minimalOrderPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string } | null, readonly totalDiscount: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly totalVouchers: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly value: number } } };

export type TMCreateOrderNewVariables = Exact<{
  branchId: Scalars['ID'];
  deliveryType?: InputMaybe<TDeliveryTypeEnum>;
  deliverAt?: InputMaybe<Scalars['DateTime']>;
  gps: TInputGeoPointCreate;
  callEventId?: InputMaybe<Scalars['ID']>;
  warePriceType: TWarePriceTypeEnum;
  resolvedAddress?: InputMaybe<TInputOrderResolvedAddressType>;
}>;


export type TMCreateOrderNew = { readonly __typename?: 'Mutation', readonly createOrder: { readonly __typename?: 'Order', readonly id: ID, readonly countWares: number, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly note: string | null, readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly nameLabel: string, readonly sideDishCount: number }, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly nameLabel: string }, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly coverPrice: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly discounts: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly minimalOrderPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string } | null, readonly totalDiscount: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly totalVouchers: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly value: number } } };

export type TMCreateOrderNewCashRegisterVariables = Exact<{
  branchId: Scalars['ID'];
  deliveryType?: InputMaybe<TDeliveryTypeEnum>;
  deliverAt?: InputMaybe<Scalars['DateTime']>;
  gps: TInputGeoPointCreate;
  callEventId?: InputMaybe<Scalars['ID']>;
  warePriceType: TWarePriceTypeEnum;
}>;


export type TMCreateOrderNewCashRegister = { readonly __typename?: 'Mutation', readonly createOrder: { readonly __typename?: 'Order', readonly id: ID, readonly countWares: number, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly note: string | null, readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly nameLabel: string, readonly sideDishCount: number }, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly nameLabel: string }, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly coverPrice: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly discounts: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly minimalOrderPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string } | null, readonly totalDiscount: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly totalVouchers: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly value: number } } };

export type TMCreateOrderRemoveItemVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type TMCreateOrderRemoveItem = { readonly __typename?: 'Mutation', readonly destroyOrderRecipe: { readonly __typename?: 'Order', readonly id: ID, readonly countWares: number, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly note: string | null, readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly nameLabel: string, readonly sideDishCount: number }, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly nameLabel: string }, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly coverPrice: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly discounts: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly minimalOrderPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string } | null, readonly totalDiscount: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly totalVouchers: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly value: number } } };

export type TMCreateOrderUpdateVariables = Exact<{
  orderId: Scalars['ID'];
  deliveryType?: InputMaybe<TDeliveryTypeEnum>;
  deliverAt?: InputMaybe<Scalars['DateTime']>;
  gps: TInputGeoPointCreate;
  customer?: InputMaybe<TInputCustomerCreate>;
  warePriceType?: InputMaybe<TWarePriceTypeEnum>;
  resolvedAddress?: InputMaybe<TInputOrderResolvedAddressType>;
}>;


export type TMCreateOrderUpdate = { readonly __typename?: 'Mutation', readonly updateOrder: { readonly __typename?: 'Order', readonly id: ID, readonly countWares: number, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly note: string | null, readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly nameLabel: string, readonly sideDishCount: number }, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly nameLabel: string }, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly coverPrice: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly discounts: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly minimalOrderPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string } | null, readonly totalDiscount: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly totalVouchers: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly value: number } } };

export type TMCreateOrderUpdateItemVariables = Exact<{
  itemId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  sideDishes?: InputMaybe<ReadonlyArray<TInputOrderRecipeSideDishUpdate>>;
  dynamicPrice?: InputMaybe<TInputCurrencyCreate>;
}>;


export type TMCreateOrderUpdateItem = { readonly __typename?: 'Mutation', readonly updateOrderRecipe: { readonly __typename?: 'Order', readonly id: ID, readonly countWares: number, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly note: string | null, readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly nameLabel: string, readonly sideDishCount: number }, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly nameLabel: string }, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly coverPrice: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly discounts: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly minimalOrderPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string } | null, readonly totalDiscount: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly totalVouchers: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly value: number } } };

export type TMRemoveOrderPromoVariables = Exact<{
  orderId: Scalars['ID'];
  codeId: Scalars['ID'];
}>;


export type TMRemoveOrderPromo = { readonly __typename?: 'Mutation', readonly removeOrderPromoCode: { readonly __typename?: 'Order', readonly id: ID, readonly countWares: number, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly note: string | null, readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly nameLabel: string, readonly sideDishCount: number }, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly nameLabel: string }, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly coverPrice: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly discounts: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly minimalOrderPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string } | null, readonly totalDiscount: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly totalVouchers: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly value: number } } };

export type TQBranchInHousePaymentMethodsVariables = Exact<{
  branchId: Scalars['ID'];
}>;


export type TQBranchInHousePaymentMethods = { readonly __typename?: 'Query', readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly paymentMethods: ReadonlyArray<{ readonly __typename?: 'PaymentMethod', readonly id: ID }> } };

export type TQBranchPaymentMethodsVariables = Exact<{
  branchId: Scalars['ID'];
  deliveryType?: InputMaybe<TDeliveryTypeEnum>;
  warePriceType?: InputMaybe<TWarePriceTypeEnum>;
}>;


export type TQBranchPaymentMethods = { readonly __typename?: 'Query', readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly paymentMethods: ReadonlyArray<{ readonly __typename?: 'PaymentMethod', readonly id: ID, readonly description: string, readonly paymentType: { readonly __typename?: 'PaymentType', readonly id: ID, readonly enum: TPaymentTypeEnum }, readonly paymentGate: { readonly __typename?: 'PaymentGate', readonly id: ID, readonly enum: TPaymentGateEnum, readonly code: string } }> } };

export type TQCreateOrderItemVariables = Exact<{
  itemId: Scalars['ID'];
  warePriceType?: InputMaybe<TWarePriceTypeEnum>;
}>;


export type TQCreateOrderItem = { readonly __typename?: 'Query', readonly item: { readonly __typename?: 'OrderRecipe', readonly id: ID, readonly note: string | null, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string, readonly isDynamicPricingEnabled: boolean, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } }, readonly sideDishCategories: ReadonlyArray<{ readonly __typename?: 'WareCategory', readonly id: ID, readonly nameLabel: string, readonly minCount: number, readonly maxCount: number, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } } }> }> }, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly selectedSideDishes: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly wareCategory: { readonly __typename?: 'WareCategory', readonly id: ID } | null, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID } }> } };

export type TQCreateOrderRecipeVariables = Exact<{
  recipeId: Scalars['ID'];
  branchId: Scalars['ID'];
  warePriceType?: InputMaybe<TWarePriceTypeEnum>;
}>;


export type TQCreateOrderRecipe = { readonly __typename?: 'Query', readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string, readonly isDynamicPricingEnabled: boolean, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } }, readonly sideDishCategories: ReadonlyArray<{ readonly __typename?: 'WareCategory', readonly id: ID, readonly nameLabel: string, readonly minCount: number, readonly maxCount: number, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } } }> }> } };

export type TQOrderCartVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type TQOrderCart = { readonly __typename?: 'Query', readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly countWares: number, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly note: string | null, readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly nameLabel: string, readonly sideDishCount: number }, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly nameLabel: string }, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly coverPrice: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly discounts: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly minimalOrderPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string } | null, readonly totalDiscount: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly totalVouchers: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly value: number } } };

export type TQOrderFormDeliverAtDefaultsVariables = Exact<{
  branchId: Scalars['ID'];
}>;


export type TQOrderFormDeliverAtDefaults = { readonly __typename?: 'Query', readonly times: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly deliveryTime: number, readonly pickupTime: number } };

export type TQOrderFormPromoVariables = Exact<{
  branchId: Scalars['ID'];
}>;


export type TQOrderFormPromo = { readonly __typename?: 'Query', readonly promoCodes: ReadonlyArray<{ readonly __typename?: 'PromoCode', readonly id: ID, readonly code: string }> };

export type TQOrderMenuVariables = Exact<{
  branchId: Scalars['ID'];
  orderOrigin: TOrderOriginCategoryEnum;
}>;


export type TQOrderMenu = { readonly __typename?: 'Query', readonly orderMenu: ReadonlyArray<{ readonly __typename?: 'OrderMenu', readonly id: ID, readonly nameLabel: string, readonly pictogram: string | null, readonly recipes: ReadonlyArray<{ readonly __typename?: 'OrderMenuRecipe', readonly id: ID, readonly isDynamicPricingEnabled: boolean, readonly code: string, readonly nameLabel: string, readonly internalNote: string | null, readonly descriptionLabel: string | null, readonly sideDishCount: number, readonly recipeColor: { readonly __typename?: 'RecipeColor', readonly id: ID, readonly color: string } | null, readonly deliveryPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string }, readonly inHousePrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string } }>, readonly color: { readonly __typename?: 'WareCategoryColor', readonly id: ID, readonly color: string } | null }> };

export type TQOrderVamCustomerVariables = Exact<{
  branchId: Scalars['ID'];
  phone: Scalars['String'];
}>;


export type TQOrderVamCustomer = { readonly __typename?: 'Query', readonly vamCustomer: { readonly __typename?: 'CustomerInformation', readonly isFound: boolean, readonly email: string, readonly firstName: string, readonly lastName: string, readonly customer: { readonly __typename?: 'Customer', readonly id: ID, readonly isRegistered: boolean } | null, readonly locations: ReadonlyArray<{ readonly __typename?: 'JsonAddress', readonly state: string | null, readonly city: string | null, readonly venue: string | null, readonly street: string | null, readonly houseNumber: string | null, readonly country: string | null, readonly gps: { readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number } | null }> } };

export type TQSearchBranchForAddressVariables = Exact<{
  brandId: Scalars['ID'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
}>;


export type TQSearchBranchForAddress = { readonly __typename?: 'Query', readonly resolveLocation: { readonly __typename?: 'AddressResolvedLocation', readonly inDeliveryLocation: boolean, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string } | null, readonly zone: { readonly __typename?: 'Zone', readonly minimalOrderPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string } } | null } };

export type TQValidateLocationVariables = Exact<{
  branchId: Scalars['ID'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
}>;


export type TQValidateLocation = { readonly __typename?: 'Query', readonly resolveLocation: { readonly __typename?: 'AddressResolvedLocation', readonly inDeliveryLocation: boolean, readonly zone: { readonly __typename?: 'Zone', readonly minimalOrderPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string } } | null } };

export type TFCustomerScreenOrder = { readonly __typename?: 'Order', readonly id: ID, readonly orderStateCategory: TOrderStateCategoryEnum, readonly orderNumber: number | null, readonly warePriceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly stateChanges: ReadonlyArray<{ readonly __typename?: 'OrderStateCategoryRelation', readonly createdAt: Date, readonly state: TOrderStateCategoryEnum }> };

export type TQCustomerScreenOrderListVariables = Exact<{
  branches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  categories?: InputMaybe<ReadonlyArray<TOrderStateCategoryEnum>>;
  sectors?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  acceptedAfter?: InputMaybe<Scalars['DateTime']>;
}>;


export type TQCustomerScreenOrderList = { readonly __typename?: 'Query', readonly orders: ReadonlyArray<{ readonly __typename?: 'Order', readonly id: ID, readonly orderStateCategory: TOrderStateCategoryEnum, readonly orderNumber: number | null, readonly warePriceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly stateChanges: ReadonlyArray<{ readonly __typename?: 'OrderStateCategoryRelation', readonly createdAt: Date, readonly state: TOrderStateCategoryEnum }> }> };

export type TSCustomerScreenOrderListVariables = Exact<{
  branches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  categories?: InputMaybe<ReadonlyArray<TOrderStateCategoryEnum>>;
  sectors?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
}>;


export type TSCustomerScreenOrderList = { readonly __typename?: 'Subscription', readonly updatedOrder: { readonly __typename?: 'OrderUpdateSubscription', readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly orderStateCategory: TOrderStateCategoryEnum, readonly orderNumber: number | null, readonly warePriceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly stateChanges: ReadonlyArray<{ readonly __typename?: 'OrderStateCategoryRelation', readonly createdAt: Date, readonly state: TOrderStateCategoryEnum }> } | null } };

export type TMUpdateBranchDeliveryTypesVariables = Exact<{
  branchId: Scalars['ID'];
  deliveryTypes: ReadonlyArray<TDeliveryTypeEnum>;
}>;


export type TMUpdateBranchDeliveryTypes = { readonly __typename?: 'Mutation', readonly updateAllowedDeliveryTypes: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string, readonly deliveryEnabled: boolean, readonly pickupEnabled: boolean } };

export type TQDeliveryTypesForBranchVariables = Exact<{
  branchId: Scalars['ID'];
}>;


export type TQDeliveryTypesForBranch = { readonly __typename?: 'Query', readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string, readonly deliveryEnabled: boolean, readonly pickupEnabled: boolean } };

export type TFExpressState = { readonly __typename?: 'ExpressDeliverySetting', readonly id: ID, readonly isExpressEnabled: boolean, readonly isExpressAvailable: boolean, readonly pausedUntil: Date | null };

export type TMUpdateExpressDeliverySettingVariables = Exact<{
  id: Scalars['ID'];
  setting: TExpressDeliverySettingUpdate;
}>;


export type TMUpdateExpressDeliverySetting = { readonly __typename?: 'Mutation', readonly updateExpressDeliverySetting: { readonly __typename?: 'ExpressDeliverySetting', readonly id: ID, readonly isExpressEnabled: boolean, readonly pausedUntil: Date | null } };

export type TQExpressDeliverySettingVariables = Exact<{
  branchId: Scalars['ID'];
}>;


export type TQExpressDeliverySetting = { readonly __typename?: 'Query', readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly expressDeliverySetting: { readonly __typename?: 'ExpressDeliverySetting', readonly ordersInProgressLimit: number | null, readonly expressBaseTimeMinutes: number, readonly id: ID, readonly isExpressEnabled: boolean, readonly isExpressAvailable: boolean, readonly pausedUntil: Date | null, readonly expressFee: { readonly __typename?: 'PriceConverted', readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } }, readonly maxOrderValue: { readonly __typename?: 'PriceConverted', readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } } | null } | null } };

export type TFHeaderTextInForm = { readonly __typename?: 'Company', readonly id: ID, readonly promoHeaderEnabled: boolean | null, readonly promoHeaderTranslations: ReadonlyArray<{ readonly __typename?: 'PromoHeaderTranslation', readonly content: string | null, readonly language: TLanguageEnum }> | null };

export type TMUpdateHeaderTextVariables = Exact<{
  brandId?: InputMaybe<Scalars['ID']>;
  branchId?: InputMaybe<Scalars['ID']>;
  translations: ReadonlyArray<TInputLabelTranslation>;
  enabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type TMUpdateHeaderText = { readonly __typename?: 'Mutation', readonly updatedHeaderText: boolean | null };

export type TQBranchHeaderTextVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TQBranchHeaderText = { readonly __typename?: 'Query', readonly headerText: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly promoHeaderEnabled: boolean | null, readonly promoHeaderTranslations: ReadonlyArray<{ readonly __typename?: 'PromoHeaderTranslation', readonly content: string | null, readonly language: TLanguageEnum }> | null } };

export type TQBranchHeaderTextLightVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TQBranchHeaderTextLight = { readonly __typename?: 'Query', readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly promoHeaderText: string | null, readonly promoHeaderEnabled: boolean | null } };

export type TQBrandHeaderTextVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TQBrandHeaderText = { readonly __typename?: 'Query', readonly headerText: { readonly __typename?: 'Company', readonly id: ID, readonly promoHeaderEnabled: boolean | null, readonly promoHeaderTranslations: ReadonlyArray<{ readonly __typename?: 'PromoHeaderTranslation', readonly content: string | null, readonly language: TLanguageEnum }> | null } };

export type TQBrandHeaderTextLightVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TQBrandHeaderTextLight = { readonly __typename?: 'Query', readonly brand: { readonly __typename?: 'Company', readonly id: ID, readonly promoHeaderText: string | null } };

export type TFBoltBase = { readonly __typename?: 'BoltProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } };

export type TFBoltProfileWithStates = { readonly __typename?: 'BoltProfile', readonly isAutomaticMenuSyncEnabled: boolean, readonly lastMenuSyncAt: Date | null, readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly onlineState: { readonly __typename?: 'IntegrationState', readonly id: ID, readonly enum: TIntegrationStateEnum } | null, readonly deliveryProvider: { readonly __typename?: 'BoltDeliveryProvider', readonly id: ID, readonly enum: TBoltDeliveryProviderEnum } | null, readonly integrationFlow: { readonly __typename?: 'IntegrationsFlow', readonly id: ID, readonly enum: TIntegrationsFlowEnum }, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } };

export type TFDotykackaBase = { readonly __typename?: 'DotykackaProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } };

export type TFDotykackaProfileWithStates = { readonly __typename?: 'DotykackaProfile', readonly lastMenuSyncAt: Date | null, readonly id: ID, readonly name: string, readonly restaurantIdValue: string, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } };

export type TFFoodoraDeliveryInfo = { readonly __typename?: 'FoodoraRecordGlType', readonly isDeliveredByFoodora: boolean, readonly minFoodoraPickupTime: Date | null, readonly maxFoodoraPickupTime: Date | null };

export type TFFoodoraBase = { readonly __typename?: 'FoodoraProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } };

export type TFFoodoraProfileWithStates = { readonly __typename?: 'FoodoraProfile', readonly isAutomaticMenuSyncEnabled: boolean, readonly lastMenuSyncAt: Date | null, readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly onlineState: { readonly __typename?: 'IntegrationState', readonly id: ID, readonly enum: TIntegrationStateEnum } | null, readonly deliveryProvider: { readonly __typename?: 'FoodoraDeliveryProvider', readonly id: ID, readonly enum: TFoodoraDeliveryProviderEnum } | null, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } };

export type TFIntegrationOnlineState = { readonly __typename?: 'IntegrationState', readonly id: ID, readonly enum: TIntegrationStateEnum };

export type TFIntegrationOrderAccept = { readonly __typename?: 'Order', readonly id: ID, readonly deliverAt: Date | null, readonly delayedDeliveryTime: Date | null, readonly canBeCanceled: boolean, readonly orderOrigin: { readonly __typename?: 'OrderOrigin', readonly enum: TOrderOriginEnum }, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly defaultDeliveryTimeEnabled: boolean, readonly defaultPickupTimeEnabled: boolean, readonly usualDeliveryTime: number, readonly usualPickupTime: number }, readonly foodoraRecord: { readonly __typename?: 'FoodoraRecordGlType', readonly isDeliveredByFoodora: boolean, readonly minFoodoraPickupTime: Date | null, readonly maxFoodoraPickupTime: Date | null } | null };

export type TFJidloPodNosBase = { readonly __typename?: 'JidloPodNosProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } };

export type TFJidloPodNosProfileWithStates = { readonly __typename?: 'JidloPodNosProfile', readonly lastMenuSyncAt: Date | null, readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } };

export type TFWoltProfile = { readonly __typename?: 'WoltProfile', readonly onboardingErrorsLocalised: ReadonlyArray<string>, readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly onboardingState: { readonly __typename?: 'WoltProfileOnboardingState', readonly id: ID, readonly enum: TWoltProfileOnboardingStateEnum }, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } };

export type TFWoltProfileBase = { readonly __typename?: 'WoltProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } };

export type TFWoltProfileWithStates = { readonly __typename?: 'WoltProfile', readonly isAutomaticMenuSyncEnabled: boolean, readonly lastMenuSyncAt: Date | null, readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly onboardingState: { readonly __typename?: 'WoltProfileOnboardingState', readonly id: ID, readonly enum: TWoltProfileOnboardingStateEnum }, readonly onlineState: { readonly __typename?: 'IntegrationState', readonly id: ID, readonly enum: TIntegrationStateEnum } | null, readonly deliveryProvider: { readonly __typename?: 'WoltDeliveryProvider', readonly id: ID, readonly enum: TWoltDeliveryProviderEnum } | null, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } };

export type TMBoltAcceptOrderVariables = Exact<{
  orderId: Scalars['ID'];
  deliverAt?: InputMaybe<Scalars['DateTime']>;
}>;


export type TMBoltAcceptOrder = { readonly __typename?: 'Mutation', readonly acceptBoltOrder: { readonly __typename?: 'Order', readonly id: ID, readonly orderStateCategory: TOrderStateCategoryEnum, readonly stateChanges: ReadonlyArray<{ readonly __typename?: 'OrderStateCategoryRelation', readonly createdAt: Date, readonly state: TOrderStateCategoryEnum }> } };

export type TMBoltDeleteProfileVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TMBoltDeleteProfile = { readonly __typename?: 'Mutation', readonly boltProfile: { readonly __typename?: 'BoltProfile', readonly id: ID } };

export type TMBoltEditProfileVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  isAutomaticMenuSyncEnabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type TMBoltEditProfile = { readonly __typename?: 'Mutation', readonly boltProfile: { readonly __typename?: 'BoltProfile', readonly id: ID, readonly isAutomaticMenuSyncEnabled: boolean } };

export type TMBoltPushMenuVariables = Exact<{
  profileId: Scalars['ID'];
}>;


export type TMBoltPushMenu = { readonly __typename?: 'Mutation', readonly pushBoltMenu: { readonly __typename?: 'BoltProfile', readonly id: ID, readonly isAutomaticMenuSyncEnabled: boolean, readonly lastMenuSyncAt: Date | null, readonly name: string, readonly restaurantIdValue: string | null, readonly onlineState: { readonly __typename?: 'IntegrationState', readonly id: ID, readonly enum: TIntegrationStateEnum } | null, readonly deliveryProvider: { readonly __typename?: 'BoltDeliveryProvider', readonly id: ID, readonly enum: TBoltDeliveryProviderEnum } | null, readonly integrationFlow: { readonly __typename?: 'IntegrationsFlow', readonly id: ID, readonly enum: TIntegrationsFlowEnum }, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } } };

export type TMBoltRejectOrderVariables = Exact<{
  orderId: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
}>;


export type TMBoltRejectOrder = { readonly __typename?: 'Mutation', readonly cancelBoltOrder: { readonly __typename?: 'Order', readonly id: ID, readonly orderStateCategory: TOrderStateCategoryEnum, readonly stateChanges: ReadonlyArray<{ readonly __typename?: 'OrderStateCategoryRelation', readonly createdAt: Date, readonly state: TOrderStateCategoryEnum }> } };

export type TMBoltUpdateAutomaticMenuSyncVariables = Exact<{
  id: Scalars['ID'];
  isAutomaticMenuSyncEnabled: Scalars['Boolean'];
}>;


export type TMBoltUpdateAutomaticMenuSync = { readonly __typename?: 'Mutation', readonly boltProfile: { readonly __typename?: 'BoltProfile', readonly id: ID } };

export type TMBoltUpdateAvailabilityStateVariables = Exact<{
  profileId: Scalars['ID'];
  availabilityState: TBoltAvailabilityStateGlEnum;
}>;


export type TMBoltUpdateAvailabilityState = { readonly __typename?: 'Mutation', readonly updateBoltAvailabilityState: { readonly __typename?: 'BoltProfile', readonly id: ID, readonly onlineState: { readonly __typename?: 'IntegrationState', readonly id: ID, readonly enum: TIntegrationStateEnum } | null } };

export type TMDotykackaDeleteProfileVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TMDotykackaDeleteProfile = { readonly __typename?: 'Mutation', readonly dotykackaProfile: { readonly __typename?: 'DotykackaProfile', readonly id: ID } };

export type TMDotykackaEditProfileVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
}>;


export type TMDotykackaEditProfile = { readonly __typename?: 'Mutation', readonly dotykackaProfile: { readonly __typename?: 'DotykackaProfile', readonly id: ID } };

export type TMFoodoraAcceptOrderVariables = Exact<{
  orderId: Scalars['ID'];
  deliverAt?: InputMaybe<Scalars['DateTime']>;
}>;


export type TMFoodoraAcceptOrder = { readonly __typename?: 'Mutation', readonly acceptFoodoraOrder: { readonly __typename?: 'Order', readonly id: ID, readonly orderStateCategory: TOrderStateCategoryEnum, readonly stateChanges: ReadonlyArray<{ readonly __typename?: 'OrderStateCategoryRelation', readonly createdAt: Date, readonly state: TOrderStateCategoryEnum }> } };

export type TMFoodoraAdjustOrderPickupTimeVariables = Exact<{
  orderId: Scalars['ID'];
  pickupAt: Scalars['DateTime'];
}>;


export type TMFoodoraAdjustOrderPickupTime = { readonly __typename?: 'Mutation', readonly adjustFoodoraOrderPickupTime: { readonly __typename?: 'Order', readonly id: ID } };

export type TMFoodoraDeleteProfileVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TMFoodoraDeleteProfile = { readonly __typename?: 'Mutation', readonly foodoraProfile: { readonly __typename?: 'FoodoraProfile', readonly id: ID } };

export type TMFoodoraEditProfileVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  isAutomaticMenuSyncEnabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type TMFoodoraEditProfile = { readonly __typename?: 'Mutation', readonly foodoraProfile: { readonly __typename?: 'FoodoraProfile', readonly id: ID, readonly isAutomaticMenuSyncEnabled: boolean } };

export type TMFoodoraPushMenuVariables = Exact<{
  profileId: Scalars['ID'];
}>;


export type TMFoodoraPushMenu = { readonly __typename?: 'Mutation', readonly pushFoodoraMenu: { readonly __typename?: 'FoodoraProfile', readonly id: ID, readonly isAutomaticMenuSyncEnabled: boolean, readonly lastMenuSyncAt: Date | null, readonly name: string, readonly restaurantIdValue: string | null, readonly onlineState: { readonly __typename?: 'IntegrationState', readonly id: ID, readonly enum: TIntegrationStateEnum } | null, readonly deliveryProvider: { readonly __typename?: 'FoodoraDeliveryProvider', readonly id: ID, readonly enum: TFoodoraDeliveryProviderEnum } | null, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } } };

export type TMFoodoraRejectOrderVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type TMFoodoraRejectOrder = { readonly __typename?: 'Mutation', readonly cancelFoodoraOrder: { readonly __typename?: 'Order', readonly id: ID, readonly orderStateCategory: TOrderStateCategoryEnum, readonly stateChanges: ReadonlyArray<{ readonly __typename?: 'OrderStateCategoryRelation', readonly createdAt: Date, readonly state: TOrderStateCategoryEnum }> } };

export type TMFoodoraUpdateAutomaticMenuSyncVariables = Exact<{
  id: Scalars['ID'];
  isAutomaticMenuSyncEnabled: Scalars['Boolean'];
}>;


export type TMFoodoraUpdateAutomaticMenuSync = { readonly __typename?: 'Mutation', readonly foodoraProfile: { readonly __typename?: 'FoodoraProfile', readonly id: ID } };

export type TMFoodoraUpdateAvailabilityStateVariables = Exact<{
  profileId: Scalars['ID'];
  availabilityState: TFoodoraAvailabilityStateGlEnum;
}>;


export type TMFoodoraUpdateAvailabilityState = { readonly __typename?: 'Mutation', readonly updateFoodoraAvailabilityState: { readonly __typename?: 'FoodoraProfile', readonly id: ID, readonly onlineState: { readonly __typename?: 'IntegrationState', readonly id: ID, readonly enum: TIntegrationStateEnum } | null } };

export type TMJidloPodNosAcceptOrderVariables = Exact<{
  orderId: Scalars['ID'];
  deliverAt?: InputMaybe<Scalars['DateTime']>;
}>;


export type TMJidloPodNosAcceptOrder = { readonly __typename?: 'Mutation', readonly acceptJidloPodNosOrder: { readonly __typename?: 'Order', readonly id: ID, readonly orderStateCategory: TOrderStateCategoryEnum, readonly stateChanges: ReadonlyArray<{ readonly __typename?: 'OrderStateCategoryRelation', readonly createdAt: Date, readonly state: TOrderStateCategoryEnum }> } };

export type TMJidloPodNosDeleteProfileVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TMJidloPodNosDeleteProfile = { readonly __typename?: 'Mutation', readonly jidloPodNosProfile: { readonly __typename?: 'JidloPodNosProfile', readonly id: ID } };

export type TMJidloPodNosEditProfileVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
}>;


export type TMJidloPodNosEditProfile = { readonly __typename?: 'Mutation', readonly jidloPodNosProfile: { readonly __typename?: 'JidloPodNosProfile', readonly id: ID } };

export type TMJidloPodNosRejectOrderVariables = Exact<{
  orderId: Scalars['ID'];
  reason: Scalars['String'];
}>;


export type TMJidloPodNosRejectOrder = { readonly __typename?: 'Mutation', readonly cancelJidloPodNosOrder: { readonly __typename?: 'Order', readonly id: ID, readonly orderStateCategory: TOrderStateCategoryEnum, readonly stateChanges: ReadonlyArray<{ readonly __typename?: 'OrderStateCategoryRelation', readonly createdAt: Date, readonly state: TOrderStateCategoryEnum }> } };

export type TMWoltAcceptOrderVariables = Exact<{
  orderId: Scalars['ID'];
  deliverAt?: InputMaybe<Scalars['DateTime']>;
}>;


export type TMWoltAcceptOrder = { readonly __typename?: 'Mutation', readonly acceptWoltOrder: { readonly __typename?: 'Order', readonly id: ID, readonly orderStateCategory: TOrderStateCategoryEnum, readonly stateChanges: ReadonlyArray<{ readonly __typename?: 'OrderStateCategoryRelation', readonly createdAt: Date, readonly state: TOrderStateCategoryEnum }> } };

export type TMWoltCreateProfileVariables = Exact<{
  branchId: Scalars['ID'];
  name: Scalars['String'];
}>;


export type TMWoltCreateProfile = { readonly __typename?: 'Mutation', readonly woltProfile: { readonly __typename?: 'WoltProfile', readonly id: ID } };

export type TMWoltDeleteProfileVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TMWoltDeleteProfile = { readonly __typename?: 'Mutation', readonly woltProfile: { readonly __typename?: 'WoltProfile', readonly id: ID } };

export type TMWoltEditProfileVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  isAutomaticMenuSyncEnabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type TMWoltEditProfile = { readonly __typename?: 'Mutation', readonly woltProfile: { readonly __typename?: 'WoltProfile', readonly id: ID, readonly isAutomaticMenuSyncEnabled: boolean } };

export type TMWoltOnboardingUrlVariables = Exact<{
  profileId: Scalars['ID'];
  redirectUrl: Scalars['String'];
}>;


export type TMWoltOnboardingUrl = { readonly __typename?: 'Mutation', readonly woltOnboardingUrl: { readonly __typename?: 'WoltOnboardingUrl', readonly url: string } };

export type TMWoltPushMenuVariables = Exact<{
  profileId: Scalars['ID'];
}>;


export type TMWoltPushMenu = { readonly __typename?: 'Mutation', readonly pushWoltMenu: { readonly __typename?: 'WoltProfile', readonly id: ID, readonly isAutomaticMenuSyncEnabled: boolean, readonly lastMenuSyncAt: Date | null, readonly name: string, readonly restaurantIdValue: string | null, readonly onboardingState: { readonly __typename?: 'WoltProfileOnboardingState', readonly id: ID, readonly enum: TWoltProfileOnboardingStateEnum }, readonly onlineState: { readonly __typename?: 'IntegrationState', readonly id: ID, readonly enum: TIntegrationStateEnum } | null, readonly deliveryProvider: { readonly __typename?: 'WoltDeliveryProvider', readonly id: ID, readonly enum: TWoltDeliveryProviderEnum } | null, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } } };

export type TMWoltRejectOrderVariables = Exact<{
  orderId: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
}>;


export type TMWoltRejectOrder = { readonly __typename?: 'Mutation', readonly cancelWoltOrder: { readonly __typename?: 'Order', readonly id: ID, readonly orderStateCategory: TOrderStateCategoryEnum, readonly stateChanges: ReadonlyArray<{ readonly __typename?: 'OrderStateCategoryRelation', readonly createdAt: Date, readonly state: TOrderStateCategoryEnum }> } };

export type TMWoltUpdateAutomaticMenuSyncVariables = Exact<{
  id: Scalars['ID'];
  isAutomaticMenuSyncEnabled: Scalars['Boolean'];
}>;


export type TMWoltUpdateAutomaticMenuSync = { readonly __typename?: 'Mutation', readonly woltProfile: { readonly __typename?: 'WoltProfile', readonly id: ID } };

export type TMWoltUpdateDeliveryProviderVariables = Exact<{
  profileId: Scalars['ID'];
  deliveryProvider: TWoltDeliveryProviderEnum;
}>;


export type TMWoltUpdateDeliveryProvider = { readonly __typename?: 'Mutation', readonly updateWoltDeliveryProvider: { readonly __typename?: 'WoltProfile', readonly id: ID } };

export type TMWoltUpdateOnlineStateVariables = Exact<{
  profileId: Scalars['ID'];
  onlineState: TIntegrationStateEnum;
  until?: InputMaybe<Scalars['DateTime']>;
}>;


export type TMWoltUpdateOnlineState = { readonly __typename?: 'Mutation', readonly updateWoltOnlineState: { readonly __typename?: 'WoltProfile', readonly id: ID } };

export type TQBranchesForIntegrationsOverviewVariables = Exact<{
  branchesIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
}>;


export type TQBranchesForIntegrationsOverview = { readonly __typename?: 'Query', readonly companyBranches: ReadonlyArray<{ readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string, readonly woltProfiles: ReadonlyArray<{ readonly __typename?: 'WoltProfile', readonly isAutomaticMenuSyncEnabled: boolean, readonly lastMenuSyncAt: Date | null, readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly onboardingState: { readonly __typename?: 'WoltProfileOnboardingState', readonly id: ID, readonly enum: TWoltProfileOnboardingStateEnum }, readonly onlineState: { readonly __typename?: 'IntegrationState', readonly id: ID, readonly enum: TIntegrationStateEnum } | null, readonly deliveryProvider: { readonly __typename?: 'WoltDeliveryProvider', readonly id: ID, readonly enum: TWoltDeliveryProviderEnum } | null, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly foodoraProfiles: ReadonlyArray<{ readonly __typename?: 'FoodoraProfile', readonly isAutomaticMenuSyncEnabled: boolean, readonly lastMenuSyncAt: Date | null, readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly onlineState: { readonly __typename?: 'IntegrationState', readonly id: ID, readonly enum: TIntegrationStateEnum } | null, readonly deliveryProvider: { readonly __typename?: 'FoodoraDeliveryProvider', readonly id: ID, readonly enum: TFoodoraDeliveryProviderEnum } | null, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly boltProfiles: ReadonlyArray<{ readonly __typename?: 'BoltProfile', readonly isAutomaticMenuSyncEnabled: boolean, readonly lastMenuSyncAt: Date | null, readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly onlineState: { readonly __typename?: 'IntegrationState', readonly id: ID, readonly enum: TIntegrationStateEnum } | null, readonly deliveryProvider: { readonly __typename?: 'BoltDeliveryProvider', readonly id: ID, readonly enum: TBoltDeliveryProviderEnum } | null, readonly integrationFlow: { readonly __typename?: 'IntegrationsFlow', readonly id: ID, readonly enum: TIntegrationsFlowEnum }, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly jidloPodNosProfiles: ReadonlyArray<{ readonly __typename?: 'JidloPodNosProfile', readonly lastMenuSyncAt: Date | null, readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly dotykackaProfiles: ReadonlyArray<{ readonly __typename?: 'DotykackaProfile', readonly lastMenuSyncAt: Date | null, readonly id: ID, readonly name: string, readonly restaurantIdValue: string, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }> }> };

export type TQBranchesStatusesVariables = Exact<{
  branchesIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
}>;


export type TQBranchesStatuses = { readonly __typename?: 'Query', readonly states: { readonly __typename?: 'AggregatedIntegrationStates', readonly foodora: { readonly __typename?: 'FoodoraIntegration', readonly integrationState: { readonly __typename?: 'IntegrationState', readonly id: ID, readonly enum: TIntegrationStateEnum } } | null, readonly wolt: { readonly __typename?: 'WoltIntegration', readonly integrationState: { readonly __typename?: 'IntegrationState', readonly id: ID, readonly enum: TIntegrationStateEnum } } | null, readonly bolt: { readonly __typename?: 'BoltIntegration', readonly integrationState: { readonly __typename?: 'IntegrationState', readonly id: ID, readonly enum: TIntegrationStateEnum } } | null } };

export type TQIntegrationProfilesVariables = Exact<{
  branchId: Scalars['ID'];
  onboardingStates?: InputMaybe<ReadonlyArray<TWoltProfileOnboardingStateEnum>>;
}>;


export type TQIntegrationProfiles = { readonly __typename?: 'Query', readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly woltProfiles: ReadonlyArray<{ readonly __typename?: 'WoltProfile', readonly onboardingErrorsLocalised: ReadonlyArray<string>, readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly onboardingState: { readonly __typename?: 'WoltProfileOnboardingState', readonly id: ID, readonly enum: TWoltProfileOnboardingStateEnum }, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly foodoraProfiles: ReadonlyArray<{ readonly __typename?: 'FoodoraProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly boltProfiles: ReadonlyArray<{ readonly __typename?: 'BoltProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integrationFlow: { readonly __typename?: 'IntegrationsFlow', readonly id: ID, readonly enum: TIntegrationsFlowEnum }, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly jidloPodNosProfiles: ReadonlyArray<{ readonly __typename?: 'JidloPodNosProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly dotykackaProfiles: ReadonlyArray<{ readonly __typename?: 'DotykackaProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }> } };

export type TQWoltProfileVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TQWoltProfile = { readonly __typename?: 'Query', readonly woltProfile: { readonly __typename?: 'WoltProfile', readonly onboardingErrorsLocalised: ReadonlyArray<string>, readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly onboardingState: { readonly __typename?: 'WoltProfileOnboardingState', readonly id: ID, readonly enum: TWoltProfileOnboardingStateEnum }, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } } };

export type TFKitchenCompletionOrder = { readonly __typename?: 'Order', readonly note: string | null, readonly orderStateCategory: TOrderStateCategoryEnum, readonly id: ID, readonly createdAt: Date, readonly acceptedAt: Date | null, readonly isPriority: boolean, readonly isExpressDelivery: boolean, readonly isPaidWithCard: boolean, readonly deliverAt: Date | null, readonly delayedDeliveryTime: Date | null, readonly deliveredAt: Date | null, readonly driverWillPickupAt: Date | null, readonly shouldVerifyAge: boolean, readonly orderNumber: number | null, readonly canBeCanceled: boolean, readonly cancelRequested: boolean, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly allowedCategories: ReadonlyArray<TOrderStateCategoryEnum>, readonly id: ID, readonly name: string, readonly defaultDeliveryTimeEnabled: boolean, readonly defaultPickupTimeEnabled: boolean, readonly usualDeliveryTime: number, readonly usualPickupTime: number }, readonly cashRegister: { readonly __typename?: 'CashBox', readonly id: ID, readonly name: string, readonly virtual: boolean, readonly kiosk: boolean } | null, readonly orderOrigin: { readonly __typename?: 'OrderOrigin', readonly enum: TOrderOriginEnum, readonly label: string }, readonly sector: { readonly __typename?: 'Sector', readonly name: string } | null, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly customer: { readonly __typename?: 'JsonCustomer', readonly firstName: string | null, readonly lastName: string | null, readonly defaultEmail: { readonly __typename?: 'Email', readonly email: string, readonly description: string | null, readonly default: boolean } | null, readonly defaultPhone: { readonly __typename?: 'Phone', readonly phone: string, readonly description: string | null, readonly default: boolean } | null }, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly note: string | null, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly name: string, readonly category: { readonly __typename?: 'WareCategory', readonly id: ID, readonly nameLabel: string } | null }, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly note: string | null, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly name: string }, readonly state: { readonly __typename?: 'OrderRecipeState', readonly enum: TOrderRecipeStateEnum } }>, readonly state: { readonly __typename?: 'OrderRecipeState', readonly enum: TOrderRecipeStateEnum } }>, readonly onlinePaymentState: { readonly __typename?: 'OrderOnlineState', readonly enum: TOrderOnlineStateEnum } | null, readonly foodoraRecord: { readonly __typename?: 'FoodoraRecordGlType', readonly isDeliveredByFoodora: boolean, readonly minFoodoraPickupTime: Date | null, readonly maxFoodoraPickupTime: Date | null } | null, readonly warePriceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly address: { readonly __typename?: 'JsonAddress', readonly original: string | null, readonly state: string | null, readonly city: string | null, readonly venue: string | null, readonly street: string | null, readonly houseNumber: string | null, readonly country: string | null }, readonly orderPayments: ReadonlyArray<{ readonly __typename?: 'OrderPaymentMethod', readonly id: ID, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly paymentMethod: { readonly __typename?: 'PaymentMethod', readonly id: ID, readonly description: string, readonly paymentType: { readonly __typename?: 'PaymentType', readonly id: ID, readonly enum: TPaymentTypeEnum } } }> };

export type TFKitchenOrder = { readonly __typename?: 'Order', readonly note: string | null, readonly orderStateCategory: TOrderStateCategoryEnum, readonly id: ID, readonly createdAt: Date, readonly acceptedAt: Date | null, readonly isPriority: boolean, readonly isExpressDelivery: boolean, readonly orderGroupIndex: number | null, readonly deliverAt: Date | null, readonly deliveredAt: Date | null, readonly driverWillPickupAt: Date | null, readonly delayedDeliveryTime: Date | null, readonly orderNumber: number | null, readonly cancelRequested: boolean, readonly orderOrigin: { readonly __typename?: 'OrderOrigin', readonly enum: TOrderOriginEnum, readonly label: string }, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string }, readonly customer: { readonly __typename?: 'JsonCustomer', readonly firstName: string | null, readonly lastName: string | null, readonly defaultEmail: { readonly __typename?: 'Email', readonly email: string, readonly description: string | null, readonly default: boolean } | null, readonly defaultPhone: { readonly __typename?: 'Phone', readonly phone: string, readonly description: string | null, readonly default: boolean } | null }, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly note: string | null, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly name: string, readonly category: { readonly __typename?: 'WareCategory', readonly id: ID, readonly nameLabel: string } | null }, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly note: string | null, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly name: string }, readonly state: { readonly __typename?: 'OrderRecipeState', readonly enum: TOrderRecipeStateEnum } }>, readonly state: { readonly __typename?: 'OrderRecipeState', readonly enum: TOrderRecipeStateEnum } }>, readonly orderGroup: { readonly __typename?: 'OrderGroup', readonly id: ID, readonly name: string | null, readonly color: { readonly __typename?: 'OrderGroupColor', readonly id: ID, readonly color: string } | null } | null, readonly warePriceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly sector: { readonly __typename?: 'Sector', readonly name: string } | null, readonly address: { readonly __typename?: 'JsonAddress', readonly original: string | null, readonly state: string | null, readonly city: string | null, readonly venue: string | null, readonly street: string | null, readonly houseNumber: string | null, readonly country: string | null } };

export type TFKitchenOrderBase = { readonly __typename?: 'Order', readonly id: ID, readonly createdAt: Date, readonly acceptedAt: Date | null, readonly isPriority: boolean, readonly isExpressDelivery: boolean, readonly deliverAt: Date | null, readonly deliveredAt: Date | null, readonly driverWillPickupAt: Date | null, readonly delayedDeliveryTime: Date | null, readonly cancelRequested: boolean, readonly orderOrigin: { readonly __typename?: 'OrderOrigin', readonly enum: TOrderOriginEnum, readonly label: string }, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string }, readonly customer: { readonly __typename?: 'JsonCustomer', readonly firstName: string | null, readonly lastName: string | null, readonly defaultEmail: { readonly __typename?: 'Email', readonly email: string, readonly description: string | null, readonly default: boolean } | null, readonly defaultPhone: { readonly __typename?: 'Phone', readonly phone: string, readonly description: string | null, readonly default: boolean } | null }, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly note: string | null, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly name: string, readonly category: { readonly __typename?: 'WareCategory', readonly id: ID, readonly nameLabel: string } | null }, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly note: string | null, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly name: string }, readonly state: { readonly __typename?: 'OrderRecipeState', readonly enum: TOrderRecipeStateEnum } }>, readonly state: { readonly __typename?: 'OrderRecipeState', readonly enum: TOrderRecipeStateEnum } }>, readonly warePriceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly sector: { readonly __typename?: 'Sector', readonly name: string } | null, readonly address: { readonly __typename?: 'JsonAddress', readonly original: string | null, readonly state: string | null, readonly city: string | null, readonly venue: string | null, readonly street: string | null, readonly houseNumber: string | null, readonly country: string | null } };

export type TFKitchenOrderRecipe = { readonly __typename?: 'OrderRecipe', readonly id: ID, readonly note: string | null, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly name: string }, readonly state: { readonly __typename?: 'OrderRecipeState', readonly enum: TOrderRecipeStateEnum } };

export type TFKitchenOrderState = { readonly __typename?: 'OrderRecipe', readonly id: ID, readonly state: { readonly __typename?: 'OrderRecipeState', readonly enum: TOrderRecipeStateEnum } };

export type TFKitchenOrderStates = { readonly __typename?: 'Order', readonly orderStates: ReadonlyArray<{ readonly __typename?: 'OrderStateCategoryRelation', readonly createdAt: Date, readonly orderStateCategory: TOrderStateCategoryEnum }> };

export type TFKitchenOrderWorkplaces = { readonly __typename?: 'Order', readonly id: ID, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly workplaces: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: ID }> }, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly workplaces: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: ID }> } }> }> };

export type TFKitchenRecipe = { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly name: string };

export type TFKitchenRecipeWorkplaces = { readonly __typename?: 'Recipe', readonly id: ID, readonly workplaces: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: ID }> };

export type TFKitchenSectorRecipe = { readonly __typename?: 'SectorRecipe', readonly id: ID, readonly note: string | null, readonly createdAt: Date, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly name: string, readonly category: { readonly __typename?: 'WareCategory', readonly id: ID, readonly nameLabel: string } | null }, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'SectorRecipe', readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly name: string } }>, readonly sector: { readonly __typename?: 'Sector', readonly id: ID }, readonly state: { readonly __typename?: 'OrderRecipeState', readonly enum: TOrderRecipeStateEnum } };

export type TFKitchenSectorState = { readonly __typename?: 'SectorRecipe', readonly id: ID, readonly state: { readonly __typename?: 'OrderRecipeState', readonly enum: TOrderRecipeStateEnum } };

export type TFKitchenSectorRecipeWorkplaces = { readonly __typename?: 'SectorRecipe', readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly workplaces: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: ID }> }, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'SectorRecipe', readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly workplaces: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: ID }> } }> };

export type TMKitchenOrderHandleVariables = Exact<{
  orderId: Scalars['ID'];
  state: TOrderStateEnum;
}>;


export type TMKitchenOrderHandle = { readonly __typename?: 'Mutation', readonly addOrderState: { readonly __typename?: 'Order', readonly id: ID, readonly orderStateCategory: TOrderStateCategoryEnum } };

export type TMKitchenOrderRecipeHandleVariables = Exact<{
  orderRecipeId: Scalars['ID'];
  state: TOrderRecipeStateEnum;
}>;


export type TMKitchenOrderRecipeHandle = { readonly __typename?: 'Mutation', readonly orderRecipe: { readonly __typename?: 'OrderRecipe', readonly id: ID, readonly state: { readonly __typename?: 'OrderRecipeState', readonly enum: TOrderRecipeStateEnum } } };

export type TMKitchenSectorHandleVariables = Exact<{
  sectorId: Scalars['ID'];
  state: TOrderRecipeStateEnum;
}>;


export type TMKitchenSectorHandle = { readonly __typename?: 'Mutation', readonly sectorRecipe: ReadonlyArray<{ readonly __typename?: 'SectorRecipe', readonly id: ID, readonly state: { readonly __typename?: 'OrderRecipeState', readonly enum: TOrderRecipeStateEnum } }> };

export type TMKitchenSectorRecipeHandleVariables = Exact<{
  sectorRecipeId: Scalars['ID'];
  state: TOrderRecipeStateEnum;
}>;


export type TMKitchenSectorRecipeHandle = { readonly __typename?: 'Mutation', readonly sectorRecipe: { readonly __typename?: 'SectorRecipe', readonly id: ID, readonly state: { readonly __typename?: 'OrderRecipeState', readonly enum: TOrderRecipeStateEnum } } };

export type TQKitchenCompletionOrderListVariables = Exact<{
  branches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  categories?: InputMaybe<ReadonlyArray<TOrderStateCategoryEnum>>;
  sectors?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  workplaces?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  showOtherWorkplaces: Scalars['Boolean'];
  acceptedAfter?: InputMaybe<Scalars['DateTime']>;
}>;


export type TQKitchenCompletionOrderList = { readonly __typename?: 'Query', readonly orders: ReadonlyArray<{ readonly __typename?: 'Order', readonly note: string | null, readonly orderStateCategory: TOrderStateCategoryEnum, readonly id: ID, readonly createdAt: Date, readonly acceptedAt: Date | null, readonly isPriority: boolean, readonly isExpressDelivery: boolean, readonly isPaidWithCard: boolean, readonly deliverAt: Date | null, readonly delayedDeliveryTime: Date | null, readonly deliveredAt: Date | null, readonly driverWillPickupAt: Date | null, readonly shouldVerifyAge: boolean, readonly orderNumber: number | null, readonly canBeCanceled: boolean, readonly cancelRequested: boolean, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly allowedCategories: ReadonlyArray<TOrderStateCategoryEnum>, readonly id: ID, readonly name: string, readonly defaultDeliveryTimeEnabled: boolean, readonly defaultPickupTimeEnabled: boolean, readonly usualDeliveryTime: number, readonly usualPickupTime: number }, readonly cashRegister: { readonly __typename?: 'CashBox', readonly id: ID, readonly name: string, readonly virtual: boolean, readonly kiosk: boolean } | null, readonly orderOrigin: { readonly __typename?: 'OrderOrigin', readonly enum: TOrderOriginEnum, readonly label: string }, readonly sector: { readonly __typename?: 'Sector', readonly name: string } | null, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly note: string | null, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly name: string, readonly category: { readonly __typename?: 'WareCategory', readonly id: ID, readonly nameLabel: string } | null, readonly workplaces: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: ID }> }, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly note: string | null, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly name: string, readonly workplaces: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: ID }> }, readonly state: { readonly __typename?: 'OrderRecipeState', readonly enum: TOrderRecipeStateEnum } }>, readonly state: { readonly __typename?: 'OrderRecipeState', readonly enum: TOrderRecipeStateEnum } }>, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly customer: { readonly __typename?: 'JsonCustomer', readonly firstName: string | null, readonly lastName: string | null, readonly defaultEmail: { readonly __typename?: 'Email', readonly email: string, readonly description: string | null, readonly default: boolean } | null, readonly defaultPhone: { readonly __typename?: 'Phone', readonly phone: string, readonly description: string | null, readonly default: boolean } | null }, readonly onlinePaymentState: { readonly __typename?: 'OrderOnlineState', readonly enum: TOrderOnlineStateEnum } | null, readonly foodoraRecord: { readonly __typename?: 'FoodoraRecordGlType', readonly isDeliveredByFoodora: boolean, readonly minFoodoraPickupTime: Date | null, readonly maxFoodoraPickupTime: Date | null } | null, readonly warePriceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly address: { readonly __typename?: 'JsonAddress', readonly original: string | null, readonly state: string | null, readonly city: string | null, readonly venue: string | null, readonly street: string | null, readonly houseNumber: string | null, readonly country: string | null }, readonly orderPayments: ReadonlyArray<{ readonly __typename?: 'OrderPaymentMethod', readonly id: ID, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly paymentMethod: { readonly __typename?: 'PaymentMethod', readonly id: ID, readonly description: string, readonly paymentType: { readonly __typename?: 'PaymentType', readonly id: ID, readonly enum: TPaymentTypeEnum } } }> }> };

export type TQKitchenOrderListVariables = Exact<{
  sectors?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  branches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  workplaces?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  showOtherWorkplaces: Scalars['Boolean'];
  shouldLoadOrderStates: Scalars['Boolean'];
  categories?: InputMaybe<ReadonlyArray<TOrderStateCategoryEnum>>;
  acceptedAfter?: InputMaybe<Scalars['DateTime']>;
}>;


export type TQKitchenOrderList = { readonly __typename?: 'Query', readonly orders: ReadonlyArray<{ readonly __typename?: 'Order', readonly note: string | null, readonly orderStateCategory: TOrderStateCategoryEnum, readonly id: ID, readonly createdAt: Date, readonly acceptedAt: Date | null, readonly isPriority: boolean, readonly isExpressDelivery: boolean, readonly orderGroupIndex: number | null, readonly deliverAt: Date | null, readonly deliveredAt: Date | null, readonly driverWillPickupAt: Date | null, readonly delayedDeliveryTime: Date | null, readonly orderNumber: number | null, readonly cancelRequested: boolean, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly note: string | null, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly name: string, readonly category: { readonly __typename?: 'WareCategory', readonly id: ID, readonly nameLabel: string } | null, readonly workplaces: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: ID }> }, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly note: string | null, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly name: string, readonly workplaces: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: ID }> }, readonly state: { readonly __typename?: 'OrderRecipeState', readonly enum: TOrderRecipeStateEnum } }>, readonly state: { readonly __typename?: 'OrderRecipeState', readonly enum: TOrderRecipeStateEnum } }>, readonly orderStates: ReadonlyArray<{ readonly __typename?: 'OrderStateCategoryRelation', readonly createdAt: Date, readonly orderStateCategory: TOrderStateCategoryEnum }>, readonly orderOrigin: { readonly __typename?: 'OrderOrigin', readonly enum: TOrderOriginEnum, readonly label: string }, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string }, readonly customer: { readonly __typename?: 'JsonCustomer', readonly firstName: string | null, readonly lastName: string | null, readonly defaultEmail: { readonly __typename?: 'Email', readonly email: string, readonly description: string | null, readonly default: boolean } | null, readonly defaultPhone: { readonly __typename?: 'Phone', readonly phone: string, readonly description: string | null, readonly default: boolean } | null }, readonly orderGroup: { readonly __typename?: 'OrderGroup', readonly id: ID, readonly name: string | null, readonly color: { readonly __typename?: 'OrderGroupColor', readonly id: ID, readonly color: string } | null } | null, readonly warePriceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly sector: { readonly __typename?: 'Sector', readonly name: string } | null, readonly address: { readonly __typename?: 'JsonAddress', readonly original: string | null, readonly state: string | null, readonly city: string | null, readonly venue: string | null, readonly street: string | null, readonly houseNumber: string | null, readonly country: string | null } }> };

export type TQKitchenSectorListVariables = Exact<{
  sectors?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  branches: ReadonlyArray<Scalars['ID']>;
  workplaces?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  showOtherWorkplaces: Scalars['Boolean'];
  states?: InputMaybe<ReadonlyArray<TOrderRecipeStateEnum>>;
}>;


export type TQKitchenSectorList = { readonly __typename?: 'Query', readonly sectors: ReadonlyArray<{ readonly __typename?: 'Sector', readonly id: ID, readonly name: string, readonly warePriceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum } | null, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string } }>, readonly sectorRecipes: ReadonlyArray<{ readonly __typename?: 'SectorRecipe', readonly id: ID, readonly note: string | null, readonly createdAt: Date, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly name: string, readonly category: { readonly __typename?: 'WareCategory', readonly id: ID, readonly nameLabel: string } | null, readonly workplaces: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: ID }> }, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'SectorRecipe', readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly name: string, readonly workplaces: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: ID }> } }>, readonly sector: { readonly __typename?: 'Sector', readonly id: ID }, readonly state: { readonly __typename?: 'OrderRecipeState', readonly enum: TOrderRecipeStateEnum } }> };

export type TSKitchenCompletionOrderListVariables = Exact<{
  branches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  categories?: InputMaybe<ReadonlyArray<TOrderStateCategoryEnum>>;
  sectors?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  workplaces?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  showOtherWorkplaces: Scalars['Boolean'];
}>;


export type TSKitchenCompletionOrderList = { readonly __typename?: 'Subscription', readonly updatedOrder: { readonly __typename?: 'OrderUpdateSubscription', readonly order: { readonly __typename?: 'Order', readonly note: string | null, readonly orderStateCategory: TOrderStateCategoryEnum, readonly id: ID, readonly createdAt: Date, readonly acceptedAt: Date | null, readonly isPriority: boolean, readonly isExpressDelivery: boolean, readonly isPaidWithCard: boolean, readonly deliverAt: Date | null, readonly delayedDeliveryTime: Date | null, readonly deliveredAt: Date | null, readonly driverWillPickupAt: Date | null, readonly shouldVerifyAge: boolean, readonly orderNumber: number | null, readonly canBeCanceled: boolean, readonly cancelRequested: boolean, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly allowedCategories: ReadonlyArray<TOrderStateCategoryEnum>, readonly id: ID, readonly name: string, readonly defaultDeliveryTimeEnabled: boolean, readonly defaultPickupTimeEnabled: boolean, readonly usualDeliveryTime: number, readonly usualPickupTime: number }, readonly cashRegister: { readonly __typename?: 'CashBox', readonly id: ID, readonly name: string, readonly virtual: boolean, readonly kiosk: boolean } | null, readonly orderOrigin: { readonly __typename?: 'OrderOrigin', readonly enum: TOrderOriginEnum, readonly label: string }, readonly sector: { readonly __typename?: 'Sector', readonly name: string } | null, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly note: string | null, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly name: string, readonly category: { readonly __typename?: 'WareCategory', readonly id: ID, readonly nameLabel: string } | null, readonly workplaces: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: ID }> }, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly note: string | null, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly name: string, readonly workplaces: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: ID }> }, readonly state: { readonly __typename?: 'OrderRecipeState', readonly enum: TOrderRecipeStateEnum } }>, readonly state: { readonly __typename?: 'OrderRecipeState', readonly enum: TOrderRecipeStateEnum } }>, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly customer: { readonly __typename?: 'JsonCustomer', readonly firstName: string | null, readonly lastName: string | null, readonly defaultEmail: { readonly __typename?: 'Email', readonly email: string, readonly description: string | null, readonly default: boolean } | null, readonly defaultPhone: { readonly __typename?: 'Phone', readonly phone: string, readonly description: string | null, readonly default: boolean } | null }, readonly onlinePaymentState: { readonly __typename?: 'OrderOnlineState', readonly enum: TOrderOnlineStateEnum } | null, readonly foodoraRecord: { readonly __typename?: 'FoodoraRecordGlType', readonly isDeliveredByFoodora: boolean, readonly minFoodoraPickupTime: Date | null, readonly maxFoodoraPickupTime: Date | null } | null, readonly warePriceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly address: { readonly __typename?: 'JsonAddress', readonly original: string | null, readonly state: string | null, readonly city: string | null, readonly venue: string | null, readonly street: string | null, readonly houseNumber: string | null, readonly country: string | null }, readonly orderPayments: ReadonlyArray<{ readonly __typename?: 'OrderPaymentMethod', readonly id: ID, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly paymentMethod: { readonly __typename?: 'PaymentMethod', readonly id: ID, readonly description: string, readonly paymentType: { readonly __typename?: 'PaymentType', readonly id: ID, readonly enum: TPaymentTypeEnum } } }> } | null } };

export type TSKitchenOrderListVariables = Exact<{
  sectors?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  branches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  workplaces?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  showOtherWorkplaces: Scalars['Boolean'];
  shouldLoadOrderStates: Scalars['Boolean'];
  categories?: InputMaybe<ReadonlyArray<TOrderStateCategoryEnum>>;
}>;


export type TSKitchenOrderList = { readonly __typename?: 'Subscription', readonly updatedOrder: { readonly __typename?: 'OrderUpdateSubscription', readonly order: { readonly __typename?: 'Order', readonly note: string | null, readonly orderStateCategory: TOrderStateCategoryEnum, readonly id: ID, readonly createdAt: Date, readonly acceptedAt: Date | null, readonly isPriority: boolean, readonly isExpressDelivery: boolean, readonly orderGroupIndex: number | null, readonly deliverAt: Date | null, readonly deliveredAt: Date | null, readonly driverWillPickupAt: Date | null, readonly delayedDeliveryTime: Date | null, readonly orderNumber: number | null, readonly cancelRequested: boolean, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly note: string | null, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly name: string, readonly category: { readonly __typename?: 'WareCategory', readonly id: ID, readonly nameLabel: string } | null, readonly workplaces: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: ID }> }, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly note: string | null, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly name: string, readonly workplaces: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: ID }> }, readonly state: { readonly __typename?: 'OrderRecipeState', readonly enum: TOrderRecipeStateEnum } }>, readonly state: { readonly __typename?: 'OrderRecipeState', readonly enum: TOrderRecipeStateEnum } }>, readonly orderStates: ReadonlyArray<{ readonly __typename?: 'OrderStateCategoryRelation', readonly createdAt: Date, readonly orderStateCategory: TOrderStateCategoryEnum }>, readonly orderOrigin: { readonly __typename?: 'OrderOrigin', readonly enum: TOrderOriginEnum, readonly label: string }, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string }, readonly customer: { readonly __typename?: 'JsonCustomer', readonly firstName: string | null, readonly lastName: string | null, readonly defaultEmail: { readonly __typename?: 'Email', readonly email: string, readonly description: string | null, readonly default: boolean } | null, readonly defaultPhone: { readonly __typename?: 'Phone', readonly phone: string, readonly description: string | null, readonly default: boolean } | null }, readonly orderGroup: { readonly __typename?: 'OrderGroup', readonly id: ID, readonly name: string | null, readonly color: { readonly __typename?: 'OrderGroupColor', readonly id: ID, readonly color: string } | null } | null, readonly warePriceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly sector: { readonly __typename?: 'Sector', readonly name: string } | null, readonly address: { readonly __typename?: 'JsonAddress', readonly original: string | null, readonly state: string | null, readonly city: string | null, readonly venue: string | null, readonly street: string | null, readonly houseNumber: string | null, readonly country: string | null } } | null } };

export type TSKitchenSectorListVariables = Exact<{
  sectors?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  branches: ReadonlyArray<Scalars['ID']>;
  workplaces?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  showOtherWorkplaces: Scalars['Boolean'];
  states?: InputMaybe<ReadonlyArray<TOrderRecipeStateEnum>>;
}>;


export type TSKitchenSectorList = { readonly __typename?: 'Subscription', readonly updatedSectorRecipe: { readonly __typename?: 'SectorRecipeUpdateSubscription', readonly id: ID, readonly sectorRecipe: { readonly __typename?: 'SectorRecipe', readonly id: ID, readonly note: string | null, readonly createdAt: Date, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly name: string, readonly category: { readonly __typename?: 'WareCategory', readonly id: ID, readonly nameLabel: string } | null, readonly workplaces: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: ID }> }, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'SectorRecipe', readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly name: string, readonly workplaces: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: ID }> } }>, readonly sector: { readonly __typename?: 'Sector', readonly id: ID }, readonly state: { readonly __typename?: 'OrderRecipeState', readonly enum: TOrderRecipeStateEnum } } | null } };

export type TQDeliveryTypesVariables = Exact<{ [key: string]: never; }>;


export type TQDeliveryTypes = { readonly __typename?: 'Query', readonly deliveryTypes: ReadonlyArray<{ readonly __typename?: 'DeliveryType', readonly id: ID, readonly code: string, readonly enum: TDeliveryTypeEnum }> };

export type TMPasswordChangeVariables = Exact<{
  password: Scalars['String'];
}>;


export type TMPasswordChange = { readonly __typename?: 'Mutation', readonly change: { readonly __typename?: 'UserUpdatedPassword', readonly userId: ID, readonly newToken: string } };

export type TQUserBootstrapVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type TQUserBootstrap = { readonly __typename?: 'Query', readonly user: { readonly __typename?: 'User', readonly id: ID, readonly firstName: string | null, readonly lastName: string | null, readonly maskedEmail: string | null, readonly phone: string, readonly language: { readonly __typename?: 'Language', readonly rawCode: string }, readonly roles: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: ID, readonly enum: TRoleEnum, readonly name: string }>, readonly branches: ReadonlyArray<{ readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string, readonly url: string, readonly urlPath: string, readonly defaultLanguage: TLanguageEnum, readonly supportedLanguages: ReadonlyArray<TLanguageEnum>, readonly promoHeaderText: string | null, readonly pohodaEnabled: boolean, readonly userAccountsEnabledForCustomer: boolean, readonly address: { readonly __typename?: 'Address', readonly country: { readonly __typename?: 'Country', readonly phonePrefix: string } | null }, readonly gps: { readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number }, readonly brand: { readonly __typename?: 'Company', readonly id: ID, readonly name: string, readonly defaultLanguage: TLanguageEnum, readonly supportedLanguages: ReadonlyArray<TLanguageEnum>, readonly promoHeaderText: string | null, readonly wareCategorySharingAllowed: boolean, readonly publicBranches: ReadonlyArray<{ readonly __typename?: 'CompanyBranch', readonly id: ID }> } }> }, readonly permissions: { readonly __typename?: 'UserPermission', readonly canCancelOrders: boolean, readonly canCreateOrder: boolean }, readonly access: { readonly __typename?: '__Schema', readonly queries: { readonly __typename?: '__Type', readonly fields: ReadonlyArray<{ readonly __typename?: '__Field', readonly name: string }> | null }, readonly mutations: { readonly __typename?: '__Type', readonly fields: ReadonlyArray<{ readonly __typename?: '__Field', readonly name: string }> | null } | null, readonly subscriptions: { readonly __typename?: '__Type', readonly fields: ReadonlyArray<{ readonly __typename?: '__Field', readonly name: string }> | null } | null } };

export type TFMenuAllergen = { readonly __typename?: 'Allergen', readonly id: ID, readonly code: string, readonly enum: TAllergenEnum, readonly category: number };

export type TFMenuProductTagRelation = { readonly __typename?: 'RecipeTagRelation', readonly id: ID, readonly inherited: boolean, readonly productTag: { readonly __typename?: 'RecipeTag', readonly id: ID, readonly label: string | null, readonly originTag: { readonly __typename?: 'RecipeTag', readonly id: ID } | null } };

export type TFMenuWareUnit = { readonly __typename?: 'WareUnit', readonly id: ID, readonly enum: TWareUnitEnum, readonly code: string };

export type TMBulkUpdateRecipePricesVariables = Exact<{
  recipeIds: ReadonlyArray<Scalars['ID']>;
  difference: Scalars['Float'];
  warePriceType: TWarePriceTypeEnum;
  currency: TCurrencyEnum;
}>;


export type TMBulkUpdateRecipePrices = { readonly __typename?: 'Mutation', readonly batchUpdateRecipePrices: ReadonlyArray<{ readonly __typename?: 'RecipePrice', readonly id: ID, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string } }> };

export type TQMenuAllergensVariables = Exact<{ [key: string]: never; }>;


export type TQMenuAllergens = { readonly __typename?: 'Query', readonly allergens: ReadonlyArray<{ readonly __typename?: 'Allergen', readonly id: ID, readonly code: string, readonly enum: TAllergenEnum, readonly category: number }> };

export type TQMenuCurrenciesVariables = Exact<{
  branchId: Scalars['ID'];
}>;


export type TQMenuCurrencies = { readonly __typename?: 'Query', readonly currencies: ReadonlyArray<{ readonly __typename?: 'Currency', readonly enum: TCurrencyEnum, readonly code: string }>, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly address: { readonly __typename?: 'Address', readonly country: { readonly __typename?: 'Country', readonly currency: { readonly __typename?: 'Currency', readonly enum: TCurrencyEnum } } | null } } };

export type TQMenuGuideDownloadVariables = Exact<{
  branchId: Scalars['ID'];
}>;


export type TQMenuGuideDownload = { readonly __typename?: 'Query', readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly foodMenuUrl: string | null } };

export type TQMenuVatsVariables = Exact<{
  branchId: Scalars['ID'];
}>;


export type TQMenuVats = { readonly __typename?: 'Query', readonly vats: ReadonlyArray<{ readonly __typename?: 'Vat', readonly id: ID, readonly vat: number }> };

export type TQMenuWareUnitsVariables = Exact<{ [key: string]: never; }>;


export type TQMenuWareUnits = { readonly __typename?: 'Query', readonly wareUnits: ReadonlyArray<{ readonly __typename?: 'WareUnit', readonly id: ID, readonly code: string, readonly enum: TWareUnitEnum }> };

export type TFMenuCategory = { readonly __typename?: 'WareCategory', readonly id: ID, readonly visible: boolean, readonly origins: ReadonlyArray<TOrderOriginCategoryEnum>, readonly categoryType: { readonly __typename?: 'WareCategoryType', readonly enum: TWareCategoryTypeEnum }, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string }, readonly sharedCompanyBranches: ReadonlyArray<{ readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string, readonly woltProfiles: ReadonlyArray<{ readonly __typename?: 'WoltProfile', readonly onboardingErrorsLocalised: ReadonlyArray<string>, readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly onboardingState: { readonly __typename?: 'WoltProfileOnboardingState', readonly id: ID, readonly enum: TWoltProfileOnboardingStateEnum }, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly foodoraProfiles: ReadonlyArray<{ readonly __typename?: 'FoodoraProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly boltProfiles: ReadonlyArray<{ readonly __typename?: 'BoltProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly jidloPodNosProfiles: ReadonlyArray<{ readonly __typename?: 'JidloPodNosProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }> }> };

export type TFMenuCategoryInForm = { readonly __typename?: 'WareCategory', readonly image: string | null, readonly pictogram: string | null, readonly dependentRules: ReadonlyArray<string>, readonly minCount: number, readonly maxCount: number, readonly automaticFinish: boolean, readonly id: ID, readonly visible: boolean, readonly origins: ReadonlyArray<TOrderOriginCategoryEnum>, readonly integrationsProfiles: ReadonlyArray<{ readonly __typename?: 'BoltProfile', readonly id: ID, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } } | { readonly __typename?: 'FoodoraProfile', readonly id: ID, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } } | { readonly __typename?: 'JidloPodNosProfile', readonly id: ID, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } } | { readonly __typename?: 'WoltProfile', readonly id: ID, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly recipes: ReadonlyArray<{ readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly internalNote: string | null, readonly isCombinationMeal: boolean, readonly isDynamicPricingEnabled: boolean, readonly nameLabel: string | null, readonly prices: ReadonlyArray<{ readonly __typename?: 'RecipePrice', readonly priceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } } }> }>, readonly color: { readonly __typename?: 'WareCategoryColor', readonly id: ID } | null, readonly promoTags: ReadonlyArray<{ readonly __typename?: 'PromoTag', readonly id: ID, readonly code: string, readonly enum: TPromoTagEnum }>, readonly productTagRelations: ReadonlyArray<{ readonly __typename?: 'RecipeTagRelation', readonly id: ID, readonly inherited: boolean, readonly productTag: { readonly __typename?: 'RecipeTag', readonly id: ID, readonly label: string | null, readonly originTag: { readonly __typename?: 'RecipeTag', readonly id: ID } | null } }> | null, readonly categoryType: { readonly __typename?: 'WareCategoryType', readonly enum: TWareCategoryTypeEnum }, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string }, readonly sharedCompanyBranches: ReadonlyArray<{ readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string, readonly woltProfiles: ReadonlyArray<{ readonly __typename?: 'WoltProfile', readonly onboardingErrorsLocalised: ReadonlyArray<string>, readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly onboardingState: { readonly __typename?: 'WoltProfileOnboardingState', readonly id: ID, readonly enum: TWoltProfileOnboardingStateEnum }, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly foodoraProfiles: ReadonlyArray<{ readonly __typename?: 'FoodoraProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly boltProfiles: ReadonlyArray<{ readonly __typename?: 'BoltProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly jidloPodNosProfiles: ReadonlyArray<{ readonly __typename?: 'JidloPodNosProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }> }>, readonly translations: ReadonlyArray<{ readonly __typename?: 'WareCategoryTranslation', readonly descriptionLabel: string | null, readonly internalNoteLabel: string | null, readonly nameLabel: string | null, readonly language: { readonly __typename?: 'Language', readonly enum: TLanguageEnum } }> };

export type TFMenuCategoryInList = { readonly __typename?: 'WareCategory', readonly nameLabel: string, readonly countRecipes: number, readonly enabledByOwner: boolean, readonly internalNoteLabel: string | null, readonly id: ID, readonly visible: boolean, readonly origins: ReadonlyArray<TOrderOriginCategoryEnum>, readonly color: { readonly __typename?: 'WareCategoryColor', readonly id: ID, readonly color: string } | null, readonly categoryType: { readonly __typename?: 'WareCategoryType', readonly enum: TWareCategoryTypeEnum }, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string }, readonly sharedCompanyBranches: ReadonlyArray<{ readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string, readonly woltProfiles: ReadonlyArray<{ readonly __typename?: 'WoltProfile', readonly onboardingErrorsLocalised: ReadonlyArray<string>, readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly onboardingState: { readonly __typename?: 'WoltProfileOnboardingState', readonly id: ID, readonly enum: TWoltProfileOnboardingStateEnum }, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly foodoraProfiles: ReadonlyArray<{ readonly __typename?: 'FoodoraProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly boltProfiles: ReadonlyArray<{ readonly __typename?: 'BoltProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly jidloPodNosProfiles: ReadonlyArray<{ readonly __typename?: 'JidloPodNosProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }> }> };

export type TFMenuCategoryLocalized = { readonly __typename?: 'WareCategory', readonly id: ID, readonly translations: ReadonlyArray<{ readonly __typename?: 'WareCategoryTranslation', readonly descriptionLabel: string | null, readonly internalNoteLabel: string | null, readonly nameLabel: string | null, readonly language: { readonly __typename?: 'Language', readonly enum: TLanguageEnum } }> };

export type TMMenuCategoryCreateVariables = Exact<{
  category: TInputWareCategoryCreate;
}>;


export type TMMenuCategoryCreate = { readonly __typename?: 'Mutation', readonly createCategory: { readonly __typename?: 'WareCategory', readonly id: ID } };

export type TMMenuCategoryDeleteVariables = Exact<{
  categoryId: Scalars['ID'];
}>;


export type TMMenuCategoryDelete = { readonly __typename?: 'Mutation', readonly deleteCategory: { readonly __typename?: 'WareCategory', readonly id: ID } };

export type TMMenuCategorySortVariables = Exact<{
  categoryId: Scalars['ID'];
  offset: Scalars['Int'];
  branchId: Scalars['ID'];
}>;


export type TMMenuCategorySort = { readonly __typename?: 'Mutation', readonly success: boolean };

export type TMMenuCategoryUpdateVariables = Exact<{
  categoryId: Scalars['ID'];
  category: TInputWareCategoryUpdate;
}>;


export type TMMenuCategoryUpdate = { readonly __typename?: 'Mutation', readonly updateCategory: { readonly __typename?: 'WareCategory', readonly id: ID, readonly visible: boolean, readonly origins: ReadonlyArray<TOrderOriginCategoryEnum>, readonly categoryType: { readonly __typename?: 'WareCategoryType', readonly enum: TWareCategoryTypeEnum }, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string }, readonly sharedCompanyBranches: ReadonlyArray<{ readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string, readonly woltProfiles: ReadonlyArray<{ readonly __typename?: 'WoltProfile', readonly onboardingErrorsLocalised: ReadonlyArray<string>, readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly onboardingState: { readonly __typename?: 'WoltProfileOnboardingState', readonly id: ID, readonly enum: TWoltProfileOnboardingStateEnum }, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly foodoraProfiles: ReadonlyArray<{ readonly __typename?: 'FoodoraProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly boltProfiles: ReadonlyArray<{ readonly __typename?: 'BoltProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly jidloPodNosProfiles: ReadonlyArray<{ readonly __typename?: 'JidloPodNosProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }> }> } };

export type TMMenuCategoryVisibilityVariables = Exact<{
  branchId: Scalars['ID'];
  categoryId: Scalars['ID'];
  visible: Scalars['Boolean'];
}>;


export type TMMenuCategoryVisibility = { readonly __typename?: 'Mutation', readonly updateVisibility: { readonly __typename?: 'WareCategory', readonly id: ID, readonly visible: boolean } };

export type TQMenuCategoryColorsVariables = Exact<{ [key: string]: never; }>;


export type TQMenuCategoryColors = { readonly __typename?: 'Query', readonly colors: ReadonlyArray<{ readonly __typename?: 'WareCategoryColor', readonly id: ID, readonly code: string, readonly color: string }> };

export type TQMenuCategoryFilterVariables = Exact<{
  branchId: Scalars['ID'];
}>;


export type TQMenuCategoryFilter = { readonly __typename?: 'Query', readonly categories: ReadonlyArray<{ readonly __typename?: 'WareCategory', readonly id: ID, readonly nameLabel: string, readonly countRecipes: number, readonly categoryType: { readonly __typename?: 'WareCategoryType', readonly enum: TWareCategoryTypeEnum } }> };

export type TQMenuCategoryFormVariables = Exact<{
  categoryId: Scalars['ID'];
  language: TLanguageEnum;
}>;


export type TQMenuCategoryForm = { readonly __typename?: 'Query', readonly category: { readonly __typename?: 'WareCategory', readonly image: string | null, readonly pictogram: string | null, readonly dependentRules: ReadonlyArray<string>, readonly minCount: number, readonly maxCount: number, readonly automaticFinish: boolean, readonly id: ID, readonly visible: boolean, readonly origins: ReadonlyArray<TOrderOriginCategoryEnum>, readonly integrationsProfiles: ReadonlyArray<{ readonly __typename?: 'BoltProfile', readonly id: ID, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } } | { readonly __typename?: 'FoodoraProfile', readonly id: ID, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } } | { readonly __typename?: 'JidloPodNosProfile', readonly id: ID, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } } | { readonly __typename?: 'WoltProfile', readonly id: ID, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly recipes: ReadonlyArray<{ readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly internalNote: string | null, readonly isCombinationMeal: boolean, readonly isDynamicPricingEnabled: boolean, readonly nameLabel: string | null, readonly prices: ReadonlyArray<{ readonly __typename?: 'RecipePrice', readonly priceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } } }> }>, readonly color: { readonly __typename?: 'WareCategoryColor', readonly id: ID } | null, readonly promoTags: ReadonlyArray<{ readonly __typename?: 'PromoTag', readonly id: ID, readonly code: string, readonly enum: TPromoTagEnum }>, readonly productTagRelations: ReadonlyArray<{ readonly __typename?: 'RecipeTagRelation', readonly id: ID, readonly inherited: boolean, readonly productTag: { readonly __typename?: 'RecipeTag', readonly id: ID, readonly label: string | null, readonly originTag: { readonly __typename?: 'RecipeTag', readonly id: ID } | null } }> | null, readonly categoryType: { readonly __typename?: 'WareCategoryType', readonly enum: TWareCategoryTypeEnum }, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string }, readonly sharedCompanyBranches: ReadonlyArray<{ readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string, readonly woltProfiles: ReadonlyArray<{ readonly __typename?: 'WoltProfile', readonly onboardingErrorsLocalised: ReadonlyArray<string>, readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly onboardingState: { readonly __typename?: 'WoltProfileOnboardingState', readonly id: ID, readonly enum: TWoltProfileOnboardingStateEnum }, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly foodoraProfiles: ReadonlyArray<{ readonly __typename?: 'FoodoraProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly boltProfiles: ReadonlyArray<{ readonly __typename?: 'BoltProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly jidloPodNosProfiles: ReadonlyArray<{ readonly __typename?: 'JidloPodNosProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }> }>, readonly translations: ReadonlyArray<{ readonly __typename?: 'WareCategoryTranslation', readonly descriptionLabel: string | null, readonly internalNoteLabel: string | null, readonly nameLabel: string | null, readonly language: { readonly __typename?: 'Language', readonly enum: TLanguageEnum } }> } };

export type TQMenuCategoryListVariables = Exact<{
  branchId: Scalars['ID'];
  categoryType?: InputMaybe<TWareCategoryTypeEnum>;
}>;


export type TQMenuCategoryList = { readonly __typename?: 'Query', readonly categories: ReadonlyArray<{ readonly __typename?: 'WareCategory', readonly nameLabel: string, readonly countRecipes: number, readonly enabledByOwner: boolean, readonly internalNoteLabel: string | null, readonly id: ID, readonly visible: boolean, readonly origins: ReadonlyArray<TOrderOriginCategoryEnum>, readonly integrationsProfiles: ReadonlyArray<{ readonly __typename?: 'BoltProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } } | { readonly __typename?: 'FoodoraProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } } | { readonly __typename?: 'JidloPodNosProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } } | { readonly __typename?: 'WoltProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly color: { readonly __typename?: 'WareCategoryColor', readonly id: ID, readonly color: string } | null, readonly categoryType: { readonly __typename?: 'WareCategoryType', readonly enum: TWareCategoryTypeEnum }, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string }, readonly sharedCompanyBranches: ReadonlyArray<{ readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string, readonly woltProfiles: ReadonlyArray<{ readonly __typename?: 'WoltProfile', readonly onboardingErrorsLocalised: ReadonlyArray<string>, readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly onboardingState: { readonly __typename?: 'WoltProfileOnboardingState', readonly id: ID, readonly enum: TWoltProfileOnboardingStateEnum }, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly foodoraProfiles: ReadonlyArray<{ readonly __typename?: 'FoodoraProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly boltProfiles: ReadonlyArray<{ readonly __typename?: 'BoltProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly jidloPodNosProfiles: ReadonlyArray<{ readonly __typename?: 'JidloPodNosProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }> }> }> };

export type TQMenuCategoryOriginsVariables = Exact<{ [key: string]: never; }>;


export type TQMenuCategoryOrigins = { readonly __typename?: 'Query', readonly origins: ReadonlyArray<{ readonly __typename?: 'OrderOriginCategory', readonly enum: TOrderOriginCategoryEnum, readonly code: string }> };

export type TQMenuCategoryRecipeListVariables = Exact<{
  branchId: Scalars['ID'];
  categoryId?: InputMaybe<Scalars['ID']>;
  categoryType?: InputMaybe<TWareCategoryTypeEnum>;
}>;


export type TQMenuCategoryRecipeList = { readonly __typename?: 'Query', readonly recipes: ReadonlyArray<{ readonly __typename?: 'Recipe', readonly shared: boolean, readonly nameLabel: string, readonly enabledByOwner: boolean, readonly id: ID, readonly code: string, readonly internalNote: string | null, readonly internalCode: string, readonly soldOut: boolean, readonly ageControl: boolean, readonly isCombinationMeal: boolean, readonly isDynamicPricingEnabled: boolean, readonly visible: boolean, readonly prices: ReadonlyArray<{ readonly __typename?: 'RecipePrice', readonly id: ID, readonly priceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } }, readonly vat: { readonly __typename?: 'Vat', readonly id: ID } }>, readonly recipeColor: { readonly __typename?: 'RecipeColor', readonly id: ID, readonly code: string, readonly color: string } | null, readonly recipeType: { readonly __typename?: 'WareCategoryType', readonly enum: TWareCategoryTypeEnum } }> };

export type TFMenuAssocRecipe = { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string, readonly inHousePrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string }, readonly deliveryPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string } };

export type TFMenuRecipe = { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly internalNote: string | null, readonly internalCode: string, readonly soldOut: boolean, readonly ageControl: boolean, readonly isCombinationMeal: boolean, readonly isDynamicPricingEnabled: boolean, readonly visible: boolean, readonly recipeColor: { readonly __typename?: 'RecipeColor', readonly id: ID, readonly code: string, readonly color: string } | null, readonly recipeType: { readonly __typename?: 'WareCategoryType', readonly enum: TWareCategoryTypeEnum } };

export type TFMenuRecipeInForm = { readonly __typename?: 'Recipe', readonly image: string | null, readonly dependentRules: ReadonlyArray<string>, readonly pictogram: string | null, readonly id: ID, readonly code: string, readonly internalNote: string | null, readonly internalCode: string, readonly soldOut: boolean, readonly ageControl: boolean, readonly isCombinationMeal: boolean, readonly isDynamicPricingEnabled: boolean, readonly visible: boolean, readonly primaryCategory: { readonly __typename?: 'WareCategory', readonly id: ID, readonly pictogram: string | null } | null, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'WareCategory', readonly nameLabel: string, readonly countRecipes: number, readonly enabledByOwner: boolean, readonly internalNoteLabel: string | null, readonly id: ID, readonly visible: boolean, readonly origins: ReadonlyArray<TOrderOriginCategoryEnum>, readonly color: { readonly __typename?: 'WareCategoryColor', readonly id: ID, readonly color: string } | null, readonly categoryType: { readonly __typename?: 'WareCategoryType', readonly enum: TWareCategoryTypeEnum }, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string }, readonly sharedCompanyBranches: ReadonlyArray<{ readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string, readonly woltProfiles: ReadonlyArray<{ readonly __typename?: 'WoltProfile', readonly onboardingErrorsLocalised: ReadonlyArray<string>, readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly onboardingState: { readonly __typename?: 'WoltProfileOnboardingState', readonly id: ID, readonly enum: TWoltProfileOnboardingStateEnum }, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly foodoraProfiles: ReadonlyArray<{ readonly __typename?: 'FoodoraProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly boltProfiles: ReadonlyArray<{ readonly __typename?: 'BoltProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly jidloPodNosProfiles: ReadonlyArray<{ readonly __typename?: 'JidloPodNosProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }> }> }>, readonly categories: ReadonlyArray<{ readonly __typename?: 'WareCategory', readonly nameLabel: string, readonly countRecipes: number, readonly enabledByOwner: boolean, readonly internalNoteLabel: string | null, readonly id: ID, readonly visible: boolean, readonly origins: ReadonlyArray<TOrderOriginCategoryEnum>, readonly color: { readonly __typename?: 'WareCategoryColor', readonly id: ID, readonly color: string } | null, readonly categoryType: { readonly __typename?: 'WareCategoryType', readonly enum: TWareCategoryTypeEnum }, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string }, readonly sharedCompanyBranches: ReadonlyArray<{ readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string, readonly woltProfiles: ReadonlyArray<{ readonly __typename?: 'WoltProfile', readonly onboardingErrorsLocalised: ReadonlyArray<string>, readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly onboardingState: { readonly __typename?: 'WoltProfileOnboardingState', readonly id: ID, readonly enum: TWoltProfileOnboardingStateEnum }, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly foodoraProfiles: ReadonlyArray<{ readonly __typename?: 'FoodoraProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly boltProfiles: ReadonlyArray<{ readonly __typename?: 'BoltProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly jidloPodNosProfiles: ReadonlyArray<{ readonly __typename?: 'JidloPodNosProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }> }> }>, readonly workplaces: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: ID }>, readonly productTagRelations: ReadonlyArray<{ readonly __typename?: 'RecipeTagRelation', readonly id: ID, readonly inherited: boolean, readonly productTag: { readonly __typename?: 'RecipeTag', readonly id: ID, readonly label: string | null, readonly originTag: { readonly __typename?: 'RecipeTag', readonly id: ID } | null } }> | null, readonly recipeColor: { readonly __typename?: 'RecipeColor', readonly id: ID, readonly code: string, readonly color: string } | null, readonly recipeType: { readonly __typename?: 'WareCategoryType', readonly enum: TWareCategoryTypeEnum }, readonly translations: ReadonlyArray<{ readonly __typename?: 'RecipeTranslation', readonly descriptionLabel: string | null, readonly nameLabel: string | null, readonly language: { readonly __typename?: 'Language', readonly enum: TLanguageEnum } }> };

export type TFMenuRecipeInList = { readonly __typename?: 'Recipe', readonly shared: boolean, readonly nameLabel: string, readonly enabledByOwner: boolean, readonly id: ID, readonly code: string, readonly internalNote: string | null, readonly internalCode: string, readonly soldOut: boolean, readonly ageControl: boolean, readonly isCombinationMeal: boolean, readonly isDynamicPricingEnabled: boolean, readonly visible: boolean, readonly recipeColor: { readonly __typename?: 'RecipeColor', readonly id: ID, readonly code: string, readonly color: string } | null, readonly recipeType: { readonly __typename?: 'WareCategoryType', readonly enum: TWareCategoryTypeEnum } };

export type TFMenuRecipeInListSlow = { readonly __typename?: 'Recipe', readonly id: ID, readonly availableAmount: number, readonly isCombinationMeal: boolean, readonly imageUrl: string | null, readonly prices: ReadonlyArray<{ readonly __typename?: 'RecipePrice', readonly id: ID, readonly priceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } }, readonly vat: { readonly __typename?: 'Vat', readonly id: ID } }> };

export type TFMenuRecipeLocalized = { readonly __typename?: 'Recipe', readonly id: ID, readonly translations: ReadonlyArray<{ readonly __typename?: 'RecipeTranslation', readonly descriptionLabel: string | null, readonly nameLabel: string | null, readonly language: { readonly __typename?: 'Language', readonly enum: TLanguageEnum } }> };

export type TFMenuRecipePricing = { readonly __typename?: 'RecipePrice', readonly id: ID, readonly priceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } }, readonly vat: { readonly __typename?: 'Vat', readonly id: ID } };

export type TMMenuRecipeCreateVariables = Exact<{
  recipe: TInputRecipeCreate;
}>;


export type TMMenuRecipeCreate = { readonly __typename?: 'Mutation', readonly recipe: { readonly __typename?: 'Recipe', readonly shared: boolean, readonly nameLabel: string, readonly enabledByOwner: boolean, readonly id: ID, readonly availableAmount: number, readonly isCombinationMeal: boolean, readonly code: string, readonly internalNote: string | null, readonly internalCode: string, readonly soldOut: boolean, readonly ageControl: boolean, readonly isDynamicPricingEnabled: boolean, readonly imageUrl: string | null, readonly visible: boolean, readonly prices: ReadonlyArray<{ readonly __typename?: 'RecipePrice', readonly id: ID, readonly priceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } }, readonly vat: { readonly __typename?: 'Vat', readonly id: ID } }>, readonly recipeColor: { readonly __typename?: 'RecipeColor', readonly id: ID, readonly code: string, readonly color: string } | null, readonly recipeType: { readonly __typename?: 'WareCategoryType', readonly enum: TWareCategoryTypeEnum } } };

export type TMMenuRecipeDeleteVariables = Exact<{
  recipeId: Scalars['ID'];
}>;


export type TMMenuRecipeDelete = { readonly __typename?: 'Mutation', readonly destroyRecipe: { readonly __typename?: 'Recipe', readonly id: ID } };

export type TMMenuRecipeSoldOutVariables = Exact<{
  branchId: Scalars['ID'];
  recipeId: Scalars['ID'];
  soldOut: Scalars['Boolean'];
}>;


export type TMMenuRecipeSoldOut = { readonly __typename?: 'Mutation', readonly updatedSoldOut: { readonly __typename?: 'Recipe', readonly id: ID, readonly soldOut: boolean } };

export type TMMenuRecipeUpdateVariables = Exact<{
  recipeId: Scalars['ID'];
  recipe: TInputRecipeUpdate;
}>;


export type TMMenuRecipeUpdate = { readonly __typename?: 'Mutation', readonly recipe: { readonly __typename?: 'Recipe', readonly shared: boolean, readonly nameLabel: string, readonly enabledByOwner: boolean, readonly id: ID, readonly availableAmount: number, readonly isCombinationMeal: boolean, readonly code: string, readonly internalNote: string | null, readonly internalCode: string, readonly soldOut: boolean, readonly ageControl: boolean, readonly isDynamicPricingEnabled: boolean, readonly imageUrl: string | null, readonly visible: boolean, readonly prices: ReadonlyArray<{ readonly __typename?: 'RecipePrice', readonly id: ID, readonly priceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } }, readonly vat: { readonly __typename?: 'Vat', readonly id: ID } }>, readonly recipeColor: { readonly __typename?: 'RecipeColor', readonly id: ID, readonly code: string, readonly color: string } | null, readonly recipeType: { readonly __typename?: 'WareCategoryType', readonly enum: TWareCategoryTypeEnum } } };

export type TMMenuRecipeVisibilityVariables = Exact<{
  branchId: Scalars['ID'];
  recipeId: Scalars['ID'];
  visible: Scalars['Boolean'];
}>;


export type TMMenuRecipeVisibility = { readonly __typename?: 'Mutation', readonly updatedVisibility: { readonly __typename?: 'Recipe', readonly id: ID, readonly visible: boolean } };

export type TQCombinationMealsVariables = Exact<{
  branchId: Scalars['ID'];
  categoryId?: InputMaybe<Scalars['ID']>;
}>;


export type TQCombinationMeals = { readonly __typename?: 'Query', readonly recipes: ReadonlyArray<{ readonly __typename?: 'Recipe', readonly id: ID, readonly deliveryCombinationMealPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } }, readonly inHouseCombinationMealPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } }, readonly woltCombinationMealPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } }, readonly foodoraCombinationMealPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } }, readonly boltCombinationMealPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } }, readonly jidloPodNosCombinationMealPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } } }> };

export type TQMenuRecipeColorsVariables = Exact<{ [key: string]: never; }>;


export type TQMenuRecipeColors = { readonly __typename?: 'Query', readonly recipeColors: ReadonlyArray<{ readonly __typename?: 'RecipeColor', readonly id: ID, readonly code: string, readonly color: string }> };

export type TQMenuRecipeDefaultsVariables = Exact<{
  branchId: Scalars['ID'];
}>;


export type TQMenuRecipeDefaults = { readonly __typename?: 'Query', readonly defaults: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly vats: ReadonlyArray<{ readonly __typename?: 'VatPriceType', readonly vatId: ID, readonly priceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum } }>, readonly currency: { readonly __typename?: 'Currency', readonly id: ID, readonly code: string } } };

export type TQMenuRecipeFormVariables = Exact<{
  recipeId: Scalars['ID'];
  language: TLanguageEnum;
}>;


export type TQMenuRecipeForm = { readonly __typename?: 'Query', readonly recipe: { readonly __typename?: 'Recipe', readonly image: string | null, readonly dependentRules: ReadonlyArray<string>, readonly pictogram: string | null, readonly id: ID, readonly code: string, readonly internalNote: string | null, readonly internalCode: string, readonly soldOut: boolean, readonly ageControl: boolean, readonly isCombinationMeal: boolean, readonly isDynamicPricingEnabled: boolean, readonly visible: boolean, readonly sourcePrices: ReadonlyArray<{ readonly __typename?: 'RecipePrice', readonly id: ID, readonly priceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } }, readonly vat: { readonly __typename?: 'Vat', readonly id: ID } }>, readonly sourceAssociatedRecipes: ReadonlyArray<{ readonly __typename?: 'RecipeRelation', readonly id: ID, readonly priceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string, readonly inHousePrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string }, readonly deliveryPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string } } }>, readonly sourceIngredients: ReadonlyArray<{ readonly __typename?: 'Ingredient', readonly id: ID, readonly quantity: number, readonly stockItem: { readonly __typename?: 'StockItem', readonly id: ID, readonly label: string, readonly wareUnit: { readonly __typename?: 'WareUnit', readonly id: ID, readonly code: string }, readonly allergens: ReadonlyArray<{ readonly __typename?: 'Allergen', readonly id: ID, readonly enum: TAllergenEnum }> } }>, readonly primaryCategory: { readonly __typename?: 'WareCategory', readonly id: ID, readonly pictogram: string | null } | null, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'WareCategory', readonly nameLabel: string, readonly countRecipes: number, readonly enabledByOwner: boolean, readonly internalNoteLabel: string | null, readonly id: ID, readonly visible: boolean, readonly origins: ReadonlyArray<TOrderOriginCategoryEnum>, readonly color: { readonly __typename?: 'WareCategoryColor', readonly id: ID, readonly color: string } | null, readonly categoryType: { readonly __typename?: 'WareCategoryType', readonly enum: TWareCategoryTypeEnum }, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string }, readonly sharedCompanyBranches: ReadonlyArray<{ readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string, readonly woltProfiles: ReadonlyArray<{ readonly __typename?: 'WoltProfile', readonly onboardingErrorsLocalised: ReadonlyArray<string>, readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly onboardingState: { readonly __typename?: 'WoltProfileOnboardingState', readonly id: ID, readonly enum: TWoltProfileOnboardingStateEnum }, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly foodoraProfiles: ReadonlyArray<{ readonly __typename?: 'FoodoraProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly boltProfiles: ReadonlyArray<{ readonly __typename?: 'BoltProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly jidloPodNosProfiles: ReadonlyArray<{ readonly __typename?: 'JidloPodNosProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }> }> }>, readonly categories: ReadonlyArray<{ readonly __typename?: 'WareCategory', readonly nameLabel: string, readonly countRecipes: number, readonly enabledByOwner: boolean, readonly internalNoteLabel: string | null, readonly id: ID, readonly visible: boolean, readonly origins: ReadonlyArray<TOrderOriginCategoryEnum>, readonly color: { readonly __typename?: 'WareCategoryColor', readonly id: ID, readonly color: string } | null, readonly categoryType: { readonly __typename?: 'WareCategoryType', readonly enum: TWareCategoryTypeEnum }, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string }, readonly sharedCompanyBranches: ReadonlyArray<{ readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string, readonly woltProfiles: ReadonlyArray<{ readonly __typename?: 'WoltProfile', readonly onboardingErrorsLocalised: ReadonlyArray<string>, readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly onboardingState: { readonly __typename?: 'WoltProfileOnboardingState', readonly id: ID, readonly enum: TWoltProfileOnboardingStateEnum }, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly foodoraProfiles: ReadonlyArray<{ readonly __typename?: 'FoodoraProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly boltProfiles: ReadonlyArray<{ readonly __typename?: 'BoltProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }>, readonly jidloPodNosProfiles: ReadonlyArray<{ readonly __typename?: 'JidloPodNosProfile', readonly id: ID, readonly name: string, readonly restaurantIdValue: string | null, readonly isAutomaticMenuSyncEnabled: boolean, readonly integration: { readonly __typename?: 'Integration', readonly enum: TIntegrationEnum } }> }> }>, readonly workplaces: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: ID }>, readonly productTagRelations: ReadonlyArray<{ readonly __typename?: 'RecipeTagRelation', readonly id: ID, readonly inherited: boolean, readonly productTag: { readonly __typename?: 'RecipeTag', readonly id: ID, readonly label: string | null, readonly originTag: { readonly __typename?: 'RecipeTag', readonly id: ID } | null } }> | null, readonly recipeColor: { readonly __typename?: 'RecipeColor', readonly id: ID, readonly code: string, readonly color: string } | null, readonly recipeType: { readonly __typename?: 'WareCategoryType', readonly enum: TWareCategoryTypeEnum }, readonly translations: ReadonlyArray<{ readonly __typename?: 'RecipeTranslation', readonly descriptionLabel: string | null, readonly nameLabel: string | null, readonly language: { readonly __typename?: 'Language', readonly enum: TLanguageEnum } }> } };

export type TQMenuRecipeFormAssocVariables = Exact<{
  branchId: Scalars['ID'];
}>;


export type TQMenuRecipeFormAssoc = { readonly __typename?: 'Query', readonly recipes: ReadonlyArray<{ readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string, readonly inHousePrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string }, readonly deliveryPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string } }> };

export type TQMenuRecipeListVariables = Exact<{
  branchId: Scalars['ID'];
  categoryId?: InputMaybe<Scalars['ID']>;
  categoryType?: InputMaybe<TWareCategoryTypeEnum>;
  recipeTagIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
}>;


export type TQMenuRecipeList = { readonly __typename?: 'Query', readonly recipes: ReadonlyArray<{ readonly __typename?: 'Recipe', readonly shared: boolean, readonly nameLabel: string, readonly enabledByOwner: boolean, readonly id: ID, readonly code: string, readonly internalNote: string | null, readonly internalCode: string, readonly soldOut: boolean, readonly ageControl: boolean, readonly isCombinationMeal: boolean, readonly isDynamicPricingEnabled: boolean, readonly visible: boolean, readonly recipeColor: { readonly __typename?: 'RecipeColor', readonly id: ID, readonly code: string, readonly color: string } | null, readonly recipeType: { readonly __typename?: 'WareCategoryType', readonly enum: TWareCategoryTypeEnum } }> };

export type TQMenuRecipeListSlowVariables = Exact<{
  branchId: Scalars['ID'];
  categoryId?: InputMaybe<Scalars['ID']>;
  categoryType?: InputMaybe<TWareCategoryTypeEnum>;
  recipeTagIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
}>;


export type TQMenuRecipeListSlow = { readonly __typename?: 'Query', readonly recipes: ReadonlyArray<{ readonly __typename?: 'Recipe', readonly id: ID, readonly availableAmount: number, readonly isCombinationMeal: boolean, readonly imageUrl: string | null, readonly prices: ReadonlyArray<{ readonly __typename?: 'RecipePrice', readonly id: ID, readonly priceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } }, readonly vat: { readonly __typename?: 'Vat', readonly id: ID } }> }> };

export type TQMenuRecipeTagFilterVariables = Exact<{
  brandId: Scalars['ID'];
  branchId: Scalars['ID'];
}>;


export type TQMenuRecipeTagFilter = { readonly __typename?: 'Query', readonly recipeTags: ReadonlyArray<{ readonly __typename?: 'RecipeTag', readonly id: ID, readonly label: string | null, readonly category: { readonly __typename?: 'RecipeTagCategoryType', readonly enum: TRecipeTagCategoryTypeEnum, readonly label: string } | null, readonly originTag: { readonly __typename?: 'RecipeTag', readonly id: ID } | null }>, readonly relations: ReadonlyArray<{ readonly __typename?: 'RecipeTagRelation', readonly id: ID, readonly recipeTag: { readonly __typename?: 'RecipeTag', readonly id: ID } }> };

export type TFMenuStockItem = { readonly __typename?: 'StockItem', readonly id: ID, readonly code: string, readonly note: string, readonly plu: string | null, readonly shared: boolean, readonly quantity: number, readonly nameLabel: string, readonly allergens: ReadonlyArray<{ readonly __typename?: 'Allergen', readonly id: ID, readonly code: string, readonly enum: TAllergenEnum, readonly category: number }>, readonly wareUnit: { readonly __typename?: 'WareUnit', readonly id: ID, readonly enum: TWareUnitEnum, readonly code: string } };

export type TMMenuStockCreateVariables = Exact<{
  stockItem: TInputStockItemCreate;
}>;


export type TMMenuStockCreate = { readonly __typename?: 'Mutation', readonly createStockItem: { readonly __typename?: 'StockItem', readonly allowNegative: TFieldStateEnum, readonly id: ID, readonly code: string, readonly note: string, readonly plu: string | null, readonly shared: boolean, readonly quantity: number, readonly nameLabel: string, readonly allergens: ReadonlyArray<{ readonly __typename?: 'Allergen', readonly id: ID, readonly code: string, readonly enum: TAllergenEnum, readonly category: number }>, readonly wareUnit: { readonly __typename?: 'WareUnit', readonly id: ID, readonly enum: TWareUnitEnum, readonly code: string } } };

export type TMMenuStockDeleteVariables = Exact<{
  stockId: Scalars['ID'];
}>;


export type TMMenuStockDelete = { readonly __typename?: 'Mutation', readonly deleteStockItem: { readonly __typename?: 'StockItem', readonly id: ID } };

export type TMMenuStockQuantityVariables = Exact<{
  stockItem: Scalars['ID'];
  quantityChange: Scalars['Float'];
  note?: InputMaybe<Scalars['String']>;
}>;


export type TMMenuStockQuantity = { readonly __typename?: 'Mutation', readonly changeAmountStockItem: { readonly __typename?: 'StockItem', readonly id: ID, readonly quantity: number } };

export type TMMenuStockUpdateVariables = Exact<{
  stockId: Scalars['ID'];
  stockItem: TInputStockItemUpdate;
}>;


export type TMMenuStockUpdate = { readonly __typename?: 'Mutation', readonly updateStockItem: { readonly __typename?: 'StockItem', readonly allowNegative: TFieldStateEnum, readonly id: ID, readonly code: string, readonly note: string, readonly plu: string | null, readonly shared: boolean, readonly quantity: number, readonly nameLabel: string, readonly allergens: ReadonlyArray<{ readonly __typename?: 'Allergen', readonly id: ID, readonly code: string, readonly enum: TAllergenEnum, readonly category: number }>, readonly wareUnit: { readonly __typename?: 'WareUnit', readonly id: ID, readonly enum: TWareUnitEnum, readonly code: string } } };

export type TMPohodaSyncPlanVariables = Exact<{
  companyBranchId: Scalars['ID'];
}>;


export type TMPohodaSyncPlan = { readonly __typename?: 'Mutation', readonly pohodaExportPlan: { readonly __typename?: 'PohodaExportPlanType', readonly message: string } };

export type TQMenuStockDefaultsVariables = Exact<{
  branchId: Scalars['ID'];
}>;


export type TQMenuStockDefaults = { readonly __typename?: 'Query', readonly defaults: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly allowNegative: boolean } };

export type TQMenuStockFormVariables = Exact<{
  stockId: Scalars['ID'];
}>;


export type TQMenuStockForm = { readonly __typename?: 'Query', readonly stockItem: { readonly __typename?: 'StockItem', readonly allowNegative: TFieldStateEnum, readonly id: ID, readonly code: string, readonly note: string, readonly plu: string | null, readonly shared: boolean, readonly quantity: number, readonly nameLabel: string, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly allowNegative: boolean }, readonly allergens: ReadonlyArray<{ readonly __typename?: 'Allergen', readonly id: ID, readonly code: string, readonly enum: TAllergenEnum, readonly category: number }>, readonly wareUnit: { readonly __typename?: 'WareUnit', readonly id: ID, readonly enum: TWareUnitEnum, readonly code: string } } };

export type TQMenuStockListVariables = Exact<{
  branchId: Scalars['ID'];
}>;


export type TQMenuStockList = { readonly __typename?: 'Query', readonly stockItems: ReadonlyArray<{ readonly __typename?: 'StockItem', readonly allowNegativeValue: boolean, readonly id: ID, readonly code: string, readonly note: string, readonly plu: string | null, readonly shared: boolean, readonly quantity: number, readonly nameLabel: string, readonly allergens: ReadonlyArray<{ readonly __typename?: 'Allergen', readonly id: ID, readonly code: string, readonly enum: TAllergenEnum, readonly category: number }>, readonly wareUnit: { readonly __typename?: 'WareUnit', readonly id: ID, readonly enum: TWareUnitEnum, readonly code: string } }> };

export type TQStockRecipesVariables = Exact<{
  stockId: Scalars['ID'];
}>;


export type TQStockRecipes = { readonly __typename?: 'Query', readonly stockItem: { readonly __typename?: 'StockItem', readonly id: ID, readonly ingredients: ReadonlyArray<{ readonly __typename?: 'Ingredient', readonly id: ID, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string, readonly descriptionLabel: string | null, readonly recipeType: { readonly __typename?: 'WareCategoryType', readonly enum: TWareCategoryTypeEnum } } }> } };

export type TQOrderDetailVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type TQOrderDetail = { readonly __typename?: 'Query', readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly isExpressDelivery: boolean, readonly createdAt: Date, readonly acceptedAt: Date | null, readonly isPriority: boolean, readonly isFromLoggedInCustomer: boolean, readonly deliverAt: Date | null, readonly deliveredAt: Date | null, readonly orderGroupIndex: number | null, readonly orderStateCategory: TOrderStateCategoryEnum, readonly delayedDeliveryTime: Date | null, readonly driverWillPickupAt: Date | null, readonly isPaidWithCard: boolean, readonly cancelRequested: boolean, readonly shouldVerifyAge: boolean, readonly orderNumber: number | null, readonly orderStates: ReadonlyArray<{ readonly __typename?: 'OrderState', readonly id: ID, readonly enum: TOrderStateEnum }>, readonly ratings: ReadonlyArray<{ readonly __typename?: 'OrderRating', readonly id: ID, readonly value: number | null, readonly description: string | null, readonly type: { readonly __typename?: 'OrderRatingType', readonly enum: TOrderRatingTypeEnum, readonly code: string } }> | null, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string, readonly oldOrderThreshold: number, readonly allowedCategories: ReadonlyArray<TOrderStateCategoryEnum>, readonly defaultDeliveryTimeEnabled: boolean, readonly defaultPickupTimeEnabled: boolean, readonly usualDeliveryTime: number, readonly usualPickupTime: number }, readonly customer: { readonly __typename?: 'JsonCustomer', readonly firstName: string | null, readonly lastName: string | null, readonly isCancelRisk: boolean | null, readonly defaultPhone: { readonly __typename?: 'Phone', readonly phone: string } | null }, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly formattedValue: string }, readonly orderGroup: { readonly __typename?: 'OrderGroup', readonly id: ID } | null, readonly driver: { readonly __typename?: 'UserDeliveringOrder', readonly id: ID, readonly user: { readonly __typename?: 'User', readonly id: ID, readonly initials: string, readonly firstName: string | null, readonly lastName: string | null } } | null, readonly orderOrigin: { readonly __typename?: 'OrderOrigin', readonly enum: TOrderOriginEnum, readonly label: string }, readonly warePriceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly sector: { readonly __typename?: 'Sector', readonly name: string } | null, readonly address: { readonly __typename?: 'JsonAddress', readonly original: string | null, readonly state: string | null, readonly city: string | null, readonly venue: string | null, readonly street: string | null, readonly houseNumber: string | null, readonly country: string | null }, readonly onlinePaymentState: { readonly __typename?: 'OrderOnlineState', readonly enum: TOrderOnlineStateEnum } | null, readonly gps: { readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number } | null, readonly orderPayments: ReadonlyArray<{ readonly __typename?: 'OrderPaymentMethod', readonly id: ID, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly paymentMethod: { readonly __typename?: 'PaymentMethod', readonly id: ID, readonly description: string, readonly paymentType: { readonly __typename?: 'PaymentType', readonly id: ID, readonly enum: TPaymentTypeEnum } } }> } };

export type TFOrderDetailWare = { readonly __typename?: 'OrderRecipe', readonly id: ID, readonly note: string | null, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly nameLabel: string }, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string } };

export type TFOrderGps = { readonly __typename?: 'Order', readonly id: ID, readonly gps: { readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number } | null };

export type TFOrderInList = { readonly __typename?: 'Order', readonly id: ID, readonly isExpressDelivery: boolean, readonly createdAt: Date, readonly acceptedAt: Date | null, readonly isPriority: boolean, readonly isFromLoggedInCustomer: boolean, readonly deliverAt: Date | null, readonly deliveredAt: Date | null, readonly orderGroupIndex: number | null, readonly orderStateCategory: TOrderStateCategoryEnum, readonly delayedDeliveryTime: Date | null, readonly driverWillPickupAt: Date | null, readonly isPaidWithCard: boolean, readonly cancelRequested: boolean, readonly shouldVerifyAge: boolean, readonly orderNumber: number | null, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string, readonly oldOrderThreshold: number, readonly allowedCategories: ReadonlyArray<TOrderStateCategoryEnum>, readonly defaultDeliveryTimeEnabled: boolean, readonly defaultPickupTimeEnabled: boolean, readonly usualDeliveryTime: number, readonly usualPickupTime: number }, readonly customer: { readonly __typename?: 'JsonCustomer', readonly firstName: string | null, readonly lastName: string | null, readonly isCancelRisk: boolean | null, readonly defaultPhone: { readonly __typename?: 'Phone', readonly phone: string } | null }, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly formattedValue: string }, readonly orderGroup: { readonly __typename?: 'OrderGroup', readonly id: ID } | null, readonly driver: { readonly __typename?: 'UserDeliveringOrder', readonly id: ID, readonly user: { readonly __typename?: 'User', readonly id: ID, readonly initials: string, readonly firstName: string | null, readonly lastName: string | null } } | null, readonly orderOrigin: { readonly __typename?: 'OrderOrigin', readonly enum: TOrderOriginEnum, readonly label: string }, readonly warePriceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly sector: { readonly __typename?: 'Sector', readonly name: string } | null, readonly address: { readonly __typename?: 'JsonAddress', readonly original: string | null, readonly state: string | null, readonly city: string | null, readonly venue: string | null, readonly street: string | null, readonly houseNumber: string | null, readonly country: string | null }, readonly onlinePaymentState: { readonly __typename?: 'OrderOnlineState', readonly enum: TOrderOnlineStateEnum } | null, readonly gps: { readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number } | null, readonly orderPayments: ReadonlyArray<{ readonly __typename?: 'OrderPaymentMethod', readonly id: ID, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly paymentMethod: { readonly __typename?: 'PaymentMethod', readonly id: ID, readonly description: string, readonly paymentType: { readonly __typename?: 'PaymentType', readonly id: ID, readonly enum: TPaymentTypeEnum } } }> };

export type TFOrderListGroup = { readonly __typename?: 'Order', readonly id: ID, readonly orderGroupIndex: number | null, readonly orderGroup: { readonly __typename?: 'OrderGroup', readonly id: ID } | null };

export type TFOrderMapDelivery = { readonly __typename?: 'User', readonly id: ID, readonly initials: string, readonly firstName: string | null, readonly lastName: string | null, readonly countUndeliveredOrders: number, readonly device: { readonly __typename?: 'TransportationDeviceUser', readonly id: ID, readonly isFinalized: boolean, readonly lastPosition: { readonly __typename?: 'GeoPositionWithTimestamp', readonly timestamp: Date, readonly gps: { readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number } } | null, readonly transportationDevice: { readonly __typename?: 'TransportationDevice', readonly deviceState: { readonly __typename?: 'DeviceState', readonly enum: TDeviceStateEnum } } } | null };

export type TFOrderMapDevice = { readonly __typename?: 'TransportationDeviceUser', readonly id: ID, readonly isFinalized: boolean, readonly lastPosition: { readonly __typename?: 'GeoPositionWithTimestamp', readonly timestamp: Date, readonly gps: { readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number } } | null, readonly transportationDevice: { readonly __typename?: 'TransportationDevice', readonly deviceState: { readonly __typename?: 'DeviceState', readonly enum: TDeviceStateEnum } } };

export type TFOrderMapDriver = { readonly __typename?: 'User', readonly id: ID, readonly initials: string, readonly firstName: string | null, readonly lastName: string | null, readonly countUndeliveredOrders: number };

export type TFOrderMapOrder = { readonly __typename?: 'Order', readonly id: ID, readonly orderStateCategory: TOrderStateCategoryEnum, readonly currentUserCanFinishOrder: boolean, readonly deliverAt: Date | null, readonly deliveredAt: Date | null, readonly driverWillPickupAt: Date | null, readonly delayedDeliveryTime: Date | null, readonly acceptedAt: Date | null, readonly isExpressDelivery: boolean, readonly cancelRequested: boolean, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly gps: { readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number } | null, readonly orderGroup: { readonly __typename?: 'OrderGroup', readonly id: ID, readonly color: { readonly __typename?: 'OrderGroupColor', readonly id: ID, readonly color: string } | null } | null };

export type TMTemporaryCloseVariables = Exact<{
  branchId: Scalars['ID'];
  closedNote?: InputMaybe<Scalars['String']>;
  closedForTime: Scalars['Int'];
}>;


export type TMTemporaryClose = { readonly __typename?: 'Mutation', readonly addSpecialClosingBusinessHours: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly isOpen: boolean } };

export type TQAreBranchesOpenVariables = Exact<{
  branchIds: ReadonlyArray<Scalars['ID']>;
}>;


export type TQAreBranchesOpen = { readonly __typename?: 'Query', readonly companyBranches: ReadonlyArray<{ readonly __typename?: 'CompanyBranch', readonly id: ID, readonly isOpen: boolean }> };

export type TQNewOrdersVariables = Exact<{
  branches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  acceptedAfter?: InputMaybe<Scalars['DateTime']>;
}>;


export type TQNewOrders = { readonly __typename?: 'Query', readonly orders: ReadonlyArray<{ readonly __typename?: 'Order', readonly id: ID }> };

export type TQOrderListVariables = Exact<{
  branches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  categories?: InputMaybe<ReadonlyArray<TOrderStateCategoryEnum>>;
  acceptedAfter?: InputMaybe<Scalars['DateTime']>;
}>;


export type TQOrderList = { readonly __typename?: 'Query', readonly orders: ReadonlyArray<{ readonly __typename?: 'Order', readonly id: ID, readonly isExpressDelivery: boolean, readonly orderStateCategory: TOrderStateCategoryEnum, readonly currentUserCanFinishOrder: boolean, readonly createdAt: Date, readonly acceptedAt: Date | null, readonly isPriority: boolean, readonly isFromLoggedInCustomer: boolean, readonly deliverAt: Date | null, readonly deliveredAt: Date | null, readonly orderGroupIndex: number | null, readonly delayedDeliveryTime: Date | null, readonly driverWillPickupAt: Date | null, readonly isPaidWithCard: boolean, readonly cancelRequested: boolean, readonly shouldVerifyAge: boolean, readonly orderNumber: number | null, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly gps: { readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number } | null, readonly orderGroup: { readonly __typename?: 'OrderGroup', readonly id: ID, readonly color: { readonly __typename?: 'OrderGroupColor', readonly id: ID, readonly color: string } | null } | null, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string, readonly oldOrderThreshold: number, readonly allowedCategories: ReadonlyArray<TOrderStateCategoryEnum>, readonly defaultDeliveryTimeEnabled: boolean, readonly defaultPickupTimeEnabled: boolean, readonly usualDeliveryTime: number, readonly usualPickupTime: number }, readonly customer: { readonly __typename?: 'JsonCustomer', readonly firstName: string | null, readonly lastName: string | null, readonly isCancelRisk: boolean | null, readonly defaultPhone: { readonly __typename?: 'Phone', readonly phone: string } | null }, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly formattedValue: string }, readonly driver: { readonly __typename?: 'UserDeliveringOrder', readonly id: ID, readonly user: { readonly __typename?: 'User', readonly id: ID, readonly initials: string, readonly firstName: string | null, readonly lastName: string | null } } | null, readonly orderOrigin: { readonly __typename?: 'OrderOrigin', readonly enum: TOrderOriginEnum, readonly label: string }, readonly warePriceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly sector: { readonly __typename?: 'Sector', readonly name: string } | null, readonly address: { readonly __typename?: 'JsonAddress', readonly original: string | null, readonly state: string | null, readonly city: string | null, readonly venue: string | null, readonly street: string | null, readonly houseNumber: string | null, readonly country: string | null }, readonly onlinePaymentState: { readonly __typename?: 'OrderOnlineState', readonly enum: TOrderOnlineStateEnum } | null, readonly orderPayments: ReadonlyArray<{ readonly __typename?: 'OrderPaymentMethod', readonly id: ID, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly paymentMethod: { readonly __typename?: 'PaymentMethod', readonly id: ID, readonly description: string, readonly paymentType: { readonly __typename?: 'PaymentType', readonly id: ID, readonly enum: TPaymentTypeEnum } } }> }> };

export type TQOrderListCategoriesVariables = Exact<{ [key: string]: never; }>;


export type TQOrderListCategories = { readonly __typename?: 'Query', readonly categories: ReadonlyArray<{ readonly __typename?: 'OrderStateCategory', readonly enum: TOrderStateCategoryEnum, readonly label: string }> };

export type TQOrderMapDeliveriesVariables = Exact<{
  branches: ReadonlyArray<Scalars['ID']>;
}>;


export type TQOrderMapDeliveries = { readonly __typename?: 'Query', readonly deliveries: ReadonlyArray<{ readonly __typename?: 'User', readonly id: ID, readonly initials: string, readonly firstName: string | null, readonly lastName: string | null, readonly countUndeliveredOrders: number, readonly device: { readonly __typename?: 'TransportationDeviceUser', readonly id: ID, readonly isFinalized: boolean, readonly lastPosition: { readonly __typename?: 'GeoPositionWithTimestamp', readonly timestamp: Date, readonly gps: { readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number } } | null, readonly transportationDevice: { readonly __typename?: 'TransportationDevice', readonly deviceState: { readonly __typename?: 'DeviceState', readonly enum: TDeviceStateEnum } } } | null }> };

export type TQOrderReturnZonesVariables = Exact<{
  branches: ReadonlyArray<Scalars['ID']>;
}>;


export type TQOrderReturnZones = { readonly __typename?: 'Query', readonly zones: ReadonlyArray<{ readonly __typename?: 'Zone', readonly id: ID, readonly name: string, readonly zoneColor: { readonly __typename?: 'ZoneColor', readonly id: ID, readonly color: string }, readonly zoneType: { readonly __typename?: 'ZoneType', readonly enum: TZoneTypeEnum }, readonly geoPolygon: ReadonlyArray<{ readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number }> }> };

export type TQOrdersCategoryCountVariables = Exact<{
  branchesId: ReadonlyArray<Scalars['ID']>;
  categories: ReadonlyArray<TOrderStateCategoryEnum>;
}>;


export type TQOrdersCategoryCount = { readonly __typename?: 'Query', readonly ordersCategoryCount: ReadonlyArray<{ readonly __typename?: 'OrderStateCategoryCount', readonly count: number, readonly category: { readonly __typename?: 'OrderStateCategory', readonly enum: TOrderStateCategoryEnum } }> };

export type TSDriverReturnsVariables = Exact<{
  branches: ReadonlyArray<Scalars['ID']>;
}>;


export type TSDriverReturns = { readonly __typename?: 'Subscription', readonly update: { readonly __typename?: 'TransportationDeviceUserUpdateSubscription', readonly device: { readonly __typename?: 'TransportationDeviceUser', readonly id: ID, readonly returning: boolean, readonly returnZone: { readonly __typename?: 'Zone', readonly id: ID, readonly name: string } | null, readonly user: { readonly __typename?: 'User', readonly id: ID, readonly firstName: string | null, readonly lastName: string | null } } | null } };

export type TSOrderCallVariables = Exact<{ [key: string]: never; }>;


export type TSOrderCall = { readonly __typename?: 'Subscription', readonly call: { readonly __typename?: 'UserCallingCustomerSubscription', readonly eventId: ID, readonly phone: string, readonly prefix: string, readonly isRinging: boolean } };

export type TSOrderListVariables = Exact<{
  branches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  categories?: InputMaybe<ReadonlyArray<TOrderStateCategoryEnum>>;
}>;


export type TSOrderList = { readonly __typename?: 'Subscription', readonly updatedOrder: { readonly __typename?: 'OrderUpdateSubscription', readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly isExpressDelivery: boolean, readonly orderStateCategory: TOrderStateCategoryEnum, readonly currentUserCanFinishOrder: boolean, readonly createdAt: Date, readonly acceptedAt: Date | null, readonly isPriority: boolean, readonly isFromLoggedInCustomer: boolean, readonly deliverAt: Date | null, readonly deliveredAt: Date | null, readonly orderGroupIndex: number | null, readonly delayedDeliveryTime: Date | null, readonly driverWillPickupAt: Date | null, readonly isPaidWithCard: boolean, readonly cancelRequested: boolean, readonly shouldVerifyAge: boolean, readonly orderNumber: number | null, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly gps: { readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number } | null, readonly orderGroup: { readonly __typename?: 'OrderGroup', readonly id: ID, readonly color: { readonly __typename?: 'OrderGroupColor', readonly id: ID, readonly color: string } | null } | null, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string, readonly oldOrderThreshold: number, readonly allowedCategories: ReadonlyArray<TOrderStateCategoryEnum>, readonly defaultDeliveryTimeEnabled: boolean, readonly defaultPickupTimeEnabled: boolean, readonly usualDeliveryTime: number, readonly usualPickupTime: number }, readonly customer: { readonly __typename?: 'JsonCustomer', readonly firstName: string | null, readonly lastName: string | null, readonly isCancelRisk: boolean | null, readonly defaultPhone: { readonly __typename?: 'Phone', readonly phone: string } | null }, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly formattedValue: string }, readonly driver: { readonly __typename?: 'UserDeliveringOrder', readonly id: ID, readonly user: { readonly __typename?: 'User', readonly id: ID, readonly initials: string, readonly firstName: string | null, readonly lastName: string | null } } | null, readonly orderOrigin: { readonly __typename?: 'OrderOrigin', readonly enum: TOrderOriginEnum, readonly label: string }, readonly warePriceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly sector: { readonly __typename?: 'Sector', readonly name: string } | null, readonly address: { readonly __typename?: 'JsonAddress', readonly original: string | null, readonly state: string | null, readonly city: string | null, readonly venue: string | null, readonly street: string | null, readonly houseNumber: string | null, readonly country: string | null }, readonly onlinePaymentState: { readonly __typename?: 'OrderOnlineState', readonly enum: TOrderOnlineStateEnum } | null, readonly orderPayments: ReadonlyArray<{ readonly __typename?: 'OrderPaymentMethod', readonly id: ID, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly paymentMethod: { readonly __typename?: 'PaymentMethod', readonly id: ID, readonly description: string, readonly paymentType: { readonly __typename?: 'PaymentType', readonly id: ID, readonly enum: TPaymentTypeEnum } } }> } | null } };

export type TSOrderMapDeliveriesVariables = Exact<{
  branches: ReadonlyArray<Scalars['ID']>;
}>;


export type TSOrderMapDeliveries = { readonly __typename?: 'Subscription', readonly update: { readonly __typename?: 'TransportationDeviceUserUpdateSubscription', readonly device: { readonly __typename?: 'TransportationDeviceUser', readonly id: ID, readonly isFinalized: boolean, readonly user: { readonly __typename?: 'User', readonly id: ID, readonly initials: string, readonly firstName: string | null, readonly lastName: string | null, readonly countUndeliveredOrders: number }, readonly lastPosition: { readonly __typename?: 'GeoPositionWithTimestamp', readonly timestamp: Date, readonly gps: { readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number } } | null, readonly transportationDevice: { readonly __typename?: 'TransportationDevice', readonly deviceState: { readonly __typename?: 'DeviceState', readonly enum: TDeviceStateEnum } } } | null } };

export type TSOrderMapOrdersVariables = Exact<{
  branches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  categories?: InputMaybe<ReadonlyArray<TOrderStateCategoryEnum>>;
}>;


export type TSOrderMapOrders = { readonly __typename?: 'Subscription', readonly updatedOrder: { readonly __typename?: 'OrderUpdateSubscription', readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly orderStateCategory: TOrderStateCategoryEnum, readonly currentUserCanFinishOrder: boolean, readonly deliverAt: Date | null, readonly deliveredAt: Date | null, readonly driverWillPickupAt: Date | null, readonly delayedDeliveryTime: Date | null, readonly acceptedAt: Date | null, readonly isExpressDelivery: boolean, readonly cancelRequested: boolean, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly gps: { readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number } | null, readonly orderGroup: { readonly __typename?: 'OrderGroup', readonly id: ID, readonly color: { readonly __typename?: 'OrderGroupColor', readonly id: ID, readonly color: string } | null } | null } | null } };

export type TSOrdersCategoryCountVariables = Exact<{
  branchesId: ReadonlyArray<Scalars['ID']>;
  categories: ReadonlyArray<TOrderStateCategoryEnum>;
}>;


export type TSOrdersCategoryCount = { readonly __typename?: 'Subscription', readonly updatedCount: { readonly __typename?: 'OrderCategoryCountSubscription', readonly nextCategory: TOrderStateCategoryEnum, readonly prevCategory: TOrderStateCategoryEnum, readonly order: { readonly __typename?: 'Order', readonly id: ID } } };

export type TMPauseExpressDeliveryVariables = Exact<{
  id: Scalars['ID'];
  pausedUntil?: InputMaybe<Scalars['DateTime']>;
}>;


export type TMPauseExpressDelivery = { readonly __typename?: 'Mutation', readonly pauseExpressDelivery: { readonly __typename?: 'ExpressDeliverySetting', readonly id: ID, readonly isExpressEnabled: boolean, readonly isExpressAvailable: boolean, readonly pausedUntil: Date | null } };

export type TQExpressPauseStateVariables = Exact<{
  branchIds: ReadonlyArray<Scalars['ID']>;
}>;


export type TQExpressPauseState = { readonly __typename?: 'Query', readonly companyBranches: ReadonlyArray<{ readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string, readonly expressDeliverySetting: { readonly __typename?: 'ExpressDeliverySetting', readonly id: ID, readonly isExpressEnabled: boolean, readonly isExpressAvailable: boolean, readonly pausedUntil: Date | null } | null }> };

export type TQOrdersWithItemsVariables = Exact<{
  branches?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  categories?: InputMaybe<ReadonlyArray<TOrderStateCategoryEnum>>;
  acceptedAfter?: InputMaybe<Scalars['DateTime']>;
}>;


export type TQOrdersWithItems = { readonly __typename?: 'Query', readonly orders: ReadonlyArray<{ readonly __typename?: 'Order', readonly id: ID, readonly delayedDeliveryTime: Date | null, readonly orderNumber: number | null, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly address: { readonly __typename?: 'JsonAddress', readonly state: string | null, readonly city: string | null, readonly venue: string | null, readonly street: string | null, readonly houseNumber: string | null, readonly country: string | null }, readonly customer: { readonly __typename?: 'JsonCustomer', readonly firstName: string | null, readonly lastName: string | null, readonly defaultEmail: { readonly __typename?: 'Email', readonly email: string, readonly description: string | null, readonly default: boolean } | null, readonly defaultPhone: { readonly __typename?: 'Phone', readonly phone: string, readonly description: string | null, readonly default: boolean } | null }, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly note: string | null, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly note: string | null, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly nameLabel: string }, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string } }>, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly nameLabel: string }, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string } }>, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string } }> };

export type TFCurrentHandoverTimes = { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly defaultDeliveryTimeEnabled: boolean, readonly currentDeliveryTime: number, readonly defaultPickupTimeEnabled: boolean, readonly currentPickupTime: number, readonly nameLabel: string, readonly usualDeliveryTime: number, readonly usualPickupTime: number, readonly overriddenDeliveryTime: { readonly __typename?: 'OrderProcessTime', readonly id: ID, readonly expiresAt: Date, readonly time: number } | null, readonly overriddenPickupTime: { readonly __typename?: 'OrderProcessTime', readonly id: ID, readonly expiresAt: Date, readonly time: number } | null };

export type TFOverriddenHandoverTime = { readonly __typename?: 'OrderProcessTime', readonly id: ID, readonly expiresAt: Date, readonly time: number };

export type TMClearHandoverTimeOverrideVariables = Exact<{
  branchId: Scalars['ID'];
  handoverType: TDeliveryTypeEnum;
}>;


export type TMClearHandoverTimeOverride = { readonly __typename?: 'Mutation', readonly destroyOrderProcessTime: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly defaultDeliveryTimeEnabled: boolean, readonly currentDeliveryTime: number, readonly defaultPickupTimeEnabled: boolean, readonly currentPickupTime: number, readonly nameLabel: string, readonly usualDeliveryTime: number, readonly usualPickupTime: number, readonly overriddenDeliveryTime: { readonly __typename?: 'OrderProcessTime', readonly id: ID, readonly expiresAt: Date, readonly time: number } | null, readonly overriddenPickupTime: { readonly __typename?: 'OrderProcessTime', readonly id: ID, readonly expiresAt: Date, readonly time: number } | null } };

export type TMCreateHandoverTimeOverrideVariables = Exact<{
  minutes: Scalars['Int'];
  branchId: Scalars['ID'];
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  handoverType: TDeliveryTypeEnum;
}>;


export type TMCreateHandoverTimeOverride = { readonly __typename?: 'Mutation', readonly createOrderProcessTime: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly defaultDeliveryTimeEnabled: boolean, readonly currentDeliveryTime: number, readonly defaultPickupTimeEnabled: boolean, readonly currentPickupTime: number, readonly nameLabel: string, readonly usualDeliveryTime: number, readonly usualPickupTime: number, readonly overriddenDeliveryTime: { readonly __typename?: 'OrderProcessTime', readonly id: ID, readonly expiresAt: Date, readonly time: number } | null, readonly overriddenPickupTime: { readonly __typename?: 'OrderProcessTime', readonly id: ID, readonly expiresAt: Date, readonly time: number } | null } };

export type TQBranchesHandoverTimesVariables = Exact<{
  branchIds: ReadonlyArray<Scalars['ID']>;
}>;


export type TQBranchesHandoverTimes = { readonly __typename?: 'Query', readonly companyBranches: ReadonlyArray<{ readonly __typename?: 'CompanyBranch', readonly id: ID, readonly defaultDeliveryTimeEnabled: boolean, readonly currentDeliveryTime: number, readonly defaultPickupTimeEnabled: boolean, readonly currentPickupTime: number, readonly nameLabel: string, readonly usualDeliveryTime: number, readonly usualPickupTime: number, readonly overriddenDeliveryTime: { readonly __typename?: 'OrderProcessTime', readonly id: ID, readonly expiresAt: Date, readonly time: number } | null, readonly overriddenPickupTime: { readonly __typename?: 'OrderProcessTime', readonly id: ID, readonly expiresAt: Date, readonly time: number } | null }> };

export type TFBillingExpense = { readonly __typename?: 'StatisticsForOperatingCosts', readonly orderCount: number, readonly orderOrigin: { readonly __typename?: 'OrderOrigin', readonly enum: TOrderOriginEnum, readonly label: string } | null, readonly info: { readonly __typename?: 'OperatingCostFrequencyType', readonly id: ID, readonly expenseType: { readonly __typename?: 'OperatingCostType', readonly enum: TOperatingCostTypeEnum, readonly label: string } }, readonly settings: { readonly __typename?: 'OperatingCostSetting', readonly id: ID, readonly fixedCoef: number, readonly percentageCoef: number } | null, readonly fixedTotal: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly percentageTotal: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly orderRevenue: { readonly __typename?: 'PriceConverted', readonly value: number } };

export type TQBillingClientVariables = Exact<{
  branch: Scalars['ID'];
}>;


export type TQBillingClient = { readonly __typename?: 'Query', readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly client: { readonly __typename?: 'Company', readonly id: ID, readonly name: string, readonly bankAccount: string }, readonly currency: { readonly __typename?: 'Currency', readonly code: string } } };

export type TQBillingExpenseDetailVariables = Exact<{
  params: TInputFeeStatistics;
}>;


export type TQBillingExpenseDetail = { readonly __typename?: 'Query', readonly costStats: ReadonlyArray<{ readonly __typename?: 'StatisticsForOperatingCosts', readonly orderCount: number, readonly orderOrigin: { readonly __typename?: 'OrderOrigin', readonly enum: TOrderOriginEnum, readonly label: string } | null, readonly info: { readonly __typename?: 'OperatingCostFrequencyType', readonly id: ID, readonly expenseType: { readonly __typename?: 'OperatingCostType', readonly enum: TOperatingCostTypeEnum, readonly label: string } }, readonly settings: { readonly __typename?: 'OperatingCostSetting', readonly id: ID, readonly fixedCoef: number, readonly percentageCoef: number } | null, readonly fixedTotal: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly percentageTotal: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly orderRevenue: { readonly __typename?: 'PriceConverted', readonly value: number } }> };

export type TQBillingExpenseSummaryVariables = Exact<{
  params: TInputFeeStatistics;
}>;


export type TQBillingExpenseSummary = { readonly __typename?: 'Query', readonly feeStats: ReadonlyArray<{ readonly __typename?: 'StatisticsForFees', readonly speedloServices: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly notifications: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly payments: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly deliveries: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly commission: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly billedFee: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly commissionLimit: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly total: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly totalWithVat: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly minimumPayment: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly minimumPaymentSurcharge: { readonly __typename?: 'PriceConverted', readonly value: number } }> };

export type TQBillingExpenseTypesVariables = Exact<{ [key: string]: never; }>;


export type TQBillingExpenseTypes = { readonly __typename?: 'Query', readonly notificationTypes: ReadonlyArray<{ readonly __typename?: 'OperatingCostType', readonly enum: TOperatingCostTypeEnum }>, readonly paymentTypes: ReadonlyArray<{ readonly __typename?: 'OperatingCostType', readonly enum: TOperatingCostTypeEnum }>, readonly deliveryTypes: ReadonlyArray<{ readonly __typename?: 'OperatingCostType', readonly enum: TOperatingCostTypeEnum }> };

export type TQBillingNotificationExpensesVariables = Exact<{
  params: TInputFeeStatistics;
}>;


export type TQBillingNotificationExpenses = { readonly __typename?: 'Query', readonly costStats: ReadonlyArray<{ readonly __typename?: 'StatisticsForOperatingCosts', readonly notificationCount: number, readonly orderOrigin: { readonly __typename?: 'OrderOrigin', readonly enum: TOrderOriginEnum, readonly label: string } | null, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly value: number } }> };

export type TQBillingOverviewVariables = Exact<{
  params: TInputFeeStatistics;
}>;


export type TQBillingOverview = { readonly __typename?: 'Query', readonly paymentStats: { readonly __typename?: 'StatisticsForPayments', readonly holdBySpeedlo: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly collectedServiceFees: { readonly __typename?: 'PriceConverted', readonly value: number } }, readonly feeStats: ReadonlyArray<{ readonly __typename?: 'StatisticsForFees', readonly totalExpenses: { readonly __typename?: 'PriceConverted', readonly value: number } }> };

export type TQBillingRevenueVariables = Exact<{
  params: TInputFeeStatistics;
}>;


export type TQBillingRevenue = { readonly __typename?: 'Query', readonly paymentsStats: { readonly __typename?: 'StatisticsForPayments', readonly prePaidOrderCount: number, readonly postPaidOrderCount: number, readonly prePaidRevenue: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly postPaidRevenue: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly holdBySpeedlo: { readonly __typename?: 'PriceConverted', readonly value: number } } };

export type TFCreditsFundsTransfer = { readonly __typename?: 'CreditsFundsTransfer', readonly id: ID, readonly amount: { readonly __typename?: 'PriceConverted', readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } }, readonly order: { readonly __typename?: 'Order', readonly id: ID } | null, readonly state: { readonly __typename?: 'CreditsFundsTransferState', readonly id: ID, readonly enum: TCreditsFundsTransferStateEnum }, readonly type: { readonly __typename?: 'CreditsFundsTransferType', readonly id: ID, readonly enum: TCreditsFundsTransferTypeEnum } };

export type TQAvailableCreditGroupsVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type TQAvailableCreditGroups = { readonly __typename?: 'Query', readonly user: { readonly __typename?: 'User', readonly id: ID, readonly creditGroups: ReadonlyArray<{ readonly __typename?: 'CreditsGroup', readonly id: ID, readonly name: string, readonly allMemberships: ReadonlyArray<{ readonly __typename?: 'CreditsGroupMembership', readonly id: ID, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID } }> }> } };

export type TQEventsStatsCreditsVariables = Exact<{
  filter: TInputStatisticCreate;
}>;


export type TQEventsStatsCredits = { readonly __typename?: 'Query', readonly statistics: { readonly __typename?: 'Statistics', readonly finishedOrders: { readonly __typename?: 'StatisticsOrders', readonly orders: ReadonlyArray<{ readonly __typename?: 'Order', readonly id: ID, readonly orderStateCategory: TOrderStateCategoryEnum, readonly cashBox: { readonly __typename?: 'CashBox', readonly id: ID } | null }> }, readonly creditFundsTransfers: { readonly __typename?: 'StatisticsFullFundsTransfers', readonly transfers: ReadonlyArray<{ readonly __typename?: 'CreditsFundsTransfer', readonly id: ID, readonly amount: { readonly __typename?: 'PriceConverted', readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } }, readonly order: { readonly __typename?: 'Order', readonly id: ID } | null, readonly state: { readonly __typename?: 'CreditsFundsTransferState', readonly id: ID, readonly enum: TCreditsFundsTransferStateEnum }, readonly type: { readonly __typename?: 'CreditsFundsTransferType', readonly id: ID, readonly enum: TCreditsFundsTransferTypeEnum } }> } } };

export type TQOrderStatsCreditsVariables = Exact<{
  filter: TInputsStatisticCreditsCreate;
}>;


export type TQOrderStatsCredits = { readonly __typename?: 'Query', readonly statisticsForCredits: { readonly __typename?: 'StatisticsCredits', readonly creditWalletActivities: { readonly __typename?: 'StatisticsWalletActivities', readonly availableOrderRewardsSum: { readonly __typename?: 'PriceConverted', readonly formattedValue: string }, readonly expiredOrderRewardsSum: { readonly __typename?: 'PriceConverted', readonly formattedValue: string }, readonly orderPaymentsSum: { readonly __typename?: 'PriceConverted', readonly formattedValue: string }, readonly orderRewardsSum: { readonly __typename?: 'PriceConverted', readonly formattedValue: string } } } };

export type TFCreditActivityInCustomerHistory = { readonly __typename?: 'CreditsWalletActivity', readonly id: ID, readonly createdAt: Date, readonly expiresAt: Date | null, readonly isExpired: boolean, readonly amount: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string }, readonly remainingAmount: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string }, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string }, readonly group: { readonly __typename?: 'CreditsGroup', readonly id: ID, readonly name: string } };

export type TFOrderInCustomerHistory = { readonly __typename?: 'Order', readonly id: ID, readonly createdAt: Date, readonly acceptedAt: Date | null, readonly isPriority: boolean, readonly isFromLoggedInCustomer: boolean, readonly deliverAt: Date | null, readonly deliveredAt: Date | null, readonly driverWillPickupAt: Date | null, readonly delayedDeliveryTime: Date | null, readonly isExpressDelivery: boolean, readonly isPaidWithCard: boolean, readonly orderStateCategory: TOrderStateCategoryEnum, readonly shouldVerifyAge: boolean, readonly cancelRequested: boolean, readonly orderNumber: number | null, readonly orderOrigin: { readonly __typename?: 'OrderOrigin', readonly enum: TOrderOriginEnum, readonly label: string }, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string }, readonly tip: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly totalDiscount: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string, readonly oldOrderThreshold: number, readonly allowedCategories: ReadonlyArray<TOrderStateCategoryEnum>, readonly defaultDeliveryTimeEnabled: boolean, readonly defaultPickupTimeEnabled: boolean, readonly usualDeliveryTime: number, readonly usualPickupTime: number }, readonly customer: { readonly __typename?: 'JsonCustomer', readonly firstName: string | null, readonly lastName: string | null, readonly isCancelRisk: boolean | null, readonly defaultPhone: { readonly __typename?: 'Phone', readonly phone: string } | null }, readonly warePriceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly sector: { readonly __typename?: 'Sector', readonly name: string } | null, readonly address: { readonly __typename?: 'JsonAddress', readonly original: string | null, readonly state: string | null, readonly city: string | null, readonly venue: string | null, readonly street: string | null, readonly houseNumber: string | null, readonly country: string | null }, readonly onlinePaymentState: { readonly __typename?: 'OrderOnlineState', readonly enum: TOrderOnlineStateEnum } | null, readonly driver: { readonly __typename?: 'UserDeliveringOrder', readonly id: ID, readonly user: { readonly __typename?: 'User', readonly id: ID, readonly initials: string, readonly firstName: string | null, readonly lastName: string | null } } | null, readonly orderPayments: ReadonlyArray<{ readonly __typename?: 'OrderPaymentMethod', readonly id: ID, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly paymentMethod: { readonly __typename?: 'PaymentMethod', readonly id: ID, readonly description: string, readonly paymentType: { readonly __typename?: 'PaymentType', readonly id: ID, readonly enum: TPaymentTypeEnum } } }> };

export type TMCreateVoucherVariables = Exact<{
  message: Scalars['String'];
  discount: Scalars['Float'];
  shareable?: InputMaybe<Scalars['Boolean']>;
  validTill: Scalars['DateTime'];
  customerPhone: Scalars['String'];
  companyBranchId: Scalars['ID'];
}>;


export type TMCreateVoucher = { readonly __typename?: 'Mutation', readonly createUserVoucher: { readonly __typename?: 'PromoCode', readonly id: ID } };

export type TMCreditsCreateGiftVariables = Exact<{
  userId: Scalars['ID'];
  amount: Scalars['Float'];
  message?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  companyBranchId: Scalars['ID'];
}>;


export type TMCreditsCreateGift = { readonly __typename?: 'Mutation', readonly creditsCreateGift: { readonly __typename?: 'CreditsWalletActivity', readonly id: ID } };

export type TQBranchCurrencyVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TQBranchCurrency = { readonly __typename?: 'Query', readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly defaultCurrency: { readonly __typename?: 'Currency', readonly id: ID, readonly code: string, readonly enum: TCurrencyEnum } } };

export type TQCustomerCreditGiftsVariables = Exact<{
  userId: Scalars['ID'];
  branchIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
}>;


export type TQCustomerCreditGifts = { readonly __typename?: 'Query', readonly user: { readonly __typename?: 'User', readonly id: ID, readonly creditActivities: { readonly __typename?: 'CreditsWalletActivityConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor: string | null, readonly startCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly nodes: ReadonlyArray<{ readonly __typename?: 'CreditsWalletActivity', readonly id: ID, readonly createdAt: Date, readonly expiresAt: Date | null, readonly isExpired: boolean, readonly amount: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string }, readonly remainingAmount: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string }, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string }, readonly group: { readonly __typename?: 'CreditsGroup', readonly id: ID, readonly name: string } } | null> | null } } };

export type TQCustomerHistoryVariables = Exact<{
  filter: TInputStatisticCreate;
}>;


export type TQCustomerHistory = { readonly __typename?: 'Query', readonly stats: { readonly __typename?: 'Statistics', readonly customerHistory: { readonly __typename?: 'StatisticsCustomer', readonly phone: string | null, readonly emails: ReadonlyArray<string>, readonly addresses: ReadonlyArray<string>, readonly names: ReadonlyArray<string>, readonly userAccount: { readonly __typename?: 'User', readonly id: ID } | null, readonly orders: ReadonlyArray<{ readonly __typename?: 'Order', readonly id: ID, readonly createdAt: Date, readonly acceptedAt: Date | null, readonly isPriority: boolean, readonly isFromLoggedInCustomer: boolean, readonly deliverAt: Date | null, readonly deliveredAt: Date | null, readonly driverWillPickupAt: Date | null, readonly delayedDeliveryTime: Date | null, readonly isExpressDelivery: boolean, readonly isPaidWithCard: boolean, readonly orderStateCategory: TOrderStateCategoryEnum, readonly shouldVerifyAge: boolean, readonly cancelRequested: boolean, readonly orderNumber: number | null, readonly orderOrigin: { readonly __typename?: 'OrderOrigin', readonly enum: TOrderOriginEnum, readonly label: string }, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string }, readonly tip: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly totalDiscount: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string, readonly oldOrderThreshold: number, readonly allowedCategories: ReadonlyArray<TOrderStateCategoryEnum>, readonly defaultDeliveryTimeEnabled: boolean, readonly defaultPickupTimeEnabled: boolean, readonly usualDeliveryTime: number, readonly usualPickupTime: number }, readonly customer: { readonly __typename?: 'JsonCustomer', readonly firstName: string | null, readonly lastName: string | null, readonly isCancelRisk: boolean | null, readonly defaultPhone: { readonly __typename?: 'Phone', readonly phone: string } | null }, readonly warePriceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly sector: { readonly __typename?: 'Sector', readonly name: string } | null, readonly address: { readonly __typename?: 'JsonAddress', readonly original: string | null, readonly state: string | null, readonly city: string | null, readonly venue: string | null, readonly street: string | null, readonly houseNumber: string | null, readonly country: string | null }, readonly onlinePaymentState: { readonly __typename?: 'OrderOnlineState', readonly enum: TOrderOnlineStateEnum } | null, readonly driver: { readonly __typename?: 'UserDeliveringOrder', readonly id: ID, readonly user: { readonly __typename?: 'User', readonly id: ID, readonly initials: string, readonly firstName: string | null, readonly lastName: string | null } } | null, readonly orderPayments: ReadonlyArray<{ readonly __typename?: 'OrderPaymentMethod', readonly id: ID, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly paymentMethod: { readonly __typename?: 'PaymentMethod', readonly id: ID, readonly description: string, readonly paymentType: { readonly __typename?: 'PaymentType', readonly id: ID, readonly enum: TPaymentTypeEnum } } }> }>, readonly promoCodeStatistics: ReadonlyArray<{ readonly __typename?: 'PromoCodeStatistic', readonly description: string | null, readonly acquiredBy: string | null, readonly expirationDate: Date | null, readonly acquirementDate: Date | null, readonly acquirementOrder: { readonly __typename?: 'Order', readonly id: ID } | null, readonly applicationOrder: { readonly __typename?: 'Order', readonly id: ID, readonly deliveredAt: Date | null, readonly customer: { readonly __typename?: 'JsonCustomer', readonly phones: ReadonlyArray<{ readonly __typename?: 'Phone', readonly phone: string }> } } | null, readonly discount: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string } | null, readonly promoCode: { readonly __typename?: 'PromoCode', readonly id: ID, readonly code: string, readonly public: boolean, readonly type: { readonly __typename?: 'PromoCodeType', readonly enum: TPromoCodeTypeEnum, readonly code: string }, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string } | null, readonly company: { readonly __typename?: 'Company', readonly id: ID, readonly name: string } | null } }> } } };

export type TMExportCustomersVariables = Exact<{
  branches: ReadonlyArray<Scalars['ID']>;
  dateFrom: Scalars['DateTime'];
  dateTo: Scalars['DateTime'];
  fileFormat: TFileReportFormat;
  madeOrder: Scalars['Boolean'];
}>;


export type TMExportCustomers = { readonly __typename?: 'Mutation', readonly result: { readonly __typename?: 'CustomerExport', readonly success: boolean, readonly maskedEmail: string | null } };

export type TMRequestPhoneConfirmationCodeVariables = Exact<{
  phoneNumber: Scalars['String'];
  exportId: Scalars['ID'];
}>;


export type TMRequestPhoneConfirmationCode = { readonly __typename?: 'Mutation', readonly result: { readonly __typename?: 'RequestPhoneConfirmationCode', readonly phoneNumber: string } };

export type TMValidateUserConfirmationCodeVariables = Exact<{
  code: Scalars['String'];
}>;


export type TMValidateUserConfirmationCode = { readonly __typename?: 'Mutation', readonly result: { readonly __typename?: 'CurrentUserValidation', readonly token: string } | null };

export type TQCustomersFileReportsVariables = Exact<{
  exportId: Scalars['ID'];
}>;


export type TQCustomersFileReports = { readonly __typename?: 'Query', readonly fileUrl: string };

export type TFOrderForRating = { readonly __typename?: 'Order', readonly id: ID, readonly acceptedAt: Date | null, readonly createdAt: Date, readonly deliveredAt: Date | null, readonly customerOrdersCountCurrent: number, readonly customerOrdersCountTotal: number, readonly customer: { readonly __typename?: 'JsonCustomer', readonly firstName: string | null, readonly lastName: string | null, readonly defaultPhone: { readonly __typename?: 'Phone', readonly phone: string } | null, readonly phones: ReadonlyArray<{ readonly __typename?: 'Phone', readonly phone: string, readonly description: string | null, readonly default: boolean }> }, readonly createdBy: { readonly __typename?: 'User', readonly id: ID, readonly firstName: string | null, readonly lastName: string | null, readonly isGuest: boolean } | null, readonly ratings: ReadonlyArray<{ readonly __typename?: 'OrderRating', readonly id: ID, readonly value: number | null, readonly description: string | null, readonly type: { readonly __typename?: 'OrderRatingType', readonly enum: TOrderRatingTypeEnum, readonly code: string } }> | null, readonly warePriceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly sector: { readonly __typename?: 'Sector', readonly name: string } | null, readonly address: { readonly __typename?: 'JsonAddress', readonly original: string | null, readonly state: string | null, readonly city: string | null, readonly venue: string | null, readonly street: string | null, readonly houseNumber: string | null, readonly country: string | null } };

export type TQOrderRatingsVariables = Exact<{
  filter: TInputStatisticCreate;
}>;


export type TQOrderRatings = { readonly __typename?: 'Query', readonly stats: { readonly __typename?: 'Statistics', readonly orders: { readonly __typename?: 'StatisticsOrders', readonly list: ReadonlyArray<{ readonly __typename?: 'Order', readonly id: ID, readonly acceptedAt: Date | null, readonly createdAt: Date, readonly deliveredAt: Date | null, readonly customerOrdersCountCurrent: number, readonly customerOrdersCountTotal: number, readonly customer: { readonly __typename?: 'JsonCustomer', readonly firstName: string | null, readonly lastName: string | null, readonly defaultPhone: { readonly __typename?: 'Phone', readonly phone: string } | null, readonly phones: ReadonlyArray<{ readonly __typename?: 'Phone', readonly phone: string, readonly description: string | null, readonly default: boolean }> }, readonly createdBy: { readonly __typename?: 'User', readonly id: ID, readonly firstName: string | null, readonly lastName: string | null, readonly isGuest: boolean } | null, readonly ratings: ReadonlyArray<{ readonly __typename?: 'OrderRating', readonly id: ID, readonly value: number | null, readonly description: string | null, readonly type: { readonly __typename?: 'OrderRatingType', readonly enum: TOrderRatingTypeEnum, readonly code: string } }> | null, readonly warePriceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly sector: { readonly __typename?: 'Sector', readonly name: string } | null, readonly address: { readonly __typename?: 'JsonAddress', readonly original: string | null, readonly state: string | null, readonly city: string | null, readonly venue: string | null, readonly street: string | null, readonly houseNumber: string | null, readonly country: string | null } }> } } };

export type TFOrderInStatistics = { readonly __typename?: 'Order', readonly id: ID, readonly createdAt: Date, readonly acceptedAt: Date | null, readonly isPriority: boolean, readonly isFromLoggedInCustomer: boolean, readonly deliverAt: Date | null, readonly deliveredAt: Date | null, readonly driverWillPickupAt: Date | null, readonly delayedDeliveryTime: Date | null, readonly isExpressDelivery: boolean, readonly isPaidWithCard: boolean, readonly orderStateCategory: TOrderStateCategoryEnum, readonly shouldVerifyAge: boolean, readonly cancelRequested: boolean, readonly orderNumber: number | null, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string, readonly oldOrderThreshold: number, readonly allowedCategories: ReadonlyArray<TOrderStateCategoryEnum>, readonly defaultDeliveryTimeEnabled: boolean, readonly defaultPickupTimeEnabled: boolean, readonly usualDeliveryTime: number, readonly usualPickupTime: number }, readonly customer: { readonly __typename?: 'JsonCustomer', readonly firstName: string | null, readonly lastName: string | null, readonly isCancelRisk: boolean | null, readonly defaultPhone: { readonly __typename?: 'Phone', readonly phone: string } | null }, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly formattedValue: string }, readonly orderOrigin: { readonly __typename?: 'OrderOrigin', readonly enum: TOrderOriginEnum, readonly label: string }, readonly warePriceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly sector: { readonly __typename?: 'Sector', readonly name: string } | null, readonly address: { readonly __typename?: 'JsonAddress', readonly original: string | null, readonly state: string | null, readonly city: string | null, readonly venue: string | null, readonly street: string | null, readonly houseNumber: string | null, readonly country: string | null }, readonly onlinePaymentState: { readonly __typename?: 'OrderOnlineState', readonly enum: TOrderOnlineStateEnum } | null, readonly driver: { readonly __typename?: 'UserDeliveringOrder', readonly id: ID, readonly user: { readonly __typename?: 'User', readonly id: ID, readonly initials: string, readonly firstName: string | null, readonly lastName: string | null } } | null, readonly orderPayments: ReadonlyArray<{ readonly __typename?: 'OrderPaymentMethod', readonly id: ID, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly paymentMethod: { readonly __typename?: 'PaymentMethod', readonly id: ID, readonly description: string, readonly paymentType: { readonly __typename?: 'PaymentType', readonly id: ID, readonly enum: TPaymentTypeEnum } } }> };

export type TMFinancialReportCreateVariables = Exact<{
  branchId: Scalars['ID'];
}>;


export type TMFinancialReportCreate = { readonly __typename?: 'Mutation', readonly result: { readonly __typename?: 'FinancialReport', readonly id: ID } };

export type TQClosureHistoryVariables = Exact<{
  branchId: Scalars['ID'];
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
}>;


export type TQClosureHistory = { readonly __typename?: 'Query', readonly history: ReadonlyArray<{ readonly __typename?: 'FinancialReport', readonly id: ID, readonly reportDatetime: Date, readonly reportSequence: number }> };

export type TQClosureReportVariables = Exact<{
  branchId: Scalars['ID'];
  reportId: Scalars['ID'];
  showReport: Scalars['Boolean'];
}>;


export type TQClosureReport = { readonly __typename?: 'Query', readonly lastReport: { readonly __typename?: 'FinancialReport', readonly plainData: string, readonly reportDatetime: Date, readonly reportSequence: number }, readonly report: { readonly __typename?: 'FinancialReport', readonly plainData: string, readonly reportDatetime: Date, readonly reportSequence: number } };

export type TQDriverHistoryVariables = Exact<{
  branchId: Scalars['ID'];
  driverId: Scalars['ID'];
  dateFrom: Scalars['DateTime'];
  dateTo: Scalars['DateTime'];
}>;


export type TQDriverHistory = { readonly __typename?: 'Query', readonly driverRoutes: ReadonlyArray<{ readonly __typename?: 'TransportationDeviceUser', readonly timePositions: ReadonlyArray<{ readonly __typename?: 'GeoPositionWithTimestamp', readonly time: Date, readonly position: { readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number } }> }>, readonly statistics: { readonly __typename?: 'Statistics', readonly finishedOrders: { readonly __typename?: 'StatisticsOrders', readonly driverOrders: ReadonlyArray<{ readonly __typename?: 'Order', readonly id: ID, readonly acceptedAt: Date | null, readonly orderStateCategory: TOrderStateCategoryEnum, readonly deliverAt: Date | null, readonly deliveredAt: Date | null, readonly driverWillPickupAt: Date | null, readonly delayedDeliveryTime: Date | null, readonly isExpressDelivery: boolean, readonly cancelRequested: boolean, readonly gps: { readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number } | null, readonly userDeliveringOrder: { readonly __typename?: 'UserDeliveringOrder', readonly id: ID, readonly assignedAt: Date, readonly deliveryStates: ReadonlyArray<{ readonly __typename?: 'DeliveryStateHistorical', readonly createdAt: Date, readonly deliveryState: TDeliveryStateEnum }> } | null }> } } };

export type TQStatsOrdersVariables = Exact<{
  filter: TInputStatisticCreate;
}>;


export type TQStatsOrders = { readonly __typename?: 'Query', readonly stats: { readonly __typename?: 'Statistics', readonly orderStatisticsPlain: string, readonly finishedOrders: { readonly __typename?: 'StatisticsOrders', readonly finishedCount: number, readonly cancelledCount: number, readonly onlinePayments: { readonly __typename?: 'PriceConverted', readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } }, readonly total: { readonly __typename?: 'PriceConverted', readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } } } } };

export type TQStatsOrdersCountsVariables = Exact<{
  filter: TInputStatisticCreate;
}>;


export type TQStatsOrdersCounts = { readonly __typename?: 'Query', readonly stats: { readonly __typename?: 'Statistics', readonly counts: { readonly __typename?: 'StatisticsOrders', readonly finished: number, readonly cancelled: number } } };

export type TQStatsOrdersListVariables = Exact<{
  filter: TInputStatisticCreate;
  pagination?: InputMaybe<TInputPaginationParams>;
  orderFinalStates?: InputMaybe<ReadonlyArray<TOrderStateEnum>>;
}>;


export type TQStatsOrdersList = { readonly __typename?: 'Query', readonly stats: { readonly __typename?: 'Statistics', readonly orders: { readonly __typename?: 'StatisticsOrders', readonly list: ReadonlyArray<{ readonly __typename?: 'Order', readonly id: ID, readonly createdAt: Date, readonly acceptedAt: Date | null, readonly isPriority: boolean, readonly isFromLoggedInCustomer: boolean, readonly deliverAt: Date | null, readonly deliveredAt: Date | null, readonly driverWillPickupAt: Date | null, readonly delayedDeliveryTime: Date | null, readonly isExpressDelivery: boolean, readonly isPaidWithCard: boolean, readonly orderStateCategory: TOrderStateCategoryEnum, readonly shouldVerifyAge: boolean, readonly cancelRequested: boolean, readonly orderNumber: number | null, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string, readonly oldOrderThreshold: number, readonly allowedCategories: ReadonlyArray<TOrderStateCategoryEnum>, readonly defaultDeliveryTimeEnabled: boolean, readonly defaultPickupTimeEnabled: boolean, readonly usualDeliveryTime: number, readonly usualPickupTime: number }, readonly customer: { readonly __typename?: 'JsonCustomer', readonly firstName: string | null, readonly lastName: string | null, readonly isCancelRisk: boolean | null, readonly defaultPhone: { readonly __typename?: 'Phone', readonly phone: string } | null }, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly formattedValue: string }, readonly orderOrigin: { readonly __typename?: 'OrderOrigin', readonly enum: TOrderOriginEnum, readonly label: string }, readonly warePriceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly sector: { readonly __typename?: 'Sector', readonly name: string } | null, readonly address: { readonly __typename?: 'JsonAddress', readonly original: string | null, readonly state: string | null, readonly city: string | null, readonly venue: string | null, readonly street: string | null, readonly houseNumber: string | null, readonly country: string | null }, readonly onlinePaymentState: { readonly __typename?: 'OrderOnlineState', readonly enum: TOrderOnlineStateEnum } | null, readonly driver: { readonly __typename?: 'UserDeliveringOrder', readonly id: ID, readonly user: { readonly __typename?: 'User', readonly id: ID, readonly initials: string, readonly firstName: string | null, readonly lastName: string | null } } | null, readonly orderPayments: ReadonlyArray<{ readonly __typename?: 'OrderPaymentMethod', readonly id: ID, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly paymentMethod: { readonly __typename?: 'PaymentMethod', readonly id: ID, readonly description: string, readonly paymentType: { readonly __typename?: 'PaymentType', readonly id: ID, readonly enum: TPaymentTypeEnum } } }> }> } } };

export type TQStatsSalesVariables = Exact<{
  filter: TInputStatisticCreate;
}>;


export type TQStatsSales = { readonly __typename?: 'Query', readonly sales: { readonly __typename?: 'Statistics', readonly category: string, readonly daily: string, readonly delivery: string, readonly drivers: string, readonly vat: string, readonly deliveryZone: string, readonly discount: string, readonly fees: string } };

export type TQReportFileVariables = Exact<{
  filter: TInputStatisticCreate;
  reportType: TFileReportTypeEnum;
}>;


export type TQReportFile = { readonly __typename?: 'Query', readonly reportUrl: string };

export type TQReportTypesVariables = Exact<{ [key: string]: never; }>;


export type TQReportTypes = { readonly __typename?: 'Query', readonly reportTypes: ReadonlyArray<{ readonly __typename?: 'FileReportType', readonly id: ID, readonly code: string, readonly enum: TFileReportTypeEnum }> };

export type TFPrintQueue = { readonly __typename?: 'CompanyBranchTrigger', readonly id: ID, readonly companyBranch: { readonly __typename?: 'Company', readonly id: ID, readonly nameLabel: string } | { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly nameLabel: string }, readonly printTemplate: { readonly __typename?: 'PrintTemplate', readonly id: ID, readonly nameLabel: string, readonly printableObject: { readonly __typename?: 'TriggerableType', readonly id: ID, readonly enum: TTriggerableTypeEnum, readonly nameLabel: string } } | { readonly __typename?: 'SmsTemplate' }, readonly printTrigger: { readonly __typename?: 'TriggerConfiguration', readonly id: ID, readonly nameLabel: string, readonly printableObject: { readonly __typename?: 'TriggerableType', readonly id: ID, readonly enum: TTriggerableTypeEnum } } };

export type TFPrintTemplate = { readonly __typename?: 'PrintTemplate', readonly id: ID, readonly nameLabel: string };

export type TFPrintTemplateWithObject = { readonly __typename?: 'PrintTemplate', readonly id: ID, readonly nameLabel: string, readonly printableObject: { readonly __typename?: 'TriggerableType', readonly id: ID, readonly enum: TTriggerableTypeEnum, readonly nameLabel: string } };

export type TFPrintTrigger = { readonly __typename?: 'TriggerConfiguration', readonly id: ID, readonly nameLabel: string, readonly printableObject: { readonly __typename?: 'TriggerableType', readonly id: ID, readonly enum: TTriggerableTypeEnum } };

export type TFPrintableObject = { readonly __typename?: 'TriggerableType', readonly id: ID, readonly enum: TTriggerableTypeEnum, readonly nameLabel: string };

export type TMCreatePrintQueueVariables = Exact<{
  printTriggerId: Scalars['ID'];
  companyBranchId: Scalars['ID'];
  printTemplateId: Scalars['ID'];
}>;


export type TMCreatePrintQueue = { readonly __typename?: 'Mutation', readonly printQueue: { readonly __typename?: 'CompanyBranchTrigger', readonly id: ID, readonly companyBranch: { readonly __typename?: 'Company', readonly id: ID, readonly nameLabel: string } | { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly nameLabel: string }, readonly printTemplate: { readonly __typename?: 'PrintTemplate', readonly id: ID, readonly nameLabel: string, readonly printableObject: { readonly __typename?: 'TriggerableType', readonly id: ID, readonly enum: TTriggerableTypeEnum, readonly nameLabel: string } } | { readonly __typename?: 'SmsTemplate' }, readonly printTrigger: { readonly __typename?: 'TriggerConfiguration', readonly id: ID, readonly nameLabel: string, readonly printableObject: { readonly __typename?: 'TriggerableType', readonly id: ID, readonly enum: TTriggerableTypeEnum } } } };

export type TMDeletePrintQueueVariables = Exact<{
  printQueueId: Scalars['ID'];
}>;


export type TMDeletePrintQueue = { readonly __typename?: 'Mutation', readonly printQueue: { readonly __typename?: 'CompanyBranchTrigger', readonly id: ID } };

export type TMUpdatePrintQueueVariables = Exact<{
  printQueueId: Scalars['ID'];
  printTriggerId?: InputMaybe<Scalars['ID']>;
  printTemplateId?: InputMaybe<Scalars['ID']>;
}>;


export type TMUpdatePrintQueue = { readonly __typename?: 'Mutation', readonly printQueue: { readonly __typename?: 'CompanyBranchTrigger', readonly id: ID, readonly companyBranch: { readonly __typename?: 'Company', readonly id: ID, readonly nameLabel: string } | { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly nameLabel: string }, readonly printTemplate: { readonly __typename?: 'PrintTemplate', readonly id: ID, readonly nameLabel: string, readonly printableObject: { readonly __typename?: 'TriggerableType', readonly id: ID, readonly enum: TTriggerableTypeEnum, readonly nameLabel: string } } | { readonly __typename?: 'SmsTemplate' }, readonly printTrigger: { readonly __typename?: 'TriggerConfiguration', readonly id: ID, readonly nameLabel: string, readonly printableObject: { readonly __typename?: 'TriggerableType', readonly id: ID, readonly enum: TTriggerableTypeEnum } } } };

export type TQPrintQueueConfigsVariables = Exact<{
  companyBranchIds: ReadonlyArray<Scalars['ID']>;
}>;


export type TQPrintQueueConfigs = { readonly __typename?: 'Query', readonly printableObjects: ReadonlyArray<{ readonly __typename?: 'TriggerableType', readonly id: ID, readonly enum: TTriggerableTypeEnum, readonly nameLabel: string }>, readonly printTriggers: ReadonlyArray<{ readonly __typename?: 'TriggerConfiguration', readonly id: ID, readonly nameLabel: string, readonly printableObject: { readonly __typename?: 'TriggerableType', readonly id: ID, readonly enum: TTriggerableTypeEnum } }>, readonly printTemplates: ReadonlyArray<{ readonly __typename?: 'PrintTemplate', readonly id: ID, readonly nameLabel: string, readonly printableObject: { readonly __typename?: 'TriggerableType', readonly id: ID, readonly enum: TTriggerableTypeEnum, readonly nameLabel: string } }> };

export type TQPrintQueuesVariables = Exact<{
  companyBranchIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
}>;


export type TQPrintQueues = { readonly __typename?: 'Query', readonly printQueues: ReadonlyArray<{ readonly __typename?: 'CompanyBranchTrigger', readonly id: ID, readonly printerBindings: ReadonlyArray<{ readonly __typename?: 'CompanyBranchTriggerPrinter', readonly id: ID, readonly targetPcMAC: string, readonly branchPrinter: { readonly __typename?: 'CompanyBranchPrinter', readonly id: ID, readonly printer: { readonly __typename?: 'Printer', readonly id: ID, readonly MAC: string, readonly nameLabel: string, readonly printerType: { readonly __typename?: 'PrinterType', readonly id: ID, readonly enum: TPrinterTypeEnum } } } }>, readonly companyBranch: { readonly __typename?: 'Company', readonly id: ID, readonly nameLabel: string } | { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly nameLabel: string }, readonly printTemplate: { readonly __typename?: 'PrintTemplate', readonly id: ID, readonly nameLabel: string, readonly printableObject: { readonly __typename?: 'TriggerableType', readonly id: ID, readonly enum: TTriggerableTypeEnum, readonly nameLabel: string } } | { readonly __typename?: 'SmsTemplate' }, readonly printTrigger: { readonly __typename?: 'TriggerConfiguration', readonly id: ID, readonly nameLabel: string, readonly printableObject: { readonly __typename?: 'TriggerableType', readonly id: ID, readonly enum: TTriggerableTypeEnum } } }> };

export type TFPrinterQueueLink = { readonly __typename?: 'CompanyBranchTriggerPrinter', readonly id: ID, readonly targetPcMAC: string, readonly branchPrinter: { readonly __typename?: 'CompanyBranchPrinter', readonly id: ID, readonly printer: { readonly __typename?: 'Printer', readonly id: ID, readonly MAC: string, readonly nameLabel: string, readonly printerType: { readonly __typename?: 'PrinterType', readonly id: ID, readonly enum: TPrinterTypeEnum } } } };

export type TMBindPrinterToQueueVariables = Exact<{
  queueId: Scalars['ID'];
  targetPcMAC: Scalars['String'];
  branchPrinterId: Scalars['ID'];
}>;


export type TMBindPrinterToQueue = { readonly __typename?: 'Mutation', readonly queuePrinterBinding: { readonly __typename?: 'CompanyBranchTriggerPrinter', readonly id: ID, readonly targetPcMAC: string, readonly branchPrinter: { readonly __typename?: 'CompanyBranchPrinter', readonly id: ID, readonly printer: { readonly __typename?: 'Printer', readonly id: ID, readonly MAC: string, readonly nameLabel: string, readonly printerType: { readonly __typename?: 'PrinterType', readonly id: ID, readonly enum: TPrinterTypeEnum } } } } };

export type TMUnbindPrinterFromQueueVariables = Exact<{
  bindingId: Scalars['ID'];
}>;


export type TMUnbindPrinterFromQueue = { readonly __typename?: 'Mutation', readonly queuePrinterBinding: { readonly __typename?: 'CompanyBranchTriggerPrinter', readonly id: ID } };

export type TFPrinter = { readonly __typename?: 'Printer', readonly id: ID, readonly MAC: string, readonly nameLabel: string, readonly printerType: { readonly __typename?: 'PrinterType', readonly id: ID, readonly enum: TPrinterTypeEnum, readonly nameLabel: string }, readonly branchPrinters: ReadonlyArray<{ readonly __typename?: 'CompanyBranchPrinter', readonly id: ID, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly nameLabel: string } }> };

export type TMRegisterPrinterVariables = Exact<{
  printerMAC: Scalars['String'];
  printerName: Scalars['String'];
  companyBranchIds: ReadonlyArray<Scalars['ID']>;
  printerType: TPrinterTypeEnum;
}>;


export type TMRegisterPrinter = { readonly __typename?: 'Mutation', readonly printer: { readonly __typename?: 'Printer', readonly id: ID, readonly MAC: string, readonly nameLabel: string, readonly printerType: { readonly __typename?: 'PrinterType', readonly id: ID, readonly enum: TPrinterTypeEnum, readonly nameLabel: string }, readonly branchPrinters: ReadonlyArray<{ readonly __typename?: 'CompanyBranchPrinter', readonly id: ID, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly nameLabel: string } }> } };

export type TMUnregisterPrinterVariables = Exact<{
  printerId: Scalars['ID'];
}>;


export type TMUnregisterPrinter = { readonly __typename?: 'Mutation', readonly printer: { readonly __typename?: 'Printer', readonly id: ID } };

export type TMUpdatePrinterVariables = Exact<{
  printerId: Scalars['ID'];
  printerMAC?: InputMaybe<Scalars['String']>;
  printerName?: InputMaybe<Scalars['String']>;
  companyBranchIds: ReadonlyArray<Scalars['ID']>;
  printerType?: InputMaybe<TPrinterTypeEnum>;
}>;


export type TMUpdatePrinter = { readonly __typename?: 'Mutation', readonly printer: { readonly __typename?: 'Printer', readonly id: ID, readonly MAC: string, readonly nameLabel: string, readonly printerType: { readonly __typename?: 'PrinterType', readonly id: ID, readonly enum: TPrinterTypeEnum, readonly nameLabel: string }, readonly branchPrinters: ReadonlyArray<{ readonly __typename?: 'CompanyBranchPrinter', readonly id: ID, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly nameLabel: string } }> } };

export type TQPrinterConfigsVariables = Exact<{ [key: string]: never; }>;


export type TQPrinterConfigs = { readonly __typename?: 'Query', readonly printerTypes: ReadonlyArray<{ readonly __typename?: 'PrinterType', readonly id: ID, readonly enum: TPrinterTypeEnum, readonly nameLabel: string }> };

export type TQRegisteredPrintersVariables = Exact<{
  companyBranchIds: ReadonlyArray<Scalars['ID']>;
}>;


export type TQRegisteredPrinters = { readonly __typename?: 'Query', readonly printers: ReadonlyArray<{ readonly __typename?: 'Printer', readonly id: ID, readonly MAC: string, readonly nameLabel: string, readonly printerType: { readonly __typename?: 'PrinterType', readonly id: ID, readonly enum: TPrinterTypeEnum, readonly nameLabel: string }, readonly branchPrinters: ReadonlyArray<{ readonly __typename?: 'CompanyBranchPrinter', readonly id: ID, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly nameLabel: string } }> }> };

export type TMUserMenuLanguageVariables = Exact<{
  userId: Scalars['ID'];
  lang: TLanguageEnum;
}>;


export type TMUserMenuLanguage = { readonly __typename?: 'Mutation', readonly updateUser: { readonly __typename?: 'User', readonly id: ID, readonly language: { readonly __typename?: 'Language', readonly enum: TLanguageEnum } } };

export type TQUserMenuLanguagesVariables = Exact<{ [key: string]: never; }>;


export type TQUserMenuLanguages = { readonly __typename?: 'Query', readonly languages: ReadonlyArray<{ readonly __typename?: 'Language', readonly code: string, readonly enum: TLanguageEnum, readonly rawCode: string }> };

export type TMCreateTransfersVariables = Exact<{
  targetBranch: Scalars['ID'];
  transfers: ReadonlyArray<TInputStockTransferCreate>;
}>;


export type TMCreateTransfers = { readonly __typename?: 'Mutation', readonly createStockItemTransfers: ReadonlyArray<{ readonly __typename?: 'StockItem', readonly id: ID, readonly quantity: number }> };

export type TQMenuStockDepositVariables = Exact<{
  branchId: Scalars['ID'];
}>;


export type TQMenuStockDeposit = { readonly __typename?: 'Query', readonly stockItems: ReadonlyArray<{ readonly __typename?: 'StockItem', readonly id: ID, readonly code: string, readonly plu: string | null, readonly note: string, readonly quantity: number, readonly nameLabel: string, readonly wareUnit: { readonly __typename?: 'WareUnit', readonly id: ID, readonly enum: TWareUnitEnum, readonly code: string } }> };

export type TQStockForTransferVariables = Exact<{
  branchId: Scalars['ID'];
}>;


export type TQStockForTransfer = { readonly __typename?: 'Query', readonly stockItems: ReadonlyArray<{ readonly __typename?: 'StockItem', readonly id: ID, readonly code: string, readonly plu: string | null, readonly allowNegativeValue: boolean, readonly quantity: number, readonly nameLabel: string, readonly wareUnit: { readonly __typename?: 'WareUnit', readonly id: ID, readonly code: string } }> };

export type TQStockStatsVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type TQStockStats = { readonly __typename?: 'Query', readonly stockItems: ReadonlyArray<{ readonly __typename?: 'StockItem', readonly id: ID, readonly code: string, readonly plu: string | null, readonly quantity: number, readonly nameLabel: string, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string }, readonly wareUnit: { readonly __typename?: 'WareUnit', readonly id: ID, readonly code: string } }> };

export type TFStockInventory = { readonly __typename?: 'StockInventory', readonly finishedAt: Date | null, readonly note: string | null, readonly id: ID, readonly createdAt: Date, readonly items: ReadonlyArray<{ readonly __typename?: 'StockInventoryItem', readonly id: ID, readonly originalQuantity: number, readonly finalQuantity: number | null, readonly stockItemChangeType: { readonly __typename?: 'StockInventoryItemChangeType', readonly id: ID, readonly enum: TStockInventoryItemChangeTypeEnum, readonly code: string } | null, readonly stockItem: { readonly __typename?: 'StockItem', readonly id: ID, readonly code: string, readonly label: string, readonly wareUnit: { readonly __typename?: 'WareUnit', readonly id: ID, readonly enum: TWareUnitEnum, readonly code: string } } }>, readonly user: { readonly __typename?: 'User', readonly id: ID, readonly initials: string, readonly firstName: string | null, readonly lastName: string | null } };

export type TFStockInventoryItem = { readonly __typename?: 'StockInventoryItem', readonly id: ID, readonly originalQuantity: number, readonly finalQuantity: number | null, readonly stockItemChangeType: { readonly __typename?: 'StockInventoryItemChangeType', readonly id: ID, readonly enum: TStockInventoryItemChangeTypeEnum, readonly code: string } | null, readonly stockItem: { readonly __typename?: 'StockItem', readonly id: ID, readonly code: string, readonly label: string, readonly wareUnit: { readonly __typename?: 'WareUnit', readonly id: ID, readonly enum: TWareUnitEnum, readonly code: string } } };

export type TFStockInventorySummary = { readonly __typename?: 'StockInventory', readonly id: ID, readonly createdAt: Date, readonly user: { readonly __typename?: 'User', readonly id: ID, readonly initials: string, readonly firstName: string | null, readonly lastName: string | null } };

export type TMCancelStockInventoryVariables = Exact<{
  inventoryId: Scalars['ID'];
}>;


export type TMCancelStockInventory = { readonly __typename?: 'Mutation', readonly destroyStockInventory: { readonly __typename?: 'StockInventory', readonly id: ID } };

export type TMCreateStockInventoryVariables = Exact<{
  branchId: Scalars['ID'];
}>;


export type TMCreateStockInventory = { readonly __typename?: 'Mutation', readonly createStockInventory: { readonly __typename?: 'StockInventory', readonly finishedAt: Date | null, readonly note: string | null, readonly id: ID, readonly createdAt: Date, readonly items: ReadonlyArray<{ readonly __typename?: 'StockInventoryItem', readonly id: ID, readonly originalQuantity: number, readonly finalQuantity: number | null, readonly stockItemChangeType: { readonly __typename?: 'StockInventoryItemChangeType', readonly id: ID, readonly enum: TStockInventoryItemChangeTypeEnum, readonly code: string } | null, readonly stockItem: { readonly __typename?: 'StockItem', readonly id: ID, readonly code: string, readonly label: string, readonly wareUnit: { readonly __typename?: 'WareUnit', readonly id: ID, readonly enum: TWareUnitEnum, readonly code: string } } }>, readonly user: { readonly __typename?: 'User', readonly id: ID, readonly initials: string, readonly firstName: string | null, readonly lastName: string | null } } };

export type TMFinishStockInventoryVariables = Exact<{
  inventoryId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
}>;


export type TMFinishStockInventory = { readonly __typename?: 'Mutation', readonly finishStockInventory: { readonly __typename?: 'StockInventory', readonly id: ID } };

export type TMUpdateStockInventoryItemVariables = Exact<{
  itemId: Scalars['ID'];
  actualQuantity: Scalars['Float'];
  varianceReason?: InputMaybe<TStockInventoryItemChangeTypeEnum>;
}>;


export type TMUpdateStockInventoryItem = { readonly __typename?: 'Mutation', readonly updateStockInventoryItem: { readonly __typename?: 'StockInventoryItem', readonly id: ID } };

export type TQStockInventoryVariables = Exact<{
  inventoryId: Scalars['ID'];
}>;


export type TQStockInventory = { readonly __typename?: 'Query', readonly stockInventory: { readonly __typename?: 'StockInventory', readonly finishedAt: Date | null, readonly note: string | null, readonly id: ID, readonly createdAt: Date, readonly items: ReadonlyArray<{ readonly __typename?: 'StockInventoryItem', readonly id: ID, readonly originalQuantity: number, readonly finalQuantity: number | null, readonly stockItemChangeType: { readonly __typename?: 'StockInventoryItemChangeType', readonly id: ID, readonly enum: TStockInventoryItemChangeTypeEnum, readonly code: string } | null, readonly stockItem: { readonly __typename?: 'StockItem', readonly id: ID, readonly code: string, readonly label: string, readonly wareUnit: { readonly __typename?: 'WareUnit', readonly id: ID, readonly enum: TWareUnitEnum, readonly code: string } } }>, readonly user: { readonly __typename?: 'User', readonly id: ID, readonly initials: string, readonly firstName: string | null, readonly lastName: string | null } } };

export type TQStockInventoryVarianceReasonsVariables = Exact<{ [key: string]: never; }>;


export type TQStockInventoryVarianceReasons = { readonly __typename?: 'Query', readonly varianceReasons: ReadonlyArray<{ readonly __typename?: 'StockInventoryItemChangeType', readonly id: ID, readonly enum: TStockInventoryItemChangeTypeEnum, readonly code: string }> };

export type TQTakenStockInventoriesVariables = Exact<{
  branchId: Scalars['ID'];
  dateFrom: Scalars['DateTime'];
  dateTo: Scalars['DateTime'];
}>;


export type TQTakenStockInventories = { readonly __typename?: 'Query', readonly stockInventories: ReadonlyArray<{ readonly __typename?: 'StockInventory', readonly id: ID, readonly createdAt: Date, readonly user: { readonly __typename?: 'User', readonly id: ID, readonly initials: string, readonly firstName: string | null, readonly lastName: string | null } }> };

export type TQUnfinishedStockInventoryVariables = Exact<{
  branchId: Scalars['ID'];
}>;


export type TQUnfinishedStockInventory = { readonly __typename?: 'Query', readonly stockInventories: ReadonlyArray<{ readonly __typename?: 'StockInventory', readonly finishedAt: Date | null, readonly note: string | null, readonly id: ID, readonly createdAt: Date, readonly items: ReadonlyArray<{ readonly __typename?: 'StockInventoryItem', readonly id: ID, readonly originalQuantity: number, readonly finalQuantity: number | null, readonly stockItemChangeType: { readonly __typename?: 'StockInventoryItemChangeType', readonly id: ID, readonly enum: TStockInventoryItemChangeTypeEnum, readonly code: string } | null, readonly stockItem: { readonly __typename?: 'StockItem', readonly id: ID, readonly code: string, readonly label: string, readonly wareUnit: { readonly __typename?: 'WareUnit', readonly id: ID, readonly enum: TWareUnitEnum, readonly code: string } } }>, readonly user: { readonly __typename?: 'User', readonly id: ID, readonly initials: string, readonly firstName: string | null, readonly lastName: string | null } }> };

export type TFZone = { readonly __typename?: 'Zone', readonly id: ID, readonly name: string, readonly enabled: boolean, readonly priority: number, readonly deliveryTimeDeviation: number, readonly zoneColor: { readonly __typename?: 'ZoneColor', readonly id: ID, readonly code: string, readonly color: string }, readonly zoneType: { readonly __typename?: 'ZoneType', readonly enum: TZoneTypeEnum }, readonly geoPolygon: ReadonlyArray<{ readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number }> };

export type TFZoneInForm = { readonly __typename?: 'Zone', readonly enabled: boolean, readonly id: ID, readonly name: string, readonly priority: number, readonly deliveryTimeDeviation: number, readonly priceRangeRules: ReadonlyArray<{ readonly __typename?: 'ZonePriceRangeRule', readonly toPrice: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly minimalOrderPrice: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly defaultDeliveryTime: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } }, readonly zoneColor: { readonly __typename?: 'ZoneColor', readonly id: ID, readonly code: string, readonly color: string }, readonly zoneType: { readonly __typename?: 'ZoneType', readonly enum: TZoneTypeEnum }, readonly geoPolygon: ReadonlyArray<{ readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number }> };

export type TFZoneInList = { readonly __typename?: 'Zone', readonly id: ID, readonly name: string, readonly enabled: boolean, readonly priority: number, readonly deliveryTimeDeviation: number, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly brand: { readonly __typename?: 'Company', readonly id: ID } }, readonly zoneColor: { readonly __typename?: 'ZoneColor', readonly id: ID, readonly code: string, readonly color: string }, readonly zoneType: { readonly __typename?: 'ZoneType', readonly enum: TZoneTypeEnum }, readonly geoPolygon: ReadonlyArray<{ readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number }> };

export type TFZonePriceRange = { readonly __typename?: 'ZonePriceRangeRule', readonly toPrice: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } };

export type TMZoneCreateVariables = Exact<{
  branchId: Scalars['ID'];
  points?: InputMaybe<ReadonlyArray<TInputGeoPointCreate>>;
  type: TZoneTypeEnum;
}>;


export type TMZoneCreate = { readonly __typename?: 'Mutation', readonly createZone: { readonly __typename?: 'Zone', readonly id: ID, readonly name: string, readonly enabled: boolean, readonly priority: number, readonly deliveryTimeDeviation: number, readonly zoneColor: { readonly __typename?: 'ZoneColor', readonly id: ID, readonly code: string, readonly color: string }, readonly zoneType: { readonly __typename?: 'ZoneType', readonly enum: TZoneTypeEnum }, readonly geoPolygon: ReadonlyArray<{ readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number }> } };

export type TMZoneDeleteVariables = Exact<{
  zoneId: Scalars['ID'];
}>;


export type TMZoneDelete = { readonly __typename?: 'Mutation', readonly deleteZone: { readonly __typename?: 'Zone', readonly id: ID } };

export type TMZoneUpdateVariables = Exact<{
  zoneId: Scalars['ID'];
  update: TInputZoneUpdate;
}>;


export type TMZoneUpdate = { readonly __typename?: 'Mutation', readonly updateZone: { readonly __typename?: 'Zone', readonly id: ID, readonly name: string, readonly enabled: boolean, readonly priority: number, readonly deliveryTimeDeviation: number, readonly zoneColor: { readonly __typename?: 'ZoneColor', readonly id: ID, readonly code: string, readonly color: string }, readonly zoneType: { readonly __typename?: 'ZoneType', readonly enum: TZoneTypeEnum }, readonly geoPolygon: ReadonlyArray<{ readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number }> } };

export type TMZoneUpdatePriorityVariables = Exact<{
  zoneId: Scalars['ID'];
  offset: Scalars['Int'];
}>;


export type TMZoneUpdatePriority = { readonly __typename?: 'Mutation', readonly updateZonePriority: ReadonlyArray<{ readonly __typename?: 'Zone', readonly id: ID, readonly priority: number }> };

export type TQZoneColorsVariables = Exact<{ [key: string]: never; }>;


export type TQZoneColors = { readonly __typename?: 'Query', readonly zoneColors: ReadonlyArray<{ readonly __typename?: 'ZoneColor', readonly id: ID, readonly code: string, readonly color: string }> };

export type TQZoneFormVariables = Exact<{
  zoneId: Scalars['ID'];
}>;


export type TQZoneForm = { readonly __typename?: 'Query', readonly zone: { readonly __typename?: 'Zone', readonly enabled: boolean, readonly id: ID, readonly name: string, readonly priority: number, readonly deliveryTimeDeviation: number, readonly priceRangeRules: ReadonlyArray<{ readonly __typename?: 'ZonePriceRangeRule', readonly toPrice: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number } }>, readonly minimalOrderPrice: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly defaultDeliveryTime: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } }, readonly zoneColor: { readonly __typename?: 'ZoneColor', readonly id: ID, readonly code: string, readonly color: string }, readonly zoneType: { readonly __typename?: 'ZoneType', readonly enum: TZoneTypeEnum }, readonly geoPolygon: ReadonlyArray<{ readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number }> } };

export type TQZoneListVariables = Exact<{
  branches: ReadonlyArray<Scalars['ID']>;
}>;


export type TQZoneList = { readonly __typename?: 'Query', readonly zones: ReadonlyArray<{ readonly __typename?: 'Zone', readonly id: ID, readonly name: string, readonly enabled: boolean, readonly priority: number, readonly deliveryTimeDeviation: number, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly brand: { readonly __typename?: 'Company', readonly id: ID } }, readonly zoneColor: { readonly __typename?: 'ZoneColor', readonly id: ID, readonly code: string, readonly color: string }, readonly zoneType: { readonly __typename?: 'ZoneType', readonly enum: TZoneTypeEnum }, readonly geoPolygon: ReadonlyArray<{ readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number }> }> };

export type TFActiveExternalDelivery = { readonly __typename?: 'ExternalDelivery', readonly id: ID, readonly seen: boolean, readonly failReason: string | null, readonly deliveryNumber: string | null, readonly status: { readonly __typename?: 'ExternalDeliveryState', readonly enum: TExternalDeliveryStateEnum, readonly label: string }, readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly orderStateCategory: TOrderStateCategoryEnum, readonly deliverAt: Date | null, readonly deliveredAt: Date | null, readonly driverWillPickupAt: Date | null, readonly delayedDeliveryTime: Date | null, readonly acceptedAt: Date | null, readonly isExpressDelivery: boolean, readonly cancelRequested: boolean, readonly orderNumber: number | null, readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string } }, readonly provider: { readonly __typename?: 'ExternalDeliveryProvider', readonly enum: TExternalDeliveryProviderEnum, readonly label: string } };

export type TFOrderForExternalDelivery = { readonly __typename?: 'Order', readonly id: ID, readonly orderStateCategory: TOrderStateCategoryEnum, readonly deliverAt: Date | null, readonly deliveredAt: Date | null, readonly driverWillPickupAt: Date | null, readonly delayedDeliveryTime: Date | null, readonly acceptedAt: Date | null, readonly isExpressDelivery: boolean, readonly cancelRequested: boolean, readonly orderNumber: number | null, readonly availableExternalDeliveries: ReadonlyArray<{ readonly __typename?: 'ExternalDeliveryProvider', readonly code: string, readonly enum: TExternalDeliveryProviderEnum }>, readonly warePriceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly sector: { readonly __typename?: 'Sector', readonly name: string } | null, readonly address: { readonly __typename?: 'JsonAddress', readonly original: string | null, readonly state: string | null, readonly city: string | null, readonly venue: string | null, readonly street: string | null, readonly houseNumber: string | null, readonly country: string | null } };

export type TMAcknowledgeExternalDeliveryFailVariables = Exact<{
  deliveryId: Scalars['ID'];
}>;


export type TMAcknowledgeExternalDeliveryFail = { readonly __typename?: 'Mutation', readonly delivery: { readonly __typename?: 'ExternalDelivery', readonly id: ID } | null };

export type TMCreateExternalDeliveryVariables = Exact<{
  orderId: Scalars['ID'];
  deliveryProvider: TExternalDeliveryProviderEnum;
  closestPickupTime?: InputMaybe<Scalars['DateTime']>;
}>;


export type TMCreateExternalDelivery = { readonly __typename?: 'Mutation', readonly isSuccess: string | null };

export type TQActiveExternalDeliveriesVariables = Exact<{
  branchIds: ReadonlyArray<Scalars['ID']>;
}>;


export type TQActiveExternalDeliveries = { readonly __typename?: 'Query', readonly externalDeliveries: ReadonlyArray<{ readonly __typename?: 'ExternalDelivery', readonly id: ID, readonly seen: boolean, readonly failReason: string | null, readonly deliveryNumber: string | null, readonly status: { readonly __typename?: 'ExternalDeliveryState', readonly enum: TExternalDeliveryStateEnum, readonly label: string }, readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly orderStateCategory: TOrderStateCategoryEnum, readonly deliverAt: Date | null, readonly deliveredAt: Date | null, readonly driverWillPickupAt: Date | null, readonly delayedDeliveryTime: Date | null, readonly acceptedAt: Date | null, readonly isExpressDelivery: boolean, readonly cancelRequested: boolean, readonly orderNumber: number | null, readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string } }, readonly provider: { readonly __typename?: 'ExternalDeliveryProvider', readonly enum: TExternalDeliveryProviderEnum, readonly label: string } }> };

export type TQEstimateExternalDeliveryVariables = Exact<{
  orderId: Scalars['ID'];
  deliveryProvider: TExternalDeliveryProviderEnum;
}>;


export type TQEstimateExternalDelivery = { readonly __typename?: 'Query', readonly estimates: { readonly __typename?: 'ExternalDeliveryEstimate', readonly errorMessage: string | null, readonly rawErrorMessage: string | null, readonly estimatedPickupTime: Date | null, readonly estimatedDeliveryTime: Date | null, readonly estimatedDeliveryFee: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string } | null } };

export type TSActiveExternalDeliveriesVariables = Exact<{
  branchIds: ReadonlyArray<Scalars['ID']>;
}>;


export type TSActiveExternalDeliveries = { readonly __typename?: 'Subscription', readonly update: { readonly __typename?: 'ExternalDeliveryUpdateSubscription', readonly id: ID, readonly externalDelivery: { readonly __typename?: 'ExternalDelivery', readonly id: ID, readonly seen: boolean, readonly failReason: string | null, readonly deliveryNumber: string | null, readonly status: { readonly __typename?: 'ExternalDeliveryState', readonly enum: TExternalDeliveryStateEnum, readonly label: string }, readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly orderStateCategory: TOrderStateCategoryEnum, readonly deliverAt: Date | null, readonly deliveredAt: Date | null, readonly driverWillPickupAt: Date | null, readonly delayedDeliveryTime: Date | null, readonly acceptedAt: Date | null, readonly isExpressDelivery: boolean, readonly cancelRequested: boolean, readonly orderNumber: number | null, readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string } }, readonly provider: { readonly __typename?: 'ExternalDeliveryProvider', readonly enum: TExternalDeliveryProviderEnum, readonly label: string } } | null } };

export type TFOrderForHandoverTime = { readonly __typename?: 'Order', readonly id: ID, readonly deliverAt: Date | null, readonly deliveredAt: Date | null, readonly driverWillPickupAt: Date | null, readonly delayedDeliveryTime: Date | null, readonly acceptedAt: Date | null, readonly isExpressDelivery: boolean, readonly cancelRequested: boolean };

export type TFNotification = { readonly __typename?: 'InAppNotification', readonly id: ID, readonly title: string, readonly content: string, readonly url: string | null, readonly isRead: boolean, readonly createdAt: Date };

export type TMUpdateNotificationsVariables = Exact<{
  ids: ReadonlyArray<Scalars['ID']>;
  isRead: Scalars['Boolean'];
}>;


export type TMUpdateNotifications = { readonly __typename?: 'Mutation', readonly updatedNotifications: ReadonlyArray<{ readonly __typename?: 'InAppNotification', readonly id: ID }> };

export type TQNotificationsVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type TQNotifications = { readonly __typename?: 'Query', readonly user: { readonly __typename?: 'User', readonly id: ID, readonly unreadInAppNotificationsCount: number, readonly inAppNotifications: { readonly __typename?: 'InAppNotificationConnection', readonly news: ReadonlyArray<{ readonly __typename?: 'InAppNotificationEdge', readonly node: { readonly __typename?: 'InAppNotification', readonly id: ID, readonly title: string, readonly content: string, readonly url: string | null, readonly isRead: boolean, readonly createdAt: Date } | null } | null> | null } } };

export type TFOrderDriver = { readonly __typename?: 'Order', readonly id: ID, readonly driver: { readonly __typename?: 'UserDeliveringOrder', readonly id: ID, readonly user: { readonly __typename?: 'User', readonly id: ID, readonly initials: string, readonly firstName: string | null, readonly lastName: string | null } } | null };

export type TFOrderForCancelAction = { readonly __typename?: 'Order', readonly id: ID, readonly canRequestCancel: boolean, readonly canBeCanceled: boolean, readonly orderOrigin: { readonly __typename?: 'OrderOrigin', readonly enum: TOrderOriginEnum }, readonly orderStates: ReadonlyArray<{ readonly __typename?: 'OrderState', readonly enum: TOrderStateEnum }> };

export type TFOrderPaymentMethods = { readonly __typename?: 'Order', readonly paymentMethods: ReadonlyArray<{ readonly __typename?: 'PaymentMethod', readonly id: ID, readonly description: string, readonly paymentType: { readonly __typename?: 'PaymentType', readonly id: ID, readonly enum: TPaymentTypeEnum }, readonly paymentGate: { readonly __typename?: 'PaymentGate', readonly id: ID, readonly enum: TPaymentGateEnum, readonly code: string } }> };

export type TMAssignOrderDriverVariables = Exact<{
  driverId: Scalars['ID'];
  orderId: Scalars['ID'];
}>;


export type TMAssignOrderDriver = { readonly __typename?: 'Mutation', readonly result: { readonly __typename?: 'UserDeliveringOrder', readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly driver: { readonly __typename?: 'UserDeliveringOrder', readonly id: ID, readonly user: { readonly __typename?: 'User', readonly id: ID, readonly initials: string, readonly firstName: string | null, readonly lastName: string | null } } | null } } };

export type TMChangeOrderHandoverTimeVariables = Exact<{
  orderId: Scalars['ID'];
  minutes: Scalars['Int'];
}>;


export type TMChangeOrderHandoverTime = { readonly __typename?: 'Mutation', readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly deliverAt: Date | null } };

export type TMChangePaymentMethodVariables = Exact<{
  orderId: Scalars['ID'];
  paymentMethodId: Scalars['ID'];
}>;


export type TMChangePaymentMethod = { readonly __typename?: 'Mutation', readonly updateOrderPaymentMethod: { readonly __typename?: 'Order', readonly id: ID, readonly paymentMethods: ReadonlyArray<{ readonly __typename?: 'PaymentMethod', readonly id: ID, readonly description: string, readonly paymentType: { readonly __typename?: 'PaymentType', readonly id: ID, readonly enum: TPaymentTypeEnum }, readonly paymentGate: { readonly __typename?: 'PaymentGate', readonly id: ID, readonly enum: TPaymentGateEnum, readonly code: string } }> } };

export type TMOrderChangeToPickupVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type TMOrderChangeToPickup = { readonly __typename?: 'Mutation', readonly updateOrderDeliveryToPickup: { readonly __typename?: 'Order', readonly id: ID, readonly warePriceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null } };

export type TMRemoveOrderDriverVariables = Exact<{
  orderDriverId: Scalars['ID'];
}>;


export type TMRemoveOrderDriver = { readonly __typename?: 'Mutation', readonly destroyUserDeliveringOrder: { readonly __typename?: 'UserDeliveringOrder', readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly driver: { readonly __typename?: 'UserDeliveringOrder', readonly id: ID, readonly user: { readonly __typename?: 'User', readonly id: ID, readonly initials: string, readonly firstName: string | null, readonly lastName: string | null } } | null } } };

export type TMRequestOrderCancelVariables = Exact<{
  orderId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  cancelReason: TStornoRequestTypeEnum;
}>;


export type TMRequestOrderCancel = { readonly __typename?: 'Mutation', readonly requestCancelOrder: { readonly __typename?: 'Order', readonly id: ID } };

export type TMTransferOrderVariables = Exact<{
  orderId: Scalars['ID'];
  branchId: Scalars['ID'];
}>;


export type TMTransferOrder = { readonly __typename?: 'Mutation', readonly transferOrder: { readonly __typename?: 'Order', readonly id: ID, readonly transferredFromOrder: { readonly __typename?: 'Order', readonly id: ID, readonly orderStateCategory: TOrderStateCategoryEnum } | null } };

export type TQCancelReasonsVariables = Exact<{ [key: string]: never; }>;


export type TQCancelReasons = { readonly __typename?: 'Query', readonly cancelReasons: ReadonlyArray<{ readonly __typename?: 'StornoRequestType', readonly id: ID, readonly enum: TStornoRequestTypeEnum, readonly needComment: boolean, readonly label: string }> };

export type TQOrderDriversVariables = Exact<{
  orderId: Scalars['ID'];
  branchId: ReadonlyArray<Scalars['ID']>;
}>;


export type TQOrderDrivers = { readonly __typename?: 'Query', readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly driver: { readonly __typename?: 'UserDeliveringOrder', readonly id: ID, readonly user: { readonly __typename?: 'User', readonly id: ID, readonly initials: string, readonly firstName: string | null, readonly lastName: string | null } } | null }, readonly drivers: ReadonlyArray<{ readonly __typename?: 'User', readonly id: ID, readonly initials: string, readonly firstName: string | null, readonly lastName: string | null }> };

export type TQOrderForCancelRequestVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type TQOrderForCancelRequest = { readonly __typename?: 'Query', readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly cancelRequested: boolean } };

export type TQOrderStateVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type TQOrderState = { readonly __typename?: 'Query', readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly currentUserCanFinishOrder: boolean, readonly canRequestCancel: boolean, readonly canBeCanceled: boolean, readonly availableExternalDeliveries: ReadonlyArray<{ readonly __typename?: 'ExternalDeliveryProvider', readonly code: string, readonly enum: TExternalDeliveryProviderEnum }>, readonly driver: { readonly __typename?: 'UserDeliveringOrder', readonly id: ID } | null, readonly paymentMethods: ReadonlyArray<{ readonly __typename?: 'PaymentMethod', readonly id: ID, readonly description: string, readonly paymentType: { readonly __typename?: 'PaymentType', readonly id: ID, readonly enum: TPaymentTypeEnum }, readonly paymentGate: { readonly __typename?: 'PaymentGate', readonly id: ID, readonly enum: TPaymentGateEnum, readonly code: string } }>, readonly orderOrigin: { readonly __typename?: 'OrderOrigin', readonly enum: TOrderOriginEnum }, readonly orderStates: ReadonlyArray<{ readonly __typename?: 'OrderState', readonly enum: TOrderStateEnum }> } };

export type TFOrderExtraFees = { readonly __typename?: 'Order', readonly extraFees: ReadonlyArray<{ readonly __typename?: 'ExtraFee', readonly code: TExtraFeeType, readonly name: string, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string } }>, readonly collectFromCustomer: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string } };

export type TFOrderForTimeline = { readonly __typename?: 'Order', readonly stateChanges: ReadonlyArray<{ readonly __typename?: 'OrderStateCategoryRelation', readonly createdAt: Date, readonly state: TOrderStateCategoryEnum }> };

export type TFOrderOrigin = { readonly __typename?: 'Order', readonly orderOrigin: { readonly __typename?: 'OrderOrigin', readonly enum: TOrderOriginEnum, readonly label: string } };

export type TFOrderPayments = { readonly __typename?: 'Order', readonly orderPayments: ReadonlyArray<{ readonly __typename?: 'OrderPaymentMethod', readonly id: ID, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly paymentMethod: { readonly __typename?: 'PaymentMethod', readonly id: ID, readonly description: string, readonly paymentType: { readonly __typename?: 'PaymentType', readonly id: ID, readonly enum: TPaymentTypeEnum } } }> };

export type TFOrderTotals = { readonly __typename?: 'Order', readonly totalSum: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string }, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string }, readonly coverPrice: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string }, readonly totalDiscount: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string }, readonly tip: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string }, readonly extraCharge: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string }, readonly serviceFee: { readonly __typename?: 'OrderServiceFee', readonly amount: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string } } | null, readonly totalVouchers: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string }, readonly expressDelivery: { readonly __typename?: 'OrderExpressDelivery', readonly expressFee: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string } } | null, readonly minOrderFee: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string }, readonly orderPayments: ReadonlyArray<{ readonly __typename?: 'OrderPaymentMethod', readonly id: ID, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly paymentMethod: { readonly __typename?: 'PaymentMethod', readonly id: ID, readonly description: string, readonly paymentType: { readonly __typename?: 'PaymentType', readonly id: ID, readonly enum: TPaymentTypeEnum } } }> };

export type TQOrderDetailsVariables = Exact<{
  orderId: Scalars['ID'];
  withRating: Scalars['Boolean'];
}>;


export type TQOrderDetails = { readonly __typename?: 'Query', readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly note: string | null, readonly allAppliedRules: ReadonlyArray<string>, readonly customerOrdersCountCurrent: number, readonly customerOrdersCountTotal: number, readonly zone: { readonly __typename?: 'Zone', readonly name: string } | null, readonly customer: { readonly __typename?: 'JsonCustomer', readonly isCancelRisk: boolean | null, readonly emails: ReadonlyArray<{ readonly __typename?: 'Email', readonly email: string, readonly description: string | null, readonly default: boolean }>, readonly phones: ReadonlyArray<{ readonly __typename?: 'Phone', readonly phone: string, readonly description: string | null, readonly default: boolean }> }, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly note: string | null, readonly sideDishes: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly note: string | null, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly nameLabel: string }, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string } }>, readonly recipe: { readonly __typename?: 'Recipe', readonly id: ID, readonly code: string, readonly nameLabel: string }, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string } }>, readonly transferredFromOrder: { readonly __typename?: 'Order', readonly id: ID, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string } } | null, readonly foodoraRecord: { readonly __typename?: 'FoodoraRecordGlType', readonly isDeliveredByFoodora: boolean, readonly minFoodoraPickupTime: Date | null, readonly maxFoodoraPickupTime: Date | null } | null, readonly orderOrigin: { readonly __typename?: 'OrderOrigin', readonly enum: TOrderOriginEnum, readonly label: string }, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string }, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string }, readonly coverPrice: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string }, readonly totalDiscount: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string }, readonly tip: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string }, readonly extraCharge: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string }, readonly serviceFee: { readonly __typename?: 'OrderServiceFee', readonly amount: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string } } | null, readonly totalVouchers: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string }, readonly expressDelivery: { readonly __typename?: 'OrderExpressDelivery', readonly expressFee: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string } } | null, readonly minOrderFee: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string }, readonly stateChanges: ReadonlyArray<{ readonly __typename?: 'OrderStateCategoryRelation', readonly createdAt: Date, readonly state: TOrderStateCategoryEnum }>, readonly extraFees: ReadonlyArray<{ readonly __typename?: 'ExtraFee', readonly code: TExtraFeeType, readonly name: string, readonly price: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string } }>, readonly collectFromCustomer: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string }, readonly ratings: ReadonlyArray<{ readonly __typename?: 'OrderRating', readonly id: ID, readonly value: number | null, readonly description: string | null, readonly type: { readonly __typename?: 'OrderRatingType', readonly enum: TOrderRatingTypeEnum, readonly code: string } }> | null, readonly orderPayments: ReadonlyArray<{ readonly __typename?: 'OrderPaymentMethod', readonly id: ID, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly paymentMethod: { readonly __typename?: 'PaymentMethod', readonly id: ID, readonly description: string, readonly paymentType: { readonly __typename?: 'PaymentType', readonly id: ID, readonly enum: TPaymentTypeEnum } } }> } };

export type TMRemoveOrderGroupDriverVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type TMRemoveOrderGroupDriver = { readonly __typename?: 'Mutation', readonly removeDriverFromOrderGroup: { readonly __typename?: 'OrderGroup', readonly id: ID } };

export type TQBranchesDriversVariables = Exact<{
  branchIds: ReadonlyArray<Scalars['ID']>;
}>;


export type TQBranchesDrivers = { readonly __typename?: 'Query', readonly drivers: ReadonlyArray<{ readonly __typename?: 'User', readonly id: ID, readonly initials: string, readonly firstName: string | null, readonly lastName: string | null }> };

export type TQOrderGroupPriorityVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type TQOrderGroupPriority = { readonly __typename?: 'Query', readonly orderGroup: { readonly __typename?: 'OrderGroup', readonly id: ID, readonly orders: ReadonlyArray<{ readonly __typename?: 'Order', readonly id: ID, readonly isPriority: boolean }> } };

export type TQOrderGroupStateAndDriverVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type TQOrderGroupStateAndDriver = { readonly __typename?: 'Query', readonly orderGroup: { readonly __typename?: 'OrderGroup', readonly id: ID, readonly orders: ReadonlyArray<{ readonly __typename?: 'Order', readonly id: ID, readonly orderStateCategory: TOrderStateCategoryEnum, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID }, readonly warePriceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly driver: { readonly __typename?: 'UserDeliveringOrder', readonly id: ID, readonly user: { readonly __typename?: 'User', readonly id: ID, readonly initials: string, readonly firstName: string | null, readonly lastName: string | null } } | null }> } };

export type TFOrderHeader = { readonly __typename?: 'Order', readonly id: ID, readonly createdAt: Date, readonly acceptedAt: Date | null, readonly isPriority: boolean, readonly isFromLoggedInCustomer: boolean, readonly deliverAt: Date | null, readonly deliveredAt: Date | null, readonly driverWillPickupAt: Date | null, readonly delayedDeliveryTime: Date | null, readonly isExpressDelivery: boolean, readonly isPaidWithCard: boolean, readonly orderStateCategory: TOrderStateCategoryEnum, readonly shouldVerifyAge: boolean, readonly cancelRequested: boolean, readonly orderNumber: number | null, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string, readonly oldOrderThreshold: number, readonly allowedCategories: ReadonlyArray<TOrderStateCategoryEnum>, readonly defaultDeliveryTimeEnabled: boolean, readonly defaultPickupTimeEnabled: boolean, readonly usualDeliveryTime: number, readonly usualPickupTime: number }, readonly customer: { readonly __typename?: 'JsonCustomer', readonly firstName: string | null, readonly lastName: string | null, readonly isCancelRisk: boolean | null, readonly defaultPhone: { readonly __typename?: 'Phone', readonly phone: string } | null }, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly formattedValue: string }, readonly orderOrigin: { readonly __typename?: 'OrderOrigin', readonly enum: TOrderOriginEnum, readonly label: string }, readonly warePriceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly sector: { readonly __typename?: 'Sector', readonly name: string } | null, readonly address: { readonly __typename?: 'JsonAddress', readonly original: string | null, readonly state: string | null, readonly city: string | null, readonly venue: string | null, readonly street: string | null, readonly houseNumber: string | null, readonly country: string | null }, readonly onlinePaymentState: { readonly __typename?: 'OrderOnlineState', readonly enum: TOrderOnlineStateEnum } | null, readonly driver: { readonly __typename?: 'UserDeliveringOrder', readonly id: ID, readonly user: { readonly __typename?: 'User', readonly id: ID, readonly initials: string, readonly firstName: string | null, readonly lastName: string | null } } | null, readonly orderPayments: ReadonlyArray<{ readonly __typename?: 'OrderPaymentMethod', readonly id: ID, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly paymentMethod: { readonly __typename?: 'PaymentMethod', readonly id: ID, readonly description: string, readonly paymentType: { readonly __typename?: 'PaymentType', readonly id: ID, readonly enum: TPaymentTypeEnum } } }> };

export type TFOrderRating = { readonly __typename?: 'Order', readonly id: ID, readonly ratings: ReadonlyArray<{ readonly __typename?: 'OrderRating', readonly id: ID, readonly value: number | null, readonly description: string | null, readonly type: { readonly __typename?: 'OrderRatingType', readonly enum: TOrderRatingTypeEnum, readonly code: string } }> | null };

export type TFPrintRecord = { readonly __typename?: 'PrintQueue', readonly id: ID, readonly createdAt: Date, readonly state: { readonly __typename?: 'PrintQueueState', readonly id: ID, readonly enum: TPrintQueueStateEnum, readonly nameLabel: string }, readonly printer: { readonly __typename?: 'Printer', readonly id: ID, readonly MAC: string, readonly nameLabel: string, readonly printerType: { readonly __typename?: 'PrinterType', readonly enum: TPrinterTypeEnum } }, readonly renderer: { readonly __typename?: 'PrintTemplateRender', readonly id: ID, readonly content: string } };

export type TMChangePrintRecordStateVariables = Exact<{
  recordId: Scalars['ID'];
  newState: TPrintQueueStateEnum;
}>;


export type TMChangePrintRecordState = { readonly __typename?: 'Mutation', readonly printRecord: { readonly __typename?: 'PrintQueue', readonly id: ID } };

export type TQPastPrintRecordsVariables = Exact<{
  thisPcMAC: Scalars['String'];
  watchedPrinterIds: ReadonlyArray<Scalars['ID']>;
}>;


export type TQPastPrintRecords = { readonly __typename?: 'Query', readonly printRecords: ReadonlyArray<{ readonly __typename?: 'PrintQueue', readonly id: ID, readonly createdAt: Date, readonly state: { readonly __typename?: 'PrintQueueState', readonly id: ID, readonly enum: TPrintQueueStateEnum, readonly nameLabel: string }, readonly printer: { readonly __typename?: 'Printer', readonly id: ID, readonly MAC: string, readonly nameLabel: string, readonly printerType: { readonly __typename?: 'PrinterType', readonly enum: TPrinterTypeEnum } }, readonly renderer: { readonly __typename?: 'PrintTemplateRender', readonly id: ID, readonly content: string } }> };

export type TQRegisteredPrintersLiteVariables = Exact<{
  companyBranchIds: ReadonlyArray<Scalars['ID']>;
}>;


export type TQRegisteredPrintersLite = { readonly __typename?: 'Query', readonly printers: ReadonlyArray<{ readonly __typename?: 'Printer', readonly id: ID, readonly MAC: string, readonly nameLabel: string }> };

export type TSPrintRecordsVariables = Exact<{
  thisPcMAC: Scalars['String'];
  watchedPrinterIds: ReadonlyArray<Scalars['ID']>;
}>;


export type TSPrintRecords = { readonly __typename?: 'Subscription', readonly updatedPrintRecord: { readonly __typename?: 'PrintQueueUpdateSubscription', readonly id: ID, readonly printRecord: { readonly __typename?: 'PrintQueue', readonly id: ID, readonly createdAt: Date, readonly state: { readonly __typename?: 'PrintQueueState', readonly id: ID, readonly enum: TPrintQueueStateEnum, readonly nameLabel: string }, readonly printer: { readonly __typename?: 'Printer', readonly id: ID, readonly MAC: string, readonly nameLabel: string, readonly printerType: { readonly __typename?: 'PrinterType', readonly enum: TPrinterTypeEnum } }, readonly renderer: { readonly __typename?: 'PrintTemplateRender', readonly id: ID, readonly content: string } } } };

export const FAddress = gql`
    fragment FAddress on JsonAddress {
  state
  city
  venue
  street
  houseNumber
  country
}
    `;
export const FDeliveryAddressSuggestion = gql`
    fragment FDeliveryAddressSuggestion on AddressResolvedLocation {
  address: finalAddress {
    ...FAddress
  }
  gps: gpsCoordinates {
    latitude
    longitude
  }
}
    ${FAddress}`;
export const FProductTagCategory = gql`
    fragment FProductTagCategory on RecipeTagCategoryType {
  enum
  label: code
}
    `;
export const FProductTagOption = gql`
    fragment FProductTagOption on RecipeTag {
  id
  label
  category: recipeTagCategoryType {
    ...FProductTagCategory
  }
  originTag: systemRecipeTag {
    id
  }
}
    ${FProductTagCategory}`;
export const FGeoPoint = gql`
    fragment FGeoPoint on GeoPoint {
  latitude
  longitude
}
    `;
export const FCompanyBranch = gql`
    fragment FCompanyBranch on CompanyBranch {
  id
  name
  url
  urlPath
  address {
    country {
      phonePrefix
    }
  }
  gps {
    ...FGeoPoint
  }
  brand {
    id
    name
    defaultLanguage
    supportedLanguages
    promoHeaderText
    wareCategorySharingAllowed
    publicBranches: companyBranches(public: true) {
      id
    }
  }
  defaultLanguage
  supportedLanguages
  promoHeaderText
  pohodaEnabled
  userAccountsEnabledForCustomer
}
    ${FGeoPoint}`;
export const FLanguage = gql`
    fragment FLanguage on Language {
  id
  code
  enum
}
    `;
export const FEmployeeRole = gql`
    fragment FEmployeeRole on Role {
  id
  enum
  code
}
    `;
export const FEmployeeBranch = gql`
    fragment FEmployeeBranch on CompanyBranch {
  id
  name
}
    `;
export const FEmployee = gql`
    fragment FEmployee on User {
  id
  email
  phone
  login
  lastName
  firstName
  language {
    ...FLanguage
  }
  roles {
    ...FEmployeeRole
  }
  employments: companyBranchUsers {
    id
    inactive: deleted
    branch: companyBranch {
      ...FEmployeeBranch
    }
  }
}
    ${FLanguage}
${FEmployeeRole}
${FEmployeeBranch}`;
export const FProductTagInListBase = gql`
    fragment FProductTagInListBase on RecipeTag {
  id
  label
}
    `;
export const FProductTagTranslations = gql`
    fragment FProductTagTranslations on RecipeTag {
  id
  translations {
    label
    language {
      enum
    }
  }
}
    `;
export const FProductTagInList = gql`
    fragment FProductTagInList on RecipeTag {
  ...FProductTagInListBase
  color
  pictogram
  imageUrl: image
  ...FProductTagTranslations
  category: recipeTagCategoryType {
    ...FProductTagCategory
  }
  originTag: systemRecipeTag {
    ...FProductTagInListBase
  }
}
    ${FProductTagInListBase}
${FProductTagTranslations}
${FProductTagCategory}`;
export const FProductTagBrand = gql`
    fragment FProductTagBrand on Company {
  id
  defaultLanguage
  supportedLanguages
}
    `;
export const FProductTagDetailBase = gql`
    fragment FProductTagDetailBase on RecipeTag {
  ...FProductTagInListBase
  ...FProductTagTranslations
  color
  pictogram
  imageUrl: image
  category: recipeTagCategoryType {
    ...FProductTagCategory
  }
}
    ${FProductTagInListBase}
${FProductTagTranslations}
${FProductTagCategory}`;
export const FProductTagDetail = gql`
    fragment FProductTagDetail on RecipeTag {
  ...FProductTagDetailBase
  originTag: systemRecipeTag {
    ...FProductTagDetailBase
  }
}
    ${FProductTagDetailBase}`;
export const FProductTagRelatedCategory = gql`
    fragment FProductTagRelatedCategory on WareCategory {
  id
  nameLabel
  categoryType: wareCategoryType {
    enum
  }
  branch: companyBranch {
    id
    name
  }
}
    `;
export const FProductTagRelatedRecipe = gql`
    fragment FProductTagRelatedRecipe on Recipe {
  id
  nameLabel
  recipeType: wareCategoryType {
    enum
  }
  primaryCategory: primaryWareCategory {
    branch: companyBranch {
      id
      name
    }
  }
}
    `;
export const FRegularBusinessHour = gql`
    fragment FRegularBusinessHour on BusinessHour {
  id
  openAt
  closeAt
  weekDay {
    enum
  }
}
    `;
export const FSpecificBusinessHour = gql`
    fragment FSpecificBusinessHour on BusinessHour {
  id
  companyBranch {
    id
  }
  specificDate
  closed
  closedNote
  openAt
  closeAt
}
    `;
export const FWeekday = gql`
    fragment FWeekday on WeekDay {
  enum
  code
}
    `;
export const FWoltOpeningTimes = gql`
    fragment FWoltOpeningTimes on WoltProfileStatus {
  openingTimes {
    openAt
    closeAt
    weekDay {
      id
      enum
    }
  }
}
    `;
export const FPrice = gql`
    fragment FPrice on PriceConverted {
  value
}
    `;
export const FCreateOrderItem = gql`
    fragment FCreateOrderItem on OrderRecipe {
  id
  price {
    ...FPrice
  }
  recipe {
    id
    code
    nameLabel
  }
}
    ${FPrice}`;
export const FOrderForItemGrouping = gql`
    fragment FOrderForItemGrouping on Order {
  id
  items {
    id
    note
    recipe {
      id
    }
    sideDishes {
      id
      recipe {
        id
      }
    }
  }
}
    `;
export const FCreateOrder = gql`
    fragment FCreateOrder on Order {
  id
  countWares
  items {
    ...FCreateOrderItem
    note
    recipe {
      sideDishCount: sideDishesWareCategoriesCount
    }
    sideDishes {
      ...FCreateOrderItem
    }
  }
  coverPrice {
    ...FPrice
  }
  transportFee {
    ...FPrice
  }
  discounts {
    code
    description
    price {
      ...FPrice
    }
  }
  minimalOrderPrice {
    formattedValue
  }
  totalDiscount {
    ...FPrice
  }
  totalVouchers {
    ...FPrice
  }
  totalSum {
    ...FPrice
  }
  ...FOrderForItemGrouping
}
    ${FCreateOrderItem}
${FPrice}
${FOrderForItemGrouping}`;
export const FAcceptedOrder = gql`
    fragment FAcceptedOrder on FinishedOrder {
  userErrors
  order {
    ...FCreateOrder
  }
}
    ${FCreateOrder}`;
export const FFormattedPrice = gql`
    fragment FFormattedPrice on PriceConverted {
  formattedValue
}
    `;
export const FPriceWithCurrency = gql`
    fragment FPriceWithCurrency on PriceConverted {
  ...FPrice
  currency {
    code
  }
}
    ${FPrice}`;
export const FCreateOrderRecipeSideDishes = gql`
    fragment FCreateOrderRecipeSideDishes on Recipe {
  id
  nameLabel
  isDynamicPricingEnabled
  price(warePriceType: $warePriceType) {
    ...FFormattedPrice
    ...FPriceWithCurrency
  }
  sideDishCategories: sideDishesWareCategories {
    id
    nameLabel
    minCount
    maxCount
    sideDishes: recipes(enabled: true, isAvailable: true) {
      id
      nameLabel
      price(warePriceType: $warePriceType) {
        ...FFormattedPrice
        ...FPriceWithCurrency
      }
    }
  }
}
    ${FFormattedPrice}
${FPriceWithCurrency}`;
export const FOrderCustomerLocation = gql`
    fragment FOrderCustomerLocation on JsonAddress {
  ...FAddress
  gps {
    latitude
    longitude
  }
}
    ${FAddress}`;
export const FOrderCustomer = gql`
    fragment FOrderCustomer on CustomerInformation {
  email
  firstName
  lastName
  customer {
    id
    isRegistered: isCustomerRegistered
  }
  locations {
    ...FOrderCustomerLocation
  }
}
    ${FOrderCustomerLocation}`;
export const FOrderForHandoverType = gql`
    fragment FOrderForHandoverType on Order {
  id
  warePriceType {
    enum
  }
  deliveryType {
    enum
  }
}
    `;
export const FOrderForTimeline = gql`
    fragment FOrderForTimeline on Order {
  stateChanges: orderStateCategoryRelations {
    createdAt
    state: orderStateCategory
  }
}
    `;
export const FOrderForNumber = gql`
    fragment FOrderForNumber on Order {
  id
  orderNumber: invoiceSequenceResettable
}
    `;
export const FCustomerScreenOrder = gql`
    fragment FCustomerScreenOrder on Order {
  id
  orderStateCategory(target: FE_COMPLETION)
  ...FOrderForHandoverType
  ...FOrderForTimeline
  ...FOrderForNumber
}
    ${FOrderForHandoverType}
${FOrderForTimeline}
${FOrderForNumber}`;
export const FExpressState = gql`
    fragment FExpressState on ExpressDeliverySetting {
  id
  isExpressEnabled
  isExpressAvailable
  pausedUntil
}
    `;
export const FHeaderTextInForm = gql`
    fragment FHeaderTextInForm on Company {
  id
  promoHeaderEnabled
  promoHeaderTranslations {
    content
    language
  }
}
    `;
export const FBoltBase = gql`
    fragment FBoltBase on BoltProfile {
  id
  name
  restaurantIdValue
  isAutomaticMenuSyncEnabled
  integration {
    enum
  }
}
    `;
export const FIntegrationOnlineState = gql`
    fragment FIntegrationOnlineState on IntegrationState {
  id
  enum
}
    `;
export const FBoltProfileWithStates = gql`
    fragment FBoltProfileWithStates on BoltProfile {
  ...FBoltBase
  onlineState {
    ...FIntegrationOnlineState
  }
  deliveryProvider {
    id
    enum
  }
  integrationFlow {
    id
    enum
  }
  isAutomaticMenuSyncEnabled
  lastMenuSyncAt
}
    ${FBoltBase}
${FIntegrationOnlineState}`;
export const FDotykackaBase = gql`
    fragment FDotykackaBase on DotykackaProfile {
  id
  name
  restaurantIdValue
  isAutomaticMenuSyncEnabled
  integration {
    enum
  }
}
    `;
export const FDotykackaProfileWithStates = gql`
    fragment FDotykackaProfileWithStates on DotykackaProfile {
  ...FDotykackaBase
  lastMenuSyncAt
}
    ${FDotykackaBase}`;
export const FFoodoraBase = gql`
    fragment FFoodoraBase on FoodoraProfile {
  id
  name
  restaurantIdValue
  isAutomaticMenuSyncEnabled
  integration {
    enum
  }
}
    `;
export const FFoodoraProfileWithStates = gql`
    fragment FFoodoraProfileWithStates on FoodoraProfile {
  ...FFoodoraBase
  onlineState {
    ...FIntegrationOnlineState
  }
  deliveryProvider {
    id
    enum
  }
  isAutomaticMenuSyncEnabled
  lastMenuSyncAt
}
    ${FFoodoraBase}
${FIntegrationOnlineState}`;
export const FJidloPodNosBase = gql`
    fragment FJidloPodNosBase on JidloPodNosProfile {
  id
  name
  restaurantIdValue
  isAutomaticMenuSyncEnabled
  integration {
    enum
  }
}
    `;
export const FJidloPodNosProfileWithStates = gql`
    fragment FJidloPodNosProfileWithStates on JidloPodNosProfile {
  ...FJidloPodNosBase
  lastMenuSyncAt
}
    ${FJidloPodNosBase}`;
export const FWoltProfileBase = gql`
    fragment FWoltProfileBase on WoltProfile {
  id
  name
  restaurantIdValue
  isAutomaticMenuSyncEnabled
  integration {
    enum
  }
}
    `;
export const FWoltProfileWithStates = gql`
    fragment FWoltProfileWithStates on WoltProfile {
  ...FWoltProfileBase
  onboardingState {
    id
    enum
  }
  onlineState {
    ...FIntegrationOnlineState
  }
  deliveryProvider {
    id
    enum
  }
  isAutomaticMenuSyncEnabled
  lastMenuSyncAt
}
    ${FWoltProfileBase}
${FIntegrationOnlineState}`;
export const FEmail = gql`
    fragment FEmail on Email {
  email
  description
  default
}
    `;
export const FPhone = gql`
    fragment FPhone on Phone {
  phone
  description
  default
}
    `;
export const FCustomer = gql`
    fragment FCustomer on JsonCustomer {
  firstName
  lastName
  defaultEmail {
    ...FEmail
  }
  defaultPhone {
    ...FPhone
  }
}
    ${FEmail}
${FPhone}`;
export const FKitchenRecipe = gql`
    fragment FKitchenRecipe on Recipe {
  id
  code
  name: nameLabel
}
    `;
export const FKitchenOrderState = gql`
    fragment FKitchenOrderState on OrderRecipe {
  id
  state: orderRecipeState {
    enum
  }
}
    `;
export const FKitchenOrderRecipe = gql`
    fragment FKitchenOrderRecipe on OrderRecipe {
  id
  note
  recipe {
    ...FKitchenRecipe
  }
  ...FKitchenOrderState
}
    ${FKitchenRecipe}
${FKitchenOrderState}`;
export const FOrderForHandoverTime = gql`
    fragment FOrderForHandoverTime on Order {
  id
  deliverAt
  deliveredAt
  driverWillPickupAt
  cancelRequested: cancelAlreadyRequested
  delayedDeliveryTime
  acceptedAt
  isExpressDelivery
}
    `;
export const FOrderForDestination = gql`
    fragment FOrderForDestination on Order {
  id
  warePriceType {
    enum
  }
  deliveryType {
    enum
  }
  sector {
    name
  }
  address {
    ...FAddress
    original
  }
}
    ${FAddress}`;
export const FKitchenOrderBase = gql`
    fragment FKitchenOrderBase on Order {
  id
  createdAt
  acceptedAt
  isPriority
  orderOrigin {
    enum
    label: code
  }
  deliveryType {
    enum
  }
  companyBranch {
    id
    name
  }
  customer: customerJson {
    ...FCustomer
  }
  items {
    recipe {
      category: primaryWareCategory {
        id
        nameLabel
      }
    }
    ...FKitchenOrderRecipe
    sideDishes {
      ...FKitchenOrderRecipe
    }
  }
  isExpressDelivery
  ...FOrderForHandoverTime
  ...FOrderForHandoverType
  ...FOrderForDestination
}
    ${FCustomer}
${FKitchenOrderRecipe}
${FOrderForHandoverTime}
${FOrderForHandoverType}
${FOrderForDestination}`;
export const FOrderPayments = gql`
    fragment FOrderPayments on Order {
  orderPayments {
    id
    price {
      formattedValue
      value
    }
    paymentMethod {
      id
      description
      paymentType {
        id
        enum
      }
    }
  }
}
    `;
export const FOrderForPaymentCategory = gql`
    fragment FOrderForPaymentCategory on Order {
  id
  isPaidWithCard
  onlinePaymentState: orderOnlineState {
    enum
  }
  ...FOrderPayments
}
    ${FOrderPayments}`;
export const FUsualHandoverTimes = gql`
    fragment FUsualHandoverTimes on CompanyBranch {
  id
  usualDeliveryTime: defaultDeliveryTime
  defaultDeliveryTimeEnabled
  usualPickupTime: defaultPickupTime
  defaultPickupTimeEnabled
}
    `;
export const FFoodoraDeliveryInfo = gql`
    fragment FFoodoraDeliveryInfo on FoodoraRecordGlType {
  isDeliveredByFoodora
  minFoodoraPickupTime
  maxFoodoraPickupTime
}
    `;
export const FIntegrationOrderAccept = gql`
    fragment FIntegrationOrderAccept on Order {
  id
  canBeCanceled: isCancelable
  deliverAt
  delayedDeliveryTime
  orderOrigin {
    enum
  }
  deliveryType {
    enum
  }
  companyBranch {
    ...FUsualHandoverTimes
  }
  foodoraRecord {
    ...FFoodoraDeliveryInfo
  }
}
    ${FUsualHandoverTimes}
${FFoodoraDeliveryInfo}`;
export const FKitchenCompletionOrder = gql`
    fragment FKitchenCompletionOrder on Order {
  ...FKitchenOrderBase
  ...FOrderForPaymentCategory
  ...FOrderForNumber
  ...FIntegrationOrderAccept
  note
  orderStateCategory(target: FE_COMPLETION)
  shouldVerifyAge: ageControl
  companyBranch {
    allowedCategories
  }
  cashRegister: cashBox {
    id
    name
    virtual
    kiosk
  }
  orderOrigin {
    enum
    label: code
  }
  sector {
    name
  }
}
    ${FKitchenOrderBase}
${FOrderForPaymentCategory}
${FOrderForNumber}
${FIntegrationOrderAccept}`;
export const FOrderGroupColor = gql`
    fragment FOrderGroupColor on OrderGroupColor {
  id
  color
}
    `;
export const FOrderGroup = gql`
    fragment FOrderGroup on OrderGroup {
  id
  name
  color {
    ...FOrderGroupColor
  }
}
    ${FOrderGroupColor}`;
export const FOrderOrderGroup = gql`
    fragment FOrderOrderGroup on Order {
  id
  orderGroupIndex
  orderGroup {
    ...FOrderGroup
  }
}
    ${FOrderGroup}`;
export const FKitchenOrder = gql`
    fragment FKitchenOrder on Order {
  ...FKitchenOrderBase
  ...FOrderForNumber
  ...FOrderOrderGroup
  note
  orderStateCategory(target: FE_KITCHEN)
}
    ${FKitchenOrderBase}
${FOrderForNumber}
${FOrderOrderGroup}`;
export const FKitchenOrderStates = gql`
    fragment FKitchenOrderStates on Order {
  orderStates: orderStateCategoryRelations(target: FE_ADMIN) {
    createdAt
    orderStateCategory
  }
}
    `;
export const FKitchenRecipeWorkplaces = gql`
    fragment FKitchenRecipeWorkplaces on Recipe {
  id
  workplaces: groups {
    id
  }
}
    `;
export const FKitchenOrderWorkplaces = gql`
    fragment FKitchenOrderWorkplaces on Order {
  id
  items {
    id
    recipe {
      ...FKitchenRecipeWorkplaces
    }
    sideDishes {
      id
      recipe {
        ...FKitchenRecipeWorkplaces
      }
    }
  }
}
    ${FKitchenRecipeWorkplaces}`;
export const FKitchenSectorState = gql`
    fragment FKitchenSectorState on SectorRecipe {
  id
  state: orderRecipeState {
    enum
  }
}
    `;
export const FKitchenSectorRecipe = gql`
    fragment FKitchenSectorRecipe on SectorRecipe {
  id
  note
  createdAt
  recipe {
    category: primaryWareCategory {
      id
      nameLabel
    }
    ...FKitchenRecipe
  }
  sideDishes {
    id
    recipe {
      ...FKitchenRecipe
    }
  }
  sector {
    id
  }
  ...FKitchenSectorState
}
    ${FKitchenRecipe}
${FKitchenSectorState}`;
export const FKitchenSectorRecipeWorkplaces = gql`
    fragment FKitchenSectorRecipeWorkplaces on SectorRecipe {
  id
  recipe {
    ...FKitchenRecipeWorkplaces
  }
  sideDishes {
    id
    recipe {
      ...FKitchenRecipeWorkplaces
    }
  }
}
    ${FKitchenRecipeWorkplaces}`;
export const FWoltProfile = gql`
    fragment FWoltProfile on WoltProfile {
  ...FWoltProfileBase
  onboardingState {
    id
    enum
  }
  onboardingErrorsLocalised
}
    ${FWoltProfileBase}`;
export const FMenuCategory = gql`
    fragment FMenuCategory on WareCategory {
  id
  visible: enabled
  categoryType: wareCategoryType {
    enum
  }
  origins: orderOriginCategories
  companyBranch {
    id
    name
  }
  sharedCompanyBranches {
    id
    name
    woltProfiles(onboardingStates: SUCCESSFUL) {
      ...FWoltProfile
    }
    foodoraProfiles {
      ...FFoodoraBase
    }
    boltProfiles {
      ...FBoltBase
    }
    jidloPodNosProfiles {
      ...FJidloPodNosBase
    }
  }
}
    ${FWoltProfile}
${FFoodoraBase}
${FBoltBase}
${FJidloPodNosBase}`;
export const FMenuCategoryLocalized = gql`
    fragment FMenuCategoryLocalized on WareCategory {
  id
  translations {
    nameLabel: label
    descriptionLabel
    internalNoteLabel
    language {
      enum
    }
  }
}
    `;
export const FPromoTag = gql`
    fragment FPromoTag on PromoTag {
  id
  code
  enum
}
    `;
export const FMenuProductTagRelation = gql`
    fragment FMenuProductTagRelation on RecipeTagRelation {
  id
  inherited
  productTag: recipeTag {
    id
    label
    originTag: systemRecipeTag {
      id
    }
  }
}
    `;
export const FMenuCategoryInForm = gql`
    fragment FMenuCategoryInForm on WareCategory {
  ...FMenuCategory
  ...FMenuCategoryLocalized
  integrationsProfiles {
    ... on BoltProfile {
      id
      integration {
        enum
      }
    }
    ... on WoltProfile {
      id
      integration {
        enum
      }
    }
    ... on FoodoraProfile {
      id
      integration {
        enum
      }
    }
    ... on JidloPodNosProfile {
      id
      integration {
        enum
      }
    }
  }
  image
  pictogram
  dependentRules
  minCount
  maxCount
  automaticFinish
  recipes {
    id
    code
    nameLabel: nameLabelTranslated
    internalNote
    isCombinationMeal
    isDynamicPricingEnabled
    prices {
      priceType: warePriceType {
        enum
      }
      price {
        ...FFormattedPrice
        ...FPriceWithCurrency
      }
    }
  }
  color: wareCategoryColor {
    id
  }
  promoTags {
    ...FPromoTag
  }
  productTagRelations: recipeTagRelations {
    ...FMenuProductTagRelation
  }
}
    ${FMenuCategory}
${FMenuCategoryLocalized}
${FFormattedPrice}
${FPriceWithCurrency}
${FPromoTag}
${FMenuProductTagRelation}`;
export const FMenuAssocRecipe = gql`
    fragment FMenuAssocRecipe on Recipe {
  id
  nameLabel
  inHousePrice: price(warePriceType: INHOUSE) {
    formattedValue
  }
  deliveryPrice: price(warePriceType: DELIVERY) {
    formattedValue
  }
}
    `;
export const FMenuRecipe = gql`
    fragment FMenuRecipe on Recipe {
  id
  code
  internalNote
  internalCode
  soldOut
  ageControl
  isCombinationMeal
  isDynamicPricingEnabled
  recipeColor {
    id
    code
    color
  }
  visible: enabled
  recipeType: wareCategoryType {
    enum
  }
}
    `;
export const FMenuRecipeLocalized = gql`
    fragment FMenuRecipeLocalized on Recipe {
  id
  translations {
    nameLabel: label
    descriptionLabel
    language {
      enum
    }
  }
}
    `;
export const FMenuCategoryInList = gql`
    fragment FMenuCategoryInList on WareCategory {
  ...FMenuCategory
  nameLabel
  countRecipes
  enabledByOwner
  internalNoteLabel
  color: wareCategoryColor {
    id
    color
  }
}
    ${FMenuCategory}`;
export const FMenuRecipeInForm = gql`
    fragment FMenuRecipeInForm on Recipe {
  ...FMenuRecipe
  ...FMenuRecipeLocalized
  image
  dependentRules
  pictogram(enableFallback: false)
  primaryCategory: primaryWareCategory {
    id
    pictogram
  }
  sideDishes: sideDishesWareCategories {
    ...FMenuCategoryInList
  }
  categories: wareCategories {
    ...FMenuCategoryInList
  }
  workplaces: groups {
    id
  }
  productTagRelations: recipeTagRelations {
    ...FMenuProductTagRelation
  }
}
    ${FMenuRecipe}
${FMenuRecipeLocalized}
${FMenuCategoryInList}
${FMenuProductTagRelation}`;
export const FMenuRecipeInList = gql`
    fragment FMenuRecipeInList on Recipe {
  ...FMenuRecipe
  shared
  nameLabel
  enabledByOwner
}
    ${FMenuRecipe}`;
export const FMenuRecipePricing = gql`
    fragment FMenuRecipePricing on RecipePrice {
  id
  priceType: warePriceType {
    enum
  }
  price {
    ...FFormattedPrice
    ...FPriceWithCurrency
  }
  vat {
    id
  }
}
    ${FFormattedPrice}
${FPriceWithCurrency}`;
export const FMenuRecipeInListSlow = gql`
    fragment FMenuRecipeInListSlow on Recipe {
  id
  availableAmount
  imageUrl: image
  prices {
    ...FMenuRecipePricing
  }
  isCombinationMeal
}
    ${FMenuRecipePricing}`;
export const FMenuAllergen = gql`
    fragment FMenuAllergen on Allergen {
  id
  code
  enum
  category
}
    `;
export const FMenuWareUnit = gql`
    fragment FMenuWareUnit on WareUnit {
  id
  enum
  code
}
    `;
export const FMenuStockItem = gql`
    fragment FMenuStockItem on StockItem {
  id
  code
  note
  plu
  shared
  quantity
  nameLabel: label
  allergens {
    ...FMenuAllergen
  }
  wareUnit {
    ...FMenuWareUnit
  }
}
    ${FMenuAllergen}
${FMenuWareUnit}`;
export const FOrderDetailWare = gql`
    fragment FOrderDetailWare on OrderRecipe {
  id
  note
  recipe {
    id
    code
    nameLabel
  }
  price {
    ...FPrice
    ...FFormattedPrice
  }
}
    ${FPrice}
${FFormattedPrice}`;
export const FOrderOrigin = gql`
    fragment FOrderOrigin on Order {
  orderOrigin {
    label: code
    enum
  }
}
    `;
export const FOrderStateCategory = gql`
    fragment FOrderStateCategory on Order {
  id
  orderStateCategory
}
    `;
export const FUserName = gql`
    fragment FUserName on User {
  firstName
  lastName
}
    `;
export const FDriver = gql`
    fragment FDriver on User {
  id
  initials
  ...FUserName
}
    ${FUserName}`;
export const FOrderDriver = gql`
    fragment FOrderDriver on Order {
  id
  driver: userDeliveringOrder {
    id
    user {
      ...FDriver
    }
  }
}
    ${FDriver}`;
export const FOrderHeader = gql`
    fragment FOrderHeader on Order {
  ...FOrderOrigin
  ...FOrderForDestination
  ...FOrderForHandoverTime
  ...FOrderForPaymentCategory
  ...FOrderForHandoverType
  ...FOrderForNumber
  ...FOrderStateCategory
  ...FOrderDriver
  id
  createdAt
  acceptedAt
  isPriority
  shouldVerifyAge: ageControl
  isFromLoggedInCustomer
  companyBranch {
    id
    name
    oldOrderThreshold
    allowedCategories
    ...FUsualHandoverTimes
  }
  customer: customerJson {
    firstName
    lastName
    isCancelRisk
    defaultPhone {
      phone
    }
  }
  totalSum {
    formattedValue
  }
}
    ${FOrderOrigin}
${FOrderForDestination}
${FOrderForHandoverTime}
${FOrderForPaymentCategory}
${FOrderForHandoverType}
${FOrderForNumber}
${FOrderStateCategory}
${FOrderDriver}
${FUsualHandoverTimes}`;
export const FOrderGps = gql`
    fragment FOrderGps on Order {
  id
  gps {
    ...FGeoPoint
  }
}
    ${FGeoPoint}`;
export const FOrderGroupModalOrder = gql`
    fragment FOrderGroupModalOrder on Order {
  id
  deliverAt
  deliveredAt
  orderGroupIndex
  orderStateCategory
  delayedDeliveryTime
  totalSum {
    ...FFormattedPrice
  }
  customer: customerJson {
    firstName
    lastName
  }
  orderGroup {
    id
  }
  driver: userDeliveringOrder {
    id
  }
  ...FOrderGps
  ...FOrderForDestination
  ...FOrderForNumber
}
    ${FFormattedPrice}
${FOrderGps}
${FOrderForDestination}
${FOrderForNumber}`;
export const FOrderListGroup = gql`
    fragment FOrderListGroup on Order {
  id
  orderGroupIndex
  orderGroup {
    id
  }
}
    `;
export const FOrderInList = gql`
    fragment FOrderInList on Order {
  id
  isExpressDelivery
  cancelRequested: cancelAlreadyRequested
  ...FOrderHeader
  ...FOrderGroupModalOrder
  ...FOrderListGroup
}
    ${FOrderHeader}
${FOrderGroupModalOrder}
${FOrderListGroup}`;
export const FOrderMapDriver = gql`
    fragment FOrderMapDriver on User {
  id
  initials
  firstName
  lastName
  countUndeliveredOrders
}
    `;
export const FOrderMapDevice = gql`
    fragment FOrderMapDevice on TransportationDeviceUser {
  id
  lastPosition {
    gps: geoPosition {
      ...FGeoPoint
    }
    timestamp
  }
  isFinalized
  transportationDevice {
    deviceState {
      enum
    }
  }
}
    ${FGeoPoint}`;
export const FOrderMapDelivery = gql`
    fragment FOrderMapDelivery on User {
  ...FOrderMapDriver
  device: usedTransportationDevice {
    ...FOrderMapDevice
  }
}
    ${FOrderMapDriver}
${FOrderMapDevice}`;
export const FOrderMapOrder = gql`
    fragment FOrderMapOrder on Order {
  ...FOrderForHandoverTime
  id
  orderStateCategory
  currentUserCanFinishOrder
  deliveryType {
    enum
  }
  gps {
    ...FGeoPoint
  }
  orderGroup {
    id
    color {
      ...FOrderGroupColor
    }
  }
}
    ${FOrderForHandoverTime}
${FGeoPoint}
${FOrderGroupColor}`;
export const FOverriddenHandoverTime = gql`
    fragment FOverriddenHandoverTime on OrderProcessTime {
  id
  expiresAt
  time: processTime
}
    `;
export const FCurrentHandoverTimes = gql`
    fragment FCurrentHandoverTimes on CompanyBranch {
  id
  nameLabel: name
  defaultDeliveryTimeEnabled
  currentDeliveryTime
  usualDeliveryTime: defaultDeliveryTime
  overriddenDeliveryTime {
    ...FOverriddenHandoverTime
  }
  defaultPickupTimeEnabled
  currentPickupTime
  usualPickupTime: defaultPickupTime
  overriddenPickupTime {
    ...FOverriddenHandoverTime
  }
}
    ${FOverriddenHandoverTime}`;
export const FBillingExpense = gql`
    fragment FBillingExpense on StatisticsForOperatingCosts {
  orderOrigin {
    label: code
    enum
  }
  info: operatingCostFrequencyType {
    id
    expenseType: operatingCostType {
      label: code
      enum
    }
  }
  settings: operatingCostSetting {
    id
    fixedCoef: absoluteValue
    percentageCoef: percentageValue
  }
  orderCount: totalCount
  fixedTotal: totalAbsoluteSum {
    value
  }
  percentageTotal: totalPercentageSum {
    value
  }
  orderRevenue: totalRecordValueSum {
    value
  }
}
    `;
export const FCreditsFundsTransfer = gql`
    fragment FCreditsFundsTransfer on CreditsFundsTransfer {
  id
  amount {
    ...FPriceWithCurrency
  }
  order {
    id
  }
  state {
    id
    enum
  }
  type {
    id
    enum
  }
}
    ${FPriceWithCurrency}`;
export const FCreditActivityInCustomerHistory = gql`
    fragment FCreditActivityInCustomerHistory on CreditsWalletActivity {
  id
  createdAt
  expiresAt
  isExpired
  amount {
    value
    formattedValue
  }
  remainingAmount {
    value
    formattedValue
  }
  companyBranch {
    id
    name
  }
  group {
    id
    name
  }
}
    `;
export const FOrderInStatistics = gql`
    fragment FOrderInStatistics on Order {
  id
  ...FOrderHeader
}
    ${FOrderHeader}`;
export const FOrderInCustomerHistory = gql`
    fragment FOrderInCustomerHistory on Order {
  ...FOrderInStatistics
  orderOrigin {
    enum
  }
  totalSum {
    value
  }
  tip {
    value
  }
  totalDiscount {
    value
  }
}
    ${FOrderInStatistics}`;
export const FOrderRating = gql`
    fragment FOrderRating on Order {
  id
  ratings: rating {
    id
    value
    description: text
    type: orderRatingType {
      enum
      code
    }
  }
}
    `;
export const FOrderForRating = gql`
    fragment FOrderForRating on Order {
  id
  acceptedAt
  createdAt
  deliveredAt
  customerOrdersCountCurrent
  customerOrdersCountTotal
  customer: customerJson {
    firstName
    lastName
    defaultPhone {
      phone
    }
    phones {
      ...FPhone
    }
  }
  createdBy: user {
    id
    firstName
    lastName
    isGuest
  }
  ...FOrderRating
  ...FOrderForDestination
}
    ${FPhone}
${FOrderRating}
${FOrderForDestination}`;
export const FPrintTemplate = gql`
    fragment FPrintTemplate on PrintTemplate {
  id
  nameLabel: description
}
    `;
export const FPrintableObject = gql`
    fragment FPrintableObject on TriggerableType {
  id
  enum
  nameLabel: code
}
    `;
export const FPrintTemplateWithObject = gql`
    fragment FPrintTemplateWithObject on PrintTemplate {
  ...FPrintTemplate
  printableObject: triggerableType {
    ...FPrintableObject
  }
}
    ${FPrintTemplate}
${FPrintableObject}`;
export const FPrintTrigger = gql`
    fragment FPrintTrigger on TriggerConfiguration {
  id
  nameLabel: description
  printableObject: triggerableType {
    id
    enum
  }
}
    `;
export const FPrintQueue = gql`
    fragment FPrintQueue on CompanyBranchTrigger {
  id
  companyBranch: assignable {
    ... on CompanyBranch {
      id
      nameLabel: name
    }
    ... on Company {
      id
      nameLabel: name
    }
  }
  printTemplate: templatable {
    ...FPrintTemplateWithObject
  }
  printTrigger: triggerConfiguration {
    ...FPrintTrigger
  }
}
    ${FPrintTemplateWithObject}
${FPrintTrigger}`;
export const FPrinterQueueLink = gql`
    fragment FPrinterQueueLink on CompanyBranchTriggerPrinter {
  id
  targetPcMAC: targetMac
  branchPrinter: companyBranchPrinter {
    id
    printer {
      id
      MAC: mac
      nameLabel: name
      printerType {
        id
        enum
      }
    }
  }
}
    `;
export const FPrinter = gql`
    fragment FPrinter on Printer {
  id
  MAC: mac
  nameLabel: name
  printerType {
    id
    enum
    nameLabel: code
  }
  branchPrinters: companyBranchPrinters {
    id
    companyBranch {
      id
      nameLabel: name
    }
  }
}
    `;
export const FUser = gql`
    fragment FUser on User {
  id
  initials
  firstName
  lastName
}
    `;
export const FStockInventorySummary = gql`
    fragment FStockInventorySummary on StockInventory {
  id
  createdAt
  user {
    ...FUser
  }
}
    ${FUser}`;
export const FStockInventoryItem = gql`
    fragment FStockInventoryItem on StockInventoryItem {
  id
  originalQuantity
  finalQuantity
  stockItemChangeType: stockInventoryItemChangeType {
    id
    enum
    code
  }
  stockItem {
    id
    code
    label
    wareUnit {
      id
      enum
      code
    }
  }
}
    `;
export const FStockInventory = gql`
    fragment FStockInventory on StockInventory {
  ...FStockInventorySummary
  finishedAt
  note
  items {
    ...FStockInventoryItem
  }
}
    ${FStockInventorySummary}
${FStockInventoryItem}`;
export const FZone = gql`
    fragment FZone on Zone {
  id
  name
  enabled
  priority
  deliveryTimeDeviation
  zoneColor {
    id
    code
    color
  }
  zoneType {
    enum
  }
  geoPolygon {
    ...FGeoPoint
  }
}
    ${FGeoPoint}`;
export const FZonePriceRange = gql`
    fragment FZonePriceRange on ZonePriceRangeRule {
  toPrice {
    ...FPrice
  }
  price {
    ...FPrice
  }
}
    ${FPrice}`;
export const FZoneInForm = gql`
    fragment FZoneInForm on Zone {
  ...FZone
  enabled
  priceRangeRules {
    ...FZonePriceRange
  }
  minimalOrderPrice {
    ...FPrice
  }
  companyBranch {
    id
    defaultDeliveryTime
    currency: defaultCurrency {
      code
    }
  }
}
    ${FZone}
${FZonePriceRange}
${FPrice}`;
export const FZoneInList = gql`
    fragment FZoneInList on Zone {
  ...FZone
  companyBranch {
    id
    brand {
      id
    }
  }
}
    ${FZone}`;
export const FActiveExternalDelivery = gql`
    fragment FActiveExternalDelivery on ExternalDelivery {
  id
  seen
  failReason: errorMessage
  deliveryNumber: orderNumber
  status: externalDeliveryState {
    enum
    label: code
  }
  order {
    ...FOrderForHandoverTime
    ...FOrderForNumber
    id
    orderStateCategory
    branch: companyBranch {
      id
      name
    }
  }
  provider: externalDeliveryProvider {
    enum
    label: code
  }
}
    ${FOrderForHandoverTime}
${FOrderForNumber}`;
export const FOrderForExternalDelivery = gql`
    fragment FOrderForExternalDelivery on Order {
  ...FOrderForHandoverTime
  ...FOrderForNumber
  ...FOrderForDestination
  id
  orderStateCategory
  availableExternalDeliveries: externalDeliveryProviders {
    code
    enum
  }
}
    ${FOrderForHandoverTime}
${FOrderForNumber}
${FOrderForDestination}`;
export const FNotification = gql`
    fragment FNotification on InAppNotification {
  id
  title
  content
  url
  isRead
  createdAt
}
    `;
export const FOrderForCancelAction = gql`
    fragment FOrderForCancelAction on Order {
  id
  canBeCanceled: isCancelable
  canRequestCancel
  orderOrigin {
    enum
  }
  orderStates {
    enum
  }
}
    `;
export const FPaymentMethod = gql`
    fragment FPaymentMethod on PaymentMethod {
  id
  description
  paymentType {
    id
    enum
  }
  paymentGate {
    id
    enum
    code
  }
}
    `;
export const FOrderPaymentMethods = gql`
    fragment FOrderPaymentMethods on Order {
  paymentMethods: canBeUpdatedToPaymentMethods {
    ...FPaymentMethod
  }
}
    ${FPaymentMethod}`;
export const FOrderExtraFees = gql`
    fragment FOrderExtraFees on Order {
  extraFees {
    code
    name
    price {
      ...FPrice
      ...FFormattedPrice
    }
  }
  collectFromCustomer {
    ...FPrice
    ...FFormattedPrice
  }
}
    ${FPrice}
${FFormattedPrice}`;
export const FOrderTotals = gql`
    fragment FOrderTotals on Order {
  totalSum {
    ...FPrice
    ...FFormattedPrice
  }
  transportFee {
    ...FPrice
    ...FFormattedPrice
  }
  coverPrice {
    ...FPrice
    ...FFormattedPrice
  }
  totalDiscount {
    ...FPrice
    ...FFormattedPrice
  }
  tip {
    ...FPrice
    ...FFormattedPrice
  }
  extraCharge {
    ...FPrice
    ...FFormattedPrice
  }
  serviceFee {
    amount {
      ...FPrice
      ...FFormattedPrice
    }
  }
  totalVouchers {
    ...FPrice
    ...FFormattedPrice
  }
  expressDelivery {
    expressFee {
      ...FPrice
      ...FFormattedPrice
    }
  }
  minOrderFee: minOrderCharge {
    ...FPrice
    ...FFormattedPrice
  }
  ...FOrderPayments
}
    ${FPrice}
${FFormattedPrice}
${FOrderPayments}`;
export const FPrintRecord = gql`
    fragment FPrintRecord on PrintQueue {
  id
  createdAt
  state: printQueueState {
    id
    enum
    nameLabel: code
  }
  printer {
    id
    MAC: mac
    nameLabel: name
    printerType {
      enum
    }
  }
  renderer: printTemplateRender {
    id
    content: renderedContentBase64
  }
}
    `;
export const QDeliveryAddressSuggestionsDocument = gql`
    query QDeliveryAddressSuggestions($gpsList: [InputGeoPointCreate!]!) {
  suggestions: suggestAddress(gps: $gpsList) {
    ...FDeliveryAddressSuggestion
  }
}
    ${FDeliveryAddressSuggestion}`;
export function useQDeliveryAddressSuggestions(baseOptions: ApolloReactHooks.QueryHookOptions<TQDeliveryAddressSuggestions, TQDeliveryAddressSuggestionsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQDeliveryAddressSuggestions, TQDeliveryAddressSuggestionsVariables>(QDeliveryAddressSuggestionsDocument, options);
      }
export function useQDeliveryAddressSuggestionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQDeliveryAddressSuggestions, TQDeliveryAddressSuggestionsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQDeliveryAddressSuggestions, TQDeliveryAddressSuggestionsVariables>(QDeliveryAddressSuggestionsDocument, options);
        }
export type QDeliveryAddressSuggestionsHookResult = ReturnType<typeof useQDeliveryAddressSuggestions>;
export type QDeliveryAddressSuggestionsLazyQueryHookResult = ReturnType<typeof useQDeliveryAddressSuggestionsLazyQuery>;
export type QDeliveryAddressSuggestionsQueryResult = ApolloReactCommon.QueryResult<TQDeliveryAddressSuggestions, TQDeliveryAddressSuggestionsVariables>;
export const QResolveDeliveryAddressDocument = gql`
    query QResolveDeliveryAddress($branchId: ID, $latitude: Float, $longitude: Float, $addressInput: String) {
  location: resolveLocation(latitude: $latitude, longitude: $longitude, address: $addressInput, companyBranch: $branchId) {
    ...FDeliveryAddressSuggestion
  }
}
    ${FDeliveryAddressSuggestion}`;
export function useQResolveDeliveryAddress(baseOptions?: ApolloReactHooks.QueryHookOptions<TQResolveDeliveryAddress, TQResolveDeliveryAddressVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQResolveDeliveryAddress, TQResolveDeliveryAddressVariables>(QResolveDeliveryAddressDocument, options);
      }
export function useQResolveDeliveryAddressLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQResolveDeliveryAddress, TQResolveDeliveryAddressVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQResolveDeliveryAddress, TQResolveDeliveryAddressVariables>(QResolveDeliveryAddressDocument, options);
        }
export type QResolveDeliveryAddressHookResult = ReturnType<typeof useQResolveDeliveryAddress>;
export type QResolveDeliveryAddressLazyQueryHookResult = ReturnType<typeof useQResolveDeliveryAddressLazyQuery>;
export type QResolveDeliveryAddressQueryResult = ApolloReactCommon.QueryResult<TQResolveDeliveryAddress, TQResolveDeliveryAddressVariables>;
export const QLogoutWidgetDocument = gql`
    query QLogoutWidget($id: ID!) {
  user(id: $id) {
    id
    firstName
    lastName
    initials
  }
}
    `;
export function useQLogoutWidget(baseOptions: ApolloReactHooks.QueryHookOptions<TQLogoutWidget, TQLogoutWidgetVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQLogoutWidget, TQLogoutWidgetVariables>(QLogoutWidgetDocument, options);
      }
export function useQLogoutWidgetLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQLogoutWidget, TQLogoutWidgetVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQLogoutWidget, TQLogoutWidgetVariables>(QLogoutWidgetDocument, options);
        }
export type QLogoutWidgetHookResult = ReturnType<typeof useQLogoutWidget>;
export type QLogoutWidgetLazyQueryHookResult = ReturnType<typeof useQLogoutWidgetLazyQuery>;
export type QLogoutWidgetQueryResult = ApolloReactCommon.QueryResult<TQLogoutWidget, TQLogoutWidgetVariables>;
export const MCreateOrderGroupDocument = gql`
    mutation MCreateOrderGroup($name: String, $color: ID, $orders: [ID!]!) {
  createOrderGroup(orderGroup: {name: $name, orders: $orders, orderGroupColor: $color}) {
    id
  }
}
    `;
export type TMCreateOrderGroupMutationFn = ApolloReactCommon.MutationFunction<TMCreateOrderGroup, TMCreateOrderGroupVariables>;
export function useMCreateOrderGroup(baseOptions?: ApolloReactHooks.MutationHookOptions<TMCreateOrderGroup, TMCreateOrderGroupVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMCreateOrderGroup, TMCreateOrderGroupVariables>(MCreateOrderGroupDocument, options);
      }
export type MCreateOrderGroupHookResult = ReturnType<typeof useMCreateOrderGroup>;
export type MCreateOrderGroupMutationResult = ApolloReactCommon.MutationResult<TMCreateOrderGroup>;
export type MCreateOrderGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<TMCreateOrderGroup, TMCreateOrderGroupVariables>;
export const MEditOrderGroupDocument = gql`
    mutation MEditOrderGroup($color: ID, $groupId: ID!, $sortedOrderIds: [ID!]!) {
  updateOrderGroup(orderGroup: {id: $groupId, orderGroupColor: $color, updatedOrders: $sortedOrderIds}) {
    ...FOrderGroup
  }
}
    ${FOrderGroup}`;
export type TMEditOrderGroupMutationFn = ApolloReactCommon.MutationFunction<TMEditOrderGroup, TMEditOrderGroupVariables>;
export function useMEditOrderGroup(baseOptions?: ApolloReactHooks.MutationHookOptions<TMEditOrderGroup, TMEditOrderGroupVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMEditOrderGroup, TMEditOrderGroupVariables>(MEditOrderGroupDocument, options);
      }
export type MEditOrderGroupHookResult = ReturnType<typeof useMEditOrderGroup>;
export type MEditOrderGroupMutationResult = ApolloReactCommon.MutationResult<TMEditOrderGroup>;
export type MEditOrderGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<TMEditOrderGroup, TMEditOrderGroupVariables>;
export const QOrderGroupDocument = gql`
    query QOrderGroup($groupId: ID!) {
  orderGroup(id: $groupId) {
    ...FOrderGroup
    orders {
      id
      orderStateCategory(target: FE_KITCHEN)
    }
  }
}
    ${FOrderGroup}`;
export function useQOrderGroup(baseOptions: ApolloReactHooks.QueryHookOptions<TQOrderGroup, TQOrderGroupVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQOrderGroup, TQOrderGroupVariables>(QOrderGroupDocument, options);
      }
export function useQOrderGroupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQOrderGroup, TQOrderGroupVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQOrderGroup, TQOrderGroupVariables>(QOrderGroupDocument, options);
        }
export type QOrderGroupHookResult = ReturnType<typeof useQOrderGroup>;
export type QOrderGroupLazyQueryHookResult = ReturnType<typeof useQOrderGroupLazyQuery>;
export type QOrderGroupQueryResult = ApolloReactCommon.QueryResult<TQOrderGroup, TQOrderGroupVariables>;
export const QOrderGroupColorsDocument = gql`
    query QOrderGroupColors {
  colors: orderGroupColors {
    id
    code
    color
  }
}
    `;
export function useQOrderGroupColors(baseOptions?: ApolloReactHooks.QueryHookOptions<TQOrderGroupColors, TQOrderGroupColorsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQOrderGroupColors, TQOrderGroupColorsVariables>(QOrderGroupColorsDocument, options);
      }
export function useQOrderGroupColorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQOrderGroupColors, TQOrderGroupColorsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQOrderGroupColors, TQOrderGroupColorsVariables>(QOrderGroupColorsDocument, options);
        }
export type QOrderGroupColorsHookResult = ReturnType<typeof useQOrderGroupColors>;
export type QOrderGroupColorsLazyQueryHookResult = ReturnType<typeof useQOrderGroupColorsLazyQuery>;
export type QOrderGroupColorsQueryResult = ApolloReactCommon.QueryResult<TQOrderGroupColors, TQOrderGroupColorsVariables>;
export const QProductTagOptionsDocument = gql`
    query QProductTagOptions($brandId: ID!) {
  productTags: recipeTags(companies: [$brandId]) {
    ...FProductTagOption
  }
}
    ${FProductTagOption}`;
export function useQProductTagOptions(baseOptions: ApolloReactHooks.QueryHookOptions<TQProductTagOptions, TQProductTagOptionsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQProductTagOptions, TQProductTagOptionsVariables>(QProductTagOptionsDocument, options);
      }
export function useQProductTagOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQProductTagOptions, TQProductTagOptionsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQProductTagOptions, TQProductTagOptionsVariables>(QProductTagOptionsDocument, options);
        }
export type QProductTagOptionsHookResult = ReturnType<typeof useQProductTagOptions>;
export type QProductTagOptionsLazyQueryHookResult = ReturnType<typeof useQProductTagOptionsLazyQuery>;
export type QProductTagOptionsQueryResult = ApolloReactCommon.QueryResult<TQProductTagOptions, TQProductTagOptionsVariables>;
export const QWorkplacesDocument = gql`
    query QWorkplaces {
  workplaces: groups {
    id
    code
    label
  }
}
    `;
export function useQWorkplaces(baseOptions?: ApolloReactHooks.QueryHookOptions<TQWorkplaces, TQWorkplacesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQWorkplaces, TQWorkplacesVariables>(QWorkplacesDocument, options);
      }
export function useQWorkplacesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQWorkplaces, TQWorkplacesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQWorkplaces, TQWorkplacesVariables>(QWorkplacesDocument, options);
        }
export type QWorkplacesHookResult = ReturnType<typeof useQWorkplaces>;
export type QWorkplacesLazyQueryHookResult = ReturnType<typeof useQWorkplacesLazyQuery>;
export type QWorkplacesQueryResult = ApolloReactCommon.QueryResult<TQWorkplaces, TQWorkplacesVariables>;
export const QBranchCountryPhonePrefixDocument = gql`
    query QBranchCountryPhonePrefix($branchId: ID!) {
  companyBranch(id: $branchId) {
    id
    address {
      id
      country {
        id
        enum
        phonePrefix
      }
    }
  }
}
    `;
export function useQBranchCountryPhonePrefix(baseOptions: ApolloReactHooks.QueryHookOptions<TQBranchCountryPhonePrefix, TQBranchCountryPhonePrefixVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQBranchCountryPhonePrefix, TQBranchCountryPhonePrefixVariables>(QBranchCountryPhonePrefixDocument, options);
      }
export function useQBranchCountryPhonePrefixLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQBranchCountryPhonePrefix, TQBranchCountryPhonePrefixVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQBranchCountryPhonePrefix, TQBranchCountryPhonePrefixVariables>(QBranchCountryPhonePrefixDocument, options);
        }
export type QBranchCountryPhonePrefixHookResult = ReturnType<typeof useQBranchCountryPhonePrefix>;
export type QBranchCountryPhonePrefixLazyQueryHookResult = ReturnType<typeof useQBranchCountryPhonePrefixLazyQuery>;
export type QBranchCountryPhonePrefixQueryResult = ApolloReactCommon.QueryResult<TQBranchCountryPhonePrefix, TQBranchCountryPhonePrefixVariables>;
export const QFilterCashboxesDocument = gql`
    query QFilterCashboxes($branches: [ID!]) {
  cashBoxes(companyBranches: $branches) {
    id
    name
    uuid
    deleted
  }
}
    `;
export function useQFilterCashboxes(baseOptions?: ApolloReactHooks.QueryHookOptions<TQFilterCashboxes, TQFilterCashboxesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQFilterCashboxes, TQFilterCashboxesVariables>(QFilterCashboxesDocument, options);
      }
export function useQFilterCashboxesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQFilterCashboxes, TQFilterCashboxesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQFilterCashboxes, TQFilterCashboxesVariables>(QFilterCashboxesDocument, options);
        }
export type QFilterCashboxesHookResult = ReturnType<typeof useQFilterCashboxes>;
export type QFilterCashboxesLazyQueryHookResult = ReturnType<typeof useQFilterCashboxesLazyQuery>;
export type QFilterCashboxesQueryResult = ApolloReactCommon.QueryResult<TQFilterCashboxes, TQFilterCashboxesVariables>;
export const QFilterCashiersDocument = gql`
    query QFilterCashiers($branches: [ID!]) {
  cashiers(companyBranches: $branches) {
    id
    firstName
    lastName
  }
}
    `;
export function useQFilterCashiers(baseOptions?: ApolloReactHooks.QueryHookOptions<TQFilterCashiers, TQFilterCashiersVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQFilterCashiers, TQFilterCashiersVariables>(QFilterCashiersDocument, options);
      }
export function useQFilterCashiersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQFilterCashiers, TQFilterCashiersVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQFilterCashiers, TQFilterCashiersVariables>(QFilterCashiersDocument, options);
        }
export type QFilterCashiersHookResult = ReturnType<typeof useQFilterCashiers>;
export type QFilterCashiersLazyQueryHookResult = ReturnType<typeof useQFilterCashiersLazyQuery>;
export type QFilterCashiersQueryResult = ApolloReactCommon.QueryResult<TQFilterCashiers, TQFilterCashiersVariables>;
export const QFilterCountriesDocument = gql`
    query QFilterCountries {
  countries {
    id
    code
    enum
  }
}
    `;
export function useQFilterCountries(baseOptions?: ApolloReactHooks.QueryHookOptions<TQFilterCountries, TQFilterCountriesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQFilterCountries, TQFilterCountriesVariables>(QFilterCountriesDocument, options);
      }
export function useQFilterCountriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQFilterCountries, TQFilterCountriesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQFilterCountries, TQFilterCountriesVariables>(QFilterCountriesDocument, options);
        }
export type QFilterCountriesHookResult = ReturnType<typeof useQFilterCountries>;
export type QFilterCountriesLazyQueryHookResult = ReturnType<typeof useQFilterCountriesLazyQuery>;
export type QFilterCountriesQueryResult = ApolloReactCommon.QueryResult<TQFilterCountries, TQFilterCountriesVariables>;
export const QFilterDriversDocument = gql`
    query QFilterDrivers($branches: [ID!]!, $withExternalDrivers: Boolean!) {
  drivers(companyBranches: $branches, onlyAvailable: false, showExternalApi: $withExternalDrivers) {
    ...FDriver
  }
}
    ${FDriver}`;
export function useQFilterDrivers(baseOptions: ApolloReactHooks.QueryHookOptions<TQFilterDrivers, TQFilterDriversVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQFilterDrivers, TQFilterDriversVariables>(QFilterDriversDocument, options);
      }
export function useQFilterDriversLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQFilterDrivers, TQFilterDriversVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQFilterDrivers, TQFilterDriversVariables>(QFilterDriversDocument, options);
        }
export type QFilterDriversHookResult = ReturnType<typeof useQFilterDrivers>;
export type QFilterDriversLazyQueryHookResult = ReturnType<typeof useQFilterDriversLazyQuery>;
export type QFilterDriversQueryResult = ApolloReactCommon.QueryResult<TQFilterDrivers, TQFilterDriversVariables>;
export const QFilterOriginsDocument = gql`
    query QFilterOrigins {
  origins: orderOrigins {
    code
    enum
  }
}
    `;
export function useQFilterOrigins(baseOptions?: ApolloReactHooks.QueryHookOptions<TQFilterOrigins, TQFilterOriginsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQFilterOrigins, TQFilterOriginsVariables>(QFilterOriginsDocument, options);
      }
export function useQFilterOriginsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQFilterOrigins, TQFilterOriginsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQFilterOrigins, TQFilterOriginsVariables>(QFilterOriginsDocument, options);
        }
export type QFilterOriginsHookResult = ReturnType<typeof useQFilterOrigins>;
export type QFilterOriginsLazyQueryHookResult = ReturnType<typeof useQFilterOriginsLazyQuery>;
export type QFilterOriginsQueryResult = ApolloReactCommon.QueryResult<TQFilterOrigins, TQFilterOriginsVariables>;
export const QFilterPaymentGatesDocument = gql`
    query QFilterPaymentGates {
  paymentGates {
    id
    code
    enum
  }
}
    `;
export function useQFilterPaymentGates(baseOptions?: ApolloReactHooks.QueryHookOptions<TQFilterPaymentGates, TQFilterPaymentGatesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQFilterPaymentGates, TQFilterPaymentGatesVariables>(QFilterPaymentGatesDocument, options);
      }
export function useQFilterPaymentGatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQFilterPaymentGates, TQFilterPaymentGatesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQFilterPaymentGates, TQFilterPaymentGatesVariables>(QFilterPaymentGatesDocument, options);
        }
export type QFilterPaymentGatesHookResult = ReturnType<typeof useQFilterPaymentGates>;
export type QFilterPaymentGatesLazyQueryHookResult = ReturnType<typeof useQFilterPaymentGatesLazyQuery>;
export type QFilterPaymentGatesQueryResult = ApolloReactCommon.QueryResult<TQFilterPaymentGates, TQFilterPaymentGatesVariables>;
export const QFilterPromoTagsDocument = gql`
    query QFilterPromoTags {
  promoTags {
    ...FPromoTag
  }
}
    ${FPromoTag}`;
export function useQFilterPromoTags(baseOptions?: ApolloReactHooks.QueryHookOptions<TQFilterPromoTags, TQFilterPromoTagsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQFilterPromoTags, TQFilterPromoTagsVariables>(QFilterPromoTagsDocument, options);
      }
export function useQFilterPromoTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQFilterPromoTags, TQFilterPromoTagsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQFilterPromoTags, TQFilterPromoTagsVariables>(QFilterPromoTagsDocument, options);
        }
export type QFilterPromoTagsHookResult = ReturnType<typeof useQFilterPromoTags>;
export type QFilterPromoTagsLazyQueryHookResult = ReturnType<typeof useQFilterPromoTagsLazyQuery>;
export type QFilterPromoTagsQueryResult = ApolloReactCommon.QueryResult<TQFilterPromoTags, TQFilterPromoTagsVariables>;
export const QFilterSectorsDocument = gql`
    query QFilterSectors($branches: [ID!]!) {
  sectors(companyBranches: $branches, enabled: true) {
    id
    code
    name
    parent {
      id
    }
    companyBranch {
      id
    }
  }
}
    `;
export function useQFilterSectors(baseOptions: ApolloReactHooks.QueryHookOptions<TQFilterSectors, TQFilterSectorsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQFilterSectors, TQFilterSectorsVariables>(QFilterSectorsDocument, options);
      }
export function useQFilterSectorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQFilterSectors, TQFilterSectorsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQFilterSectors, TQFilterSectorsVariables>(QFilterSectorsDocument, options);
        }
export type QFilterSectorsHookResult = ReturnType<typeof useQFilterSectors>;
export type QFilterSectorsLazyQueryHookResult = ReturnType<typeof useQFilterSectorsLazyQuery>;
export type QFilterSectorsQueryResult = ApolloReactCommon.QueryResult<TQFilterSectors, TQFilterSectorsVariables>;
export const MRequestReprintDocument = gql`
    mutation MRequestReprint($printerId: ID!, $templateId: ID!, $thisPcMAC: String!, $printObjectId: ID!) {
  printRecord: createPrintQueue(printer: $printerId, template: $templateId, targetMac: $thisPcMAC, printableObject: $printObjectId) {
    id
  }
}
    `;
export type TMRequestReprintMutationFn = ApolloReactCommon.MutationFunction<TMRequestReprint, TMRequestReprintVariables>;
export function useMRequestReprint(baseOptions?: ApolloReactHooks.MutationHookOptions<TMRequestReprint, TMRequestReprintVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMRequestReprint, TMRequestReprintVariables>(MRequestReprintDocument, options);
      }
export type MRequestReprintHookResult = ReturnType<typeof useMRequestReprint>;
export type MRequestReprintMutationResult = ApolloReactCommon.MutationResult<TMRequestReprint>;
export type MRequestReprintMutationOptions = ApolloReactCommon.BaseMutationOptions<TMRequestReprint, TMRequestReprintVariables>;
export const QReprintTemplatesDocument = gql`
    query QReprintTemplates($companyBranchIds: [ID!]!, $forPrintableObject: TriggerableTypeEnum!) {
  printTemplates(triggerableType: $forPrintableObject, companyBranches: $companyBranchIds) {
    ...FPrintTemplate
  }
}
    ${FPrintTemplate}`;
export function useQReprintTemplates(baseOptions: ApolloReactHooks.QueryHookOptions<TQReprintTemplates, TQReprintTemplatesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQReprintTemplates, TQReprintTemplatesVariables>(QReprintTemplatesDocument, options);
      }
export function useQReprintTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQReprintTemplates, TQReprintTemplatesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQReprintTemplates, TQReprintTemplatesVariables>(QReprintTemplatesDocument, options);
        }
export type QReprintTemplatesHookResult = ReturnType<typeof useQReprintTemplates>;
export type QReprintTemplatesLazyQueryHookResult = ReturnType<typeof useQReprintTemplatesLazyQuery>;
export type QReprintTemplatesQueryResult = ApolloReactCommon.QueryResult<TQReprintTemplates, TQReprintTemplatesVariables>;
export const MOrderStateDocument = gql`
    mutation MOrderState($orderId: ID!, $state: OrderStateEnum!) {
  addOrderState(order: $orderId, orderState: $state) {
    ...FOrderStateCategory
    ...FOrderForTimeline
  }
}
    ${FOrderStateCategory}
${FOrderForTimeline}`;
export type TMOrderStateMutationFn = ApolloReactCommon.MutationFunction<TMOrderState, TMOrderStateVariables>;
export function useMOrderState(baseOptions?: ApolloReactHooks.MutationHookOptions<TMOrderState, TMOrderStateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMOrderState, TMOrderStateVariables>(MOrderStateDocument, options);
      }
export type MOrderStateHookResult = ReturnType<typeof useMOrderState>;
export type MOrderStateMutationResult = ApolloReactCommon.MutationResult<TMOrderState>;
export type MOrderStateMutationOptions = ApolloReactCommon.BaseMutationOptions<TMOrderState, TMOrderStateVariables>;
export const MSetPriorityOrderDocument = gql`
    mutation MSetPriorityOrder($orderId: ID!, $isPriority: Boolean!) {
  setPriorityOrder(order: $orderId, isPriority: $isPriority) {
    id
    isPriority
  }
}
    `;
export type TMSetPriorityOrderMutationFn = ApolloReactCommon.MutationFunction<TMSetPriorityOrder, TMSetPriorityOrderVariables>;
export function useMSetPriorityOrder(baseOptions?: ApolloReactHooks.MutationHookOptions<TMSetPriorityOrder, TMSetPriorityOrderVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMSetPriorityOrder, TMSetPriorityOrderVariables>(MSetPriorityOrderDocument, options);
      }
export type MSetPriorityOrderHookResult = ReturnType<typeof useMSetPriorityOrder>;
export type MSetPriorityOrderMutationResult = ApolloReactCommon.MutationResult<TMSetPriorityOrder>;
export type MSetPriorityOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<TMSetPriorityOrder, TMSetPriorityOrderVariables>;
export const MCreateEmployeeDocument = gql`
    mutation MCreateEmployee($userData: InputUserCreate!) {
  createdEmployee: createUser(user: $userData) {
    ...FEmployee
  }
}
    ${FEmployee}`;
export type TMCreateEmployeeMutationFn = ApolloReactCommon.MutationFunction<TMCreateEmployee, TMCreateEmployeeVariables>;
export function useMCreateEmployee(baseOptions?: ApolloReactHooks.MutationHookOptions<TMCreateEmployee, TMCreateEmployeeVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMCreateEmployee, TMCreateEmployeeVariables>(MCreateEmployeeDocument, options);
      }
export type MCreateEmployeeHookResult = ReturnType<typeof useMCreateEmployee>;
export type MCreateEmployeeMutationResult = ApolloReactCommon.MutationResult<TMCreateEmployee>;
export type MCreateEmployeeMutationOptions = ApolloReactCommon.BaseMutationOptions<TMCreateEmployee, TMCreateEmployeeVariables>;
export const MCreateEmploymentDocument = gql`
    mutation MCreateEmployment($employeeId: ID!, $branchId: ID!) {
  createCompanyBranchUser(user: $employeeId, companyBranch: $branchId) {
    id
  }
}
    `;
export type TMCreateEmploymentMutationFn = ApolloReactCommon.MutationFunction<TMCreateEmployment, TMCreateEmploymentVariables>;
export function useMCreateEmployment(baseOptions?: ApolloReactHooks.MutationHookOptions<TMCreateEmployment, TMCreateEmploymentVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMCreateEmployment, TMCreateEmploymentVariables>(MCreateEmploymentDocument, options);
      }
export type MCreateEmploymentHookResult = ReturnType<typeof useMCreateEmployment>;
export type MCreateEmploymentMutationResult = ApolloReactCommon.MutationResult<TMCreateEmployment>;
export type MCreateEmploymentMutationOptions = ApolloReactCommon.BaseMutationOptions<TMCreateEmployment, TMCreateEmploymentVariables>;
export const MDeactivateEmploymentDocument = gql`
    mutation MDeactivateEmployment($employmentId: ID!) {
  destroyCompanyBranchUser(companyBranchUser: $employmentId) {
    id
  }
}
    `;
export type TMDeactivateEmploymentMutationFn = ApolloReactCommon.MutationFunction<TMDeactivateEmployment, TMDeactivateEmploymentVariables>;
export function useMDeactivateEmployment(baseOptions?: ApolloReactHooks.MutationHookOptions<TMDeactivateEmployment, TMDeactivateEmploymentVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMDeactivateEmployment, TMDeactivateEmploymentVariables>(MDeactivateEmploymentDocument, options);
      }
export type MDeactivateEmploymentHookResult = ReturnType<typeof useMDeactivateEmployment>;
export type MDeactivateEmploymentMutationResult = ApolloReactCommon.MutationResult<TMDeactivateEmployment>;
export type MDeactivateEmploymentMutationOptions = ApolloReactCommon.BaseMutationOptions<TMDeactivateEmployment, TMDeactivateEmploymentVariables>;
export const MSuspendUserDocument = gql`
    mutation MSuspendUser($userId: ID!) {
  suspendedUser: suspendUser(id: $userId) {
    ...FEmployee
  }
}
    ${FEmployee}`;
export type TMSuspendUserMutationFn = ApolloReactCommon.MutationFunction<TMSuspendUser, TMSuspendUserVariables>;
export function useMSuspendUser(baseOptions?: ApolloReactHooks.MutationHookOptions<TMSuspendUser, TMSuspendUserVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMSuspendUser, TMSuspendUserVariables>(MSuspendUserDocument, options);
      }
export type MSuspendUserHookResult = ReturnType<typeof useMSuspendUser>;
export type MSuspendUserMutationResult = ApolloReactCommon.MutationResult<TMSuspendUser>;
export type MSuspendUserMutationOptions = ApolloReactCommon.BaseMutationOptions<TMSuspendUser, TMSuspendUserVariables>;
export const MUpdateEmployeeDocument = gql`
    mutation MUpdateEmployee($employeeId: ID!, $userData: InputUserUpdate!) {
  updatedEmployee: updateUser(id: $employeeId, user: $userData) {
    ...FEmployee
  }
}
    ${FEmployee}`;
export type TMUpdateEmployeeMutationFn = ApolloReactCommon.MutationFunction<TMUpdateEmployee, TMUpdateEmployeeVariables>;
export function useMUpdateEmployee(baseOptions?: ApolloReactHooks.MutationHookOptions<TMUpdateEmployee, TMUpdateEmployeeVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMUpdateEmployee, TMUpdateEmployeeVariables>(MUpdateEmployeeDocument, options);
      }
export type MUpdateEmployeeHookResult = ReturnType<typeof useMUpdateEmployee>;
export type MUpdateEmployeeMutationResult = ApolloReactCommon.MutationResult<TMUpdateEmployee>;
export type MUpdateEmployeeMutationOptions = ApolloReactCommon.BaseMutationOptions<TMUpdateEmployee, TMUpdateEmployeeVariables>;
export const QEmployeeFormConfigDocument = gql`
    query QEmployeeFormConfig($userId: ID!) {
  user(id: $userId) {
    id
    settings {
      canAssignRoles: userAssignableRoles {
        ...FEmployeeRole
      }
    }
  }
  languages {
    ...FLanguage
  }
}
    ${FEmployeeRole}
${FLanguage}`;
export function useQEmployeeFormConfig(baseOptions: ApolloReactHooks.QueryHookOptions<TQEmployeeFormConfig, TQEmployeeFormConfigVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQEmployeeFormConfig, TQEmployeeFormConfigVariables>(QEmployeeFormConfigDocument, options);
      }
export function useQEmployeeFormConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQEmployeeFormConfig, TQEmployeeFormConfigVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQEmployeeFormConfig, TQEmployeeFormConfigVariables>(QEmployeeFormConfigDocument, options);
        }
export type QEmployeeFormConfigHookResult = ReturnType<typeof useQEmployeeFormConfig>;
export type QEmployeeFormConfigLazyQueryHookResult = ReturnType<typeof useQEmployeeFormConfigLazyQuery>;
export type QEmployeeFormConfigQueryResult = ApolloReactCommon.QueryResult<TQEmployeeFormConfig, TQEmployeeFormConfigVariables>;
export const QEmployeeListDocument = gql`
    query QEmployeeList($branchIds: [ID!]!) {
  employees: users(companyBranches: $branchIds) {
    ...FEmployee
  }
}
    ${FEmployee}`;
export function useQEmployeeList(baseOptions: ApolloReactHooks.QueryHookOptions<TQEmployeeList, TQEmployeeListVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQEmployeeList, TQEmployeeListVariables>(QEmployeeListDocument, options);
      }
export function useQEmployeeListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQEmployeeList, TQEmployeeListVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQEmployeeList, TQEmployeeListVariables>(QEmployeeListDocument, options);
        }
export type QEmployeeListHookResult = ReturnType<typeof useQEmployeeList>;
export type QEmployeeListLazyQueryHookResult = ReturnType<typeof useQEmployeeListLazyQuery>;
export type QEmployeeListQueryResult = ApolloReactCommon.QueryResult<TQEmployeeList, TQEmployeeListVariables>;
export const QProductTagBrandDocument = gql`
    query QProductTagBrand($tagId: ID!, $brandId: ID!, $byTag: Boolean!) {
  tag: recipeTag(id: $tagId) @include(if: $byTag) {
    id
    brand: company {
      ...FProductTagBrand
    }
  }
  brand: company(id: $brandId) @skip(if: $byTag) {
    ...FProductTagBrand
  }
}
    ${FProductTagBrand}`;
export function useQProductTagBrand(baseOptions: ApolloReactHooks.QueryHookOptions<TQProductTagBrand, TQProductTagBrandVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQProductTagBrand, TQProductTagBrandVariables>(QProductTagBrandDocument, options);
      }
export function useQProductTagBrandLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQProductTagBrand, TQProductTagBrandVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQProductTagBrand, TQProductTagBrandVariables>(QProductTagBrandDocument, options);
        }
export type QProductTagBrandHookResult = ReturnType<typeof useQProductTagBrand>;
export type QProductTagBrandLazyQueryHookResult = ReturnType<typeof useQProductTagBrandLazyQuery>;
export type QProductTagBrandQueryResult = ApolloReactCommon.QueryResult<TQProductTagBrand, TQProductTagBrandVariables>;
export const QProductTagDetailDocument = gql`
    query QProductTagDetail($tagId: ID!) {
  tag: recipeTag(id: $tagId, skipSystemTagFallback: true) {
    ...FProductTagDetail
  }
}
    ${FProductTagDetail}`;
export function useQProductTagDetail(baseOptions: ApolloReactHooks.QueryHookOptions<TQProductTagDetail, TQProductTagDetailVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQProductTagDetail, TQProductTagDetailVariables>(QProductTagDetailDocument, options);
      }
export function useQProductTagDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQProductTagDetail, TQProductTagDetailVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQProductTagDetail, TQProductTagDetailVariables>(QProductTagDetailDocument, options);
        }
export type QProductTagDetailHookResult = ReturnType<typeof useQProductTagDetail>;
export type QProductTagDetailLazyQueryHookResult = ReturnType<typeof useQProductTagDetailLazyQuery>;
export type QProductTagDetailQueryResult = ApolloReactCommon.QueryResult<TQProductTagDetail, TQProductTagDetailVariables>;
export const QProductTagRelationsDocument = gql`
    query QProductTagRelations($branchIds: [ID!]!) {
  relations: recipeTagRelations(usedByCompanyBranches: $branchIds) {
    id
    inherited
    productTag: recipeTag {
      id
    }
    relatedObject: taggable {
      __typename
      ... on Recipe {
        ...FProductTagRelatedRecipe
      }
      ... on WareCategory {
        ...FProductTagRelatedCategory
      }
    }
  }
}
    ${FProductTagRelatedRecipe}
${FProductTagRelatedCategory}`;
export function useQProductTagRelations(baseOptions: ApolloReactHooks.QueryHookOptions<TQProductTagRelations, TQProductTagRelationsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQProductTagRelations, TQProductTagRelationsVariables>(QProductTagRelationsDocument, options);
      }
export function useQProductTagRelationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQProductTagRelations, TQProductTagRelationsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQProductTagRelations, TQProductTagRelationsVariables>(QProductTagRelationsDocument, options);
        }
export type QProductTagRelationsHookResult = ReturnType<typeof useQProductTagRelations>;
export type QProductTagRelationsLazyQueryHookResult = ReturnType<typeof useQProductTagRelationsLazyQuery>;
export type QProductTagRelationsQueryResult = ApolloReactCommon.QueryResult<TQProductTagRelations, TQProductTagRelationsVariables>;
export const QSystemProductTagsDocument = gql`
    query QSystemProductTags {
  productTags: recipeTags(systemTags: true) {
    ...FProductTagInList
  }
}
    ${FProductTagInList}`;
export function useQSystemProductTags(baseOptions?: ApolloReactHooks.QueryHookOptions<TQSystemProductTags, TQSystemProductTagsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQSystemProductTags, TQSystemProductTagsVariables>(QSystemProductTagsDocument, options);
      }
export function useQSystemProductTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQSystemProductTags, TQSystemProductTagsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQSystemProductTags, TQSystemProductTagsVariables>(QSystemProductTagsDocument, options);
        }
export type QSystemProductTagsHookResult = ReturnType<typeof useQSystemProductTags>;
export type QSystemProductTagsLazyQueryHookResult = ReturnType<typeof useQSystemProductTagsLazyQuery>;
export type QSystemProductTagsQueryResult = ApolloReactCommon.QueryResult<TQSystemProductTags, TQSystemProductTagsVariables>;
export const QProductTagListDocument = gql`
    query QProductTagList($brandId: ID!, $branchIds: [ID!]!) {
  productTags: recipeTags(companies: [$brandId]) {
    ...FProductTagInList
  }
  relations: recipeTagRelations(usedByCompanyBranches: $branchIds) {
    id
    inherited
    recipeTag {
      id
    }
  }
}
    ${FProductTagInList}`;
export function useQProductTagList(baseOptions: ApolloReactHooks.QueryHookOptions<TQProductTagList, TQProductTagListVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQProductTagList, TQProductTagListVariables>(QProductTagListDocument, options);
      }
export function useQProductTagListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQProductTagList, TQProductTagListVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQProductTagList, TQProductTagListVariables>(QProductTagListDocument, options);
        }
export type QProductTagListHookResult = ReturnType<typeof useQProductTagList>;
export type QProductTagListLazyQueryHookResult = ReturnType<typeof useQProductTagListLazyQuery>;
export type QProductTagListQueryResult = ApolloReactCommon.QueryResult<TQProductTagList, TQProductTagListVariables>;
export const MCreateProductTagDocument = gql`
    mutation MCreateProductTag($brandId: ID!, $originTagId: ID!, $color: String, $image: InputFile, $pictogram: String, $translatedNameLabels: [InputRecipeTagTranslation!]!) {
  createdTag: createRecipeTag(recipeTag: {company: $brandId, systemRecipeTag: $originTagId, color: $color, image: $image, pictogram: $pictogram, translations: $translatedNameLabels}) {
    ...FProductTagInList
  }
}
    ${FProductTagInList}`;
export type TMCreateProductTagMutationFn = ApolloReactCommon.MutationFunction<TMCreateProductTag, TMCreateProductTagVariables>;
export function useMCreateProductTag(baseOptions?: ApolloReactHooks.MutationHookOptions<TMCreateProductTag, TMCreateProductTagVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMCreateProductTag, TMCreateProductTagVariables>(MCreateProductTagDocument, options);
      }
export type MCreateProductTagHookResult = ReturnType<typeof useMCreateProductTag>;
export type MCreateProductTagMutationResult = ApolloReactCommon.MutationResult<TMCreateProductTag>;
export type MCreateProductTagMutationOptions = ApolloReactCommon.BaseMutationOptions<TMCreateProductTag, TMCreateProductTagVariables>;
export const MDeleteProductTagDocument = gql`
    mutation MDeleteProductTag($tagId: ID!) {
  deletedTag: destroyRecipeTag(id: $tagId) {
    id
  }
}
    `;
export type TMDeleteProductTagMutationFn = ApolloReactCommon.MutationFunction<TMDeleteProductTag, TMDeleteProductTagVariables>;
export function useMDeleteProductTag(baseOptions?: ApolloReactHooks.MutationHookOptions<TMDeleteProductTag, TMDeleteProductTagVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMDeleteProductTag, TMDeleteProductTagVariables>(MDeleteProductTagDocument, options);
      }
export type MDeleteProductTagHookResult = ReturnType<typeof useMDeleteProductTag>;
export type MDeleteProductTagMutationResult = ApolloReactCommon.MutationResult<TMDeleteProductTag>;
export type MDeleteProductTagMutationOptions = ApolloReactCommon.BaseMutationOptions<TMDeleteProductTag, TMDeleteProductTagVariables>;
export const MUpdateProductTagDocument = gql`
    mutation MUpdateProductTag($tagId: ID!, $originTagId: ID, $color: String, $pictogram: String, $deleteLabel: Boolean, $image: InputRecipeTagImage, $translatedNameLabels: [InputRecipeTagTranslation!]!) {
  updatedTag: updateRecipeTag(id: $tagId, recipeTag: {systemRecipeTag: $originTagId, color: $color, image: $image, pictogram: $pictogram, deleteLabel: $deleteLabel, translations: $translatedNameLabels}) {
    ...FProductTagInList
  }
}
    ${FProductTagInList}`;
export type TMUpdateProductTagMutationFn = ApolloReactCommon.MutationFunction<TMUpdateProductTag, TMUpdateProductTagVariables>;
export function useMUpdateProductTag(baseOptions?: ApolloReactHooks.MutationHookOptions<TMUpdateProductTag, TMUpdateProductTagVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMUpdateProductTag, TMUpdateProductTagVariables>(MUpdateProductTagDocument, options);
      }
export type MUpdateProductTagHookResult = ReturnType<typeof useMUpdateProductTag>;
export type MUpdateProductTagMutationResult = ApolloReactCommon.MutationResult<TMUpdateProductTag>;
export type MUpdateProductTagMutationOptions = ApolloReactCommon.BaseMutationOptions<TMUpdateProductTag, TMUpdateProductTagVariables>;
export const MBusinessHoursSubmitDocument = gql`
    mutation MBusinessHoursSubmit($branchId: ID!, $hours: [InputBusinessHourCreate!]!, $mode: BusinessHoursModeEnum!) {
  createBusinessHours(companyBranch: $branchId, businessHours: $hours, mode: $mode) {
    ...FRegularBusinessHour
  }
}
    ${FRegularBusinessHour}`;
export type TMBusinessHoursSubmitMutationFn = ApolloReactCommon.MutationFunction<TMBusinessHoursSubmit, TMBusinessHoursSubmitVariables>;
export function useMBusinessHoursSubmit(baseOptions?: ApolloReactHooks.MutationHookOptions<TMBusinessHoursSubmit, TMBusinessHoursSubmitVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMBusinessHoursSubmit, TMBusinessHoursSubmitVariables>(MBusinessHoursSubmitDocument, options);
      }
export type MBusinessHoursSubmitHookResult = ReturnType<typeof useMBusinessHoursSubmit>;
export type MBusinessHoursSubmitMutationResult = ApolloReactCommon.MutationResult<TMBusinessHoursSubmit>;
export type MBusinessHoursSubmitMutationOptions = ApolloReactCommon.BaseMutationOptions<TMBusinessHoursSubmit, TMBusinessHoursSubmitVariables>;
export const MSpecificBusinessHourCreateDocument = gql`
    mutation MSpecificBusinessHourCreate($input: InputBusinessHourSpecificDateCreate!) {
  result: addSpecialBusinessHour(businessHour: $input) {
    ...FSpecificBusinessHour
  }
}
    ${FSpecificBusinessHour}`;
export type TMSpecificBusinessHourCreateMutationFn = ApolloReactCommon.MutationFunction<TMSpecificBusinessHourCreate, TMSpecificBusinessHourCreateVariables>;
export function useMSpecificBusinessHourCreate(baseOptions?: ApolloReactHooks.MutationHookOptions<TMSpecificBusinessHourCreate, TMSpecificBusinessHourCreateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMSpecificBusinessHourCreate, TMSpecificBusinessHourCreateVariables>(MSpecificBusinessHourCreateDocument, options);
      }
export type MSpecificBusinessHourCreateHookResult = ReturnType<typeof useMSpecificBusinessHourCreate>;
export type MSpecificBusinessHourCreateMutationResult = ApolloReactCommon.MutationResult<TMSpecificBusinessHourCreate>;
export type MSpecificBusinessHourCreateMutationOptions = ApolloReactCommon.BaseMutationOptions<TMSpecificBusinessHourCreate, TMSpecificBusinessHourCreateVariables>;
export const MSpecificBusinessHourDeleteDocument = gql`
    mutation MSpecificBusinessHourDelete($id: ID!) {
  result: destroyBusinessHour(id: $id) {
    id
  }
}
    `;
export type TMSpecificBusinessHourDeleteMutationFn = ApolloReactCommon.MutationFunction<TMSpecificBusinessHourDelete, TMSpecificBusinessHourDeleteVariables>;
export function useMSpecificBusinessHourDelete(baseOptions?: ApolloReactHooks.MutationHookOptions<TMSpecificBusinessHourDelete, TMSpecificBusinessHourDeleteVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMSpecificBusinessHourDelete, TMSpecificBusinessHourDeleteVariables>(MSpecificBusinessHourDeleteDocument, options);
      }
export type MSpecificBusinessHourDeleteHookResult = ReturnType<typeof useMSpecificBusinessHourDelete>;
export type MSpecificBusinessHourDeleteMutationResult = ApolloReactCommon.MutationResult<TMSpecificBusinessHourDelete>;
export type MSpecificBusinessHourDeleteMutationOptions = ApolloReactCommon.BaseMutationOptions<TMSpecificBusinessHourDelete, TMSpecificBusinessHourDeleteVariables>;
export const MUpdateBoltBusinessHoursDocument = gql`
    mutation MUpdateBoltBusinessHours($profileId: ID!, $businessHours: [InputIntegrationsBusinessHourCreate!]!) {
  pushIntegrationsBusinessHours(profileId: $profileId, profileIntegration: BOLT, businessHours: $businessHours) {
    id
  }
}
    `;
export type TMUpdateBoltBusinessHoursMutationFn = ApolloReactCommon.MutationFunction<TMUpdateBoltBusinessHours, TMUpdateBoltBusinessHoursVariables>;
export function useMUpdateBoltBusinessHours(baseOptions?: ApolloReactHooks.MutationHookOptions<TMUpdateBoltBusinessHours, TMUpdateBoltBusinessHoursVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMUpdateBoltBusinessHours, TMUpdateBoltBusinessHoursVariables>(MUpdateBoltBusinessHoursDocument, options);
      }
export type MUpdateBoltBusinessHoursHookResult = ReturnType<typeof useMUpdateBoltBusinessHours>;
export type MUpdateBoltBusinessHoursMutationResult = ApolloReactCommon.MutationResult<TMUpdateBoltBusinessHours>;
export type MUpdateBoltBusinessHoursMutationOptions = ApolloReactCommon.BaseMutationOptions<TMUpdateBoltBusinessHours, TMUpdateBoltBusinessHoursVariables>;
export const MUpdateUsualHandoverTimeDocument = gql`
    mutation MUpdateUsualHandoverTime($minutes: Int!, $branchId: ID!, $handoverType: DeliveryTypeEnum!) {
  handoverTimes: updateDefaultOrderProcessTime(defaultTime: $minutes, companyBranch: $branchId, deliveryType: $handoverType) {
    ...FUsualHandoverTimes
  }
}
    ${FUsualHandoverTimes}`;
export type TMUpdateUsualHandoverTimeMutationFn = ApolloReactCommon.MutationFunction<TMUpdateUsualHandoverTime, TMUpdateUsualHandoverTimeVariables>;
export function useMUpdateUsualHandoverTime(baseOptions?: ApolloReactHooks.MutationHookOptions<TMUpdateUsualHandoverTime, TMUpdateUsualHandoverTimeVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMUpdateUsualHandoverTime, TMUpdateUsualHandoverTimeVariables>(MUpdateUsualHandoverTimeDocument, options);
      }
export type MUpdateUsualHandoverTimeHookResult = ReturnType<typeof useMUpdateUsualHandoverTime>;
export type MUpdateUsualHandoverTimeMutationResult = ApolloReactCommon.MutationResult<TMUpdateUsualHandoverTime>;
export type MUpdateUsualHandoverTimeMutationOptions = ApolloReactCommon.BaseMutationOptions<TMUpdateUsualHandoverTime, TMUpdateUsualHandoverTimeVariables>;
export const MUpdateWoltBusinessHoursDocument = gql`
    mutation MUpdateWoltBusinessHours($profileId: ID!, $businessHours: [InputBusinessHourCreate!]!) {
  updateWoltBusinessHours(profileId: $profileId, businessHours: $businessHours) {
    id
  }
}
    `;
export type TMUpdateWoltBusinessHoursMutationFn = ApolloReactCommon.MutationFunction<TMUpdateWoltBusinessHours, TMUpdateWoltBusinessHoursVariables>;
export function useMUpdateWoltBusinessHours(baseOptions?: ApolloReactHooks.MutationHookOptions<TMUpdateWoltBusinessHours, TMUpdateWoltBusinessHoursVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMUpdateWoltBusinessHours, TMUpdateWoltBusinessHoursVariables>(MUpdateWoltBusinessHoursDocument, options);
      }
export type MUpdateWoltBusinessHoursHookResult = ReturnType<typeof useMUpdateWoltBusinessHours>;
export type MUpdateWoltBusinessHoursMutationResult = ApolloReactCommon.MutationResult<TMUpdateWoltBusinessHours>;
export type MUpdateWoltBusinessHoursMutationOptions = ApolloReactCommon.BaseMutationOptions<TMUpdateWoltBusinessHours, TMUpdateWoltBusinessHoursVariables>;
export const MWoltBusinessHoursDocument = gql`
    mutation MWoltBusinessHours($profileId: ID!) {
  woltProfileStatus(profileId: $profileId) {
    ...FWoltOpeningTimes
  }
}
    ${FWoltOpeningTimes}`;
export type TMWoltBusinessHoursMutationFn = ApolloReactCommon.MutationFunction<TMWoltBusinessHours, TMWoltBusinessHoursVariables>;
export function useMWoltBusinessHours(baseOptions?: ApolloReactHooks.MutationHookOptions<TMWoltBusinessHours, TMWoltBusinessHoursVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMWoltBusinessHours, TMWoltBusinessHoursVariables>(MWoltBusinessHoursDocument, options);
      }
export type MWoltBusinessHoursHookResult = ReturnType<typeof useMWoltBusinessHours>;
export type MWoltBusinessHoursMutationResult = ApolloReactCommon.MutationResult<TMWoltBusinessHours>;
export type MWoltBusinessHoursMutationOptions = ApolloReactCommon.BaseMutationOptions<TMWoltBusinessHours, TMWoltBusinessHoursVariables>;
export const QBoltBusinessHoursDocument = gql`
    query QBoltBusinessHours($profileId: ID!) {
  integrationsBusinessHours(profileId: $profileId, profileIntegration: BOLT) {
    id
    openAt
    closeAt
    weekDay {
      id
      enum
    }
  }
}
    `;
export function useQBoltBusinessHours(baseOptions: ApolloReactHooks.QueryHookOptions<TQBoltBusinessHours, TQBoltBusinessHoursVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQBoltBusinessHours, TQBoltBusinessHoursVariables>(QBoltBusinessHoursDocument, options);
      }
export function useQBoltBusinessHoursLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQBoltBusinessHours, TQBoltBusinessHoursVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQBoltBusinessHours, TQBoltBusinessHoursVariables>(QBoltBusinessHoursDocument, options);
        }
export type QBoltBusinessHoursHookResult = ReturnType<typeof useQBoltBusinessHours>;
export type QBoltBusinessHoursLazyQueryHookResult = ReturnType<typeof useQBoltBusinessHoursLazyQuery>;
export type QBoltBusinessHoursQueryResult = ApolloReactCommon.QueryResult<TQBoltBusinessHours, TQBoltBusinessHoursVariables>;
export const QRegularBusinessHoursDocument = gql`
    query QRegularBusinessHours($branchId: ID!, $mode: BusinessHoursModeEnum!) {
  businessHours(companyBranch: $branchId, mode: $mode) {
    ...FRegularBusinessHour
  }
}
    ${FRegularBusinessHour}`;
export function useQRegularBusinessHours(baseOptions: ApolloReactHooks.QueryHookOptions<TQRegularBusinessHours, TQRegularBusinessHoursVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQRegularBusinessHours, TQRegularBusinessHoursVariables>(QRegularBusinessHoursDocument, options);
      }
export function useQRegularBusinessHoursLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQRegularBusinessHours, TQRegularBusinessHoursVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQRegularBusinessHours, TQRegularBusinessHoursVariables>(QRegularBusinessHoursDocument, options);
        }
export type QRegularBusinessHoursHookResult = ReturnType<typeof useQRegularBusinessHours>;
export type QRegularBusinessHoursLazyQueryHookResult = ReturnType<typeof useQRegularBusinessHoursLazyQuery>;
export type QRegularBusinessHoursQueryResult = ApolloReactCommon.QueryResult<TQRegularBusinessHours, TQRegularBusinessHoursVariables>;
export const QSpecificBusinessHoursDocument = gql`
    query QSpecificBusinessHours($branchId: ID!, $mode: BusinessHoursModeEnum!) {
  businessHours(companyBranch: $branchId, specific: true, mode: $mode) {
    ...FSpecificBusinessHour
  }
}
    ${FSpecificBusinessHour}`;
export function useQSpecificBusinessHours(baseOptions: ApolloReactHooks.QueryHookOptions<TQSpecificBusinessHours, TQSpecificBusinessHoursVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQSpecificBusinessHours, TQSpecificBusinessHoursVariables>(QSpecificBusinessHoursDocument, options);
      }
export function useQSpecificBusinessHoursLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQSpecificBusinessHours, TQSpecificBusinessHoursVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQSpecificBusinessHours, TQSpecificBusinessHoursVariables>(QSpecificBusinessHoursDocument, options);
        }
export type QSpecificBusinessHoursHookResult = ReturnType<typeof useQSpecificBusinessHours>;
export type QSpecificBusinessHoursLazyQueryHookResult = ReturnType<typeof useQSpecificBusinessHoursLazyQuery>;
export type QSpecificBusinessHoursQueryResult = ApolloReactCommon.QueryResult<TQSpecificBusinessHours, TQSpecificBusinessHoursVariables>;
export const QUsualHandoverTimesDocument = gql`
    query QUsualHandoverTimes($branchId: ID!) {
  handoverTimes: companyBranch(id: $branchId) {
    ...FUsualHandoverTimes
  }
}
    ${FUsualHandoverTimes}`;
export function useQUsualHandoverTimes(baseOptions: ApolloReactHooks.QueryHookOptions<TQUsualHandoverTimes, TQUsualHandoverTimesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQUsualHandoverTimes, TQUsualHandoverTimesVariables>(QUsualHandoverTimesDocument, options);
      }
export function useQUsualHandoverTimesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQUsualHandoverTimes, TQUsualHandoverTimesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQUsualHandoverTimes, TQUsualHandoverTimesVariables>(QUsualHandoverTimesDocument, options);
        }
export type QUsualHandoverTimesHookResult = ReturnType<typeof useQUsualHandoverTimes>;
export type QUsualHandoverTimesLazyQueryHookResult = ReturnType<typeof useQUsualHandoverTimesLazyQuery>;
export type QUsualHandoverTimesQueryResult = ApolloReactCommon.QueryResult<TQUsualHandoverTimes, TQUsualHandoverTimesVariables>;
export const QWeekDaysDocument = gql`
    query QWeekDays {
  weekDays {
    id
    ...FWeekday
  }
}
    ${FWeekday}`;
export function useQWeekDays(baseOptions?: ApolloReactHooks.QueryHookOptions<TQWeekDays, TQWeekDaysVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQWeekDays, TQWeekDaysVariables>(QWeekDaysDocument, options);
      }
export function useQWeekDaysLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQWeekDays, TQWeekDaysVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQWeekDays, TQWeekDaysVariables>(QWeekDaysDocument, options);
        }
export type QWeekDaysHookResult = ReturnType<typeof useQWeekDays>;
export type QWeekDaysLazyQueryHookResult = ReturnType<typeof useQWeekDaysLazyQuery>;
export type QWeekDaysQueryResult = ApolloReactCommon.QueryResult<TQWeekDays, TQWeekDaysVariables>;
export const MAcceptCashRegisterOrderDocument = gql`
    mutation MAcceptCashRegisterOrder($orderId: ID!, $customer: InputCustomerCreate!, $note: String, $paymentType: PaymentTypeEnum, $paymentGate: PaymentGateEnum) {
  finishOrder: finishVirtualCashBoxOrder(id: $orderId, order: {customer: $customer, note: $note, paymentMethod: $paymentType, paymentGate: $paymentGate}) {
    ...FAcceptedOrder
  }
}
    ${FAcceptedOrder}`;
export type TMAcceptCashRegisterOrderMutationFn = ApolloReactCommon.MutationFunction<TMAcceptCashRegisterOrder, TMAcceptCashRegisterOrderVariables>;
export function useMAcceptCashRegisterOrder(baseOptions?: ApolloReactHooks.MutationHookOptions<TMAcceptCashRegisterOrder, TMAcceptCashRegisterOrderVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMAcceptCashRegisterOrder, TMAcceptCashRegisterOrderVariables>(MAcceptCashRegisterOrderDocument, options);
      }
export type MAcceptCashRegisterOrderHookResult = ReturnType<typeof useMAcceptCashRegisterOrder>;
export type MAcceptCashRegisterOrderMutationResult = ApolloReactCommon.MutationResult<TMAcceptCashRegisterOrder>;
export type MAcceptCashRegisterOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<TMAcceptCashRegisterOrder, TMAcceptCashRegisterOrderVariables>;
export const MAddOrderPromoDocument = gql`
    mutation MAddOrderPromo($orderId: ID!, $code: String!) {
  addOrderPromoCode(order: $orderId, promoCode: $code) {
    userErrors: errors
    order {
      ...FCreateOrder
      promoCodes {
        id
        code
      }
    }
  }
}
    ${FCreateOrder}`;
export type TMAddOrderPromoMutationFn = ApolloReactCommon.MutationFunction<TMAddOrderPromo, TMAddOrderPromoVariables>;
export function useMAddOrderPromo(baseOptions?: ApolloReactHooks.MutationHookOptions<TMAddOrderPromo, TMAddOrderPromoVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMAddOrderPromo, TMAddOrderPromoVariables>(MAddOrderPromoDocument, options);
      }
export type MAddOrderPromoHookResult = ReturnType<typeof useMAddOrderPromo>;
export type MAddOrderPromoMutationResult = ApolloReactCommon.MutationResult<TMAddOrderPromo>;
export type MAddOrderPromoMutationOptions = ApolloReactCommon.BaseMutationOptions<TMAddOrderPromo, TMAddOrderPromoVariables>;
export const MAddToSectorDocument = gql`
    mutation MAddToSector($sectorId: ID!, $recipeId: ID!, $sideDishes: [ID!]) {
  createSectorRecipe(sectorRecipe: {sector: $sectorId, recipe: $recipeId, sideDishes: $sideDishes}) {
    id
  }
}
    `;
export type TMAddToSectorMutationFn = ApolloReactCommon.MutationFunction<TMAddToSector, TMAddToSectorVariables>;
export function useMAddToSector(baseOptions?: ApolloReactHooks.MutationHookOptions<TMAddToSector, TMAddToSectorVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMAddToSector, TMAddToSectorVariables>(MAddToSectorDocument, options);
      }
export type MAddToSectorHookResult = ReturnType<typeof useMAddToSector>;
export type MAddToSectorMutationResult = ApolloReactCommon.MutationResult<TMAddToSector>;
export type MAddToSectorMutationOptions = ApolloReactCommon.BaseMutationOptions<TMAddToSector, TMAddToSectorVariables>;
export const MCancelOrderDocument = gql`
    mutation MCancelOrder($orderId: ID!) {
  addOrderState(order: $orderId, orderState: CANCELED) {
    id
    ...FOrderStateCategory
  }
}
    ${FOrderStateCategory}`;
export type TMCancelOrderMutationFn = ApolloReactCommon.MutationFunction<TMCancelOrder, TMCancelOrderVariables>;
export function useMCancelOrder(baseOptions?: ApolloReactHooks.MutationHookOptions<TMCancelOrder, TMCancelOrderVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMCancelOrder, TMCancelOrderVariables>(MCancelOrderDocument, options);
      }
export type MCancelOrderHookResult = ReturnType<typeof useMCancelOrder>;
export type MCancelOrderMutationResult = ApolloReactCommon.MutationResult<TMCancelOrder>;
export type MCancelOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<TMCancelOrder, TMCancelOrderVariables>;
export const MCreateOrderAcceptDocument = gql`
    mutation MCreateOrderAccept($orderId: ID!, $customer: InputCustomerCreate!, $deliverAt: DateTime, $note: String, $paymentType: PaymentTypeEnum, $paymentGate: PaymentGateEnum) {
  finishOrder(id: $orderId, order: {customer: $customer, note: $note, deliverAt: $deliverAt, paymentMethod: $paymentType, paymentGate: $paymentGate}) {
    ...FAcceptedOrder
  }
}
    ${FAcceptedOrder}`;
export type TMCreateOrderAcceptMutationFn = ApolloReactCommon.MutationFunction<TMCreateOrderAccept, TMCreateOrderAcceptVariables>;
export function useMCreateOrderAccept(baseOptions?: ApolloReactHooks.MutationHookOptions<TMCreateOrderAccept, TMCreateOrderAcceptVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMCreateOrderAccept, TMCreateOrderAcceptVariables>(MCreateOrderAcceptDocument, options);
      }
export type MCreateOrderAcceptHookResult = ReturnType<typeof useMCreateOrderAccept>;
export type MCreateOrderAcceptMutationResult = ApolloReactCommon.MutationResult<TMCreateOrderAccept>;
export type MCreateOrderAcceptMutationOptions = ApolloReactCommon.BaseMutationOptions<TMCreateOrderAccept, TMCreateOrderAcceptVariables>;
export const MCreateOrderAddRecipeDocument = gql`
    mutation MCreateOrderAddRecipe($note: String, $orderId: ID!, $recipeId: ID!, $categoryId: ID!, $sideDishes: [InputOrderRecipeSideDishCreate!], $itemQuantity: Int!, $dynamicPrice: InputCurrencyCreate) {
  createOrderRecipe(orderRecipe: {note: $note, order: $orderId, recipe: $recipeId, amount: $itemQuantity, sideDishRecipes: $sideDishes, dynamicPrice: $dynamicPrice, wareCategory: $categoryId}) {
    ...FCreateOrder
  }
}
    ${FCreateOrder}`;
export type TMCreateOrderAddRecipeMutationFn = ApolloReactCommon.MutationFunction<TMCreateOrderAddRecipe, TMCreateOrderAddRecipeVariables>;
export function useMCreateOrderAddRecipe(baseOptions?: ApolloReactHooks.MutationHookOptions<TMCreateOrderAddRecipe, TMCreateOrderAddRecipeVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMCreateOrderAddRecipe, TMCreateOrderAddRecipeVariables>(MCreateOrderAddRecipeDocument, options);
      }
export type MCreateOrderAddRecipeHookResult = ReturnType<typeof useMCreateOrderAddRecipe>;
export type MCreateOrderAddRecipeMutationResult = ApolloReactCommon.MutationResult<TMCreateOrderAddRecipe>;
export type MCreateOrderAddRecipeMutationOptions = ApolloReactCommon.BaseMutationOptions<TMCreateOrderAddRecipe, TMCreateOrderAddRecipeVariables>;
export const MCreateOrderNewDocument = gql`
    mutation MCreateOrderNew($branchId: ID!, $deliveryType: DeliveryTypeEnum, $deliverAt: DateTime, $gps: InputGeoPointCreate!, $callEventId: ID, $warePriceType: WarePriceTypeEnum!, $resolvedAddress: InputOrderResolvedAddressType) {
  createOrder(order: {companyBranch: $branchId, deliveryType: $deliveryType, callEventId: $callEventId, deliverAt: $deliverAt, gps: $gps, customer: {}, warePriceType: $warePriceType, orderOrigin: STAFF, resolvedAddress: $resolvedAddress}) {
    ...FCreateOrder
  }
}
    ${FCreateOrder}`;
export type TMCreateOrderNewMutationFn = ApolloReactCommon.MutationFunction<TMCreateOrderNew, TMCreateOrderNewVariables>;
export function useMCreateOrderNew(baseOptions?: ApolloReactHooks.MutationHookOptions<TMCreateOrderNew, TMCreateOrderNewVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMCreateOrderNew, TMCreateOrderNewVariables>(MCreateOrderNewDocument, options);
      }
export type MCreateOrderNewHookResult = ReturnType<typeof useMCreateOrderNew>;
export type MCreateOrderNewMutationResult = ApolloReactCommon.MutationResult<TMCreateOrderNew>;
export type MCreateOrderNewMutationOptions = ApolloReactCommon.BaseMutationOptions<TMCreateOrderNew, TMCreateOrderNewVariables>;
export const MCreateOrderNewCashRegisterDocument = gql`
    mutation MCreateOrderNewCashRegister($branchId: ID!, $deliveryType: DeliveryTypeEnum, $deliverAt: DateTime, $gps: InputGeoPointCreate!, $callEventId: ID, $warePriceType: WarePriceTypeEnum!) {
  createOrder: createVirtualCashBoxOrder(order: {companyBranch: $branchId, deliveryType: $deliveryType, callEventId: $callEventId, deliverAt: $deliverAt, gps: $gps, customer: {}, warePriceType: $warePriceType}) {
    ...FCreateOrder
  }
}
    ${FCreateOrder}`;
export type TMCreateOrderNewCashRegisterMutationFn = ApolloReactCommon.MutationFunction<TMCreateOrderNewCashRegister, TMCreateOrderNewCashRegisterVariables>;
export function useMCreateOrderNewCashRegister(baseOptions?: ApolloReactHooks.MutationHookOptions<TMCreateOrderNewCashRegister, TMCreateOrderNewCashRegisterVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMCreateOrderNewCashRegister, TMCreateOrderNewCashRegisterVariables>(MCreateOrderNewCashRegisterDocument, options);
      }
export type MCreateOrderNewCashRegisterHookResult = ReturnType<typeof useMCreateOrderNewCashRegister>;
export type MCreateOrderNewCashRegisterMutationResult = ApolloReactCommon.MutationResult<TMCreateOrderNewCashRegister>;
export type MCreateOrderNewCashRegisterMutationOptions = ApolloReactCommon.BaseMutationOptions<TMCreateOrderNewCashRegister, TMCreateOrderNewCashRegisterVariables>;
export const MCreateOrderRemoveItemDocument = gql`
    mutation MCreateOrderRemoveItem($itemId: ID!) {
  destroyOrderRecipe(id: $itemId) {
    ...FCreateOrder
  }
}
    ${FCreateOrder}`;
export type TMCreateOrderRemoveItemMutationFn = ApolloReactCommon.MutationFunction<TMCreateOrderRemoveItem, TMCreateOrderRemoveItemVariables>;
export function useMCreateOrderRemoveItem(baseOptions?: ApolloReactHooks.MutationHookOptions<TMCreateOrderRemoveItem, TMCreateOrderRemoveItemVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMCreateOrderRemoveItem, TMCreateOrderRemoveItemVariables>(MCreateOrderRemoveItemDocument, options);
      }
export type MCreateOrderRemoveItemHookResult = ReturnType<typeof useMCreateOrderRemoveItem>;
export type MCreateOrderRemoveItemMutationResult = ApolloReactCommon.MutationResult<TMCreateOrderRemoveItem>;
export type MCreateOrderRemoveItemMutationOptions = ApolloReactCommon.BaseMutationOptions<TMCreateOrderRemoveItem, TMCreateOrderRemoveItemVariables>;
export const MCreateOrderUpdateDocument = gql`
    mutation MCreateOrderUpdate($orderId: ID!, $deliveryType: DeliveryTypeEnum, $deliverAt: DateTime, $gps: InputGeoPointCreate!, $customer: InputCustomerCreate, $warePriceType: WarePriceTypeEnum, $resolvedAddress: InputOrderResolvedAddressType) {
  updateOrder(id: $orderId, order: {deliveryType: $deliveryType, deliverAt: $deliverAt, gps: $gps, customer: $customer, warePriceType: $warePriceType, resolvedAddress: $resolvedAddress}) {
    ...FCreateOrder
  }
}
    ${FCreateOrder}`;
export type TMCreateOrderUpdateMutationFn = ApolloReactCommon.MutationFunction<TMCreateOrderUpdate, TMCreateOrderUpdateVariables>;
export function useMCreateOrderUpdate(baseOptions?: ApolloReactHooks.MutationHookOptions<TMCreateOrderUpdate, TMCreateOrderUpdateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMCreateOrderUpdate, TMCreateOrderUpdateVariables>(MCreateOrderUpdateDocument, options);
      }
export type MCreateOrderUpdateHookResult = ReturnType<typeof useMCreateOrderUpdate>;
export type MCreateOrderUpdateMutationResult = ApolloReactCommon.MutationResult<TMCreateOrderUpdate>;
export type MCreateOrderUpdateMutationOptions = ApolloReactCommon.BaseMutationOptions<TMCreateOrderUpdate, TMCreateOrderUpdateVariables>;
export const MCreateOrderUpdateItemDocument = gql`
    mutation MCreateOrderUpdateItem($itemId: ID!, $note: String, $sideDishes: [InputOrderRecipeSideDishUpdate!], $dynamicPrice: InputCurrencyCreate) {
  updateOrderRecipe(id: $itemId, orderRecipe: {note: $note, sideDishRecipes: $sideDishes, dynamicPrice: $dynamicPrice}) {
    ...FCreateOrder
  }
}
    ${FCreateOrder}`;
export type TMCreateOrderUpdateItemMutationFn = ApolloReactCommon.MutationFunction<TMCreateOrderUpdateItem, TMCreateOrderUpdateItemVariables>;
export function useMCreateOrderUpdateItem(baseOptions?: ApolloReactHooks.MutationHookOptions<TMCreateOrderUpdateItem, TMCreateOrderUpdateItemVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMCreateOrderUpdateItem, TMCreateOrderUpdateItemVariables>(MCreateOrderUpdateItemDocument, options);
      }
export type MCreateOrderUpdateItemHookResult = ReturnType<typeof useMCreateOrderUpdateItem>;
export type MCreateOrderUpdateItemMutationResult = ApolloReactCommon.MutationResult<TMCreateOrderUpdateItem>;
export type MCreateOrderUpdateItemMutationOptions = ApolloReactCommon.BaseMutationOptions<TMCreateOrderUpdateItem, TMCreateOrderUpdateItemVariables>;
export const MRemoveOrderPromoDocument = gql`
    mutation MRemoveOrderPromo($orderId: ID!, $codeId: ID!) {
  removeOrderPromoCode(order: $orderId, promoCode: $codeId) {
    ...FCreateOrder
  }
}
    ${FCreateOrder}`;
export type TMRemoveOrderPromoMutationFn = ApolloReactCommon.MutationFunction<TMRemoveOrderPromo, TMRemoveOrderPromoVariables>;
export function useMRemoveOrderPromo(baseOptions?: ApolloReactHooks.MutationHookOptions<TMRemoveOrderPromo, TMRemoveOrderPromoVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMRemoveOrderPromo, TMRemoveOrderPromoVariables>(MRemoveOrderPromoDocument, options);
      }
export type MRemoveOrderPromoHookResult = ReturnType<typeof useMRemoveOrderPromo>;
export type MRemoveOrderPromoMutationResult = ApolloReactCommon.MutationResult<TMRemoveOrderPromo>;
export type MRemoveOrderPromoMutationOptions = ApolloReactCommon.BaseMutationOptions<TMRemoveOrderPromo, TMRemoveOrderPromoVariables>;
export const QBranchInHousePaymentMethodsDocument = gql`
    query QBranchInHousePaymentMethods($branchId: ID!) {
  companyBranch(id: $branchId) {
    id
    paymentMethods: canBeUpdatedToPaymentMethods(orderOrigin: STAFF, warePriceType: INHOUSE) {
      id
    }
  }
}
    `;
export function useQBranchInHousePaymentMethods(baseOptions: ApolloReactHooks.QueryHookOptions<TQBranchInHousePaymentMethods, TQBranchInHousePaymentMethodsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQBranchInHousePaymentMethods, TQBranchInHousePaymentMethodsVariables>(QBranchInHousePaymentMethodsDocument, options);
      }
export function useQBranchInHousePaymentMethodsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQBranchInHousePaymentMethods, TQBranchInHousePaymentMethodsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQBranchInHousePaymentMethods, TQBranchInHousePaymentMethodsVariables>(QBranchInHousePaymentMethodsDocument, options);
        }
export type QBranchInHousePaymentMethodsHookResult = ReturnType<typeof useQBranchInHousePaymentMethods>;
export type QBranchInHousePaymentMethodsLazyQueryHookResult = ReturnType<typeof useQBranchInHousePaymentMethodsLazyQuery>;
export type QBranchInHousePaymentMethodsQueryResult = ApolloReactCommon.QueryResult<TQBranchInHousePaymentMethods, TQBranchInHousePaymentMethodsVariables>;
export const QBranchPaymentMethodsDocument = gql`
    query QBranchPaymentMethods($branchId: ID!, $deliveryType: DeliveryTypeEnum, $warePriceType: WarePriceTypeEnum) {
  companyBranch(id: $branchId) {
    id
    paymentMethods: canBeUpdatedToPaymentMethods(orderOrigin: STAFF, deliveryType: $deliveryType, warePriceType: $warePriceType) {
      ...FPaymentMethod
    }
  }
}
    ${FPaymentMethod}`;
export function useQBranchPaymentMethods(baseOptions: ApolloReactHooks.QueryHookOptions<TQBranchPaymentMethods, TQBranchPaymentMethodsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQBranchPaymentMethods, TQBranchPaymentMethodsVariables>(QBranchPaymentMethodsDocument, options);
      }
export function useQBranchPaymentMethodsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQBranchPaymentMethods, TQBranchPaymentMethodsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQBranchPaymentMethods, TQBranchPaymentMethodsVariables>(QBranchPaymentMethodsDocument, options);
        }
export type QBranchPaymentMethodsHookResult = ReturnType<typeof useQBranchPaymentMethods>;
export type QBranchPaymentMethodsLazyQueryHookResult = ReturnType<typeof useQBranchPaymentMethodsLazyQuery>;
export type QBranchPaymentMethodsQueryResult = ApolloReactCommon.QueryResult<TQBranchPaymentMethods, TQBranchPaymentMethodsVariables>;
export const QCreateOrderItemDocument = gql`
    query QCreateOrderItem($itemId: ID!, $warePriceType: WarePriceTypeEnum) {
  item: orderRecipe(id: $itemId) {
    id
    note
    recipe {
      ...FCreateOrderRecipeSideDishes
    }
    price {
      ...FPrice
    }
    selectedSideDishes: sideDishes {
      id
      wareCategory {
        id
      }
      recipe {
        id
      }
    }
  }
}
    ${FCreateOrderRecipeSideDishes}
${FPrice}`;
export function useQCreateOrderItem(baseOptions: ApolloReactHooks.QueryHookOptions<TQCreateOrderItem, TQCreateOrderItemVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQCreateOrderItem, TQCreateOrderItemVariables>(QCreateOrderItemDocument, options);
      }
export function useQCreateOrderItemLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQCreateOrderItem, TQCreateOrderItemVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQCreateOrderItem, TQCreateOrderItemVariables>(QCreateOrderItemDocument, options);
        }
export type QCreateOrderItemHookResult = ReturnType<typeof useQCreateOrderItem>;
export type QCreateOrderItemLazyQueryHookResult = ReturnType<typeof useQCreateOrderItemLazyQuery>;
export type QCreateOrderItemQueryResult = ApolloReactCommon.QueryResult<TQCreateOrderItem, TQCreateOrderItemVariables>;
export const QCreateOrderRecipeDocument = gql`
    query QCreateOrderRecipe($recipeId: ID!, $branchId: ID!, $warePriceType: WarePriceTypeEnum) {
  recipe(id: $recipeId, companyBranch: $branchId) {
    ...FCreateOrderRecipeSideDishes
  }
}
    ${FCreateOrderRecipeSideDishes}`;
export function useQCreateOrderRecipe(baseOptions: ApolloReactHooks.QueryHookOptions<TQCreateOrderRecipe, TQCreateOrderRecipeVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQCreateOrderRecipe, TQCreateOrderRecipeVariables>(QCreateOrderRecipeDocument, options);
      }
export function useQCreateOrderRecipeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQCreateOrderRecipe, TQCreateOrderRecipeVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQCreateOrderRecipe, TQCreateOrderRecipeVariables>(QCreateOrderRecipeDocument, options);
        }
export type QCreateOrderRecipeHookResult = ReturnType<typeof useQCreateOrderRecipe>;
export type QCreateOrderRecipeLazyQueryHookResult = ReturnType<typeof useQCreateOrderRecipeLazyQuery>;
export type QCreateOrderRecipeQueryResult = ApolloReactCommon.QueryResult<TQCreateOrderRecipe, TQCreateOrderRecipeVariables>;
export const QOrderCartDocument = gql`
    query QOrderCart($orderId: ID!) {
  order(id: $orderId) {
    ...FCreateOrder
  }
}
    ${FCreateOrder}`;
export function useQOrderCart(baseOptions: ApolloReactHooks.QueryHookOptions<TQOrderCart, TQOrderCartVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQOrderCart, TQOrderCartVariables>(QOrderCartDocument, options);
      }
export function useQOrderCartLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQOrderCart, TQOrderCartVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQOrderCart, TQOrderCartVariables>(QOrderCartDocument, options);
        }
export type QOrderCartHookResult = ReturnType<typeof useQOrderCart>;
export type QOrderCartLazyQueryHookResult = ReturnType<typeof useQOrderCartLazyQuery>;
export type QOrderCartQueryResult = ApolloReactCommon.QueryResult<TQOrderCart, TQOrderCartVariables>;
export const QOrderFormDeliverAtDefaultsDocument = gql`
    query QOrderFormDeliverAtDefaults($branchId: ID!) {
  times: companyBranch(id: $branchId) {
    id
    deliveryTime: defaultDeliveryTime
    pickupTime: defaultPickupTime
  }
}
    `;
export function useQOrderFormDeliverAtDefaults(baseOptions: ApolloReactHooks.QueryHookOptions<TQOrderFormDeliverAtDefaults, TQOrderFormDeliverAtDefaultsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQOrderFormDeliverAtDefaults, TQOrderFormDeliverAtDefaultsVariables>(QOrderFormDeliverAtDefaultsDocument, options);
      }
export function useQOrderFormDeliverAtDefaultsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQOrderFormDeliverAtDefaults, TQOrderFormDeliverAtDefaultsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQOrderFormDeliverAtDefaults, TQOrderFormDeliverAtDefaultsVariables>(QOrderFormDeliverAtDefaultsDocument, options);
        }
export type QOrderFormDeliverAtDefaultsHookResult = ReturnType<typeof useQOrderFormDeliverAtDefaults>;
export type QOrderFormDeliverAtDefaultsLazyQueryHookResult = ReturnType<typeof useQOrderFormDeliverAtDefaultsLazyQuery>;
export type QOrderFormDeliverAtDefaultsQueryResult = ApolloReactCommon.QueryResult<TQOrderFormDeliverAtDefaults, TQOrderFormDeliverAtDefaultsVariables>;
export const QOrderFormPromoDocument = gql`
    query QOrderFormPromo($branchId: ID!) {
  promoCodes(promoCode: {companyBranch: $branchId, enabled: true}) {
    id
    code
  }
}
    `;
export function useQOrderFormPromo(baseOptions: ApolloReactHooks.QueryHookOptions<TQOrderFormPromo, TQOrderFormPromoVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQOrderFormPromo, TQOrderFormPromoVariables>(QOrderFormPromoDocument, options);
      }
export function useQOrderFormPromoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQOrderFormPromo, TQOrderFormPromoVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQOrderFormPromo, TQOrderFormPromoVariables>(QOrderFormPromoDocument, options);
        }
export type QOrderFormPromoHookResult = ReturnType<typeof useQOrderFormPromo>;
export type QOrderFormPromoLazyQueryHookResult = ReturnType<typeof useQOrderFormPromoLazyQuery>;
export type QOrderFormPromoQueryResult = ApolloReactCommon.QueryResult<TQOrderFormPromo, TQOrderFormPromoVariables>;
export const QOrderMenuDocument = gql`
    query QOrderMenu($branchId: ID!, $orderOrigin: OrderOriginCategoryEnum!) {
  orderMenu: orderMenuAdmin(wareCategoryType: MAIN, companyBranch: $branchId, orderOriginCategory: $orderOrigin) {
    id
    nameLabel
    pictogram
    recipes {
      id
      isDynamicPricingEnabled
      recipeColor {
        id
        color
      }
      code
      nameLabel
      internalNote
      descriptionLabel
      deliveryPrice: price(warePriceType: DELIVERY) {
        ...FFormattedPrice
      }
      inHousePrice: price(warePriceType: INHOUSE) {
        ...FFormattedPrice
      }
      sideDishCount: sideDishesWareCategoriesCount
    }
    color: wareCategoryColor {
      id
      color
    }
  }
}
    ${FFormattedPrice}`;
export function useQOrderMenu(baseOptions: ApolloReactHooks.QueryHookOptions<TQOrderMenu, TQOrderMenuVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQOrderMenu, TQOrderMenuVariables>(QOrderMenuDocument, options);
      }
export function useQOrderMenuLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQOrderMenu, TQOrderMenuVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQOrderMenu, TQOrderMenuVariables>(QOrderMenuDocument, options);
        }
export type QOrderMenuHookResult = ReturnType<typeof useQOrderMenu>;
export type QOrderMenuLazyQueryHookResult = ReturnType<typeof useQOrderMenuLazyQuery>;
export type QOrderMenuQueryResult = ApolloReactCommon.QueryResult<TQOrderMenu, TQOrderMenuVariables>;
export const QOrderVamCustomerDocument = gql`
    query QOrderVamCustomer($branchId: ID!, $phone: String!) {
  vamCustomer: vamInformation(companyBranchId: $branchId, phone: $phone) {
    isFound
    ...FOrderCustomer
  }
}
    ${FOrderCustomer}`;
export function useQOrderVamCustomer(baseOptions: ApolloReactHooks.QueryHookOptions<TQOrderVamCustomer, TQOrderVamCustomerVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQOrderVamCustomer, TQOrderVamCustomerVariables>(QOrderVamCustomerDocument, options);
      }
export function useQOrderVamCustomerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQOrderVamCustomer, TQOrderVamCustomerVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQOrderVamCustomer, TQOrderVamCustomerVariables>(QOrderVamCustomerDocument, options);
        }
export type QOrderVamCustomerHookResult = ReturnType<typeof useQOrderVamCustomer>;
export type QOrderVamCustomerLazyQueryHookResult = ReturnType<typeof useQOrderVamCustomerLazyQuery>;
export type QOrderVamCustomerQueryResult = ApolloReactCommon.QueryResult<TQOrderVamCustomer, TQOrderVamCustomerVariables>;
export const QSearchBranchForAddressDocument = gql`
    query QSearchBranchForAddress($brandId: ID!, $latitude: Float!, $longitude: Float!) {
  resolveLocation(brand: $brandId, latitude: $latitude, longitude: $longitude) {
    inDeliveryLocation
    companyBranch {
      id
      name
    }
    zone {
      minimalOrderPrice {
        formattedValue
      }
    }
  }
}
    `;
export function useQSearchBranchForAddress(baseOptions: ApolloReactHooks.QueryHookOptions<TQSearchBranchForAddress, TQSearchBranchForAddressVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQSearchBranchForAddress, TQSearchBranchForAddressVariables>(QSearchBranchForAddressDocument, options);
      }
export function useQSearchBranchForAddressLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQSearchBranchForAddress, TQSearchBranchForAddressVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQSearchBranchForAddress, TQSearchBranchForAddressVariables>(QSearchBranchForAddressDocument, options);
        }
export type QSearchBranchForAddressHookResult = ReturnType<typeof useQSearchBranchForAddress>;
export type QSearchBranchForAddressLazyQueryHookResult = ReturnType<typeof useQSearchBranchForAddressLazyQuery>;
export type QSearchBranchForAddressQueryResult = ApolloReactCommon.QueryResult<TQSearchBranchForAddress, TQSearchBranchForAddressVariables>;
export const QValidateLocationDocument = gql`
    query QValidateLocation($branchId: ID!, $latitude: Float!, $longitude: Float!) {
  resolveLocation(companyBranch: $branchId, latitude: $latitude, longitude: $longitude) {
    inDeliveryLocation
    zone {
      minimalOrderPrice {
        formattedValue
      }
    }
  }
}
    `;
export function useQValidateLocation(baseOptions: ApolloReactHooks.QueryHookOptions<TQValidateLocation, TQValidateLocationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQValidateLocation, TQValidateLocationVariables>(QValidateLocationDocument, options);
      }
export function useQValidateLocationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQValidateLocation, TQValidateLocationVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQValidateLocation, TQValidateLocationVariables>(QValidateLocationDocument, options);
        }
export type QValidateLocationHookResult = ReturnType<typeof useQValidateLocation>;
export type QValidateLocationLazyQueryHookResult = ReturnType<typeof useQValidateLocationLazyQuery>;
export type QValidateLocationQueryResult = ApolloReactCommon.QueryResult<TQValidateLocation, TQValidateLocationVariables>;
export const QCustomerScreenOrderListDocument = gql`
    query QCustomerScreenOrderList($branches: [ID!], $categories: [OrderStateCategoryEnum!], $sectors: [ID!], $acceptedAfter: DateTime) {
  orders(order: {companyBranches: $branches, orderStateCategoryTarget: FE_COMPLETION, orderStateCategoriesOR: $categories, includeOldFinished: false, acceptedAfter: $acceptedAfter, sectors: $sectors, sectorsWithChildren: true}) {
    ...FCustomerScreenOrder
  }
}
    ${FCustomerScreenOrder}`;
export function useQCustomerScreenOrderList(baseOptions?: ApolloReactHooks.QueryHookOptions<TQCustomerScreenOrderList, TQCustomerScreenOrderListVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQCustomerScreenOrderList, TQCustomerScreenOrderListVariables>(QCustomerScreenOrderListDocument, options);
      }
export function useQCustomerScreenOrderListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQCustomerScreenOrderList, TQCustomerScreenOrderListVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQCustomerScreenOrderList, TQCustomerScreenOrderListVariables>(QCustomerScreenOrderListDocument, options);
        }
export type QCustomerScreenOrderListHookResult = ReturnType<typeof useQCustomerScreenOrderList>;
export type QCustomerScreenOrderListLazyQueryHookResult = ReturnType<typeof useQCustomerScreenOrderListLazyQuery>;
export type QCustomerScreenOrderListQueryResult = ApolloReactCommon.QueryResult<TQCustomerScreenOrderList, TQCustomerScreenOrderListVariables>;
export const SCustomerScreenOrderListDocument = gql`
    subscription SCustomerScreenOrderList($branches: [ID!], $categories: [OrderStateCategoryEnum!], $sectors: [ID!]) {
  updatedOrder(companyBranches: $branches, orderStateCategoriesOR: $categories, orderStateCategoryTarget: FE_COMPLETION, sectors: $sectors, sectorsWithChildren: true) {
    order {
      ...FCustomerScreenOrder
    }
  }
}
    ${FCustomerScreenOrder}`;
export function useSCustomerScreenOrderList(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<TSCustomerScreenOrderList, TSCustomerScreenOrderListVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<TSCustomerScreenOrderList, TSCustomerScreenOrderListVariables>(SCustomerScreenOrderListDocument, options);
      }
export type SCustomerScreenOrderListHookResult = ReturnType<typeof useSCustomerScreenOrderList>;
export type SCustomerScreenOrderListSubscriptionResult = ApolloReactCommon.SubscriptionResult<TSCustomerScreenOrderList>;
export const MUpdateBranchDeliveryTypesDocument = gql`
    mutation MUpdateBranchDeliveryTypes($branchId: ID!, $deliveryTypes: [DeliveryTypeEnum!]!) {
  updateAllowedDeliveryTypes(companyBranchId: $branchId, deliveryTypes: $deliveryTypes) {
    id
    name
    deliveryEnabled
    pickupEnabled
  }
}
    `;
export type TMUpdateBranchDeliveryTypesMutationFn = ApolloReactCommon.MutationFunction<TMUpdateBranchDeliveryTypes, TMUpdateBranchDeliveryTypesVariables>;
export function useMUpdateBranchDeliveryTypes(baseOptions?: ApolloReactHooks.MutationHookOptions<TMUpdateBranchDeliveryTypes, TMUpdateBranchDeliveryTypesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMUpdateBranchDeliveryTypes, TMUpdateBranchDeliveryTypesVariables>(MUpdateBranchDeliveryTypesDocument, options);
      }
export type MUpdateBranchDeliveryTypesHookResult = ReturnType<typeof useMUpdateBranchDeliveryTypes>;
export type MUpdateBranchDeliveryTypesMutationResult = ApolloReactCommon.MutationResult<TMUpdateBranchDeliveryTypes>;
export type MUpdateBranchDeliveryTypesMutationOptions = ApolloReactCommon.BaseMutationOptions<TMUpdateBranchDeliveryTypes, TMUpdateBranchDeliveryTypesVariables>;
export const QDeliveryTypesForBranchDocument = gql`
    query QDeliveryTypesForBranch($branchId: ID!) {
  companyBranch(id: $branchId) {
    id
    name
    deliveryEnabled
    pickupEnabled
  }
}
    `;
export function useQDeliveryTypesForBranch(baseOptions: ApolloReactHooks.QueryHookOptions<TQDeliveryTypesForBranch, TQDeliveryTypesForBranchVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQDeliveryTypesForBranch, TQDeliveryTypesForBranchVariables>(QDeliveryTypesForBranchDocument, options);
      }
export function useQDeliveryTypesForBranchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQDeliveryTypesForBranch, TQDeliveryTypesForBranchVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQDeliveryTypesForBranch, TQDeliveryTypesForBranchVariables>(QDeliveryTypesForBranchDocument, options);
        }
export type QDeliveryTypesForBranchHookResult = ReturnType<typeof useQDeliveryTypesForBranch>;
export type QDeliveryTypesForBranchLazyQueryHookResult = ReturnType<typeof useQDeliveryTypesForBranchLazyQuery>;
export type QDeliveryTypesForBranchQueryResult = ApolloReactCommon.QueryResult<TQDeliveryTypesForBranch, TQDeliveryTypesForBranchVariables>;
export const MUpdateExpressDeliverySettingDocument = gql`
    mutation MUpdateExpressDeliverySetting($id: ID!, $setting: ExpressDeliverySettingUpdate!) {
  updateExpressDeliverySetting(id: $id, setting: $setting) {
    id
    isExpressEnabled
    pausedUntil
  }
}
    `;
export type TMUpdateExpressDeliverySettingMutationFn = ApolloReactCommon.MutationFunction<TMUpdateExpressDeliverySetting, TMUpdateExpressDeliverySettingVariables>;
export function useMUpdateExpressDeliverySetting(baseOptions?: ApolloReactHooks.MutationHookOptions<TMUpdateExpressDeliverySetting, TMUpdateExpressDeliverySettingVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMUpdateExpressDeliverySetting, TMUpdateExpressDeliverySettingVariables>(MUpdateExpressDeliverySettingDocument, options);
      }
export type MUpdateExpressDeliverySettingHookResult = ReturnType<typeof useMUpdateExpressDeliverySetting>;
export type MUpdateExpressDeliverySettingMutationResult = ApolloReactCommon.MutationResult<TMUpdateExpressDeliverySetting>;
export type MUpdateExpressDeliverySettingMutationOptions = ApolloReactCommon.BaseMutationOptions<TMUpdateExpressDeliverySetting, TMUpdateExpressDeliverySettingVariables>;
export const QExpressDeliverySettingDocument = gql`
    query QExpressDeliverySetting($branchId: ID!) {
  companyBranch(id: $branchId) {
    id
    expressDeliverySetting {
      ...FExpressState
      ordersInProgressLimit
      expressBaseTimeMinutes
      expressFee {
        ...FPriceWithCurrency
      }
      maxOrderValue {
        ...FPriceWithCurrency
      }
    }
  }
}
    ${FExpressState}
${FPriceWithCurrency}`;
export function useQExpressDeliverySetting(baseOptions: ApolloReactHooks.QueryHookOptions<TQExpressDeliverySetting, TQExpressDeliverySettingVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQExpressDeliverySetting, TQExpressDeliverySettingVariables>(QExpressDeliverySettingDocument, options);
      }
export function useQExpressDeliverySettingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQExpressDeliverySetting, TQExpressDeliverySettingVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQExpressDeliverySetting, TQExpressDeliverySettingVariables>(QExpressDeliverySettingDocument, options);
        }
export type QExpressDeliverySettingHookResult = ReturnType<typeof useQExpressDeliverySetting>;
export type QExpressDeliverySettingLazyQueryHookResult = ReturnType<typeof useQExpressDeliverySettingLazyQuery>;
export type QExpressDeliverySettingQueryResult = ApolloReactCommon.QueryResult<TQExpressDeliverySetting, TQExpressDeliverySettingVariables>;
export const MUpdateHeaderTextDocument = gql`
    mutation MUpdateHeaderText($brandId: ID, $branchId: ID, $translations: [InputLabelTranslation!]!, $enabled: Boolean) {
  updatedHeaderText: updateGraphicHeaders(company: $brandId, companyBranch: $branchId, promoTranslations: $translations, enabled: $enabled)
}
    `;
export type TMUpdateHeaderTextMutationFn = ApolloReactCommon.MutationFunction<TMUpdateHeaderText, TMUpdateHeaderTextVariables>;
export function useMUpdateHeaderText(baseOptions?: ApolloReactHooks.MutationHookOptions<TMUpdateHeaderText, TMUpdateHeaderTextVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMUpdateHeaderText, TMUpdateHeaderTextVariables>(MUpdateHeaderTextDocument, options);
      }
export type MUpdateHeaderTextHookResult = ReturnType<typeof useMUpdateHeaderText>;
export type MUpdateHeaderTextMutationResult = ApolloReactCommon.MutationResult<TMUpdateHeaderText>;
export type MUpdateHeaderTextMutationOptions = ApolloReactCommon.BaseMutationOptions<TMUpdateHeaderText, TMUpdateHeaderTextVariables>;
export const QBranchHeaderTextDocument = gql`
    query QBranchHeaderText($id: ID!) {
  headerText: companyBranch(id: $id) {
    id
    promoHeaderEnabled
    promoHeaderTranslations {
      content
      language
    }
  }
}
    `;
export function useQBranchHeaderText(baseOptions: ApolloReactHooks.QueryHookOptions<TQBranchHeaderText, TQBranchHeaderTextVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQBranchHeaderText, TQBranchHeaderTextVariables>(QBranchHeaderTextDocument, options);
      }
export function useQBranchHeaderTextLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQBranchHeaderText, TQBranchHeaderTextVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQBranchHeaderText, TQBranchHeaderTextVariables>(QBranchHeaderTextDocument, options);
        }
export type QBranchHeaderTextHookResult = ReturnType<typeof useQBranchHeaderText>;
export type QBranchHeaderTextLazyQueryHookResult = ReturnType<typeof useQBranchHeaderTextLazyQuery>;
export type QBranchHeaderTextQueryResult = ApolloReactCommon.QueryResult<TQBranchHeaderText, TQBranchHeaderTextVariables>;
export const QBranchHeaderTextLightDocument = gql`
    query QBranchHeaderTextLight($id: ID!) {
  branch: companyBranch(id: $id) {
    id
    promoHeaderText
    promoHeaderEnabled
  }
}
    `;
export function useQBranchHeaderTextLight(baseOptions: ApolloReactHooks.QueryHookOptions<TQBranchHeaderTextLight, TQBranchHeaderTextLightVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQBranchHeaderTextLight, TQBranchHeaderTextLightVariables>(QBranchHeaderTextLightDocument, options);
      }
export function useQBranchHeaderTextLightLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQBranchHeaderTextLight, TQBranchHeaderTextLightVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQBranchHeaderTextLight, TQBranchHeaderTextLightVariables>(QBranchHeaderTextLightDocument, options);
        }
export type QBranchHeaderTextLightHookResult = ReturnType<typeof useQBranchHeaderTextLight>;
export type QBranchHeaderTextLightLazyQueryHookResult = ReturnType<typeof useQBranchHeaderTextLightLazyQuery>;
export type QBranchHeaderTextLightQueryResult = ApolloReactCommon.QueryResult<TQBranchHeaderTextLight, TQBranchHeaderTextLightVariables>;
export const QBrandHeaderTextDocument = gql`
    query QBrandHeaderText($id: ID!) {
  headerText: company(id: $id) {
    ...FHeaderTextInForm
  }
}
    ${FHeaderTextInForm}`;
export function useQBrandHeaderText(baseOptions: ApolloReactHooks.QueryHookOptions<TQBrandHeaderText, TQBrandHeaderTextVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQBrandHeaderText, TQBrandHeaderTextVariables>(QBrandHeaderTextDocument, options);
      }
export function useQBrandHeaderTextLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQBrandHeaderText, TQBrandHeaderTextVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQBrandHeaderText, TQBrandHeaderTextVariables>(QBrandHeaderTextDocument, options);
        }
export type QBrandHeaderTextHookResult = ReturnType<typeof useQBrandHeaderText>;
export type QBrandHeaderTextLazyQueryHookResult = ReturnType<typeof useQBrandHeaderTextLazyQuery>;
export type QBrandHeaderTextQueryResult = ApolloReactCommon.QueryResult<TQBrandHeaderText, TQBrandHeaderTextVariables>;
export const QBrandHeaderTextLightDocument = gql`
    query QBrandHeaderTextLight($id: ID!) {
  brand: company(id: $id) {
    id
    promoHeaderText
  }
}
    `;
export function useQBrandHeaderTextLight(baseOptions: ApolloReactHooks.QueryHookOptions<TQBrandHeaderTextLight, TQBrandHeaderTextLightVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQBrandHeaderTextLight, TQBrandHeaderTextLightVariables>(QBrandHeaderTextLightDocument, options);
      }
export function useQBrandHeaderTextLightLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQBrandHeaderTextLight, TQBrandHeaderTextLightVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQBrandHeaderTextLight, TQBrandHeaderTextLightVariables>(QBrandHeaderTextLightDocument, options);
        }
export type QBrandHeaderTextLightHookResult = ReturnType<typeof useQBrandHeaderTextLight>;
export type QBrandHeaderTextLightLazyQueryHookResult = ReturnType<typeof useQBrandHeaderTextLightLazyQuery>;
export type QBrandHeaderTextLightQueryResult = ApolloReactCommon.QueryResult<TQBrandHeaderTextLight, TQBrandHeaderTextLightVariables>;
export const MBoltAcceptOrderDocument = gql`
    mutation MBoltAcceptOrder($orderId: ID!, $deliverAt: DateTime) {
  acceptBoltOrder(orderId: $orderId, deliverAt: $deliverAt) {
    ...FOrderStateCategory
    ...FOrderForTimeline
  }
}
    ${FOrderStateCategory}
${FOrderForTimeline}`;
export type TMBoltAcceptOrderMutationFn = ApolloReactCommon.MutationFunction<TMBoltAcceptOrder, TMBoltAcceptOrderVariables>;
export function useMBoltAcceptOrder(baseOptions?: ApolloReactHooks.MutationHookOptions<TMBoltAcceptOrder, TMBoltAcceptOrderVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMBoltAcceptOrder, TMBoltAcceptOrderVariables>(MBoltAcceptOrderDocument, options);
      }
export type MBoltAcceptOrderHookResult = ReturnType<typeof useMBoltAcceptOrder>;
export type MBoltAcceptOrderMutationResult = ApolloReactCommon.MutationResult<TMBoltAcceptOrder>;
export type MBoltAcceptOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<TMBoltAcceptOrder, TMBoltAcceptOrderVariables>;
export const MBoltDeleteProfileDocument = gql`
    mutation MBoltDeleteProfile($id: ID!) {
  boltProfile: updateBoltProfile(id: $id, profile: {isDeleted: true}) {
    id
  }
}
    `;
export type TMBoltDeleteProfileMutationFn = ApolloReactCommon.MutationFunction<TMBoltDeleteProfile, TMBoltDeleteProfileVariables>;
export function useMBoltDeleteProfile(baseOptions?: ApolloReactHooks.MutationHookOptions<TMBoltDeleteProfile, TMBoltDeleteProfileVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMBoltDeleteProfile, TMBoltDeleteProfileVariables>(MBoltDeleteProfileDocument, options);
      }
export type MBoltDeleteProfileHookResult = ReturnType<typeof useMBoltDeleteProfile>;
export type MBoltDeleteProfileMutationResult = ApolloReactCommon.MutationResult<TMBoltDeleteProfile>;
export type MBoltDeleteProfileMutationOptions = ApolloReactCommon.BaseMutationOptions<TMBoltDeleteProfile, TMBoltDeleteProfileVariables>;
export const MBoltEditProfileDocument = gql`
    mutation MBoltEditProfile($id: ID!, $name: String!, $isAutomaticMenuSyncEnabled: Boolean) {
  boltProfile: updateBoltProfile(id: $id, profile: {name: $name, isAutomaticMenuSyncEnabled: $isAutomaticMenuSyncEnabled}) {
    id
    isAutomaticMenuSyncEnabled
  }
}
    `;
export type TMBoltEditProfileMutationFn = ApolloReactCommon.MutationFunction<TMBoltEditProfile, TMBoltEditProfileVariables>;
export function useMBoltEditProfile(baseOptions?: ApolloReactHooks.MutationHookOptions<TMBoltEditProfile, TMBoltEditProfileVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMBoltEditProfile, TMBoltEditProfileVariables>(MBoltEditProfileDocument, options);
      }
export type MBoltEditProfileHookResult = ReturnType<typeof useMBoltEditProfile>;
export type MBoltEditProfileMutationResult = ApolloReactCommon.MutationResult<TMBoltEditProfile>;
export type MBoltEditProfileMutationOptions = ApolloReactCommon.BaseMutationOptions<TMBoltEditProfile, TMBoltEditProfileVariables>;
export const MBoltPushMenuDocument = gql`
    mutation MBoltPushMenu($profileId: ID!) {
  pushBoltMenu(profileId: $profileId) {
    id
    ...FBoltProfileWithStates
  }
}
    ${FBoltProfileWithStates}`;
export type TMBoltPushMenuMutationFn = ApolloReactCommon.MutationFunction<TMBoltPushMenu, TMBoltPushMenuVariables>;
export function useMBoltPushMenu(baseOptions?: ApolloReactHooks.MutationHookOptions<TMBoltPushMenu, TMBoltPushMenuVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMBoltPushMenu, TMBoltPushMenuVariables>(MBoltPushMenuDocument, options);
      }
export type MBoltPushMenuHookResult = ReturnType<typeof useMBoltPushMenu>;
export type MBoltPushMenuMutationResult = ApolloReactCommon.MutationResult<TMBoltPushMenu>;
export type MBoltPushMenuMutationOptions = ApolloReactCommon.BaseMutationOptions<TMBoltPushMenu, TMBoltPushMenuVariables>;
export const MBoltRejectOrderDocument = gql`
    mutation MBoltRejectOrder($orderId: ID!, $reason: String) {
  cancelBoltOrder(orderId: $orderId, rejectComment: $reason) {
    ...FOrderStateCategory
    ...FOrderForTimeline
  }
}
    ${FOrderStateCategory}
${FOrderForTimeline}`;
export type TMBoltRejectOrderMutationFn = ApolloReactCommon.MutationFunction<TMBoltRejectOrder, TMBoltRejectOrderVariables>;
export function useMBoltRejectOrder(baseOptions?: ApolloReactHooks.MutationHookOptions<TMBoltRejectOrder, TMBoltRejectOrderVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMBoltRejectOrder, TMBoltRejectOrderVariables>(MBoltRejectOrderDocument, options);
      }
export type MBoltRejectOrderHookResult = ReturnType<typeof useMBoltRejectOrder>;
export type MBoltRejectOrderMutationResult = ApolloReactCommon.MutationResult<TMBoltRejectOrder>;
export type MBoltRejectOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<TMBoltRejectOrder, TMBoltRejectOrderVariables>;
export const MBoltUpdateAutomaticMenuSyncDocument = gql`
    mutation MBoltUpdateAutomaticMenuSync($id: ID!, $isAutomaticMenuSyncEnabled: Boolean!) {
  boltProfile: updateBoltProfile(id: $id, profile: {isAutomaticMenuSyncEnabled: $isAutomaticMenuSyncEnabled}) {
    id
  }
}
    `;
export type TMBoltUpdateAutomaticMenuSyncMutationFn = ApolloReactCommon.MutationFunction<TMBoltUpdateAutomaticMenuSync, TMBoltUpdateAutomaticMenuSyncVariables>;
export function useMBoltUpdateAutomaticMenuSync(baseOptions?: ApolloReactHooks.MutationHookOptions<TMBoltUpdateAutomaticMenuSync, TMBoltUpdateAutomaticMenuSyncVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMBoltUpdateAutomaticMenuSync, TMBoltUpdateAutomaticMenuSyncVariables>(MBoltUpdateAutomaticMenuSyncDocument, options);
      }
export type MBoltUpdateAutomaticMenuSyncHookResult = ReturnType<typeof useMBoltUpdateAutomaticMenuSync>;
export type MBoltUpdateAutomaticMenuSyncMutationResult = ApolloReactCommon.MutationResult<TMBoltUpdateAutomaticMenuSync>;
export type MBoltUpdateAutomaticMenuSyncMutationOptions = ApolloReactCommon.BaseMutationOptions<TMBoltUpdateAutomaticMenuSync, TMBoltUpdateAutomaticMenuSyncVariables>;
export const MBoltUpdateAvailabilityStateDocument = gql`
    mutation MBoltUpdateAvailabilityState($profileId: ID!, $availabilityState: BoltAvailabilityStateGlEnum!) {
  updateBoltAvailabilityState(profileId: $profileId, availabilityState: $availabilityState) {
    id
    onlineState {
      ...FIntegrationOnlineState
    }
  }
}
    ${FIntegrationOnlineState}`;
export type TMBoltUpdateAvailabilityStateMutationFn = ApolloReactCommon.MutationFunction<TMBoltUpdateAvailabilityState, TMBoltUpdateAvailabilityStateVariables>;
export function useMBoltUpdateAvailabilityState(baseOptions?: ApolloReactHooks.MutationHookOptions<TMBoltUpdateAvailabilityState, TMBoltUpdateAvailabilityStateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMBoltUpdateAvailabilityState, TMBoltUpdateAvailabilityStateVariables>(MBoltUpdateAvailabilityStateDocument, options);
      }
export type MBoltUpdateAvailabilityStateHookResult = ReturnType<typeof useMBoltUpdateAvailabilityState>;
export type MBoltUpdateAvailabilityStateMutationResult = ApolloReactCommon.MutationResult<TMBoltUpdateAvailabilityState>;
export type MBoltUpdateAvailabilityStateMutationOptions = ApolloReactCommon.BaseMutationOptions<TMBoltUpdateAvailabilityState, TMBoltUpdateAvailabilityStateVariables>;
export const MDotykackaDeleteProfileDocument = gql`
    mutation MDotykackaDeleteProfile($id: ID!) {
  dotykackaProfile: updateDotykackaProfile(id: $id, profile: {isDeleted: true}) {
    id
  }
}
    `;
export type TMDotykackaDeleteProfileMutationFn = ApolloReactCommon.MutationFunction<TMDotykackaDeleteProfile, TMDotykackaDeleteProfileVariables>;
export function useMDotykackaDeleteProfile(baseOptions?: ApolloReactHooks.MutationHookOptions<TMDotykackaDeleteProfile, TMDotykackaDeleteProfileVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMDotykackaDeleteProfile, TMDotykackaDeleteProfileVariables>(MDotykackaDeleteProfileDocument, options);
      }
export type MDotykackaDeleteProfileHookResult = ReturnType<typeof useMDotykackaDeleteProfile>;
export type MDotykackaDeleteProfileMutationResult = ApolloReactCommon.MutationResult<TMDotykackaDeleteProfile>;
export type MDotykackaDeleteProfileMutationOptions = ApolloReactCommon.BaseMutationOptions<TMDotykackaDeleteProfile, TMDotykackaDeleteProfileVariables>;
export const MDotykackaEditProfileDocument = gql`
    mutation MDotykackaEditProfile($id: ID!, $name: String!) {
  dotykackaProfile: updateDotykackaProfile(id: $id, profile: {name: $name}) {
    id
  }
}
    `;
export type TMDotykackaEditProfileMutationFn = ApolloReactCommon.MutationFunction<TMDotykackaEditProfile, TMDotykackaEditProfileVariables>;
export function useMDotykackaEditProfile(baseOptions?: ApolloReactHooks.MutationHookOptions<TMDotykackaEditProfile, TMDotykackaEditProfileVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMDotykackaEditProfile, TMDotykackaEditProfileVariables>(MDotykackaEditProfileDocument, options);
      }
export type MDotykackaEditProfileHookResult = ReturnType<typeof useMDotykackaEditProfile>;
export type MDotykackaEditProfileMutationResult = ApolloReactCommon.MutationResult<TMDotykackaEditProfile>;
export type MDotykackaEditProfileMutationOptions = ApolloReactCommon.BaseMutationOptions<TMDotykackaEditProfile, TMDotykackaEditProfileVariables>;
export const MFoodoraAcceptOrderDocument = gql`
    mutation MFoodoraAcceptOrder($orderId: ID!, $deliverAt: DateTime) {
  acceptFoodoraOrder(orderId: $orderId, deliverAt: $deliverAt) {
    ...FOrderStateCategory
    ...FOrderForTimeline
  }
}
    ${FOrderStateCategory}
${FOrderForTimeline}`;
export type TMFoodoraAcceptOrderMutationFn = ApolloReactCommon.MutationFunction<TMFoodoraAcceptOrder, TMFoodoraAcceptOrderVariables>;
export function useMFoodoraAcceptOrder(baseOptions?: ApolloReactHooks.MutationHookOptions<TMFoodoraAcceptOrder, TMFoodoraAcceptOrderVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMFoodoraAcceptOrder, TMFoodoraAcceptOrderVariables>(MFoodoraAcceptOrderDocument, options);
      }
export type MFoodoraAcceptOrderHookResult = ReturnType<typeof useMFoodoraAcceptOrder>;
export type MFoodoraAcceptOrderMutationResult = ApolloReactCommon.MutationResult<TMFoodoraAcceptOrder>;
export type MFoodoraAcceptOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<TMFoodoraAcceptOrder, TMFoodoraAcceptOrderVariables>;
export const MFoodoraAdjustOrderPickupTimeDocument = gql`
    mutation MFoodoraAdjustOrderPickupTime($orderId: ID!, $pickupAt: DateTime!) {
  adjustFoodoraOrderPickupTime(orderId: $orderId, pickupAt: $pickupAt) {
    id
  }
}
    `;
export type TMFoodoraAdjustOrderPickupTimeMutationFn = ApolloReactCommon.MutationFunction<TMFoodoraAdjustOrderPickupTime, TMFoodoraAdjustOrderPickupTimeVariables>;
export function useMFoodoraAdjustOrderPickupTime(baseOptions?: ApolloReactHooks.MutationHookOptions<TMFoodoraAdjustOrderPickupTime, TMFoodoraAdjustOrderPickupTimeVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMFoodoraAdjustOrderPickupTime, TMFoodoraAdjustOrderPickupTimeVariables>(MFoodoraAdjustOrderPickupTimeDocument, options);
      }
export type MFoodoraAdjustOrderPickupTimeHookResult = ReturnType<typeof useMFoodoraAdjustOrderPickupTime>;
export type MFoodoraAdjustOrderPickupTimeMutationResult = ApolloReactCommon.MutationResult<TMFoodoraAdjustOrderPickupTime>;
export type MFoodoraAdjustOrderPickupTimeMutationOptions = ApolloReactCommon.BaseMutationOptions<TMFoodoraAdjustOrderPickupTime, TMFoodoraAdjustOrderPickupTimeVariables>;
export const MFoodoraDeleteProfileDocument = gql`
    mutation MFoodoraDeleteProfile($id: ID!) {
  foodoraProfile: updateFoodoraProfile(id: $id, profile: {isDeleted: true}) {
    id
  }
}
    `;
export type TMFoodoraDeleteProfileMutationFn = ApolloReactCommon.MutationFunction<TMFoodoraDeleteProfile, TMFoodoraDeleteProfileVariables>;
export function useMFoodoraDeleteProfile(baseOptions?: ApolloReactHooks.MutationHookOptions<TMFoodoraDeleteProfile, TMFoodoraDeleteProfileVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMFoodoraDeleteProfile, TMFoodoraDeleteProfileVariables>(MFoodoraDeleteProfileDocument, options);
      }
export type MFoodoraDeleteProfileHookResult = ReturnType<typeof useMFoodoraDeleteProfile>;
export type MFoodoraDeleteProfileMutationResult = ApolloReactCommon.MutationResult<TMFoodoraDeleteProfile>;
export type MFoodoraDeleteProfileMutationOptions = ApolloReactCommon.BaseMutationOptions<TMFoodoraDeleteProfile, TMFoodoraDeleteProfileVariables>;
export const MFoodoraEditProfileDocument = gql`
    mutation MFoodoraEditProfile($id: ID!, $name: String!, $isAutomaticMenuSyncEnabled: Boolean) {
  foodoraProfile: updateFoodoraProfile(id: $id, profile: {name: $name, isAutomaticMenuSyncEnabled: $isAutomaticMenuSyncEnabled}) {
    id
    isAutomaticMenuSyncEnabled
  }
}
    `;
export type TMFoodoraEditProfileMutationFn = ApolloReactCommon.MutationFunction<TMFoodoraEditProfile, TMFoodoraEditProfileVariables>;
export function useMFoodoraEditProfile(baseOptions?: ApolloReactHooks.MutationHookOptions<TMFoodoraEditProfile, TMFoodoraEditProfileVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMFoodoraEditProfile, TMFoodoraEditProfileVariables>(MFoodoraEditProfileDocument, options);
      }
export type MFoodoraEditProfileHookResult = ReturnType<typeof useMFoodoraEditProfile>;
export type MFoodoraEditProfileMutationResult = ApolloReactCommon.MutationResult<TMFoodoraEditProfile>;
export type MFoodoraEditProfileMutationOptions = ApolloReactCommon.BaseMutationOptions<TMFoodoraEditProfile, TMFoodoraEditProfileVariables>;
export const MFoodoraPushMenuDocument = gql`
    mutation MFoodoraPushMenu($profileId: ID!) {
  pushFoodoraMenu(profileId: $profileId) {
    id
    ...FFoodoraProfileWithStates
  }
}
    ${FFoodoraProfileWithStates}`;
export type TMFoodoraPushMenuMutationFn = ApolloReactCommon.MutationFunction<TMFoodoraPushMenu, TMFoodoraPushMenuVariables>;
export function useMFoodoraPushMenu(baseOptions?: ApolloReactHooks.MutationHookOptions<TMFoodoraPushMenu, TMFoodoraPushMenuVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMFoodoraPushMenu, TMFoodoraPushMenuVariables>(MFoodoraPushMenuDocument, options);
      }
export type MFoodoraPushMenuHookResult = ReturnType<typeof useMFoodoraPushMenu>;
export type MFoodoraPushMenuMutationResult = ApolloReactCommon.MutationResult<TMFoodoraPushMenu>;
export type MFoodoraPushMenuMutationOptions = ApolloReactCommon.BaseMutationOptions<TMFoodoraPushMenu, TMFoodoraPushMenuVariables>;
export const MFoodoraRejectOrderDocument = gql`
    mutation MFoodoraRejectOrder($orderId: ID!) {
  cancelFoodoraOrder(orderId: $orderId) {
    ...FOrderStateCategory
    ...FOrderForTimeline
  }
}
    ${FOrderStateCategory}
${FOrderForTimeline}`;
export type TMFoodoraRejectOrderMutationFn = ApolloReactCommon.MutationFunction<TMFoodoraRejectOrder, TMFoodoraRejectOrderVariables>;
export function useMFoodoraRejectOrder(baseOptions?: ApolloReactHooks.MutationHookOptions<TMFoodoraRejectOrder, TMFoodoraRejectOrderVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMFoodoraRejectOrder, TMFoodoraRejectOrderVariables>(MFoodoraRejectOrderDocument, options);
      }
export type MFoodoraRejectOrderHookResult = ReturnType<typeof useMFoodoraRejectOrder>;
export type MFoodoraRejectOrderMutationResult = ApolloReactCommon.MutationResult<TMFoodoraRejectOrder>;
export type MFoodoraRejectOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<TMFoodoraRejectOrder, TMFoodoraRejectOrderVariables>;
export const MFoodoraUpdateAutomaticMenuSyncDocument = gql`
    mutation MFoodoraUpdateAutomaticMenuSync($id: ID!, $isAutomaticMenuSyncEnabled: Boolean!) {
  foodoraProfile: updateFoodoraProfile(id: $id, profile: {isAutomaticMenuSyncEnabled: $isAutomaticMenuSyncEnabled}) {
    id
  }
}
    `;
export type TMFoodoraUpdateAutomaticMenuSyncMutationFn = ApolloReactCommon.MutationFunction<TMFoodoraUpdateAutomaticMenuSync, TMFoodoraUpdateAutomaticMenuSyncVariables>;
export function useMFoodoraUpdateAutomaticMenuSync(baseOptions?: ApolloReactHooks.MutationHookOptions<TMFoodoraUpdateAutomaticMenuSync, TMFoodoraUpdateAutomaticMenuSyncVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMFoodoraUpdateAutomaticMenuSync, TMFoodoraUpdateAutomaticMenuSyncVariables>(MFoodoraUpdateAutomaticMenuSyncDocument, options);
      }
export type MFoodoraUpdateAutomaticMenuSyncHookResult = ReturnType<typeof useMFoodoraUpdateAutomaticMenuSync>;
export type MFoodoraUpdateAutomaticMenuSyncMutationResult = ApolloReactCommon.MutationResult<TMFoodoraUpdateAutomaticMenuSync>;
export type MFoodoraUpdateAutomaticMenuSyncMutationOptions = ApolloReactCommon.BaseMutationOptions<TMFoodoraUpdateAutomaticMenuSync, TMFoodoraUpdateAutomaticMenuSyncVariables>;
export const MFoodoraUpdateAvailabilityStateDocument = gql`
    mutation MFoodoraUpdateAvailabilityState($profileId: ID!, $availabilityState: FoodoraAvailabilityStateGlEnum!) {
  updateFoodoraAvailabilityState(profileId: $profileId, availabilityState: $availabilityState, closedReason: TECHNICAL_PROBLEM) {
    id
    onlineState {
      ...FIntegrationOnlineState
    }
  }
}
    ${FIntegrationOnlineState}`;
export type TMFoodoraUpdateAvailabilityStateMutationFn = ApolloReactCommon.MutationFunction<TMFoodoraUpdateAvailabilityState, TMFoodoraUpdateAvailabilityStateVariables>;
export function useMFoodoraUpdateAvailabilityState(baseOptions?: ApolloReactHooks.MutationHookOptions<TMFoodoraUpdateAvailabilityState, TMFoodoraUpdateAvailabilityStateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMFoodoraUpdateAvailabilityState, TMFoodoraUpdateAvailabilityStateVariables>(MFoodoraUpdateAvailabilityStateDocument, options);
      }
export type MFoodoraUpdateAvailabilityStateHookResult = ReturnType<typeof useMFoodoraUpdateAvailabilityState>;
export type MFoodoraUpdateAvailabilityStateMutationResult = ApolloReactCommon.MutationResult<TMFoodoraUpdateAvailabilityState>;
export type MFoodoraUpdateAvailabilityStateMutationOptions = ApolloReactCommon.BaseMutationOptions<TMFoodoraUpdateAvailabilityState, TMFoodoraUpdateAvailabilityStateVariables>;
export const MJidloPodNosAcceptOrderDocument = gql`
    mutation MJidloPodNosAcceptOrder($orderId: ID!, $deliverAt: DateTime) {
  acceptJidloPodNosOrder(orderId: $orderId, deliverAt: $deliverAt) {
    ...FOrderStateCategory
    ...FOrderForTimeline
  }
}
    ${FOrderStateCategory}
${FOrderForTimeline}`;
export type TMJidloPodNosAcceptOrderMutationFn = ApolloReactCommon.MutationFunction<TMJidloPodNosAcceptOrder, TMJidloPodNosAcceptOrderVariables>;
export function useMJidloPodNosAcceptOrder(baseOptions?: ApolloReactHooks.MutationHookOptions<TMJidloPodNosAcceptOrder, TMJidloPodNosAcceptOrderVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMJidloPodNosAcceptOrder, TMJidloPodNosAcceptOrderVariables>(MJidloPodNosAcceptOrderDocument, options);
      }
export type MJidloPodNosAcceptOrderHookResult = ReturnType<typeof useMJidloPodNosAcceptOrder>;
export type MJidloPodNosAcceptOrderMutationResult = ApolloReactCommon.MutationResult<TMJidloPodNosAcceptOrder>;
export type MJidloPodNosAcceptOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<TMJidloPodNosAcceptOrder, TMJidloPodNosAcceptOrderVariables>;
export const MJidloPodNosDeleteProfileDocument = gql`
    mutation MJidloPodNosDeleteProfile($id: ID!) {
  jidloPodNosProfile: updateJidloPodNosProfile(id: $id, profile: {isDeleted: true}) {
    id
  }
}
    `;
export type TMJidloPodNosDeleteProfileMutationFn = ApolloReactCommon.MutationFunction<TMJidloPodNosDeleteProfile, TMJidloPodNosDeleteProfileVariables>;
export function useMJidloPodNosDeleteProfile(baseOptions?: ApolloReactHooks.MutationHookOptions<TMJidloPodNosDeleteProfile, TMJidloPodNosDeleteProfileVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMJidloPodNosDeleteProfile, TMJidloPodNosDeleteProfileVariables>(MJidloPodNosDeleteProfileDocument, options);
      }
export type MJidloPodNosDeleteProfileHookResult = ReturnType<typeof useMJidloPodNosDeleteProfile>;
export type MJidloPodNosDeleteProfileMutationResult = ApolloReactCommon.MutationResult<TMJidloPodNosDeleteProfile>;
export type MJidloPodNosDeleteProfileMutationOptions = ApolloReactCommon.BaseMutationOptions<TMJidloPodNosDeleteProfile, TMJidloPodNosDeleteProfileVariables>;
export const MJidloPodNosEditProfileDocument = gql`
    mutation MJidloPodNosEditProfile($id: ID!, $name: String!) {
  jidloPodNosProfile: updateJidloPodNosProfile(id: $id, profile: {name: $name}) {
    id
  }
}
    `;
export type TMJidloPodNosEditProfileMutationFn = ApolloReactCommon.MutationFunction<TMJidloPodNosEditProfile, TMJidloPodNosEditProfileVariables>;
export function useMJidloPodNosEditProfile(baseOptions?: ApolloReactHooks.MutationHookOptions<TMJidloPodNosEditProfile, TMJidloPodNosEditProfileVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMJidloPodNosEditProfile, TMJidloPodNosEditProfileVariables>(MJidloPodNosEditProfileDocument, options);
      }
export type MJidloPodNosEditProfileHookResult = ReturnType<typeof useMJidloPodNosEditProfile>;
export type MJidloPodNosEditProfileMutationResult = ApolloReactCommon.MutationResult<TMJidloPodNosEditProfile>;
export type MJidloPodNosEditProfileMutationOptions = ApolloReactCommon.BaseMutationOptions<TMJidloPodNosEditProfile, TMJidloPodNosEditProfileVariables>;
export const MJidloPodNosRejectOrderDocument = gql`
    mutation MJidloPodNosRejectOrder($orderId: ID!, $reason: String!) {
  cancelJidloPodNosOrder(orderId: $orderId, reason: $reason) {
    ...FOrderStateCategory
    ...FOrderForTimeline
  }
}
    ${FOrderStateCategory}
${FOrderForTimeline}`;
export type TMJidloPodNosRejectOrderMutationFn = ApolloReactCommon.MutationFunction<TMJidloPodNosRejectOrder, TMJidloPodNosRejectOrderVariables>;
export function useMJidloPodNosRejectOrder(baseOptions?: ApolloReactHooks.MutationHookOptions<TMJidloPodNosRejectOrder, TMJidloPodNosRejectOrderVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMJidloPodNosRejectOrder, TMJidloPodNosRejectOrderVariables>(MJidloPodNosRejectOrderDocument, options);
      }
export type MJidloPodNosRejectOrderHookResult = ReturnType<typeof useMJidloPodNosRejectOrder>;
export type MJidloPodNosRejectOrderMutationResult = ApolloReactCommon.MutationResult<TMJidloPodNosRejectOrder>;
export type MJidloPodNosRejectOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<TMJidloPodNosRejectOrder, TMJidloPodNosRejectOrderVariables>;
export const MWoltAcceptOrderDocument = gql`
    mutation MWoltAcceptOrder($orderId: ID!, $deliverAt: DateTime) {
  acceptWoltOrder(orderId: $orderId, deliverAt: $deliverAt) {
    ...FOrderStateCategory
    ...FOrderForTimeline
  }
}
    ${FOrderStateCategory}
${FOrderForTimeline}`;
export type TMWoltAcceptOrderMutationFn = ApolloReactCommon.MutationFunction<TMWoltAcceptOrder, TMWoltAcceptOrderVariables>;
export function useMWoltAcceptOrder(baseOptions?: ApolloReactHooks.MutationHookOptions<TMWoltAcceptOrder, TMWoltAcceptOrderVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMWoltAcceptOrder, TMWoltAcceptOrderVariables>(MWoltAcceptOrderDocument, options);
      }
export type MWoltAcceptOrderHookResult = ReturnType<typeof useMWoltAcceptOrder>;
export type MWoltAcceptOrderMutationResult = ApolloReactCommon.MutationResult<TMWoltAcceptOrder>;
export type MWoltAcceptOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<TMWoltAcceptOrder, TMWoltAcceptOrderVariables>;
export const MWoltCreateProfileDocument = gql`
    mutation MWoltCreateProfile($branchId: ID!, $name: String!) {
  woltProfile: createWoltProfile(profile: {companyBranchId: $branchId, name: $name}) {
    id
  }
}
    `;
export type TMWoltCreateProfileMutationFn = ApolloReactCommon.MutationFunction<TMWoltCreateProfile, TMWoltCreateProfileVariables>;
export function useMWoltCreateProfile(baseOptions?: ApolloReactHooks.MutationHookOptions<TMWoltCreateProfile, TMWoltCreateProfileVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMWoltCreateProfile, TMWoltCreateProfileVariables>(MWoltCreateProfileDocument, options);
      }
export type MWoltCreateProfileHookResult = ReturnType<typeof useMWoltCreateProfile>;
export type MWoltCreateProfileMutationResult = ApolloReactCommon.MutationResult<TMWoltCreateProfile>;
export type MWoltCreateProfileMutationOptions = ApolloReactCommon.BaseMutationOptions<TMWoltCreateProfile, TMWoltCreateProfileVariables>;
export const MWoltDeleteProfileDocument = gql`
    mutation MWoltDeleteProfile($id: ID!) {
  woltProfile: updateWoltProfile(id: $id, profile: {isDeleted: true}) {
    id
  }
}
    `;
export type TMWoltDeleteProfileMutationFn = ApolloReactCommon.MutationFunction<TMWoltDeleteProfile, TMWoltDeleteProfileVariables>;
export function useMWoltDeleteProfile(baseOptions?: ApolloReactHooks.MutationHookOptions<TMWoltDeleteProfile, TMWoltDeleteProfileVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMWoltDeleteProfile, TMWoltDeleteProfileVariables>(MWoltDeleteProfileDocument, options);
      }
export type MWoltDeleteProfileHookResult = ReturnType<typeof useMWoltDeleteProfile>;
export type MWoltDeleteProfileMutationResult = ApolloReactCommon.MutationResult<TMWoltDeleteProfile>;
export type MWoltDeleteProfileMutationOptions = ApolloReactCommon.BaseMutationOptions<TMWoltDeleteProfile, TMWoltDeleteProfileVariables>;
export const MWoltEditProfileDocument = gql`
    mutation MWoltEditProfile($id: ID!, $name: String!, $isAutomaticMenuSyncEnabled: Boolean) {
  woltProfile: updateWoltProfile(id: $id, profile: {name: $name, isAutomaticMenuSyncEnabled: $isAutomaticMenuSyncEnabled}) {
    id
    isAutomaticMenuSyncEnabled
  }
}
    `;
export type TMWoltEditProfileMutationFn = ApolloReactCommon.MutationFunction<TMWoltEditProfile, TMWoltEditProfileVariables>;
export function useMWoltEditProfile(baseOptions?: ApolloReactHooks.MutationHookOptions<TMWoltEditProfile, TMWoltEditProfileVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMWoltEditProfile, TMWoltEditProfileVariables>(MWoltEditProfileDocument, options);
      }
export type MWoltEditProfileHookResult = ReturnType<typeof useMWoltEditProfile>;
export type MWoltEditProfileMutationResult = ApolloReactCommon.MutationResult<TMWoltEditProfile>;
export type MWoltEditProfileMutationOptions = ApolloReactCommon.BaseMutationOptions<TMWoltEditProfile, TMWoltEditProfileVariables>;
export const MWoltOnboardingUrlDocument = gql`
    mutation MWoltOnboardingUrl($profileId: ID!, $redirectUrl: String!) {
  woltOnboardingUrl(profileId: $profileId, redirectUrl: $redirectUrl) {
    url
  }
}
    `;
export type TMWoltOnboardingUrlMutationFn = ApolloReactCommon.MutationFunction<TMWoltOnboardingUrl, TMWoltOnboardingUrlVariables>;
export function useMWoltOnboardingUrl(baseOptions?: ApolloReactHooks.MutationHookOptions<TMWoltOnboardingUrl, TMWoltOnboardingUrlVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMWoltOnboardingUrl, TMWoltOnboardingUrlVariables>(MWoltOnboardingUrlDocument, options);
      }
export type MWoltOnboardingUrlHookResult = ReturnType<typeof useMWoltOnboardingUrl>;
export type MWoltOnboardingUrlMutationResult = ApolloReactCommon.MutationResult<TMWoltOnboardingUrl>;
export type MWoltOnboardingUrlMutationOptions = ApolloReactCommon.BaseMutationOptions<TMWoltOnboardingUrl, TMWoltOnboardingUrlVariables>;
export const MWoltPushMenuDocument = gql`
    mutation MWoltPushMenu($profileId: ID!) {
  pushWoltMenu(profileId: $profileId) {
    id
    ...FWoltProfileWithStates
  }
}
    ${FWoltProfileWithStates}`;
export type TMWoltPushMenuMutationFn = ApolloReactCommon.MutationFunction<TMWoltPushMenu, TMWoltPushMenuVariables>;
export function useMWoltPushMenu(baseOptions?: ApolloReactHooks.MutationHookOptions<TMWoltPushMenu, TMWoltPushMenuVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMWoltPushMenu, TMWoltPushMenuVariables>(MWoltPushMenuDocument, options);
      }
export type MWoltPushMenuHookResult = ReturnType<typeof useMWoltPushMenu>;
export type MWoltPushMenuMutationResult = ApolloReactCommon.MutationResult<TMWoltPushMenu>;
export type MWoltPushMenuMutationOptions = ApolloReactCommon.BaseMutationOptions<TMWoltPushMenu, TMWoltPushMenuVariables>;
export const MWoltRejectOrderDocument = gql`
    mutation MWoltRejectOrder($orderId: ID!, $reason: String) {
  cancelWoltOrder(orderId: $orderId, reason: $reason) {
    ...FOrderStateCategory
    ...FOrderForTimeline
  }
}
    ${FOrderStateCategory}
${FOrderForTimeline}`;
export type TMWoltRejectOrderMutationFn = ApolloReactCommon.MutationFunction<TMWoltRejectOrder, TMWoltRejectOrderVariables>;
export function useMWoltRejectOrder(baseOptions?: ApolloReactHooks.MutationHookOptions<TMWoltRejectOrder, TMWoltRejectOrderVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMWoltRejectOrder, TMWoltRejectOrderVariables>(MWoltRejectOrderDocument, options);
      }
export type MWoltRejectOrderHookResult = ReturnType<typeof useMWoltRejectOrder>;
export type MWoltRejectOrderMutationResult = ApolloReactCommon.MutationResult<TMWoltRejectOrder>;
export type MWoltRejectOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<TMWoltRejectOrder, TMWoltRejectOrderVariables>;
export const MWoltUpdateAutomaticMenuSyncDocument = gql`
    mutation MWoltUpdateAutomaticMenuSync($id: ID!, $isAutomaticMenuSyncEnabled: Boolean!) {
  woltProfile: updateWoltProfile(id: $id, profile: {isAutomaticMenuSyncEnabled: $isAutomaticMenuSyncEnabled}) {
    id
  }
}
    `;
export type TMWoltUpdateAutomaticMenuSyncMutationFn = ApolloReactCommon.MutationFunction<TMWoltUpdateAutomaticMenuSync, TMWoltUpdateAutomaticMenuSyncVariables>;
export function useMWoltUpdateAutomaticMenuSync(baseOptions?: ApolloReactHooks.MutationHookOptions<TMWoltUpdateAutomaticMenuSync, TMWoltUpdateAutomaticMenuSyncVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMWoltUpdateAutomaticMenuSync, TMWoltUpdateAutomaticMenuSyncVariables>(MWoltUpdateAutomaticMenuSyncDocument, options);
      }
export type MWoltUpdateAutomaticMenuSyncHookResult = ReturnType<typeof useMWoltUpdateAutomaticMenuSync>;
export type MWoltUpdateAutomaticMenuSyncMutationResult = ApolloReactCommon.MutationResult<TMWoltUpdateAutomaticMenuSync>;
export type MWoltUpdateAutomaticMenuSyncMutationOptions = ApolloReactCommon.BaseMutationOptions<TMWoltUpdateAutomaticMenuSync, TMWoltUpdateAutomaticMenuSyncVariables>;
export const MWoltUpdateDeliveryProviderDocument = gql`
    mutation MWoltUpdateDeliveryProvider($profileId: ID!, $deliveryProvider: WoltDeliveryProviderEnum!) {
  updateWoltDeliveryProvider(profileId: $profileId, deliveryProvider: $deliveryProvider) {
    id
  }
}
    `;
export type TMWoltUpdateDeliveryProviderMutationFn = ApolloReactCommon.MutationFunction<TMWoltUpdateDeliveryProvider, TMWoltUpdateDeliveryProviderVariables>;
export function useMWoltUpdateDeliveryProvider(baseOptions?: ApolloReactHooks.MutationHookOptions<TMWoltUpdateDeliveryProvider, TMWoltUpdateDeliveryProviderVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMWoltUpdateDeliveryProvider, TMWoltUpdateDeliveryProviderVariables>(MWoltUpdateDeliveryProviderDocument, options);
      }
export type MWoltUpdateDeliveryProviderHookResult = ReturnType<typeof useMWoltUpdateDeliveryProvider>;
export type MWoltUpdateDeliveryProviderMutationResult = ApolloReactCommon.MutationResult<TMWoltUpdateDeliveryProvider>;
export type MWoltUpdateDeliveryProviderMutationOptions = ApolloReactCommon.BaseMutationOptions<TMWoltUpdateDeliveryProvider, TMWoltUpdateDeliveryProviderVariables>;
export const MWoltUpdateOnlineStateDocument = gql`
    mutation MWoltUpdateOnlineState($profileId: ID!, $onlineState: IntegrationStateEnum!, $until: DateTime) {
  updateWoltOnlineState(profileId: $profileId, onlineState: $onlineState, until: $until) {
    id
  }
}
    `;
export type TMWoltUpdateOnlineStateMutationFn = ApolloReactCommon.MutationFunction<TMWoltUpdateOnlineState, TMWoltUpdateOnlineStateVariables>;
export function useMWoltUpdateOnlineState(baseOptions?: ApolloReactHooks.MutationHookOptions<TMWoltUpdateOnlineState, TMWoltUpdateOnlineStateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMWoltUpdateOnlineState, TMWoltUpdateOnlineStateVariables>(MWoltUpdateOnlineStateDocument, options);
      }
export type MWoltUpdateOnlineStateHookResult = ReturnType<typeof useMWoltUpdateOnlineState>;
export type MWoltUpdateOnlineStateMutationResult = ApolloReactCommon.MutationResult<TMWoltUpdateOnlineState>;
export type MWoltUpdateOnlineStateMutationOptions = ApolloReactCommon.BaseMutationOptions<TMWoltUpdateOnlineState, TMWoltUpdateOnlineStateVariables>;
export const QBranchesForIntegrationsOverviewDocument = gql`
    query QBranchesForIntegrationsOverview($branchesIds: [ID!]) {
  companyBranches(ids: $branchesIds) {
    id
    name
    woltProfiles {
      ...FWoltProfileWithStates
    }
    foodoraProfiles {
      ...FFoodoraProfileWithStates
    }
    boltProfiles {
      ...FBoltProfileWithStates
    }
    jidloPodNosProfiles {
      ...FJidloPodNosProfileWithStates
    }
    dotykackaProfiles {
      ...FDotykackaProfileWithStates
    }
  }
}
    ${FWoltProfileWithStates}
${FFoodoraProfileWithStates}
${FBoltProfileWithStates}
${FJidloPodNosProfileWithStates}
${FDotykackaProfileWithStates}`;
export function useQBranchesForIntegrationsOverview(baseOptions?: ApolloReactHooks.QueryHookOptions<TQBranchesForIntegrationsOverview, TQBranchesForIntegrationsOverviewVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQBranchesForIntegrationsOverview, TQBranchesForIntegrationsOverviewVariables>(QBranchesForIntegrationsOverviewDocument, options);
      }
export function useQBranchesForIntegrationsOverviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQBranchesForIntegrationsOverview, TQBranchesForIntegrationsOverviewVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQBranchesForIntegrationsOverview, TQBranchesForIntegrationsOverviewVariables>(QBranchesForIntegrationsOverviewDocument, options);
        }
export type QBranchesForIntegrationsOverviewHookResult = ReturnType<typeof useQBranchesForIntegrationsOverview>;
export type QBranchesForIntegrationsOverviewLazyQueryHookResult = ReturnType<typeof useQBranchesForIntegrationsOverviewLazyQuery>;
export type QBranchesForIntegrationsOverviewQueryResult = ApolloReactCommon.QueryResult<TQBranchesForIntegrationsOverview, TQBranchesForIntegrationsOverviewVariables>;
export const QBranchesStatusesDocument = gql`
    query QBranchesStatuses($branchesIds: [ID!]) {
  states: aggregatedIntegrationStates(companyBranchIds: $branchesIds) {
    foodora {
      integrationState {
        ...FIntegrationOnlineState
      }
    }
    wolt {
      integrationState {
        ...FIntegrationOnlineState
      }
    }
    bolt {
      integrationState {
        ...FIntegrationOnlineState
      }
    }
  }
}
    ${FIntegrationOnlineState}`;
export function useQBranchesStatuses(baseOptions?: ApolloReactHooks.QueryHookOptions<TQBranchesStatuses, TQBranchesStatusesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQBranchesStatuses, TQBranchesStatusesVariables>(QBranchesStatusesDocument, options);
      }
export function useQBranchesStatusesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQBranchesStatuses, TQBranchesStatusesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQBranchesStatuses, TQBranchesStatusesVariables>(QBranchesStatusesDocument, options);
        }
export type QBranchesStatusesHookResult = ReturnType<typeof useQBranchesStatuses>;
export type QBranchesStatusesLazyQueryHookResult = ReturnType<typeof useQBranchesStatusesLazyQuery>;
export type QBranchesStatusesQueryResult = ApolloReactCommon.QueryResult<TQBranchesStatuses, TQBranchesStatusesVariables>;
export const QIntegrationProfilesDocument = gql`
    query QIntegrationProfiles($branchId: ID!, $onboardingStates: [WoltProfileOnboardingStateEnum!]) {
  companyBranch(id: $branchId) {
    id
    woltProfiles(onboardingStates: $onboardingStates) {
      ...FWoltProfile
    }
    foodoraProfiles {
      ...FFoodoraBase
    }
    boltProfiles {
      ...FBoltBase
      integrationFlow {
        id
        enum
      }
    }
    jidloPodNosProfiles {
      ...FJidloPodNosBase
    }
    dotykackaProfiles {
      ...FDotykackaBase
    }
  }
}
    ${FWoltProfile}
${FFoodoraBase}
${FBoltBase}
${FJidloPodNosBase}
${FDotykackaBase}`;
export function useQIntegrationProfiles(baseOptions: ApolloReactHooks.QueryHookOptions<TQIntegrationProfiles, TQIntegrationProfilesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQIntegrationProfiles, TQIntegrationProfilesVariables>(QIntegrationProfilesDocument, options);
      }
export function useQIntegrationProfilesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQIntegrationProfiles, TQIntegrationProfilesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQIntegrationProfiles, TQIntegrationProfilesVariables>(QIntegrationProfilesDocument, options);
        }
export type QIntegrationProfilesHookResult = ReturnType<typeof useQIntegrationProfiles>;
export type QIntegrationProfilesLazyQueryHookResult = ReturnType<typeof useQIntegrationProfilesLazyQuery>;
export type QIntegrationProfilesQueryResult = ApolloReactCommon.QueryResult<TQIntegrationProfiles, TQIntegrationProfilesVariables>;
export const QWoltProfileDocument = gql`
    query QWoltProfile($id: ID!) {
  woltProfile(id: $id) {
    ...FWoltProfile
  }
}
    ${FWoltProfile}`;
export function useQWoltProfile(baseOptions: ApolloReactHooks.QueryHookOptions<TQWoltProfile, TQWoltProfileVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQWoltProfile, TQWoltProfileVariables>(QWoltProfileDocument, options);
      }
export function useQWoltProfileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQWoltProfile, TQWoltProfileVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQWoltProfile, TQWoltProfileVariables>(QWoltProfileDocument, options);
        }
export type QWoltProfileHookResult = ReturnType<typeof useQWoltProfile>;
export type QWoltProfileLazyQueryHookResult = ReturnType<typeof useQWoltProfileLazyQuery>;
export type QWoltProfileQueryResult = ApolloReactCommon.QueryResult<TQWoltProfile, TQWoltProfileVariables>;
export const MKitchenOrderHandleDocument = gql`
    mutation MKitchenOrderHandle($orderId: ID!, $state: OrderStateEnum!) {
  addOrderState(order: $orderId, orderState: $state) {
    ...FOrderStateCategory
  }
}
    ${FOrderStateCategory}`;
export type TMKitchenOrderHandleMutationFn = ApolloReactCommon.MutationFunction<TMKitchenOrderHandle, TMKitchenOrderHandleVariables>;
export function useMKitchenOrderHandle(baseOptions?: ApolloReactHooks.MutationHookOptions<TMKitchenOrderHandle, TMKitchenOrderHandleVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMKitchenOrderHandle, TMKitchenOrderHandleVariables>(MKitchenOrderHandleDocument, options);
      }
export type MKitchenOrderHandleHookResult = ReturnType<typeof useMKitchenOrderHandle>;
export type MKitchenOrderHandleMutationResult = ApolloReactCommon.MutationResult<TMKitchenOrderHandle>;
export type MKitchenOrderHandleMutationOptions = ApolloReactCommon.BaseMutationOptions<TMKitchenOrderHandle, TMKitchenOrderHandleVariables>;
export const MKitchenOrderRecipeHandleDocument = gql`
    mutation MKitchenOrderRecipeHandle($orderRecipeId: ID!, $state: OrderRecipeStateEnum!) {
  orderRecipe: updateOrderRecipeState(id: $orderRecipeId, orderRecipeState: $state) {
    ...FKitchenOrderState
  }
}
    ${FKitchenOrderState}`;
export type TMKitchenOrderRecipeHandleMutationFn = ApolloReactCommon.MutationFunction<TMKitchenOrderRecipeHandle, TMKitchenOrderRecipeHandleVariables>;
export function useMKitchenOrderRecipeHandle(baseOptions?: ApolloReactHooks.MutationHookOptions<TMKitchenOrderRecipeHandle, TMKitchenOrderRecipeHandleVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMKitchenOrderRecipeHandle, TMKitchenOrderRecipeHandleVariables>(MKitchenOrderRecipeHandleDocument, options);
      }
export type MKitchenOrderRecipeHandleHookResult = ReturnType<typeof useMKitchenOrderRecipeHandle>;
export type MKitchenOrderRecipeHandleMutationResult = ApolloReactCommon.MutationResult<TMKitchenOrderRecipeHandle>;
export type MKitchenOrderRecipeHandleMutationOptions = ApolloReactCommon.BaseMutationOptions<TMKitchenOrderRecipeHandle, TMKitchenOrderRecipeHandleVariables>;
export const MKitchenSectorHandleDocument = gql`
    mutation MKitchenSectorHandle($sectorId: ID!, $state: OrderRecipeStateEnum!) {
  sectorRecipe: updateSectorRecipes(sectorId: $sectorId, orderRecipeState: $state) {
    ...FKitchenSectorState
  }
}
    ${FKitchenSectorState}`;
export type TMKitchenSectorHandleMutationFn = ApolloReactCommon.MutationFunction<TMKitchenSectorHandle, TMKitchenSectorHandleVariables>;
export function useMKitchenSectorHandle(baseOptions?: ApolloReactHooks.MutationHookOptions<TMKitchenSectorHandle, TMKitchenSectorHandleVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMKitchenSectorHandle, TMKitchenSectorHandleVariables>(MKitchenSectorHandleDocument, options);
      }
export type MKitchenSectorHandleHookResult = ReturnType<typeof useMKitchenSectorHandle>;
export type MKitchenSectorHandleMutationResult = ApolloReactCommon.MutationResult<TMKitchenSectorHandle>;
export type MKitchenSectorHandleMutationOptions = ApolloReactCommon.BaseMutationOptions<TMKitchenSectorHandle, TMKitchenSectorHandleVariables>;
export const MKitchenSectorRecipeHandleDocument = gql`
    mutation MKitchenSectorRecipeHandle($sectorRecipeId: ID!, $state: OrderRecipeStateEnum!) {
  sectorRecipe: updateSectorRecipe(id: $sectorRecipeId, orderRecipeState: $state) {
    ...FKitchenSectorState
  }
}
    ${FKitchenSectorState}`;
export type TMKitchenSectorRecipeHandleMutationFn = ApolloReactCommon.MutationFunction<TMKitchenSectorRecipeHandle, TMKitchenSectorRecipeHandleVariables>;
export function useMKitchenSectorRecipeHandle(baseOptions?: ApolloReactHooks.MutationHookOptions<TMKitchenSectorRecipeHandle, TMKitchenSectorRecipeHandleVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMKitchenSectorRecipeHandle, TMKitchenSectorRecipeHandleVariables>(MKitchenSectorRecipeHandleDocument, options);
      }
export type MKitchenSectorRecipeHandleHookResult = ReturnType<typeof useMKitchenSectorRecipeHandle>;
export type MKitchenSectorRecipeHandleMutationResult = ApolloReactCommon.MutationResult<TMKitchenSectorRecipeHandle>;
export type MKitchenSectorRecipeHandleMutationOptions = ApolloReactCommon.BaseMutationOptions<TMKitchenSectorRecipeHandle, TMKitchenSectorRecipeHandleVariables>;
export const QKitchenCompletionOrderListDocument = gql`
    query QKitchenCompletionOrderList($branches: [ID!], $categories: [OrderStateCategoryEnum!], $sectors: [ID!], $workplaces: [ID!], $showOtherWorkplaces: Boolean!, $acceptedAfter: DateTime) {
  orders(order: {companyBranches: $branches, orderStateCategoryTarget: FE_COMPLETION, orderStateCategoriesOR: $categories, includeOldFinished: false, acceptedAfter: $acceptedAfter, sectors: $sectors, groups: $workplaces, sectorsWithChildren: true}) {
    ...FKitchenCompletionOrder
    ...FKitchenOrderWorkplaces @include(if: $showOtherWorkplaces)
  }
}
    ${FKitchenCompletionOrder}
${FKitchenOrderWorkplaces}`;
export function useQKitchenCompletionOrderList(baseOptions: ApolloReactHooks.QueryHookOptions<TQKitchenCompletionOrderList, TQKitchenCompletionOrderListVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQKitchenCompletionOrderList, TQKitchenCompletionOrderListVariables>(QKitchenCompletionOrderListDocument, options);
      }
export function useQKitchenCompletionOrderListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQKitchenCompletionOrderList, TQKitchenCompletionOrderListVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQKitchenCompletionOrderList, TQKitchenCompletionOrderListVariables>(QKitchenCompletionOrderListDocument, options);
        }
export type QKitchenCompletionOrderListHookResult = ReturnType<typeof useQKitchenCompletionOrderList>;
export type QKitchenCompletionOrderListLazyQueryHookResult = ReturnType<typeof useQKitchenCompletionOrderListLazyQuery>;
export type QKitchenCompletionOrderListQueryResult = ApolloReactCommon.QueryResult<TQKitchenCompletionOrderList, TQKitchenCompletionOrderListVariables>;
export const QKitchenOrderListDocument = gql`
    query QKitchenOrderList($sectors: [ID!], $branches: [ID!], $workplaces: [ID!], $showOtherWorkplaces: Boolean!, $shouldLoadOrderStates: Boolean!, $categories: [OrderStateCategoryEnum!], $acceptedAfter: DateTime) {
  orders(order: {sectors: $sectors, groups: $workplaces, includeOldFinished: false, acceptedAfter: $acceptedAfter, sectorsWithChildren: true, companyBranches: $branches, orderStateCategoriesOR: $categories, orderStateCategoryTarget: FE_KITCHEN}) {
    ...FKitchenOrder
    ...FKitchenOrderWorkplaces @include(if: $showOtherWorkplaces)
    ...FKitchenOrderStates @include(if: $shouldLoadOrderStates)
  }
}
    ${FKitchenOrder}
${FKitchenOrderWorkplaces}
${FKitchenOrderStates}`;
export function useQKitchenOrderList(baseOptions: ApolloReactHooks.QueryHookOptions<TQKitchenOrderList, TQKitchenOrderListVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQKitchenOrderList, TQKitchenOrderListVariables>(QKitchenOrderListDocument, options);
      }
export function useQKitchenOrderListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQKitchenOrderList, TQKitchenOrderListVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQKitchenOrderList, TQKitchenOrderListVariables>(QKitchenOrderListDocument, options);
        }
export type QKitchenOrderListHookResult = ReturnType<typeof useQKitchenOrderList>;
export type QKitchenOrderListLazyQueryHookResult = ReturnType<typeof useQKitchenOrderListLazyQuery>;
export type QKitchenOrderListQueryResult = ApolloReactCommon.QueryResult<TQKitchenOrderList, TQKitchenOrderListVariables>;
export const QKitchenSectorListDocument = gql`
    query QKitchenSectorList($sectors: [ID!], $branches: [ID!]!, $workplaces: [ID!], $showOtherWorkplaces: Boolean!, $states: [OrderRecipeStateEnum!]) {
  sectors(companyBranches: $branches, enabled: true) {
    id
    name
    warePriceType {
      enum
    }
    deliveryType {
      enum
    }
    companyBranch {
      id
      name
    }
  }
  sectorRecipes(sectors: $sectors, groups: $workplaces, sectorsWithChildren: true, companyBranches: $branches, orderRecipeStateOR: $states) {
    ...FKitchenSectorRecipe
    ...FKitchenSectorRecipeWorkplaces @include(if: $showOtherWorkplaces)
  }
}
    ${FKitchenSectorRecipe}
${FKitchenSectorRecipeWorkplaces}`;
export function useQKitchenSectorList(baseOptions: ApolloReactHooks.QueryHookOptions<TQKitchenSectorList, TQKitchenSectorListVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQKitchenSectorList, TQKitchenSectorListVariables>(QKitchenSectorListDocument, options);
      }
export function useQKitchenSectorListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQKitchenSectorList, TQKitchenSectorListVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQKitchenSectorList, TQKitchenSectorListVariables>(QKitchenSectorListDocument, options);
        }
export type QKitchenSectorListHookResult = ReturnType<typeof useQKitchenSectorList>;
export type QKitchenSectorListLazyQueryHookResult = ReturnType<typeof useQKitchenSectorListLazyQuery>;
export type QKitchenSectorListQueryResult = ApolloReactCommon.QueryResult<TQKitchenSectorList, TQKitchenSectorListVariables>;
export const SKitchenCompletionOrderListDocument = gql`
    subscription SKitchenCompletionOrderList($branches: [ID!], $categories: [OrderStateCategoryEnum!], $sectors: [ID!], $workplaces: [ID!], $showOtherWorkplaces: Boolean!) {
  updatedOrder(companyBranches: $branches, orderStateCategoriesOR: $categories, orderStateCategoryTarget: FE_COMPLETION, sectors: $sectors, groups: $workplaces, sectorsWithChildren: true) {
    order {
      ...FKitchenCompletionOrder
      ...FKitchenOrderWorkplaces @include(if: $showOtherWorkplaces)
    }
  }
}
    ${FKitchenCompletionOrder}
${FKitchenOrderWorkplaces}`;
export function useSKitchenCompletionOrderList(baseOptions: ApolloReactHooks.SubscriptionHookOptions<TSKitchenCompletionOrderList, TSKitchenCompletionOrderListVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<TSKitchenCompletionOrderList, TSKitchenCompletionOrderListVariables>(SKitchenCompletionOrderListDocument, options);
      }
export type SKitchenCompletionOrderListHookResult = ReturnType<typeof useSKitchenCompletionOrderList>;
export type SKitchenCompletionOrderListSubscriptionResult = ApolloReactCommon.SubscriptionResult<TSKitchenCompletionOrderList>;
export const SKitchenOrderListDocument = gql`
    subscription SKitchenOrderList($sectors: [ID!], $branches: [ID!], $workplaces: [ID!], $showOtherWorkplaces: Boolean!, $shouldLoadOrderStates: Boolean!, $categories: [OrderStateCategoryEnum!]) {
  updatedOrder(sectors: $sectors, groups: $workplaces, sectorsWithChildren: true, companyBranches: $branches, orderStateCategoriesOR: $categories, orderStateCategoryTarget: FE_KITCHEN) {
    order {
      ...FKitchenOrder
      ...FKitchenOrderWorkplaces @include(if: $showOtherWorkplaces)
      ...FKitchenOrderStates @include(if: $shouldLoadOrderStates)
    }
  }
}
    ${FKitchenOrder}
${FKitchenOrderWorkplaces}
${FKitchenOrderStates}`;
export function useSKitchenOrderList(baseOptions: ApolloReactHooks.SubscriptionHookOptions<TSKitchenOrderList, TSKitchenOrderListVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<TSKitchenOrderList, TSKitchenOrderListVariables>(SKitchenOrderListDocument, options);
      }
export type SKitchenOrderListHookResult = ReturnType<typeof useSKitchenOrderList>;
export type SKitchenOrderListSubscriptionResult = ApolloReactCommon.SubscriptionResult<TSKitchenOrderList>;
export const SKitchenSectorListDocument = gql`
    subscription SKitchenSectorList($sectors: [ID!], $branches: [ID!]!, $workplaces: [ID!], $showOtherWorkplaces: Boolean!, $states: [OrderRecipeStateEnum!]) {
  updatedSectorRecipe(sectors: $sectors, groups: $workplaces, sectorsWithChildren: true, companyBranches: $branches, orderRecipeStateOR: $states) {
    id
    sectorRecipe {
      ...FKitchenSectorRecipe
      ...FKitchenSectorRecipeWorkplaces @include(if: $showOtherWorkplaces)
    }
  }
}
    ${FKitchenSectorRecipe}
${FKitchenSectorRecipeWorkplaces}`;
export function useSKitchenSectorList(baseOptions: ApolloReactHooks.SubscriptionHookOptions<TSKitchenSectorList, TSKitchenSectorListVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<TSKitchenSectorList, TSKitchenSectorListVariables>(SKitchenSectorListDocument, options);
      }
export type SKitchenSectorListHookResult = ReturnType<typeof useSKitchenSectorList>;
export type SKitchenSectorListSubscriptionResult = ApolloReactCommon.SubscriptionResult<TSKitchenSectorList>;
export const QDeliveryTypesDocument = gql`
    query QDeliveryTypes {
  deliveryTypes {
    id
    code
    enum
  }
}
    `;
export function useQDeliveryTypes(baseOptions?: ApolloReactHooks.QueryHookOptions<TQDeliveryTypes, TQDeliveryTypesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQDeliveryTypes, TQDeliveryTypesVariables>(QDeliveryTypesDocument, options);
      }
export function useQDeliveryTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQDeliveryTypes, TQDeliveryTypesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQDeliveryTypes, TQDeliveryTypesVariables>(QDeliveryTypesDocument, options);
        }
export type QDeliveryTypesHookResult = ReturnType<typeof useQDeliveryTypes>;
export type QDeliveryTypesLazyQueryHookResult = ReturnType<typeof useQDeliveryTypesLazyQuery>;
export type QDeliveryTypesQueryResult = ApolloReactCommon.QueryResult<TQDeliveryTypes, TQDeliveryTypesVariables>;
export const MPasswordChangeDocument = gql`
    mutation MPasswordChange($password: String!) {
  change: updateUserPassword(newPassword: $password) {
    userId: id
    newToken: token
  }
}
    `;
export type TMPasswordChangeMutationFn = ApolloReactCommon.MutationFunction<TMPasswordChange, TMPasswordChangeVariables>;
export function useMPasswordChange(baseOptions?: ApolloReactHooks.MutationHookOptions<TMPasswordChange, TMPasswordChangeVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMPasswordChange, TMPasswordChangeVariables>(MPasswordChangeDocument, options);
      }
export type MPasswordChangeHookResult = ReturnType<typeof useMPasswordChange>;
export type MPasswordChangeMutationResult = ApolloReactCommon.MutationResult<TMPasswordChange>;
export type MPasswordChangeMutationOptions = ApolloReactCommon.BaseMutationOptions<TMPasswordChange, TMPasswordChangeVariables>;
export const QUserBootstrapDocument = gql`
    query QUserBootstrap($userId: ID!) {
  user(id: $userId) {
    id
    firstName
    lastName
    maskedEmail
    language {
      rawCode
    }
    phone
    roles {
      id
      enum
      name: code
    }
    branches: accessibleBranches {
      ...FCompanyBranch
    }
  }
  permissions: permissions {
    canCancelOrders
    canCreateOrder
  }
  access: __schema {
    queries: queryType {
      fields {
        name
      }
    }
    mutations: mutationType {
      fields {
        name
      }
    }
    subscriptions: subscriptionType {
      fields {
        name
      }
    }
  }
}
    ${FCompanyBranch}`;
export function useQUserBootstrap(baseOptions: ApolloReactHooks.QueryHookOptions<TQUserBootstrap, TQUserBootstrapVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQUserBootstrap, TQUserBootstrapVariables>(QUserBootstrapDocument, options);
      }
export function useQUserBootstrapLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQUserBootstrap, TQUserBootstrapVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQUserBootstrap, TQUserBootstrapVariables>(QUserBootstrapDocument, options);
        }
export type QUserBootstrapHookResult = ReturnType<typeof useQUserBootstrap>;
export type QUserBootstrapLazyQueryHookResult = ReturnType<typeof useQUserBootstrapLazyQuery>;
export type QUserBootstrapQueryResult = ApolloReactCommon.QueryResult<TQUserBootstrap, TQUserBootstrapVariables>;
export const MBulkUpdateRecipePricesDocument = gql`
    mutation MBulkUpdateRecipePrices($recipeIds: [ID!]!, $difference: Float!, $warePriceType: WarePriceTypeEnum!, $currency: CurrencyEnum!) {
  batchUpdateRecipePrices(recipeIds: $recipeIds, difference: $difference, warePriceType: $warePriceType, currency: $currency) {
    id
    price {
      formattedValue
    }
  }
}
    `;
export type TMBulkUpdateRecipePricesMutationFn = ApolloReactCommon.MutationFunction<TMBulkUpdateRecipePrices, TMBulkUpdateRecipePricesVariables>;
export function useMBulkUpdateRecipePrices(baseOptions?: ApolloReactHooks.MutationHookOptions<TMBulkUpdateRecipePrices, TMBulkUpdateRecipePricesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMBulkUpdateRecipePrices, TMBulkUpdateRecipePricesVariables>(MBulkUpdateRecipePricesDocument, options);
      }
export type MBulkUpdateRecipePricesHookResult = ReturnType<typeof useMBulkUpdateRecipePrices>;
export type MBulkUpdateRecipePricesMutationResult = ApolloReactCommon.MutationResult<TMBulkUpdateRecipePrices>;
export type MBulkUpdateRecipePricesMutationOptions = ApolloReactCommon.BaseMutationOptions<TMBulkUpdateRecipePrices, TMBulkUpdateRecipePricesVariables>;
export const QMenuAllergensDocument = gql`
    query QMenuAllergens {
  allergens {
    ...FMenuAllergen
  }
}
    ${FMenuAllergen}`;
export function useQMenuAllergens(baseOptions?: ApolloReactHooks.QueryHookOptions<TQMenuAllergens, TQMenuAllergensVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQMenuAllergens, TQMenuAllergensVariables>(QMenuAllergensDocument, options);
      }
export function useQMenuAllergensLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQMenuAllergens, TQMenuAllergensVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQMenuAllergens, TQMenuAllergensVariables>(QMenuAllergensDocument, options);
        }
export type QMenuAllergensHookResult = ReturnType<typeof useQMenuAllergens>;
export type QMenuAllergensLazyQueryHookResult = ReturnType<typeof useQMenuAllergensLazyQuery>;
export type QMenuAllergensQueryResult = ApolloReactCommon.QueryResult<TQMenuAllergens, TQMenuAllergensVariables>;
export const QMenuCurrenciesDocument = gql`
    query QMenuCurrencies($branchId: ID!) {
  currencies {
    enum
    code
  }
  companyBranch(id: $branchId) {
    address {
      country {
        currency {
          enum
        }
      }
    }
  }
}
    `;
export function useQMenuCurrencies(baseOptions: ApolloReactHooks.QueryHookOptions<TQMenuCurrencies, TQMenuCurrenciesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQMenuCurrencies, TQMenuCurrenciesVariables>(QMenuCurrenciesDocument, options);
      }
export function useQMenuCurrenciesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQMenuCurrencies, TQMenuCurrenciesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQMenuCurrencies, TQMenuCurrenciesVariables>(QMenuCurrenciesDocument, options);
        }
export type QMenuCurrenciesHookResult = ReturnType<typeof useQMenuCurrencies>;
export type QMenuCurrenciesLazyQueryHookResult = ReturnType<typeof useQMenuCurrenciesLazyQuery>;
export type QMenuCurrenciesQueryResult = ApolloReactCommon.QueryResult<TQMenuCurrencies, TQMenuCurrenciesVariables>;
export const QMenuGuideDownloadDocument = gql`
    query QMenuGuideDownload($branchId: ID!) {
  companyBranch(id: $branchId) {
    id
    foodMenuUrl
  }
}
    `;
export function useQMenuGuideDownload(baseOptions: ApolloReactHooks.QueryHookOptions<TQMenuGuideDownload, TQMenuGuideDownloadVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQMenuGuideDownload, TQMenuGuideDownloadVariables>(QMenuGuideDownloadDocument, options);
      }
export function useQMenuGuideDownloadLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQMenuGuideDownload, TQMenuGuideDownloadVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQMenuGuideDownload, TQMenuGuideDownloadVariables>(QMenuGuideDownloadDocument, options);
        }
export type QMenuGuideDownloadHookResult = ReturnType<typeof useQMenuGuideDownload>;
export type QMenuGuideDownloadLazyQueryHookResult = ReturnType<typeof useQMenuGuideDownloadLazyQuery>;
export type QMenuGuideDownloadQueryResult = ApolloReactCommon.QueryResult<TQMenuGuideDownload, TQMenuGuideDownloadVariables>;
export const QMenuVatsDocument = gql`
    query QMenuVats($branchId: ID!) {
  vats(companyBranch: $branchId) {
    id
    vat
  }
}
    `;
export function useQMenuVats(baseOptions: ApolloReactHooks.QueryHookOptions<TQMenuVats, TQMenuVatsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQMenuVats, TQMenuVatsVariables>(QMenuVatsDocument, options);
      }
export function useQMenuVatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQMenuVats, TQMenuVatsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQMenuVats, TQMenuVatsVariables>(QMenuVatsDocument, options);
        }
export type QMenuVatsHookResult = ReturnType<typeof useQMenuVats>;
export type QMenuVatsLazyQueryHookResult = ReturnType<typeof useQMenuVatsLazyQuery>;
export type QMenuVatsQueryResult = ApolloReactCommon.QueryResult<TQMenuVats, TQMenuVatsVariables>;
export const QMenuWareUnitsDocument = gql`
    query QMenuWareUnits {
  wareUnits {
    id
    code
    enum
  }
}
    `;
export function useQMenuWareUnits(baseOptions?: ApolloReactHooks.QueryHookOptions<TQMenuWareUnits, TQMenuWareUnitsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQMenuWareUnits, TQMenuWareUnitsVariables>(QMenuWareUnitsDocument, options);
      }
export function useQMenuWareUnitsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQMenuWareUnits, TQMenuWareUnitsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQMenuWareUnits, TQMenuWareUnitsVariables>(QMenuWareUnitsDocument, options);
        }
export type QMenuWareUnitsHookResult = ReturnType<typeof useQMenuWareUnits>;
export type QMenuWareUnitsLazyQueryHookResult = ReturnType<typeof useQMenuWareUnitsLazyQuery>;
export type QMenuWareUnitsQueryResult = ApolloReactCommon.QueryResult<TQMenuWareUnits, TQMenuWareUnitsVariables>;
export const MMenuCategoryCreateDocument = gql`
    mutation MMenuCategoryCreate($category: InputWareCategoryCreate!) {
  createCategory: createWareCategory(wareCategory: $category) {
    id
  }
}
    `;
export type TMMenuCategoryCreateMutationFn = ApolloReactCommon.MutationFunction<TMMenuCategoryCreate, TMMenuCategoryCreateVariables>;
export function useMMenuCategoryCreate(baseOptions?: ApolloReactHooks.MutationHookOptions<TMMenuCategoryCreate, TMMenuCategoryCreateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMMenuCategoryCreate, TMMenuCategoryCreateVariables>(MMenuCategoryCreateDocument, options);
      }
export type MMenuCategoryCreateHookResult = ReturnType<typeof useMMenuCategoryCreate>;
export type MMenuCategoryCreateMutationResult = ApolloReactCommon.MutationResult<TMMenuCategoryCreate>;
export type MMenuCategoryCreateMutationOptions = ApolloReactCommon.BaseMutationOptions<TMMenuCategoryCreate, TMMenuCategoryCreateVariables>;
export const MMenuCategoryDeleteDocument = gql`
    mutation MMenuCategoryDelete($categoryId: ID!) {
  deleteCategory: destroyWareCategory(id: $categoryId) {
    id
  }
}
    `;
export type TMMenuCategoryDeleteMutationFn = ApolloReactCommon.MutationFunction<TMMenuCategoryDelete, TMMenuCategoryDeleteVariables>;
export function useMMenuCategoryDelete(baseOptions?: ApolloReactHooks.MutationHookOptions<TMMenuCategoryDelete, TMMenuCategoryDeleteVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMMenuCategoryDelete, TMMenuCategoryDeleteVariables>(MMenuCategoryDeleteDocument, options);
      }
export type MMenuCategoryDeleteHookResult = ReturnType<typeof useMMenuCategoryDelete>;
export type MMenuCategoryDeleteMutationResult = ApolloReactCommon.MutationResult<TMMenuCategoryDelete>;
export type MMenuCategoryDeleteMutationOptions = ApolloReactCommon.BaseMutationOptions<TMMenuCategoryDelete, TMMenuCategoryDeleteVariables>;
export const MMenuCategorySortDocument = gql`
    mutation MMenuCategorySort($categoryId: ID!, $offset: Int!, $branchId: ID!) {
  success: updateWareCategoriesOrder(offset: $offset, companyBranch: $branchId, wareCategory: $categoryId)
}
    `;
export type TMMenuCategorySortMutationFn = ApolloReactCommon.MutationFunction<TMMenuCategorySort, TMMenuCategorySortVariables>;
export function useMMenuCategorySort(baseOptions?: ApolloReactHooks.MutationHookOptions<TMMenuCategorySort, TMMenuCategorySortVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMMenuCategorySort, TMMenuCategorySortVariables>(MMenuCategorySortDocument, options);
      }
export type MMenuCategorySortHookResult = ReturnType<typeof useMMenuCategorySort>;
export type MMenuCategorySortMutationResult = ApolloReactCommon.MutationResult<TMMenuCategorySort>;
export type MMenuCategorySortMutationOptions = ApolloReactCommon.BaseMutationOptions<TMMenuCategorySort, TMMenuCategorySortVariables>;
export const MMenuCategoryUpdateDocument = gql`
    mutation MMenuCategoryUpdate($categoryId: ID!, $category: InputWareCategoryUpdate!) {
  updateCategory: updateWareCategory(id: $categoryId, wareCategory: $category) {
    ...FMenuCategory
  }
}
    ${FMenuCategory}`;
export type TMMenuCategoryUpdateMutationFn = ApolloReactCommon.MutationFunction<TMMenuCategoryUpdate, TMMenuCategoryUpdateVariables>;
export function useMMenuCategoryUpdate(baseOptions?: ApolloReactHooks.MutationHookOptions<TMMenuCategoryUpdate, TMMenuCategoryUpdateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMMenuCategoryUpdate, TMMenuCategoryUpdateVariables>(MMenuCategoryUpdateDocument, options);
      }
export type MMenuCategoryUpdateHookResult = ReturnType<typeof useMMenuCategoryUpdate>;
export type MMenuCategoryUpdateMutationResult = ApolloReactCommon.MutationResult<TMMenuCategoryUpdate>;
export type MMenuCategoryUpdateMutationOptions = ApolloReactCommon.BaseMutationOptions<TMMenuCategoryUpdate, TMMenuCategoryUpdateVariables>;
export const MMenuCategoryVisibilityDocument = gql`
    mutation MMenuCategoryVisibility($branchId: ID!, $categoryId: ID!, $visible: Boolean!) {
  updateVisibility: updateCompanyBranchWareCategory(companyBranch: $branchId, wareCategory: {id: $categoryId, enabled: $visible}) {
    id
    visible: enabled
  }
}
    `;
export type TMMenuCategoryVisibilityMutationFn = ApolloReactCommon.MutationFunction<TMMenuCategoryVisibility, TMMenuCategoryVisibilityVariables>;
export function useMMenuCategoryVisibility(baseOptions?: ApolloReactHooks.MutationHookOptions<TMMenuCategoryVisibility, TMMenuCategoryVisibilityVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMMenuCategoryVisibility, TMMenuCategoryVisibilityVariables>(MMenuCategoryVisibilityDocument, options);
      }
export type MMenuCategoryVisibilityHookResult = ReturnType<typeof useMMenuCategoryVisibility>;
export type MMenuCategoryVisibilityMutationResult = ApolloReactCommon.MutationResult<TMMenuCategoryVisibility>;
export type MMenuCategoryVisibilityMutationOptions = ApolloReactCommon.BaseMutationOptions<TMMenuCategoryVisibility, TMMenuCategoryVisibilityVariables>;
export const QMenuCategoryColorsDocument = gql`
    query QMenuCategoryColors {
  colors: wareCategoryColors {
    id
    code
    color
  }
}
    `;
export function useQMenuCategoryColors(baseOptions?: ApolloReactHooks.QueryHookOptions<TQMenuCategoryColors, TQMenuCategoryColorsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQMenuCategoryColors, TQMenuCategoryColorsVariables>(QMenuCategoryColorsDocument, options);
      }
export function useQMenuCategoryColorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQMenuCategoryColors, TQMenuCategoryColorsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQMenuCategoryColors, TQMenuCategoryColorsVariables>(QMenuCategoryColorsDocument, options);
        }
export type QMenuCategoryColorsHookResult = ReturnType<typeof useQMenuCategoryColors>;
export type QMenuCategoryColorsLazyQueryHookResult = ReturnType<typeof useQMenuCategoryColorsLazyQuery>;
export type QMenuCategoryColorsQueryResult = ApolloReactCommon.QueryResult<TQMenuCategoryColors, TQMenuCategoryColorsVariables>;
export const QMenuCategoryFilterDocument = gql`
    query QMenuCategoryFilter($branchId: ID!) {
  categories: wareCategories(companyBranch: $branchId) {
    id
    nameLabel
    countRecipes
    categoryType: wareCategoryType {
      enum
    }
  }
}
    `;
export function useQMenuCategoryFilter(baseOptions: ApolloReactHooks.QueryHookOptions<TQMenuCategoryFilter, TQMenuCategoryFilterVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQMenuCategoryFilter, TQMenuCategoryFilterVariables>(QMenuCategoryFilterDocument, options);
      }
export function useQMenuCategoryFilterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQMenuCategoryFilter, TQMenuCategoryFilterVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQMenuCategoryFilter, TQMenuCategoryFilterVariables>(QMenuCategoryFilterDocument, options);
        }
export type QMenuCategoryFilterHookResult = ReturnType<typeof useQMenuCategoryFilter>;
export type QMenuCategoryFilterLazyQueryHookResult = ReturnType<typeof useQMenuCategoryFilterLazyQuery>;
export type QMenuCategoryFilterQueryResult = ApolloReactCommon.QueryResult<TQMenuCategoryFilter, TQMenuCategoryFilterVariables>;
export const QMenuCategoryFormDocument = gql`
    query QMenuCategoryForm($categoryId: ID!, $language: LanguageEnum!) {
  category: wareCategory(id: $categoryId, language: $language) {
    ...FMenuCategoryInForm
  }
}
    ${FMenuCategoryInForm}`;
export function useQMenuCategoryForm(baseOptions: ApolloReactHooks.QueryHookOptions<TQMenuCategoryForm, TQMenuCategoryFormVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQMenuCategoryForm, TQMenuCategoryFormVariables>(QMenuCategoryFormDocument, options);
      }
export function useQMenuCategoryFormLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQMenuCategoryForm, TQMenuCategoryFormVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQMenuCategoryForm, TQMenuCategoryFormVariables>(QMenuCategoryFormDocument, options);
        }
export type QMenuCategoryFormHookResult = ReturnType<typeof useQMenuCategoryForm>;
export type QMenuCategoryFormLazyQueryHookResult = ReturnType<typeof useQMenuCategoryFormLazyQuery>;
export type QMenuCategoryFormQueryResult = ApolloReactCommon.QueryResult<TQMenuCategoryForm, TQMenuCategoryFormVariables>;
export const QMenuCategoryListDocument = gql`
    query QMenuCategoryList($branchId: ID!, $categoryType: WareCategoryTypeEnum) {
  categories: wareCategories(companyBranch: $branchId, wareCategoryType: $categoryType) {
    ...FMenuCategoryInList
    integrationsProfiles {
      ...FBoltBase
      ...FFoodoraBase
      ...FWoltProfileBase
      ...FJidloPodNosBase
    }
  }
}
    ${FMenuCategoryInList}
${FBoltBase}
${FFoodoraBase}
${FWoltProfileBase}
${FJidloPodNosBase}`;
export function useQMenuCategoryList(baseOptions: ApolloReactHooks.QueryHookOptions<TQMenuCategoryList, TQMenuCategoryListVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQMenuCategoryList, TQMenuCategoryListVariables>(QMenuCategoryListDocument, options);
      }
export function useQMenuCategoryListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQMenuCategoryList, TQMenuCategoryListVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQMenuCategoryList, TQMenuCategoryListVariables>(QMenuCategoryListDocument, options);
        }
export type QMenuCategoryListHookResult = ReturnType<typeof useQMenuCategoryList>;
export type QMenuCategoryListLazyQueryHookResult = ReturnType<typeof useQMenuCategoryListLazyQuery>;
export type QMenuCategoryListQueryResult = ApolloReactCommon.QueryResult<TQMenuCategoryList, TQMenuCategoryListVariables>;
export const QMenuCategoryOriginsDocument = gql`
    query QMenuCategoryOrigins {
  origins: orderOriginCategories {
    enum
    code
  }
}
    `;
export function useQMenuCategoryOrigins(baseOptions?: ApolloReactHooks.QueryHookOptions<TQMenuCategoryOrigins, TQMenuCategoryOriginsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQMenuCategoryOrigins, TQMenuCategoryOriginsVariables>(QMenuCategoryOriginsDocument, options);
      }
export function useQMenuCategoryOriginsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQMenuCategoryOrigins, TQMenuCategoryOriginsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQMenuCategoryOrigins, TQMenuCategoryOriginsVariables>(QMenuCategoryOriginsDocument, options);
        }
export type QMenuCategoryOriginsHookResult = ReturnType<typeof useQMenuCategoryOrigins>;
export type QMenuCategoryOriginsLazyQueryHookResult = ReturnType<typeof useQMenuCategoryOriginsLazyQuery>;
export type QMenuCategoryOriginsQueryResult = ApolloReactCommon.QueryResult<TQMenuCategoryOrigins, TQMenuCategoryOriginsVariables>;
export const QMenuCategoryRecipeListDocument = gql`
    query QMenuCategoryRecipeList($branchId: ID!, $categoryId: ID, $categoryType: WareCategoryTypeEnum) {
  recipes(companyBranch: $branchId, wareCategory: $categoryId, wareCategoryType: $categoryType) {
    ...FMenuRecipeInList
    prices {
      ...FMenuRecipePricing
    }
  }
}
    ${FMenuRecipeInList}
${FMenuRecipePricing}`;
export function useQMenuCategoryRecipeList(baseOptions: ApolloReactHooks.QueryHookOptions<TQMenuCategoryRecipeList, TQMenuCategoryRecipeListVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQMenuCategoryRecipeList, TQMenuCategoryRecipeListVariables>(QMenuCategoryRecipeListDocument, options);
      }
export function useQMenuCategoryRecipeListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQMenuCategoryRecipeList, TQMenuCategoryRecipeListVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQMenuCategoryRecipeList, TQMenuCategoryRecipeListVariables>(QMenuCategoryRecipeListDocument, options);
        }
export type QMenuCategoryRecipeListHookResult = ReturnType<typeof useQMenuCategoryRecipeList>;
export type QMenuCategoryRecipeListLazyQueryHookResult = ReturnType<typeof useQMenuCategoryRecipeListLazyQuery>;
export type QMenuCategoryRecipeListQueryResult = ApolloReactCommon.QueryResult<TQMenuCategoryRecipeList, TQMenuCategoryRecipeListVariables>;
export const MMenuRecipeCreateDocument = gql`
    mutation MMenuRecipeCreate($recipe: InputRecipeCreate!) {
  recipe: createRecipe(recipe: $recipe) {
    ...FMenuRecipeInList
    ...FMenuRecipeInListSlow
  }
}
    ${FMenuRecipeInList}
${FMenuRecipeInListSlow}`;
export type TMMenuRecipeCreateMutationFn = ApolloReactCommon.MutationFunction<TMMenuRecipeCreate, TMMenuRecipeCreateVariables>;
export function useMMenuRecipeCreate(baseOptions?: ApolloReactHooks.MutationHookOptions<TMMenuRecipeCreate, TMMenuRecipeCreateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMMenuRecipeCreate, TMMenuRecipeCreateVariables>(MMenuRecipeCreateDocument, options);
      }
export type MMenuRecipeCreateHookResult = ReturnType<typeof useMMenuRecipeCreate>;
export type MMenuRecipeCreateMutationResult = ApolloReactCommon.MutationResult<TMMenuRecipeCreate>;
export type MMenuRecipeCreateMutationOptions = ApolloReactCommon.BaseMutationOptions<TMMenuRecipeCreate, TMMenuRecipeCreateVariables>;
export const MMenuRecipeDeleteDocument = gql`
    mutation MMenuRecipeDelete($recipeId: ID!) {
  destroyRecipe(id: $recipeId) {
    id
  }
}
    `;
export type TMMenuRecipeDeleteMutationFn = ApolloReactCommon.MutationFunction<TMMenuRecipeDelete, TMMenuRecipeDeleteVariables>;
export function useMMenuRecipeDelete(baseOptions?: ApolloReactHooks.MutationHookOptions<TMMenuRecipeDelete, TMMenuRecipeDeleteVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMMenuRecipeDelete, TMMenuRecipeDeleteVariables>(MMenuRecipeDeleteDocument, options);
      }
export type MMenuRecipeDeleteHookResult = ReturnType<typeof useMMenuRecipeDelete>;
export type MMenuRecipeDeleteMutationResult = ApolloReactCommon.MutationResult<TMMenuRecipeDelete>;
export type MMenuRecipeDeleteMutationOptions = ApolloReactCommon.BaseMutationOptions<TMMenuRecipeDelete, TMMenuRecipeDeleteVariables>;
export const MMenuRecipeSoldOutDocument = gql`
    mutation MMenuRecipeSoldOut($branchId: ID!, $recipeId: ID!, $soldOut: Boolean!) {
  updatedSoldOut: updateCompanyBranchRecipe(companyBranch: $branchId, recipe: {id: $recipeId, soldOut: $soldOut}) {
    id
    soldOut: soldOut
  }
}
    `;
export type TMMenuRecipeSoldOutMutationFn = ApolloReactCommon.MutationFunction<TMMenuRecipeSoldOut, TMMenuRecipeSoldOutVariables>;
export function useMMenuRecipeSoldOut(baseOptions?: ApolloReactHooks.MutationHookOptions<TMMenuRecipeSoldOut, TMMenuRecipeSoldOutVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMMenuRecipeSoldOut, TMMenuRecipeSoldOutVariables>(MMenuRecipeSoldOutDocument, options);
      }
export type MMenuRecipeSoldOutHookResult = ReturnType<typeof useMMenuRecipeSoldOut>;
export type MMenuRecipeSoldOutMutationResult = ApolloReactCommon.MutationResult<TMMenuRecipeSoldOut>;
export type MMenuRecipeSoldOutMutationOptions = ApolloReactCommon.BaseMutationOptions<TMMenuRecipeSoldOut, TMMenuRecipeSoldOutVariables>;
export const MMenuRecipeUpdateDocument = gql`
    mutation MMenuRecipeUpdate($recipeId: ID!, $recipe: InputRecipeUpdate!) {
  recipe: updateRecipe(id: $recipeId, recipe: $recipe) {
    ...FMenuRecipeInList
    ...FMenuRecipeInListSlow
  }
}
    ${FMenuRecipeInList}
${FMenuRecipeInListSlow}`;
export type TMMenuRecipeUpdateMutationFn = ApolloReactCommon.MutationFunction<TMMenuRecipeUpdate, TMMenuRecipeUpdateVariables>;
export function useMMenuRecipeUpdate(baseOptions?: ApolloReactHooks.MutationHookOptions<TMMenuRecipeUpdate, TMMenuRecipeUpdateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMMenuRecipeUpdate, TMMenuRecipeUpdateVariables>(MMenuRecipeUpdateDocument, options);
      }
export type MMenuRecipeUpdateHookResult = ReturnType<typeof useMMenuRecipeUpdate>;
export type MMenuRecipeUpdateMutationResult = ApolloReactCommon.MutationResult<TMMenuRecipeUpdate>;
export type MMenuRecipeUpdateMutationOptions = ApolloReactCommon.BaseMutationOptions<TMMenuRecipeUpdate, TMMenuRecipeUpdateVariables>;
export const MMenuRecipeVisibilityDocument = gql`
    mutation MMenuRecipeVisibility($branchId: ID!, $recipeId: ID!, $visible: Boolean!) {
  updatedVisibility: updateCompanyBranchRecipe(companyBranch: $branchId, recipe: {id: $recipeId, enabled: $visible}) {
    id
    visible: enabled
  }
}
    `;
export type TMMenuRecipeVisibilityMutationFn = ApolloReactCommon.MutationFunction<TMMenuRecipeVisibility, TMMenuRecipeVisibilityVariables>;
export function useMMenuRecipeVisibility(baseOptions?: ApolloReactHooks.MutationHookOptions<TMMenuRecipeVisibility, TMMenuRecipeVisibilityVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMMenuRecipeVisibility, TMMenuRecipeVisibilityVariables>(MMenuRecipeVisibilityDocument, options);
      }
export type MMenuRecipeVisibilityHookResult = ReturnType<typeof useMMenuRecipeVisibility>;
export type MMenuRecipeVisibilityMutationResult = ApolloReactCommon.MutationResult<TMMenuRecipeVisibility>;
export type MMenuRecipeVisibilityMutationOptions = ApolloReactCommon.BaseMutationOptions<TMMenuRecipeVisibility, TMMenuRecipeVisibilityVariables>;
export const QCombinationMealsDocument = gql`
    query QCombinationMeals($branchId: ID!, $categoryId: ID) {
  recipes(companyBranch: $branchId, wareCategory: $categoryId, wareCategoryType: MAIN, isCombinationMeal: true) {
    id
    deliveryCombinationMealPrice: mainCombinationMealPrice(warePriceType: DELIVERY) {
      ...FFormattedPrice
      ...FPriceWithCurrency
    }
    inHouseCombinationMealPrice: mainCombinationMealPrice(warePriceType: INHOUSE) {
      ...FFormattedPrice
      ...FPriceWithCurrency
    }
    woltCombinationMealPrice: mainCombinationMealPrice(warePriceType: WOLT) {
      ...FFormattedPrice
      ...FPriceWithCurrency
    }
    foodoraCombinationMealPrice: mainCombinationMealPrice(warePriceType: FOODORA) {
      ...FFormattedPrice
      ...FPriceWithCurrency
    }
    boltCombinationMealPrice: mainCombinationMealPrice(warePriceType: BOLT) {
      ...FFormattedPrice
      ...FPriceWithCurrency
    }
    jidloPodNosCombinationMealPrice: mainCombinationMealPrice(warePriceType: JIDLO_POD_NOS) {
      ...FFormattedPrice
      ...FPriceWithCurrency
    }
  }
}
    ${FFormattedPrice}
${FPriceWithCurrency}`;
export function useQCombinationMeals(baseOptions: ApolloReactHooks.QueryHookOptions<TQCombinationMeals, TQCombinationMealsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQCombinationMeals, TQCombinationMealsVariables>(QCombinationMealsDocument, options);
      }
export function useQCombinationMealsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQCombinationMeals, TQCombinationMealsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQCombinationMeals, TQCombinationMealsVariables>(QCombinationMealsDocument, options);
        }
export type QCombinationMealsHookResult = ReturnType<typeof useQCombinationMeals>;
export type QCombinationMealsLazyQueryHookResult = ReturnType<typeof useQCombinationMealsLazyQuery>;
export type QCombinationMealsQueryResult = ApolloReactCommon.QueryResult<TQCombinationMeals, TQCombinationMealsVariables>;
export const QMenuRecipeColorsDocument = gql`
    query QMenuRecipeColors {
  recipeColors {
    id
    code
    color
  }
}
    `;
export function useQMenuRecipeColors(baseOptions?: ApolloReactHooks.QueryHookOptions<TQMenuRecipeColors, TQMenuRecipeColorsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQMenuRecipeColors, TQMenuRecipeColorsVariables>(QMenuRecipeColorsDocument, options);
      }
export function useQMenuRecipeColorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQMenuRecipeColors, TQMenuRecipeColorsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQMenuRecipeColors, TQMenuRecipeColorsVariables>(QMenuRecipeColorsDocument, options);
        }
export type QMenuRecipeColorsHookResult = ReturnType<typeof useQMenuRecipeColors>;
export type QMenuRecipeColorsLazyQueryHookResult = ReturnType<typeof useQMenuRecipeColorsLazyQuery>;
export type QMenuRecipeColorsQueryResult = ApolloReactCommon.QueryResult<TQMenuRecipeColors, TQMenuRecipeColorsVariables>;
export const QMenuRecipeDefaultsDocument = gql`
    query QMenuRecipeDefaults($branchId: ID!) {
  defaults: companyBranch(id: $branchId) {
    id
    vats: defaultVats {
      vatId: id
      priceType: warePriceType {
        enum
      }
    }
    currency: defaultCurrency {
      id
      code
    }
  }
}
    `;
export function useQMenuRecipeDefaults(baseOptions: ApolloReactHooks.QueryHookOptions<TQMenuRecipeDefaults, TQMenuRecipeDefaultsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQMenuRecipeDefaults, TQMenuRecipeDefaultsVariables>(QMenuRecipeDefaultsDocument, options);
      }
export function useQMenuRecipeDefaultsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQMenuRecipeDefaults, TQMenuRecipeDefaultsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQMenuRecipeDefaults, TQMenuRecipeDefaultsVariables>(QMenuRecipeDefaultsDocument, options);
        }
export type QMenuRecipeDefaultsHookResult = ReturnType<typeof useQMenuRecipeDefaults>;
export type QMenuRecipeDefaultsLazyQueryHookResult = ReturnType<typeof useQMenuRecipeDefaultsLazyQuery>;
export type QMenuRecipeDefaultsQueryResult = ApolloReactCommon.QueryResult<TQMenuRecipeDefaults, TQMenuRecipeDefaultsVariables>;
export const QMenuRecipeFormDocument = gql`
    query QMenuRecipeForm($recipeId: ID!, $language: LanguageEnum!) {
  recipe(id: $recipeId, language: $language) {
    ...FMenuRecipeInForm
    sourcePrices: prices {
      ...FMenuRecipePricing
    }
    sourceAssociatedRecipes: associatedRecipes {
      id
      priceType: warePriceType {
        enum
      }
      recipe: associatedRecipe {
        ...FMenuAssocRecipe
      }
    }
    sourceIngredients: ingredients {
      id
      quantity
      stockItem {
        id
        label
        wareUnit {
          id
          code
        }
        allergens {
          id
          enum
        }
      }
    }
  }
}
    ${FMenuRecipeInForm}
${FMenuRecipePricing}
${FMenuAssocRecipe}`;
export function useQMenuRecipeForm(baseOptions: ApolloReactHooks.QueryHookOptions<TQMenuRecipeForm, TQMenuRecipeFormVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQMenuRecipeForm, TQMenuRecipeFormVariables>(QMenuRecipeFormDocument, options);
      }
export function useQMenuRecipeFormLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQMenuRecipeForm, TQMenuRecipeFormVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQMenuRecipeForm, TQMenuRecipeFormVariables>(QMenuRecipeFormDocument, options);
        }
export type QMenuRecipeFormHookResult = ReturnType<typeof useQMenuRecipeForm>;
export type QMenuRecipeFormLazyQueryHookResult = ReturnType<typeof useQMenuRecipeFormLazyQuery>;
export type QMenuRecipeFormQueryResult = ApolloReactCommon.QueryResult<TQMenuRecipeForm, TQMenuRecipeFormVariables>;
export const QMenuRecipeFormAssocDocument = gql`
    query QMenuRecipeFormAssoc($branchId: ID!) {
  recipes(companyBranch: $branchId, wareCategoryType: COVER) {
    ...FMenuAssocRecipe
  }
}
    ${FMenuAssocRecipe}`;
export function useQMenuRecipeFormAssoc(baseOptions: ApolloReactHooks.QueryHookOptions<TQMenuRecipeFormAssoc, TQMenuRecipeFormAssocVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQMenuRecipeFormAssoc, TQMenuRecipeFormAssocVariables>(QMenuRecipeFormAssocDocument, options);
      }
export function useQMenuRecipeFormAssocLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQMenuRecipeFormAssoc, TQMenuRecipeFormAssocVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQMenuRecipeFormAssoc, TQMenuRecipeFormAssocVariables>(QMenuRecipeFormAssocDocument, options);
        }
export type QMenuRecipeFormAssocHookResult = ReturnType<typeof useQMenuRecipeFormAssoc>;
export type QMenuRecipeFormAssocLazyQueryHookResult = ReturnType<typeof useQMenuRecipeFormAssocLazyQuery>;
export type QMenuRecipeFormAssocQueryResult = ApolloReactCommon.QueryResult<TQMenuRecipeFormAssoc, TQMenuRecipeFormAssocVariables>;
export const QMenuRecipeListDocument = gql`
    query QMenuRecipeList($branchId: ID!, $categoryId: ID, $categoryType: WareCategoryTypeEnum, $recipeTagIds: [ID!]) {
  recipes(companyBranch: $branchId, wareCategory: $categoryId, wareCategoryType: $categoryType, recipeTags: $recipeTagIds) {
    ...FMenuRecipeInList
  }
}
    ${FMenuRecipeInList}`;
export function useQMenuRecipeList(baseOptions: ApolloReactHooks.QueryHookOptions<TQMenuRecipeList, TQMenuRecipeListVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQMenuRecipeList, TQMenuRecipeListVariables>(QMenuRecipeListDocument, options);
      }
export function useQMenuRecipeListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQMenuRecipeList, TQMenuRecipeListVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQMenuRecipeList, TQMenuRecipeListVariables>(QMenuRecipeListDocument, options);
        }
export type QMenuRecipeListHookResult = ReturnType<typeof useQMenuRecipeList>;
export type QMenuRecipeListLazyQueryHookResult = ReturnType<typeof useQMenuRecipeListLazyQuery>;
export type QMenuRecipeListQueryResult = ApolloReactCommon.QueryResult<TQMenuRecipeList, TQMenuRecipeListVariables>;
export const QMenuRecipeListSlowDocument = gql`
    query QMenuRecipeListSlow($branchId: ID!, $categoryId: ID, $categoryType: WareCategoryTypeEnum, $recipeTagIds: [ID!]) {
  recipes(companyBranch: $branchId, wareCategory: $categoryId, wareCategoryType: $categoryType, recipeTags: $recipeTagIds) {
    ...FMenuRecipeInListSlow
  }
}
    ${FMenuRecipeInListSlow}`;
export function useQMenuRecipeListSlow(baseOptions: ApolloReactHooks.QueryHookOptions<TQMenuRecipeListSlow, TQMenuRecipeListSlowVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQMenuRecipeListSlow, TQMenuRecipeListSlowVariables>(QMenuRecipeListSlowDocument, options);
      }
export function useQMenuRecipeListSlowLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQMenuRecipeListSlow, TQMenuRecipeListSlowVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQMenuRecipeListSlow, TQMenuRecipeListSlowVariables>(QMenuRecipeListSlowDocument, options);
        }
export type QMenuRecipeListSlowHookResult = ReturnType<typeof useQMenuRecipeListSlow>;
export type QMenuRecipeListSlowLazyQueryHookResult = ReturnType<typeof useQMenuRecipeListSlowLazyQuery>;
export type QMenuRecipeListSlowQueryResult = ApolloReactCommon.QueryResult<TQMenuRecipeListSlow, TQMenuRecipeListSlowVariables>;
export const QMenuRecipeTagFilterDocument = gql`
    query QMenuRecipeTagFilter($brandId: ID!, $branchId: ID!) {
  recipeTags(companies: [$brandId]) {
    ...FProductTagOption
  }
  relations: recipeTagRelations(usedByCompanyBranches: [$branchId]) {
    id
    recipeTag {
      id
    }
  }
}
    ${FProductTagOption}`;
export function useQMenuRecipeTagFilter(baseOptions: ApolloReactHooks.QueryHookOptions<TQMenuRecipeTagFilter, TQMenuRecipeTagFilterVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQMenuRecipeTagFilter, TQMenuRecipeTagFilterVariables>(QMenuRecipeTagFilterDocument, options);
      }
export function useQMenuRecipeTagFilterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQMenuRecipeTagFilter, TQMenuRecipeTagFilterVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQMenuRecipeTagFilter, TQMenuRecipeTagFilterVariables>(QMenuRecipeTagFilterDocument, options);
        }
export type QMenuRecipeTagFilterHookResult = ReturnType<typeof useQMenuRecipeTagFilter>;
export type QMenuRecipeTagFilterLazyQueryHookResult = ReturnType<typeof useQMenuRecipeTagFilterLazyQuery>;
export type QMenuRecipeTagFilterQueryResult = ApolloReactCommon.QueryResult<TQMenuRecipeTagFilter, TQMenuRecipeTagFilterVariables>;
export const MMenuStockCreateDocument = gql`
    mutation MMenuStockCreate($stockItem: InputStockItemCreate!) {
  createStockItem(stockItem: $stockItem) {
    ...FMenuStockItem
    allowNegative
  }
}
    ${FMenuStockItem}`;
export type TMMenuStockCreateMutationFn = ApolloReactCommon.MutationFunction<TMMenuStockCreate, TMMenuStockCreateVariables>;
export function useMMenuStockCreate(baseOptions?: ApolloReactHooks.MutationHookOptions<TMMenuStockCreate, TMMenuStockCreateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMMenuStockCreate, TMMenuStockCreateVariables>(MMenuStockCreateDocument, options);
      }
export type MMenuStockCreateHookResult = ReturnType<typeof useMMenuStockCreate>;
export type MMenuStockCreateMutationResult = ApolloReactCommon.MutationResult<TMMenuStockCreate>;
export type MMenuStockCreateMutationOptions = ApolloReactCommon.BaseMutationOptions<TMMenuStockCreate, TMMenuStockCreateVariables>;
export const MMenuStockDeleteDocument = gql`
    mutation MMenuStockDelete($stockId: ID!) {
  deleteStockItem: destroyStockItem(id: $stockId) {
    id
  }
}
    `;
export type TMMenuStockDeleteMutationFn = ApolloReactCommon.MutationFunction<TMMenuStockDelete, TMMenuStockDeleteVariables>;
export function useMMenuStockDelete(baseOptions?: ApolloReactHooks.MutationHookOptions<TMMenuStockDelete, TMMenuStockDeleteVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMMenuStockDelete, TMMenuStockDeleteVariables>(MMenuStockDeleteDocument, options);
      }
export type MMenuStockDeleteHookResult = ReturnType<typeof useMMenuStockDelete>;
export type MMenuStockDeleteMutationResult = ApolloReactCommon.MutationResult<TMMenuStockDelete>;
export type MMenuStockDeleteMutationOptions = ApolloReactCommon.BaseMutationOptions<TMMenuStockDelete, TMMenuStockDeleteVariables>;
export const MMenuStockQuantityDocument = gql`
    mutation MMenuStockQuantity($stockItem: ID!, $quantityChange: Float!, $note: String) {
  changeAmountStockItem(id: $stockItem, amountOffset: $quantityChange, note: $note) {
    id
    quantity
  }
}
    `;
export type TMMenuStockQuantityMutationFn = ApolloReactCommon.MutationFunction<TMMenuStockQuantity, TMMenuStockQuantityVariables>;
export function useMMenuStockQuantity(baseOptions?: ApolloReactHooks.MutationHookOptions<TMMenuStockQuantity, TMMenuStockQuantityVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMMenuStockQuantity, TMMenuStockQuantityVariables>(MMenuStockQuantityDocument, options);
      }
export type MMenuStockQuantityHookResult = ReturnType<typeof useMMenuStockQuantity>;
export type MMenuStockQuantityMutationResult = ApolloReactCommon.MutationResult<TMMenuStockQuantity>;
export type MMenuStockQuantityMutationOptions = ApolloReactCommon.BaseMutationOptions<TMMenuStockQuantity, TMMenuStockQuantityVariables>;
export const MMenuStockUpdateDocument = gql`
    mutation MMenuStockUpdate($stockId: ID!, $stockItem: InputStockItemUpdate!) {
  updateStockItem(id: $stockId, stockItem: $stockItem) {
    ...FMenuStockItem
    allowNegative
  }
}
    ${FMenuStockItem}`;
export type TMMenuStockUpdateMutationFn = ApolloReactCommon.MutationFunction<TMMenuStockUpdate, TMMenuStockUpdateVariables>;
export function useMMenuStockUpdate(baseOptions?: ApolloReactHooks.MutationHookOptions<TMMenuStockUpdate, TMMenuStockUpdateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMMenuStockUpdate, TMMenuStockUpdateVariables>(MMenuStockUpdateDocument, options);
      }
export type MMenuStockUpdateHookResult = ReturnType<typeof useMMenuStockUpdate>;
export type MMenuStockUpdateMutationResult = ApolloReactCommon.MutationResult<TMMenuStockUpdate>;
export type MMenuStockUpdateMutationOptions = ApolloReactCommon.BaseMutationOptions<TMMenuStockUpdate, TMMenuStockUpdateVariables>;
export const MPohodaSyncPlanDocument = gql`
    mutation MPohodaSyncPlan($companyBranchId: ID!) {
  pohodaExportPlan(companyBranch: $companyBranchId) {
    message
  }
}
    `;
export type TMPohodaSyncPlanMutationFn = ApolloReactCommon.MutationFunction<TMPohodaSyncPlan, TMPohodaSyncPlanVariables>;
export function useMPohodaSyncPlan(baseOptions?: ApolloReactHooks.MutationHookOptions<TMPohodaSyncPlan, TMPohodaSyncPlanVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMPohodaSyncPlan, TMPohodaSyncPlanVariables>(MPohodaSyncPlanDocument, options);
      }
export type MPohodaSyncPlanHookResult = ReturnType<typeof useMPohodaSyncPlan>;
export type MPohodaSyncPlanMutationResult = ApolloReactCommon.MutationResult<TMPohodaSyncPlan>;
export type MPohodaSyncPlanMutationOptions = ApolloReactCommon.BaseMutationOptions<TMPohodaSyncPlan, TMPohodaSyncPlanVariables>;
export const QMenuStockDefaultsDocument = gql`
    query QMenuStockDefaults($branchId: ID!) {
  defaults: companyBranch(id: $branchId) {
    id
    allowNegative: stockItemsCanBeNegative
  }
}
    `;
export function useQMenuStockDefaults(baseOptions: ApolloReactHooks.QueryHookOptions<TQMenuStockDefaults, TQMenuStockDefaultsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQMenuStockDefaults, TQMenuStockDefaultsVariables>(QMenuStockDefaultsDocument, options);
      }
export function useQMenuStockDefaultsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQMenuStockDefaults, TQMenuStockDefaultsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQMenuStockDefaults, TQMenuStockDefaultsVariables>(QMenuStockDefaultsDocument, options);
        }
export type QMenuStockDefaultsHookResult = ReturnType<typeof useQMenuStockDefaults>;
export type QMenuStockDefaultsLazyQueryHookResult = ReturnType<typeof useQMenuStockDefaultsLazyQuery>;
export type QMenuStockDefaultsQueryResult = ApolloReactCommon.QueryResult<TQMenuStockDefaults, TQMenuStockDefaultsVariables>;
export const QMenuStockFormDocument = gql`
    query QMenuStockForm($stockId: ID!) {
  stockItem(id: $stockId) {
    ...FMenuStockItem
    allowNegative
    companyBranch {
      id
      allowNegative: stockItemsCanBeNegative
    }
  }
}
    ${FMenuStockItem}`;
export function useQMenuStockForm(baseOptions: ApolloReactHooks.QueryHookOptions<TQMenuStockForm, TQMenuStockFormVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQMenuStockForm, TQMenuStockFormVariables>(QMenuStockFormDocument, options);
      }
export function useQMenuStockFormLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQMenuStockForm, TQMenuStockFormVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQMenuStockForm, TQMenuStockFormVariables>(QMenuStockFormDocument, options);
        }
export type QMenuStockFormHookResult = ReturnType<typeof useQMenuStockForm>;
export type QMenuStockFormLazyQueryHookResult = ReturnType<typeof useQMenuStockFormLazyQuery>;
export type QMenuStockFormQueryResult = ApolloReactCommon.QueryResult<TQMenuStockForm, TQMenuStockFormVariables>;
export const QMenuStockListDocument = gql`
    query QMenuStockList($branchId: ID!) {
  stockItems(companyBranch: $branchId) {
    ...FMenuStockItem
    allowNegativeValue
  }
}
    ${FMenuStockItem}`;
export function useQMenuStockList(baseOptions: ApolloReactHooks.QueryHookOptions<TQMenuStockList, TQMenuStockListVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQMenuStockList, TQMenuStockListVariables>(QMenuStockListDocument, options);
      }
export function useQMenuStockListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQMenuStockList, TQMenuStockListVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQMenuStockList, TQMenuStockListVariables>(QMenuStockListDocument, options);
        }
export type QMenuStockListHookResult = ReturnType<typeof useQMenuStockList>;
export type QMenuStockListLazyQueryHookResult = ReturnType<typeof useQMenuStockListLazyQuery>;
export type QMenuStockListQueryResult = ApolloReactCommon.QueryResult<TQMenuStockList, TQMenuStockListVariables>;
export const QStockRecipesDocument = gql`
    query QStockRecipes($stockId: ID!) {
  stockItem(id: $stockId) {
    id
    ingredients {
      id
      recipe {
        id
        nameLabel
        descriptionLabel
        recipeType: wareCategoryType {
          enum
        }
      }
    }
  }
}
    `;
export function useQStockRecipes(baseOptions: ApolloReactHooks.QueryHookOptions<TQStockRecipes, TQStockRecipesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQStockRecipes, TQStockRecipesVariables>(QStockRecipesDocument, options);
      }
export function useQStockRecipesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQStockRecipes, TQStockRecipesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQStockRecipes, TQStockRecipesVariables>(QStockRecipesDocument, options);
        }
export type QStockRecipesHookResult = ReturnType<typeof useQStockRecipes>;
export type QStockRecipesLazyQueryHookResult = ReturnType<typeof useQStockRecipesLazyQuery>;
export type QStockRecipesQueryResult = ApolloReactCommon.QueryResult<TQStockRecipes, TQStockRecipesVariables>;
export const QOrderDetailDocument = gql`
    query QOrderDetail($orderId: ID!) {
  order(id: $orderId) {
    ...FOrderInList
    ...FOrderRating
    orderStates {
      id
      enum
    }
  }
}
    ${FOrderInList}
${FOrderRating}`;
export function useQOrderDetail(baseOptions: ApolloReactHooks.QueryHookOptions<TQOrderDetail, TQOrderDetailVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQOrderDetail, TQOrderDetailVariables>(QOrderDetailDocument, options);
      }
export function useQOrderDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQOrderDetail, TQOrderDetailVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQOrderDetail, TQOrderDetailVariables>(QOrderDetailDocument, options);
        }
export type QOrderDetailHookResult = ReturnType<typeof useQOrderDetail>;
export type QOrderDetailLazyQueryHookResult = ReturnType<typeof useQOrderDetailLazyQuery>;
export type QOrderDetailQueryResult = ApolloReactCommon.QueryResult<TQOrderDetail, TQOrderDetailVariables>;
export const MTemporaryCloseDocument = gql`
    mutation MTemporaryClose($branchId: ID!, $closedNote: String, $closedForTime: Int!) {
  addSpecialClosingBusinessHours(closingSpecification: {closedNote: $closedNote, companyBranchId: $branchId, closingInterval: $closedForTime}) {
    id
    isOpen
  }
}
    `;
export type TMTemporaryCloseMutationFn = ApolloReactCommon.MutationFunction<TMTemporaryClose, TMTemporaryCloseVariables>;
export function useMTemporaryClose(baseOptions?: ApolloReactHooks.MutationHookOptions<TMTemporaryClose, TMTemporaryCloseVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMTemporaryClose, TMTemporaryCloseVariables>(MTemporaryCloseDocument, options);
      }
export type MTemporaryCloseHookResult = ReturnType<typeof useMTemporaryClose>;
export type MTemporaryCloseMutationResult = ApolloReactCommon.MutationResult<TMTemporaryClose>;
export type MTemporaryCloseMutationOptions = ApolloReactCommon.BaseMutationOptions<TMTemporaryClose, TMTemporaryCloseVariables>;
export const QAreBranchesOpenDocument = gql`
    query QAreBranchesOpen($branchIds: [ID!]!) {
  companyBranches(ids: $branchIds) {
    id
    isOpen
  }
}
    `;
export function useQAreBranchesOpen(baseOptions: ApolloReactHooks.QueryHookOptions<TQAreBranchesOpen, TQAreBranchesOpenVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQAreBranchesOpen, TQAreBranchesOpenVariables>(QAreBranchesOpenDocument, options);
      }
export function useQAreBranchesOpenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQAreBranchesOpen, TQAreBranchesOpenVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQAreBranchesOpen, TQAreBranchesOpenVariables>(QAreBranchesOpenDocument, options);
        }
export type QAreBranchesOpenHookResult = ReturnType<typeof useQAreBranchesOpen>;
export type QAreBranchesOpenLazyQueryHookResult = ReturnType<typeof useQAreBranchesOpenLazyQuery>;
export type QAreBranchesOpenQueryResult = ApolloReactCommon.QueryResult<TQAreBranchesOpen, TQAreBranchesOpenVariables>;
export const QNewOrdersDocument = gql`
    query QNewOrders($branches: [ID!], $acceptedAfter: DateTime) {
  orders(order: {companyBranches: $branches, orderStateCategoriesOR: [NEW_ORDERS], includeOldFinished: false, acceptedAfter: $acceptedAfter}) {
    id
  }
}
    `;
export function useQNewOrders(baseOptions?: ApolloReactHooks.QueryHookOptions<TQNewOrders, TQNewOrdersVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQNewOrders, TQNewOrdersVariables>(QNewOrdersDocument, options);
      }
export function useQNewOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQNewOrders, TQNewOrdersVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQNewOrders, TQNewOrdersVariables>(QNewOrdersDocument, options);
        }
export type QNewOrdersHookResult = ReturnType<typeof useQNewOrders>;
export type QNewOrdersLazyQueryHookResult = ReturnType<typeof useQNewOrdersLazyQuery>;
export type QNewOrdersQueryResult = ApolloReactCommon.QueryResult<TQNewOrders, TQNewOrdersVariables>;
export const QOrderListDocument = gql`
    query QOrderList($branches: [ID!], $categories: [OrderStateCategoryEnum!], $acceptedAfter: DateTime) {
  orders(order: {companyBranches: $branches, orderStateCategoriesOR: $categories, includeOldFinished: false, acceptedAfter: $acceptedAfter}) {
    ...FOrderInList
    ...FOrderMapOrder
  }
}
    ${FOrderInList}
${FOrderMapOrder}`;
export function useQOrderList(baseOptions?: ApolloReactHooks.QueryHookOptions<TQOrderList, TQOrderListVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQOrderList, TQOrderListVariables>(QOrderListDocument, options);
      }
export function useQOrderListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQOrderList, TQOrderListVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQOrderList, TQOrderListVariables>(QOrderListDocument, options);
        }
export type QOrderListHookResult = ReturnType<typeof useQOrderList>;
export type QOrderListLazyQueryHookResult = ReturnType<typeof useQOrderListLazyQuery>;
export type QOrderListQueryResult = ApolloReactCommon.QueryResult<TQOrderList, TQOrderListVariables>;
export const QOrderListCategoriesDocument = gql`
    query QOrderListCategories {
  categories: orderStateCategories {
    label: code
    enum
  }
}
    `;
export function useQOrderListCategories(baseOptions?: ApolloReactHooks.QueryHookOptions<TQOrderListCategories, TQOrderListCategoriesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQOrderListCategories, TQOrderListCategoriesVariables>(QOrderListCategoriesDocument, options);
      }
export function useQOrderListCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQOrderListCategories, TQOrderListCategoriesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQOrderListCategories, TQOrderListCategoriesVariables>(QOrderListCategoriesDocument, options);
        }
export type QOrderListCategoriesHookResult = ReturnType<typeof useQOrderListCategories>;
export type QOrderListCategoriesLazyQueryHookResult = ReturnType<typeof useQOrderListCategoriesLazyQuery>;
export type QOrderListCategoriesQueryResult = ApolloReactCommon.QueryResult<TQOrderListCategories, TQOrderListCategoriesVariables>;
export const QOrderMapDeliveriesDocument = gql`
    query QOrderMapDeliveries($branches: [ID!]!) {
  deliveries: drivers(companyBranches: $branches, onlyAvailable: true) {
    ...FOrderMapDelivery
  }
}
    ${FOrderMapDelivery}`;
export function useQOrderMapDeliveries(baseOptions: ApolloReactHooks.QueryHookOptions<TQOrderMapDeliveries, TQOrderMapDeliveriesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQOrderMapDeliveries, TQOrderMapDeliveriesVariables>(QOrderMapDeliveriesDocument, options);
      }
export function useQOrderMapDeliveriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQOrderMapDeliveries, TQOrderMapDeliveriesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQOrderMapDeliveries, TQOrderMapDeliveriesVariables>(QOrderMapDeliveriesDocument, options);
        }
export type QOrderMapDeliveriesHookResult = ReturnType<typeof useQOrderMapDeliveries>;
export type QOrderMapDeliveriesLazyQueryHookResult = ReturnType<typeof useQOrderMapDeliveriesLazyQuery>;
export type QOrderMapDeliveriesQueryResult = ApolloReactCommon.QueryResult<TQOrderMapDeliveries, TQOrderMapDeliveriesVariables>;
export const QOrderReturnZonesDocument = gql`
    query QOrderReturnZones($branches: [ID!]!) {
  zones(enabled: true, companyBranches: $branches, zoneTypes: [RETURN]) {
    id
    name
    zoneColor {
      id
      color
    }
    zoneType {
      enum
    }
    geoPolygon {
      ...FGeoPoint
    }
  }
}
    ${FGeoPoint}`;
export function useQOrderReturnZones(baseOptions: ApolloReactHooks.QueryHookOptions<TQOrderReturnZones, TQOrderReturnZonesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQOrderReturnZones, TQOrderReturnZonesVariables>(QOrderReturnZonesDocument, options);
      }
export function useQOrderReturnZonesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQOrderReturnZones, TQOrderReturnZonesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQOrderReturnZones, TQOrderReturnZonesVariables>(QOrderReturnZonesDocument, options);
        }
export type QOrderReturnZonesHookResult = ReturnType<typeof useQOrderReturnZones>;
export type QOrderReturnZonesLazyQueryHookResult = ReturnType<typeof useQOrderReturnZonesLazyQuery>;
export type QOrderReturnZonesQueryResult = ApolloReactCommon.QueryResult<TQOrderReturnZones, TQOrderReturnZonesVariables>;
export const QOrdersCategoryCountDocument = gql`
    query QOrdersCategoryCount($branchesId: [ID!]!, $categories: [OrderStateCategoryEnum!]!) {
  ordersCategoryCount(companyBranches: $branchesId, orderStateCategoriesOR: $categories) {
    category: orderStateCategory {
      enum
    }
    count: ordersCount
  }
}
    `;
export function useQOrdersCategoryCount(baseOptions: ApolloReactHooks.QueryHookOptions<TQOrdersCategoryCount, TQOrdersCategoryCountVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQOrdersCategoryCount, TQOrdersCategoryCountVariables>(QOrdersCategoryCountDocument, options);
      }
export function useQOrdersCategoryCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQOrdersCategoryCount, TQOrdersCategoryCountVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQOrdersCategoryCount, TQOrdersCategoryCountVariables>(QOrdersCategoryCountDocument, options);
        }
export type QOrdersCategoryCountHookResult = ReturnType<typeof useQOrdersCategoryCount>;
export type QOrdersCategoryCountLazyQueryHookResult = ReturnType<typeof useQOrdersCategoryCountLazyQuery>;
export type QOrdersCategoryCountQueryResult = ApolloReactCommon.QueryResult<TQOrdersCategoryCount, TQOrdersCategoryCountVariables>;
export const SDriverReturnsDocument = gql`
    subscription SDriverReturns($branches: [ID!]!) {
  update: updatedTransportationDeviceUser(companyBranches: $branches) {
    device: transportationDeviceUser {
      id
      returning
      returnZone {
        id
        name
      }
      user {
        id
        firstName
        lastName
      }
    }
  }
}
    `;
export function useSDriverReturns(baseOptions: ApolloReactHooks.SubscriptionHookOptions<TSDriverReturns, TSDriverReturnsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<TSDriverReturns, TSDriverReturnsVariables>(SDriverReturnsDocument, options);
      }
export type SDriverReturnsHookResult = ReturnType<typeof useSDriverReturns>;
export type SDriverReturnsSubscriptionResult = ApolloReactCommon.SubscriptionResult<TSDriverReturns>;
export const SOrderCallDocument = gql`
    subscription SOrderCall {
  call: updatedUserCallingCustomer {
    eventId
    phone
    prefix
    isRinging
  }
}
    `;
export function useSOrderCall(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<TSOrderCall, TSOrderCallVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<TSOrderCall, TSOrderCallVariables>(SOrderCallDocument, options);
      }
export type SOrderCallHookResult = ReturnType<typeof useSOrderCall>;
export type SOrderCallSubscriptionResult = ApolloReactCommon.SubscriptionResult<TSOrderCall>;
export const SOrderListDocument = gql`
    subscription SOrderList($branches: [ID!], $categories: [OrderStateCategoryEnum!]) {
  updatedOrder(companyBranches: $branches, orderStateCategoriesOR: $categories) {
    order {
      ...FOrderInList
      ...FOrderMapOrder
    }
  }
}
    ${FOrderInList}
${FOrderMapOrder}`;
export function useSOrderList(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<TSOrderList, TSOrderListVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<TSOrderList, TSOrderListVariables>(SOrderListDocument, options);
      }
export type SOrderListHookResult = ReturnType<typeof useSOrderList>;
export type SOrderListSubscriptionResult = ApolloReactCommon.SubscriptionResult<TSOrderList>;
export const SOrderMapDeliveriesDocument = gql`
    subscription SOrderMapDeliveries($branches: [ID!]!) {
  update: updatedTransportationDeviceUser(companyBranches: $branches) {
    device: transportationDeviceUser {
      ...FOrderMapDevice
      user {
        ...FOrderMapDriver
      }
    }
  }
}
    ${FOrderMapDevice}
${FOrderMapDriver}`;
export function useSOrderMapDeliveries(baseOptions: ApolloReactHooks.SubscriptionHookOptions<TSOrderMapDeliveries, TSOrderMapDeliveriesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<TSOrderMapDeliveries, TSOrderMapDeliveriesVariables>(SOrderMapDeliveriesDocument, options);
      }
export type SOrderMapDeliveriesHookResult = ReturnType<typeof useSOrderMapDeliveries>;
export type SOrderMapDeliveriesSubscriptionResult = ApolloReactCommon.SubscriptionResult<TSOrderMapDeliveries>;
export const SOrderMapOrdersDocument = gql`
    subscription SOrderMapOrders($branches: [ID!], $categories: [OrderStateCategoryEnum!]) {
  updatedOrder(companyBranches: $branches, orderStateCategoriesOR: $categories) {
    order {
      ...FOrderMapOrder
    }
  }
}
    ${FOrderMapOrder}`;
export function useSOrderMapOrders(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<TSOrderMapOrders, TSOrderMapOrdersVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<TSOrderMapOrders, TSOrderMapOrdersVariables>(SOrderMapOrdersDocument, options);
      }
export type SOrderMapOrdersHookResult = ReturnType<typeof useSOrderMapOrders>;
export type SOrderMapOrdersSubscriptionResult = ApolloReactCommon.SubscriptionResult<TSOrderMapOrders>;
export const SOrdersCategoryCountDocument = gql`
    subscription SOrdersCategoryCount($branchesId: [ID!]!, $categories: [OrderStateCategoryEnum!]!) {
  updatedCount: updatedOrderCategoryCount(companyBranches: $branchesId, orderStateCategories: $categories) {
    order {
      id
    }
    nextCategory: newOrderStateCategory
    prevCategory: oldOrderStateCategory
  }
}
    `;
export function useSOrdersCategoryCount(baseOptions: ApolloReactHooks.SubscriptionHookOptions<TSOrdersCategoryCount, TSOrdersCategoryCountVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<TSOrdersCategoryCount, TSOrdersCategoryCountVariables>(SOrdersCategoryCountDocument, options);
      }
export type SOrdersCategoryCountHookResult = ReturnType<typeof useSOrdersCategoryCount>;
export type SOrdersCategoryCountSubscriptionResult = ApolloReactCommon.SubscriptionResult<TSOrdersCategoryCount>;
export const MPauseExpressDeliveryDocument = gql`
    mutation MPauseExpressDelivery($id: ID!, $pausedUntil: DateTime) {
  pauseExpressDelivery(id: $id, pausedUntil: $pausedUntil) {
    ...FExpressState
  }
}
    ${FExpressState}`;
export type TMPauseExpressDeliveryMutationFn = ApolloReactCommon.MutationFunction<TMPauseExpressDelivery, TMPauseExpressDeliveryVariables>;
export function useMPauseExpressDelivery(baseOptions?: ApolloReactHooks.MutationHookOptions<TMPauseExpressDelivery, TMPauseExpressDeliveryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMPauseExpressDelivery, TMPauseExpressDeliveryVariables>(MPauseExpressDeliveryDocument, options);
      }
export type MPauseExpressDeliveryHookResult = ReturnType<typeof useMPauseExpressDelivery>;
export type MPauseExpressDeliveryMutationResult = ApolloReactCommon.MutationResult<TMPauseExpressDelivery>;
export type MPauseExpressDeliveryMutationOptions = ApolloReactCommon.BaseMutationOptions<TMPauseExpressDelivery, TMPauseExpressDeliveryVariables>;
export const QExpressPauseStateDocument = gql`
    query QExpressPauseState($branchIds: [ID!]!) {
  companyBranches(ids: $branchIds) {
    id
    name
    expressDeliverySetting {
      id
      isExpressEnabled
      isExpressAvailable
      pausedUntil
    }
  }
}
    `;
export function useQExpressPauseState(baseOptions: ApolloReactHooks.QueryHookOptions<TQExpressPauseState, TQExpressPauseStateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQExpressPauseState, TQExpressPauseStateVariables>(QExpressPauseStateDocument, options);
      }
export function useQExpressPauseStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQExpressPauseState, TQExpressPauseStateVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQExpressPauseState, TQExpressPauseStateVariables>(QExpressPauseStateDocument, options);
        }
export type QExpressPauseStateHookResult = ReturnType<typeof useQExpressPauseState>;
export type QExpressPauseStateLazyQueryHookResult = ReturnType<typeof useQExpressPauseStateLazyQuery>;
export type QExpressPauseStateQueryResult = ApolloReactCommon.QueryResult<TQExpressPauseState, TQExpressPauseStateVariables>;
export const QOrdersWithItemsDocument = gql`
    query QOrdersWithItems($branches: [ID!], $categories: [OrderStateCategoryEnum!], $acceptedAfter: DateTime) {
  orders(order: {companyBranches: $branches, orderStateCategoriesOR: $categories, includeOldFinished: false, acceptedAfter: $acceptedAfter}) {
    id
    deliveryType {
      enum
    }
    address {
      ...FAddress
    }
    delayedDeliveryTime
    customer: customerJson {
      ...FCustomer
    }
    items {
      ...FOrderDetailWare
      sideDishes {
        ...FOrderDetailWare
      }
    }
    companyBranch {
      id
      name
    }
    ...FOrderForNumber
  }
}
    ${FAddress}
${FCustomer}
${FOrderDetailWare}
${FOrderForNumber}`;
export function useQOrdersWithItems(baseOptions?: ApolloReactHooks.QueryHookOptions<TQOrdersWithItems, TQOrdersWithItemsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQOrdersWithItems, TQOrdersWithItemsVariables>(QOrdersWithItemsDocument, options);
      }
export function useQOrdersWithItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQOrdersWithItems, TQOrdersWithItemsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQOrdersWithItems, TQOrdersWithItemsVariables>(QOrdersWithItemsDocument, options);
        }
export type QOrdersWithItemsHookResult = ReturnType<typeof useQOrdersWithItems>;
export type QOrdersWithItemsLazyQueryHookResult = ReturnType<typeof useQOrdersWithItemsLazyQuery>;
export type QOrdersWithItemsQueryResult = ApolloReactCommon.QueryResult<TQOrdersWithItems, TQOrdersWithItemsVariables>;
export const MClearHandoverTimeOverrideDocument = gql`
    mutation MClearHandoverTimeOverride($branchId: ID!, $handoverType: DeliveryTypeEnum!) {
  destroyOrderProcessTime(companyBranch: $branchId, deliveryType: $handoverType) {
    ...FCurrentHandoverTimes
  }
}
    ${FCurrentHandoverTimes}`;
export type TMClearHandoverTimeOverrideMutationFn = ApolloReactCommon.MutationFunction<TMClearHandoverTimeOverride, TMClearHandoverTimeOverrideVariables>;
export function useMClearHandoverTimeOverride(baseOptions?: ApolloReactHooks.MutationHookOptions<TMClearHandoverTimeOverride, TMClearHandoverTimeOverrideVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMClearHandoverTimeOverride, TMClearHandoverTimeOverrideVariables>(MClearHandoverTimeOverrideDocument, options);
      }
export type MClearHandoverTimeOverrideHookResult = ReturnType<typeof useMClearHandoverTimeOverride>;
export type MClearHandoverTimeOverrideMutationResult = ApolloReactCommon.MutationResult<TMClearHandoverTimeOverride>;
export type MClearHandoverTimeOverrideMutationOptions = ApolloReactCommon.BaseMutationOptions<TMClearHandoverTimeOverride, TMClearHandoverTimeOverrideVariables>;
export const MCreateHandoverTimeOverrideDocument = gql`
    mutation MCreateHandoverTimeOverride($minutes: Int!, $branchId: ID!, $expiresAt: DateTime, $handoverType: DeliveryTypeEnum!) {
  createOrderProcessTime(processTime: $minutes, expiresAt: $expiresAt, companyBranch: $branchId, deliveryType: $handoverType) {
    ...FCurrentHandoverTimes
  }
}
    ${FCurrentHandoverTimes}`;
export type TMCreateHandoverTimeOverrideMutationFn = ApolloReactCommon.MutationFunction<TMCreateHandoverTimeOverride, TMCreateHandoverTimeOverrideVariables>;
export function useMCreateHandoverTimeOverride(baseOptions?: ApolloReactHooks.MutationHookOptions<TMCreateHandoverTimeOverride, TMCreateHandoverTimeOverrideVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMCreateHandoverTimeOverride, TMCreateHandoverTimeOverrideVariables>(MCreateHandoverTimeOverrideDocument, options);
      }
export type MCreateHandoverTimeOverrideHookResult = ReturnType<typeof useMCreateHandoverTimeOverride>;
export type MCreateHandoverTimeOverrideMutationResult = ApolloReactCommon.MutationResult<TMCreateHandoverTimeOverride>;
export type MCreateHandoverTimeOverrideMutationOptions = ApolloReactCommon.BaseMutationOptions<TMCreateHandoverTimeOverride, TMCreateHandoverTimeOverrideVariables>;
export const QBranchesHandoverTimesDocument = gql`
    query QBranchesHandoverTimes($branchIds: [ID!]!) {
  companyBranches(ids: $branchIds) {
    ...FCurrentHandoverTimes
  }
}
    ${FCurrentHandoverTimes}`;
export function useQBranchesHandoverTimes(baseOptions: ApolloReactHooks.QueryHookOptions<TQBranchesHandoverTimes, TQBranchesHandoverTimesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQBranchesHandoverTimes, TQBranchesHandoverTimesVariables>(QBranchesHandoverTimesDocument, options);
      }
export function useQBranchesHandoverTimesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQBranchesHandoverTimes, TQBranchesHandoverTimesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQBranchesHandoverTimes, TQBranchesHandoverTimesVariables>(QBranchesHandoverTimesDocument, options);
        }
export type QBranchesHandoverTimesHookResult = ReturnType<typeof useQBranchesHandoverTimes>;
export type QBranchesHandoverTimesLazyQueryHookResult = ReturnType<typeof useQBranchesHandoverTimesLazyQuery>;
export type QBranchesHandoverTimesQueryResult = ApolloReactCommon.QueryResult<TQBranchesHandoverTimes, TQBranchesHandoverTimesVariables>;
export const QBillingClientDocument = gql`
    query QBillingClient($branch: ID!) {
  companyBranch(id: $branch) {
    id
    client: company {
      id
      name
      bankAccount: account
    }
    currency: defaultCurrency {
      code
    }
  }
}
    `;
export function useQBillingClient(baseOptions: ApolloReactHooks.QueryHookOptions<TQBillingClient, TQBillingClientVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQBillingClient, TQBillingClientVariables>(QBillingClientDocument, options);
      }
export function useQBillingClientLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQBillingClient, TQBillingClientVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQBillingClient, TQBillingClientVariables>(QBillingClientDocument, options);
        }
export type QBillingClientHookResult = ReturnType<typeof useQBillingClient>;
export type QBillingClientLazyQueryHookResult = ReturnType<typeof useQBillingClientLazyQuery>;
export type QBillingClientQueryResult = ApolloReactCommon.QueryResult<TQBillingClient, TQBillingClientVariables>;
export const QBillingExpenseDetailDocument = gql`
    query QBillingExpenseDetail($params: InputFeeStatistics!) {
  costStats: statisticsForOperatingCosts(statisticsParams: $params) {
    ...FBillingExpense
  }
}
    ${FBillingExpense}`;
export function useQBillingExpenseDetail(baseOptions: ApolloReactHooks.QueryHookOptions<TQBillingExpenseDetail, TQBillingExpenseDetailVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQBillingExpenseDetail, TQBillingExpenseDetailVariables>(QBillingExpenseDetailDocument, options);
      }
export function useQBillingExpenseDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQBillingExpenseDetail, TQBillingExpenseDetailVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQBillingExpenseDetail, TQBillingExpenseDetailVariables>(QBillingExpenseDetailDocument, options);
        }
export type QBillingExpenseDetailHookResult = ReturnType<typeof useQBillingExpenseDetail>;
export type QBillingExpenseDetailLazyQueryHookResult = ReturnType<typeof useQBillingExpenseDetailLazyQuery>;
export type QBillingExpenseDetailQueryResult = ApolloReactCommon.QueryResult<TQBillingExpenseDetail, TQBillingExpenseDetailVariables>;
export const QBillingExpenseSummaryDocument = gql`
    query QBillingExpenseSummary($params: InputFeeStatistics!) {
  feeStats: statisticsForFees(statisticsParams: $params) {
    speedloServices {
      value
    }
    notifications {
      value
    }
    payments: paymentGates {
      value
    }
    deliveries {
      value
    }
    commission {
      value
    }
    billedFee: commissionAfterLimit {
      value
    }
    commissionLimit {
      value
    }
    total {
      value
    }
    totalWithVat {
      value
    }
    minimumPayment {
      value
    }
    minimumPaymentSurcharge {
      value
    }
  }
}
    `;
export function useQBillingExpenseSummary(baseOptions: ApolloReactHooks.QueryHookOptions<TQBillingExpenseSummary, TQBillingExpenseSummaryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQBillingExpenseSummary, TQBillingExpenseSummaryVariables>(QBillingExpenseSummaryDocument, options);
      }
export function useQBillingExpenseSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQBillingExpenseSummary, TQBillingExpenseSummaryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQBillingExpenseSummary, TQBillingExpenseSummaryVariables>(QBillingExpenseSummaryDocument, options);
        }
export type QBillingExpenseSummaryHookResult = ReturnType<typeof useQBillingExpenseSummary>;
export type QBillingExpenseSummaryLazyQueryHookResult = ReturnType<typeof useQBillingExpenseSummaryLazyQuery>;
export type QBillingExpenseSummaryQueryResult = ApolloReactCommon.QueryResult<TQBillingExpenseSummary, TQBillingExpenseSummaryVariables>;
export const QBillingExpenseTypesDocument = gql`
    query QBillingExpenseTypes {
  notificationTypes: operatingCostTypesForSms {
    enum
  }
  paymentTypes: operatingCostTypesForPayments {
    enum
  }
  deliveryTypes: operatingCostTypesForDeliveries {
    enum
  }
}
    `;
export function useQBillingExpenseTypes(baseOptions?: ApolloReactHooks.QueryHookOptions<TQBillingExpenseTypes, TQBillingExpenseTypesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQBillingExpenseTypes, TQBillingExpenseTypesVariables>(QBillingExpenseTypesDocument, options);
      }
export function useQBillingExpenseTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQBillingExpenseTypes, TQBillingExpenseTypesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQBillingExpenseTypes, TQBillingExpenseTypesVariables>(QBillingExpenseTypesDocument, options);
        }
export type QBillingExpenseTypesHookResult = ReturnType<typeof useQBillingExpenseTypes>;
export type QBillingExpenseTypesLazyQueryHookResult = ReturnType<typeof useQBillingExpenseTypesLazyQuery>;
export type QBillingExpenseTypesQueryResult = ApolloReactCommon.QueryResult<TQBillingExpenseTypes, TQBillingExpenseTypesVariables>;
export const QBillingNotificationExpensesDocument = gql`
    query QBillingNotificationExpenses($params: InputFeeStatistics!) {
  costStats: statisticsForOperatingCosts(statisticsParams: $params) {
    orderOrigin {
      label: code
      enum
    }
    notificationCount: totalCount
    totalSum: totalAbsoluteSum {
      value
    }
  }
}
    `;
export function useQBillingNotificationExpenses(baseOptions: ApolloReactHooks.QueryHookOptions<TQBillingNotificationExpenses, TQBillingNotificationExpensesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQBillingNotificationExpenses, TQBillingNotificationExpensesVariables>(QBillingNotificationExpensesDocument, options);
      }
export function useQBillingNotificationExpensesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQBillingNotificationExpenses, TQBillingNotificationExpensesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQBillingNotificationExpenses, TQBillingNotificationExpensesVariables>(QBillingNotificationExpensesDocument, options);
        }
export type QBillingNotificationExpensesHookResult = ReturnType<typeof useQBillingNotificationExpenses>;
export type QBillingNotificationExpensesLazyQueryHookResult = ReturnType<typeof useQBillingNotificationExpensesLazyQuery>;
export type QBillingNotificationExpensesQueryResult = ApolloReactCommon.QueryResult<TQBillingNotificationExpenses, TQBillingNotificationExpensesVariables>;
export const QBillingOverviewDocument = gql`
    query QBillingOverview($params: InputFeeStatistics!) {
  paymentStats: statisticsForPayments(statisticsParams: $params) {
    holdBySpeedlo: valueHoldBySpeedlo {
      value
    }
    collectedServiceFees {
      value
    }
  }
  feeStats: statisticsForFees(statisticsParams: $params) {
    totalExpenses: totalWithVat {
      value
    }
  }
}
    `;
export function useQBillingOverview(baseOptions: ApolloReactHooks.QueryHookOptions<TQBillingOverview, TQBillingOverviewVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQBillingOverview, TQBillingOverviewVariables>(QBillingOverviewDocument, options);
      }
export function useQBillingOverviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQBillingOverview, TQBillingOverviewVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQBillingOverview, TQBillingOverviewVariables>(QBillingOverviewDocument, options);
        }
export type QBillingOverviewHookResult = ReturnType<typeof useQBillingOverview>;
export type QBillingOverviewLazyQueryHookResult = ReturnType<typeof useQBillingOverviewLazyQuery>;
export type QBillingOverviewQueryResult = ApolloReactCommon.QueryResult<TQBillingOverview, TQBillingOverviewVariables>;
export const QBillingRevenueDocument = gql`
    query QBillingRevenue($params: InputFeeStatistics!) {
  paymentsStats: statisticsForPayments(statisticsParams: $params) {
    prePaidRevenue: prePaidTurnover {
      value
    }
    postPaidRevenue: postPaidTurnover {
      value
    }
    prePaidOrderCount
    postPaidOrderCount
    holdBySpeedlo: valueHoldBySpeedlo {
      value
    }
  }
}
    `;
export function useQBillingRevenue(baseOptions: ApolloReactHooks.QueryHookOptions<TQBillingRevenue, TQBillingRevenueVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQBillingRevenue, TQBillingRevenueVariables>(QBillingRevenueDocument, options);
      }
export function useQBillingRevenueLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQBillingRevenue, TQBillingRevenueVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQBillingRevenue, TQBillingRevenueVariables>(QBillingRevenueDocument, options);
        }
export type QBillingRevenueHookResult = ReturnType<typeof useQBillingRevenue>;
export type QBillingRevenueLazyQueryHookResult = ReturnType<typeof useQBillingRevenueLazyQuery>;
export type QBillingRevenueQueryResult = ApolloReactCommon.QueryResult<TQBillingRevenue, TQBillingRevenueVariables>;
export const QAvailableCreditGroupsDocument = gql`
    query QAvailableCreditGroups($userId: ID!) {
  user(id: $userId) {
    id
    creditGroups: accessibleCreditsGroups {
      id
      name
      allMemberships {
        id
        companyBranch {
          id
        }
      }
    }
  }
}
    `;
export function useQAvailableCreditGroups(baseOptions: ApolloReactHooks.QueryHookOptions<TQAvailableCreditGroups, TQAvailableCreditGroupsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQAvailableCreditGroups, TQAvailableCreditGroupsVariables>(QAvailableCreditGroupsDocument, options);
      }
export function useQAvailableCreditGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQAvailableCreditGroups, TQAvailableCreditGroupsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQAvailableCreditGroups, TQAvailableCreditGroupsVariables>(QAvailableCreditGroupsDocument, options);
        }
export type QAvailableCreditGroupsHookResult = ReturnType<typeof useQAvailableCreditGroups>;
export type QAvailableCreditGroupsLazyQueryHookResult = ReturnType<typeof useQAvailableCreditGroupsLazyQuery>;
export type QAvailableCreditGroupsQueryResult = ApolloReactCommon.QueryResult<TQAvailableCreditGroups, TQAvailableCreditGroupsVariables>;
export const QEventsStatsCreditsDocument = gql`
    query QEventsStatsCredits($filter: InputStatisticCreate!) {
  statistics(statisticsInput: $filter) {
    finishedOrders {
      orders(includeCanceled: true) {
        id
        orderStateCategory
        cashBox {
          id
        }
      }
    }
    creditFundsTransfers {
      transfers {
        ...FCreditsFundsTransfer
      }
    }
  }
}
    ${FCreditsFundsTransfer}`;
export function useQEventsStatsCredits(baseOptions: ApolloReactHooks.QueryHookOptions<TQEventsStatsCredits, TQEventsStatsCreditsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQEventsStatsCredits, TQEventsStatsCreditsVariables>(QEventsStatsCreditsDocument, options);
      }
export function useQEventsStatsCreditsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQEventsStatsCredits, TQEventsStatsCreditsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQEventsStatsCredits, TQEventsStatsCreditsVariables>(QEventsStatsCreditsDocument, options);
        }
export type QEventsStatsCreditsHookResult = ReturnType<typeof useQEventsStatsCredits>;
export type QEventsStatsCreditsLazyQueryHookResult = ReturnType<typeof useQEventsStatsCreditsLazyQuery>;
export type QEventsStatsCreditsQueryResult = ApolloReactCommon.QueryResult<TQEventsStatsCredits, TQEventsStatsCreditsVariables>;
export const QOrderStatsCreditsDocument = gql`
    query QOrderStatsCredits($filter: InputsStatisticCreditsCreate!) {
  statisticsForCredits(statisticsInput: $filter) {
    creditWalletActivities {
      availableOrderRewardsSum {
        ...FFormattedPrice
      }
      expiredOrderRewardsSum {
        ...FFormattedPrice
      }
      orderPaymentsSum {
        ...FFormattedPrice
      }
      orderRewardsSum {
        ...FFormattedPrice
      }
    }
  }
}
    ${FFormattedPrice}`;
export function useQOrderStatsCredits(baseOptions: ApolloReactHooks.QueryHookOptions<TQOrderStatsCredits, TQOrderStatsCreditsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQOrderStatsCredits, TQOrderStatsCreditsVariables>(QOrderStatsCreditsDocument, options);
      }
export function useQOrderStatsCreditsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQOrderStatsCredits, TQOrderStatsCreditsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQOrderStatsCredits, TQOrderStatsCreditsVariables>(QOrderStatsCreditsDocument, options);
        }
export type QOrderStatsCreditsHookResult = ReturnType<typeof useQOrderStatsCredits>;
export type QOrderStatsCreditsLazyQueryHookResult = ReturnType<typeof useQOrderStatsCreditsLazyQuery>;
export type QOrderStatsCreditsQueryResult = ApolloReactCommon.QueryResult<TQOrderStatsCredits, TQOrderStatsCreditsVariables>;
export const MCreateVoucherDocument = gql`
    mutation MCreateVoucher($message: String!, $discount: Float!, $shareable: Boolean, $validTill: DateTime!, $customerPhone: String!, $companyBranchId: ID!) {
  createUserVoucher(message: $message, public: $shareable, discount: $discount, phone: $customerPhone, validTill: $validTill, companyBranch: $companyBranchId) {
    id
  }
}
    `;
export type TMCreateVoucherMutationFn = ApolloReactCommon.MutationFunction<TMCreateVoucher, TMCreateVoucherVariables>;
export function useMCreateVoucher(baseOptions?: ApolloReactHooks.MutationHookOptions<TMCreateVoucher, TMCreateVoucherVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMCreateVoucher, TMCreateVoucherVariables>(MCreateVoucherDocument, options);
      }
export type MCreateVoucherHookResult = ReturnType<typeof useMCreateVoucher>;
export type MCreateVoucherMutationResult = ApolloReactCommon.MutationResult<TMCreateVoucher>;
export type MCreateVoucherMutationOptions = ApolloReactCommon.BaseMutationOptions<TMCreateVoucher, TMCreateVoucherVariables>;
export const MCreditsCreateGiftDocument = gql`
    mutation MCreditsCreateGift($userId: ID!, $amount: Float!, $message: String, $expiresAt: DateTime, $companyBranchId: ID!) {
  creditsCreateGift(userId: $userId, amount: $amount, message: $message, expiresAt: $expiresAt, companyBranchId: $companyBranchId) {
    id
  }
}
    `;
export type TMCreditsCreateGiftMutationFn = ApolloReactCommon.MutationFunction<TMCreditsCreateGift, TMCreditsCreateGiftVariables>;
export function useMCreditsCreateGift(baseOptions?: ApolloReactHooks.MutationHookOptions<TMCreditsCreateGift, TMCreditsCreateGiftVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMCreditsCreateGift, TMCreditsCreateGiftVariables>(MCreditsCreateGiftDocument, options);
      }
export type MCreditsCreateGiftHookResult = ReturnType<typeof useMCreditsCreateGift>;
export type MCreditsCreateGiftMutationResult = ApolloReactCommon.MutationResult<TMCreditsCreateGift>;
export type MCreditsCreateGiftMutationOptions = ApolloReactCommon.BaseMutationOptions<TMCreditsCreateGift, TMCreditsCreateGiftVariables>;
export const QBranchCurrencyDocument = gql`
    query QBranchCurrency($id: ID!) {
  companyBranch(id: $id) {
    id
    defaultCurrency {
      id
      code
      enum
    }
  }
}
    `;
export function useQBranchCurrency(baseOptions: ApolloReactHooks.QueryHookOptions<TQBranchCurrency, TQBranchCurrencyVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQBranchCurrency, TQBranchCurrencyVariables>(QBranchCurrencyDocument, options);
      }
export function useQBranchCurrencyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQBranchCurrency, TQBranchCurrencyVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQBranchCurrency, TQBranchCurrencyVariables>(QBranchCurrencyDocument, options);
        }
export type QBranchCurrencyHookResult = ReturnType<typeof useQBranchCurrency>;
export type QBranchCurrencyLazyQueryHookResult = ReturnType<typeof useQBranchCurrencyLazyQuery>;
export type QBranchCurrencyQueryResult = ApolloReactCommon.QueryResult<TQBranchCurrency, TQBranchCurrencyVariables>;
export const QCustomerCreditGiftsDocument = gql`
    query QCustomerCreditGifts($userId: ID!, $branchIds: [ID!], $first: Int, $last: Int, $after: String, $before: String) {
  user(id: $userId) {
    id
    creditActivities: creditsWalletActivities(activityTypes: [GIFT], companyBranchIds: $branchIds, first: $first, last: $last, after: $after, before: $before) {
      pageInfo {
        endCursor
        startCursor
        hasNextPage
        hasPreviousPage
      }
      nodes {
        ...FCreditActivityInCustomerHistory
      }
    }
  }
}
    ${FCreditActivityInCustomerHistory}`;
export function useQCustomerCreditGifts(baseOptions: ApolloReactHooks.QueryHookOptions<TQCustomerCreditGifts, TQCustomerCreditGiftsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQCustomerCreditGifts, TQCustomerCreditGiftsVariables>(QCustomerCreditGiftsDocument, options);
      }
export function useQCustomerCreditGiftsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQCustomerCreditGifts, TQCustomerCreditGiftsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQCustomerCreditGifts, TQCustomerCreditGiftsVariables>(QCustomerCreditGiftsDocument, options);
        }
export type QCustomerCreditGiftsHookResult = ReturnType<typeof useQCustomerCreditGifts>;
export type QCustomerCreditGiftsLazyQueryHookResult = ReturnType<typeof useQCustomerCreditGiftsLazyQuery>;
export type QCustomerCreditGiftsQueryResult = ApolloReactCommon.QueryResult<TQCustomerCreditGifts, TQCustomerCreditGiftsVariables>;
export const QCustomerHistoryDocument = gql`
    query QCustomerHistory($filter: InputStatisticCreate!) {
  stats: statistics(statisticsInput: $filter) {
    customerHistory: customerStatistics {
      userAccount {
        id
      }
      phone
      names: fullNames
      emails
      addresses
      orders {
        ...FOrderInCustomerHistory
      }
      promoCodeStatistics {
        description
        acquiredBy: claimCustomerPhone
        expirationDate: claimExpiration
        acquirementDate: claimDate
        acquirementOrder: claimOrder {
          id
        }
        applicationOrder: appliedOrder {
          id
          deliveredAt
          customer: customerJson {
            phones {
              phone
            }
          }
        }
        discount {
          value
          formattedValue
        }
        promoCode {
          id
          code
          public
          type {
            enum
            code
          }
          companyBranch {
            id
            name
          }
          company {
            id
            name
          }
        }
      }
    }
  }
}
    ${FOrderInCustomerHistory}`;
export function useQCustomerHistory(baseOptions: ApolloReactHooks.QueryHookOptions<TQCustomerHistory, TQCustomerHistoryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQCustomerHistory, TQCustomerHistoryVariables>(QCustomerHistoryDocument, options);
      }
export function useQCustomerHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQCustomerHistory, TQCustomerHistoryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQCustomerHistory, TQCustomerHistoryVariables>(QCustomerHistoryDocument, options);
        }
export type QCustomerHistoryHookResult = ReturnType<typeof useQCustomerHistory>;
export type QCustomerHistoryLazyQueryHookResult = ReturnType<typeof useQCustomerHistoryLazyQuery>;
export type QCustomerHistoryQueryResult = ApolloReactCommon.QueryResult<TQCustomerHistory, TQCustomerHistoryVariables>;
export const MExportCustomersDocument = gql`
    mutation MExportCustomers($branches: [ID!]!, $dateFrom: DateTime!, $dateTo: DateTime!, $fileFormat: FileReportFormat!, $madeOrder: Boolean!) {
  result: exportCustomers(companyBranches: $branches, dateFrom: $dateFrom, dateTo: $dateTo, format: $fileFormat, madeOrder: $madeOrder) {
    success
    maskedEmail
  }
}
    `;
export type TMExportCustomersMutationFn = ApolloReactCommon.MutationFunction<TMExportCustomers, TMExportCustomersVariables>;
export function useMExportCustomers(baseOptions?: ApolloReactHooks.MutationHookOptions<TMExportCustomers, TMExportCustomersVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMExportCustomers, TMExportCustomersVariables>(MExportCustomersDocument, options);
      }
export type MExportCustomersHookResult = ReturnType<typeof useMExportCustomers>;
export type MExportCustomersMutationResult = ApolloReactCommon.MutationResult<TMExportCustomers>;
export type MExportCustomersMutationOptions = ApolloReactCommon.BaseMutationOptions<TMExportCustomers, TMExportCustomersVariables>;
export const MRequestPhoneConfirmationCodeDocument = gql`
    mutation MRequestPhoneConfirmationCode($phoneNumber: String!, $exportId: ID!) {
  result: requestPhoneConfirmationCode(phoneNumber: $phoneNumber, backgroundExport: $exportId) {
    phoneNumber: phone
  }
}
    `;
export type TMRequestPhoneConfirmationCodeMutationFn = ApolloReactCommon.MutationFunction<TMRequestPhoneConfirmationCode, TMRequestPhoneConfirmationCodeVariables>;
export function useMRequestPhoneConfirmationCode(baseOptions?: ApolloReactHooks.MutationHookOptions<TMRequestPhoneConfirmationCode, TMRequestPhoneConfirmationCodeVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMRequestPhoneConfirmationCode, TMRequestPhoneConfirmationCodeVariables>(MRequestPhoneConfirmationCodeDocument, options);
      }
export type MRequestPhoneConfirmationCodeHookResult = ReturnType<typeof useMRequestPhoneConfirmationCode>;
export type MRequestPhoneConfirmationCodeMutationResult = ApolloReactCommon.MutationResult<TMRequestPhoneConfirmationCode>;
export type MRequestPhoneConfirmationCodeMutationOptions = ApolloReactCommon.BaseMutationOptions<TMRequestPhoneConfirmationCode, TMRequestPhoneConfirmationCodeVariables>;
export const MValidateUserConfirmationCodeDocument = gql`
    mutation MValidateUserConfirmationCode($code: String!) {
  result: validateCurrentUserConfirmationCode(code: $code) {
    token
  }
}
    `;
export type TMValidateUserConfirmationCodeMutationFn = ApolloReactCommon.MutationFunction<TMValidateUserConfirmationCode, TMValidateUserConfirmationCodeVariables>;
export function useMValidateUserConfirmationCode(baseOptions?: ApolloReactHooks.MutationHookOptions<TMValidateUserConfirmationCode, TMValidateUserConfirmationCodeVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMValidateUserConfirmationCode, TMValidateUserConfirmationCodeVariables>(MValidateUserConfirmationCodeDocument, options);
      }
export type MValidateUserConfirmationCodeHookResult = ReturnType<typeof useMValidateUserConfirmationCode>;
export type MValidateUserConfirmationCodeMutationResult = ApolloReactCommon.MutationResult<TMValidateUserConfirmationCode>;
export type MValidateUserConfirmationCodeMutationOptions = ApolloReactCommon.BaseMutationOptions<TMValidateUserConfirmationCode, TMValidateUserConfirmationCodeVariables>;
export const QCustomersFileReportsDocument = gql`
    query QCustomersFileReports($exportId: ID!) {
  fileUrl: customersFileReports(backgroundExport: $exportId)
}
    `;
export function useQCustomersFileReports(baseOptions: ApolloReactHooks.QueryHookOptions<TQCustomersFileReports, TQCustomersFileReportsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQCustomersFileReports, TQCustomersFileReportsVariables>(QCustomersFileReportsDocument, options);
      }
export function useQCustomersFileReportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQCustomersFileReports, TQCustomersFileReportsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQCustomersFileReports, TQCustomersFileReportsVariables>(QCustomersFileReportsDocument, options);
        }
export type QCustomersFileReportsHookResult = ReturnType<typeof useQCustomersFileReports>;
export type QCustomersFileReportsLazyQueryHookResult = ReturnType<typeof useQCustomersFileReportsLazyQuery>;
export type QCustomersFileReportsQueryResult = ApolloReactCommon.QueryResult<TQCustomersFileReports, TQCustomersFileReportsVariables>;
export const QOrderRatingsDocument = gql`
    query QOrderRatings($filter: InputStatisticCreate!) {
  stats: statistics(statisticsInput: $filter) {
    orders: finishedOrders {
      list: orders(includeCanceled: false) {
        ...FOrderForRating
      }
    }
  }
}
    ${FOrderForRating}`;
export function useQOrderRatings(baseOptions: ApolloReactHooks.QueryHookOptions<TQOrderRatings, TQOrderRatingsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQOrderRatings, TQOrderRatingsVariables>(QOrderRatingsDocument, options);
      }
export function useQOrderRatingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQOrderRatings, TQOrderRatingsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQOrderRatings, TQOrderRatingsVariables>(QOrderRatingsDocument, options);
        }
export type QOrderRatingsHookResult = ReturnType<typeof useQOrderRatings>;
export type QOrderRatingsLazyQueryHookResult = ReturnType<typeof useQOrderRatingsLazyQuery>;
export type QOrderRatingsQueryResult = ApolloReactCommon.QueryResult<TQOrderRatings, TQOrderRatingsVariables>;
export const MFinancialReportCreateDocument = gql`
    mutation MFinancialReportCreate($branchId: ID!) {
  result: createFinancialReport(companyBranchId: $branchId) {
    id
  }
}
    `;
export type TMFinancialReportCreateMutationFn = ApolloReactCommon.MutationFunction<TMFinancialReportCreate, TMFinancialReportCreateVariables>;
export function useMFinancialReportCreate(baseOptions?: ApolloReactHooks.MutationHookOptions<TMFinancialReportCreate, TMFinancialReportCreateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMFinancialReportCreate, TMFinancialReportCreateVariables>(MFinancialReportCreateDocument, options);
      }
export type MFinancialReportCreateHookResult = ReturnType<typeof useMFinancialReportCreate>;
export type MFinancialReportCreateMutationResult = ApolloReactCommon.MutationResult<TMFinancialReportCreate>;
export type MFinancialReportCreateMutationOptions = ApolloReactCommon.BaseMutationOptions<TMFinancialReportCreate, TMFinancialReportCreateVariables>;
export const QClosureHistoryDocument = gql`
    query QClosureHistory($branchId: ID!, $dateFrom: Date!, $dateTo: Date!) {
  history: financialReports(companyBranchId: $branchId, dateFrom: $dateFrom, dateTo: $dateTo) {
    id
    reportDatetime
    reportSequence
  }
}
    `;
export function useQClosureHistory(baseOptions: ApolloReactHooks.QueryHookOptions<TQClosureHistory, TQClosureHistoryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQClosureHistory, TQClosureHistoryVariables>(QClosureHistoryDocument, options);
      }
export function useQClosureHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQClosureHistory, TQClosureHistoryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQClosureHistory, TQClosureHistoryVariables>(QClosureHistoryDocument, options);
        }
export type QClosureHistoryHookResult = ReturnType<typeof useQClosureHistory>;
export type QClosureHistoryLazyQueryHookResult = ReturnType<typeof useQClosureHistoryLazyQuery>;
export type QClosureHistoryQueryResult = ApolloReactCommon.QueryResult<TQClosureHistory, TQClosureHistoryVariables>;
export const QClosureReportDocument = gql`
    query QClosureReport($branchId: ID!, $reportId: ID!, $showReport: Boolean!) {
  lastReport: lastFinancialReport(companyBranchId: $branchId) @skip(if: $showReport) {
    plainData
    reportDatetime
    reportSequence
  }
  report: financialReport(report: $reportId) @include(if: $showReport) {
    plainData
    reportDatetime
    reportSequence
  }
}
    `;
export function useQClosureReport(baseOptions: ApolloReactHooks.QueryHookOptions<TQClosureReport, TQClosureReportVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQClosureReport, TQClosureReportVariables>(QClosureReportDocument, options);
      }
export function useQClosureReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQClosureReport, TQClosureReportVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQClosureReport, TQClosureReportVariables>(QClosureReportDocument, options);
        }
export type QClosureReportHookResult = ReturnType<typeof useQClosureReport>;
export type QClosureReportLazyQueryHookResult = ReturnType<typeof useQClosureReportLazyQuery>;
export type QClosureReportQueryResult = ApolloReactCommon.QueryResult<TQClosureReport, TQClosureReportVariables>;
export const QDriverHistoryDocument = gql`
    query QDriverHistory($branchId: ID!, $driverId: ID!, $dateFrom: DateTime!, $dateTo: DateTime!) {
  driverRoutes: transportationDeviceUsers(user: $driverId, createdFrom: $dateFrom, createdTo: $dateTo) {
    timePositions: geoRoad {
      position: geoPosition {
        latitude
        longitude
      }
      time: timestamp
    }
  }
  statistics(statisticsInput: {branches: [$branchId], dateTimeFrom: $dateFrom, dateTimeTo: $dateTo, drivers: [$driverId]}) {
    finishedOrders {
      driverOrders: orders(includeCanceled: true) {
        ...FOrderForHandoverTime
        id
        acceptedAt
        orderStateCategory
        gps {
          ...FGeoPoint
        }
        userDeliveringOrder {
          id
          assignedAt: createdAt
          deliveryStates {
            createdAt
            deliveryState
          }
        }
      }
    }
  }
}
    ${FOrderForHandoverTime}
${FGeoPoint}`;
export function useQDriverHistory(baseOptions: ApolloReactHooks.QueryHookOptions<TQDriverHistory, TQDriverHistoryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQDriverHistory, TQDriverHistoryVariables>(QDriverHistoryDocument, options);
      }
export function useQDriverHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQDriverHistory, TQDriverHistoryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQDriverHistory, TQDriverHistoryVariables>(QDriverHistoryDocument, options);
        }
export type QDriverHistoryHookResult = ReturnType<typeof useQDriverHistory>;
export type QDriverHistoryLazyQueryHookResult = ReturnType<typeof useQDriverHistoryLazyQuery>;
export type QDriverHistoryQueryResult = ApolloReactCommon.QueryResult<TQDriverHistory, TQDriverHistoryVariables>;
export const QStatsOrdersDocument = gql`
    query QStatsOrders($filter: InputStatisticCreate!) {
  stats: statistics(statisticsInput: $filter) {
    finishedOrders {
      onlinePayments {
        ...FPriceWithCurrency
      }
      total {
        ...FPriceWithCurrency
      }
      finishedCount: ordersCount
      cancelledCount: ordersCanceledCount
    }
    orderStatisticsPlain
  }
}
    ${FPriceWithCurrency}`;
export function useQStatsOrders(baseOptions: ApolloReactHooks.QueryHookOptions<TQStatsOrders, TQStatsOrdersVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQStatsOrders, TQStatsOrdersVariables>(QStatsOrdersDocument, options);
      }
export function useQStatsOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQStatsOrders, TQStatsOrdersVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQStatsOrders, TQStatsOrdersVariables>(QStatsOrdersDocument, options);
        }
export type QStatsOrdersHookResult = ReturnType<typeof useQStatsOrders>;
export type QStatsOrdersLazyQueryHookResult = ReturnType<typeof useQStatsOrdersLazyQuery>;
export type QStatsOrdersQueryResult = ApolloReactCommon.QueryResult<TQStatsOrders, TQStatsOrdersVariables>;
export const QStatsOrdersCountsDocument = gql`
    query QStatsOrdersCounts($filter: InputStatisticCreate!) {
  stats: statistics(statisticsInput: $filter) {
    counts: finishedOrders {
      finished: ordersCount
      cancelled: ordersCanceledCount
    }
  }
}
    `;
export function useQStatsOrdersCounts(baseOptions: ApolloReactHooks.QueryHookOptions<TQStatsOrdersCounts, TQStatsOrdersCountsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQStatsOrdersCounts, TQStatsOrdersCountsVariables>(QStatsOrdersCountsDocument, options);
      }
export function useQStatsOrdersCountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQStatsOrdersCounts, TQStatsOrdersCountsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQStatsOrdersCounts, TQStatsOrdersCountsVariables>(QStatsOrdersCountsDocument, options);
        }
export type QStatsOrdersCountsHookResult = ReturnType<typeof useQStatsOrdersCounts>;
export type QStatsOrdersCountsLazyQueryHookResult = ReturnType<typeof useQStatsOrdersCountsLazyQuery>;
export type QStatsOrdersCountsQueryResult = ApolloReactCommon.QueryResult<TQStatsOrdersCounts, TQStatsOrdersCountsVariables>;
export const QStatsOrdersListDocument = gql`
    query QStatsOrdersList($filter: InputStatisticCreate!, $pagination: InputPaginationParams, $orderFinalStates: [OrderStateEnum!]) {
  stats: statistics(statisticsInput: $filter) {
    orders: finishedOrders {
      list: orders(includeCanceled: true, pagination: $pagination, orderStatesOr: $orderFinalStates) {
        ...FOrderInStatistics
      }
    }
  }
}
    ${FOrderInStatistics}`;
export function useQStatsOrdersList(baseOptions: ApolloReactHooks.QueryHookOptions<TQStatsOrdersList, TQStatsOrdersListVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQStatsOrdersList, TQStatsOrdersListVariables>(QStatsOrdersListDocument, options);
      }
export function useQStatsOrdersListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQStatsOrdersList, TQStatsOrdersListVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQStatsOrdersList, TQStatsOrdersListVariables>(QStatsOrdersListDocument, options);
        }
export type QStatsOrdersListHookResult = ReturnType<typeof useQStatsOrdersList>;
export type QStatsOrdersListLazyQueryHookResult = ReturnType<typeof useQStatsOrdersListLazyQuery>;
export type QStatsOrdersListQueryResult = ApolloReactCommon.QueryResult<TQStatsOrdersList, TQStatsOrdersListVariables>;
export const QStatsSalesDocument = gql`
    query QStatsSales($filter: InputStatisticCreate!) {
  sales: statistics(statisticsInput: $filter) {
    category: categoryStatisticsPlain
    daily: dailyStatisticsPlain
    delivery: deliveryStatisticsPlain
    drivers: driversStatisticsPlain
    vat: vatStatisticsPlain
    deliveryZone: deliveryZoneStatisticsPlain
    discount: discountStatisticsPlain
    fees: chargeStatisticsPlain
  }
}
    `;
export function useQStatsSales(baseOptions: ApolloReactHooks.QueryHookOptions<TQStatsSales, TQStatsSalesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQStatsSales, TQStatsSalesVariables>(QStatsSalesDocument, options);
      }
export function useQStatsSalesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQStatsSales, TQStatsSalesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQStatsSales, TQStatsSalesVariables>(QStatsSalesDocument, options);
        }
export type QStatsSalesHookResult = ReturnType<typeof useQStatsSales>;
export type QStatsSalesLazyQueryHookResult = ReturnType<typeof useQStatsSalesLazyQuery>;
export type QStatsSalesQueryResult = ApolloReactCommon.QueryResult<TQStatsSales, TQStatsSalesVariables>;
export const QReportFileDocument = gql`
    query QReportFile($filter: InputStatisticCreate!, $reportType: FileReportTypeEnum!) {
  reportUrl: fileReports(statisticsInput: $filter, fileReportType: $reportType)
}
    `;
export function useQReportFile(baseOptions: ApolloReactHooks.QueryHookOptions<TQReportFile, TQReportFileVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQReportFile, TQReportFileVariables>(QReportFileDocument, options);
      }
export function useQReportFileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQReportFile, TQReportFileVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQReportFile, TQReportFileVariables>(QReportFileDocument, options);
        }
export type QReportFileHookResult = ReturnType<typeof useQReportFile>;
export type QReportFileLazyQueryHookResult = ReturnType<typeof useQReportFileLazyQuery>;
export type QReportFileQueryResult = ApolloReactCommon.QueryResult<TQReportFile, TQReportFileVariables>;
export const QReportTypesDocument = gql`
    query QReportTypes {
  reportTypes: fileReportTypes {
    id
    code
    enum
  }
}
    `;
export function useQReportTypes(baseOptions?: ApolloReactHooks.QueryHookOptions<TQReportTypes, TQReportTypesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQReportTypes, TQReportTypesVariables>(QReportTypesDocument, options);
      }
export function useQReportTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQReportTypes, TQReportTypesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQReportTypes, TQReportTypesVariables>(QReportTypesDocument, options);
        }
export type QReportTypesHookResult = ReturnType<typeof useQReportTypes>;
export type QReportTypesLazyQueryHookResult = ReturnType<typeof useQReportTypesLazyQuery>;
export type QReportTypesQueryResult = ApolloReactCommon.QueryResult<TQReportTypes, TQReportTypesVariables>;
export const MCreatePrintQueueDocument = gql`
    mutation MCreatePrintQueue($printTriggerId: ID!, $companyBranchId: ID!, $printTemplateId: ID!) {
  printQueue: createCompanyBranchTrigger(templatable: $printTemplateId, companyBranch: $companyBranchId, triggerConfiguration: $printTriggerId) {
    ...FPrintQueue
  }
}
    ${FPrintQueue}`;
export type TMCreatePrintQueueMutationFn = ApolloReactCommon.MutationFunction<TMCreatePrintQueue, TMCreatePrintQueueVariables>;
export function useMCreatePrintQueue(baseOptions?: ApolloReactHooks.MutationHookOptions<TMCreatePrintQueue, TMCreatePrintQueueVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMCreatePrintQueue, TMCreatePrintQueueVariables>(MCreatePrintQueueDocument, options);
      }
export type MCreatePrintQueueHookResult = ReturnType<typeof useMCreatePrintQueue>;
export type MCreatePrintQueueMutationResult = ApolloReactCommon.MutationResult<TMCreatePrintQueue>;
export type MCreatePrintQueueMutationOptions = ApolloReactCommon.BaseMutationOptions<TMCreatePrintQueue, TMCreatePrintQueueVariables>;
export const MDeletePrintQueueDocument = gql`
    mutation MDeletePrintQueue($printQueueId: ID!) {
  printQueue: destroyCompanyBranchTrigger(id: $printQueueId) {
    id
  }
}
    `;
export type TMDeletePrintQueueMutationFn = ApolloReactCommon.MutationFunction<TMDeletePrintQueue, TMDeletePrintQueueVariables>;
export function useMDeletePrintQueue(baseOptions?: ApolloReactHooks.MutationHookOptions<TMDeletePrintQueue, TMDeletePrintQueueVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMDeletePrintQueue, TMDeletePrintQueueVariables>(MDeletePrintQueueDocument, options);
      }
export type MDeletePrintQueueHookResult = ReturnType<typeof useMDeletePrintQueue>;
export type MDeletePrintQueueMutationResult = ApolloReactCommon.MutationResult<TMDeletePrintQueue>;
export type MDeletePrintQueueMutationOptions = ApolloReactCommon.BaseMutationOptions<TMDeletePrintQueue, TMDeletePrintQueueVariables>;
export const MUpdatePrintQueueDocument = gql`
    mutation MUpdatePrintQueue($printQueueId: ID!, $printTriggerId: ID, $printTemplateId: ID) {
  printQueue: updateCompanyBranchTrigger(id: $printQueueId, templatable: $printTemplateId, triggerConfiguration: $printTriggerId) {
    ...FPrintQueue
  }
}
    ${FPrintQueue}`;
export type TMUpdatePrintQueueMutationFn = ApolloReactCommon.MutationFunction<TMUpdatePrintQueue, TMUpdatePrintQueueVariables>;
export function useMUpdatePrintQueue(baseOptions?: ApolloReactHooks.MutationHookOptions<TMUpdatePrintQueue, TMUpdatePrintQueueVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMUpdatePrintQueue, TMUpdatePrintQueueVariables>(MUpdatePrintQueueDocument, options);
      }
export type MUpdatePrintQueueHookResult = ReturnType<typeof useMUpdatePrintQueue>;
export type MUpdatePrintQueueMutationResult = ApolloReactCommon.MutationResult<TMUpdatePrintQueue>;
export type MUpdatePrintQueueMutationOptions = ApolloReactCommon.BaseMutationOptions<TMUpdatePrintQueue, TMUpdatePrintQueueVariables>;
export const QPrintQueueConfigsDocument = gql`
    query QPrintQueueConfigs($companyBranchIds: [ID!]!) {
  printableObjects: triggerableTypes {
    ...FPrintableObject
  }
  printTriggers: triggerConfigurations(companyBranches: $companyBranchIds, triggerType: PRINT) {
    ...FPrintTrigger
  }
  printTemplates(companyBranches: $companyBranchIds) {
    ...FPrintTemplateWithObject
  }
}
    ${FPrintableObject}
${FPrintTrigger}
${FPrintTemplateWithObject}`;
export function useQPrintQueueConfigs(baseOptions: ApolloReactHooks.QueryHookOptions<TQPrintQueueConfigs, TQPrintQueueConfigsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQPrintQueueConfigs, TQPrintQueueConfigsVariables>(QPrintQueueConfigsDocument, options);
      }
export function useQPrintQueueConfigsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQPrintQueueConfigs, TQPrintQueueConfigsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQPrintQueueConfigs, TQPrintQueueConfigsVariables>(QPrintQueueConfigsDocument, options);
        }
export type QPrintQueueConfigsHookResult = ReturnType<typeof useQPrintQueueConfigs>;
export type QPrintQueueConfigsLazyQueryHookResult = ReturnType<typeof useQPrintQueueConfigsLazyQuery>;
export type QPrintQueueConfigsQueryResult = ApolloReactCommon.QueryResult<TQPrintQueueConfigs, TQPrintQueueConfigsVariables>;
export const QPrintQueuesDocument = gql`
    query QPrintQueues($companyBranchIds: [ID!]) {
  printQueues: companyBranchTriggers(companyBranches: $companyBranchIds, triggerType: PRINT) {
    ...FPrintQueue
    printerBindings: companyBranchTriggerPrinters {
      ...FPrinterQueueLink
    }
  }
}
    ${FPrintQueue}
${FPrinterQueueLink}`;
export function useQPrintQueues(baseOptions?: ApolloReactHooks.QueryHookOptions<TQPrintQueues, TQPrintQueuesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQPrintQueues, TQPrintQueuesVariables>(QPrintQueuesDocument, options);
      }
export function useQPrintQueuesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQPrintQueues, TQPrintQueuesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQPrintQueues, TQPrintQueuesVariables>(QPrintQueuesDocument, options);
        }
export type QPrintQueuesHookResult = ReturnType<typeof useQPrintQueues>;
export type QPrintQueuesLazyQueryHookResult = ReturnType<typeof useQPrintQueuesLazyQuery>;
export type QPrintQueuesQueryResult = ApolloReactCommon.QueryResult<TQPrintQueues, TQPrintQueuesVariables>;
export const MBindPrinterToQueueDocument = gql`
    mutation MBindPrinterToQueue($queueId: ID!, $targetPcMAC: String!, $branchPrinterId: ID!) {
  queuePrinterBinding: createCompanyBranchTriggerPrinter(targetMac: $targetPcMAC, companyBranchTrigger: $queueId, companyBranchPrinter: $branchPrinterId) {
    ...FPrinterQueueLink
  }
}
    ${FPrinterQueueLink}`;
export type TMBindPrinterToQueueMutationFn = ApolloReactCommon.MutationFunction<TMBindPrinterToQueue, TMBindPrinterToQueueVariables>;
export function useMBindPrinterToQueue(baseOptions?: ApolloReactHooks.MutationHookOptions<TMBindPrinterToQueue, TMBindPrinterToQueueVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMBindPrinterToQueue, TMBindPrinterToQueueVariables>(MBindPrinterToQueueDocument, options);
      }
export type MBindPrinterToQueueHookResult = ReturnType<typeof useMBindPrinterToQueue>;
export type MBindPrinterToQueueMutationResult = ApolloReactCommon.MutationResult<TMBindPrinterToQueue>;
export type MBindPrinterToQueueMutationOptions = ApolloReactCommon.BaseMutationOptions<TMBindPrinterToQueue, TMBindPrinterToQueueVariables>;
export const MUnbindPrinterFromQueueDocument = gql`
    mutation MUnbindPrinterFromQueue($bindingId: ID!) {
  queuePrinterBinding: destroyCompanyBranchTriggerPrinter(id: $bindingId) {
    id
  }
}
    `;
export type TMUnbindPrinterFromQueueMutationFn = ApolloReactCommon.MutationFunction<TMUnbindPrinterFromQueue, TMUnbindPrinterFromQueueVariables>;
export function useMUnbindPrinterFromQueue(baseOptions?: ApolloReactHooks.MutationHookOptions<TMUnbindPrinterFromQueue, TMUnbindPrinterFromQueueVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMUnbindPrinterFromQueue, TMUnbindPrinterFromQueueVariables>(MUnbindPrinterFromQueueDocument, options);
      }
export type MUnbindPrinterFromQueueHookResult = ReturnType<typeof useMUnbindPrinterFromQueue>;
export type MUnbindPrinterFromQueueMutationResult = ApolloReactCommon.MutationResult<TMUnbindPrinterFromQueue>;
export type MUnbindPrinterFromQueueMutationOptions = ApolloReactCommon.BaseMutationOptions<TMUnbindPrinterFromQueue, TMUnbindPrinterFromQueueVariables>;
export const MRegisterPrinterDocument = gql`
    mutation MRegisterPrinter($printerMAC: String!, $printerName: String!, $companyBranchIds: [ID!]!, $printerType: PrinterTypeEnum!) {
  printer: createPrinter(mac: $printerMAC, name: $printerName, printerType: $printerType, companyBranches: $companyBranchIds) {
    ...FPrinter
  }
}
    ${FPrinter}`;
export type TMRegisterPrinterMutationFn = ApolloReactCommon.MutationFunction<TMRegisterPrinter, TMRegisterPrinterVariables>;
export function useMRegisterPrinter(baseOptions?: ApolloReactHooks.MutationHookOptions<TMRegisterPrinter, TMRegisterPrinterVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMRegisterPrinter, TMRegisterPrinterVariables>(MRegisterPrinterDocument, options);
      }
export type MRegisterPrinterHookResult = ReturnType<typeof useMRegisterPrinter>;
export type MRegisterPrinterMutationResult = ApolloReactCommon.MutationResult<TMRegisterPrinter>;
export type MRegisterPrinterMutationOptions = ApolloReactCommon.BaseMutationOptions<TMRegisterPrinter, TMRegisterPrinterVariables>;
export const MUnregisterPrinterDocument = gql`
    mutation MUnregisterPrinter($printerId: ID!) {
  printer: destroyPrinter(id: $printerId) {
    id
  }
}
    `;
export type TMUnregisterPrinterMutationFn = ApolloReactCommon.MutationFunction<TMUnregisterPrinter, TMUnregisterPrinterVariables>;
export function useMUnregisterPrinter(baseOptions?: ApolloReactHooks.MutationHookOptions<TMUnregisterPrinter, TMUnregisterPrinterVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMUnregisterPrinter, TMUnregisterPrinterVariables>(MUnregisterPrinterDocument, options);
      }
export type MUnregisterPrinterHookResult = ReturnType<typeof useMUnregisterPrinter>;
export type MUnregisterPrinterMutationResult = ApolloReactCommon.MutationResult<TMUnregisterPrinter>;
export type MUnregisterPrinterMutationOptions = ApolloReactCommon.BaseMutationOptions<TMUnregisterPrinter, TMUnregisterPrinterVariables>;
export const MUpdatePrinterDocument = gql`
    mutation MUpdatePrinter($printerId: ID!, $printerMAC: String, $printerName: String, $companyBranchIds: [ID!]!, $printerType: PrinterTypeEnum) {
  printer: updatePrinter(id: $printerId, mac: $printerMAC, name: $printerName, printerType: $printerType, companyBranches: $companyBranchIds) {
    ...FPrinter
  }
}
    ${FPrinter}`;
export type TMUpdatePrinterMutationFn = ApolloReactCommon.MutationFunction<TMUpdatePrinter, TMUpdatePrinterVariables>;
export function useMUpdatePrinter(baseOptions?: ApolloReactHooks.MutationHookOptions<TMUpdatePrinter, TMUpdatePrinterVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMUpdatePrinter, TMUpdatePrinterVariables>(MUpdatePrinterDocument, options);
      }
export type MUpdatePrinterHookResult = ReturnType<typeof useMUpdatePrinter>;
export type MUpdatePrinterMutationResult = ApolloReactCommon.MutationResult<TMUpdatePrinter>;
export type MUpdatePrinterMutationOptions = ApolloReactCommon.BaseMutationOptions<TMUpdatePrinter, TMUpdatePrinterVariables>;
export const QPrinterConfigsDocument = gql`
    query QPrinterConfigs {
  printerTypes {
    id
    enum
    nameLabel: code
  }
}
    `;
export function useQPrinterConfigs(baseOptions?: ApolloReactHooks.QueryHookOptions<TQPrinterConfigs, TQPrinterConfigsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQPrinterConfigs, TQPrinterConfigsVariables>(QPrinterConfigsDocument, options);
      }
export function useQPrinterConfigsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQPrinterConfigs, TQPrinterConfigsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQPrinterConfigs, TQPrinterConfigsVariables>(QPrinterConfigsDocument, options);
        }
export type QPrinterConfigsHookResult = ReturnType<typeof useQPrinterConfigs>;
export type QPrinterConfigsLazyQueryHookResult = ReturnType<typeof useQPrinterConfigsLazyQuery>;
export type QPrinterConfigsQueryResult = ApolloReactCommon.QueryResult<TQPrinterConfigs, TQPrinterConfigsVariables>;
export const QRegisteredPrintersDocument = gql`
    query QRegisteredPrinters($companyBranchIds: [ID!]!) {
  printers(companyBranches: $companyBranchIds) {
    ...FPrinter
  }
}
    ${FPrinter}`;
export function useQRegisteredPrinters(baseOptions: ApolloReactHooks.QueryHookOptions<TQRegisteredPrinters, TQRegisteredPrintersVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQRegisteredPrinters, TQRegisteredPrintersVariables>(QRegisteredPrintersDocument, options);
      }
export function useQRegisteredPrintersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQRegisteredPrinters, TQRegisteredPrintersVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQRegisteredPrinters, TQRegisteredPrintersVariables>(QRegisteredPrintersDocument, options);
        }
export type QRegisteredPrintersHookResult = ReturnType<typeof useQRegisteredPrinters>;
export type QRegisteredPrintersLazyQueryHookResult = ReturnType<typeof useQRegisteredPrintersLazyQuery>;
export type QRegisteredPrintersQueryResult = ApolloReactCommon.QueryResult<TQRegisteredPrinters, TQRegisteredPrintersVariables>;
export const MUserMenuLanguageDocument = gql`
    mutation MUserMenuLanguage($userId: ID!, $lang: LanguageEnum!) {
  updateUser(id: $userId, user: {language: $lang}) {
    id
    language {
      enum
    }
  }
}
    `;
export type TMUserMenuLanguageMutationFn = ApolloReactCommon.MutationFunction<TMUserMenuLanguage, TMUserMenuLanguageVariables>;
export function useMUserMenuLanguage(baseOptions?: ApolloReactHooks.MutationHookOptions<TMUserMenuLanguage, TMUserMenuLanguageVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMUserMenuLanguage, TMUserMenuLanguageVariables>(MUserMenuLanguageDocument, options);
      }
export type MUserMenuLanguageHookResult = ReturnType<typeof useMUserMenuLanguage>;
export type MUserMenuLanguageMutationResult = ApolloReactCommon.MutationResult<TMUserMenuLanguage>;
export type MUserMenuLanguageMutationOptions = ApolloReactCommon.BaseMutationOptions<TMUserMenuLanguage, TMUserMenuLanguageVariables>;
export const QUserMenuLanguagesDocument = gql`
    query QUserMenuLanguages {
  languages {
    code
    enum
    rawCode
  }
}
    `;
export function useQUserMenuLanguages(baseOptions?: ApolloReactHooks.QueryHookOptions<TQUserMenuLanguages, TQUserMenuLanguagesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQUserMenuLanguages, TQUserMenuLanguagesVariables>(QUserMenuLanguagesDocument, options);
      }
export function useQUserMenuLanguagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQUserMenuLanguages, TQUserMenuLanguagesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQUserMenuLanguages, TQUserMenuLanguagesVariables>(QUserMenuLanguagesDocument, options);
        }
export type QUserMenuLanguagesHookResult = ReturnType<typeof useQUserMenuLanguages>;
export type QUserMenuLanguagesLazyQueryHookResult = ReturnType<typeof useQUserMenuLanguagesLazyQuery>;
export type QUserMenuLanguagesQueryResult = ApolloReactCommon.QueryResult<TQUserMenuLanguages, TQUserMenuLanguagesVariables>;
export const MCreateTransfersDocument = gql`
    mutation MCreateTransfers($targetBranch: ID!, $transfers: [InputStockTransferCreate!]!) {
  createStockItemTransfers(destinationBranchId: $targetBranch, transfers: $transfers) {
    id
    quantity
  }
}
    `;
export type TMCreateTransfersMutationFn = ApolloReactCommon.MutationFunction<TMCreateTransfers, TMCreateTransfersVariables>;
export function useMCreateTransfers(baseOptions?: ApolloReactHooks.MutationHookOptions<TMCreateTransfers, TMCreateTransfersVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMCreateTransfers, TMCreateTransfersVariables>(MCreateTransfersDocument, options);
      }
export type MCreateTransfersHookResult = ReturnType<typeof useMCreateTransfers>;
export type MCreateTransfersMutationResult = ApolloReactCommon.MutationResult<TMCreateTransfers>;
export type MCreateTransfersMutationOptions = ApolloReactCommon.BaseMutationOptions<TMCreateTransfers, TMCreateTransfersVariables>;
export const QMenuStockDepositDocument = gql`
    query QMenuStockDeposit($branchId: ID!) {
  stockItems(companyBranch: $branchId) {
    id
    code
    plu
    nameLabel: label
    note
    quantity
    wareUnit {
      ...FMenuWareUnit
    }
  }
}
    ${FMenuWareUnit}`;
export function useQMenuStockDeposit(baseOptions: ApolloReactHooks.QueryHookOptions<TQMenuStockDeposit, TQMenuStockDepositVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQMenuStockDeposit, TQMenuStockDepositVariables>(QMenuStockDepositDocument, options);
      }
export function useQMenuStockDepositLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQMenuStockDeposit, TQMenuStockDepositVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQMenuStockDeposit, TQMenuStockDepositVariables>(QMenuStockDepositDocument, options);
        }
export type QMenuStockDepositHookResult = ReturnType<typeof useQMenuStockDeposit>;
export type QMenuStockDepositLazyQueryHookResult = ReturnType<typeof useQMenuStockDepositLazyQuery>;
export type QMenuStockDepositQueryResult = ApolloReactCommon.QueryResult<TQMenuStockDeposit, TQMenuStockDepositVariables>;
export const QStockForTransferDocument = gql`
    query QStockForTransfer($branchId: ID!) {
  stockItems(companyBranch: $branchId) {
    id
    code
    plu
    nameLabel: label
    allowNegativeValue
    quantity
    wareUnit {
      id
      code
    }
  }
}
    `;
export function useQStockForTransfer(baseOptions: ApolloReactHooks.QueryHookOptions<TQStockForTransfer, TQStockForTransferVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQStockForTransfer, TQStockForTransferVariables>(QStockForTransferDocument, options);
      }
export function useQStockForTransferLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQStockForTransfer, TQStockForTransferVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQStockForTransfer, TQStockForTransferVariables>(QStockForTransferDocument, options);
        }
export type QStockForTransferHookResult = ReturnType<typeof useQStockForTransfer>;
export type QStockForTransferLazyQueryHookResult = ReturnType<typeof useQStockForTransferLazyQuery>;
export type QStockForTransferQueryResult = ApolloReactCommon.QueryResult<TQStockForTransfer, TQStockForTransferVariables>;
export const QStockStatsDocument = gql`
    query QStockStats($brandId: ID!) {
  stockItems(company: $brandId) {
    id
    code
    companyBranch {
      id
      name
    }
    plu
    quantity
    nameLabel: label
    wareUnit {
      id
      code
    }
  }
}
    `;
export function useQStockStats(baseOptions: ApolloReactHooks.QueryHookOptions<TQStockStats, TQStockStatsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQStockStats, TQStockStatsVariables>(QStockStatsDocument, options);
      }
export function useQStockStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQStockStats, TQStockStatsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQStockStats, TQStockStatsVariables>(QStockStatsDocument, options);
        }
export type QStockStatsHookResult = ReturnType<typeof useQStockStats>;
export type QStockStatsLazyQueryHookResult = ReturnType<typeof useQStockStatsLazyQuery>;
export type QStockStatsQueryResult = ApolloReactCommon.QueryResult<TQStockStats, TQStockStatsVariables>;
export const MCancelStockInventoryDocument = gql`
    mutation MCancelStockInventory($inventoryId: ID!) {
  destroyStockInventory(id: $inventoryId) {
    id
  }
}
    `;
export type TMCancelStockInventoryMutationFn = ApolloReactCommon.MutationFunction<TMCancelStockInventory, TMCancelStockInventoryVariables>;
export function useMCancelStockInventory(baseOptions?: ApolloReactHooks.MutationHookOptions<TMCancelStockInventory, TMCancelStockInventoryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMCancelStockInventory, TMCancelStockInventoryVariables>(MCancelStockInventoryDocument, options);
      }
export type MCancelStockInventoryHookResult = ReturnType<typeof useMCancelStockInventory>;
export type MCancelStockInventoryMutationResult = ApolloReactCommon.MutationResult<TMCancelStockInventory>;
export type MCancelStockInventoryMutationOptions = ApolloReactCommon.BaseMutationOptions<TMCancelStockInventory, TMCancelStockInventoryVariables>;
export const MCreateStockInventoryDocument = gql`
    mutation MCreateStockInventory($branchId: ID!) {
  createStockInventory(companyBranch: $branchId) {
    ...FStockInventory
  }
}
    ${FStockInventory}`;
export type TMCreateStockInventoryMutationFn = ApolloReactCommon.MutationFunction<TMCreateStockInventory, TMCreateStockInventoryVariables>;
export function useMCreateStockInventory(baseOptions?: ApolloReactHooks.MutationHookOptions<TMCreateStockInventory, TMCreateStockInventoryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMCreateStockInventory, TMCreateStockInventoryVariables>(MCreateStockInventoryDocument, options);
      }
export type MCreateStockInventoryHookResult = ReturnType<typeof useMCreateStockInventory>;
export type MCreateStockInventoryMutationResult = ApolloReactCommon.MutationResult<TMCreateStockInventory>;
export type MCreateStockInventoryMutationOptions = ApolloReactCommon.BaseMutationOptions<TMCreateStockInventory, TMCreateStockInventoryVariables>;
export const MFinishStockInventoryDocument = gql`
    mutation MFinishStockInventory($inventoryId: ID!, $note: String) {
  finishStockInventory(id: $inventoryId, note: $note) {
    id
  }
}
    `;
export type TMFinishStockInventoryMutationFn = ApolloReactCommon.MutationFunction<TMFinishStockInventory, TMFinishStockInventoryVariables>;
export function useMFinishStockInventory(baseOptions?: ApolloReactHooks.MutationHookOptions<TMFinishStockInventory, TMFinishStockInventoryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMFinishStockInventory, TMFinishStockInventoryVariables>(MFinishStockInventoryDocument, options);
      }
export type MFinishStockInventoryHookResult = ReturnType<typeof useMFinishStockInventory>;
export type MFinishStockInventoryMutationResult = ApolloReactCommon.MutationResult<TMFinishStockInventory>;
export type MFinishStockInventoryMutationOptions = ApolloReactCommon.BaseMutationOptions<TMFinishStockInventory, TMFinishStockInventoryVariables>;
export const MUpdateStockInventoryItemDocument = gql`
    mutation MUpdateStockInventoryItem($itemId: ID!, $actualQuantity: Float!, $varianceReason: StockInventoryItemChangeTypeEnum) {
  updateStockInventoryItem(id: $itemId, stockInventoryItem: {finalQuantity: $actualQuantity, stockItemChangeType: $varianceReason}) {
    id
  }
}
    `;
export type TMUpdateStockInventoryItemMutationFn = ApolloReactCommon.MutationFunction<TMUpdateStockInventoryItem, TMUpdateStockInventoryItemVariables>;
export function useMUpdateStockInventoryItem(baseOptions?: ApolloReactHooks.MutationHookOptions<TMUpdateStockInventoryItem, TMUpdateStockInventoryItemVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMUpdateStockInventoryItem, TMUpdateStockInventoryItemVariables>(MUpdateStockInventoryItemDocument, options);
      }
export type MUpdateStockInventoryItemHookResult = ReturnType<typeof useMUpdateStockInventoryItem>;
export type MUpdateStockInventoryItemMutationResult = ApolloReactCommon.MutationResult<TMUpdateStockInventoryItem>;
export type MUpdateStockInventoryItemMutationOptions = ApolloReactCommon.BaseMutationOptions<TMUpdateStockInventoryItem, TMUpdateStockInventoryItemVariables>;
export const QStockInventoryDocument = gql`
    query QStockInventory($inventoryId: ID!) {
  stockInventory(id: $inventoryId) {
    ...FStockInventory
  }
}
    ${FStockInventory}`;
export function useQStockInventory(baseOptions: ApolloReactHooks.QueryHookOptions<TQStockInventory, TQStockInventoryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQStockInventory, TQStockInventoryVariables>(QStockInventoryDocument, options);
      }
export function useQStockInventoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQStockInventory, TQStockInventoryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQStockInventory, TQStockInventoryVariables>(QStockInventoryDocument, options);
        }
export type QStockInventoryHookResult = ReturnType<typeof useQStockInventory>;
export type QStockInventoryLazyQueryHookResult = ReturnType<typeof useQStockInventoryLazyQuery>;
export type QStockInventoryQueryResult = ApolloReactCommon.QueryResult<TQStockInventory, TQStockInventoryVariables>;
export const QStockInventoryVarianceReasonsDocument = gql`
    query QStockInventoryVarianceReasons {
  varianceReasons: stockInventoryItemChangeTypes {
    id
    enum
    code
  }
}
    `;
export function useQStockInventoryVarianceReasons(baseOptions?: ApolloReactHooks.QueryHookOptions<TQStockInventoryVarianceReasons, TQStockInventoryVarianceReasonsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQStockInventoryVarianceReasons, TQStockInventoryVarianceReasonsVariables>(QStockInventoryVarianceReasonsDocument, options);
      }
export function useQStockInventoryVarianceReasonsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQStockInventoryVarianceReasons, TQStockInventoryVarianceReasonsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQStockInventoryVarianceReasons, TQStockInventoryVarianceReasonsVariables>(QStockInventoryVarianceReasonsDocument, options);
        }
export type QStockInventoryVarianceReasonsHookResult = ReturnType<typeof useQStockInventoryVarianceReasons>;
export type QStockInventoryVarianceReasonsLazyQueryHookResult = ReturnType<typeof useQStockInventoryVarianceReasonsLazyQuery>;
export type QStockInventoryVarianceReasonsQueryResult = ApolloReactCommon.QueryResult<TQStockInventoryVarianceReasons, TQStockInventoryVarianceReasonsVariables>;
export const QTakenStockInventoriesDocument = gql`
    query QTakenStockInventories($branchId: ID!, $dateFrom: DateTime!, $dateTo: DateTime!) {
  stockInventories(companyBranch: $branchId, createdFrom: $dateFrom, createdTo: $dateTo, finished: true) {
    ...FStockInventorySummary
  }
}
    ${FStockInventorySummary}`;
export function useQTakenStockInventories(baseOptions: ApolloReactHooks.QueryHookOptions<TQTakenStockInventories, TQTakenStockInventoriesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQTakenStockInventories, TQTakenStockInventoriesVariables>(QTakenStockInventoriesDocument, options);
      }
export function useQTakenStockInventoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQTakenStockInventories, TQTakenStockInventoriesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQTakenStockInventories, TQTakenStockInventoriesVariables>(QTakenStockInventoriesDocument, options);
        }
export type QTakenStockInventoriesHookResult = ReturnType<typeof useQTakenStockInventories>;
export type QTakenStockInventoriesLazyQueryHookResult = ReturnType<typeof useQTakenStockInventoriesLazyQuery>;
export type QTakenStockInventoriesQueryResult = ApolloReactCommon.QueryResult<TQTakenStockInventories, TQTakenStockInventoriesVariables>;
export const QUnfinishedStockInventoryDocument = gql`
    query QUnfinishedStockInventory($branchId: ID!) {
  stockInventories(companyBranch: $branchId, inProgress: true) {
    ...FStockInventory
  }
}
    ${FStockInventory}`;
export function useQUnfinishedStockInventory(baseOptions: ApolloReactHooks.QueryHookOptions<TQUnfinishedStockInventory, TQUnfinishedStockInventoryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQUnfinishedStockInventory, TQUnfinishedStockInventoryVariables>(QUnfinishedStockInventoryDocument, options);
      }
export function useQUnfinishedStockInventoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQUnfinishedStockInventory, TQUnfinishedStockInventoryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQUnfinishedStockInventory, TQUnfinishedStockInventoryVariables>(QUnfinishedStockInventoryDocument, options);
        }
export type QUnfinishedStockInventoryHookResult = ReturnType<typeof useQUnfinishedStockInventory>;
export type QUnfinishedStockInventoryLazyQueryHookResult = ReturnType<typeof useQUnfinishedStockInventoryLazyQuery>;
export type QUnfinishedStockInventoryQueryResult = ApolloReactCommon.QueryResult<TQUnfinishedStockInventory, TQUnfinishedStockInventoryVariables>;
export const MZoneCreateDocument = gql`
    mutation MZoneCreate($branchId: ID!, $points: [InputGeoPointCreate!], $type: ZoneTypeEnum!) {
  createZone(zone: {companyBranch: $branchId, geoPolygon: $points, zoneType: $type}) {
    ...FZone
  }
}
    ${FZone}`;
export type TMZoneCreateMutationFn = ApolloReactCommon.MutationFunction<TMZoneCreate, TMZoneCreateVariables>;
export function useMZoneCreate(baseOptions?: ApolloReactHooks.MutationHookOptions<TMZoneCreate, TMZoneCreateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMZoneCreate, TMZoneCreateVariables>(MZoneCreateDocument, options);
      }
export type MZoneCreateHookResult = ReturnType<typeof useMZoneCreate>;
export type MZoneCreateMutationResult = ApolloReactCommon.MutationResult<TMZoneCreate>;
export type MZoneCreateMutationOptions = ApolloReactCommon.BaseMutationOptions<TMZoneCreate, TMZoneCreateVariables>;
export const MZoneDeleteDocument = gql`
    mutation MZoneDelete($zoneId: ID!) {
  deleteZone: destroyZone(id: $zoneId) {
    id
  }
}
    `;
export type TMZoneDeleteMutationFn = ApolloReactCommon.MutationFunction<TMZoneDelete, TMZoneDeleteVariables>;
export function useMZoneDelete(baseOptions?: ApolloReactHooks.MutationHookOptions<TMZoneDelete, TMZoneDeleteVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMZoneDelete, TMZoneDeleteVariables>(MZoneDeleteDocument, options);
      }
export type MZoneDeleteHookResult = ReturnType<typeof useMZoneDelete>;
export type MZoneDeleteMutationResult = ApolloReactCommon.MutationResult<TMZoneDelete>;
export type MZoneDeleteMutationOptions = ApolloReactCommon.BaseMutationOptions<TMZoneDelete, TMZoneDeleteVariables>;
export const MZoneUpdateDocument = gql`
    mutation MZoneUpdate($zoneId: ID!, $update: InputZoneUpdate!) {
  updateZone(id: $zoneId, zone: $update) {
    ...FZone
  }
}
    ${FZone}`;
export type TMZoneUpdateMutationFn = ApolloReactCommon.MutationFunction<TMZoneUpdate, TMZoneUpdateVariables>;
export function useMZoneUpdate(baseOptions?: ApolloReactHooks.MutationHookOptions<TMZoneUpdate, TMZoneUpdateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMZoneUpdate, TMZoneUpdateVariables>(MZoneUpdateDocument, options);
      }
export type MZoneUpdateHookResult = ReturnType<typeof useMZoneUpdate>;
export type MZoneUpdateMutationResult = ApolloReactCommon.MutationResult<TMZoneUpdate>;
export type MZoneUpdateMutationOptions = ApolloReactCommon.BaseMutationOptions<TMZoneUpdate, TMZoneUpdateVariables>;
export const MZoneUpdatePriorityDocument = gql`
    mutation MZoneUpdatePriority($zoneId: ID!, $offset: Int!) {
  updateZonePriority(zone: $zoneId, offset: $offset) {
    id
    priority
  }
}
    `;
export type TMZoneUpdatePriorityMutationFn = ApolloReactCommon.MutationFunction<TMZoneUpdatePriority, TMZoneUpdatePriorityVariables>;
export function useMZoneUpdatePriority(baseOptions?: ApolloReactHooks.MutationHookOptions<TMZoneUpdatePriority, TMZoneUpdatePriorityVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMZoneUpdatePriority, TMZoneUpdatePriorityVariables>(MZoneUpdatePriorityDocument, options);
      }
export type MZoneUpdatePriorityHookResult = ReturnType<typeof useMZoneUpdatePriority>;
export type MZoneUpdatePriorityMutationResult = ApolloReactCommon.MutationResult<TMZoneUpdatePriority>;
export type MZoneUpdatePriorityMutationOptions = ApolloReactCommon.BaseMutationOptions<TMZoneUpdatePriority, TMZoneUpdatePriorityVariables>;
export const QZoneColorsDocument = gql`
    query QZoneColors {
  zoneColors {
    id
    code
    color
  }
}
    `;
export function useQZoneColors(baseOptions?: ApolloReactHooks.QueryHookOptions<TQZoneColors, TQZoneColorsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQZoneColors, TQZoneColorsVariables>(QZoneColorsDocument, options);
      }
export function useQZoneColorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQZoneColors, TQZoneColorsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQZoneColors, TQZoneColorsVariables>(QZoneColorsDocument, options);
        }
export type QZoneColorsHookResult = ReturnType<typeof useQZoneColors>;
export type QZoneColorsLazyQueryHookResult = ReturnType<typeof useQZoneColorsLazyQuery>;
export type QZoneColorsQueryResult = ApolloReactCommon.QueryResult<TQZoneColors, TQZoneColorsVariables>;
export const QZoneFormDocument = gql`
    query QZoneForm($zoneId: ID!) {
  zone(id: $zoneId) {
    ...FZoneInForm
  }
}
    ${FZoneInForm}`;
export function useQZoneForm(baseOptions: ApolloReactHooks.QueryHookOptions<TQZoneForm, TQZoneFormVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQZoneForm, TQZoneFormVariables>(QZoneFormDocument, options);
      }
export function useQZoneFormLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQZoneForm, TQZoneFormVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQZoneForm, TQZoneFormVariables>(QZoneFormDocument, options);
        }
export type QZoneFormHookResult = ReturnType<typeof useQZoneForm>;
export type QZoneFormLazyQueryHookResult = ReturnType<typeof useQZoneFormLazyQuery>;
export type QZoneFormQueryResult = ApolloReactCommon.QueryResult<TQZoneForm, TQZoneFormVariables>;
export const QZoneListDocument = gql`
    query QZoneList($branches: [ID!]!) {
  zones(companyBranches: $branches) {
    ...FZoneInList
  }
}
    ${FZoneInList}`;
export function useQZoneList(baseOptions: ApolloReactHooks.QueryHookOptions<TQZoneList, TQZoneListVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQZoneList, TQZoneListVariables>(QZoneListDocument, options);
      }
export function useQZoneListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQZoneList, TQZoneListVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQZoneList, TQZoneListVariables>(QZoneListDocument, options);
        }
export type QZoneListHookResult = ReturnType<typeof useQZoneList>;
export type QZoneListLazyQueryHookResult = ReturnType<typeof useQZoneListLazyQuery>;
export type QZoneListQueryResult = ApolloReactCommon.QueryResult<TQZoneList, TQZoneListVariables>;
export const MAcknowledgeExternalDeliveryFailDocument = gql`
    mutation MAcknowledgeExternalDeliveryFail($deliveryId: ID!) {
  delivery: acknowledgeExternalDelivery(id: $deliveryId) {
    id
  }
}
    `;
export type TMAcknowledgeExternalDeliveryFailMutationFn = ApolloReactCommon.MutationFunction<TMAcknowledgeExternalDeliveryFail, TMAcknowledgeExternalDeliveryFailVariables>;
export function useMAcknowledgeExternalDeliveryFail(baseOptions?: ApolloReactHooks.MutationHookOptions<TMAcknowledgeExternalDeliveryFail, TMAcknowledgeExternalDeliveryFailVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMAcknowledgeExternalDeliveryFail, TMAcknowledgeExternalDeliveryFailVariables>(MAcknowledgeExternalDeliveryFailDocument, options);
      }
export type MAcknowledgeExternalDeliveryFailHookResult = ReturnType<typeof useMAcknowledgeExternalDeliveryFail>;
export type MAcknowledgeExternalDeliveryFailMutationResult = ApolloReactCommon.MutationResult<TMAcknowledgeExternalDeliveryFail>;
export type MAcknowledgeExternalDeliveryFailMutationOptions = ApolloReactCommon.BaseMutationOptions<TMAcknowledgeExternalDeliveryFail, TMAcknowledgeExternalDeliveryFailVariables>;
export const MCreateExternalDeliveryDocument = gql`
    mutation MCreateExternalDelivery($orderId: ID!, $deliveryProvider: ExternalDeliveryProviderEnum!, $closestPickupTime: DateTime) {
  isSuccess: createExternalDelivery(id: $orderId, externalDeliveryProvider: $deliveryProvider, closestPickup: $closestPickupTime)
}
    `;
export type TMCreateExternalDeliveryMutationFn = ApolloReactCommon.MutationFunction<TMCreateExternalDelivery, TMCreateExternalDeliveryVariables>;
export function useMCreateExternalDelivery(baseOptions?: ApolloReactHooks.MutationHookOptions<TMCreateExternalDelivery, TMCreateExternalDeliveryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMCreateExternalDelivery, TMCreateExternalDeliveryVariables>(MCreateExternalDeliveryDocument, options);
      }
export type MCreateExternalDeliveryHookResult = ReturnType<typeof useMCreateExternalDelivery>;
export type MCreateExternalDeliveryMutationResult = ApolloReactCommon.MutationResult<TMCreateExternalDelivery>;
export type MCreateExternalDeliveryMutationOptions = ApolloReactCommon.BaseMutationOptions<TMCreateExternalDelivery, TMCreateExternalDeliveryVariables>;
export const QActiveExternalDeliveriesDocument = gql`
    query QActiveExternalDeliveries($branchIds: [ID!]!) {
  externalDeliveries(companyBranches: $branchIds) {
    ...FActiveExternalDelivery
  }
}
    ${FActiveExternalDelivery}`;
export function useQActiveExternalDeliveries(baseOptions: ApolloReactHooks.QueryHookOptions<TQActiveExternalDeliveries, TQActiveExternalDeliveriesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQActiveExternalDeliveries, TQActiveExternalDeliveriesVariables>(QActiveExternalDeliveriesDocument, options);
      }
export function useQActiveExternalDeliveriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQActiveExternalDeliveries, TQActiveExternalDeliveriesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQActiveExternalDeliveries, TQActiveExternalDeliveriesVariables>(QActiveExternalDeliveriesDocument, options);
        }
export type QActiveExternalDeliveriesHookResult = ReturnType<typeof useQActiveExternalDeliveries>;
export type QActiveExternalDeliveriesLazyQueryHookResult = ReturnType<typeof useQActiveExternalDeliveriesLazyQuery>;
export type QActiveExternalDeliveriesQueryResult = ApolloReactCommon.QueryResult<TQActiveExternalDeliveries, TQActiveExternalDeliveriesVariables>;
export const QEstimateExternalDeliveryDocument = gql`
    query QEstimateExternalDelivery($orderId: ID!, $deliveryProvider: ExternalDeliveryProviderEnum!) {
  estimates: estimateExternalDelivery(order: $orderId, externalDeliveryProvider: $deliveryProvider) {
    estimatedDeliveryFee {
      ...FPrice
      ...FFormattedPrice
    }
    estimatedPickupTime: courierEtaPickup
    estimatedDeliveryTime: courierEtaDelivery
    errorMessage
    rawErrorMessage
  }
}
    ${FPrice}
${FFormattedPrice}`;
export function useQEstimateExternalDelivery(baseOptions: ApolloReactHooks.QueryHookOptions<TQEstimateExternalDelivery, TQEstimateExternalDeliveryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQEstimateExternalDelivery, TQEstimateExternalDeliveryVariables>(QEstimateExternalDeliveryDocument, options);
      }
export function useQEstimateExternalDeliveryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQEstimateExternalDelivery, TQEstimateExternalDeliveryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQEstimateExternalDelivery, TQEstimateExternalDeliveryVariables>(QEstimateExternalDeliveryDocument, options);
        }
export type QEstimateExternalDeliveryHookResult = ReturnType<typeof useQEstimateExternalDelivery>;
export type QEstimateExternalDeliveryLazyQueryHookResult = ReturnType<typeof useQEstimateExternalDeliveryLazyQuery>;
export type QEstimateExternalDeliveryQueryResult = ApolloReactCommon.QueryResult<TQEstimateExternalDelivery, TQEstimateExternalDeliveryVariables>;
export const SActiveExternalDeliveriesDocument = gql`
    subscription SActiveExternalDeliveries($branchIds: [ID!]!) {
  update: updatedExternalDelivery(companyBranches: $branchIds) {
    id
    externalDelivery {
      ...FActiveExternalDelivery
    }
  }
}
    ${FActiveExternalDelivery}`;
export function useSActiveExternalDeliveries(baseOptions: ApolloReactHooks.SubscriptionHookOptions<TSActiveExternalDeliveries, TSActiveExternalDeliveriesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<TSActiveExternalDeliveries, TSActiveExternalDeliveriesVariables>(SActiveExternalDeliveriesDocument, options);
      }
export type SActiveExternalDeliveriesHookResult = ReturnType<typeof useSActiveExternalDeliveries>;
export type SActiveExternalDeliveriesSubscriptionResult = ApolloReactCommon.SubscriptionResult<TSActiveExternalDeliveries>;
export const MUpdateNotificationsDocument = gql`
    mutation MUpdateNotifications($ids: [ID!]!, $isRead: Boolean!) {
  updatedNotifications: bulkUpdateInAppNotifications(ids: $ids, isRead: $isRead) {
    id
  }
}
    `;
export type TMUpdateNotificationsMutationFn = ApolloReactCommon.MutationFunction<TMUpdateNotifications, TMUpdateNotificationsVariables>;
export function useMUpdateNotifications(baseOptions?: ApolloReactHooks.MutationHookOptions<TMUpdateNotifications, TMUpdateNotificationsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMUpdateNotifications, TMUpdateNotificationsVariables>(MUpdateNotificationsDocument, options);
      }
export type MUpdateNotificationsHookResult = ReturnType<typeof useMUpdateNotifications>;
export type MUpdateNotificationsMutationResult = ApolloReactCommon.MutationResult<TMUpdateNotifications>;
export type MUpdateNotificationsMutationOptions = ApolloReactCommon.BaseMutationOptions<TMUpdateNotifications, TMUpdateNotificationsVariables>;
export const QNotificationsDocument = gql`
    query QNotifications($userId: ID!) {
  user(id: $userId) {
    id
    unreadInAppNotificationsCount
    inAppNotifications {
      news: edges {
        node {
          ...FNotification
        }
      }
    }
  }
}
    ${FNotification}`;
export function useQNotifications(baseOptions: ApolloReactHooks.QueryHookOptions<TQNotifications, TQNotificationsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQNotifications, TQNotificationsVariables>(QNotificationsDocument, options);
      }
export function useQNotificationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQNotifications, TQNotificationsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQNotifications, TQNotificationsVariables>(QNotificationsDocument, options);
        }
export type QNotificationsHookResult = ReturnType<typeof useQNotifications>;
export type QNotificationsLazyQueryHookResult = ReturnType<typeof useQNotificationsLazyQuery>;
export type QNotificationsQueryResult = ApolloReactCommon.QueryResult<TQNotifications, TQNotificationsVariables>;
export const MAssignOrderDriverDocument = gql`
    mutation MAssignOrderDriver($driverId: ID!, $orderId: ID!) {
  result: createUserDeliveringOrder(user: $driverId, order: $orderId) {
    order {
      ...FOrderDriver
    }
  }
}
    ${FOrderDriver}`;
export type TMAssignOrderDriverMutationFn = ApolloReactCommon.MutationFunction<TMAssignOrderDriver, TMAssignOrderDriverVariables>;
export function useMAssignOrderDriver(baseOptions?: ApolloReactHooks.MutationHookOptions<TMAssignOrderDriver, TMAssignOrderDriverVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMAssignOrderDriver, TMAssignOrderDriverVariables>(MAssignOrderDriverDocument, options);
      }
export type MAssignOrderDriverHookResult = ReturnType<typeof useMAssignOrderDriver>;
export type MAssignOrderDriverMutationResult = ApolloReactCommon.MutationResult<TMAssignOrderDriver>;
export type MAssignOrderDriverMutationOptions = ApolloReactCommon.BaseMutationOptions<TMAssignOrderDriver, TMAssignOrderDriverVariables>;
export const MChangeOrderHandoverTimeDocument = gql`
    mutation MChangeOrderHandoverTime($orderId: ID!, $minutes: Int!) {
  order: orderNotifyCustomer(id: $orderId, minutes: $minutes) {
    id
    deliverAt
  }
}
    `;
export type TMChangeOrderHandoverTimeMutationFn = ApolloReactCommon.MutationFunction<TMChangeOrderHandoverTime, TMChangeOrderHandoverTimeVariables>;
export function useMChangeOrderHandoverTime(baseOptions?: ApolloReactHooks.MutationHookOptions<TMChangeOrderHandoverTime, TMChangeOrderHandoverTimeVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMChangeOrderHandoverTime, TMChangeOrderHandoverTimeVariables>(MChangeOrderHandoverTimeDocument, options);
      }
export type MChangeOrderHandoverTimeHookResult = ReturnType<typeof useMChangeOrderHandoverTime>;
export type MChangeOrderHandoverTimeMutationResult = ApolloReactCommon.MutationResult<TMChangeOrderHandoverTime>;
export type MChangeOrderHandoverTimeMutationOptions = ApolloReactCommon.BaseMutationOptions<TMChangeOrderHandoverTime, TMChangeOrderHandoverTimeVariables>;
export const MChangePaymentMethodDocument = gql`
    mutation MChangePaymentMethod($orderId: ID!, $paymentMethodId: ID!) {
  updateOrderPaymentMethod(orderId: $orderId, paymentMethodId: $paymentMethodId) {
    id
    ...FOrderPaymentMethods
  }
}
    ${FOrderPaymentMethods}`;
export type TMChangePaymentMethodMutationFn = ApolloReactCommon.MutationFunction<TMChangePaymentMethod, TMChangePaymentMethodVariables>;
export function useMChangePaymentMethod(baseOptions?: ApolloReactHooks.MutationHookOptions<TMChangePaymentMethod, TMChangePaymentMethodVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMChangePaymentMethod, TMChangePaymentMethodVariables>(MChangePaymentMethodDocument, options);
      }
export type MChangePaymentMethodHookResult = ReturnType<typeof useMChangePaymentMethod>;
export type MChangePaymentMethodMutationResult = ApolloReactCommon.MutationResult<TMChangePaymentMethod>;
export type MChangePaymentMethodMutationOptions = ApolloReactCommon.BaseMutationOptions<TMChangePaymentMethod, TMChangePaymentMethodVariables>;
export const MOrderChangeToPickupDocument = gql`
    mutation MOrderChangeToPickup($orderId: ID!) {
  updateOrderDeliveryToPickup(id: $orderId) {
    ...FOrderForHandoverType
  }
}
    ${FOrderForHandoverType}`;
export type TMOrderChangeToPickupMutationFn = ApolloReactCommon.MutationFunction<TMOrderChangeToPickup, TMOrderChangeToPickupVariables>;
export function useMOrderChangeToPickup(baseOptions?: ApolloReactHooks.MutationHookOptions<TMOrderChangeToPickup, TMOrderChangeToPickupVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMOrderChangeToPickup, TMOrderChangeToPickupVariables>(MOrderChangeToPickupDocument, options);
      }
export type MOrderChangeToPickupHookResult = ReturnType<typeof useMOrderChangeToPickup>;
export type MOrderChangeToPickupMutationResult = ApolloReactCommon.MutationResult<TMOrderChangeToPickup>;
export type MOrderChangeToPickupMutationOptions = ApolloReactCommon.BaseMutationOptions<TMOrderChangeToPickup, TMOrderChangeToPickupVariables>;
export const MRemoveOrderDriverDocument = gql`
    mutation MRemoveOrderDriver($orderDriverId: ID!) {
  destroyUserDeliveringOrder(id: $orderDriverId) {
    order {
      ...FOrderDriver
    }
  }
}
    ${FOrderDriver}`;
export type TMRemoveOrderDriverMutationFn = ApolloReactCommon.MutationFunction<TMRemoveOrderDriver, TMRemoveOrderDriverVariables>;
export function useMRemoveOrderDriver(baseOptions?: ApolloReactHooks.MutationHookOptions<TMRemoveOrderDriver, TMRemoveOrderDriverVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMRemoveOrderDriver, TMRemoveOrderDriverVariables>(MRemoveOrderDriverDocument, options);
      }
export type MRemoveOrderDriverHookResult = ReturnType<typeof useMRemoveOrderDriver>;
export type MRemoveOrderDriverMutationResult = ApolloReactCommon.MutationResult<TMRemoveOrderDriver>;
export type MRemoveOrderDriverMutationOptions = ApolloReactCommon.BaseMutationOptions<TMRemoveOrderDriver, TMRemoveOrderDriverVariables>;
export const MRequestOrderCancelDocument = gql`
    mutation MRequestOrderCancel($orderId: ID!, $note: String, $cancelReason: StornoRequestTypeEnum!) {
  requestCancelOrder(id: $orderId, comment: $note, cancelReason: $cancelReason) {
    id
  }
}
    `;
export type TMRequestOrderCancelMutationFn = ApolloReactCommon.MutationFunction<TMRequestOrderCancel, TMRequestOrderCancelVariables>;
export function useMRequestOrderCancel(baseOptions?: ApolloReactHooks.MutationHookOptions<TMRequestOrderCancel, TMRequestOrderCancelVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMRequestOrderCancel, TMRequestOrderCancelVariables>(MRequestOrderCancelDocument, options);
      }
export type MRequestOrderCancelHookResult = ReturnType<typeof useMRequestOrderCancel>;
export type MRequestOrderCancelMutationResult = ApolloReactCommon.MutationResult<TMRequestOrderCancel>;
export type MRequestOrderCancelMutationOptions = ApolloReactCommon.BaseMutationOptions<TMRequestOrderCancel, TMRequestOrderCancelVariables>;
export const MTransferOrderDocument = gql`
    mutation MTransferOrder($orderId: ID!, $branchId: ID!) {
  transferOrder(id: $orderId, companyBranch: $branchId) {
    id
    transferredFromOrder: transferOrderFrom {
      id
      ...FOrderStateCategory
    }
  }
}
    ${FOrderStateCategory}`;
export type TMTransferOrderMutationFn = ApolloReactCommon.MutationFunction<TMTransferOrder, TMTransferOrderVariables>;
export function useMTransferOrder(baseOptions?: ApolloReactHooks.MutationHookOptions<TMTransferOrder, TMTransferOrderVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMTransferOrder, TMTransferOrderVariables>(MTransferOrderDocument, options);
      }
export type MTransferOrderHookResult = ReturnType<typeof useMTransferOrder>;
export type MTransferOrderMutationResult = ApolloReactCommon.MutationResult<TMTransferOrder>;
export type MTransferOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<TMTransferOrder, TMTransferOrderVariables>;
export const QCancelReasonsDocument = gql`
    query QCancelReasons {
  cancelReasons: stornoRequestTypes {
    id
    enum
    label: code
    needComment
  }
}
    `;
export function useQCancelReasons(baseOptions?: ApolloReactHooks.QueryHookOptions<TQCancelReasons, TQCancelReasonsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQCancelReasons, TQCancelReasonsVariables>(QCancelReasonsDocument, options);
      }
export function useQCancelReasonsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQCancelReasons, TQCancelReasonsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQCancelReasons, TQCancelReasonsVariables>(QCancelReasonsDocument, options);
        }
export type QCancelReasonsHookResult = ReturnType<typeof useQCancelReasons>;
export type QCancelReasonsLazyQueryHookResult = ReturnType<typeof useQCancelReasonsLazyQuery>;
export type QCancelReasonsQueryResult = ApolloReactCommon.QueryResult<TQCancelReasons, TQCancelReasonsVariables>;
export const QOrderDriversDocument = gql`
    query QOrderDrivers($orderId: ID!, $branchId: [ID!]!) {
  order(id: $orderId) {
    ...FOrderDriver
  }
  drivers(companyBranches: $branchId, onlyAvailable: true, orderId: $orderId) {
    ...FDriver
  }
}
    ${FOrderDriver}
${FDriver}`;
export function useQOrderDrivers(baseOptions: ApolloReactHooks.QueryHookOptions<TQOrderDrivers, TQOrderDriversVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQOrderDrivers, TQOrderDriversVariables>(QOrderDriversDocument, options);
      }
export function useQOrderDriversLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQOrderDrivers, TQOrderDriversVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQOrderDrivers, TQOrderDriversVariables>(QOrderDriversDocument, options);
        }
export type QOrderDriversHookResult = ReturnType<typeof useQOrderDrivers>;
export type QOrderDriversLazyQueryHookResult = ReturnType<typeof useQOrderDriversLazyQuery>;
export type QOrderDriversQueryResult = ApolloReactCommon.QueryResult<TQOrderDrivers, TQOrderDriversVariables>;
export const QOrderForCancelRequestDocument = gql`
    query QOrderForCancelRequest($orderId: ID!) {
  order(id: $orderId) {
    id
    cancelRequested: cancelAlreadyRequested
  }
}
    `;
export function useQOrderForCancelRequest(baseOptions: ApolloReactHooks.QueryHookOptions<TQOrderForCancelRequest, TQOrderForCancelRequestVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQOrderForCancelRequest, TQOrderForCancelRequestVariables>(QOrderForCancelRequestDocument, options);
      }
export function useQOrderForCancelRequestLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQOrderForCancelRequest, TQOrderForCancelRequestVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQOrderForCancelRequest, TQOrderForCancelRequestVariables>(QOrderForCancelRequestDocument, options);
        }
export type QOrderForCancelRequestHookResult = ReturnType<typeof useQOrderForCancelRequest>;
export type QOrderForCancelRequestLazyQueryHookResult = ReturnType<typeof useQOrderForCancelRequestLazyQuery>;
export type QOrderForCancelRequestQueryResult = ApolloReactCommon.QueryResult<TQOrderForCancelRequest, TQOrderForCancelRequestVariables>;
export const QOrderStateDocument = gql`
    query QOrderState($orderId: ID!) {
  order(id: $orderId) {
    id
    currentUserCanFinishOrder
    availableExternalDeliveries: externalDeliveryProviders {
      code
      enum
    }
    driver: userDeliveringOrder {
      id
    }
    ...FOrderPaymentMethods
    ...FOrderForCancelAction
  }
}
    ${FOrderPaymentMethods}
${FOrderForCancelAction}`;
export function useQOrderState(baseOptions: ApolloReactHooks.QueryHookOptions<TQOrderState, TQOrderStateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQOrderState, TQOrderStateVariables>(QOrderStateDocument, options);
      }
export function useQOrderStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQOrderState, TQOrderStateVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQOrderState, TQOrderStateVariables>(QOrderStateDocument, options);
        }
export type QOrderStateHookResult = ReturnType<typeof useQOrderState>;
export type QOrderStateLazyQueryHookResult = ReturnType<typeof useQOrderStateLazyQuery>;
export type QOrderStateQueryResult = ApolloReactCommon.QueryResult<TQOrderState, TQOrderStateVariables>;
export const QOrderDetailsDocument = gql`
    query QOrderDetails($orderId: ID!, $withRating: Boolean!) {
  order(id: $orderId) {
    id
    note
    allAppliedRules
    zone {
      name
    }
    customerOrdersCountCurrent
    customerOrdersCountTotal
    customer: customerJson {
      isCancelRisk
      emails {
        ...FEmail
      }
      phones {
        ...FPhone
      }
    }
    items {
      ...FOrderDetailWare
      sideDishes {
        ...FOrderDetailWare
      }
    }
    transferredFromOrder: transferOrderFrom {
      id
      companyBranch {
        id
        name
      }
    }
    foodoraRecord {
      ...FFoodoraDeliveryInfo
    }
    ...FOrderOrigin
    ...FOrderTotals
    ...FOrderForTimeline
    ...FOrderExtraFees
    ...FOrderForItemGrouping
    ...FOrderRating @include(if: $withRating)
  }
}
    ${FEmail}
${FPhone}
${FOrderDetailWare}
${FFoodoraDeliveryInfo}
${FOrderOrigin}
${FOrderTotals}
${FOrderForTimeline}
${FOrderExtraFees}
${FOrderForItemGrouping}
${FOrderRating}`;
export function useQOrderDetails(baseOptions: ApolloReactHooks.QueryHookOptions<TQOrderDetails, TQOrderDetailsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQOrderDetails, TQOrderDetailsVariables>(QOrderDetailsDocument, options);
      }
export function useQOrderDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQOrderDetails, TQOrderDetailsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQOrderDetails, TQOrderDetailsVariables>(QOrderDetailsDocument, options);
        }
export type QOrderDetailsHookResult = ReturnType<typeof useQOrderDetails>;
export type QOrderDetailsLazyQueryHookResult = ReturnType<typeof useQOrderDetailsLazyQuery>;
export type QOrderDetailsQueryResult = ApolloReactCommon.QueryResult<TQOrderDetails, TQOrderDetailsVariables>;
export const MRemoveOrderGroupDriverDocument = gql`
    mutation MRemoveOrderGroupDriver($groupId: ID!) {
  removeDriverFromOrderGroup(orderGroup: $groupId) {
    id
  }
}
    `;
export type TMRemoveOrderGroupDriverMutationFn = ApolloReactCommon.MutationFunction<TMRemoveOrderGroupDriver, TMRemoveOrderGroupDriverVariables>;
export function useMRemoveOrderGroupDriver(baseOptions?: ApolloReactHooks.MutationHookOptions<TMRemoveOrderGroupDriver, TMRemoveOrderGroupDriverVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMRemoveOrderGroupDriver, TMRemoveOrderGroupDriverVariables>(MRemoveOrderGroupDriverDocument, options);
      }
export type MRemoveOrderGroupDriverHookResult = ReturnType<typeof useMRemoveOrderGroupDriver>;
export type MRemoveOrderGroupDriverMutationResult = ApolloReactCommon.MutationResult<TMRemoveOrderGroupDriver>;
export type MRemoveOrderGroupDriverMutationOptions = ApolloReactCommon.BaseMutationOptions<TMRemoveOrderGroupDriver, TMRemoveOrderGroupDriverVariables>;
export const QBranchesDriversDocument = gql`
    query QBranchesDrivers($branchIds: [ID!]!) {
  drivers(onlyAvailable: true, availableForAll: true, companyBranches: $branchIds) {
    ...FDriver
  }
}
    ${FDriver}`;
export function useQBranchesDrivers(baseOptions: ApolloReactHooks.QueryHookOptions<TQBranchesDrivers, TQBranchesDriversVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQBranchesDrivers, TQBranchesDriversVariables>(QBranchesDriversDocument, options);
      }
export function useQBranchesDriversLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQBranchesDrivers, TQBranchesDriversVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQBranchesDrivers, TQBranchesDriversVariables>(QBranchesDriversDocument, options);
        }
export type QBranchesDriversHookResult = ReturnType<typeof useQBranchesDrivers>;
export type QBranchesDriversLazyQueryHookResult = ReturnType<typeof useQBranchesDriversLazyQuery>;
export type QBranchesDriversQueryResult = ApolloReactCommon.QueryResult<TQBranchesDrivers, TQBranchesDriversVariables>;
export const QOrderGroupPriorityDocument = gql`
    query QOrderGroupPriority($groupId: ID!) {
  orderGroup(id: $groupId) {
    id
    orders {
      id
      isPriority
    }
  }
}
    `;
export function useQOrderGroupPriority(baseOptions: ApolloReactHooks.QueryHookOptions<TQOrderGroupPriority, TQOrderGroupPriorityVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQOrderGroupPriority, TQOrderGroupPriorityVariables>(QOrderGroupPriorityDocument, options);
      }
export function useQOrderGroupPriorityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQOrderGroupPriority, TQOrderGroupPriorityVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQOrderGroupPriority, TQOrderGroupPriorityVariables>(QOrderGroupPriorityDocument, options);
        }
export type QOrderGroupPriorityHookResult = ReturnType<typeof useQOrderGroupPriority>;
export type QOrderGroupPriorityLazyQueryHookResult = ReturnType<typeof useQOrderGroupPriorityLazyQuery>;
export type QOrderGroupPriorityQueryResult = ApolloReactCommon.QueryResult<TQOrderGroupPriority, TQOrderGroupPriorityVariables>;
export const QOrderGroupStateAndDriverDocument = gql`
    query QOrderGroupStateAndDriver($groupId: ID!) {
  orderGroup(id: $groupId) {
    id
    orders {
      id
      orderStateCategory
      companyBranch {
        id
      }
      ...FOrderForHandoverType
      ...FOrderDriver
    }
  }
}
    ${FOrderForHandoverType}
${FOrderDriver}`;
export function useQOrderGroupStateAndDriver(baseOptions: ApolloReactHooks.QueryHookOptions<TQOrderGroupStateAndDriver, TQOrderGroupStateAndDriverVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQOrderGroupStateAndDriver, TQOrderGroupStateAndDriverVariables>(QOrderGroupStateAndDriverDocument, options);
      }
export function useQOrderGroupStateAndDriverLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQOrderGroupStateAndDriver, TQOrderGroupStateAndDriverVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQOrderGroupStateAndDriver, TQOrderGroupStateAndDriverVariables>(QOrderGroupStateAndDriverDocument, options);
        }
export type QOrderGroupStateAndDriverHookResult = ReturnType<typeof useQOrderGroupStateAndDriver>;
export type QOrderGroupStateAndDriverLazyQueryHookResult = ReturnType<typeof useQOrderGroupStateAndDriverLazyQuery>;
export type QOrderGroupStateAndDriverQueryResult = ApolloReactCommon.QueryResult<TQOrderGroupStateAndDriver, TQOrderGroupStateAndDriverVariables>;
export const MChangePrintRecordStateDocument = gql`
    mutation MChangePrintRecordState($recordId: ID!, $newState: PrintQueueStateEnum!) {
  printRecord: updatePrintQueue(id: $recordId, printQueueState: $newState) {
    id
  }
}
    `;
export type TMChangePrintRecordStateMutationFn = ApolloReactCommon.MutationFunction<TMChangePrintRecordState, TMChangePrintRecordStateVariables>;
export function useMChangePrintRecordState(baseOptions?: ApolloReactHooks.MutationHookOptions<TMChangePrintRecordState, TMChangePrintRecordStateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMChangePrintRecordState, TMChangePrintRecordStateVariables>(MChangePrintRecordStateDocument, options);
      }
export type MChangePrintRecordStateHookResult = ReturnType<typeof useMChangePrintRecordState>;
export type MChangePrintRecordStateMutationResult = ApolloReactCommon.MutationResult<TMChangePrintRecordState>;
export type MChangePrintRecordStateMutationOptions = ApolloReactCommon.BaseMutationOptions<TMChangePrintRecordState, TMChangePrintRecordStateVariables>;
export const QPastPrintRecordsDocument = gql`
    query QPastPrintRecords($thisPcMAC: String!, $watchedPrinterIds: [ID!]!) {
  printRecords: printQueues(targetMac: $thisPcMAC, printers: $watchedPrinterIds) {
    ...FPrintRecord
  }
}
    ${FPrintRecord}`;
export function useQPastPrintRecords(baseOptions: ApolloReactHooks.QueryHookOptions<TQPastPrintRecords, TQPastPrintRecordsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQPastPrintRecords, TQPastPrintRecordsVariables>(QPastPrintRecordsDocument, options);
      }
export function useQPastPrintRecordsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQPastPrintRecords, TQPastPrintRecordsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQPastPrintRecords, TQPastPrintRecordsVariables>(QPastPrintRecordsDocument, options);
        }
export type QPastPrintRecordsHookResult = ReturnType<typeof useQPastPrintRecords>;
export type QPastPrintRecordsLazyQueryHookResult = ReturnType<typeof useQPastPrintRecordsLazyQuery>;
export type QPastPrintRecordsQueryResult = ApolloReactCommon.QueryResult<TQPastPrintRecords, TQPastPrintRecordsVariables>;
export const QRegisteredPrintersLiteDocument = gql`
    query QRegisteredPrintersLite($companyBranchIds: [ID!]!) {
  printers(companyBranches: $companyBranchIds) {
    id
    MAC: mac
    nameLabel: name
  }
}
    `;
export function useQRegisteredPrintersLite(baseOptions: ApolloReactHooks.QueryHookOptions<TQRegisteredPrintersLite, TQRegisteredPrintersLiteVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQRegisteredPrintersLite, TQRegisteredPrintersLiteVariables>(QRegisteredPrintersLiteDocument, options);
      }
export function useQRegisteredPrintersLiteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQRegisteredPrintersLite, TQRegisteredPrintersLiteVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQRegisteredPrintersLite, TQRegisteredPrintersLiteVariables>(QRegisteredPrintersLiteDocument, options);
        }
export type QRegisteredPrintersLiteHookResult = ReturnType<typeof useQRegisteredPrintersLite>;
export type QRegisteredPrintersLiteLazyQueryHookResult = ReturnType<typeof useQRegisteredPrintersLiteLazyQuery>;
export type QRegisteredPrintersLiteQueryResult = ApolloReactCommon.QueryResult<TQRegisteredPrintersLite, TQRegisteredPrintersLiteVariables>;
export const SPrintRecordsDocument = gql`
    subscription SPrintRecords($thisPcMAC: String!, $watchedPrinterIds: [ID!]!) {
  updatedPrintRecord: updatedPrintQueue(targetMac: $thisPcMAC, printers: $watchedPrinterIds) {
    id
    printRecord: printQueue {
      ...FPrintRecord
    }
  }
}
    ${FPrintRecord}`;
export function useSPrintRecords(baseOptions: ApolloReactHooks.SubscriptionHookOptions<TSPrintRecords, TSPrintRecordsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<TSPrintRecords, TSPrintRecordsVariables>(SPrintRecordsDocument, options);
      }
export type SPrintRecordsHookResult = ReturnType<typeof useSPrintRecords>;
export type SPrintRecordsSubscriptionResult = ApolloReactCommon.SubscriptionResult<TSPrintRecords>;